webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(129);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(2742);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(2741);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _store = __webpack_require__(161);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(1890);
	
	__webpack_require__(1889);
	
	__webpack_require__(1354);
	
	var _App = __webpack_require__(1896);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _breadcrumbs = __webpack_require__(1179);
	
	var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);
	
	var _attributes = __webpack_require__(1178);
	
	var _attributes2 = _interopRequireDefault(_attributes);
	
	var _foundation = __webpack_require__(1182);
	
	var _foundation2 = _interopRequireDefault(_foundation);
	
	var _dates = __webpack_require__(1181);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _stringHelper = __webpack_require__(1183);
	
	var _stringHelper2 = _interopRequireDefault(_stringHelper);
	
	var _currency = __webpack_require__(1180);
	
	var _currency2 = _interopRequireDefault(_currency);
	
	var _ckeditor5Vue = __webpack_require__(610);
	
	var _ckeditor5Vue2 = _interopRequireDefault(_ckeditor5Vue);
	
	var _vMdDateRangePicker = __webpack_require__(1894);
	
	var _vMdDateRangePicker2 = _interopRequireDefault(_vMdDateRangePicker);
	
	var _main = __webpack_require__(240);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _acl = __webpack_require__(629);
	
	var _acl2 = _interopRequireDefault(_acl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_acl2.default, {
	  handler: function handler(value) {
	    var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'can';
	    var modifiers = arguments[2];
	
	    var user = _store2.default.state.userStore;
	
	    if (value === '*' || user.isRoot) {
	      return true;
	    }
	
	    var prms = _store2.default.state.userStore.user.roles.flatMap(function (item) {
	      return item.permissions;
	    }).map(function (item) {
	      return item.name;
	    });
	
	    var has = prms.includes(value);
	
	    return has;
	  }
	});
	_vue2.default.component('app', _App2.default);
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.use(_breadcrumbs2.default);
	_vue2.default.use(_attributes2.default);
	_vue2.default.use(_foundation2.default);
	_vue2.default.use(_dates2.default);
	_vue2.default.use(_stringHelper2.default);
	_vue2.default.use(_currency2.default);
	_vue2.default.use(_ckeditor5Vue2.default);
	_vue2.default.use(_vMdDateRangePicker2.default);
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: _main2.default
	});
	
	router.beforeResolve(function (to, from, next) {
	  var hasToken = localStorage.getItem('backoffice-token') != null;
	  if (hasToken && _store2.default.state.userStore.user === null) {
	    _store2.default.dispatch('init');
	    _store2.default.dispatch('profile').then(function () {
	      next();
	    });
	  } else {
	    next();
	  }
	});
	
	
	router.beforeEach(function (to, from, next) {
	  var hasToken = localStorage.getItem('backoffice-token') != null;
	
	  if (to.name == 'login') {
	    next();
	  } else {
	    if (hasToken) {
	      if (to.path.includes('login')) {
	        next({
	          path: to.path.replace('login', '')
	        });
	      } else {
	        next();
	      }
	    } else {
	      next({
	        name: 'login'
	      });
	    }
	  }
	});
	
	router.afterEach(function (to, from) {
	  _vue2.default.nextTick(function () {
	    var ucWords = function ucWords(string) {
	      return string !== undefined ? string.charAt(0).toUpperCase() + string.substring(1).toLowerCase() : '';
	    };
	
	    var title = to.name.replace(/^(\w+)?(-)?(\w+)?/, function (match, p1, p2, p3) {
	      return ucWords(p1) + ' ' + ucWords(p3);
	    });
	    if (to.hasOwnProperty('params') && to.params.hasOwnProperty('id') && to.params.id !== null) {
	      title += ' #' + to.params.id;
	    }
	    document.title = title + ' - PLAYMOOVE';
	  });
	});
	
	var app = new _vue2.default({
	  router: router,
	  store: _store2.default
	}).$mount('#app');

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(104);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(611);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extractError(error, errorCallback) {
	  var response = error.response;
	  if (response.status == 403) {
	    alert('403! You will now be logged out');
	    localStorage.removeItem('backoffice-token');
	  }
	  var parsed = '';
	  if (response) {
	    parsed = 'Error: ' + response.status + ' (' + response.request.responseURL + '): ' + (0, _stringify2.default)(response.data);
	  } else {
	    parsed = error;
	    console.log('SYS ERROR', error);
	  }
	  if (typeof errorCallback === 'function') {
	    errorCallback(error.response.data);
	  } else {
	    _maggieHelper2.default.notification(response.data.result, response.data.messages, 'alert', response.data.result_code);
	  }
	}
	
	function extractId(examine) {
	  if ((typeof examine === 'undefined' ? 'undefined' : (0, _typeof3.default)(examine)) === 'object') {
	    return examine.id;
	  } else {
	    return examine;
	  }
	}
	
	_axios2.default.interceptors.request.use(function (config) {
	  config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('backoffice-token');
	  return config;
	});
	
	var baseUrl = getBaseUrl();
	
	function url() {
	  return window.env.API_URL;
	}
	
	function getBaseUrl() {
	  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';
	
	  return url() + ('/api/backoffice/' + version + '/');
	}
	
	function getUploadUrl() {
	  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'v1';
	
	  return window.env.API_URL + '/api/' + version + '/attachment/upload';
	}
	
	var KeplerBackofficeSdk = {
	  endpoint: baseUrl,
	  getUrlForDropzone: function getUrlForDropzone() {
	    return getUploadUrl();
	  },
	  getSource: function getSource() {
	    return _axios2.default.CancelToken.source();
	  },
	
	  login: function login(body, successCallback, errorCallback) {
	    _axios2.default.post(baseUrl + 'login', body).then(function (response) {
	      successCallback(response.data);
	    }).catch(function (error) {
	      extractError(error, errorCallback);
	    });
	  },
	
	  examples: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'example/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    list: {
	      all: function all(successCallback, errorCallback) {
	        _axios2.default.get(baseUrl + 'examples').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	
	  calls: {
	    request: function request(payload, successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/';
	      _axios2.default.post(baseUrl + 'clients/call', payload).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	
	  charts: {
	    for: function _for(start, end, bracketing) {
	      var query = '?start=' + start + '&end=' + end + '&bracketing=' + bracketing;
	      return {
	        charged_reservations: function charged_reservations(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'charts/charged-reservations' + query).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        driven_distance: function driven_distance(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'charts/driven-distance' + query).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        client_registrations: function client_registrations(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'charts/client-registrations' + query).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        driver_registrations: function driver_registrations(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'charts/driver-registrations' + query).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        vehicle_reservations: function vehicle_reservations(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'charts/vehicle-reservations' + query).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        vehicle_distance: function vehicle_distance(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'charts/vehicle-distance' + query).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        reservation_types: function reservation_types(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'charts/reservation-types' + query).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        driver_stats: function driver_stats(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'charts/driver-stats' + query).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        vehicles_by_zone: function vehicles_by_zone(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/';
	          _axios2.default.get(baseUrl + 'charts/vehicles_by_zone' + query).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  vehicle: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        activateImmo: function activateImmo(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.post(baseUrl + 'vehicles/' + id + '/immo_on').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  vehicleSlots: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'vehicle_slot/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        enable: function enable(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'vehicle_slot/' + id + '/enable').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        disable: function disable(body, successCallback, errorCallback) {
	          return _axios2.default.patch(baseUrl + 'vehicle_slot/' + id + '/disable', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        dismiss: function dismiss(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.post(baseUrl + 'vehicle_slots/' + id + '/dismiss').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        move: function move(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	
	          _axios2.default.post(baseUrl + 'vehicle_slots/' + id + '/move', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        drain: function drain(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	
	          _axios2.default.post(baseUrl + 'vehicle_slots/' + id + '/drain', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    swap: function swap(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	
	      _axios2.default.post(baseUrl + 'vehicle_slots/swap', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments[2];
	
	      return {
	
	        allV2: function allV2(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'vehicle_slots/').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        all: function all(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'vehicle_slots/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        available: function available(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'vehicle_slots/available').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        logs: function logs() {
	          var entityId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	          var successCallback = arguments[1];
	          var errorCallback = arguments[2];
	
	          return _axios2.default.get(baseUrl + 'logs/' + perPage + '/' + page + '/vehicle_slot/' + entityId).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    management: function management(successCallback, errorCallback) {
	
	      var url = getBaseUrl('v2');
	      _axios2.default.get(url + 'vehicle_slots').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var url = getBaseUrl('v2');
	      _axios2.default.post(url + 'vehicle_slots', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    search: function search(body, successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'vehicle_slot/search/', { params: body }).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  vehicles: {
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(body, successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'vehicles/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        fleetMap: function fleetMap(body, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/vehicles/';
	          return _axios2.default.get(baseUrl, {
	            params: body
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        archive: function archive(id, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/vehicles/';
	          _axios2.default.post(baseUrl + (id + '/archive')).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        movements: function movements(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'vehicle/' + body.vehicle_id + '/movements/' + perPage + '/' + page, {
	            params: body
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        search: function search(successCallback, errorCallback, cancelToken) {
	          body.plate = body.query;
	          body.per_page = perPage;
	          body.page_number = page;
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/vehicles';
	
	          return _axios2.default.get(baseUrl, {
	            params: body,
	            cancelToken: cancelToken
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id, body) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'vehicle/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        availability: function availability(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'vehicle/' + id + '/availability', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        getData: function getData(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'vehicle/' + id + '/data').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        openDoors: function openDoors(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	
	          _axios2.default.post(baseUrl + 'vehicles/' + id + '/open').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        closeDoors: function closeDoors(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.post(baseUrl + 'vehicles/' + id + '/close').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          _axios2.default.put(baseUrl + 'vehicle/' + id + '/edit', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        roi: function roi(start, end, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'vehicles/' + id + '/roi?start=' + start + '&end=' + end).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        costs: function costs(start, end, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'vehicles/' + id + '/costs?start=' + start + '&end=' + end).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        attributes: function attributes(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'vehicles/' + id + '/attributes').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        forceRebook: function forceRebook(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.post(baseUrl + 'vehicles/' + id + '/force_rebook', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        toggleHidden: function toggleHidden(body, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/vehicle-slots/' + id + '/toggle_hidden');
	
	          return _axios2.default.patch(baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      _axios2.default.post(baseUrl + 'vehicle/add', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  notes: {
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        all: function all() {
	          var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	          var successCallback = arguments[1];
	          var errorCallback = arguments[2];
	
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'notes/', {
	            params: (0, _extends3.default)({}, body, {
	              page_number: page,
	              per_page: perPage
	            })
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.delete(baseUrl + 'notes/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'notes', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  maintenanceRequest: {
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        all: function all() {
	          var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	          var successCallback = arguments[1];
	          var errorCallback = arguments[2];
	
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/intervention-requests';
	          _axios2.default.get(baseUrl, {
	            params: (0, _extends3.default)({}, body, {
	              page_number: page,
	              per_page: perPage
	            })
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = url() + '/api/v3/backoffice/intervention-requests';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = url() + '/api/v3/backoffice/intervention-requests/' + id;
	          return _axios2.default.delete(baseUrl).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        update: function update(body, successCallback, errorCallback) {
	          var baseUrl = url() + '/api/v3/backoffice/intervention-requests/' + id;
	          return _axios2.default.patch(baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        complete: function complete(body, successCallback, errorCallback) {
	          var baseUrl = url() + '/api/v3/backoffice/intervention-requests/' + id + '/complete';
	          return _axios2.default.patch(baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  vehicleCost: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(body, successCallback, errorCallback) {}
	      };
	    },
	    make: function make(vehicleId, body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      _axios2.default.post(baseUrl + 'vehicles/' + vehicleId + '/add_cost', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  wallets: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          body.payment_method_id = body.payment_method.id;
	          _axios2.default.post(baseUrl + 'wallet/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        manualCreditNote: function manualCreditNote(body, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/billing/wallets/' + id + '/manual_credit_note');
	
	          return _axios2.default.post(baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        billWallet: function billWallet(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/billing/wallets/' + id + '/bill');
	          return _axios2.default.post(baseUrl).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        records: function records(walletId, successCallback, errorCallback) {
	          return _axios2.default.get(baseUrl + 'wallet/' + walletId + '/records/' + perPage + '/' + page).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        refundable: function refundable(walletId, search, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/billing/wallets/' + walletId + '/refundable_records');
	
	          var params = (0, _extends3.default)({
	            page: page,
	            limit: perPage
	          }, search);
	          return _axios2.default.get(baseUrl, {
	            params: params
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    make: function make(body) {
	      return {
	        manualRecord: function manualRecord(walletId, successCallback, errorCallback) {
	          return _axios2.default.post(baseUrl + 'wallet/' + walletId + '/add_manual_record', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	
	  },
	  walletRecords: {
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        uninvoiced: function uninvoiced(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/billing/wallets/uninvoiced';
	          return _axios2.default.get(baseUrl, {
	            params: {
	              page_number: page,
	              per_page: perPage
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  promotionalOffering: {
	    select: function select(slug) {
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/billing/promotional_offers/' + slug);
	          return _axios2.default.get(baseUrl).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        uninvoiced: function uninvoiced(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/billing/wallets/uninvoiced';
	          return _axios2.default.get(baseUrl, {
	            params: {
	              page_number: page,
	              per_page: perPage
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  clients: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          return _axios2.default.get(baseUrl + 'client/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        suspend: function suspend(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'client/' + id + '/suspend').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        activate: function activate(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'client/' + id + '/activate').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        delete: function _delete(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'client/' + id + '/delete').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	
	          _axios2.default.patch(baseUrl + 'client/' + id + '/edit', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        subscribe: function subscribe(plan_id, free_subscription, subscribe_main_driver, successCallback, errorCallback) {
	          var body = {
	            plan_id: plan_id,
	            free_subscription: free_subscription,
	            subscribe_main_driver: subscribe_main_driver
	          };
	          return _axios2.default.post(baseUrl + 'client/' + id + '/subscribe', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        setMainDriver: function setMainDriver(driverId, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'client/' + id + '/main_driver/' + driverId).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        deposits: function deposits(page_number, per_page, successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'client/' + id + '/deposits', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        dump: function dump(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'clients/' + id + '/dump').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        checkClientData: function checkClientData(successCallback, errorCallback, lookupType) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/';
	          _axios2.default.get(baseUrl + 'clients/' + id + '?lookup_type=' + lookupType).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments[2];
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'clients/' + perPage + '/' + page, (0, _extends3.default)({}, body)).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        search: function search(successCallback, errorCallback, cancelToken) {
	          var bodyClone = (0, _assign2.default)({}, body);
	          bodyClone.entity = 'client';
	          var url = baseUrl + 'search?per_page=' + perPage + '&page_number=' + page;
	          return _axios2.default.post(url, bodyClone, { cancelToken: cancelToken }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        reservations: function reservations(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'client/' + body.id + '/reservations/' + perPage + '/' + page).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        subscriptions: function subscriptions(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'client/' + body.id + '/subscriptions/' + perPage + '/' + page).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        drivers: function drivers(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'client/' + body.id + '/drivers/' + perPage + '/' + page).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        paymentMethods: function paymentMethods(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'client/' + body.id + '/payment_methods/' + perPage + '/' + page).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        wallets: function wallets(clientId, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'clients/' + clientId + '/wallets?uninvoiced=true').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        cards: function cards(clientId, successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'client/' + clientId + '/cards/' + perPage + '/' + page).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        logs: function logs() {
	          var entityId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	          var successCallback = arguments[1];
	          var errorCallback = arguments[2];
	
	          _axios2.default.get(baseUrl + 'logs/' + perPage + '/' + page + '/client/' + entityId).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        approval: function approval(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          var params = (0, _extends3.default)({
	            page_number: page,
	            per_page: perPage
	          }, body);
	          _axios2.default.get(baseUrl + 'clients/approval', {
	            params: params
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      _axios2.default.post(baseUrl + 'clients', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  clientTypes: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'client_type/' + id + '/delete').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.put(baseUrl + 'client_type/' + id + '/edit', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments[2];
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'client_types/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      _axios2.default.post(baseUrl + 'client_type/add', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  licenseTypes: {
	    list: function list() {
	      return {
	        all: function all() {
	          return [{ id: 1, name: 'Patente b' }];
	        }
	      };
	    }
	  },
	  drivers: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'driver/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        getLicences: function getLicences(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'driver/' + id + '/licenses').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        approve: function approve(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'driver/' + id + '/approve').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        suspend: function suspend(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'driver/' + id + '/suspend').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        reactivate: function reactivate(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'driver/' + id + '/reactivate').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        delete: function _delete(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'driver/' + id + '/delete').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        pictureDelete: function pictureDelete(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/';
	          _axios2.default.post(baseUrl + 'drivers/' + id + '/delete-profile-picture').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        edit: function edit(body, successCallback, errorCallback) {
	          body['salutation'] = body['title'];
	          _axios2.default.put(baseUrl + 'driver/' + id + '/edit', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        setNewPassword: function setNewPassword(body, successCallback, errorCallback) {
	          _axios2.default.put(baseUrl + 'driver/' + id + '/reset_password', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        sendPasswordResetLink: function sendPasswordResetLink(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'driver/' + id + '/password/forgot').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        tocs: function tocs(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'drivers/' + id + '/tocs').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        setFlags: function setFlags(body, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/drivers/' + id + '/set-flags');
	
	          return _axios2.default.put(baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    sendNotification: function sendNotification(body, successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/drivers/send-notification';
	      return _axios2.default.post(baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'drivers/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        maintenance: function maintenance(successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/drivers/maintenance', {
	            params: (0, _extends3.default)({
	              page: page,
	              perPage: perPage
	            }, body)
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        reservations: function reservations(driverId, successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'driver/' + driverId + '/reservations/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        subscriptions: function subscriptions(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'driver/' + body.id + '/subscriptions').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        search: function search(successCallback, errorCallback, cancelToken) {
	          body.entity = 'driver';
	          var url = baseUrl + 'search?per_page=' + perPage + '&page_number=' + page;
	          return _axios2.default.post(url, body, { cancelToken: cancelToken }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        coupons: function coupons(page_number, per_page, successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/coupons-use/' + body.id, {
	            params: (0, _extends3.default)({
	              page_number: page_number,
	              per_page: per_page
	            }, body)
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        cards: function cards(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'driver/' + body.id + '/cards/' + perPage + '/' + page).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        logs: function logs() {
	          var entityId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	          var successCallback = arguments[1];
	          var errorCallback = arguments[2];
	
	          _axios2.default.get(baseUrl + 'logs/' + perPage + '/' + page + '/driver/' + entityId).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        approval: function approval(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          var params = (0, _extends3.default)({
	            page_number: page,
	            per_page: perPage
	          }, body);
	
	          _axios2.default.get(baseUrl + 'drivers/approval', {
	            params: params
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        pendingDelete: function pendingDelete(successCallback, errorCallback) {
	          var params = (0, _extends3.default)({
	            page_number: page,
	            per_page: perPage
	          }, body);
	          return _axios2.default.get(window.env.API_URL + '/api/v3/backoffice/drivers/pending-deletion', {
	            params: params
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      _axios2.default.post(baseUrl + 'drivers/', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  driverLicenses: {
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var search = body;
	      search.page_number = page;
	      search.per_page = perPage;
	      return {
	        approval: function approval(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'documents/approval', {
	            params: search
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          body.issued_by = body.issuer.by;
	          body.issuer_country = body.issuer.country;
	          body.issued_date = body.issuer.date;
	          body.type = 1;
	
	          _axios2.default.put(baseUrl + 'driver_license/' + id + '/update', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        removeAttachment: function removeAttachment(attachmentId, successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'driver_license/' + id + '/attachment/' + attachmentId + '/remove').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        addAttachment: function addAttachment(body, successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'driver_license/' + id + '/attachment/attach', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        approve: function approve(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'driver_license/' + id + '/approve').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        delete: function _delete(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'driver_license/' + id + '/delete').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        refuse: function refuse(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'driver_license/' + id + '/refuse').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      body.approved = true;
	      _axios2.default.post(baseUrl + 'driver/' + body.driver_id + '/license', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  documentTypes: {
	    list: function list() {
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'document_types').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = getBaseUrl('v2');
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          return _axios2.default.delete(baseUrl + 'document_types/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch(baseUrl + 'document_types/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'document_types', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  documentRequirements: {
	    list: function list() {
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'document_requirements').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = getBaseUrl('v2');
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          return _axios2.default.delete(baseUrl + 'document_requirements/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch(window.env.API_URL + ('/api/v3/backoffice/document-requirements/' + id), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    entityAllowed: function entityAllowed() {
	      return {
	        entityList: function entityList(successCallback, errorCallback) {
	          return _axios2.default.get(window.env.API_URL + '/api/v3/backoffice/document-requirements/types').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = '';
	      baseUrl = window.env.API_URL + '/api/v3/backoffice/document-requirements/types';
	      return _axios2.default.post(baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  documents: {
	    list: function list() {
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'document_requirements').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = getBaseUrl('v2');
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'documents/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      _axios2.default.post(baseUrl + 'documents/', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  alarms: {
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	          var baseUrl = getBaseUrl('v2');
	          var params = (0, _extends3.default)({
	            per_page: perPage,
	            page_number: page
	          }, body);
	          return _axios2.default.get(baseUrl + 'vehicle_alarms', { params: params }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  chargingSessions: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'reservation/' + id).then(function (response) {
	            return successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        start: function start(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/charge-sessions/' + id + '/start');
	
	          return _axios2.default.post(baseUrl).then(function (response) {
	            return successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        end: function end(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/charge-sessions/' + id + '/end');
	
	          return _axios2.default.post(baseUrl).then(function (response) {
	            return successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/charge-sessions';
	          return _axios2.default.get(baseUrl, {
	
	            params: (0, _extends3.default)({
	              per_page: perPage,
	              page_number: page
	            }, body)
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/charge-sessions';
	      return _axios2.default.post(baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  preauth: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        cashIn: function cashIn(body, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/preauth/' + id + '/cash_in');
	          return _axios2.default.post(baseUrl, body).then(function (response) {
	            return successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        cancel: function cancel(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/preauth/' + id + '/cancel');
	          return _axios2.default.post(baseUrl).then(function (response) {
	            return successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        refresh: function refresh(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/preauth/' + id + '/refresh');
	          return _axios2.default.post(baseUrl).then(function (response) {
	            return successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/charge-sessions';
	          return _axios2.default.get(baseUrl, {
	
	            params: (0, _extends3.default)({
	              per_page: perPage,
	              page_number: page
	            }, body)
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	
	  },
	  reservations: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'reservation/' + id).then(function (response) {
	            return successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        open: function open(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'reservations/' + id + '/open').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        close: function close(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'reservations/' + id + '/close').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        cancel: function cancel(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'reservations/' + id + '/cancel').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        terminate: function terminate(body, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/reservations/' + id + '/terminate');
	          return _axios2.default.post(baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        void: function _void(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'reservations/' + id + '/void').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        replaceVehicleSlot: function replaceVehicleSlot(body, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/reservations/' + id);
	
	          return _axios2.default.patch(baseUrl + '/vehicle_replace', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        complete: function complete(body, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/reservations/' + id);
	          return _axios2.default.post(baseUrl + '/complete', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        extend: function extend(end_time, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'reservations/' + id + '/extend', {
	            'end': end_time
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        resend: function resend(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'reservation/' + id + '/resend_to_vehicle').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        debugInfo: function debugInfo(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'reservation/' + id + '/debug_info').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'reservations/' + id + '/edit', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        report: function report(body, successCallback, errorCallback) {
	          return _axios2.default.post(url() + '/api/v3/backoffice/reservations/' + id + '/report', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        bookedTimes: function bookedTimes(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'reservations/' + id + '/booked_times').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        deposits: function deposits(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'reservations/' + id + '/deposits').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        route: function route(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'reservation/' + id + '/route').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        reconciliate: function reconciliate(successCallback, errorCallback) {
	          return _axios2.default.post(url() + '/api/v3/backoffice/reservations/' + id + '/reconciliate').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        uncoveredAmount: function uncoveredAmount(successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/reservations/' + id + '/uncovered_amount').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        cleanUp: function cleanUp(successCallback, errorCallback) {
	          return _axios2.default.post(url() + '/api/v3/backoffice/reservations/' + id + '/clean_up').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        requestPreauth: function requestPreauth(amount, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/reservations/' + id + '/request_preauth');
	          return _axios2.default.post(baseUrl, { amount: amount }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        replaceMaintenanceDriver: function replaceMaintenanceDriver(body, successCallback, errorCallback) {
	          return _axios2.default.patch(url() + '/api/v3/backoffice/reservations/' + id + '/replace_maintenance_driver', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          return _axios2.default.post(baseUrl + 'reservations/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        search: function search(successCallback, errorCallback, cancelToken) {
	          body.entity = 'reservation';
	          _axios2.default.post(baseUrl + 'search?per_page=' + perPage + '&page_number=' + page, body, { cancelToken: cancelToken }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        modes: function modes(successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/reservations/available_booking_types').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        driversReservationRequests: function driversReservationRequests(filter, successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/driver-reservation-requests', {
	            params: (0, _extends3.default)({
	              per_page: perPage,
	              page_number: page
	            }, filter)
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        preauths: function preauths(body, successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/reservations/' + body.reservation_id + '/preauths', {
	            params: {
	              per_page: perPage,
	              page_number: page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'reservations', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    makeDriverRequestBooking: function makeDriverRequestBooking(requestId, body, successCallback, errorCallback) {
	      return _axios2.default.post(url() + '/api/v3/backoffice/reservations/reservation_request/' + requestId + '/book', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    rejectDriverRequestBooking: function rejectDriverRequestBooking(requestId, successCallback, errorCallback) {
	      return _axios2.default.delete(url() + '/api/v3/backoffice/driver-reservation-requests/' + requestId).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    updateStatusRequest: function updateStatusRequest(requestId, body, successCallback, errorCallback) {
	      return _axios2.default.patch(url() + '/api/v3/backoffice/driver-reservation-requests/' + requestId, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    planning: function planning(body, successCallback, errorCallback) {
	      return _axios2.default.post(url() + '/api/v3/backoffice/reservations/find_vehicle_for_shifts', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    bookPlanning: function bookPlanning(body, successCallback, errorCallback) {
	      return _axios2.default.post(url() + '/api/v3/backoffice/reservations/book_planning', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  subscriptions: {
	    select: function select(id) {
	      var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'subscription/' + id).then(function (response) {
	            return successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        removeDriver: function removeDriver(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'subscriptions/remove_driver', {
	            subscription_id: id,
	            driver_id: body.driver_id
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        addDriver: function addDriver(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'subscriptions/associate_driver', {
	            subscription_id: id,
	            driver_id: body.driver_id
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        renew: function renew(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'subscription/' + id + '/renew').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        disable: function disable(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'subscription/' + id + '/void').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'subscription/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'subscription/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	
	      };
	    },
	
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'subscriptions/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	
	  },
	  invoices: {
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoices/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        paid: function paid(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoices/1000/1', {
	            status: 'PAID'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        onHold: function onHold(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoices/1000/1', {
	            status: 'ON HOLD'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        awaitingPayment: function awaitingPayment(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoices/1000/1', {
	            status: 'AWAITING PAYMENT'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        noPaymentMethod: function noPaymentMethod(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoices/1000/1', {
	            status: 'NO PAYMENT METHOD'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        sent: function sent(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoices/1000/1', {
	            status: 'SENT'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        overDue: function overDue(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoices/1000/1', {
	            status: 'OVERDUE'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        canceled: function canceled(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoices/1000/1', {
	            status: 'CANCELED'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        client: function client(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'billing/invoices/' + body.client_id, {
	            params: (0, _extends3.default)({
	              per_page: perPage,
	              page_number: page
	            }, body)
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'invoice/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        payInvoice: function payInvoice(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoice/' + id + '/pay').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        setPaid: function setPaid(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'invoice/' + id + '/payed').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        setAwaitingPayment: function setAwaitingPayment(successCallback, errorCallback) {
	          return _axios2.default.patch(url() + '/api/v3/backoffice/billing/invoices/' + id + '/mark_awaiting_payment').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            console.log(error);
	            extractError(error, errorCallback);
	          });
	        },
	        voidInvoice: function voidInvoice(body, successCallback, errorCallback) {
	          return _axios2.default.post(baseUrl + 'invoice/' + id + '/void', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        downloadXML: function downloadXML(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'modules/italian-e-invoice/download/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        downloadZucchetti: function downloadZucchetti(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'modules/zucchetti/download/' + id, {
	            params: (0, _extends3.default)({}, body)
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        sendToSdi: function sendToSdi(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.post(baseUrl + 'modules/aruba-italian-e-invoice/upload/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        getStatus: function getStatus(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'modules/aruba-italian-e-invoice/get_status/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        updateFilename: function updateFilename(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.post(baseUrl + 'modules/aruba-italian-e-invoice/update_filename/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        convertToCreditNote: function convertToCreditNote(body, successCallback, errorCallback) {
	          var baseUrl = url() + '/api/v3/backoffice/billing/invoices/' + id + '/proforma_to_credit_note';
	          return _axios2.default.patch(baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    archiveXml: function archiveXml(body) {
	      var baseUrl = getBaseUrl('v2');
	      var token = localStorage.getItem('backoffice-token');
	      var url = baseUrl + 'modules/italian-e-invoice/archive?driver_id=0&token=' + token + '&emission_from=' + body.from + '&emission_to=' + body.to;
	      if (body.type != null) {
	        url += '&type=' + body.type;
	      }
	      return url;
	    }
	  },
	  reportings: {
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'reportings/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        types: function types(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'reportings/types').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'reportings/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        setVoided: function setVoided(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'reportings/' + id + '/status', {
	            status: 'VOIDED'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        setConfirmed: function setConfirmed(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'reportings/' + id + '/status', {
	            status: 'CONFIRMED'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        setResolved: function setResolved(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'reportings/' + id + '/status', {
	            status: 'RESOLVED'
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'reportings/' + id + '/edit', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    make: function make(vehicleId, body, successCallback, errorCallback) {
	      _axios2.default.post(baseUrl + 'reportings/' + vehicleId, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  vehicleCategories: {
	    list: function list(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'vehicle_categories').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        addPicture: function addPicture(body, successCallback, errorCallback) {
	          _axios2.default.put(baseUrl + 'vehicle_category/' + id + '/add_picture', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'vehicle_category/' + id + '/edit', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          return _axios2.default.delete(url() + '/api/v3/backoffice/vehicle-category/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      _axios2.default.post(baseUrl + 'vehicle_category/add', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  cards: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'cards/' + id + '/edit', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        unbind: function unbind(successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'cards/' + id + '/unbind').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'cards/' + id + '/delete').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'cards/search?per_page=' + perPage + '&page_number=' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        unassigned: function unassigned(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'cards/search?per_page=1000&page_number=1&driver_id=null').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      _axios2.default.post(baseUrl + 'cards', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  plans: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'plans/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.patch(baseUrl + 'plans/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        rates: function rates(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'plans/' + id + '/rates').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    list: function list() {
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'plans/').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'plans', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  selects: {
	    vehicleBrands: function vehicleBrands(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'select/vehicle_brands').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    vehicleCategories: function vehicleCategories(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'select/vehicle_categories').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    clients: function clients(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'select/clients').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    plans: function plans() {
	      var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var successCallback = arguments[1];
	      var errorCallback = arguments[2];
	
	      _axios2.default.get(baseUrl + 'select/plans?disabled=' + disabled).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    vehicles: function vehicles() {
	      var disabledSlot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var archived = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var successCallback = arguments[2];
	      var errorCallback = arguments[3];
	
	      _axios2.default.get(baseUrl + 'select/vehicles?disabledSlot=' + disabledSlot + '&archived=' + archived).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    vehicleSlots: function vehicleSlots(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'select/vehicle_slots').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    drivers: function drivers(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'select/drivers').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    reportingTypes: function reportingTypes(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'select/reporting_types').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    timeRates: function timeRates(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'select/time_rates').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    distanceRates: function distanceRates(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'select/distance_rates').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  reports: {
	    list: function list() {
	      var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return {
	        vehicles: function vehicles(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'reports/vehicles', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        reservations: function reservations(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'reports/reservations', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        clients: function clients(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'reports/clients', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        subscriptions: function subscriptions(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'reports/subscriptions', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        invoices: function invoices(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'reports/invoices', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	
	      };
	    }
	
	  },
	  transactions: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'transactions/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        refund: function refund(body, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'transactions/' + id + '/refound', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          _axios2.default.post(baseUrl + 'transactions/' + perPage + '/' + page, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  logs: {
	    list: function list() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        all: function all() {
	          var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	          var entityId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	          var successCallback = arguments[2];
	          var errorCallback = arguments[3];
	
	          _axios2.default.get(baseUrl + 'logs/' + perPage + '/' + page + '/' + entity + '/' + entityId).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  timeOverrides: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'time_overrides/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'time_overrides/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    make: function make(body, successCallback, errorCallback) {
	      _axios2.default.post(baseUrl + 'time_overrides', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  bulkOverrides: {
	    make: function make(body, successCallback, errorCallback) {
	      _axios2.default.post(baseUrl + 'bulk_overrides', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'bulk_overrides/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  distanceOverrides: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + 'distance_overrides/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + 'distance_overrides/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    make: function make(body, successCallback, errorCallback) {
	      _axios2.default.post(baseUrl + 'distance_overrides', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  timeRates: {
	    make: function make(body, successCallback, errorCallback) {
	      return _axios2.default.post(baseUrl + 'time_rates', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  distanceRates: {
	    make: function make(body, successCallback, errorCallback) {
	      return _axios2.default.post(baseUrl + 'distance_rates', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	
	  },
	  configuration: {
	    get: function get(successCallback, errorCallback) {
	      _axios2.default.get(baseUrl + 'config').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    getPromise: function getPromise() {
	      return _axios2.default.get(baseUrl + 'config');
	    },
	    update: function update(key, value, successCallback, errorCallback) {
	      _axios2.default.patch(baseUrl + 'config', { key: key, value: value }).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  parkingGroups: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'parking_group/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.post(baseUrl + 'parking_groups/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'parking_groups/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        parkingLots: function parkingLots(body, successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/parking-group/' + id + '/parking_lots', {
	            params: body
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        _axios2.default.get(baseUrl + 'parking_groups').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      },
	      allv3: function allv3(successCallback, errorCallback) {
	        return _axios2.default.get(url() + '/api/v3/backoffice/parking-group', {
	          params: {
	            per_page: -1,
	            page_number: 1
	          }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    },
	
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      _axios2.default.post(baseUrl + 'parking_groups', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  parkingLots: {
	    list: {
	      all: function all(successCallback, errorCallback) {
	        _axios2.default.get(baseUrl + 'parking_lots').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + 'parking_lot/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        update: function update(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.post(baseUrl + ('parking_lots/' + id), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + ('parking_lots/' + id)).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      _axios2.default.post(baseUrl + 'parking_lots', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  parkingSlots: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        update: function update(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.post(baseUrl + ('parking_slots/' + id), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + ('parking_slots/' + id)).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        archive: function archive(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.patch(baseUrl + ('parking_slots/' + id + '/archive'), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'parking_slots').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      },
	      slots: function slots(lotId, successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'parking_lots/' + lotId + '/slots').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      _axios2.default.post(baseUrl + 'parking_slots', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  zones: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          _axios2.default.get(baseUrl + ('zone/' + id)).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        update: function update(body, successCallback, errorCallback) {
	          _axios2.default.patch(baseUrl + ('zone/' + id), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          _axios2.default.delete(baseUrl + ('zone/' + id + '/delete')).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        getGeoJson: function getGeoJson(successCallback, errorCallback) {
	          _axios2.default.get(url() + '/api/v3/backoffice/zone/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        _axios2.default.get(baseUrl + 'zone').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      },
	      grouped: function grouped(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'zone').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    },
	    make: function make(body, successCallback, errorCallback) {
	      _axios2.default.put(baseUrl + 'zone/add', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    mergeGeoJson: function mergeGeoJson(body, successCallback, errorCallback) {
	      _axios2.default.post(url() + '/api/v3/backoffice/zone/geojson/merge', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  vehicleTypes: {
	    list: {
	      all: function all(successCallback, errorCallback) {
	        _axios2.default.get(baseUrl + 'vehicle_types').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          _axios2.default.delete(url() + '/api/v3/backoffice/vehicle-types/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v1');
	
	      _axios2.default.post(baseUrl + 'vehicle_type/add', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  vehicleHardware: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	
	      _axios2.default.post(baseUrl + 'vehicle_hardwares', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'vehicle_hardwares/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.post(baseUrl + 'vehicle_hardwares/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'vehicle_hardwares').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      },
	      managers: function managers(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'vehicle_hardwares/managers').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	  files: {
	    uploadImage: function uploadImage(file, visibility, prefix, filename, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	
	      var formData = new FormData();
	      formData.append('file', file);
	      formData.append('visibility', visibility);
	      formData.append('prefix', prefix);
	      formData.append('filename', filename);
	
	      _axios2.default.post(baseUrl + 'files/upload', formData, {
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      }).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    remove: function remove(internalPath, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.delete(baseUrl + 'files', {
	        params: {
	          path: internalPath
	        }
	      }).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    list: {
	      public: function _public() {
	        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var successCallback = arguments[1];
	        var errorCallback = arguments[2];
	
	        var baseUrl = getBaseUrl('v2');
	        return _axios2.default.get(baseUrl + 'files/index_public', {
	          params: { prefix: prefix }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	  assetCosts: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'asset_costs/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      types: function types(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'asset_costs/types').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	
	    }
	  },
	  planReservationRates: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'plan_reservation_rates/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.patch(baseUrl + 'plan_reservation_rates/' + body.id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'plan_reservation_rates/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'plan_reservation_rates', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  reservationRates: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'reservation_rates', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'reservation_rates/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'reservation_rate/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.patch(baseUrl + 'reservation_rates/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      rates: function rates(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'reservation_rates').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	
	    }
	  },
	  tocTypes: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'toc_types', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'toc_types/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.patch(baseUrl + 'toc_types/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'toc_types').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	
	    }
	  },
	  payment_methods: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'payment_methods', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.delete(baseUrl + 'payment_methods/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  tocs: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'tocs', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'tocs/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.patch(baseUrl + 'tocs/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'tocs/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'tocs').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	
	    }
	  },
	  instructions: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'instructions', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'instructions/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.patch(baseUrl + 'instructions/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'instructions/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'instructions').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	  vehicleInstructions: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'vehicle_instructions', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'vehicle_instructions/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.patch(baseUrl + 'vehicle_instructions/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'vehicle_instructions/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'vehicle_instructions').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	  vehicleAttributes: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'vehicle_attributes', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'vehicle_attributes/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.patch(baseUrl + 'vehicle_attributes/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'vehicle_attributes/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'vehicle_attributes').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	  vehicleVehicleAttributes: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'vehicle_vehicleattributes', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.patch(baseUrl + 'vehicle_vehicleattributes/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.delete(baseUrl + 'vehicle_vehicleattributes/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'vehicle_attributes').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	  reportingTypes: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'reporting_types', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.patch(baseUrl + 'reporting_types/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'vehicle_attributes').then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	  console: {
	    run: function run(command, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'console', {
	        'command': command
	      }).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        errorCallback(error);
	      });
	    },
	    list: function list(successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.get(baseUrl + 'console').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        errorCallback(error);
	      });
	    }
	  },
	  credits: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'billing/credits/' + body.client_id + '/promo', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    makePaid: function makePaid(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'billing/credits/' + body.client_id + '/paid', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        balance: function balance(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'billing/' + id + '/balance').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        expire: function expire(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.patch(baseUrl + 'billing/credits/' + id + '/expire').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    list: {
	      all: function all(body, page_number, per_page, successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'billing/credits/' + body.client_id, {
	          params: (0, _extends3.default)({
	            per_page: per_page,
	            page_number: page_number
	          }, body)
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    },
	    usages: function usages(recordId, page_number, per_page, successCallback, errorCallback) {
	      return _axios2.default.get(url() + '/api/v3/backoffice/billing/credits/' + recordId + '/usages', {
	        params: {
	          per_page: per_page,
	          page_number: page_number
	        }
	      }).then(function (response) {
	        console.log(response.data);
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  topUps: {
	    list: {
	      all: function all(client_id, page_number, per_page, successCallback, errorCallback) {
	        var baseUrl = getBaseUrl('v2');
	        _axios2.default.get(baseUrl + 'billing/' + client_id + '/top_ups', {
	          params: {
	            per_page: per_page,
	            page_number: page_number
	          }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	  packetRecords: {
	    list: {
	      all: function all(client_id, page_number, per_page, successCallback, errorCallback) {
	        return _axios2.default.get(window.env.API_URL + ('/api/v3/backoffice/clients/' + client_id + '/packets'), {
	          params: {
	            per_page: per_page,
	            page_number: page_number
	          }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      },
	      usages: function usages(recordId, page_number, per_page, successCallback, errorCallback) {
	        return _axios2.default.get(window.env.API_URL + ('/api/v3/backoffice/packet-records/' + recordId + '/usages'), {
	          params: {
	            per_page: per_page,
	            page_number: page_number
	          }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    }
	  },
	  policies: {
	    list: function list() {
	      var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	
	          _axios2.default.get(baseUrl + 'policies/', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'policies/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.patch(baseUrl + 'policies/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.delete(baseUrl + 'policies/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'policies', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  commonCosts: {
	    list: function list() {
	      return {
	        all: function all(page_number, per_page, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'common_costs', {
	            params: {
	              per_page: per_page,
	              page_number: page_number
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = getBaseUrl('v2');
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch(baseUrl + 'common_costs/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        delete: function _delete(successCallback, errorCallback) {
	          return _axios2.default.delete(baseUrl + 'common_costs/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        addToWallet: function addToWallet(body, successCallback, errorCallback) {
	          return _axios2.default.post(baseUrl + 'common_costs/' + id + '/add_to_wallet', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'common_costs/', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  packets: {
	    list: {
	      all: function all() {
	        var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
	        var successCallback = arguments[2];
	        var errorCallback = arguments[3];
	
	        _axios2.default.get(window.env.API_URL + '/api/v3/backoffice/packets', {
	          params: {
	            per_page: per_page,
	            page_number: page_number
	          }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch(window.env.API_URL + ('/api/v3/backoffice/packets/' + id), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      return _axios2.default.post(window.env.API_URL + '/api/v3/backoffice/packets', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  packetVehicleCategories: {
	    list: {
	      all: function all() {
	        var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
	        var successCallback = arguments[2];
	        var errorCallback = arguments[3];
	
	        _axios2.default.get(window.env.API_URL + '/api/v3/backoffice/packet-vehicle-category', {
	          params: {
	            per_page: per_page,
	            page_number: page_number
	          }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch(window.env.API_URL + ('/api/v3/backoffice/packet-vehicle-category/' + id), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        delete: function _delete(body, successCallback, errorCallback) {
	          return _axios2.default.delete(window.env.API_URL + ('/api/v3/backoffice/packet-vehicle-category/' + id), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      return _axios2.default.post(window.env.API_URL + '/api/v3/backoffice/packet-vehicle-category', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  translations: {
	    list: {
	      all: function all() {
	        var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
	        var successCallback = arguments[2];
	        var errorCallback = arguments[3];
	
	        _axios2.default.get(window.env.API_URL + '/api/v3/backoffice/translation', {
	          params: {
	            per_page: per_page,
	            page_number: page_number
	          }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      },
	      overridable: function overridable(groups, key, successCallback, errorCallback) {
	        return _axios2.default.get(window.env.API_URL + '/api/v3/backoffice/translation/langs/overridable', {
	          params: {
	            groups: groups,
	            key: key
	          }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          return _axios2.default.get(window.env.API_URL + ('/api/v3/backoffice/translation/' + id)).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        update: function update(body, successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + ('/api/v3/backoffice/translation/' + id + '/update');
	          return _axios2.default.patch('' + baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = window.env.API_URL + '/api/v3/backoffice/';
	          return _axios2.default.delete(baseUrl + 'translation/' + id + '?XDEBUG_SESSION_START').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/translation';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  commonCostType: {
	    list: {
	      all: function all() {
	        var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
	        var successCallback = arguments[2];
	        var errorCallback = arguments[3];
	
	        _axios2.default.get(window.env.API_URL + '/api/v3/backoffice/common-cost-type', {
	          params: {
	            per_page: per_page,
	            page_number: page_number
	          }
	        }).then(function (response) {
	          successCallback(response.data);
	        }).catch(function (error) {
	          extractError(error, errorCallback);
	        });
	      }
	
	    },
	
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = '';
	      baseUrl = window.env.API_URL + '/api/v3/backoffice/common-cost-type';
	      _axios2.default.post(baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	
	    edit: function edit(body, successCallback, errorCallback) {
	      var baseUrl = '';
	      baseUrl = window.env.API_URL + ('/api/v3/backoffice/common-cost-type/' + body.id + '/update');
	      _axios2.default.patch(baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  zoneConfigurations: {
	    list: function list() {
	      return {
	        all: function all(page_number, per_page, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'zone_configs/', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = getBaseUrl('v2');
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          return _axios2.default.get(baseUrl + 'zone_configs/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch(baseUrl + 'zone_configs/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        delete: function _delete(successCallback, errorCallback) {
	          return _axios2.default.delete(baseUrl + 'zone_configs/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'zone_configs/', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  reservationFlags: {
	    list: function list() {
	      return {
	        all: function all(page_number, per_page, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'zone_configs/', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = getBaseUrl('v2');
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          return _axios2.default.get(baseUrl + 'zone_configs/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch(baseUrl + 'reservation_flags/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        delete: function _delete(successCallback, errorCallback) {
	          return _axios2.default.delete(baseUrl + 'reservation_flags/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(id, body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + ('reservation_flags/' + id), body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  groups: {
	    list: function list() {
	      var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	
	          _axios2.default.get(baseUrl + 'groups/', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'groups/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.patch(baseUrl + 'groups/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        drivers: function drivers(page_number, per_page, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'groups/' + id + '/drivers', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.delete(baseUrl + 'groups/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'groups', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	
	  driverGroups: {
	    list: function list() {
	      var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	
	          _axios2.default.get(baseUrl + 'groups/', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        detach: function detach(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          console.log(body);
	          return _axios2.default.delete(baseUrl + 'driver_groups/' + id, { data: body }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        toggleSupervisor: function toggleSupervisor(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.patch(baseUrl + 'driver_groups/' + id + '/supervisor', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'groups', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  vehiclePolicies: {
	    list: function list(id) {
	      var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var per_page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	
	          _axios2.default.get(baseUrl + 'vehicle_policies/' + id, {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.delete(baseUrl + 'vehicle_policies/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'vehicle_policies/' + body.vehicle_id, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  driverPolicies: {
	    list: function list(id) {
	      var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var per_page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	
	          return _axios2.default.get(baseUrl + 'driver_policies/' + id, {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.delete(baseUrl + 'driver_policies/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'driver_policies/' + body.driver_id, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  hooks: {
	    manual: function manual(body, successCallback, errorCallback) {
	      _axios2.default.post('https://core.staging.playmoove.com/hooks/manual', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    vehicleStatus: function vehicleStatus(hw, successCallback, errorCallback) {
	      _axios2.default.get('https://core.staging.playmoove.com/api/v2/vehicles/status/' + hw).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  federations: {
	    list: function list() {
	      var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'federations/', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.delete(baseUrl + 'federations/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        updateFederated: function updateFederated(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.patch(baseUrl + 'federations/' + id + '/update_federated', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'federations', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  federationVehicles: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var page_number = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	          var per_page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
	
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'federations/' + id + '/vehicles', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	
	  },
	  federationParkingGroups: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var page_number = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	          var per_page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
	
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'federations/' + id + '/parking_groups', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	
	  },
	  federationClients: {
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var page_number = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	          var per_page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
	
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'federations/' + id + '/clients', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	
	  },
	  users: {
	    list: function list() {
	      var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'users/', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'users/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.delete(baseUrl + 'users/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.patch(baseUrl + 'users/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'users', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    profile: function profile() {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.get(baseUrl + 'users/profile');
	    }
	  },
	  roles: {
	    list: function list() {
	      var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'roles/', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        permissions: function permissions(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          _axios2.default.get(baseUrl + 'roles/permissions').then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      id = extractId(id);
	      return {
	        get: function get(successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.get(baseUrl + 'roles/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        edit: function edit(body, successCallback, errorCallback) {
	          var baseUrl = getBaseUrl('v2');
	          return _axios2.default.patch(baseUrl + 'roles/' + id, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.post(baseUrl + 'roles', body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  userConfig: {
	    list: function list() {
	      var baseUrl = getBaseUrl('v2');
	      return _axios2.default.get(baseUrl + 'user_configs/');
	    }
	  },
	  sentinel: {
	    list: function list(page_number, per_page, body) {
	      return {
	        all: function all(successCallback, errorCallback) {
	          body.page_number = page_number;
	          body.per_page = per_page;
	          return _axios2.default.get(url() + '/api/v3/backoffice/sentinel', {
	            params: body
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  export: {
	    getCsv: function getCsv(report, body) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/';
	      var token = localStorage.getItem('backoffice-token');
	      var url = baseUrl + 'export?driver_id=0&token=' + token + '&entity=' + report + '&format=csv';
	
	      if (body.start) url += '&start=' + body.start;
	      if (body.end) url += '&end=' + body.end;
	      if (body.params && (0, _typeof3.default)(body.params) === 'object') {
	        var params = (0, _keys2.default)(body.params).filter(function (k) {
	          return !!body.params[k];
	        }).map(function (k) {
	          return k + '|' + body.params[k];
	        }).join('-');
	        if (params) url += '&params=' + params;
	      }
	      return url;
	    },
	    getTypes: function getTypes(successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/';
	      return _axios2.default.get(baseUrl + 'export/types').then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	
	  cargo: {
	    cargoOperationCreate: function cargoOperationCreate(body, successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/cargo';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    operationList: function operationList(page_number, per_page, successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/cargo';
	      return _axios2.default.get('' + baseUrl, {
	        params: {
	          page_number: page_number,
	          per_page: per_page
	        }
	      }).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    getOperation: function getOperation(id, successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/cargo';
	      return _axios2.default.get(baseUrl + '/' + id).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    import: function _import(file, successCallback, errorCallback) {
	      var baseUrl = getBaseUrl('v1');
	      var formData = new FormData();
	      formData.append("attachment", file);
	      return _axios2.default.post(baseUrl + 'attachment/upload', formData, {
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      }).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    stop: function stop(id, successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + ('/api/v3/backoffice/cargo/' + id + '/stop');
	      return _axios2.default.post(baseUrl).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  clone: {
	    cloneVehicle: function cloneVehicle(body, successCallback, errorCallback) {
	      var baseUrl = window.env.API_URL + '/api/v3/backoffice/import-clone';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  coupons: {
	    list: function list(page_number, per_page) {
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/coupons', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        list: function list(successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/coupons-use/list', {
	            params: (0, _extends3.default)({
	              page_number: page_number,
	              per_page: per_page
	            }, body)
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = url() + '/api/v3/backoffice/coupons/' + id;
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch('' + baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = url() + '/api/v3/backoffice/coupons';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  segments: {
	    list: function list(page_number, per_page) {
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/segments', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = url() + '/api/v3/backoffice/segments/' + id;
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch('' + baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        vehicles: function vehicles(page_number, per_page, successCallback, errorCallback) {
	          return _axios2.default.get(baseUrl + '/vehicles', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        addVehicles: function addVehicles(body, successCallback, errorCallback) {
	          return _axios2.default.post(baseUrl + '/vehicles', body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        removeVehicles: function removeVehicles(body, successCallback, errorCallback) {
	          console.log(body);
	          return _axios2.default.delete(baseUrl + '/vehicles', { data: body }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = url() + '/api/v3/backoffice/segments';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  segmentRates: {
	    list: function list(page_number, per_page) {
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/segment-rates', {
	            params: {
	              page_number: page_number,
	              per_page: per_page,
	              segment_id: body
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = url() + '/api/v3/backoffice/segment-rates/' + id;
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch('' + baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        remove: function remove(successCallback, errorCallback) {
	          return _axios2.default.delete('' + baseUrl).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = url() + '/api/v3/backoffice/segment-rates';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  segmentAttributes: {
	
	    select: function select(id) {
	      var baseUrl = url() + '/api/v3/backoffice/segment-attributes/' + id;
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch('' + baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          });
	        },
	        delete: function _delete(successCallback, errorCallback) {
	          return _axios2.default.delete('' + baseUrl).then(function (response) {
	            successCallback(response.data);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      console.log(body);
	      var baseUrl = url() + '/api/v3/backoffice/segment-attributes';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      });
	    }
	  },
	
	  notifications: {
	    list: function list() {
	      var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          return _axios2.default.get(window.env.API_URL + ('/api/v3/backoffice/notifications?limit=' + per_page + '&page=' + page_number), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    }
	  },
	  registrationTokens: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = url() + '/api/v3/backoffice/registration-tokens';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    },
	    list: function list() {
	      var page_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	      var per_page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return {
	        all: function all(successCallback, errorCallback) {
	          return _axios2.default.get(window.env.API_URL + ('/api/v3/backoffice/registration-tokens?per_page=' + per_page + '&page_number=' + page_number), body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    select: function select(id) {
	      var baseUrl = url() + '/api/v3/backoffice/registration-tokens/' + id;
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch('' + baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        remove: function remove(successCallback, errorCallback) {
	          return _axios2.default.delete(url() + '/api/v3/backoffice/registration-tokens/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	        apply: function apply(clientId, successCallback, errorCallback) {
	          return _axios2.default.patch(url() + '/api/v3/backoffice/registration-tokens/' + id + '/apply_token', { client_id: clientId }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	
	      };
	    }
	  },
	  vats: {
	    list: function list(page_number, per_page) {
	      return {
	        all: function all(successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/vat', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	
	      };
	    },
	    select: function select(id) {
	      var baseUrl = url() + '/api/v3/backoffice/vat/' + id;
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch('' + baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        remove: function remove(successCallback, errorCallback) {
	          return _axios2.default.delete(url() + '/api/v3/backoffice/vat/' + id).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = url() + '/api/v3/backoffice/vat';
	      return _axios2.default.post('' + baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  splash: {
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = url() + '/api/v3/backoffice/configs/wizard/splash';
	      return _axios2.default.post(baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  },
	  pages: {
	    list: function list(page_number, per_page) {
	      return {
	        all: function all(successCallback, errorCallback) {
	          return _axios2.default.get(url() + '/api/v3/backoffice/pages', {
	            params: {
	              page_number: page_number,
	              per_page: per_page
	            }
	          }).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	
	      };
	    },
	    select: function select(id) {
	      var baseUrl = url() + '/api/v3/backoffice/pages/' + id;
	      return {
	        edit: function edit(body, successCallback, errorCallback) {
	          return _axios2.default.patch('' + baseUrl, body).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        },
	
	        remove: function remove(successCallback, errorCallback) {
	          var baseUrl = url() + '/api/v3/backoffice/pages/' + id;
	          return _axios2.default.delete(baseUrl).then(function (response) {
	            successCallback(response.data);
	          }).catch(function (error) {
	            extractError(error, errorCallback);
	          });
	        }
	      };
	    },
	    make: function make(body, successCallback, errorCallback) {
	      var baseUrl = url() + '/api/v3/backoffice/pages';
	      return _axios2.default.post(baseUrl, body).then(function (response) {
	        successCallback(response.data);
	      }).catch(function (error) {
	        extractError(error, errorCallback);
	      });
	    }
	  }
	};
	
	exports.default = KeplerBackofficeSdk;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(161);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _keplerSdk = __webpack_require__(65);
	
	var _keplerSdk2 = _interopRequireDefault(_keplerSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaggieHelper = {
	  callback: null,
	  notification: function notification(title, subtitile, severity) {
	    var code = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    _store2.default.dispatch('newNotification', {
	      title: title,
	      subtitle: subtitile,
	      style: severity,
	      code: code
	    });
	  },
	  login: function login(user, token) {
	    _store2.default.dispatch('login', user);
	    if (token != null) {
	      this.token(token);
	    }
	  },
	
	  token: function token(_token) {
	    _store2.default.dispatch('setToken', _token);
	  },
	  checkForToken: function checkForToken() {
	    var that = this;
	    if (localStorage.getItem('token') != null) {
	      var token = localStorage.getItem('token');
	      this.token(token);
	      _keplerSdk2.default.driver(function (driver) {
	        that.login(driver);
	      }, function (e) {
	        localStorage.removeItem('token');
	      });
	    }
	  },
	
	  isAdminLoggedIn: function isAdminLoggedIn() {
	    return localStorage.getItem('backoffice-token') !== null;
	  },
	
	  registerCallback: function registerCallback(incomingCallback) {
	    this.callback = incomingCallback;
	  },
	  openRightPanel: function openRightPanel(options) {
	    options.position = 'right';
	    this.callback(options);
	  },
	  openTopPanel: function openTopPanel(options) {
	    options.position = 'top';
	    this.callback(options);
	  },
	  closeTopPanel: function closeTopPanel() {
	    this.callback({});
	  },
	  closeRightPanel: function closeRightPanel() {
	    $('#offCanvasRight').foundation('close');
	  },
	
	  showPreloader: function showPreloader() {
	    $('#preloader').removeClass('is-hidden');
	  },
	  hidePreloader: function hidePreloader() {
	    $('#preloader').addClass('is-hidden');
	  }
	};
	
	exports.default = MaggieHelper;

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1807)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(853),
	  /* template */
	  __webpack_require__(2663),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1713)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(842),
	  /* template */
	  __webpack_require__(2567),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1801)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1043),
	  /* template */
	  __webpack_require__(2656),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1822)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(841),
	  /* template */
	  __webpack_require__(2678),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1671)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1134),
	  /* template */
	  __webpack_require__(2523),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1879)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(818),
	  /* template */
	  __webpack_require__(2736),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1805)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(816),
	  /* template */
	  __webpack_require__(2661),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventBus = undefined;
	
	var _vue = __webpack_require__(129);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventBus = exports.EventBus = new _vue2.default();

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1698)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(823),
	  /* template */
	  __webpack_require__(2552),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1421)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(829),
	  /* template */
	  __webpack_require__(2268),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1389)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(653),
	  /* template */
	  __webpack_require__(2236),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(997),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1442)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(706),
	  /* template */
	  __webpack_require__(2289),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1861)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(894),
	  /* template */
	  __webpack_require__(2718),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1508)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(860),
	  /* template */
	  __webpack_require__(2356),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1640)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1006),
	  /* template */
	  __webpack_require__(2491),
	  /* scopeId */
	  "data-v-55ad4956",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1842)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1023),
	  /* template */
	  __webpack_require__(2699),
	  /* scopeId */
	  "data-v-d6f60c62",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1744)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1093),
	  /* template */
	  __webpack_require__(2599),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1629)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(861),
	  /* template */
	  __webpack_require__(2480),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1705)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(852),
	  /* template */
	  __webpack_require__(2559),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1371)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(863),
	  /* template */
	  __webpack_require__(2218),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1760)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(689),
	  /* template */
	  __webpack_require__(2615),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1621)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1028),
	  /* template */
	  __webpack_require__(2472),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1656)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(822),
	  /* template */
	  __webpack_require__(2507),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1451)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(701),
	  /* template */
	  __webpack_require__(2298),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1864)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(806),
	  /* template */
	  __webpack_require__(2721),
	  /* scopeId */
	  "data-v-e6538eb2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1435)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(830),
	  /* template */
	  __webpack_require__(2282),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(884),
	  /* template */
	  __webpack_require__(2680),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1882)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(944),
	  /* template */
	  __webpack_require__(2739),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1770)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(667),
	  /* template */
	  __webpack_require__(2625),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1802)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(817),
	  /* template */
	  __webpack_require__(2657),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1702)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1160),
	  /* template */
	  __webpack_require__(2556),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1472)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1176),
	  /* template */
	  __webpack_require__(2320),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1493)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(641),
	  /* template */
	  __webpack_require__(2341),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1869)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(868),
	  /* template */
	  __webpack_require__(2726),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1586)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(940),
	  /* template */
	  __webpack_require__(2436),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1404)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1169),
	  /* template */
	  __webpack_require__(2251),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1821)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(819),
	  /* template */
	  __webpack_require__(2677),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1476)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(820),
	  /* template */
	  __webpack_require__(2324),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1791)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(902),
	  /* template */
	  __webpack_require__(2646),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1825)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(942),
	  /* template */
	  __webpack_require__(2682),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1855)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1000),
	  /* template */
	  __webpack_require__(2712),
	  /* scopeId */
	  "data-v-ddc3582a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1779)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1035),
	  /* template */
	  __webpack_require__(2634),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1596)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1119),
	  /* template */
	  __webpack_require__(2447),
	  /* scopeId */
	  "data-v-47e9ecac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1575)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1145),
	  /* template */
	  __webpack_require__(2425),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(129);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extractError(response) {
	    return "Error: " + response.status + " (" + response.url + "): " + (0, _stringify2.default)(response.data);
	}
	
	var baseUrl = "";
	if (true) {
	    baseUrl = 'https://kepler.playcar.net/api/backoffice/v1/';
	} else {
	    baseUrl = 'https://core.staging.playmoove.com:8585/api/backoffice/v1/';
	}
	
	var KeplerSdk = {
	    user: {
	        profile: null
	    },
	    login: function login(username, password, successCallback, errorCallback) {
	        _vue2.default.http.post(baseUrl + 'login', {
	            username: username,
	            password: password
	        }).then(function (response) {
	            localStorage.setItem('token', response.data.token);
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    lastReservation: function lastReservation(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'driver/last_reservation', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(extractError(response));
	        });
	    },
	    extendReservation: function extendReservation(body, successCallback, errorCallback) {
	        _vue2.default.http.patch(baseUrl + 'reservation/extend', body, { headers: this.getAuthHeader() }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(extractError(response));
	        });
	    },
	    reservationList: function reservationList(successCallback, errorCallback) {
	        return _vue2.default.http.get(baseUrl + 'reservation/list', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(extractError(response));
	        });
	    },
	    paymentMethodsList: function paymentMethodsList(successCallback, errorCallback) {
	        return _vue2.default.http.get(baseUrl + 'payment_methods', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(extractError(response));
	        });
	    },
	    createPaymentMethod: function createPaymentMethod(body, successCallback, errorCallback) {
	        _vue2.default.http.post(baseUrl + 'payment_methods/add_by_info', body, {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    subscriptionList: function subscriptionList(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'subscriptions/available_subscriptions', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(extractError(response));
	        });
	    },
	    purchaseSubscription: function purchaseSubscription(subscriptionId, successCallback, errorCallback) {
	        _vue2.default.http.post(baseUrl + 'subscription/subscribe', {
	            plan_id: subscriptionId
	        }, { headers: this.getAuthHeader() }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    getAuthHeader: function getAuthHeader() {
	        return {
	            'Authorization': 'Bearer ' + localStorage.getItem('token')
	        };
	    },
	    isUserAuthenticated: function isUserAuthenticated() {
	        return localStorage.getItem('token') != null;
	    },
	    register: function register(body, successCallback, errorCallback) {
	        _vue2.default.http.post(baseUrl + 'client/register', body).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    getClientTypes: function getClientTypes(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'client/types').then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    getDriverLicense: function getDriverLicense(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'license/types').then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    fleetSearch: function fleetSearch(start, end, booking_mode, vehicle_category_id, successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'fleet/advanced_search?' + 'start=' + start + '&end=' + end + '&booking_mode=' + booking_mode + '&vehicle_category_id=' + vehicle_category_id, {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    vehicleCatetoriesSearch: function vehicleCatetoriesSearch(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'fleet/categories', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    bookReservation: function bookReservation(body, successCallback, errorCallback) {
	        _vue2.default.http.post(baseUrl + 'reservation/book', body, {
	
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    currentReservation: function currentReservation(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'reservation/current', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    openCar: function openCar() {
	        _vue2.default.http.post(baseUrl + 'reservation/open', null, {
	            headers: this.getAuthHeader()
	        });
	    },
	    closeCar: function closeCar() {
	        _vue2.default.http.post(baseUrl + 'reservation/close', null, {
	            headers: this.getAuthHeader()
	        });
	    },
	    endReservation: function endReservation(successCallback, errorCallback) {
	
	        _vue2.default.http.post(baseUrl + 'reservation/end', null, {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    getWallets: function getWallets(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'wallet', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    addPaymentMethodToWallet: function addPaymentMethodToWallet(body, successCallback, errorCallback) {
	        _vue2.default.http.post(baseUrl + 'wallet/add_payment_method', body, {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    getSubscriptions: function getSubscriptions(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'client/subscriptions', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    myDriversList: function myDriversList(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'drivers', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    addDriversToSubscription: function addDriversToSubscription(body, successCallback, errorCallback) {
	        _vue2.default.http.post(baseUrl + 'subscription/add_driver', body, {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    clientSubscriptions: function clientSubscriptions(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'client/subscriptions', {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    reservationDetail: function reservationDetail(reservationId, successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'reservation/' + reservationId, {
	            headers: this.getAuthHeader()
	        }).then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    driver: function driver(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'driver').then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    drivers: function drivers(successCallback, errorCallback) {
	        _vue2.default.http.get(baseUrl + 'drivers').then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    },
	    serviceToc: function serviceToc(successCallback, errorCallback) {
	        return _vue2.default.http.get(baseUrl + 'config/service_toc').then(function (response) {
	            successCallback(response.data);
	        }, function (response) {
	            errorCallback(response.data);
	        });
	    }
	};
	
	exports.default = KeplerSdk;

/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1521)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(722),
	  /* template */
	  __webpack_require__(2369),
	  /* scopeId */
	  "data-v-3029ce1f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1789)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(845),
	  /* template */
	  __webpack_require__(2644),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1830)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(875),
	  /* template */
	  __webpack_require__(2687),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1683)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(931),
	  /* template */
	  __webpack_require__(2535),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1814)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1003),
	  /* template */
	  __webpack_require__(2670),
	  /* scopeId */
	  "data-v-c0fd8df6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1530)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1033),
	  /* template */
	  __webpack_require__(2378),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1613)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1162),
	  /* template */
	  __webpack_require__(2464),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1819)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(809),
	  /* template */
	  __webpack_require__(2675),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1818)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(810),
	  /* template */
	  __webpack_require__(2674),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1834)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(838),
	  /* template */
	  __webpack_require__(2691),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1361)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(848),
	  /* template */
	  __webpack_require__(2207),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1449)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(865),
	  /* template */
	  __webpack_require__(2296),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1685)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1005),
	  /* template */
	  __webpack_require__(2538),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1559)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(716),
	  /* template */
	  __webpack_require__(2408),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1617)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(839),
	  /* template */
	  __webpack_require__(2468),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1649)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(840),
	  /* template */
	  __webpack_require__(2500),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1782)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(854),
	  /* template */
	  __webpack_require__(2637),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1437)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1001),
	  /* template */
	  __webpack_require__(2284),
	  /* scopeId */
	  "data-v-1919a510",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1874)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1002),
	  /* template */
	  __webpack_require__(2731),
	  /* scopeId */
	  "data-v-f744f85c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1641)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1009),
	  /* template */
	  __webpack_require__(2492),
	  /* scopeId */
	  "data-v-55b8fa8a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1542)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1017),
	  /* template */
	  __webpack_require__(2390),
	  /* scopeId */
	  "data-v-35280716",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1529)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1101),
	  /* template */
	  __webpack_require__(2377),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1799)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(638),
	  /* template */
	  __webpack_require__(2654),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1414)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(855),
	  /* template */
	  __webpack_require__(2261),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1501)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(926),
	  /* template */
	  __webpack_require__(2349),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1515)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(932),
	  /* template */
	  __webpack_require__(2363),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1029),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1775)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(671),
	  /* template */
	  __webpack_require__(2630),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1418)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(672),
	  /* template */
	  __webpack_require__(2265),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1752)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(705),
	  /* template */
	  __webpack_require__(2607),
	  /* scopeId */
	  "data-v-7e69f018",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1703)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(797),
	  /* template */
	  __webpack_require__(2557),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1817)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(811),
	  /* template */
	  __webpack_require__(2673),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(836),
	  /* template */
	  __webpack_require__(2540),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1506)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(846),
	  /* template */
	  __webpack_require__(2354),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1599)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(847),
	  /* template */
	  __webpack_require__(2450),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1566)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(867),
	  /* template */
	  __webpack_require__(2415),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1581)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(988),
	  /* template */
	  __webpack_require__(2431),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1738)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(991),
	  /* template */
	  __webpack_require__(2592),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1456)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(992),
	  /* template */
	  __webpack_require__(2303),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1577)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1061),
	  /* template */
	  __webpack_require__(2427),
	  /* scopeId */
	  "data-v-4062fea0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1734)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1091),
	  /* template */
	  __webpack_require__(2588),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1688)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1140),
	  /* template */
	  __webpack_require__(2542),
	  /* scopeId */
	  "data-v-66902681",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  company: null,
	  branding: null,
	  locale: null,
	  constraints: null,
	  commercial: null,
	  fleet: null,
	  communication: null,
	  system: null,
	  application: null,
	  userConfiguration: null,
	  configReady: false,
	  vats: [],
	  commonCostTypes: []
	};
	
	var mutations = {
	  SET_CONFIG: function SET_CONFIG(state, payload) {
	    (0, _assign2.default)(state, payload);
	  },
	  SET_USER_CONFIG: function SET_USER_CONFIG(state, payload) {
	    state.userConfiguration = payload;
	    var permissions = {};
	    payload.permissions.forEach(function (item) {
	      var path = '';
	      switch (item) {
	        case 'index-clients':
	          path = 'clients';
	          break;
	        case 'index-drivers':
	          path = 'drivers';
	          break;
	        case 'index-reservations':
	          path = 'reservations';
	          break;
	        case 'index-plan':
	          path = 'plans';
	          break;
	        case 'index-reporting':
	          path = 'reportings';
	          break;
	      }
	
	      permissions[path] = item;
	    });
	
	    state.userConfiguration.permissions = permissions;
	  },
	  SET_CONFIG_READY: function SET_CONFIG_READY(state, payload) {
	    state.configReady = payload;
	  },
	  SET_VATS: function SET_VATS(state, payload) {
	    state.vats = payload;
	  },
	  SET_COMMON_COST_TYPES: function SET_COMMON_COST_TYPES(state, payload) {
	    state.commonCostTypes = payload;
	  }
	};
	
	var actions = {
	  init: function init() {
	    this.dispatch('getConfiguration');
	    this.dispatch('loadVat');
	    this.dispatch('loadCommonCostTypes');
	  },
	  configInit: function configInit() {
	    var _this = this;
	
	    return this.dispatch('getUserConfiguration').then(function () {
	      return _this.dispatch('getConfiguration');
	    });
	  },
	
	  getConfiguration: function getConfiguration(_ref) {
	    var commit = _ref.commit;
	
	
	    return _backoffice2.default.configuration.getPromise().then(function (payload) {
	      commit('SET_CONFIG', payload.data);
	      commit('SET_CONFIG_READY', true);
	      return payload.data;
	    });
	  },
	  getUserConfiguration: function getUserConfiguration(_ref2) {
	    var commit = _ref2.commit;
	
	    return _backoffice2.default.userConfig.list().then(function (payload) {
	      commit('SET_USER_CONFIG', payload.data);
	      return payload.data;
	    });
	  },
	  loadVat: function loadVat(_ref3) {
	    var commit = _ref3.commit;
	
	    return _backoffice2.default.vats.list(1, -1).all(function (data) {
	      commit('SET_VATS', data.items);
	    });
	  },
	  loadCommonCostTypes: function loadCommonCostTypes(_ref4) {
	    var commit = _ref4.commit;
	
	    _backoffice2.default.commonCostType.list.all(1, 25, function (data) {
	      commit('SET_COMMON_COST_TYPES', data.items);
	    });
	  }
	};
	
	exports.default = {
	  state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1374)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(673),
	  /* template */
	  __webpack_require__(2221),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1463)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(688),
	  /* template */
	  __webpack_require__(2310),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1496)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(697),
	  /* template */
	  __webpack_require__(2344),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1396)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(708),
	  /* template */
	  __webpack_require__(2243),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1653)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(710),
	  /* template */
	  __webpack_require__(2504),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1815)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(813),
	  /* template */
	  __webpack_require__(2671),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1812)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(815),
	  /* template */
	  __webpack_require__(2668),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(833),
	  /* template */
	  __webpack_require__(2446),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1615)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(871),
	  /* template */
	  __webpack_require__(2466),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1614)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(872),
	  /* template */
	  __webpack_require__(2465),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1808)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(886),
	  /* template */
	  __webpack_require__(2664),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1587)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(907),
	  /* template */
	  __webpack_require__(2437),
	  /* scopeId */
	  "data-v-42c618dc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1453)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(917),
	  /* template */
	  __webpack_require__(2300),
	  /* scopeId */
	  "data-v-1cd2ae46",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1838)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(933),
	  /* template */
	  __webpack_require__(2695),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1568)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(990),
	  /* template */
	  __webpack_require__(2417),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1520)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1004),
	  /* template */
	  __webpack_require__(2368),
	  /* scopeId */
	  "data-v-2fea7d39",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1794)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1016),
	  /* template */
	  __webpack_require__(2649),
	  /* scopeId */
	  "data-v-ae25c6b4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1660)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1026),
	  /* template */
	  __webpack_require__(2512),
	  /* scopeId */
	  "data-v-5bffa56d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1674)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1030),
	  /* template */
	  __webpack_require__(2526),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1737)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1067),
	  /* template */
	  __webpack_require__(2591),
	  /* scopeId */
	  "data-v-75e6120c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1543)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1068),
	  /* template */
	  __webpack_require__(2391),
	  /* scopeId */
	  "data-v-358831db",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1783)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1069),
	  /* template */
	  __webpack_require__(2638),
	  /* scopeId */
	  "data-v-a89f7d7c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1488)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1108),
	  /* template */
	  __webpack_require__(2336),
	  /* scopeId */
	  "data-v-2607c007",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1745)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1147),
	  /* template */
	  __webpack_require__(2600),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1762)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1163),
	  /* template */
	  __webpack_require__(2617),
	  /* scopeId */
	  "data-v-879afe70",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1699)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1168),
	  /* template */
	  __webpack_require__(2553),
	  /* scopeId */
	  "data-v-6a98bafe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(129);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(10);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vehiclesStore = __webpack_require__(1185);
	
	var _vehiclesStore2 = _interopRequireDefault(_vehiclesStore);
	
	var _clientTypesStore = __webpack_require__(1186);
	
	var _clientTypesStore2 = _interopRequireDefault(_clientTypesStore);
	
	var _licenseTypesStore = __webpack_require__(1188);
	
	var _licenseTypesStore2 = _interopRequireDefault(_licenseTypesStore);
	
	var _driversStore = __webpack_require__(1187);
	
	var _driversStore2 = _interopRequireDefault(_driversStore);
	
	var _paymentMethodsStore = __webpack_require__(1189);
	
	var _paymentMethodsStore2 = _interopRequireDefault(_paymentMethodsStore);
	
	var _walletsStore = __webpack_require__(1192);
	
	var _walletsStore2 = _interopRequireDefault(_walletsStore);
	
	var _subscriptionsStore = __webpack_require__(1191);
	
	var _subscriptionsStore2 = _interopRequireDefault(_subscriptionsStore);
	
	var _reservationsStore = __webpack_require__(1190);
	
	var _reservationsStore2 = _interopRequireDefault(_reservationsStore);
	
	var _userStore = __webpack_require__(1194);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _notificationsStore = __webpack_require__(1193);
	
	var _notificationsStore2 = _interopRequireDefault(_notificationsStore);
	
	var _plansStore = __webpack_require__(1184);
	
	var _plansStore2 = _interopRequireDefault(_plansStore);
	
	var _configuration = __webpack_require__(130);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	exports.default = new _vuex2.default.Store({
	  actions: {},
	
	  modules: {
	    vehicleStore: _vehiclesStore2.default,
	    clientTypesStore: _clientTypesStore2.default,
	    licenseTypesStore: _licenseTypesStore2.default,
	    driversStore: _driversStore2.default,
	    paymentMethodsStore: _paymentMethodsStore2.default,
	    walletsStore: _walletsStore2.default,
	    subscriptionsStore: _subscriptionsStore2.default,
	    reservationsStore: _reservationsStore2.default,
	    notificationsStore: _notificationsStore2.default,
	    userStore: _userStore2.default,
	    plansStore: _plansStore2.default,
	    configuration: _configuration2.default
	  },
	  strict: debug
	});

/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1866)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(631),
	  /* template */
	  __webpack_require__(2723),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1580)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(639),
	  /* template */
	  __webpack_require__(2430),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1412)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(649),
	  /* template */
	  __webpack_require__(2259),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1642)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(655),
	  /* template */
	  __webpack_require__(2493),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1607)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(684),
	  /* template */
	  __webpack_require__(2458),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1731)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(694),
	  /* template */
	  __webpack_require__(2585),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1439)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(712),
	  /* template */
	  __webpack_require__(2286),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1844)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(729),
	  /* template */
	  __webpack_require__(2701),
	  /* scopeId */
	  "data-v-d84e386a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1666)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(747),
	  /* template */
	  __webpack_require__(2518),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1485)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(749),
	  /* template */
	  __webpack_require__(2333),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1823)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(750),
	  /* template */
	  __webpack_require__(2679),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1523)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(799),
	  /* template */
	  __webpack_require__(2371),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(801),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1813)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(814),
	  /* template */
	  __webpack_require__(2669),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1532)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(821),
	  /* template */
	  __webpack_require__(2380),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1609)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(827),
	  /* template */
	  __webpack_require__(2460),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1589)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(832),
	  /* template */
	  __webpack_require__(2439),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(837),
	  /* template */
	  __webpack_require__(2509),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1358)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(851),
	  /* template */
	  __webpack_require__(2204),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1415)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(858),
	  /* template */
	  __webpack_require__(2262),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1850)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(862),
	  /* template */
	  __webpack_require__(2707),
	  /* scopeId */
	  "data-v-db74637a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1710)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(876),
	  /* template */
	  __webpack_require__(2564),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1426)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(877),
	  /* template */
	  __webpack_require__(2273),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1820)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(878),
	  /* template */
	  __webpack_require__(2676),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1793)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(881),
	  /* template */
	  __webpack_require__(2648),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1570)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(889),
	  /* template */
	  __webpack_require__(2419),
	  /* scopeId */
	  "data-v-3e7934cf",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1764)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(896),
	  /* template */
	  __webpack_require__(2619),
	  /* scopeId */
	  "data-v-89e8341e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1692)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(911),
	  /* template */
	  __webpack_require__(2546),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1492)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(921),
	  /* template */
	  __webpack_require__(2340),
	  /* scopeId */
	  "data-v-27d00843",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1605)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(934),
	  /* template */
	  __webpack_require__(2456),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1748)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(950),
	  /* template */
	  __webpack_require__(2603),
	  /* scopeId */
	  "data-v-7b541089",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1601)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(953),
	  /* template */
	  __webpack_require__(2452),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1409)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(954),
	  /* template */
	  __webpack_require__(2256),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1669)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(958),
	  /* template */
	  __webpack_require__(2521),
	  /* scopeId */
	  "data-v-60ac8da7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1528)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(979),
	  /* template */
	  __webpack_require__(2376),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1406)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(982),
	  /* template */
	  __webpack_require__(2253),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1848)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(989),
	  /* template */
	  __webpack_require__(2705),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1545)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1015),
	  /* template */
	  __webpack_require__(2393),
	  /* scopeId */
	  "data-v-36cb64d8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1558)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1024),
	  /* template */
	  __webpack_require__(2407),
	  /* scopeId */
	  "data-v-3aa7c5bd",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1730)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1027),
	  /* template */
	  __webpack_require__(2584),
	  /* scopeId */
	  "data-v-74734ca9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1490)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1031),
	  /* template */
	  __webpack_require__(2338),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1761)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1034),
	  /* template */
	  __webpack_require__(2616),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1454)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1065),
	  /* template */
	  __webpack_require__(2301),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1763)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1156),
	  /* template */
	  __webpack_require__(2618),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1417)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1167),
	  /* template */
	  __webpack_require__(2264),
	  /* scopeId */
	  "data-v-116c64f1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1479)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1174),
	  /* template */
	  __webpack_require__(2327),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CountryList = {
	    countries: [{ "name": "Italy", "code": "IT" }, { "name": "Afghanistan", "code": "AF" }, { "name": "Åland Islands", "code": "AX" }, { "name": "Albania", "code": "AL" }, { "name": "Algeria", "code": "DZ" }, { "name": "American Samoa", "code": "AS" }, { "name": "Andorra", "code": "AD" }, { "name": "Angola", "code": "AO" }, { "name": "Anguilla", "code": "AI" }, { "name": "Antarctica", "code": "AQ" }, { "name": "Antigua and Barbuda", "code": "AG" }, { "name": "Argentina", "code": "AR" }, { "name": "Armenia", "code": "AM" }, { "name": "Aruba", "code": "AW" }, { "name": "Australia", "code": "AU" }, { "name": "Austria", "code": "AT" }, { "name": "Azerbaijan", "code": "AZ" }, { "name": "Bahamas", "code": "BS" }, { "name": "Bahrain", "code": "BH" }, { "name": "Bangladesh", "code": "BD" }, { "name": "Barbados", "code": "BB" }, { "name": "Belarus", "code": "BY" }, { "name": "Belgium", "code": "BE" }, { "name": "Belize", "code": "BZ" }, { "name": "Benin", "code": "BJ" }, { "name": "Bermuda", "code": "BM" }, { "name": "Bhutan", "code": "BT" }, { "name": "Bolivia", "code": "BO" }, { "name": "Bosnia and Herzegovina", "code": "BA" }, { "name": "Botswana", "code": "BW" }, { "name": "Bouvet Island", "code": "BV" }, { "name": "Brazil", "code": "BR" }, { "name": "British Indian Ocean Territory", "code": "IO" }, { "name": "Brunei Darussalam", "code": "BN" }, { "name": "Bulgaria", "code": "BG" }, { "name": "Burkina Faso", "code": "BF" }, { "name": "Burundi", "code": "BI" }, { "name": "Cambodia", "code": "KH" }, { "name": "Cameroon", "code": "CM" }, { "name": "Canada", "code": "CA" }, { "name": "Cape Verde", "code": "CV" }, { "name": "Cayman Islands", "code": "KY" }, { "name": "Central African Republic", "code": "CF" }, { "name": "Chad", "code": "TD" }, { "name": "Chile", "code": "CL" }, { "name": "China", "code": "CN" }, { "name": "Christmas Island", "code": "CX" }, { "name": "Cocos (Keeling) Islands", "code": "CC" }, { "name": "Colombia", "code": "CO" }, { "name": "Comoros", "code": "KM" }, { "name": "Congo", "code": "CG" }, { "name": "Congo, The Democratic Republic of the", "code": "CD" }, { "name": "Cook Islands", "code": "CK" }, { "name": "Costa Rica", "code": "CR" }, { "name": "Cote D'Ivoire", "code": "CI" }, { "name": "Croatia", "code": "HR" }, { "name": "Cuba", "code": "CU" }, { "name": "Cyprus", "code": "CY" }, { "name": "Czech Republic", "code": "CZ" }, { "name": "Denmark", "code": "DK" }, { "name": "Djibouti", "code": "DJ" }, { "name": "Dominica", "code": "DM" }, { "name": "Dominican Republic", "code": "DO" }, { "name": "Ecuador", "code": "EC" }, { "name": "Egypt", "code": "EG" }, { "name": "El Salvador", "code": "SV" }, { "name": "Equatorial Guinea", "code": "GQ" }, { "name": "Eritrea", "code": "ER" }, { "name": "Estonia", "code": "EE" }, { "name": "Ethiopia", "code": "ET" }, { "name": "Falkland Islands (Malvinas)", "code": "FK" }, { "name": "Faroe Islands", "code": "FO" }, { "name": "Fiji", "code": "FJ" }, { "name": "Finland", "code": "FI" }, { "name": "France", "code": "FR" }, { "name": "French Guiana", "code": "GF" }, { "name": "French Polynesia", "code": "PF" }, { "name": "French Southern Territories", "code": "TF" }, { "name": "Gabon", "code": "GA" }, { "name": "Gambia", "code": "GM" }, { "name": "Georgia", "code": "GE" }, { "name": "Germany", "code": "DE" }, { "name": "Ghana", "code": "GH" }, { "name": "Gibraltar", "code": "GI" }, { "name": "Greece", "code": "GR" }, { "name": "Greenland", "code": "GL" }, { "name": "Grenada", "code": "GD" }, { "name": "Guadeloupe", "code": "GP" }, { "name": "Guam", "code": "GU" }, { "name": "Guatemala", "code": "GT" }, { "name": "Guernsey", "code": "GG" }, { "name": "Guinea", "code": "GN" }, { "name": "Guinea-Bissau", "code": "GW" }, { "name": "Guyana", "code": "GY" }, { "name": "Haiti", "code": "HT" }, { "name": "Heard Island and Mcdonald Islands", "code": "HM" }, { "name": "Holy See (Vatican City State)", "code": "VA" }, { "name": "Honduras", "code": "HN" }, { "name": "Hong Kong", "code": "HK" }, { "name": "Hungary", "code": "HU" }, { "name": "Iceland", "code": "IS" }, { "name": "India", "code": "IN" }, { "name": "Indonesia", "code": "ID" }, { "name": "Iran, Islamic Republic Of", "code": "IR" }, { "name": "Iraq", "code": "IQ" }, { "name": "Ireland", "code": "IE" }, { "name": "Isle of Man", "code": "IM" }, { "name": "Israel", "code": "IL" }, { "name": "Jamaica", "code": "JM" }, { "name": "Japan", "code": "JP" }, { "name": "Jersey", "code": "JE" }, { "name": "Jordan", "code": "JO" }, { "name": "Kazakhstan", "code": "KZ" }, { "name": "Kenya", "code": "KE" }, { "name": "Kiribati", "code": "KI" }, { "name": "Democratic People's Republic of Korea", "code": "KP" }, { "name": "Korea, Republic of", "code": "KR" }, { "name": "Kosovo", "code": "XK" }, { "name": "Kuwait", "code": "KW" }, { "name": "Kyrgyzstan", "code": "KG" }, { "name": "Lao People's Democratic Republic", "code": "LA" }, { "name": "Latvia", "code": "LV" }, { "name": "Lebanon", "code": "LB" }, { "name": "Lesotho", "code": "LS" }, { "name": "Liberia", "code": "LR" }, { "name": "Libyan Arab Jamahiriya", "code": "LY" }, { "name": "Liechtenstein", "code": "LI" }, { "name": "Lithuania", "code": "LT" }, { "name": "Luxembourg", "code": "LU" }, { "name": "Macao", "code": "MO" }, { "name": "Macedonia, The Former Yugoslav Republic of", "code": "MK" }, { "name": "Madagascar", "code": "MG" }, { "name": "Malawi", "code": "MW" }, { "name": "Malaysia", "code": "MY" }, { "name": "Maldives", "code": "MV" }, { "name": "Mali", "code": "ML" }, { "name": "Malta", "code": "MT" }, { "name": "Marshall Islands", "code": "MH" }, { "name": "Martinique", "code": "MQ" }, { "name": "Mauritania", "code": "MR" }, { "name": "Mauritius", "code": "MU" }, { "name": "Mayotte", "code": "YT" }, { "name": "Mexico", "code": "MX" }, { "name": "Micronesia, Federated States of", "code": "FM" }, { "name": "Moldova, Republic of", "code": "MD" }, { "name": "Monaco", "code": "MC" }, { "name": "Mongolia", "code": "MN" }, { "name": "Montenegro", "code": "ME" }, { "name": "Montserrat", "code": "MS" }, { "name": "Morocco", "code": "MA" }, { "name": "Mozambique", "code": "MZ" }, { "name": "Myanmar", "code": "MM" }, { "name": "Namibia", "code": "NA" }, { "name": "Nauru", "code": "NR" }, { "name": "Nepal", "code": "NP" }, { "name": "Netherlands", "code": "NL" }, { "name": "Netherlands Antilles", "code": "AN" }, { "name": "New Caledonia", "code": "NC" }, { "name": "New Zealand", "code": "NZ" }, { "name": "Nicaragua", "code": "NI" }, { "name": "Niger", "code": "NE" }, { "name": "Nigeria", "code": "NG" }, { "name": "Niue", "code": "NU" }, { "name": "Norfolk Island", "code": "NF" }, { "name": "Northern Mariana Islands", "code": "MP" }, { "name": "Norway", "code": "NO" }, { "name": "Oman", "code": "OM" }, { "name": "Pakistan", "code": "PK" }, { "name": "Palau", "code": "PW" }, { "name": "Palestinian Territory, Occupied", "code": "PS" }, { "name": "Panama", "code": "PA" }, { "name": "Papua New Guinea", "code": "PG" }, { "name": "Paraguay", "code": "PY" }, { "name": "Peru", "code": "PE" }, { "name": "Philippines", "code": "PH" }, { "name": "Pitcairn", "code": "PN" }, { "name": "Poland", "code": "PL" }, { "name": "Portugal", "code": "PT" }, { "name": "Puerto Rico", "code": "PR" }, { "name": "Qatar", "code": "QA" }, { "name": "Reunion", "code": "RE" }, { "name": "Romania", "code": "RO" }, { "name": "Russian Federation", "code": "RU" }, { "name": "Rwanda", "code": "RW" }, { "name": "Saint Helena", "code": "SH" }, { "name": "Saint Kitts and Nevis", "code": "KN" }, { "name": "Saint Lucia", "code": "LC" }, { "name": "Saint Pierre and Miquelon", "code": "PM" }, { "name": "Saint Vincent and the Grenadines", "code": "VC" }, { "name": "Samoa", "code": "WS" }, { "name": "San Marino", "code": "SM" }, { "name": "Sao Tome and Principe", "code": "ST" }, { "name": "Saudi Arabia", "code": "SA" }, { "name": "Senegal", "code": "SN" }, { "name": "Serbia", "code": "RS" }, { "name": "Seychelles", "code": "SC" }, { "name": "Sierra Leone", "code": "SL" }, { "name": "Singapore", "code": "SG" }, { "name": "Slovakia", "code": "SK" }, { "name": "Slovenia", "code": "SI" }, { "name": "Solomon Islands", "code": "SB" }, { "name": "Somalia", "code": "SO" }, { "name": "South Africa", "code": "ZA" }, { "name": "South Georgia and the South Sandwich Islands", "code": "GS" }, { "name": "Spain", "code": "ES" }, { "name": "Sri Lanka", "code": "LK" }, { "name": "Sudan", "code": "SD" }, { "name": "Suriname", "code": "SR" }, { "name": "Svalbard and Jan Mayen", "code": "SJ" }, { "name": "Swaziland", "code": "SZ" }, { "name": "Sweden", "code": "SE" }, { "name": "Switzerland", "code": "CH" }, { "name": "Syrian Arab Republic", "code": "SY" }, { "name": "Taiwan", "code": "TW" }, { "name": "Tajikistan", "code": "TJ" }, { "name": "Tanzania, United Republic of", "code": "TZ" }, { "name": "Thailand", "code": "TH" }, { "name": "Timor-Leste", "code": "TL" }, { "name": "Togo", "code": "TG" }, { "name": "Tokelau", "code": "TK" }, { "name": "Tonga", "code": "TO" }, { "name": "Trinidad and Tobago", "code": "TT" }, { "name": "Tunisia", "code": "TN" }, { "name": "Turkey", "code": "TR" }, { "name": "Turkmenistan", "code": "TM" }, { "name": "Turks and Caicos Islands", "code": "TC" }, { "name": "Tuvalu", "code": "TV" }, { "name": "Uganda", "code": "UG" }, { "name": "Ukraine", "code": "UA" }, { "name": "United Arab Emirates", "code": "AE" }, { "name": "United Kingdom", "code": "GB" }, { "name": "United States", "code": "US" }, { "name": "United States Minor Outlying Islands", "code": "UM" }, { "name": "Uruguay", "code": "UY" }, { "name": "Uzbekistan", "code": "UZ" }, { "name": "Vanuatu", "code": "VU" }, { "name": "Venezuela", "code": "VE" }, { "name": "Viet Nam", "code": "VN" }, { "name": "Virgin Islands, British", "code": "VG" }, { "name": "Virgin Islands, U.S.", "code": "VI" }, { "name": "Wallis and Futuna", "code": "WF" }, { "name": "Western Sahara", "code": "EH" }, { "name": "Yemen", "code": "YE" }, { "name": "Zambia", "code": "ZM" }, { "name": "Zimbabwe", "code": "ZW" }]
	};
	
	exports.default = CountryList;

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    transactionUrl: function transactionUrl(provider, transactionId) {
	        if (provider === 'braintree') {
	            return "https://www.braintreegateway.com/merchants/m6f3n3v683gc947s/transactions/" + transactionId;
	        }
	    },
	    clientUrl: function clientUrl(provider, clientId) {
	        if (provider === 'braintree') {
	            return "https://www.braintreegateway.com/merchants/m6f3n3v683gc947s/customers/" + clientId;
	        }
	    },
	    paymentMethod: function paymentMethod(provider, paymentMethodId) {
	        if (provider === 'braintree') {
	            return "https://www.braintreegateway.com/merchants/m6f3n3v683gc947s/payment_methods/any/" + paymentMethodId;
	        }
	    }
	};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var routes = [{
	  path: 'overview',
	  meta: {
	    breadcrumb: 'Overview',
	    path: 'home'
	  },
	  component: __webpack_require__(12),
	  children: [{
	    path: '',
	    name: 'home',
	    meta: { breadcrumb: 'Dashboard' },
	    component: __webpack_require__(2150)
	  }, {
	    path: 'visual',
	    name: 'visual',
	    meta: { breadcrumb: 'Visual' },
	    component: __webpack_require__(2190)
	  }, {
	    path: 'fleet-map',
	    name: 'fleet-map',
	    meta: { breadcrumb: 'Fleet Map' },
	    component: __webpack_require__(2147)
	  }, {
	    path: 'sentinel',
	    name: 'sentinel',
	    meta: { breadcrumb: 'Sentinel' },
	    component: __webpack_require__(2179)
	  }, {
	    path: 'export',
	    name: 'export',
	    meta: { breadcrumb: 'Export' },
	    component: __webpack_require__(2141)
	  }, {
	    path: 'cargo',
	    name: 'cargo',
	    meta: { breadcrumb: 'Cargo' },
	    redirect: { name: 'cargos' },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'cargos',
	      component: __webpack_require__(2109)
	    }, {
	      path: ':id',
	      name: 'cargo-operation',
	      component: __webpack_require__(2193),
	      meta: {
	        breadcrumb: '#CO',
	        hideInMenu: true
	      }
	    }]
	  }, {
	    path: 'alarms',
	    name: 'alarms',
	    meta: { breadcrumb: 'Alarms' },
	    component: __webpack_require__(2106)
	  }]
	}, {
	  path: 'todo',
	  meta: { breadcrumb: 'Todo\'s' },
	  component: __webpack_require__(12),
	  name: 'todo-root',
	  redirect: { name: 'client-approval' },
	  children: [{
	    path: 'client-approval',
	    name: 'client-approval',
	    meta: { breadcrumb: 'Client Approval' },
	    component: __webpack_require__(2112)
	  }, {
	    path: 'driver-approval',
	    name: 'driver-approval',
	    meta: { breadcrumb: 'Driver Approval' },
	    component: __webpack_require__(2134)
	  }, {
	    path: 'document-approval',
	    name: 'document-approval',
	    meta: { breadcrumb: 'Documents Approval' },
	    component: __webpack_require__(2135)
	  }, {
	    path: 'reservation-approval',
	    name: 'reservation-approval',
	    meta: { breadcrumb: 'Reservation Approval' },
	    component: __webpack_require__(2174)
	  }, {
	    path: 'pending-delete',
	    name: 'pending-delete',
	    meta: { breadcrumb: 'Delete requests' },
	    component: __webpack_require__(2137)
	  }]
	}, {
	  path: 'customers',
	  name: 'customers-root',
	  redirect: { name: 'clients' },
	  meta: {
	    breadcrumb: 'Customers'
	  },
	  component: __webpack_require__(12),
	  children: [{
	    path: 'clients',
	    meta: {
	      path: 'clients',
	      breadcrumb: 'Clients'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'clients',
	      component: __webpack_require__(2113),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'Client list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-client',
	      meta: {
	        breadcrumb: 'Add client',
	        hideInMenu: true
	      },
	      component: __webpack_require__(2123)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#CL',
	        source: 'clients',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(48),
	        action: {
	          component: __webpack_require__(43)
	        }
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'client',
	        component: __webpack_require__(1972),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'profile',
	          breadcrumb: 'Profile',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'reservations',
	        name: 'client-reservations',
	        component: __webpack_require__(1973),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'reservations',
	          breadcrumb: 'Reservations',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'subscriptions',
	        name: 'client-subscriptions',
	        component: __webpack_require__(1974),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'subscriptions',
	          breadcrumb: 'Subscriptions',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'drivers',
	        name: 'client-drivers',
	        component: __webpack_require__(1970),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'drivers',
	          breadcrumb: 'Drivers',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'invoices',
	        name: 'client-invoices',
	        component: __webpack_require__(548),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'invoices',
	          breadcrumb: 'Invoices',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'credit-note/:wallet_id',
	        name: 'credit-note',
	        component: __webpack_require__(1969),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(2194),
	          name: 'credit-note',
	          breadcrumb: 'Credit Note'
	
	        }
	      }, {
	        path: 'transactions',
	        name: 'client-transactions',
	        component: __webpack_require__(1976),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'transactions',
	          breadcrumb: 'Transactions',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'deposits',
	        name: 'client-deposits',
	        component: __webpack_require__(547),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'deposits',
	          breadcrumb: 'Reservations',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'payment-methods',
	        name: 'client-payment-methods',
	        component: __webpack_require__(549),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'payment-methods',
	          breadcrumb: 'Payment methods',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'wallets',
	        name: 'client-wallets',
	        component: __webpack_require__(1977),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'wallets',
	          breadcrumb: 'Wallets',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'client-cards',
	        component: __webpack_require__(1968),
	        name: 'client-cards',
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'client-cards',
	          breadcrumb: 'Cards',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }, {
	        path: 'client-logs',
	        name: 'client-logs',
	        component: __webpack_require__(1971),
	        meta: {
	          source: 'clients',
	          entityComponent: __webpack_require__(48),
	          name: 'client-logs',
	          breadcrumb: 'Logs',
	          action: {
	            component: __webpack_require__(43)
	          }
	        }
	      }]
	
	    }]
	  }, {
	    path: 'drivers',
	    meta: {
	      path: 'drivers',
	      breadcrumb: 'Drivers'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '/',
	      name: 'drivers',
	      component: __webpack_require__(2136),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'Driver list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-driver',
	      meta: {
	        breadcrumb: 'Add driver',
	        hideInMenu: true
	      },
	      component: __webpack_require__(2125)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#DR',
	        source: 'drivers',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(73),
	        action: {
	          component: __webpack_require__(59)
	        }
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'driver',
	        component: __webpack_require__(1983),
	        meta: {
	          source: 'drivers',
	          entityComponent: __webpack_require__(73),
	          name: 'profile',
	          breadcrumb: 'Profile',
	          action: {
	            component: __webpack_require__(59)
	          }
	        }
	      }, {
	        path: 'reservations',
	        name: 'driver-reservations',
	        component: __webpack_require__(1984),
	        meta: {
	          source: 'drivers',
	          entityComponent: __webpack_require__(73),
	          name: 'driver-reservations',
	          breadcrumb: 'Reservations',
	          action: {
	            component: __webpack_require__(59)
	          }
	        }
	      }, {
	        path: 'subscriptions',
	        component: __webpack_require__(1985),
	        name: 'driver-subscriptions',
	        meta: {
	          source: 'drivers',
	          entityComponent: __webpack_require__(73),
	          name: 'subscriptions',
	          breadcrumb: 'Subscriptions',
	          action: {
	            component: __webpack_require__(59)
	          }
	        }
	      }, {
	        path: 'driver-licenses',
	        component: __webpack_require__(1981),
	        name: 'driver-licenses',
	        meta: {
	          source: 'drivers',
	          entityComponent: __webpack_require__(73),
	          name: 'driver-licenses',
	          breadcrumb: 'Driver licenses',
	          action: {
	            component: __webpack_require__(59)
	          }
	        }
	      }, {
	        path: 'driver-coupons',
	        component: __webpack_require__(1980),
	        name: 'driver-coupons',
	        meta: {
	          source: 'drivers',
	          entityComponent: __webpack_require__(73),
	          name: 'driver-coupons',
	          breadcrumb: 'Driver coupons',
	          action: {
	            component: __webpack_require__(59)
	          }
	        }
	      }, {
	        path: 'driver-cards',
	        component: __webpack_require__(1979),
	        name: 'driver-cards',
	        meta: {
	          source: 'drivers',
	          entityComponent: __webpack_require__(73),
	          name: 'driver-cards',
	          breadcrumb: 'Driver cards',
	          action: {
	            component: __webpack_require__(59)
	          }
	        }
	      }, {
	        path: 'driver-tocs',
	        component: __webpack_require__(1986),
	        name: 'driver-tocs',
	        meta: {
	          source: 'drivers',
	          entityComponent: __webpack_require__(73),
	          name: 'driver-tocs',
	          breadcrumb: 'Driver tocs',
	          action: {
	            component: __webpack_require__(59)
	          }
	        }
	      }, {
	        path: 'driver-logs',
	        component: __webpack_require__(1982),
	        name: 'driver-logs',
	        meta: {
	          source: 'drivers',
	          entityComponent: __webpack_require__(73),
	          name: 'driver-logs',
	          breadcrumb: 'Logs',
	          action: {
	            component: __webpack_require__(59)
	          }
	        }
	      }]
	    }]
	  }, {
	    path: 'subscriptions',
	    component: __webpack_require__(12),
	    meta: {
	      path: 'subscriptions',
	      breadcrumb: 'Subscriptions'
	    },
	    children: [{
	      path: '/',
	      name: 'subscriptions',
	      meta: {
	        breadcrumb: 'Subscription list'
	      },
	      component: __webpack_require__(2180)
	    }, {
	      path: ':id',
	      name: 'subscription',
	      component: __webpack_require__(27),
	      meta: {
	        breadcrumb: '#S',
	        hideInMenu: true,
	        source: 'subscriptions',
	        entityComponent: __webpack_require__(2200),
	        name: 'Subscription',
	        action: {
	          component: __webpack_require__(572)
	        }
	      }
	    }]
	  }, {
	    path: 'cards',
	    name: 'cards',
	    meta: {
	      breadcrumb: 'Cards',
	      action: {
	        component: __webpack_require__(22),
	        path: 'add-card'
	      }
	    },
	    component: __webpack_require__(2108)
	  }, {
	    path: 'add-card',
	    name: 'add-card',
	    meta: {
	      breadcrumb: 'New card',
	      hideInMenu: true
	    },
	    component: __webpack_require__(204)
	  }, {
	    path: 'notifications',
	    name: 'notifications',
	    meta: {
	      breadcrumb: 'Notifications'
	    },
	    component: __webpack_require__(2156)
	  }, {
	    path: 'registration-tokens',
	    meta: {
	      breadcrumb: 'Registration Tokens',
	      path: 'registration-tokens'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'registration-tokens',
	      component: __webpack_require__(2166),
	      meta: {
	        breadcrumb: '',
	        action: {
	          component: __webpack_require__(603),
	          path: 'add'
	        }
	      }
	    }]
	  }]
	}, {
	  path: 'booking',
	  meta: {
	    breadcrumb: 'Booking'
	  },
	  name: 'booking-root',
	  redirect: { name: 'reservations' },
	  component: __webpack_require__(12),
	  children: [{
	    path: 'reservations',
	    meta: {
	      breadcrumb: 'Reservations',
	      path: 'reservations'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'reservations',
	      component: __webpack_require__(2169),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'List'
	      }
	    }, {
	      path: 'add',
	      name: 'Create reservation',
	      meta: {
	        breadcrumb: 'New reservation',
	        hideInMenu: true
	      },
	      component: __webpack_require__(100)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#R',
	        source: 'reservations',
	        hideInMenu: true
	
	      },
	      children: [{
	        path: '',
	        name: 'reservation',
	        meta: {
	          source: 'reservations',
	          entityComponent: __webpack_require__(2199),
	          name: 'reservation',
	          action: {
	            component: __webpack_require__(101)
	          }
	        }
	      }, {
	        path: 'replace-vehicle',
	        name: 'replace-vehicle',
	        meta: {
	          source: 'reservations',
	          entityComponent: __webpack_require__(2195),
	          name: 'reservation',
	          breadcrumb: 'Replace vehicle',
	          action: {
	            component: __webpack_require__(101)
	          }
	        }
	      }, {
	        path: 'report-reservation',
	        name: 'report-resevation',
	        meta: {
	          source: 'reservations',
	          entityComponent: __webpack_require__(2197),
	          name: 'report-reservation',
	          breadcrumb: 'Reservation report'
	        }
	      }],
	
	      component: __webpack_require__(27)
	    }]
	  }, {
	    path: 'reservation-planner',
	    name: 'reservation-planner',
	    meta: { breadcrumb: 'Planner' },
	    component: __webpack_require__(2170)
	  }, {
	    path: 'charge-sessions',
	    name: 'charge-sessions',
	    meta: {
	      breadcrumb: 'Charging sessions',
	      action: {
	        component: __webpack_require__(593),
	        path: 'add'
	      }
	    },
	    component: __webpack_require__(594)
	  }, {
	    path: 'reservation-request',
	    name: 'reservation-request',
	    meta: { breadcrumb: 'Requests' },
	    component: __webpack_require__(2138)
	  }]
	}, {
	  path: 'billing',
	  meta: {
	    breadcrumb: 'Billing'
	  },
	  name: 'billing-root',
	  redirect: { name: 'invoices' },
	  component: __webpack_require__(12),
	  children: [{
	    path: 'invoices',
	    meta: {
	      breadcrumb: 'Invoices',
	      path: 'invoices'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'invoices',
	      component: __webpack_require__(2152),
	      meta: {
	        breadcrumb: 'Invoice list'
	      }
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#INV',
	        source: 'invoices',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(608),
	        action: {
	          component: __webpack_require__(212)
	        }
	      },
	      children: [{
	        path: '',
	        name: 'invoice',
	        component: __webpack_require__(114),
	        meta: {
	          source: 'invoices',
	          entityComponent: __webpack_require__(608),
	          name: 'invoice',
	          breadcrumb: 'invoice',
	          action: {
	            component: __webpack_require__(212)
	          }
	        }
	      }],
	      component: __webpack_require__(27)
	    }]
	  }, {
	    path: 'transactions',
	    meta: {
	      breadcrumb: 'Transactions',
	      path: 'transactions'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'transactions',
	      component: __webpack_require__(2183),
	      meta: {
	        breadcrumb: 'Transactions'
	      }
	    }, {
	      path: ':id',
	      name: 'transaction',
	      component: __webpack_require__(1994),
	      meta: {
	        breadcrumb: '#TR',
	        source: 'transactions',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(2201),
	        action: {
	          component: __webpack_require__(147)
	        }
	      }
	    }]
	  }, {
	    path: 'pending-records',
	    meta: {
	      breadcrumb: 'Pending records',
	      path: 'pending-records'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'pending-records',
	      component: __webpack_require__(2160)
	
	    }]
	  }, {
	    path: 'coupons',
	    meta: {
	      breadcrumb: 'Coupons',
	      path: 'coupons'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'coupons',
	      component: __webpack_require__(2122),
	      meta: {
	        breadcrumb: 'Coupons',
	        action: {
	          component: __webpack_require__(126),
	          path: 'add'
	        }
	      }
	    }]
	  }, {
	    path: 'coupons-list',
	    meta: {
	      breadcrumb: 'Coupons List',
	      path: 'coupons-list'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'coupons-list',
	      component: __webpack_require__(2121),
	      meta: {
	        breadcrumb: 'Coupons List'
	      }
	
	    }]
	  }]
	}, {
	  path: 'assets',
	  meta: { breadcrumb: 'Assets' },
	  name: 'assets-root',
	  redirect: { name: 'vehicles' },
	  component: __webpack_require__(12),
	
	  children: [{
	    path: 'categories',
	    meta: {
	      breadcrumb: 'Vehicle Categories',
	      path: 'categories'
	
	    },
	    children: [{
	      path: '',
	      name: 'categories',
	      component: __webpack_require__(2111),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        }
	      }
	    }, {
	      path: 'add',
	      name: 'create-category',
	      meta: { breadcrumb: 'Add Vehicle Category', hideInMenu: true },
	      component: __webpack_require__(2130)
	    }],
	    component: __webpack_require__(12)
	
	  }, {
	    path: 'types',
	    meta: {
	      breadcrumb: 'Vehicle types',
	      path: 'types'
	
	    },
	    children: [{
	      path: '',
	      name: 'types',
	      component: __webpack_require__(2189),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        }
	      }
	    }, {
	      path: 'add',
	      name: 'create-vehicle-type',
	      meta: { breadcrumb: 'Add vehicle type', hideInMenu: true },
	      component: __webpack_require__(2131)
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'management',
	    meta: {
	      breadcrumb: 'Management',
	      path: 'management'
	    },
	    children: [{
	      path: '',
	      name: 'management',
	      component: __webpack_require__(2107),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add-parking-group'
	        },
	        breadcrumb: 'Parking Groups'
	
	      }
	    }, {
	      path: 'add-parking-group',
	      name: 'add-parking-group',
	      meta: { breadcrumb: 'Add Parking Group', hideInMenu: true },
	      component: __webpack_require__(2036)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#PL',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(159)
	      },
	      children: [{
	        path: '',
	        name: 'parkingLot',
	        component: __webpack_require__(1992),
	        meta: {
	          source: 'parkingLots',
	          entityComponent: __webpack_require__(159),
	          name: 'parkingLot',
	          breadcrumb: 'Manage',
	          action: {
	            component: __webpack_require__(146)
	          }
	        }
	      }, {
	        path: 'manage',
	        name: 'manage',
	        component: __webpack_require__(1991),
	        meta: {
	          source: 'parkingLots',
	          entityComponent: __webpack_require__(159),
	          name: 'manage',
	          breadcrumb: 'Manage',
	          action: {
	            component: __webpack_require__(146)
	          }
	        }
	      }, {
	        path: 'zones',
	        name: 'zones',
	        component: __webpack_require__(1990),
	        meta: {
	          source: 'parkingLots',
	          entityComponent: __webpack_require__(159),
	          name: 'zones',
	          breadcrumb: 'Zones',
	          action: {
	            component: __webpack_require__(146)
	          }
	        }
	      }, {
	        path: 'add-parking-lot',
	        name: 'add-parking-lot',
	        meta: {
	          breadcrumb: 'Add Parking Lot', hideInMenu: true,
	          source: 'parkingGroups',
	          entityComponent: __webpack_require__(211),
	          name: 'parkingLots'
	        },
	        component: __webpack_require__(211)
	      }],
	      component: __webpack_require__(27)
	
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'operations',
	    meta: {
	      breadcrumb: 'Operations',
	      path: 'operations',
	      hideInMenu: true
	    },
	    children: [{
	      path: ':id',
	      meta: {
	        breadcrumb: '#VS',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(229)
	      },
	      children: [{
	        path: '',
	        name: 'operations',
	
	        meta: {
	          source: 'vehicleSlots',
	          entityComponent: __webpack_require__(229),
	          name: 'operations',
	          breadcrumb: 'Drain'
	
	        }
	      }],
	      component: __webpack_require__(27)
	
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'vehicles',
	    meta: {
	      breadcrumb: 'Vehicles',
	      path: 'vehicles'
	    },
	    children: [{
	      path: '',
	      name: 'vehicles',
	      component: __webpack_require__(607),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'Vehicle list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-vehicle',
	      meta: { breadcrumb: 'Add vehicle', hideInMenu: true },
	      component: __webpack_require__(2129)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#V',
	        source: 'vehicles',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(49)
	      },
	      children: [{
	        path: '',
	        name: 'vehicle',
	        component: __webpack_require__(2002),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle',
	          breadcrumb: 'Overview',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'availability',
	        name: 'vehicle-availability',
	        component: __webpack_require__(1996),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle-availability',
	          breadcrumb: 'Availability',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'reports',
	        name: 'vehicle-reports',
	        component: __webpack_require__(2003),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle-reports',
	          breadcrumb: 'Reports',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'maintenance-requests',
	        name: 'maintenance-requests',
	        component: __webpack_require__(1999),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'maintenance-requests',
	          breadcrumb: 'Maintenance requests',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'reservations',
	        name: 'vehicle-reservations',
	        component: __webpack_require__(2004),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle-reservations',
	          breadcrumb: 'Reservations',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'position',
	        name: 'vehicle-position',
	        component: __webpack_require__(2000),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle-position',
	          breadcrumb: 'Position',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'costs',
	        name: 'vehicle-costs',
	        component: __webpack_require__(1997),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle-costs',
	          breadcrumb: 'Costs',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'notes',
	        name: 'vehicle-notes',
	        component: __webpack_require__(2001),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle-notes',
	          breadcrumb: 'Notes',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'instructions',
	        name: 'vehicle-instructions',
	        component: __webpack_require__(1998),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle-instructions',
	          breadcrumb: 'Instructions',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'attributes',
	        name: 'vehicle-attributes',
	        component: __webpack_require__(1995),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle-attributes',
	          breadcrumb: 'Attributes',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }, {
	        path: 'logs',
	        name: 'vehicle-logs',
	        component: __webpack_require__(2005),
	        meta: {
	          source: 'vehicles',
	          entityComponent: __webpack_require__(49),
	          name: 'vehicle-logs',
	          breadcrumb: 'Logs',
	          action: {
	            component: __webpack_require__(44)
	          }
	        }
	      }],
	      component: __webpack_require__(27)
	
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'notes-management',
	    meta: {
	      breadcrumb: 'Notes',
	      path: 'notes-management'
	    },
	    children: [{
	      path: '',
	      name: 'notes-management',
	      component: __webpack_require__(2155),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        }
	      }
	    }, {
	      path: 'add',
	      name: 'create-note',
	      meta: { breadcrumb: 'Add Global Note', hideInMenu: true },
	      component: __webpack_require__(154)
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'attributes',
	    meta: {
	      breadcrumb: 'Attributes',
	      path: 'attributes'
	    },
	    children: [{
	      path: '',
	      name: 'attributes',
	      component: __webpack_require__(2188),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'Attribute list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-attribute',
	      meta: { breadcrumb: 'Add attribute', hideInMenu: true },
	      component: __webpack_require__(598)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#VA',
	        source: 'vehicleAttributes',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(56)
	      },
	      children: [{
	        path: '',
	        name: 'attribute',
	        component: __webpack_require__(598),
	        meta: {
	          source: 'vehicleAttributes',
	          entityComponent: __webpack_require__(56),
	          name: 'attribute'
	        }
	      }],
	      component: __webpack_require__(27)
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'zone-management',
	    meta: {
	      breadcrumb: 'Zones',
	      path: 'zone-management'
	    },
	    children: [{
	      path: '',
	      name: 'zone-management',
	      component: __webpack_require__(2192),
	      meta: {
	        action: [{
	          component: __webpack_require__(22),
	          path: 'add'
	        }, {
	          component: __webpack_require__(22),
	          path: 'merge'
	        }]
	      }
	    }, {
	      path: 'merge',
	      name: 'merge-zone',
	      meta: { breadcrumb: 'Merge zone', hideInMenu: true },
	      component: __webpack_require__(2154)
	    }, {
	      path: 'add',
	      name: 'create-zone',
	      meta: { breadcrumb: 'Add zone', hideInMenu: true },
	      component: __webpack_require__(2132)
	    }, {
	      path: ':id/edit',
	      name: 'edit-zone',
	      meta: { breadcrumb: 'Edit zone', hideInMenu: true },
	      component: __webpack_require__(2140)
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'clone',
	    meta: {
	      breadcrumb: 'Clone Vehicle',
	      path: 'clone'
	    },
	    children: [{
	      path: '',
	      name: 'clone',
	      component: __webpack_require__(2115)
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'segments',
	    meta: {
	      breadcrumb: 'Segments',
	      path: 'segments'
	    },
	    children: [{
	      path: '',
	      name: 'segments',
	      component: __webpack_require__(2177),
	      meta: {}
	    }],
	    component: __webpack_require__(12)
	  }]
	}, {
	  path: 'support',
	  name: 'support-root',
	  meta: { breadcrumb: 'Support' },
	  redirect: { name: 'reportings' },
	  component: __webpack_require__(12),
	  children: [{
	    path: 'reportings',
	    meta: {
	      breadcrumb: 'Reporting List',
	      path: 'reportings'
	    },
	    children: [{
	      path: '',
	      name: 'reportings',
	      component: __webpack_require__(2167),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'create-reporting'
	        },
	        breadcrumb: 'Reporting List'
	      }
	    }, {
	      path: 'create-reporting/:vehicleId?',
	      name: 'create-reporting',
	      meta: {
	        breadcrumb: 'New reporting',
	        hideInMenu: true
	      },
	      component: __webpack_require__(2128)
	    }, {
	      path: ':id',
	      name: 'reporting',
	      meta: {
	        breadcrumb: '#RP',
	        source: 'reportings',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(2198),
	        action: {
	          component: __webpack_require__(571)
	        }
	      },
	      children: [{
	        path: 'edit',
	        name: 'edit-reporting',
	        entityComponent: __webpack_require__(602),
	        meta: {
	          source: 'reportings',
	          entityComponent: __webpack_require__(602),
	          name: 'reportings',
	          breadcrumb: 'Edit'
	        }
	      }],
	
	      component: __webpack_require__(27)
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'reporting-types',
	    meta: {
	      breadcrumb: 'Reporting type List',
	      path: 'reporting-types'
	    },
	    children: [{
	      path: '',
	      name: 'reporting-types',
	      component: __webpack_require__(2168),
	      meta: {
	        action: {
	          component: __webpack_require__(2037),
	          path: 'create-reporting'
	        }
	      }
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'intervention-request',
	    meta: {
	      breadcrumb: 'Maintenance request',
	      path: 'intervention-request'
	
	    },
	    children: [{
	      path: '',
	      name: 'intervention-request',
	      component: __webpack_require__(156),
	      meta: {
	        action: {
	          component: __webpack_require__(153),
	          path: 'add'
	        }
	      }
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'instructions',
	    meta: {
	      breadcrumb: 'Vehicle Instructions',
	      path: 'instructions'
	    },
	    children: [{
	      path: '',
	      name: 'instructions',
	      component: __webpack_require__(2151),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'create-instruction'
	        },
	        breadcrumb: ''
	      }
	    }, {
	      path: 'create-instruction/',
	      name: 'create-instruction',
	      meta: {
	        breadcrumb: 'New instruction',
	        hideInMenu: true
	      },
	      component: __webpack_require__(595)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#IN',
	        source: 'instructions',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(230)
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'instruction',
	        component: __webpack_require__(595),
	        meta: {
	          source: 'instructions',
	          entityComponent: __webpack_require__(56),
	          name: 'update',
	          breadcrumb: 'Update'
	        }
	      }]
	    }],
	    component: __webpack_require__(12)
	  }]
	}, {
	  path: 'config',
	  name: 'config-root',
	  meta: { breadcrumb: 'Configuration' },
	  redirect: { name: 'plans' },
	  component: __webpack_require__(12),
	  children: [{
	    path: 'system',
	    name: 'system',
	    meta: { breadcrumb: 'System' },
	    component: __webpack_require__(2119)
	  }, {
	    path: 'plans',
	    meta: {
	      breadcrumb: 'Plans',
	      path: 'plans'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'plans',
	      component: __webpack_require__(2161),
	      meta: {
	        action: {
	          component: __webpack_require__(2162),
	          path: 'add'
	        },
	        breadcrumb: 'Plan list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-plan',
	      meta: {
	        breadcrumb: 'Add plan',
	        hideInMenu: true
	      },
	      component: __webpack_require__(2127)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#PL',
	        source: 'plans',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(56),
	        action: {
	          component: __webpack_require__(569)
	        }
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'plan',
	        component: __webpack_require__(553),
	        meta: {
	          source: 'plans',
	          entityComponent: __webpack_require__(56),
	          name: 'setup',
	          breadcrumb: 'Setup',
	          action: {
	            component: __webpack_require__(569)
	          }
	        }
	      }, {
	        path: 'plan-reservation-rates',
	        name: 'plan-reservation-rates',
	        component: __webpack_require__(552),
	        meta: {
	          source: 'plans',
	          entityComponent: __webpack_require__(56),
	          name: 'rates',
	          breadcrumb: 'Plan reservation rates'
	        }
	      }, {
	        path: ':rateId/edit',
	        name: 'edit-plan-reservation-rates',
	        component: __webpack_require__(551),
	        meta: {
	          source: 'plans',
	          entityComponent: __webpack_require__(56),
	          name: 'rates',
	          breadcrumb: 'Edit'
	        }
	
	      }, {
	        path: 'add-plan-reservation-rate',
	        name: 'add-plan-reservation-rates',
	        component: __webpack_require__(550),
	        meta: {
	          source: 'plans',
	          entityComponent: __webpack_require__(56),
	          name: 'rates',
	          breadcrumb: 'New'
	        }
	
	      }]
	    }]
	  }, {
	    path: 'rates',
	    meta: {
	      breadcrumb: 'Rates',
	      path: 'rates'
	    },
	    component: __webpack_require__(12),
	
	    children: [{
	      path: 'add-rate',
	      name: 'add-rate',
	      component: __webpack_require__(554),
	      meta: {
	        breadcrumb: 'Add Rate'
	      }
	    }, {
	      path: '',
	      name: 'rates',
	      component: __webpack_require__(2171),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add-rate'
	        },
	        breadcrumb: 'Rate list'
	      }
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#R',
	        source: 'reservationRates',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(56)
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'configuration-rate',
	        component: __webpack_require__(554),
	        meta: {
	          source: 'reservationRates',
	          entityComponent: __webpack_require__(56),
	          name: 'setup',
	          breadcrumb: 'Setup'
	        }
	      }]
	    }]
	  }, {
	    path: 'tocs',
	    meta: {
	      breadcrumb: 'Tocs',
	      path: 'tocs'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'tocs',
	      component: __webpack_require__(2181),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'Toc list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-toc',
	      meta: {
	        breadcrumb: 'Add toc',
	        hideInMenu: true
	      },
	      component: __webpack_require__(597)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#TOC',
	        source: 'tocs',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(230)
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'toc',
	        component: __webpack_require__(597),
	        meta: {
	          source: 'tocs',
	          entityComponent: __webpack_require__(56),
	          name: 'update',
	          breadcrumb: 'Update'
	        }
	      }]
	    }]
	  }, {
	    path: 'policies',
	    meta: {
	      breadcrumb: 'Policies',
	      path: 'policies'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'policies',
	      component: __webpack_require__(2163),
	      meta: {
	        action: {
	          component: __webpack_require__(63),
	          path: 'add'
	        },
	        breadcrumb: 'Policy list'
	      }
	    }]
	  }, {
	    path: 'groups',
	    meta: {
	      breadcrumb: 'Groups',
	      path: 'groups'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'groups',
	      component: __webpack_require__(2148),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'Group list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-group',
	      meta: {
	        breadcrumb: 'Add group',
	        hideInMenu: true
	      },
	      component: __webpack_require__(93)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#G',
	        source: 'groups',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(230)
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'group',
	        component: __webpack_require__(93),
	        meta: {
	          source: 'groups',
	          entityComponent: __webpack_require__(93),
	          name: 'update',
	          breadcrumb: 'Update'
	        }
	      }]
	    }]
	  }, {
	    path: 'federations',
	    meta: {
	      breadcrumb: 'Federations',
	      path: 'federations'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'federations',
	      component: __webpack_require__(2144),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'List'
	      }
	    }, {
	      path: 'add',
	      name: 'create-federation',
	      meta: {
	        breadcrumb: 'Add federation',
	        hideInMenu: true
	      },
	      component: __webpack_require__(2142)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#F',
	        source: 'federations',
	        hideInMenu: true,
	        entityComponent: __webpack_require__(158)
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: 'vehicles',
	        name: 'federation-vehicles',
	        component: __webpack_require__(2146),
	        meta: {
	          source: 'federationVehicles',
	          entityComponent: __webpack_require__(158),
	          name: 'federationVehicles',
	          breadcrumb: 'Vehicles'
	        }
	      }, {
	        path: 'parking-groups',
	        name: 'federation-parking-groups',
	        component: __webpack_require__(2145),
	        meta: {
	          source: 'federationParkingGroups',
	          entityComponent: __webpack_require__(158),
	          name: 'federationParkingGroups',
	          breadcrumb: 'Parking Groups'
	        }
	      }, {
	        path: 'clients',
	        name: 'federation-clients',
	        component: __webpack_require__(2143),
	        meta: {
	          source: 'federationClients',
	          entityComponent: __webpack_require__(158),
	          name: 'federationClients',
	          breadcrumb: 'Clients'
	        }
	      }]
	    }]
	  }, {
	    path: 'users',
	    meta: {
	      breadcrumb: 'Users',
	      path: 'users'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'users',
	      component: __webpack_require__(2186),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'User list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-user',
	      meta: {
	        breadcrumb: 'Add user',
	        hideInMenu: true
	      },
	      component: __webpack_require__(606)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#U',
	        source: 'users',
	        hideInMenu: true
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'user',
	        meta: {
	          source: 'users',
	          entityComponent: __webpack_require__(606),
	          name: 'update',
	          breadcrumb: 'Update'
	        }
	      }]
	    }]
	  }, {
	    path: 'roles',
	    meta: {
	      breadcrumb: 'Roles',
	      path: 'roles'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'roles',
	      component: __webpack_require__(2175),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'Role list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-role',
	      meta: {
	        breadcrumb: 'Add Role',
	        hideInMenu: true
	      },
	      component: __webpack_require__(604)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#RL',
	        source: 'roles',
	        hideInMenu: true
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'role',
	        meta: {
	          source: 'roles',
	          entityComponent: __webpack_require__(604),
	          name: 'update',
	          breadcrumb: 'Update'
	        }
	      }]
	    }]
	  }, {
	    path: 'translations',
	    meta: {
	      breadcrumb: 'Translations',
	      path: 'translations'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'translations',
	      component: __webpack_require__(2185),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'Translation list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-translation',
	      meta: {
	        breadcrumb: 'Add Translation',
	        hideInMenu: true
	      },
	      component: __webpack_require__(2184)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#TR',
	        source: 'translations',
	        hideInMenu: true
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: '',
	        name: 'translation',
	        meta: {
	          source: 'translations',
	          entityComponent: __webpack_require__(157),
	          name: 'update',
	          breadcrumb: 'Update'
	        }
	      }]
	    }]
	  }, {
	    path: 'toc-types',
	    meta: {
	      breadcrumb: 'Toc types',
	      path: 'toc-types'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'toc-types',
	      component: __webpack_require__(2182),
	      meta: {
	        action: {
	          component: __webpack_require__(2038),
	          path: 'add'
	        },
	        breadcrumb: 'Toc type list'
	      }
	    }]
	  }, {
	    path: 'document-types',
	    meta: {
	      breadcrumb: 'Document types',
	      path: 'document-types'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'document-types',
	      component: __webpack_require__(2133),
	      meta: {
	        action: {
	          component: __webpack_require__(564),
	          path: 'add'
	        },
	        breadcrumb: 'Document type list'
	      }
	    }]
	  }, {
	    path: 'common-costs',
	    meta: {
	      breadcrumb: 'Common Costs',
	      path: 'common-costs'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'common-costs',
	      component: __webpack_require__(2116),
	      meta: {
	        breadcrumb: 'Cost list'
	      }
	    }]
	  }, {
	    path: 'common-cost-types',
	    meta: {
	      breadcrumb: 'Common Cost Types',
	      path: 'common-cost-types'
	
	    },
	    children: [{
	      path: '',
	      name: 'common-cost-types',
	      component: __webpack_require__(2117),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        }
	      }
	    }, {
	      path: 'add',
	      name: 'create-common-cost-type',
	      meta: { breadcrumb: 'Add common cost type', hideInMenu: true },
	      component: __webpack_require__(2124)
	    }],
	    component: __webpack_require__(12)
	  }, {
	    path: 'packets',
	    meta: {
	      breadcrumb: 'Packets',
	      path: 'packets'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'packets',
	      component: __webpack_require__(2157),
	      meta: {
	        action: {
	          component: __webpack_require__(218),
	          path: 'add'
	        },
	        breadcrumb: 'Packet list'
	      }
	    }]
	  }, {
	    path: 'packet-category',
	    meta: {
	      breadcrumb: 'packet category',
	      path: 'packet-category'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'packet-category',
	      component: __webpack_require__(2158),
	      meta: {
	        breadcrumb: 'packet category list'
	      }
	    }]
	  }, {
	    path: 'requirements',
	    meta: {
	      breadcrumb: 'Requirements',
	      path: 'requirements'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'requirements',
	      component: __webpack_require__(600),
	      meta: {
	        action: {
	          component: __webpack_require__(563),
	          path: 'add'
	        },
	        breadcrumb: 'Requirement list'
	      }
	    }]
	  }, {
	    path: 'console',
	    meta: {
	      breadcrumb: 'Console',
	      path: 'console'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'console',
	      component: __webpack_require__(2120),
	      meta: {
	        breadcrumb: 'Console'
	      }
	    }]
	  }, {
	    path: 'client-types',
	    meta: {
	      breadcrumb: 'Client types',
	      path: 'client-types'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'client-types',
	      component: __webpack_require__(2114),
	      meta: {
	        action: {
	          component: __webpack_require__(2035),
	          path: 'add'
	        },
	        breadcrumb: 'Client type list'
	      }
	    }]
	  }, {
	    path: 'vats',
	    meta: {
	      breadcrumb: 'Vat',
	      path: 'vats'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'vats',
	      component: __webpack_require__(2187),
	      meta: {
	        action: {
	          component: __webpack_require__(2059),
	          path: 'add'
	        },
	        breadcrumb: 'Vat list'
	      }
	    }]
	  }, {
	    path: 'zone-configuration',
	    meta: {
	      breadcrumb: 'Zone Config',
	      path: 'zone-configuration'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'zone-configuration',
	      component: __webpack_require__(2191),
	      meta: {
	        action: {
	          component: __webpack_require__(22),
	          path: 'add'
	        },
	        breadcrumb: 'Zone config list'
	      }
	    }, {
	      path: 'add',
	      name: 'create-zone-config',
	      meta: {
	        breadcrumb: 'Add',
	        hideInMenu: true
	      },
	      component: __webpack_require__(228)
	    }, {
	      path: ':id',
	      meta: {
	        breadcrumb: '#ZC',
	        source: 'zoneConfigurations',
	        hideInMenu: true
	      },
	      component: __webpack_require__(27),
	      children: [{
	        path: 'edit',
	        name: 'edit-zone-config',
	
	        meta: {
	          hideInMenu: true,
	          source: 'zoneConfigurations',
	          entityComponent: __webpack_require__(228),
	          name: 'edit',
	          breadcrumb: 'Edit'
	        },
	        component: __webpack_require__(228)
	      }]
	    }]
	  }, {
	    path: 'pages-configuration',
	    meta: {
	      breadcrumb: 'Pages Config',
	      path: 'pages-configuration'
	    },
	    component: __webpack_require__(12),
	    children: [{
	      path: '',
	      name: 'pages-configuration',
	      component: __webpack_require__(2159),
	      meta: {
	        breadcrumb: '',
	        action: {
	          component: __webpack_require__(2126),
	          path: 'add'
	        }
	      }
	    }]
	  }, {
	    path: 'logout',
	    name: 'logout',
	    meta: { breadcrumb: 'Logout' },
	    component: __webpack_require__(2153)
	  }]
	}];
	
	exports.default = [{
	  path: '/',
	  redirect: { name: 'home' }
	}, {
	  path: '/administration',
	  component: __webpack_require__(2103),
	  meta: { breadcrumb: 'Backoffice' },
	  redirect: { name: 'home' },
	  children: routes
	}, {
	  path: 'login',
	  name: 'login',
	  meta: { breadcrumb: 'Login', hideInMenu: true },
	  component: __webpack_require__(2105)
	}, {
	  path: '/hardware-sim',
	  meta: { path: 'hwsim' },
	  component: __webpack_require__(2104)
	}];

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1460)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(632),
	  /* template */
	  __webpack_require__(2307),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1572)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(634),
	  /* template */
	  __webpack_require__(2422),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1491)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(635),
	  /* template */
	  __webpack_require__(2339),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1500)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(646),
	  /* template */
	  __webpack_require__(2348),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1786)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(648),
	  /* template */
	  __webpack_require__(2641),
	  /* scopeId */
	  "data-v-aa8d1b16",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1634)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(650),
	  /* template */
	  __webpack_require__(2485),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1661)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(651),
	  /* template */
	  __webpack_require__(2513),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1477)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(658),
	  /* template */
	  __webpack_require__(2325),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1507)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(669),
	  /* template */
	  __webpack_require__(2355),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1405)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(674),
	  /* template */
	  __webpack_require__(2252),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1527)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(677),
	  /* template */
	  __webpack_require__(2375),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1480)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(681),
	  /* template */
	  __webpack_require__(2328),
	  /* scopeId */
	  "data-v-243f6230",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1633)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(682),
	  /* template */
	  __webpack_require__(2484),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1432)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(683),
	  /* template */
	  __webpack_require__(2279),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1457)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(692),
	  /* template */
	  __webpack_require__(2304),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1832)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(693),
	  /* template */
	  __webpack_require__(2689),
	  /* scopeId */
	  "data-v-d0d97a26",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1365)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(707),
	  /* template */
	  __webpack_require__(2211),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1720)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(709),
	  /* template */
	  __webpack_require__(2574),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1856)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(715),
	  /* template */
	  __webpack_require__(2713),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1739)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(738),
	  /* template */
	  __webpack_require__(2593),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1561)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(746),
	  /* template */
	  __webpack_require__(2410),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1639)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(753),
	  /* template */
	  __webpack_require__(2490),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1398)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(755),
	  /* template */
	  __webpack_require__(2245),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1722)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(757),
	  /* template */
	  __webpack_require__(2576),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1677)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(764),
	  /* template */
	  __webpack_require__(2529),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1806)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(774),
	  /* template */
	  __webpack_require__(2662),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1652)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(781),
	  /* template */
	  __webpack_require__(2503),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1840)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(782),
	  /* template */
	  __webpack_require__(2697),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1433)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(783),
	  /* template */
	  __webpack_require__(2280),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1816)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(812),
	  /* template */
	  __webpack_require__(2672),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1376)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(828),
	  /* template */
	  __webpack_require__(2223),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1512)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(834),
	  /* template */
	  __webpack_require__(2360),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1494)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(835),
	  /* template */
	  __webpack_require__(2342),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1676)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(869),
	  /* template */
	  __webpack_require__(2528),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1611)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(874),
	  /* template */
	  __webpack_require__(2462),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1427)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(883),
	  /* template */
	  __webpack_require__(2274),
	  /* scopeId */
	  "data-v-142cadb8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1438)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(885),
	  /* template */
	  __webpack_require__(2285),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1608)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(892),
	  /* template */
	  __webpack_require__(2459),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1860)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(893),
	  /* template */
	  __webpack_require__(2717),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1843)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(899),
	  /* template */
	  __webpack_require__(2700),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1387)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(901),
	  /* template */
	  __webpack_require__(2234),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1593)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(908),
	  /* template */
	  __webpack_require__(2443),
	  /* scopeId */
	  "data-v-46a3dede",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1578)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(909),
	  /* template */
	  __webpack_require__(2428),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1873)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(919),
	  /* template */
	  __webpack_require__(2730),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1659)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(920),
	  /* template */
	  __webpack_require__(2511),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1551)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(924),
	  /* template */
	  __webpack_require__(2400),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1878)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(929),
	  /* template */
	  __webpack_require__(2735),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1845)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(948),
	  /* template */
	  __webpack_require__(2702),
	  /* scopeId */
	  "data-v-da6a068a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1425)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(949),
	  /* template */
	  __webpack_require__(2272),
	  /* scopeId */
	  "data-v-13dcf296",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1772)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(951),
	  /* template */
	  __webpack_require__(2627),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1547)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(961),
	  /* template */
	  __webpack_require__(2395),
	  /* scopeId */
	  "data-v-3725f57e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1715)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(968),
	  /* template */
	  __webpack_require__(2569),
	  /* scopeId */
	  "data-v-70a3ae41",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1773)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(974),
	  /* template */
	  __webpack_require__(2628),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1631)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(975),
	  /* template */
	  __webpack_require__(2482),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1701)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(976),
	  /* template */
	  __webpack_require__(2555),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1399)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(987),
	  /* template */
	  __webpack_require__(2246),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1714)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(994),
	  /* template */
	  __webpack_require__(2568),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1567)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(995),
	  /* template */
	  __webpack_require__(2416),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1733)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(999),
	  /* template */
	  __webpack_require__(2587),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1687)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1007),
	  /* template */
	  __webpack_require__(2541),
	  /* scopeId */
	  "data-v-66814edc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1719)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1011),
	  /* template */
	  __webpack_require__(2573),
	  /* scopeId */
	  "data-v-71e9de92",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1462)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1013),
	  /* template */
	  __webpack_require__(2309),
	  /* scopeId */
	  "data-v-1eb1a67e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1754)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1019),
	  /* template */
	  __webpack_require__(2609),
	  /* scopeId */
	  "data-v-7f409e6f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1619)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1021),
	  /* template */
	  __webpack_require__(2470),
	  /* scopeId */
	  "data-v-4e0b7b6b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1455)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1022),
	  /* template */
	  __webpack_require__(2302),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1367)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1032),
	  /* template */
	  __webpack_require__(2213),
	  /* scopeId */
	  "data-v-04549721",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1696)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1037),
	  /* template */
	  __webpack_require__(2550),
	  /* scopeId */
	  "data-v-695d2981",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1048),
	  /* template */
	  __webpack_require__(2216),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1049),
	  /* template */
	  __webpack_require__(2598),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1851)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1066),
	  /* template */
	  __webpack_require__(2708),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1564)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1073),
	  /* template */
	  __webpack_require__(2413),
	  /* scopeId */
	  "data-v-3cca26a4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1829)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1074),
	  /* template */
	  __webpack_require__(2686),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1655)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1076),
	  /* template */
	  __webpack_require__(2506),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1579)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1080),
	  /* template */
	  __webpack_require__(2429),
	  /* scopeId */
	  "data-v-407df6d7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1689)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1081),
	  /* template */
	  __webpack_require__(2543),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1647)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1089),
	  /* template */
	  __webpack_require__(2498),
	  /* scopeId */
	  "data-v-5760dd9a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1534)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1090),
	  /* template */
	  __webpack_require__(2382),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1517)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1123),
	  /* template */
	  __webpack_require__(2365),
	  /* scopeId */
	  "data-v-2f4a93b0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1800)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1132),
	  /* template */
	  __webpack_require__(2655),
	  /* scopeId */
	  "data-v-b3ed9aa6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1636)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1137),
	  /* template */
	  __webpack_require__(2487),
	  /* scopeId */
	  "data-v-54606e23",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1504)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1149),
	  /* template */
	  __webpack_require__(2352),
	  /* scopeId */
	  "data-v-2baf0dfc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1742)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1153),
	  /* template */
	  __webpack_require__(2596),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1565)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1166),
	  /* template */
	  __webpack_require__(2414),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    install: function install(Vue, options) {
	        Vue.prototype.$acl = options.handler;
	    }
	};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(10);
	
	var _Notification = __webpack_require__(2015);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "App",
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    notificationsStore: function notificationsStore(state) {
	      return state.notificationsStore;
	    }
	  }), {
	    title: function title() {
	      return window.env.UPPER_BAR;
	    }
	  }),
	  components: {
	    Notification: _Notification2.default
	  },
	  created: function created() {}
	};

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'AccountStatus',
	  methods: {
	    getStatusClass: function getStatusClass(status) {
	      switch (status) {
	        case 'document_status':
	          {
	            var currentStatus = this.accountStatus.document_status;
	            return 'fa-id-card ' + currentStatus;
	          }
	        case 'payment_method':
	          {
	            var _currentStatus = this.accountStatus.payment_method ? 'valid' : '';
	            return 'fa-credit-card ' + _currentStatus;
	          }
	        case 'subscription':
	          {
	            var _currentStatus2 = this.accountStatus.subscription ? 'valid' : '';
	            return 'fa-money ' + _currentStatus2;
	          }
	        case 'address':
	          {
	            var _currentStatus3 = this.accountStatus.address ? 'valid' : '';
	            return 'fa-address-card ' + _currentStatus3;
	          }
	        case 'client':
	          {
	            var _currentStatus4 = this.accountStatus.client ? 'valid' : 'pending_validation';
	            return 'fa-user ' + _currentStatus4;
	          }
	        case 'driver':
	          {
	            var _currentStatus5 = this.accountStatus.driver ? 'valid' : 'pending_validation';
	            return 'fa-user ' + _currentStatus5;
	          }
	
	      }
	    }
	  },
	  props: {
	    toggleable: {
	      type: Boolean,
	      default: false
	    },
	    accountStatus: {
	      type: Object
	    },
	    statuses: {
	      type: Array,
	      default: function _default() {
	        return ['document_status', 'payment_method', 'subscription', 'address'];
	      }
	    }
	  }
	};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _VehicleFields = __webpack_require__(220);
	
	var _VehicleFields2 = _interopRequireDefault(_VehicleFields);
	
	var _VehicleStatus = __webpack_require__(208);
	
	var _VehicleStatus2 = _interopRequireDefault(_VehicleStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Alarm',
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  components: { VehicleStatus: _VehicleStatus2.default, VehicleFields: _VehicleFields2.default, CardN: _CardN2.default },
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {},
	  destroyed: function destroyed() {},
	  updated: function updated() {},
	
	  methods: {}
	};

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "AppliedRates",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    computed: {},
	    props: ['item']
	};

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "BackofficeAttachment",
	    props: {
	        item: Object,
	        type: {
	            type: String,
	            default: ''
	        }
	    },
	    components: {},
	    created: function created() {},
	
	    methods: {
	        openUrl: function openUrl(url) {
	            window.open(url, '_blank');
	        }
	    }
	};

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BilledRecords',
	  methods: {},
	  filters: {
	    walletableType: function walletableType(value) {
	      return value.replace(/App\\Models\\/, '');
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapMarker = __webpack_require__(72);
	
	var _GoogleMapMarker2 = _interopRequireDefault(_GoogleMapMarker);
	
	var _GoogleMapCircle = __webpack_require__(152);
	
	var _GoogleMapCircle2 = _interopRequireDefault(_GoogleMapCircle);
	
	var _GoogleMapMarkerCluster = __webpack_require__(226);
	
	var _GoogleMapMarkerCluster2 = _interopRequireDefault(_GoogleMapMarkerCluster);
	
	var _GoogleMapDirectionsService = __webpack_require__(225);
	
	var _GoogleMapDirectionsService2 = _interopRequireDefault(_GoogleMapDirectionsService);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BookVehicleFromMap",
	  components: {
	    GoogleMap: _GoogleMap2.default,
	    GoogleMapMarker: _GoogleMapMarker2.default,
	    GoogleMapCircle: _GoogleMapCircle2.default,
	    GoogleMapMarkerCluster: _GoogleMapMarkerCluster2.default,
	    GoogleMapContainer: _GoogleMapContainer2.default,
	    GoogleMapDirectionsService: _GoogleMapDirectionsService2.default,
	    Vehicle: _Vehicle2.default
	  },
	  data: function data() {
	    return {
	      vehiclePosition: null,
	      userPos: null,
	      mapsAPI: null,
	      mapCenter: {
	        lat: 0,
	        lng: 0
	      }
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this.mapCenter.lat = data.application.application_default_latitude.value;
	      _this.mapCenter.lng = data.application.application_default_longitude.value;
	    });
	    this.mapsAPI = window.env.GOOGLE_MAPS_KEY;
	  },
	
	
	  methods: {
	    updateUserPosition: function updateUserPosition(position) {
	      this.userPosition = position.location;
	    },
	    updateSelectedVehicle: function updateSelectedVehicle(position) {
	      this.vehiclePosition = position.latLng;
	    }
	  },
	  watch: {
	    userPosition: function userPosition() {
	      if (this.userPosition) {
	        this.mapCenter.lat = this.userPosition.latitude;
	        this.mapCenter.lng = this.userPosition.longitude;
	      }
	    }
	  },
	  props: {
	    vehicles: Array,
	    userPosition: null
	  }
	};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CallButton',
	  components: {
	    ModalReveal: _ModalReveal2.default
	  },
	  data: function data() {
	    return {
	      loading: false,
	      result: "",
	      payload: {
	        internal: "",
	        external: ""
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.payload.external = this.phone;
	    var i = localStorage.getItem("c2c-internal");
	
	    if (i) {
	      this.payload.internal = i;
	    }
	  },
	
	  methods: {
	    requestCall: function requestCall() {
	      var _this = this;
	
	      localStorage.setItem("c2c-internal", this.payload.internal);
	      this.loading = true;
	      this.result = "";
	      _backoffice2.default.calls.request(this.payload, function () {
	        _this.loading = false;
	        _this.result = "CALL REQUESTED";
	      }, function () {
	        _this.loading = false;
	        _this.result = "CALL REQUEST FAIL";
	      });
	    }
	  },
	  computed: {},
	  props: {
	    phone: {
	      required: true
	    }
	  }
	};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Card = __webpack_require__(77);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _CardActionButtons = __webpack_require__(2031);
	
	var _CardActionButtons2 = _interopRequireDefault(_CardActionButtons);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "",
	  components: {
	    CardN: _CardN2.default,
	    CardActionButtons: _CardActionButtons2.default,
	    Dropdown: _Dropdown2.default,
	    Card4: _Card2.default,
	    Driver: _Driver2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: ['item']
	};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _MdiIcon = __webpack_require__(80);
	
	var _MdiIcon2 = _interopRequireDefault(_MdiIcon);
	
	var _eventBus = __webpack_require__(15);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Cargo",
	  components: {
	    Dropdown: _Dropdown2.default,
	    MdiIcon: _MdiIcon2.default,
	    ActionButton: _ActionButton2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    openUrl: function openUrl(url) {
	      window.open(url, '_blank');
	    },
	    stopProcessing: function stopProcessing() {
	      return _backoffice2.default.cargo.stop(this.item.id, function () {
	        _eventBus.EventBus.$emit('reload-list');
	      });
	    }
	  },
	  computed: {},
	  props: {
	    item: '',
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _ChargingSessionButtons = __webpack_require__(561);
	
	var _ChargingSessionButtons2 = _interopRequireDefault(_ChargingSessionButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ChargingSession',
	  components: { ChargingSessionButtons: _ChargingSessionButtons2.default, Dropdown: _Dropdown2.default },
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Accordion = __webpack_require__(78);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _DriverNote = __webpack_require__(533);
	
	var _DriverNote2 = _interopRequireDefault(_DriverNote);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Status = __webpack_require__(69);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _Wallet = __webpack_require__(1940);
	
	var _Wallet2 = _interopRequireDefault(_Wallet);
	
	var _ClientActionButtons = __webpack_require__(43);
	
	var _ClientActionButtons2 = _interopRequireDefault(_ClientActionButtons);
	
	var _simpleColums = __webpack_require__(2020);
	
	var _simpleColums2 = _interopRequireDefault(_simpleColums);
	
	var _thumbnail = __webpack_require__(203);
	
	var _thumbnail2 = _interopRequireDefault(_thumbnail);
	
	var _vuex = __webpack_require__(10);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AccountStatus = __webpack_require__(185);
	
	var _AccountStatus2 = _interopRequireDefault(_AccountStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeClient',
	  data: function data() {
	    return {
	      lastNotes: []
	    };
	  },
	
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  created: function created() {},
	
	  components: {
	    AccountStatus: _AccountStatus2.default,
	    Thumbnail: _thumbnail2.default,
	    SimpleColumns2: _simpleColums2.default,
	    Driver: _Driver2.default,
	    Accordion: _Accordion2.default,
	    CardN: _CardN2.default,
	    Dropdown: _Dropdown2.default,
	    Status: _Status2.default,
	    ClientActionButtons: _ClientActionButtons2.default,
	    Wallet: _Wallet2.default,
	    DriverNotes: _DriverNote2.default
	  },
	  methods: {
	    retriveLastNotes: function retriveLastNotes(items) {
	      var count = 0;
	      self = this;
	      console.log(items.items);
	      items.items.forEach(function (item) {
	        if (count < 2) {
	          self.lastNotes.push(item.description);
	          count++;
	        }
	      });
	    },
	
	    update: function update() {
	      this.$emit('updated', this.item);
	    },
	    checkAddress: function checkAddress(address) {
	      return function sum(obj) {
	        return (0, _keys2.default)(obj).reduce(function (sum, key) {
	          return sum + parseFloat(obj[key]);
	        }, 0);
	      };
	
	      return !!sum(address);
	    },
	    daysWaiting: function daysWaiting(updated) {
	      return (0, _moment2.default)(updated).fromNow(true);
	    },
	    formatDate: function formatDate(date) {
	      return (0, _moment2.default)(date).format('DD/MM/YYYY');
	    }
	  },
	  computed: (0, _extends3.default)({
	    fiscalCode: function fiscalCode() {
	      return this.item.fiscal_code ? this.item.fiscal_code.toUpperCase() : null;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    extra: function extra() {
	      var _this = this;
	
	      if (this.item.extra === null) {
	        this.$set(this.item, 'extra', {});
	        this.configuration.system.system_client_custom_fields.value.forEach(function (item) {
	          _this.$set(_this.item.extra, item.value, null);
	        });
	        return;
	      }
	      return this.item.extra;
	    },
	    accountStatus: function accountStatus() {
	      var accountStatus = this.item.account_status;
	      accountStatus.address = !!this.item.address.street;
	      return accountStatus;
	    }
	  })
	};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientPlanSubscriber',
	  components: { ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      plans: [],
	      selected_plan: null,
	      subscribe_main_driver: true,
	      free_subscription: true,
	      unavailable: false,
	      disabled: 'not_disabled'
	    };
	  },
	  created: function created() {
	    var self = this;
	    _backoffice2.default.selects.plans(this.disabled, function (response) {
	      self.plans = response;
	    });
	  },
	  mounted: function mounted() {
	    this.getPlans();
	  },
	
	  watch: {
	    unavailable: function unavailable(newValue, oldValue) {
	      this.getPlans();
	    }
	  },
	  methods: {
	    subscribe: function subscribe() {
	      var self = this;
	      return _backoffice2.default.clients.select(this.client_id).subscribe(this.selected_plan, this.free_subscription, this.subscribe_main_driver, function (response) {
	        self.$emit('subscriptionAdded', 'added');
	      });
	    },
	
	    getPlans: function getPlans() {
	      if (this.unavailable) {
	        return this.plans;
	      } else {
	        return this.plans.filter(function (item) {
	          if (item.status === 'AVAILABLE') {
	            return item;
	          }
	        });
	      }
	    }
	  },
	
	  props: ['client_id']
	};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _vuex = __webpack_require__(10);
	
	var _TocButtons = __webpack_require__(70);
	
	var _TocButtons2 = _interopRequireDefault(_TocButtons);
	
	var _TocTypeButtons = __webpack_require__(102);
	
	var _TocTypeButtons2 = _interopRequireDefault(_TocTypeButtons);
	
	var _ClientTypeButtons = __webpack_require__(562);
	
	var _ClientTypeButtons2 = _interopRequireDefault(_ClientTypeButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientType',
	  components: {
	    ClientTypeButtons: _ClientTypeButtons2.default,
	    TocTypeButtons: _TocTypeButtons2.default,
	    TocButtons: _TocButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _TocButtons = __webpack_require__(70);
	
	var _TocButtons2 = _interopRequireDefault(_TocButtons);
	
	var _TocTypeButtons = __webpack_require__(102);
	
	var _TocTypeButtons2 = _interopRequireDefault(_TocTypeButtons);
	
	var _CommonCostButtons = __webpack_require__(2032);
	
	var _CommonCostButtons2 = _interopRequireDefault(_CommonCostButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocumentType',
	  components: {
	    CommonCostButtons: _CommonCostButtons2.default,
	    TocTypeButtons: _TocTypeButtons2.default,
	    TocButtons: _TocButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _CommonCostTypeButton = __webpack_require__(2033);
	
	var _CommonCostTypeButton2 = _interopRequireDefault(_CommonCostTypeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CommonCostType',
	  components: {
	    CommonCostTypeButton: _CommonCostTypeButton2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _DepositConfiguration = __webpack_require__(1946);
	
	var _DepositConfiguration2 = _interopRequireDefault(_DepositConfiguration);
	
	var _ValidationConfig = __webpack_require__(192);
	
	var _ValidationConfig2 = _interopRequireDefault(_ValidationConfig);
	
	var _ClientCustomFieldsConfiguration = __webpack_require__(1943);
	
	var _ClientCustomFieldsConfiguration2 = _interopRequireDefault(_ClientCustomFieldsConfiguration);
	
	var _SystemFieldsConfiguration = __webpack_require__(1951);
	
	var _SystemFieldsConfiguration2 = _interopRequireDefault(_SystemFieldsConfiguration);
	
	var _FleetPositionConfiguration = __webpack_require__(1947);
	
	var _FleetPositionConfiguration2 = _interopRequireDefault(_FleetPositionConfiguration);
	
	var _DeleteConf = __webpack_require__(67);
	
	var _DeleteConf2 = _interopRequireDefault(_DeleteConf);
	
	var _ReservationSurveyConfiguration = __webpack_require__(1950);
	
	var _ReservationSurveyConfiguration2 = _interopRequireDefault(_ReservationSurveyConfiguration);
	
	var _ItalianEInvoiceSplitPaymentConfiguration = __webpack_require__(1948);
	
	var _ItalianEInvoiceSplitPaymentConfiguration2 = _interopRequireDefault(_ItalianEInvoiceSplitPaymentConfiguration);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CreditBonusConfiguration = __webpack_require__(1944);
	
	var _CreditBonusConfiguration2 = _interopRequireDefault(_CreditBonusConfiguration);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _CreditBonusInformation = __webpack_require__(1945);
	
	var _CreditBonusInformation2 = _interopRequireDefault(_CreditBonusInformation);
	
	var _JsonConf = __webpack_require__(1949);
	
	var _JsonConf2 = _interopRequireDefault(_JsonConf);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ConfigurationItem',
	  components: {
	    TranslateField: _TranslateField2.default,
	    JsonConf: _JsonConf2.default,
	
	    CreditBonusInformation: _CreditBonusInformation2.default,
	    Dropdown: _Dropdown2.default,
	    CreditBonusConfiguration: _CreditBonusConfiguration2.default,
	    ModalReveal: _ModalReveal2.default,
	    ReservationSurveyConfiguration: _ReservationSurveyConfiguration2.default,
	    ItalianEInvoiceSplitPaymentConfiguration: _ItalianEInvoiceSplitPaymentConfiguration2.default,
	    DeleteConf: _DeleteConf2.default,
	    FleetPositionConfiguration: _FleetPositionConfiguration2.default,
	    SystemFieldsConfiguration: _SystemFieldsConfiguration2.default,
	    ClientCustomFieldsConfiguration: _ClientCustomFieldsConfiguration2.default,
	    ValidationConfig: _ValidationConfig2.default, DepositConfiguration: _DepositConfiguration2.default
	  },
	  data: function data() {
	    return {
	      value: null,
	      selectTmp: null
	    };
	  },
	  created: function created() {
	    if (this.item.value) {
	      this.value = this.item.value;
	    } else {
	      if (this.item.type.split(':')[1] === 'simple') {
	        this.value = this.item.default;
	      }
	    }
	  },
	
	  methods: {
	    update: function update() {
	      console.log(this.item);
	      if (this.item.type === "json") {
	        try {
	          var newFoo = JSON.parse(this.value);
	        } catch (err) {
	          alert("seems to be invalid json: " + err);
	
	          return;
	        }
	      }
	      this.$emit('updateItem', this.itemKey, this.value);
	    },
	    pushEmptyValue: function pushEmptyValue(fields) {
	      if (!this.value) {
	        this.value = [];
	      }
	
	      var item = {};
	
	      fields.forEach(function (fi) {
	        item[fi] = null;
	      });
	
	      this.value.push(item);
	    },
	    pushKeyed: function pushKeyed() {
	
	      if (this.value === null) {
	        this.value = {};
	      }
	
	      if (this.selectTmp) {
	        this.value[this.selectTmp] = null;
	
	        this.reloadValue();
	      }
	    },
	    deleteKeyed: function deleteKeyed(index) {
	      delete this.value[index];
	      this.reloadValue();
	    },
	    reloadValue: function reloadValue() {
	      var tmp = (0, _assign2.default)({}, this.value);
	      this.value = {};
	      this.value = (0, _assign2.default)({}, tmp);
	    },
	    pushAndSave: function pushAndSave(item) {}
	  },
	  props: ['item', 'itemKey']
	};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _FederationButtons = __webpack_require__(145);
	
	var _FederationButtons2 = _interopRequireDefault(_FederationButtons);
	
	var _CouponButtons = __webpack_require__(210);
	
	var _CouponButtons2 = _interopRequireDefault(_CouponButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Coupon',
	  components: { CouponButtons: _CouponButtons2.default, FederationButtons: _FederationButtons2.default, Dropdown: _Dropdown2.default, CardN: _CardN2.default },
	  props: ['item', 'type']
	};

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'CouponInUse',
	  components: {},
	  props: ['item', 'type']
	
	};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _vuex = __webpack_require__(10);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _CreditRecordButtons = __webpack_require__(565);
	
	var _CreditRecordButtons2 = _interopRequireDefault(_CreditRecordButtons);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreditRecord',
	  components: { Dropdown: _Dropdown2.default, CreditRecordButtons: _CreditRecordButtons2.default, ActionButton: _ActionButton2.default, CardN: _CardN2.default },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: ['item', 'type']
	};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _TocButtons = __webpack_require__(70);
	
	var _TocButtons2 = _interopRequireDefault(_TocButtons);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'Deposit',
	    components: {
	        TocButtons: _TocButtons2.default,
	        VehicleNoteButtons: _VehicleNoteButtons2.default,
	        VehicleCostButtons: _VehicleCostButtons2.default,
	        Dropdown: _Dropdown2.default,
	        CardN: _CardN2.default
	    },
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	        configuration: function configuration(state) {
	            return state.configuration;
	        }
	    }), {
	        walletable: function walletable() {
	            return this.item.walletable_type ? this.item.walletable_type.replace(/App\\Models\\Reservation/, 'R') : null;
	        }
	    }),
	    props: {
	        item: Object,
	        type: {
	            type: String,
	            default: ''
	        }
	    }
	};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _vuex = __webpack_require__(10);
	
	var _TocButtons = __webpack_require__(70);
	
	var _TocButtons2 = _interopRequireDefault(_TocButtons);
	
	var _TocTypeButtons = __webpack_require__(102);
	
	var _TocTypeButtons2 = _interopRequireDefault(_TocTypeButtons);
	
	var _DocumentTypeButtons = __webpack_require__(566);
	
	var _DocumentTypeButtons2 = _interopRequireDefault(_DocumentTypeButtons);
	
	var _DocumentRequirementButtons = __webpack_require__(2039);
	
	var _DocumentRequirementButtons2 = _interopRequireDefault(_DocumentRequirementButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocumentRequirement',
	  components: {
	    DocumentRequirementButtons: _DocumentRequirementButtons2.default,
	    DocumentTypeButtons: _DocumentTypeButtons2.default,
	    TocTypeButtons: _TocTypeButtons2.default,
	    TocButtons: _TocButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _vuex = __webpack_require__(10);
	
	var _TocButtons = __webpack_require__(70);
	
	var _TocButtons2 = _interopRequireDefault(_TocButtons);
	
	var _TocTypeButtons = __webpack_require__(102);
	
	var _TocTypeButtons2 = _interopRequireDefault(_TocTypeButtons);
	
	var _DocumentTypeButtons = __webpack_require__(566);
	
	var _DocumentTypeButtons2 = _interopRequireDefault(_DocumentTypeButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocumentType',
	  components: {
	    DocumentTypeButtons: _DocumentTypeButtons2.default,
	    TocTypeButtons: _TocTypeButtons2.default,
	    TocButtons: _TocButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Accordion = __webpack_require__(78);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _Status = __webpack_require__(69);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _DriverActionButtons = __webpack_require__(59);
	
	var _DriverActionButtons2 = _interopRequireDefault(_DriverActionButtons);
	
	var _Card = __webpack_require__(555);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _DriverFields = __webpack_require__(579);
	
	var _DriverFields2 = _interopRequireDefault(_DriverFields);
	
	var _Card3 = __webpack_require__(2013);
	
	var _Card4 = _interopRequireDefault(_Card3);
	
	var _simpleColums = __webpack_require__(2021);
	
	var _simpleColums2 = _interopRequireDefault(_simpleColums);
	
	var _thumbnail = __webpack_require__(203);
	
	var _thumbnail2 = _interopRequireDefault(_thumbnail);
	
	var _AccountStatus = __webpack_require__(185);
	
	var _AccountStatus2 = _interopRequireDefault(_AccountStatus);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _DriverNote = __webpack_require__(533);
	
	var _DriverNote2 = _interopRequireDefault(_DriverNote);
	
	var _CallButton = __webpack_require__(1899);
	
	var _CallButton2 = _interopRequireDefault(_CallButton);
	
	var _DriverNotification = __webpack_require__(1910);
	
	var _DriverNotification2 = _interopRequireDefault(_DriverNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeDriver',
	  data: function data() {
	    return {
	      fakePicture: false,
	      pictureOriginal: '',
	      lastNotes: []
	    };
	  },
	
	  components: {
	    CallButton: _CallButton2.default,
	    DriverNotes: _DriverNote2.default,
	    ModalReveal: _ModalReveal2.default,
	    AccountStatus: _AccountStatus2.default,
	    thumbnail: _thumbnail2.default,
	    SimpleColumns33: _simpleColums2.default,
	    Card10: _Card4.default,
	    DriverFields: _DriverFields2.default,
	    Card6: _Card2.default,
	    Accordion: _Accordion2.default,
	    Status: _Status2.default,
	    CardN: _CardN2.default,
	    Dropdown: _Dropdown2.default,
	    DriverActionButtons: _DriverActionButtons2.default,
	    DriverNotification: _DriverNotification2.default
	
	  },
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  mounted: function mounted() {
	    this.lookForDeletableProfilePicture();
	  },
	  created: function created() {},
	
	  methods: {
	    retriveLastNotes: function retriveLastNotes(items) {
	      var count = 0;
	      self = this;
	      items.items.forEach(function (item) {
	        if (count < 2) {
	          self.lastNotes.push(item.description);
	          count++;
	        }
	      });
	    },
	
	    update: function update() {
	      this.$emit('updated', this.item);
	    },
	    lookForDeletableProfilePicture: function lookForDeletableProfilePicture() {
	      if (this.item.profile_picture.indexOf('/res') > -1) {
	        return this.fakePicture = false;
	      }
	      return this.fakePicture = true;
	    },
	    deletePicture: function deletePicture() {
	      var _this = this;
	
	      this.$confirm('Are you sure', 'Do you want to delete profile picture?', function () {
	        _backoffice2.default.drivers.select(_this.item).pictureDelete(function (data) {
	          if (data.result_code == 'profile-picture-deleted') {
	            _maggieHelper2.default.notification('delete-esit', data.result);
	            window.location.reload();
	          } else {
	            _maggieHelper2.default.notification('delete-esit', data.result);
	          }
	        });
	      });
	    },
	    openPicture: function openPicture(po) {
	      this.pictureOriginal = po;
	      this.$refs.reveal.openModal();
	    }
	  },
	  computed: {
	    accountStatus: function accountStatus() {
	      var accountStatus = this.item.account_status;
	      accountStatus.address = !!this.item.address.street;
	      return accountStatus;
	    },
	
	    c2cEnabled: function c2cEnabled() {
	      return window.env.C2C_ENABLED == 'true';
	    }
	  }
	};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _PolicyButtons = __webpack_require__(213);
	
	var _PolicyButtons2 = _interopRequireDefault(_PolicyButtons);
	
	var _GroupButtons = __webpack_require__(567);
	
	var _GroupButtons2 = _interopRequireDefault(_GroupButtons);
	
	var _DriverGroupButtons = __webpack_require__(2040);
	
	var _DriverGroupButtons2 = _interopRequireDefault(_DriverGroupButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverGroup',
	  components: { DriverGroupButtons: _DriverGroupButtons2.default, GroupButtons: _GroupButtons2.default, PolicyButtons: _PolicyButtons2.default, Dropdown: _Dropdown2.default, CardN: _CardN2.default },
	  props: ['item', 'driver']
	};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Status = __webpack_require__(69);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _Attachment = __webpack_require__(527);
	
	var _Attachment2 = _interopRequireDefault(_Attachment);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _DriverLicenseEdit = __webpack_require__(1963);
	
	var _DriverLicenseEdit2 = _interopRequireDefault(_DriverLicenseEdit);
	
	var _DriverLicenseAttachment = __webpack_require__(1908);
	
	var _DriverLicenseAttachment2 = _interopRequireDefault(_DriverLicenseAttachment);
	
	var _DriverLicenseAttachmentUpload = __webpack_require__(1909);
	
	var _DriverLicenseAttachmentUpload2 = _interopRequireDefault(_DriverLicenseAttachmentUpload);
	
	var _Card = __webpack_require__(77);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Card3 = __webpack_require__(76);
	
	var _Card4 = _interopRequireDefault(_Card3);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _thumbnail = __webpack_require__(203);
	
	var _thumbnail2 = _interopRequireDefault(_thumbnail);
	
	var _DriverFields = __webpack_require__(579);
	
	var _DriverFields2 = _interopRequireDefault(_DriverFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DriverFields: _DriverFields2.default,
	    Thumbnail: _thumbnail2.default,
	    CardN: _CardN2.default,
	    Dropdown: _Dropdown2.default,
	    Card3: _Card4.default,
	    Card4: _Card2.default,
	    BackofficeDriverLicenseAttachmentUpload: _DriverLicenseAttachmentUpload2.default,
	    BackofficeDriverLicenseAttachment: _DriverLicenseAttachment2.default,
	    BackofficeAttachment: _Attachment2.default,
	    Status: _Status2.default,
	    Driver: _Driver2.default
	  },
	  name: 'DriverLicence',
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      showAttachments: false
	    };
	  },
	
	  methods: {
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _DriverLicenseEdit2.default,
	        props: {
	          item: this.item
	        }
	      });
	    },
	    approve: function approve() {
	      _backoffice2.default.driverLicenses.select(this.item).approve(function (data) {
	        location.reload();
	      });
	    },
	    deleteD: function deleteD() {
	      var _this = this;
	
	      this.$confirm('Are you sure', 'Do you want to delete DL' + this.item.id + ' document?', function () {
	        _backoffice2.default.driverLicenses.select(_this.item).delete(function (data) {
	          location.reload();
	        });
	      });
	    },
	    refuse: function refuse() {
	      _backoffice2.default.driverLicenses.select(this.item).refuse(function (data) {
	        location.reload();
	      });
	    },
	    upload: function upload() {
	      _maggieHelper2.default.openRightPanel({
	        component: _DriverLicenseAttachmentUpload2.default,
	        props: {
	          item: this.item
	        }
	      });
	    },
	
	    openUrl: function openUrl(url) {
	      window.open(url, '_blank');
	    }
	  },
	  computed: {
	    attachmentButton: function attachmentButton() {
	      return this.showAttachments ? 'fa-minus' : 'fa-plus';
	    }
	  }
	};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _DriverLicenseAttachmentActionButtons = __webpack_require__(2041);
	
	var _DriverLicenseAttachmentActionButtons2 = _interopRequireDefault(_DriverLicenseAttachmentActionButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficeDriverLicenseAttachment",
	  components: {
	    DriverLicenseAttachmentActionButtons: _DriverLicenseAttachmentActionButtons2.default,
	    Dropdown: _Dropdown2.default
	  },
	  created: function created() {},
	
	  methods: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficeDriverLicenseAttachmentUpload",
	  components: {
	    Dropzone: _Dropzone2.default
	  },
	  data: function data() {
	    return {
	      attachments: [],
	      dropzoneUrl: _backoffice2.default.getUrlForDropzone() + ''
	    };
	  },
	
	  methods: {
	    removeAttachment: function removeAttachment(file) {
	      var _this = this;
	
	      var tokenOnQueue = JSON.parse(file.xhr.response).token;
	      this.attachments.forEach(function (token, key) {
	        if (token === tokenOnQueue) {
	          _this.attachments.splice(key, 1);
	        }
	      });
	    },
	
	    uploaded: function uploaded(file, response) {
	      this.attachments.push(response.token);
	    },
	    upload: function upload() {
	      var _this2 = this;
	
	      this.attachments.forEach(function (token, key) {
	        _backoffice2.default.driverLicenses.select(_this2.item.id).addAttachment({ attachment_token: token }, function (data) {
	          _this2.attachments.splice(key, 1);
	          _maggieHelper2.default.notification('upload-esit', 'Attachment uploaded');
	          _this2.$emit('attachmentUploaded');
	          _this2.$refs.dropzone.removeAllFiles();
	          _maggieHelper2.default.closeRightPanel();
	          window.location.reload();
	        });
	      });
	    }
	  },
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vuex = __webpack_require__(10);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverNotes',
	  components: {
	    ActionButton: _ActionButton2.default,
	    BaseList: _BaseList2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    ModalReveal: _ModalReveal2.default
	
	  },
	  data: function data() {
	    return {
	      body: {
	        description: null,
	        id: this.driver_id,
	        type: 'App\\Models\\Driver'
	      },
	      loading: false,
	      component: __webpack_require__(134),
	      notes: 0,
	      items: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.dataLoader(function (notes) {
	      _this.notes = notes.items_count;
	    });
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      var _this2 = this;
	
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	
	      _backoffice2.default.notes.list().all({
	        per_page: resultsPerPage,
	        page_number: page,
	        type: this.body.type,
	        id: this.body.id
	      }, function (data) {
	        if (_this2.type === "highlightedNotes") {
	          var new_obj = (0, _assign2.default)(data, { 'highlightedNotes': true });
	          _this2.items = new_obj;
	          _this2.$emit('notes', _this2.items);
	        }
	        callback(data);
	      });
	    },
	    pushNote: function pushNote() {
	      var _this3 = this;
	
	      var body = (0, _extends3.default)({}, this.body);
	      body.description += "\n -  (" + this.user.username + ")";
	
	      this.body.description = null;
	      this.$refs.baseList.data.items = null;
	      return _backoffice2.default.notes.make(body, function () {
	        return _this3.$refs.baseList.loadData(1);
	      }).finally(function () {
	        return _this3.loading = false;
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    },
	    user: function user(state) {
	      return state.userStore.user;
	    }
	  })),
	  props: {
	    driver_id: {
	      required: true
	    },
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(10);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverNotification',
	  components: {
	    ActionButton: _ActionButton2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    ModalReveal: _ModalReveal2.default
	
	  },
	  data: function data() {
	    return {
	      body: {
	        subject: null,
	        url: "",
	        content: null,
	        driver_id: this.driver_id,
	        type: 'App\\Models\\Driver'
	      },
	      loading: false,
	      items: null
	    };
	  },
	
	
	  methods: {
	    pushNotification: function pushNotification() {
	      return _backoffice2.default.drivers.sendNotification(this.body, function (data) {
	        return _maggieHelper2.default.notification(data.result);
	      });
	    }
	  },
	
	  props: {
	    driver_id: {
	      required: true
	    },
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _DriverReservationRequestButtons = __webpack_require__(2042);
	
	var _DriverReservationRequestButtons2 = _interopRequireDefault(_DriverReservationRequestButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverReservationRequest',
	  components: {
	    DriverReservationRequestButtons: _DriverReservationRequestButtons2.default,
	    Driver: _Driver2.default, Dropdown: _Dropdown2.default, CardN: _CardN2.default
	  },
	
	  props: ['item', 'driver']
	};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _vuex = __webpack_require__(10);
	
	var _TocButtons = __webpack_require__(70);
	
	var _TocButtons2 = _interopRequireDefault(_TocButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Toc',
	  components: {
	    TocButtons: _TocButtons2.default,
	    VehicleNoteButtons: _VehicleNoteButtons2.default,
	    VehicleCostButtons: _VehicleCostButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    fileUrl: function fileUrl() {
	      window.open(window.env.API_URL + '/storage/' + this.item.toc.attachment);
	    }
	  },
	  computed: {
	    hasAttachment: function hasAttachment() {
	      return this.item.toc.attachment !== '' && this.item.toc.attachment !== null;
	    }
	  },
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Tooltip = __webpack_require__(79);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Reservation = __webpack_require__(37);
	
	var _Reservation2 = _interopRequireDefault(_Reservation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "EasyWeeks",
	  components: { Driver: _Driver2.default, LoadingSpinner: _LoadingSpinner2.default, Tooltip: _Tooltip2.default, Reservation: _Reservation2.default },
	  props: {
	    plate: String,
	    shifts: Array,
	    reservations: Array,
	    daysToShow: Number
	  },
	  data: function data() {
	    return {
	      details: null,
	      loadingDetails: false
	    };
	  },
	
	  computed: {
	    gridCss: function gridCss() {
	      var _this = this;
	
	      var repeatForShifts = function repeatForShifts() {
	        var arr = [];
	        _this.shifts.forEach(function (s) {
	          arr.push("[row-" + (s.name + s.id) + "] '" + (s.name + s.id) + "' max-content");
	        });
	        return arr.join(' ');
	      };
	
	      return {
	        'grid': "[row-header] 'header' max-content " + repeatForShifts(),
	        'grid-auto-columns': 'minmax(min(5em, 100%), 1fr)'
	      };
	    },
	    days: function days() {
	      var arr = [];
	      for (var n = 0; n < this.daysToShow; n++) {
	        arr.push((0, _moment2.default)().isoWeekday(n + 2).format('ddd'));
	      }
	      return arr;
	    },
	    doDays: function doDays() {
	      var _this2 = this;
	
	      var arr = [];
	
	      var parseTime = function parseTime(time) {
	        var t = (0, _moment2.default)(time, 'HH:mm');
	        return {
	          hour: t.hours(),
	          minutes: t.minutes()
	        };
	      };
	
	      var _loop = function _loop(n) {
	        var veramenteDay = (0, _moment2.default)().isoWeekday(n + (0, _moment2.default)().isoWeekday()).startOf('minute');
	        var day = {
	          name: veramenteDay.format('ddd'),
	          date: veramenteDay.format('DD'),
	          shifts: []
	        };
	
	        _this2.shifts.forEach(function (shift) {
	          var obj = {};
	          obj.reservations = _this2.reservations.filter(function (r) {
	            var t1 = parseTime(shift.start);
	            var sStart = veramenteDay.clone().hour(t1.hour).minutes(t1.minutes);
	            var sEnd = sStart.clone().add(shift.duration, "minutes");
	            var rStart = (0, _moment2.default)(r.start);
	            var rEnd = (0, _moment2.default)(r.end);
	            var isContained = sStart.isSameOrBefore(rStart) && sEnd.isSameOrAfter(rEnd);
	            var hovers = rStart.isSameOrBefore(sStart) && rEnd.isSameOrAfter(sEnd);
	            var startsIn = rStart.isSameOrAfter(sStart) && rStart.isBefore(sEnd);
	            var endsIn = rEnd.isAfter(sStart) && rEnd.isSameOrBefore(sEnd);
	
	            return isContained || hovers || startsIn || endsIn;
	          });
	
	          obj.id = (shift.start + shift.end).replaceAll(':', '');
	          obj.name = shift.name;
	
	          day.shifts.push(obj);
	        });
	        arr.push(day);
	      };
	
	      for (var n = 0; n < this.daysToShow; n++) {
	        _loop(n);
	      }
	      return arr;
	    }
	  },
	  methods: {
	    displayDay: function displayDay(day) {
	      var m = (0, _moment2.default)(day);
	      return m.format("dddd");
	    },
	    getBackgroundColor: function getBackgroundColor(shift) {
	      var id = shift.id;
	      var name = shift.name;
	      return '#eaeaea';
	
	      var i = id.slice(0, 2);
	      if (i < 8) {
	        return '#3680c5';
	      } else if (i > 18) {
	        return '#3680c5';
	      } else {
	        return 'yellow';
	      }
	    },
	    getColor: function getColor(reservation) {
	      if (reservation.memo) {
	        var c = reservation.memo.split(' ')[0];
	        if (c[0] === "#") {
	          return c;
	        }
	        switch (c) {
	          case "DAY":
	            return 'yellow';
	          case "NIGHT":
	            return '#3680c5';
	        }
	      }
	      return '#03fc84';
	    },
	    getDriver: function getDriver(id) {
	      return new _promise2.default(function (resolve) {
	        _backoffice2.default.drivers.select(id).get(function (data) {
	          resolve(data);
	        });
	      });
	    },
	    getReservation: function getReservation(id) {
	      return new _promise2.default(function (resolve) {
	        _backoffice2.default.reservations.select(id).get(function (data) {
	          resolve(data);
	        });
	      });
	    },
	    getDetails: function getDetails(res) {
	      var _this3 = this;
	
	      this.loadingDetails = true;
	      _promise2.default.all([this.getReservation(res.reservation_id)]).then(function (r) {
	        _this3.details = {
	          reservation: r[0],
	          driver: r[1]
	        };
	      }).finally(function () {
	        _this3.loadingDetails = false;
	      });
	    },
	    clearDetails: function clearDetails() {
	      this.details = null;
	      this.loadingDetails = false;
	    }
	  }
	};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(241);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _EasyWeek = __webpack_require__(1913);
	
	var _EasyWeek2 = _interopRequireDefault(_EasyWeek);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "EasyWeeksWrapper",
	  components: { EasyWeeks: _EasyWeek2.default },
	  props: {
	    daysToShow: { type: Number, default: 14 },
	    autoShift: { type: Number, default: 0 },
	    hourOffset: { type: Number, default: 0 }
	  },
	  data: function data() {
	    return {
	      vehicles: null,
	      loading: false
	    };
	  },
	  created: function created() {
	    this.init();
	  },
	
	  watch: {
	    daysToShow: function daysToShow(val, oldVal) {
	      if (val !== oldVal && !this.loading) {
	        this.init();
	      }
	    },
	    hourOffset: function hourOffset(val, oldVal) {
	      if (val !== oldVal && !this.loading) {
	        this.init();
	        localStorage.setItem("hourOffset", val);
	      }
	    },
	    autoShift: function autoShift(val, oldVal) {
	      if (val !== oldVal && !this.loading) {
	        this.init();
	        localStorage.setItem("shiftCount", val);
	      }
	    }
	  },
	  methods: {
	    init: function init() {
	      var _this = this;
	
	      this.loading = true;
	      _backoffice2.default.reservations.list(1, 1000, {
	        from: (0, _moment2.default)().format('Y-MM-DD'),
	        to: (0, _moment2.default)().add(this.daysToShow, "days").format('Y-MM-DD'),
	
	        status: "STARTED|CONFIRMED|PLANNED|SENT"
	      }).all(function (data) {
	
	        _this.vehicles = (0, _collect2.default)(data.items.map(function (i) {
	          if (i) {
	            return {
	              start: i.start,
	              end: i.end,
	              reservation_id: i.id,
	              driver_id: i.driver.id,
	              plate: i.vehicle.plate,
	              status: i.status,
	              memo: i.memo
	            };
	          }
	        })).groupBy('plate').map(function (resGroup) {
	          var shifts = {};
	          var reservations = [];
	          resGroup.forEach(function (i) {
	            if (_this.autoShift == 0) {
	              var m = void 0;
	              if (i.memo && typeof i.memo === "string") {
	                m = i.memo.split(' ')[0];
	              } else {
	                m = 'no_memo';
	              }
	
	              var start = (0, _moment2.default)(i.start).format('HH:mm');
	              var end = (0, _moment2.default)(i.end).format('HH:mm');
	              var id = (start + '' + end).replaceAll(':', '');
	              var shift = {
	                id: id,
	                name: m,
	                start: start,
	                end: end,
	                duration: (0, _moment2.default)(i.end).diff((0, _moment2.default)(i.start), 'minutes'),
	                color: ''
	              };
	
	              if (!shifts.hasOwnProperty(id)) {
	                shifts[id] = shift;
	              }
	            } else {
	              shifts = [];
	              var numberOfShifts = 1440 / 30;
	
	              numberOfShifts = _this.autoShift > 24 ? 24 : _this.autoShift;
	
	              var counter = 0;
	
	              var increment = 1440 / numberOfShifts;
	
	              while (counter < 1440) {
	                var s = (0, _moment2.default)().startOf("day").hour(_this.hourOffset).add(counter, "minutes");
	                counter += increment;
	                var e = s.clone().add(increment, "minutes");
	
	                shifts.push({
	                  id: s.format("HHmm") + e.format("HHmm"),
	                  name: "T" + (shifts.length + 1),
	                  start: s.format("HH:mm"),
	                  end: e.format("HH:mm"),
	                  duration: increment,
	                  color: ''
	                });
	              }
	            }
	            reservations.push(i);
	          });
	
	          _this.loading = false;
	
	          return {
	            shifts: (0, _collect2.default)(!Array.isArray(shifts) ? (0, _values2.default)(shifts) : shifts).sortBy('id').all(),
	            reservations: (0, _collect2.default)(reservations).sortBy(function (i) {
	              return i.start;
	            }).all()
	          };
	        }).all();
	      });
	    }
	  }
	};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchInputForm = __webpack_require__(125);
	
	var _SearchInputForm2 = _interopRequireDefault(_SearchInputForm);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _VehicleListForm = __webpack_require__(583);
	
	var _VehicleListForm2 = _interopRequireDefault(_VehicleListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      component: null,
	      search: {
	        query: null
	      }
	    };
	  },
	  components: {
	    BaseList: _BaseList2.default,
	    VehicleListForm: _VehicleListForm2.default,
	    SearchInputForm: _SearchInputForm2.default
	  },
	  name: "entities-search",
	  methods: {
	    setClientComponent: function setClientComponent(search) {
	      this.search.query = search.query;
	      this.component = __webpack_require__(53);
	    },
	    setDriverComponent: function setDriverComponent(search) {
	      this.search.query = search.query;
	      this.component = __webpack_require__(18);
	    },
	    setReservationComponent: function setReservationComponent(search) {
	      this.search.query = search.query;
	      this.component = __webpack_require__(37);
	    },
	    setVehicleComponent: function setVehicleComponent(search) {
	      this.search.query = search.query;
	      this.search.inject_reservation_status = true;
	      this.component = __webpack_require__(20);
	    },
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	
	
	      var entity = null;
	      switch (this.component.name) {
	        case 'BackofficeClient':
	          entity = 'clients';
	          break;
	        case 'BackofficeDriver':
	          entity = 'drivers';
	          break;
	        case 'BackofficeReservation':
	          entity = 'reservations';
	          break;
	        case 'Vehicle':
	          entity = 'vehicles';
	          break;
	        default:
	          console.log(this.component.name);
	      }
	
	      return _backoffice2.default[entity].list(page, resultsPerPage, this.search).search(function (items) {
	        callback(items);
	      });
	    }
	  }
	};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _VehicleAvailability = __webpack_require__(137);
	
	var _VehicleAvailability2 = _interopRequireDefault(_VehicleAvailability);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ExtendReservation',
	  components: {
	    LoadingSpinner: _LoadingSpinner2.default,
	    DatePicker: _DatePicker2.default,
	    BackofficeVehicleAvailability: _VehicleAvailability2.default
	  },
	  data: function data() {
	    return {
	      availability: [],
	      start: null,
	      end: null,
	      loading: false
	    };
	  },
	  created: function created() {
	    this.start = this.$date(this.reservation.end);
	    this.end = this.$date(this.reservation.end).add(1, 'days').hours(23).minutes(30).seconds(0);
	    this.loading = true;
	    this.getAvailability();
	  },
	
	  methods: {
	    slotSelected: function slotSelected(obj) {
	      console.log(obj);
	      _backoffice2.default.reservations.select(this.reservation).extend(obj.end, function () {
	        _maggieHelper2.default.closeTopPanel();
	        _maggieHelper2.default.notification('Extended', 'Reservation extended correctly');
	      });
	    },
	    search: function search() {
	      this.start = this.$date(this.start);
	      this.end = this.$date(this.end);
	      this.getAvailability();
	    },
	    getAvailability: function getAvailability() {
	      var _this = this;
	
	      _backoffice2.default.vehicles.select(this.reservation.vehicle, {
	        start: this.start.unix(),
	        end: this.end.unix()
	      }).availability(function (data) {
	        data.forEach(function (a, i) {
	
	          (0, _assign2.default)(a, { selected: false });
	        });
	        _this.loading = false;
	        _this.availability = data;
	      });
	    },
	    showExtraDay: function showExtraDay() {
	      this.end = this.$date(this.end).add(1, 'days').hours(23).minutes(30).seconds(0);
	      this.getAvailability();
	    }
	  },
	  computed: {},
	  props: ['selectable', 'reservation']
	};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _FederationButtons = __webpack_require__(145);
	
	var _FederationButtons2 = _interopRequireDefault(_FederationButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Federation',
	  components: { FederationButtons: _FederationButtons2.default, Dropdown: _Dropdown2.default, CardN: _CardN2.default },
	  props: ['item', 'type']
	};

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'GoogleMapContainer'
	};

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _PolicyButtons = __webpack_require__(213);
	
	var _PolicyButtons2 = _interopRequireDefault(_PolicyButtons);
	
	var _GroupButtons = __webpack_require__(567);
	
	var _GroupButtons2 = _interopRequireDefault(_GroupButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Group',
	  components: { GroupButtons: _GroupButtons2.default, PolicyButtons: _PolicyButtons2.default, Dropdown: _Dropdown2.default, CardN: _CardN2.default },
	  props: ['item', 'type']
	};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _InstructionButtons = __webpack_require__(568);
	
	var _InstructionButtons2 = _interopRequireDefault(_InstructionButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Instruction",
	  components: {
	    InstructionButtons: _InstructionButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _vuex = __webpack_require__(10);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _InterventionRequestButtons = __webpack_require__(2044);
	
	var _InterventionRequestButtons2 = _interopRequireDefault(_InterventionRequestButtons);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "InterventionRequest",
	  components: {
	    InterventionRequestButtons: _InterventionRequestButtons2.default,
	    BackofficeDriver: _Driver2.default,
	    Vehicle: _Vehicle2.default,
	    VehicleNoteButtons: _VehicleNoteButtons2.default,
	    VehicleCostButtons: _VehicleCostButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {
	      showSub: false
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    close: function close() {
	      _eventBus.EventBus.$emit("close-modal");
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    linkedCompleted: function linkedCompleted() {
	      return this.item.linked_requests.filter(function (i) {
	        return i.status === "COMPLETED";
	      }).length;
	    },
	    priority: function priority() {
	      var priority = "";
	      switch (this.item.priority) {
	        case 1:
	          priority = "Minor";
	          break;
	        case 2:
	          priority = "Medium";
	          break;
	        case 3:
	          priority = "Major";
	          break;
	      }
	      return priority;
	    }
	  }),
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Accordion = __webpack_require__(78);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _InvoiceButtons = __webpack_require__(212);
	
	var _InvoiceButtons2 = _interopRequireDefault(_InvoiceButtons);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _InvoiceFields = __webpack_require__(580);
	
	var _InvoiceFields2 = _interopRequireDefault(_InvoiceFields);
	
	var _vuex = __webpack_require__(10);
	
	var _IsModuleEnabled = __webpack_require__(199);
	
	var _IsModuleEnabled2 = _interopRequireDefault(_IsModuleEnabled);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Invoice',
	  components: {
	    ActionButton: _ActionButton2.default,
	    IsModuleEnabled: _IsModuleEnabled2.default,
	    InvoiceFields: _InvoiceFields2.default,
	    CardN: _CardN2.default,
	    Transaction: _Transaction2.default,
	    InvoiceActionButtons: _InvoiceButtons2.default,
	    Accordion: _Accordion2.default,
	    Dropdown: _Dropdown2.default,
	    MaggieHelper: _maggieHelper2.default,
	    KeplerBackofficeSdk: _backoffice2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    openUrl: function openUrl(url) {
	      window.open(url, '_blank');
	    },
	    downloadXML: function downloadXML() {
	      return _backoffice2.default.invoices.select(this.item).downloadXML(function (data) {
	        window.open(data, '_blank');
	      });
	    },
	    setChecked: function setChecked(item) {
	      this.$emit('input', item.id);
	    }
	  },
	  props: {
	    item: Object,
	
	    checked: {
	      type: Boolean,
	      default: false
	    },
	    value: {},
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    label: function label() {
	      switch (this.item.type) {
	        case 'INVOICE':
	          return 'INV';
	        case 'CREDIT NOTE':
	          return 'CRN';
	        case 'PROFORMA':
	          return 'PRO';
	      }
	    },
	    xmlStatus: function xmlStatus() {
	      if (this.item.extra === undefined || this.item.extra === null || this.item.extra.einvoice === undefined || this.item.extra.einvoice === null || this.item.extra.einvoice.hasOwnProperty('uploadedFileName') && this.item.extra.einvoice.uploadedFileName == null) {
	        return {
	          color: '#A3A3A3'
	        };
	      }
	      var einvoice = this.item.extra.einvoice;
	
	      if (this.item.extra.hasOwnProperty('einvoice')) {
	        switch (this.item.extra.hasOwnProperty('einvoice')) {
	          case einvoice.is_invoice_rejected:
	            return {
	              color: 'red'
	            };
	          case einvoice.is_invoice_processing:
	            return {
	              color: '#ffae00'
	            };
	          case einvoice.is_invoice_finalized && !einvoice.is_invoice_rejected:
	            return {
	              color: 'green'
	            };
	        }
	      }
	    }
	  })
	};

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "Log",
	  props: ['item']
	};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Note",
	  components: {
	    VehicleNoteButtons: _VehicleNoteButtons2.default,
	    VehicleCostButtons: _VehicleCostButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: (0, _extends3.default)({
	    noteUrl: function noteUrl() {
	      switch (this.item.annotable_type) {
	        case 'App\\Models\\Vehicle':
	          return { name: 'vehicle-notes', params: { id: this.item.annotable_id } };
	        case 'App\\Models\\Reservation':
	          return { name: 'reservation', params: { id: this.item.annotable_id } };
	        case 'App\\Models\\Driver':
	          return { name: 'driver', params: { id: this.item.annotable_id } };
	      }
	    },
	    annotable: function annotable() {
	      return this.item.annotable_type ? this.item.annotable_type.split('\\').pop() + ' ' + this.item.annotable_id + ' ' : 'Global note';
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "NoteForm",
	  components: { DatePicker: _DatePicker2.default },
	  data: function data() {
	    return {
	      note: {
	        description: null,
	        valid_from: null,
	        valid_to: null
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    noteCompleted: function noteCompleted() {
	      this.$emit('completed', this.note);
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Notification',
	  components: { ModalReveal: _ModalReveal2.default },
	  props: ['item', 'type'],
	  data: function data() {
	    return {
	      strippedMessage: ''
	    };
	  },
	  methods: {
	    getStrippedMessage: function getStrippedMessage() {
	
	      if (this.item.message.subject) {
	        this.strippedMessage = this.item.message.subject;
	      } else {
	        this.strippedMessage = (0, _stringify2.default)(this.item.message).slice(0, 160);
	      }
	      return this.strippedMessage;
	    }
	  }
	};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _CreatePacketReveal = __webpack_require__(218);
	
	var _CreatePacketReveal2 = _interopRequireDefault(_CreatePacketReveal);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _PacketButtons = __webpack_require__(2045);
	
	var _PacketButtons2 = _interopRequireDefault(_PacketButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Packet",
	  components: { PacketButtons: _PacketButtons2.default, PacketModal: _CreatePacketReveal2.default, CardN: _CardN2.default, Dropdown: _Dropdown2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	
	};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _vuex = __webpack_require__(10);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _CreditRecordButtons = __webpack_require__(565);
	
	var _CreditRecordButtons2 = _interopRequireDefault(_CreditRecordButtons);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _PacketRecordButtons = __webpack_require__(2046);
	
	var _PacketRecordButtons2 = _interopRequireDefault(_PacketRecordButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PacketRecord',
	  components: { PacketRecordButtons: _PacketRecordButtons2.default, Dropdown: _Dropdown2.default, CreditRecordButtons: _CreditRecordButtons2.default, ActionButton: _ActionButton2.default, CardN: _CardN2.default },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: ['item', 'type']
	};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PacketVehicleCategoryButton = __webpack_require__(2047);
	
	var _PacketVehicleCategoryButton2 = _interopRequireDefault(_PacketVehicleCategoryButton);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PacketVehicleCategory",
	  components: { PacketVehicleCategoryButton: _PacketVehicleCategoryButton2.default, CardN: _CardN2.default, Dropdown: _Dropdown2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _FederationButtons = __webpack_require__(145);
	
	var _FederationButtons2 = _interopRequireDefault(_FederationButtons);
	
	var _CouponButtons = __webpack_require__(210);
	
	var _CouponButtons2 = _interopRequireDefault(_CouponButtons);
	
	var _vuex = __webpack_require__(10);
	
	var _PageButtons = __webpack_require__(2048);
	
	var _PageButtons2 = _interopRequireDefault(_PageButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Page',
	  components: { PageButtons: _PageButtons2.default, CouponButtons: _CouponButtons2.default, FederationButtons: _FederationButtons2.default, Dropdown: _Dropdown2.default, CardN: _CardN2.default },
	  props: ['item', 'type'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    defaultLanguage: function defaultLanguage() {
	      return this.configuration.application.application_default_language.value;
	    }
	  })
	};

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ParkingGroup',
	  props: ['item']
	};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Card = __webpack_require__(76);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _ParkingLotActionButtons = __webpack_require__(146);
	
	var _ParkingLotActionButtons2 = _interopRequireDefault(_ParkingLotActionButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ParkingLot',
	  components: { ParkingLotActionButtons: _ParkingLotActionButtons2.default, Dropdown: _Dropdown2.default, Card3: _Card2.default },
	  props: ['item']
	};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Card = __webpack_require__(77);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Card3 = __webpack_require__(76);
	
	var _Card4 = _interopRequireDefault(_Card3);
	
	var _Card5 = __webpack_require__(118);
	
	var _Card6 = _interopRequireDefault(_Card5);
	
	var _PaymentMethodFields = __webpack_require__(2084);
	
	var _PaymentMethodFields2 = _interopRequireDefault(_PaymentMethodFields);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _PaymentMethodButtons = __webpack_require__(2050);
	
	var _PaymentMethodButtons2 = _interopRequireDefault(_PaymentMethodButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PaymentMethod',
	  components: {
	    PaymentMethodButtons: _PaymentMethodButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default,
	    PaymentMethodFields: _PaymentMethodFields2.default,
	    Card5: _Card6.default,
	    Card3: _Card4.default,
	    Card4: _Card2.default
	
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Card = __webpack_require__(77);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "Plan",
	    components: { Card4: _Card2.default },
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	        configuration: function configuration(state) {
	            return state.configuration;
	        }
	    }), {
	        currency: function currency() {
	            return this.configuration.commercial.commercial_currency.value;
	        }
	    }),
	    methods: {},
	    props: {
	        item: Object,
	        type: {
	            type: String,
	            default: ''
	        }
	    }
	};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Card = __webpack_require__(140);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ReservationActionButtons = __webpack_require__(101);
	
	var _ReservationActionButtons2 = _interopRequireDefault(_ReservationActionButtons);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _Tab = __webpack_require__(201);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Card3 = __webpack_require__(77);
	
	var _Card4 = _interopRequireDefault(_Card3);
	
	var _Card5 = __webpack_require__(118);
	
	var _Card6 = _interopRequireDefault(_Card5);
	
	var _ReservationFields = __webpack_require__(219);
	
	var _ReservationFields2 = _interopRequireDefault(_ReservationFields);
	
	var _Card7 = __webpack_require__(198);
	
	var _Card8 = _interopRequireDefault(_Card7);
	
	var _Card9 = __webpack_require__(139);
	
	var _Card10 = _interopRequireDefault(_Card9);
	
	var _PlanReservationRateActionButtons = __webpack_require__(570);
	
	var _PlanReservationRateActionButtons2 = _interopRequireDefault(_PlanReservationRateActionButtons);
	
	var _Card11 = __webpack_require__(76);
	
	var _Card12 = _interopRequireDefault(_Card11);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficePlanReservationRates",
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  components: {
	    Card3: _Card12.default,
	    PlanReservationRateActionButtons: _PlanReservationRateActionButtons2.default,
	    Card7: _Card10.default,
	    Card8: _Card8.default,
	    ReservationFields: _ReservationFields2.default,
	    Card5: _Card6.default,
	    Card4: _Card4.default,
	    DatePicker: _DatePicker2.default,
	    Dropdown: _Dropdown2.default,
	    Card9: _Card2.default,
	    ReservationActionButtons: _ReservationActionButtons2.default,
	    Driver: _Driver2.default,
	    Vehicle: _Vehicle2.default
	  },
	  data: function data() {
	    return {
	      endTime: null
	    };
	  },
	  mounted: function mounted() {
	    this.endTime = null;
	  },
	  destroyed: function destroyed() {},
	
	  methods: {
	    withVat: function withVat(price) {
	      return price;
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  })
	};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _PolicyButtons = __webpack_require__(213);
	
	var _PolicyButtons2 = _interopRequireDefault(_PolicyButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Policy',
	  components: { PolicyButtons: _PolicyButtons2.default, Dropdown: _Dropdown2.default, CardN: _CardN2.default },
	  props: ['item', 'type']
	};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _ChargingSessionButtons = __webpack_require__(561);
	
	var _ChargingSessionButtons2 = _interopRequireDefault(_ChargingSessionButtons);
	
	var _PreauthButtons = __webpack_require__(2051);
	
	var _PreauthButtons2 = _interopRequireDefault(_PreauthButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ChargingSession',
	  components: { PreauthButtons: _PreauthButtons2.default, ChargingSessionButtons: _ChargingSessionButtons2.default, Dropdown: _Dropdown2.default },
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _RegistrationTokenButtons = __webpack_require__(2052);
	
	var _RegistrationTokenButtons2 = _interopRequireDefault(_RegistrationTokenButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RegistrationToken',
	  components: { RegistrationTokenButtons: _RegistrationTokenButtons2.default, Dropdown: _Dropdown2.default, ModalReveal: _ModalReveal2.default },
	  props: ['item', 'type'],
	  data: function data() {
	    return {
	      strippedMessage: ''
	    };
	  },
	  methods: {
	    getStrippedMessage: function getStrippedMessage() {
	
	      if (this.item.message.subject) {
	        this.strippedMessage = this.item.message.subject;
	      } else {
	        this.strippedMessage = (0, _stringify2.default)(this.item.message).slice(0, 160);
	      }
	      return this.strippedMessage;
	    }
	  }
	};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Accordion = __webpack_require__(78);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _Card = __webpack_require__(139);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Status = __webpack_require__(69);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _ReportingActionButtons = __webpack_require__(571);
	
	var _ReportingActionButtons2 = _interopRequireDefault(_ReportingActionButtons);
	
	var _ReportingFields = __webpack_require__(2085);
	
	var _ReportingFields2 = _interopRequireDefault(_ReportingFields);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "Reporting",
	    components: {
	        CardN: _CardN2.default,
	        ReportingFields: _ReportingFields2.default,
	        ReportingActionButtons: _ReportingActionButtons2.default,
	        Dropdown: _Dropdown2.default,
	        Status: _Status2.default,
	        Card7: _Card2.default,
	        Vehicle: _Vehicle2.default,
	        Driver: _Driver2.default,
	        Accordion: _Accordion2.default,
	        KeplerBackofficeSdk: _backoffice2.default,
	        MaggieHelper: _maggieHelper2.default
	    },
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    props: {
	        item: Object,
	        type: {
	            type: String,
	            default: ''
	        }
	    }
	};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Card = __webpack_require__(140);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ReservationActionButtons = __webpack_require__(101);
	
	var _ReservationActionButtons2 = _interopRequireDefault(_ReservationActionButtons);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _Card3 = __webpack_require__(77);
	
	var _Card4 = _interopRequireDefault(_Card3);
	
	var _Card5 = __webpack_require__(118);
	
	var _Card6 = _interopRequireDefault(_Card5);
	
	var _ReservationFields = __webpack_require__(219);
	
	var _ReservationFields2 = _interopRequireDefault(_ReservationFields);
	
	var _Card7 = __webpack_require__(198);
	
	var _Card8 = _interopRequireDefault(_Card7);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeReservation',
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    },
	    locate: {
	      type: Function
	    }
	  },
	  components: {
	    CardN: _CardN2.default,
	    Card8: _Card8.default,
	    ReservationFields: _ReservationFields2.default,
	    Card5: _Card6.default,
	    Card4: _Card4.default,
	    DatePicker: _DatePicker2.default,
	    Dropdown: _Dropdown2.default,
	    Card9: _Card2.default,
	    ReservationActionButtons: _ReservationActionButtons2.default,
	    Driver: _Driver2.default,
	    Vehicle: _Vehicle2.default
	  },
	  data: function data() {
	    return {
	      endTime: null
	    };
	  },
	  mounted: function mounted() {
	    this.endTime = null;
	  },
	  destroyed: function destroyed() {},
	  updated: function updated() {
	    if (this.endTime == null) {
	      this.endTime = this.item.end;
	    }
	  },
	
	  methods: {
	    update: function update() {
	      this.$emit('updated', this.item);
	    },
	
	    open: function open() {
	      var _this = this;
	
	      _backoffice2.default.reservations.select(this.item.number).open(function (response) {
	        _this.update();
	        _maggieHelper2.default.notification('open-esit', 'vehicle open signal sent');
	      });
	    },
	    close: function close() {
	      var _this2 = this;
	
	      _backoffice2.default.reservations.select(this.item.number).close(function (response) {
	        _this2.update();
	        _maggieHelper2.default.notification('close-esit', 'vehicle close signal sent');
	      });
	    },
	
	    cancel: function cancel() {
	      var _this3 = this;
	
	      _backoffice2.default.reservations.select(this.item.number).cancel(function (response) {
	        _this3.update();
	        _maggieHelper2.default.notification('cancel-esit', 'reservation cancelled');
	      });
	    },
	
	    terminate: function terminate() {
	      var _this4 = this;
	
	      _backoffice2.default.reservations.select(this.item.number).terminate(function (response) {
	        _this4.update();
	        _maggieHelper2.default.notification('cancel-esit', 'reservation cancelled');
	      });
	    },
	
	    extend: function extend() {
	      var _this5 = this;
	
	      _backoffice2.default.reservations.select(this.item.number).extend(this.convertTimestamp(this.endTime), function (response) {
	        _this5.update();
	        _maggieHelper2.default.notification('extend-esit', 'reservation extended');
	      });
	    },
	
	    pmvoid: function pmvoid() {
	      var _this6 = this;
	
	      _backoffice2.default.reservations.select(this.item.number).void(function (response) {
	        _this6.update();
	        _maggieHelper2.default.notification('void-esit', 'reservation voided');
	      });
	    },
	
	    convertTimestamp: function convertTimestamp(datetime) {
	      var t = datetime.split(/[- :]/);
	      var date = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
	      return Math.round(date.getTime() / 1000);
	    }
	
	  }
	};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeCommonCost = __webpack_require__(71);
	
	var _SelectizeCommonCost2 = _interopRequireDefault(_SelectizeCommonCost);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationFlag',
	  components: { SelectizeCommonCost: _SelectizeCommonCost2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      addFlag: false,
	      body: {
	        flag: null,
	        value: null
	      }
	    };
	  },
	
	  methods: {
	    deleteFlag: function deleteFlag(flag) {
	      return _backoffice2.default.reservationFlags.select(flag).delete(function () {
	        _maggieHelper2.default.notification('Flag', 'Deleted');
	      });
	    },
	    editFlag: function editFlag(val) {
	      return _backoffice2.default.reservationFlags.select(val).edit({
	        value: val.value
	      }, function () {
	        _maggieHelper2.default.notification('Flag', 'Edited');
	      });
	    },
	    saveFlag: function saveFlag() {
	      return _backoffice2.default.reservationFlags.make(this.reservation.id, this.body, function () {
	        _maggieHelper2.default.notification('Flag', 'Added');
	      });
	    }
	  },
	  props: ['reservation']
	};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _Tooltip = __webpack_require__(79);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _ToggleableButton = __webpack_require__(206);
	
	var _ToggleableButton2 = _interopRequireDefault(_ToggleableButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationLogTimeLine',
	  components: { ToggleableButton: _ToggleableButton2.default, Tooltip: _Tooltip2.default },
	  data: function data() {
	    return {
	      timeline: {},
	      groupedTimeline: {},
	      activeTab: [],
	      tabs: {},
	      enabledTabs: []
	
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.items.forEach(function (item, index) {
	      item.case = _this.getDescription(item);
	    });
	    var groupedTimeline = (0, _collect2.default)(this.items).groupBy('user');
	
	    groupedTimeline.each(function (item, k) {
	      _this.tabs[k] = true;
	    });
	    this.updateTimeLine();
	  },
	
	  methods: {
	    toggle: function toggle(tab) {
	      var t = this.tabs;
	      t[tab] = !t[tab];
	      this.tabs = (0, _assign2.default)({}, t);
	      this.updateTimeLine();
	    },
	    updateTimeLine: function updateTimeLine() {
	      var _this2 = this;
	
	      var filtered = this.items.filter(function (item) {
	        return _this2.tabs[item.user];
	      });
	
	      this.timeline = (0, _collect2.default)(filtered).groupBy(function (i) {
	        return _this2.$date(i.created_at).format('DD MMM YYYY');
	      }).all();
	    },
	    getTabIcon: function getTabIcon(key) {
	      var cssClass = ['fa', 'fa-user'];
	
	      switch (key) {
	        case 'sentinel':
	          cssClass = ['fa', 'fa-exclamation-triangle'];
	          break;
	        case 'hardware':
	          cssClass = ['fa', 'fa-microchip'];
	          break;
	        case 'System:0':
	          cssClass = ['fa', 'fa-cog'];
	          break;
	      }
	
	      return cssClass;
	    },
	    getCount: function getCount(key) {
	      return (0, _collect2.default)(this.items).groupBy('user').all()[key].length;
	    },
	    getDescription: function getDescription(item) {
	      switch (item.case) {
	        case 'reservation-immediate-send':
	          return 'Reservation triggered immediate send';
	
	        case 'reservation-created':
	          return '<div>Reservation <strong>created</strong></div><div>Start: ' + this.$dateFormat(item.start, this.$toMomentFormat(this.$configurationDateTimeFormat())) + ' - End: ' + this.$dateFormat(item.end, this.$toMomentFormat(this.$configurationDateTimeFormat())) + '</div>';
	
	        case 'send-to-vehicle':
	          return 'Reservation has been sent to the vehicle';
	
	        case 'reservation-sent':
	          return 'Vehicle has received command';
	
	        case 'convadis-start-received':
	          return 'Vehicle has received command';
	
	        case 'reservation-edited':
	          return '<div>Reservation <strong>edited</strong></div><div>Start: ' + this.$dateFormat(item.start, this.$toMomentFormat(this.$configurationDateTimeFormat())) + ' - End: ' + this.$dateFormat(item.end, this.$toMomentFormat(this.$configurationDateTimeFormat())) + '</div>';
	
	        case 'reservation-immediate-send-edit':
	          return 'Reservation triggered immediate send edit';
	
	        case 'action-teminate-sent':
	          return 'Customer has terminated the reservation';
	
	        case 'reservation-completed':
	          return 'Reservation end has been sent to the vehicle';
	
	        case 'reservation-unable-to-set-completed-from-COMPLETED':
	          return 'Vehicle has received end signal';
	
	        case 'reservation-charged':
	          return 'Reservation Charged';
	
	        case 'send-edit-to-vehicle':
	          return 'Edited reservation received';
	
	        case 'action-close-car-sent':
	          return 'Customer has logged out';
	
	        case 'action-open-car-sent':
	          return 'Customer has sent pin for open';
	
	        case 'reservation-started':
	          return 'Reservation status has changed to: <strong>STARTED</strong>';
	
	        case 'reservation-unable-to-set-started-from-STARTED':
	          return 'Customer has logged out';
	
	        case 'reservation-confirmed':
	          return 'Reservation status has changed to: <strong>CONFIRMED</strong>';
	        default:
	          if (item.case.startsWith('SENTINEL')) {
	            item.user = 'sentinel';
	          }
	          if (item.case.startsWith('SENT VH')) {
	            item.case = item.user + ' ' + item.case;
	            item.user = 'hardware';
	          }
	          if (item.case.includes('App\\Exceptions')) {
	            item.user = 'hardware';
	            item.case = '<span class="danger">' + item.case + '</span>';
	          }
	          return item.case;
	      }
	    }
	  },
	  computed: {},
	  props: ['items']
	};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Card = __webpack_require__(140);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ReservationActionButtons = __webpack_require__(101);
	
	var _ReservationActionButtons2 = _interopRequireDefault(_ReservationActionButtons);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _Tab = __webpack_require__(201);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Card3 = __webpack_require__(77);
	
	var _Card4 = _interopRequireDefault(_Card3);
	
	var _Card5 = __webpack_require__(118);
	
	var _Card6 = _interopRequireDefault(_Card5);
	
	var _ReservationFields = __webpack_require__(219);
	
	var _ReservationFields2 = _interopRequireDefault(_ReservationFields);
	
	var _Card7 = __webpack_require__(198);
	
	var _Card8 = _interopRequireDefault(_Card7);
	
	var _Card9 = __webpack_require__(139);
	
	var _Card10 = _interopRequireDefault(_Card9);
	
	var _PlanReservationRateActionButtons = __webpack_require__(570);
	
	var _PlanReservationRateActionButtons2 = _interopRequireDefault(_PlanReservationRateActionButtons);
	
	var _Card11 = __webpack_require__(76);
	
	var _Card12 = _interopRequireDefault(_Card11);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficeReservationRate",
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  components: {
	    Card3: _Card12.default,
	    PlanReservationRateActionButtons: _PlanReservationRateActionButtons2.default,
	    Card7: _Card10.default,
	    Card8: _Card8.default,
	    ReservationFields: _ReservationFields2.default,
	    Card5: _Card6.default,
	    Card4: _Card4.default,
	    DatePicker: _DatePicker2.default,
	    Dropdown: _Dropdown2.default,
	    Card9: _Card2.default,
	    ReservationActionButtons: _ReservationActionButtons2.default,
	    Driver: _Driver2.default,
	    Vehicle: _Vehicle2.default
	  },
	  data: function data() {
	    return {
	      endTime: null
	    };
	  },
	  mounted: function mounted() {
	    this.endTime = null;
	  },
	  destroyed: function destroyed() {},
	
	  methods: {
	    withVat: function withVat(price) {
	      return price;
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  })
	};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Role',
	  components: { Dropdown: _Dropdown2.default },
	  props: ['item']
	};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _VehicleAvailability = __webpack_require__(137);
	
	var _VehicleAvailability2 = _interopRequireDefault(_VehicleAvailability);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SearchVehicleAvailability',
	  components: {
	    DatePicker: _DatePicker2.default,
	    BackofficeVehicleAvailability: _VehicleAvailability2.default
	  },
	  data: function data() {
	    return {
	      availability: [],
	      start: null,
	      end: null
	    };
	  },
	  created: function created() {
	    this.start = this.$date().minutes(0).seconds(0);
	    this.end = this.$date().add(2, 'days').minutes(0).seconds(0);
	    this.getAvailability();
	  },
	
	  methods: {
	    slotSelected: function slotSelected(obj) {
	      this.$emit('slotsSelected', obj);
	    },
	    search: function search() {
	      this.start = this.$date(this.start);
	      this.end = this.$date(this.end);
	      this.getAvailability();
	    },
	    getAvailability: function getAvailability() {
	      var _this = this;
	
	      _backoffice2.default.vehicles.select(this.vehicle, {
	        start: this.start.unix(),
	        end: this.end.unix()
	      }).availability(function (data) {
	        data.forEach(function (a) {
	          (0, _assign2.default)(a, { selected: false });
	        });
	        _this.availability = data;
	      });
	    },
	    showExtraDay: function showExtraDay() {
	      this.end = this.$date(this.end).add(1, 'days').hours(23).minutes(30).seconds(0);
	      this.getAvailability();
	    }
	  },
	  computed: {},
	  props: ['vehicle', 'selectable']
	};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _FederationButtons = __webpack_require__(145);
	
	var _FederationButtons2 = _interopRequireDefault(_FederationButtons);
	
	var _CouponButtons = __webpack_require__(210);
	
	var _CouponButtons2 = _interopRequireDefault(_CouponButtons);
	
	var _SegmentButtons = __webpack_require__(2054);
	
	var _SegmentButtons2 = _interopRequireDefault(_SegmentButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SegmentRate',
	  components: { SegmentButtons: _SegmentButtons2.default, CouponButtons: _CouponButtons2.default, FederationButtons: _FederationButtons2.default, Dropdown: _Dropdown2.default, CardN: _CardN2.default },
	  props: ['item', 'type']
	};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Sentinel',
	  components: {},
	  computed: (0, _extends3.default)({
	    severity: function severity() {
	      switch (this.item.severity) {
	        case 0:
	          return 'MAINTENANCE';
	        case 1:
	          return 'INFO';
	        case 2:
	          return 'MANAGEMENT';
	        case '3':
	          return 'DEFCON';
	
	        default:
	          return this.item.severity;
	      }
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: ['item', 'type']
	};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Accordion = __webpack_require__(78);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _Card = __webpack_require__(139);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SubscriptionActionButtons = __webpack_require__(572);
	
	var _SubscriptionActionButtons2 = _interopRequireDefault(_SubscriptionActionButtons);
	
	var _Card3 = __webpack_require__(118);
	
	var _Card4 = _interopRequireDefault(_Card3);
	
	var _Card5 = __webpack_require__(555);
	
	var _Card6 = _interopRequireDefault(_Card5);
	
	var _Plan = __webpack_require__(539);
	
	var _Plan2 = _interopRequireDefault(_Plan);
	
	var _DriverSubscriptionSlots = __webpack_require__(2024);
	
	var _DriverSubscriptionSlots2 = _interopRequireDefault(_DriverSubscriptionSlots);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SubscriptionEdit = __webpack_require__(546);
	
	var _SubscriptionEdit2 = _interopRequireDefault(_SubscriptionEdit);
	
	var _SubscriptionFields = __webpack_require__(2086);
	
	var _SubscriptionFields2 = _interopRequireDefault(_SubscriptionFields);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficeSubscription",
	  components: {
	    SubscriptionFields: _SubscriptionFields2.default,
	    DriverSubscriptionSlots: _DriverSubscriptionSlots2.default,
	    Plan: _Plan2.default,
	    Card6: _Card6.default,
	    Card5: _Card4.default,
	    SubscriptionActionButtons: _SubscriptionActionButtons2.default,
	    Dropdown: _Dropdown2.default,
	    Card7: _Card2.default,
	    Driver: _Driver2.default,
	    Accordion: _Accordion2.default
	  },
	  data: function data() {
	    return {
	      shrink: [{ n5: true }]
	    };
	  },
	
	  methods: {
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _SubscriptionEdit2.default,
	        props: {
	          item: this.item
	        }
	      });
	    }
	  },
	  computed: (0, _extends3.default)({
	    expired: function expired() {
	      if (this.item.start === null || this.item.end === null) {
	        return true;
	      }
	      var end = (0, _moment2.default)(this.item.end);
	      var today = (0, _moment2.default)();
	      return this.item.start && this.item.end && today.isAfter(end);
	    },
	    daysToExpiry: function daysToExpiry() {
	      return this.$diffInDays(this.item.end, new Date());
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  }),
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ""
	    }
	  }
	};

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _vuex = __webpack_require__(10);
	
	var _TocButtons = __webpack_require__(70);
	
	var _TocButtons2 = _interopRequireDefault(_TocButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Toc",
	  components: {
	    TocButtons: _TocButtons2.default,
	    VehicleNoteButtons: _VehicleNoteButtons2.default,
	    VehicleCostButtons: _VehicleCostButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _vuex = __webpack_require__(10);
	
	var _TocButtons = __webpack_require__(70);
	
	var _TocButtons2 = _interopRequireDefault(_TocButtons);
	
	var _TocTypeButtons = __webpack_require__(102);
	
	var _TocTypeButtons2 = _interopRequireDefault(_TocTypeButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TocType',
	  components: {
	    TocTypeButtons: _TocTypeButtons2.default,
	    TocButtons: _TocButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'TopUp',
	    props: ['item']
	};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _StatisticsCard = __webpack_require__(143);
	
	var _StatisticsCard2 = _interopRequireDefault(_StatisticsCard);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _TransactionButtons = __webpack_require__(147);
	
	var _TransactionButtons2 = _interopRequireDefault(_TransactionButtons);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _gatewayUrlHelper = __webpack_require__(239);
	
	var _gatewayUrlHelper2 = _interopRequireDefault(_gatewayUrlHelper);
	
	var _StatisticsCard3 = __webpack_require__(2028);
	
	var _StatisticsCard4 = _interopRequireDefault(_StatisticsCard3);
	
	var _StatisticsCard5 = __webpack_require__(560);
	
	var _StatisticsCard6 = _interopRequireDefault(_StatisticsCard5);
	
	var _TransactionFields = __webpack_require__(2087);
	
	var _TransactionFields2 = _interopRequireDefault(_TransactionFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Transaction",
	  components: {
	    TransactionFields: _TransactionFields2.default,
	    StatisticsCard7: _StatisticsCard6.default,
	    StatisticsCard6: _StatisticsCard4.default,
	    Dropdown: _Dropdown2.default,
	    TransactionActionButtons: _TransactionButtons2.default,
	    CardN: _CardN2.default,
	    StatisticsCard5: _StatisticsCard2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    viewOnGateway: function viewOnGateway() {
	      var url = _gatewayUrlHelper2.default.transactionUrl(this.item.payment_method_provider, this.item.transaction_uid);
	      window.open(url, '_blank');
	    }
	  },
	  computed: {
	    getResponse: function getResponse() {
	      return (0, _stringify2.default)(this.item.response.raw).startsWith("{", 0) ? this.item.response.raw : { "message": this.item.response.raw };
	    }
	  },
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TranslationButtons = __webpack_require__(214);
	
	var _TranslationButtons2 = _interopRequireDefault(_TranslationButtons);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Translation',
	  components: { Dropdown: _Dropdown2.default, TranslationButtons: _TranslationButtons2.default },
	  props: ['item']
	};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Status = __webpack_require__(69);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _UserButtons = __webpack_require__(2058);
	
	var _UserButtons2 = _interopRequireDefault(_UserButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'User',
	  components: { UserButtons: _UserButtons2.default, Status: _Status2.default, Dropdown: _Dropdown2.default, CardN: _CardN2.default },
	  props: ['item', 'type']
	};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _VehicleNoteButtons = __webpack_require__(60);
	
	var _VehicleNoteButtons2 = _interopRequireDefault(_VehicleNoteButtons);
	
	var _vuex = __webpack_require__(10);
	
	var _TocButtons = __webpack_require__(70);
	
	var _TocButtons2 = _interopRequireDefault(_TocButtons);
	
	var _TocTypeButtons = __webpack_require__(102);
	
	var _TocTypeButtons2 = _interopRequireDefault(_TocTypeButtons);
	
	var _ClientTypeButtons = __webpack_require__(562);
	
	var _ClientTypeButtons2 = _interopRequireDefault(_ClientTypeButtons);
	
	var _VatButtons = __webpack_require__(2060);
	
	var _VatButtons2 = _interopRequireDefault(_VatButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Vat',
	  components: {
	    VatButtons: _VatButtons2.default,
	    ClientTypeButtons: _ClientTypeButtons2.default,
	    TocTypeButtons: _TocTypeButtons2.default,
	    TocButtons: _TocButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'VatAmountToggler',
	  watch: {
	    vat: function vat() {
	
	      this.$emit('input', this.vatAmount);
	    },
	    tax: function tax() {
	      this.$emit('input', this.vatAmount);
	    }
	  },
	  data: function data() {
	    return {
	      vat: false,
	      amount: 0
	    };
	  },
	  created: function created() {
	    this.amount = this.value;
	  },
	
	  methods: {
	    setAmount: function setAmount() {
	      this.$emit('input', this.vatAmount);
	    }
	  },
	  computed: {
	    recordAmount: function recordAmount() {
	      if (this.vat === false) {
	        var tax = this.tax !== '' || this.tax === 0 ? this.tax : null;
	        return this.$priceWithVat(this.amount, tax);
	      }
	      return this.amount;
	    },
	    vatAmount: function vatAmount() {
	      return this.$vatPart(this.recordAmount, parseFloat(this.tax));
	    }
	  },
	  props: {
	    label: {
	      type: String,
	      required: true
	    },
	    value: {
	      required: true
	    },
	    tax: {}
	  }
	};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleStatus = __webpack_require__(208);
	
	var _VehicleStatus2 = _interopRequireDefault(_VehicleStatus);
	
	var _VehicleAdditionalStatus = __webpack_require__(207);
	
	var _VehicleAdditionalStatus2 = _interopRequireDefault(_VehicleAdditionalStatus);
	
	var _VehicleSlotButtons = __webpack_require__(44);
	
	var _VehicleSlotButtons2 = _interopRequireDefault(_VehicleSlotButtons);
	
	var _VehicleHardware = __webpack_require__(191);
	
	var _VehicleHardware2 = _interopRequireDefault(_VehicleHardware);
	
	var _VehicleFields = __webpack_require__(220);
	
	var _VehicleFields2 = _interopRequireDefault(_VehicleFields);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CreateVehicleSlot = __webpack_require__(573);
	
	var _CreateVehicleSlot2 = _interopRequireDefault(_CreateVehicleSlot);
	
	var _ParkingLot = __webpack_require__(537);
	
	var _ParkingLot2 = _interopRequireDefault(_ParkingLot);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Vehicle',
	  components: {
	    VehicleAdditionalStatus: _VehicleAdditionalStatus2.default,
	    ParkingLot: _ParkingLot2.default,
	    CreateVehicleSlot: _CreateVehicleSlot2.default,
	    ModalReveal: _ModalReveal2.default,
	    CardN: _CardN2.default,
	    VehicleFields: _VehicleFields2.default,
	    VehicleHardware: _VehicleHardware2.default,
	    VehicleSlotButtons: _VehicleSlotButtons2.default,
	    VehicleStatus: _VehicleStatus2.default,
	    VehicleAditionalStatus: _VehicleAdditionalStatus2.default,
	    Dropdown: _Dropdown2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }))
	};

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _InstructionButtons = __webpack_require__(568);
	
	var _InstructionButtons2 = _interopRequireDefault(_InstructionButtons);
	
	var _VehicleAttributeButtons = __webpack_require__(2061);
	
	var _VehicleAttributeButtons2 = _interopRequireDefault(_VehicleAttributeButtons);
	
	var _MdiIcon = __webpack_require__(80);
	
	var _MdiIcon2 = _interopRequireDefault(_MdiIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Instruction",
	  components: {
	    MdiIcon: _MdiIcon2.default,
	    VehicleAttributeButtons: _VehicleAttributeButtons2.default,
	    InstructionButtons: _InstructionButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tooltip = __webpack_require__(79);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _ToggleableButton = __webpack_require__(206);
	
	var _ToggleableButton2 = _interopRequireDefault(_ToggleableButton);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeVehicleAvailability',
	  data: function data() {
	    return {
	      selectionStart: -1,
	      selectionEnd: -1,
	      rows: 1
	    };
	  },
	
	  components: {
	    ToggleableButton: _ToggleableButton2.default,
	    Tooltip: _Tooltip2.default
	  },
	  props: {
	    type: {
	      type: String,
	      default: ''
	    },
	    availability: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectable: {
	      type: Boolean,
	      default: true
	    },
	    extend: {
	      type: Boolean,
	      default: false
	    }
	  },
	  created: function created() {},
	
	  methods: {
	    loadMore: function loadMore() {
	      this.resetSelection();
	      this.$emit('loadExtra');
	      this.rows++;
	    },
	    fakeSelection: function fakeSelection(index) {
	      if (this.selectionStart >= 0 && this.selectionEnd >= 0) {
	        return index <= this.selectionEnd && index > this.selectionStart - 1;
	      }
	    },
	    setSelections: function setSelections() {
	
	      this.selectionStart = this.availability.findIndex(function (timeslot) {
	        return timeslot.selected;
	      });
	
	      var reverse = this.availability.reduce(function (arr, el) {
	        arr.unshift(el);
	        return arr;
	      }, []);
	
	      this.selectionEnd = this.selectionStart >= 0 ? Math.abs(reverse.findIndex(function (timeslot) {
	        return timeslot.selected;
	      }) - reverse.length + 1) : -1;
	      this.$emit('rangeSelection', this.selectedSlots);
	      return this.selectionStart !== -1 && this.selectionEnd !== -1;
	    },
	    checkIndex: function checkIndex() {
	
	      if (!this.selectable) {
	        return;
	      }
	      var thereAreSelections = this.setSelections();
	
	      if (this.extend && thereAreSelections) {
	        this.selectionStart = 0;
	      }
	
	      if (this.selectionStart + this.selectionEnd !== -2) {
	
	        if (this.selectionStart !== this.selectionEnd) {
	          this.toggleSelection(this.selectionStart);
	          this.toggleSelection(this.selectionEnd);
	        }
	      }
	      if (this.selectionCrossesUnavailable == true) {
	        this.resetSelection();
	      }
	    },
	    toggleSelection: function toggleSelection(index) {
	      if (this.availability && index < this.availability.length && index >= 0) this.availability[index].selected = false;
	    },
	    resetSelection: function resetSelection() {
	      this.toggleSelection(this.selectionStart);
	      this.toggleSelection(this.selectionEnd);
	      this.setSelections();
	    },
	    formatUnix: function formatUnix(t) {
	      return _moment2.default.unix(t).format('HH:mm');
	    },
	    timeBreak: function timeBreak(t) {
	      return _moment2.default.unix(t).calendar(undefined, {
	        lastDay: '[Yesterday]',
	        sameDay: '[Today]',
	        nextDay: '[Tomorrow]',
	        lastWeek: '[last] dddd',
	        nextWeek: 'dddd',
	        sameElse: 'L'
	      });
	    },
	    isStartOfDay: function isStartOfDay(t) {
	      return t === _moment2.default.unix(t).startOf('day').unix();
	    }
	  },
	  computed: {
	    selectionCrossesUnavailable: function selectionCrossesUnavailable() {
	      for (var i = this.selectionStart; i < this.selectionEnd; i++) {
	        if (this.availability[i].available === false) {
	          return true;
	        }
	      }
	      return false;
	    },
	    selectedSlots: function selectedSlots() {
	      return {
	        start: this.selectionStart >= 0 ? this.availability[this.selectionStart].start_timestamp : null,
	        end: this.selectionEnd >= 0 ? this.availability[this.selectionEnd].end_timestamp : null
	      };
	    },
	    selectionValid: function selectionValid() {
	      var notEqual = this.selectionStart !== this.selectionEnd || this.extend;
	      var notStartSelection = this.selectionStart + this.selectionEnd !== -2;
	      return notEqual && notStartSelection && !this.selectionCrossesUnavailable;
	    },
	    showRows: function showRows() {
	      return {};
	    }
	  }
	};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _VehicleCostButtons = __webpack_require__(55);
	
	var _VehicleCostButtons2 = _interopRequireDefault(_VehicleCostButtons);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleCost",
	  components: {
	    VehicleCostButtons: _VehicleCostButtons2.default,
	    Dropdown: _Dropdown2.default,
	    CardN: _CardN2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  }),
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'VehicleDamage',
	  components: {},
	  data: function data() {
	    return {
	      pins: [],
	      rendered: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.render();
	    setTimeout(function () {
	      _this.render();
	      _this.rendered = true;
	    }, 500);
	  },
	
	  methods: {
	    render: function render() {
	      var _this2 = this;
	
	      var container = $('.car-outline');
	      this.items.forEach(function (item, key) {
	        _this2.pins.splice(key, 1, {
	          id: item.id ? item.id : null,
	          containerWidth: item.containerWidth,
	          containerHeight: item.containerHeight,
	          left: item.left * container.width() / item.containerWidth,
	          top: item.top * container.height() / item.containerHeight
	        });
	      });
	    },
	    addPin: function addPin(e) {
	      if (!this.editable) {
	        return;
	      }
	      var pin = {
	        containerWidth: this.container.width,
	        containerHeight: this.container.height,
	        left: e.offsetX - 25,
	        top: e.offsetY - 25
	      };
	      this.pins.push(pin);
	      this.$emit('damagesUpdated', this.pins);
	    },
	    removePin: function removePin(component) {
	      var _this3 = this;
	
	      if (!this.editable) {
	        return;
	      }
	      this.pins.forEach(function (item, key) {
	        if (component.left === item.left && component.top === item.top) {
	          _this3.pins.splice(key, 1);
	          _this3.$emit('damagesUpdated', _this3.pins);
	        }
	      });
	    }
	  },
	  computed: {
	    container: function container() {
	      var dmg = $('.car-outline');
	
	      return {
	        containerClass: dmg.attr('class'),
	        width: dmg.width(),
	        height: dmg.height()
	      };
	    },
	    pin: function pin() {
	      return $('.component-pin');
	    },
	    vehicleOutline: function vehicleOutline() {
	      return this.vehicleType === 'Car' ? '/static/car_outline.png' : '/static/bike_outline.jpg';
	    }
	  },
	  props: {
	    items: {
	      required: true,
	      type: Array
	    },
	    editable: {
	      default: false
	    },
	    vehicleType: {
	      required: true
	    },
	    vehicleDamagePicture: {
	      required: true
	    }
	  }
	};

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'VehicleDamageDetail',
	  components: {},
	  data: function data() {
	    return {
	      pins: [],
	      rendered: false
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    render: function render() {
	      var _this = this;
	
	      var container = this.$refs.damageContainer;
	      this.items.forEach(function (item, key) {
	        _this.pins.splice(key, 1, {
	          id: item.id ? item.id : null,
	          uid: item.uid ? item.uid : null,
	          containerWidth: item.containerWidth,
	          containerHeight: item.containerHeight,
	          left: item.left * container.clientWidth / item.containerWidth,
	          top: item.top * container.clientHeight / item.containerHeight,
	          expanded: false,
	          hover: false,
	          description: item.description ? item.description : null,
	          status: item.status ? item.status : null,
	          created_at: item.created_at ? item.created_at : null
	        });
	      });
	    },
	    resetHover: function resetHover() {
	      this.pins.forEach(function (item) {
	        item.hover = false;
	      });
	    },
	    selectHovered: function selectHovered(pin) {
	      this.pins.filter(function (item) {
	        return pin.id === item.id;
	      }).forEach(function (item) {
	        item.hover = true;
	      });
	    }
	  },
	  computed: {},
	  props: {
	    items: {
	      required: true,
	      type: Array
	    },
	
	    vehicleDamagePicture: {
	      required: true
	    }
	  }
	};

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Card = __webpack_require__(76);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _VehicleHardwareActionButtons = __webpack_require__(2062);
	
	var _VehicleHardwareActionButtons2 = _interopRequireDefault(_VehicleHardwareActionButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleHardware",
	  components: {
	    VehicleHardwareActionButtons: _VehicleHardwareActionButtons2.default,
	    Card3: _Card2.default,
	    Dropdown: _Dropdown2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    update: function update() {
	      this.$emit('update');
	    }
	  },
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  filters: {
	    manager: function manager(value) {
	      return value.replace(/App\\Logic\\VehicleHardware\\/, '');
	    }
	  }
	};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Accordion = __webpack_require__(78);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _InlineEditableField = __webpack_require__(205);
	
	var _InlineEditableField2 = _interopRequireDefault(_InlineEditableField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficeVehicleSlot",
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  components: {
	    InlineEditableField: _InlineEditableField2.default,
	    Accordion: _Accordion2.default
	  },
	  created: function created() {},
	
	  methods: {
	    update: function update() {
	      this.$emit("updated", this.item);
	    },
	    enable: function enable() {
	      var _this = this;
	
	      _backoffice2.default.vehicleSlots.select(this.item).enable(function (response) {
	        _this.update();
	        _maggieHelper2.default.notification('enable-esit', "vehicle slot enabled");
	      });
	    },
	    disable: function disable() {
	      var _this2 = this;
	
	      _backoffice2.default.vehicleSlots.select(this.item).disable(function (response) {
	        _this2.update();
	        _maggieHelper2.default.notification('disable-esit', "vehicle slot disabled");
	      });
	    },
	    edit: function edit(edited) {}
	  }
	};

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "BackofficeWallet",
	    props: {
	        item: Object,
	        type: {
	            type: String,
	            default: ''
	        }
	    },
	    created: function created() {},
	
	    components: {},
	    methods: {}
	};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'WalletAddCost',
	    components: { ActionButton: _ActionButton2.default },
	    data: function data() {
	        return {
	            body: {
	                amount: 0,
	                reason: null,
	                tax: null
	            },
	            vat: false,
	            credit: false
	        };
	    },
	    created: function created() {},
	
	    methods: {
	        submit: function submit() {
	            var _this = this;
	
	            if (this.body.reason == null || this.body.reason == '') {
	                _maggieHelper2.default.notification('Reason', 'Please insert a valid reason');
	                return;
	            }
	
	            if (this.vat) {
	                this.body.amount = this.$priceWithoutVat(this.body.amount);
	            }
	
	            if (this.credit) {
	                this.body.amount = -this.body.amount;
	            }
	
	            return _backoffice2.default.wallets.make(this.body).manualRecord(this.wallet.id, function () {
	                _maggieHelper2.default.notification('manual-record', 'Record added successfully');
	                _this.body.amount = 0;
	                _this.body.reason = null;
	                _this.$emit('costAdded');
	            });
	        },
	
	        isNumber: function isNumber(evt) {
	            evt = evt ? evt : window.event;
	            var charCode = evt.which ? evt.which : evt.keyCode;
	            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
	                evt.preventDefault();
	            } else {
	                return true;
	            }
	        }
	    },
	    props: ['wallet'],
	    computed: (0, _extends3.default)({
	        recordAmount: function recordAmount() {
	            if (!this.vat) {
	                return this.$priceWithVat(this.body.amount, this.body.tax);
	            }
	
	            return this.body.amount;
	        }
	    }, (0, _vuex.mapState)({
	        vats: function vats(state) {
	            return state.configuration.vats;
	        },
	        commonCostTypes: function commonCostTypes(state) {
	            return state.configuration.commonCostTypes;
	        }
	    }))
	};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Tab = __webpack_require__(201);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _WalletRecordFields = __webpack_require__(2088);
	
	var _WalletRecordFields2 = _interopRequireDefault(_WalletRecordFields);
	
	var _Accordion = __webpack_require__(78);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'BackofficeWalletRecord',
	    props: {
	        item: Object,
	        type: {
	            type: String,
	            default: ''
	        }
	    },
	    created: function created() {},
	
	    components: {
	        CardN: _CardN2.default,
	        Accordion: _Accordion2.default,
	        WalletRecordFields: _WalletRecordFields2.default,
	        Card7: _Tab2.default
	    },
	    methods: {
	        cleanString: function cleanString(string, char) {
	            var r = new RegExp('' + char, 'gi');
	            return string.replace(r, "");
	        }
	    },
	    computed: (0, _extends3.default)({
	        lines: function lines() {
	            return this.item.reason.split('|');
	        },
	        walletableType: function walletableType() {
	            return this.item.walletable_type.replace(/App\\Models\\/, '');
	        }
	    }, (0, _vuex.mapState)({
	        configuration: function configuration(state) {
	            return state.configuration;
	        }
	    }), {
	        vat: function vat() {
	            return this.item.amount * -1 * this.item.tax;
	        },
	        commercialDocumentType: function commercialDocumentType() {
	            switch (this.item.invoice.type) {
	                case 'INVOICE':
	                    return 'INV';
	                case 'CREDIT NOTE':
	                    return 'CRN';
	                case 'PROFORMA':
	                    return 'PRO';
	            }
	        }
	    }),
	    filters: {
	        walletableType: function walletableType(value) {
	            return value.replace(/App\\Models\\/, '');
	        }
	    }
	};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Client = __webpack_require__(53);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _InvoiceFields = __webpack_require__(580);
	
	var _InvoiceFields2 = _interopRequireDefault(_InvoiceFields);
	
	var _WalletRecord = __webpack_require__(85);
	
	var _WalletRecord2 = _interopRequireDefault(_WalletRecord);
	
	var _BilledRecords = __webpack_require__(528);
	
	var _BilledRecords2 = _interopRequireDefault(_BilledRecords);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficeWalletUninvoiced",
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      detail: false
	    };
	  },
	  created: function created() {},
	
	  components: {
	    ActionButton: _ActionButton2.default,
	    BilledRecords: _BilledRecords2.default,
	    BackofficeWalletRecord: _WalletRecord2.default,
	    InvoiceFields: _InvoiceFields2.default,
	    BackofficeClient: _Client2.default
	  },
	  methods: {
	    cleanString: function cleanString(string, char) {
	      var r = new RegExp("" + char, 'gi');
	      return string.replace(r, "");
	    },
	    billWallet: function billWallet() {
	      var _this = this;
	
	      return _backoffice2.default.wallets.select(this.item.wallet_id).billWallet(function () {
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	  filters: {
	    walletableType: function walletableType(value) {
	      return value.replace(/App\\Models\\/, '');
	    }
	  }
	};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ZoneConfigButtons = __webpack_require__(2064);
	
	var _ZoneConfigButtons2 = _interopRequireDefault(_ZoneConfigButtons);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ZoneCost',
	  components: { Dropdown: _Dropdown2.default, ZoneConfigButtons: _ZoneConfigButtons2.default },
	  props: ['item']
	};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ValidationConfig = __webpack_require__(192);
	
	var _ValidationConfig2 = _interopRequireDefault(_ValidationConfig);
	
	var _DeleteConf = __webpack_require__(67);
	
	var _DeleteConf2 = _interopRequireDefault(_DeleteConf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientCustomFieldsConfiguration',
	  components: { DeleteConf: _DeleteConf2.default, ValidationConfig: _ValidationConfig2.default },
	  props: ['value']
	};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(94);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _slicedToArray2 = __webpack_require__(243);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _SelectizeClientType = __webpack_require__(90);
	
	var _SelectizeClientType2 = _interopRequireDefault(_SelectizeClientType);
	
	var _DeleteConf = __webpack_require__(67);
	
	var _DeleteConf2 = _interopRequireDefault(_DeleteConf);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _ArrayEdit = __webpack_require__(88);
	
	var _ArrayEdit2 = _interopRequireDefault(_ArrayEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreditBonusConfiguration',
	  components: { ArrayEdit: _ArrayEdit2.default, Editor: _Editor2.default, ModalReveal: _ModalReveal2.default, DeleteConf: _DeleteConf2.default, SelectizeClientType: _SelectizeClientType2.default },
	  data: function data() {
	    return {
	      config: {},
	      slot: "footer",
	      fields: [{
	        "Address": [{
	          "address_city": "City",
	          "address_postal_code": "Postal code",
	          "address_country": "Country",
	          "address_street": "Street",
	          "address_region": "Region"
	        }],
	        "Client": [{
	          "email": "Email",
	          "fiscal_code": "Fiscal code",
	          "plan_id": "Plan",
	          "date_account_after": "Subscribed after date",
	          "driver_age": "Age range (xx-xx)",
	          "document_type_id": "A valid document of given type"
	        }],
	        "Actions": [{
	          "action": "book"
	        }],
	        "Bonus": [{
	          "max_uses": "Times that a bonus can be activated",
	          "max_client_uses": "Times that a client can receive this bonus",
	          "only_with": "Only with another bonus slug",
	          "not_with": "Not with another bonus slug",
	          "max_amount": "Max amount",
	          "gateway_reason": "Gateway reason",
	          "current_count": "Current count of given bonuses"
	        }]
	      }]
	    };
	  },
	  mounted: function mounted() {
	    if (this.item.name === null) {
	      var cazzo = this.$refs;
	      this.$refs.bonusModal.openModal();
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.item.config !== null) {
	      var config = this.item.config.split('|');
	      config.forEach(function (item) {
	        var _item$split = item.split(':'),
	            _item$split2 = (0, _slicedToArray3.default)(_item$split, 2),
	            key = _item$split2[0],
	            value = _item$split2[1];
	
	        _this.config[key] = value;
	      });
	    }
	  },
	
	  methods: {
	    load: function load() {},
	    update: function update() {
	      if (this.item == null) {
	        return;
	      }
	      this.item.config = (0, _entries2.default)(this.config).map(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            key = _ref2[0],
	            value = _ref2[1];
	
	        return key + ':' + value;
	      }).join('|');
	
	      this.$emit('update');
	    }
	  },
	  computed: {
	    configuration: function configuration() {
	      var jsonObject = {};
	      console.log(this.item);
	      if (this.item == null) {
	        return {};
	      }
	      var config = this.item.config.split('|');
	      config.forEach(function (item) {
	        var _item$split3 = item.split(':'),
	            _item$split4 = (0, _slicedToArray3.default)(_item$split3, 2),
	            key = _item$split4[0],
	            value = _item$split4[1];
	
	        jsonObject[key] = value;
	      });
	
	      return jsonObject;
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SelectizeClientType = __webpack_require__(90);
	
	var _SelectizeClientType2 = _interopRequireDefault(_SelectizeClientType);
	
	var _DeleteConf = __webpack_require__(67);
	
	var _DeleteConf2 = _interopRequireDefault(_DeleteConf);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _ArrayEdit = __webpack_require__(88);
	
	var _ArrayEdit2 = _interopRequireDefault(_ArrayEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreditBonusInformation',
	  components: { ArrayEdit: _ArrayEdit2.default, Editor: _Editor2.default, ModalReveal: _ModalReveal2.default, DeleteConf: _DeleteConf2.default, SelectizeClientType: _SelectizeClientType2.default },
	  data: function data() {
	    return {
	      info: null,
	      slot: "footer"
	
	    };
	  },
	  mounted: function mounted() {},
	  created: function created() {},
	
	  methods: {
	    load: function load() {
	      var _this = this;
	
	      if (this.item.amount == null) {
	        return;
	      }
	      var slugify = function slugify(str) {
	        return str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '_').replace(/^-+|-+$/g, '');
	      };
	      _backoffice2.default.promotionalOffering.select(slugify(this.item.name)).get(function (data) {
	        _this.info = data;
	      });
	
	      this.$emit('update');
	    }
	  },
	  computed: {
	    checkConfig: function checkConfig() {
	      if (this.item.config == null) {
	        return {};
	      }
	      return this.item.config.split('|').filter(function (item) {
	        return item === 'action:book';
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DeleteConf',
	  methods: {
	    deleteConf: function deleteConf() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'Do you want to delete this configuration?', function () {
	        _this.$emit('click');
	      });
	    }
	  }
	};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SelectizePlan = __webpack_require__(92);
	
	var _SelectizePlan2 = _interopRequireDefault(_SelectizePlan);
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _DeleteConf = __webpack_require__(67);
	
	var _DeleteConf2 = _interopRequireDefault(_DeleteConf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DepositConfiguration',
	  components: { DeleteConf: _DeleteConf2.default, BookingModeSelect: _BookingModeSelect2.default, SelectizeCategory: _SelectizeCategory2.default, SelectizePlan: _SelectizePlan2.default },
	  data: function data() {
	    return {
	      strategies: ['FIXED', 'ESTIMATE', 'TIME']
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    setPlan: function setPlan(val, index) {
	      this.value[index].plan = val.id;
	    },
	    unsetPlan: function unsetPlan(index) {
	      this.value[index].plan = null;
	    },
	    setCategory: function setCategory(val, index) {
	      this.value[index].vehicle_category = val.id;
	    },
	    unsetCategory: function unsetCategory(index) {
	      this.value[index].vehicle_category = null;
	    }
	  },
	  computed: {},
	  props: ['value', 'item']
	};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _DeleteConf = __webpack_require__(67);
	
	var _DeleteConf2 = _interopRequireDefault(_DeleteConf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FleetPositionConfiguration',
	  components: { DeleteConf: _DeleteConf2.default, BookingModeSelect: _BookingModeSelect2.default, SelectizeCategory: _SelectizeCategory2.default },
	  methods: {
	    updateCategory: function updateCategory(val, index) {
	      this.value[index].vehicle_category_id = val.id;
	    }
	  },
	  props: ['value', 'item']
	};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SelectizeClientType = __webpack_require__(90);
	
	var _SelectizeClientType2 = _interopRequireDefault(_SelectizeClientType);
	
	var _DeleteConf = __webpack_require__(67);
	
	var _DeleteConf2 = _interopRequireDefault(_DeleteConf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ItalianEInvoiceSplitPaymentConfiguration',
	  components: { DeleteConf: _DeleteConf2.default, SelectizeClientType: _SelectizeClientType2.default },
	  methods: {
	    setClientType: function setClientType(obj, value) {
	      value.client_type_id = obj.id;
	    }
	  },
	  props: ['value', 'item']
	};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'JsonConf',
	  mounted: function mounted() {
	    this.json = (0, _stringify2.default)(this.value, null, 2);
	  },
	  data: function data() {
	    return {
	      json: ""
	    };
	  },
	
	  methods: {
	    updateValue: function updateValue() {
	      this.$emit('input', this.json);
	    }
	  },
	  props: ['value', 'item']
	};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DeleteConf = __webpack_require__(67);
	
	var _DeleteConf2 = _interopRequireDefault(_DeleteConf);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationSurveyConfiguration',
	  components: { DeleteConf: _DeleteConf2.default },
	  data: function data() {
	    return {
	      reportingTypes: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.selects.reportingTypes(function (data) {
	      _this.reportingTypes = data;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: ['value', 'item']
	
	};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ValidationConfig = __webpack_require__(192);
	
	var _ValidationConfig2 = _interopRequireDefault(_ValidationConfig);
	
	var _DeleteConf = __webpack_require__(67);
	
	var _DeleteConf2 = _interopRequireDefault(_DeleteConf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SystemFieldsConfiguration',
	  components: { DeleteConf: _DeleteConf2.default, ValidationConfig: _ValidationConfig2.default },
	  props: ['value']
	};

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ValidationConfig',
	  data: function data() {
	    return {
	      validations: {
	        string: {
	          active: false,
	          disabled: false
	        },
	        required: {
	          active: false,
	          disabled: false
	        },
	        hidden: {
	          active: false,
	          disabled: false
	        },
	        nullable: {
	          active: false,
	          disabled: false
	        },
	        email: {
	          active: false,
	          disabled: false
	        },
	        default: {
	          active: false,
	          disabled: false,
	          value: null
	        },
	        custom: {
	          active: false,
	          disabled: false,
	          value: null
	        }
	      }
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var arr = [];
	    if (this.value[this.validationKey] !== null && this.value[this.validationKey].length) {
	      this.value[this.validationKey].split('|').forEach(function (item, k) {
	        if (_this.validations.hasOwnProperty(item)) {
	          _this.validations[item].active = true;
	        } else {
	          _this.validations.custom.active = true;
	          arr.push(item);
	        }
	      });
	      this.validations.custom.value = arr.join('|');
	    }
	
	    if (this.value.hasOwnProperty('default') && this.value.default !== null) {
	      this.validations.default.active = true;
	      this.validations.default.value = this.value.default;
	    }
	  },
	
	  watch: {
	    validations: {
	      handler: function handler() {
	
	        var validations = [];
	        for (var item in this.validations) {
	
	          if (this.validations[item].active && item !== 'default' && item !== 'custom') {
	            validations.push(item);
	          }
	
	          if (item === 'default' && this.validations.default.active) {
	            if (this.validations.default.value !== null) {
	              validations.push('default:' + this.validations.default.value);
	            }
	          }
	
	          if (item === 'custom' && this.validations.custom.active && this.validations.custom.value) {
	            validations.push(this.validations.custom.value);
	          }
	        }
	
	        this.$set(this.value, this.validationKey, validations.join('|'));
	      },
	
	      deep: true
	    }
	  },
	  props: {
	    value: {
	      type: Object | Array
	    },
	    valueKey: String,
	    validationKey: String
	  }
	};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TimeRange",
	  components: {},
	  props: ['reservation', 'availability'],
	  data: function data() {
	    return {
	      selectedEndTimestamp: null,
	      debug: {
	        selectedBox: null,
	        selectedEnd: null
	      }
	    };
	  },
	  created: function created() {},
	  mounted: function mounted() {
	
	    var self = this;
	    this.getSlider().draggable({
	      grid: [20, 20],
	      containment: "parent",
	      zIndex: 99,
	      axis: "x",
	      stop: function stop() {
	        self.onEdit();
	      },
	      drag: function drag() {
	        self.onEdit();
	      }
	    });
	
	    this.getSlider().bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () {
	      self.onEdit();
	    });
	  },
	  destroyed: function destroyed() {
	    this.getSlider().draggable("destroy");
	  },
	
	  methods: {
	    getSlider: function getSlider() {
	      return $(this.$el).find(".slider");
	    },
	    onEdit: function onEdit() {
	      var currentSlot = Math.floor(this.getSlider().position().left / 20);
	
	      if (currentSlot != this.debug.selectedBox) {
	        this.debug.selectedBox = currentSlot;
	        this.debug.selectedEnd = this.availability[this.debug.selectedBox].end;
	        this.selectedEndTimestamp = this.availability[this.debug.selectedBox].end_timestamp;
	      }
	    },
	    onClick: function onClick(index) {
	      var value = index * 20;
	      this.getSlider().css('left', value + 'px');
	    },
	    isInReservation: function isInReservation(index) {
	      var item = this.availability[index];
	      var reservation = this.reservation;
	
	      return item.start_timestamp >= this.convertTimestamp(reservation.start) && item.end_timestamp <= this.convertTimestamp(reservation.end) + 60;
	    },
	    formatDate: function formatDate(date) {
	      var i = (0, _moment2.default)(date);
	      return i.format("HH:mm");
	    },
	    handleConfirm: function handleConfirm() {
	      this.$emit('selection', this.debug.selectedEnd);
	    },
	    convertTimestamp: function convertTimestamp(datetime) {
	      var t = datetime.split(/[- :]/);
	      var date = new Date(t[0], t[1] - 1, t[2], t[3], t[4]);
	      return Math.round(date.getTime() / 1000);
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TimeRange = __webpack_require__(1952);
	
	var _TimeRange2 = _interopRequireDefault(_TimeRange);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TimeRangeWrapper',
	  components: { TimeRange: _TimeRange2.default },
	  methods: {
	    handleExtend: function handleExtend(timestamp) {
	      _backoffice2.default.reservations.select(this.reservation.number).extend(this.$convertTimestamp(timestamp), function (response) {
	        _maggieHelper2.default.notification('extend-esit', 'reservation extended');
	        _maggieHelper2.default.closeTopPanel();
	      }, function (e) {
	        _maggieHelper2.default.notification(e.result_code, e.messages, 'alert');
	        _maggieHelper2.default.closeTopPanel();
	      });
	    }
	  },
	  props: ['reservation', 'availability']
	};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EinvoiceGetStatus',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      sdiStatus: null,
	      openSdiStatus: false
	    };
	  },
	
	  methods: {
	    closeSdiStatus: function closeSdiStatus() {
	      this.sdiStatus = null;
	      this.openSdiStatus = false;
	    },
	    getStatus: function getStatus() {
	      var _this = this;
	
	      return _backoffice2.default.invoices.select(this.invoice).getStatus(function (data) {
	        _this.sdiStatus = data;
	        _this.openSdiStatus = true;
	      });
	    },
	    openSentXml: function openSentXml() {
	      var blob = new Blob([atob(this.sdiStatus.file)], { type: 'text/xml' });
	      var url = URL.createObjectURL(blob);
	      window.open(url);
	    }
	  },
	  props: ['invoice']
	};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Reveal = __webpack_require__(122);
	
	var _Reveal2 = _interopRequireDefault(_Reveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SendToExternal',
	  components: { Reveal: _Reveal2.default },
	  methods: {
	    sendToSDI: function sendToSDI() {
	      _backoffice2.default.invoices.select(this.invoice).sendToSdi(function (data) {
	        _maggieHelper2.default.notification('upload-status', data);
	      });
	    }
	  },
	  props: ['invoice']
	};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UpdateEinvoiceFileName',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      filename: null,
	      openSdiStatus: false
	    };
	  },
	
	  methods: {
	    closeSdiStatus: function closeSdiStatus() {
	      this.sdiStatus = null;
	      this.openSdiStatus = false;
	    },
	    open: function open() {
	      this.openSdiStatus = true;
	    },
	    getStatus: function getStatus() {
	      var _this = this;
	
	      return _backoffice2.default.invoices.select(this.invoice).updateFilename({
	        filename: this.filename
	      }, function (data) {
	        _this.openSdiStatus = false;
	        _maggieHelper2.default.notification('Updated', 'File name updated');
	      });
	    }
	  },
	  props: ['invoice']
	};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DownloadInvoiceAsEvilVersion',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      query: {
	        debug: false,
	        pn_serial: null
	      },
	      data: null,
	      hasId: false
	    };
	  },
	
	  methods: {
	    checkClient: function checkClient() {
	      var _this = this;
	
	      return _backoffice2.default.clients.select(this.invoice.billing_info.client_id).get(function (data) {
	        _this.hasId = data.extra !== null && data.extra.hasOwnProperty('zucchetti');
	      });
	    },
	    download: function download() {
	      var _this2 = this;
	
	      if (!this.hasId) {
	        _maggieHelper2.default.notification("ANCODICE", 'ANCODICE missing');
	      }
	      return _backoffice2.default.invoices.select(this.invoice).downloadZucchetti(this.query, function (data) {
	        _this2.data = data;
	      });
	    }
	  },
	  props: {
	    invoice: {
	      type: Object
	    }
	  }
	};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CardSmartEdit",
	  components: { SelectizeDriver: _SelectizeDriver2.default, SmartEdit: _SmartEdit2.default },
	  data: function data() {
	    return {
	      options: {
	        translations: {},
	        types: {
	          enabled: [true, false]
	        },
	        disabled: ["id"],
	        list: ["id", "uid", "pin", "name", "chip_id", "enabled"],
	        listMode: 'blacklist'
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    driverSelected: function driverSelected(driver) {
	      this.item.driver = driver;
	      this.item.driver_id = driver.id;
	    },
	    edit: function edit() {
	      _backoffice2.default.cards.select(this.item.id).edit(this.item, function (response) {
	        _maggieHelper2.default.notification('edit-esit', 'Card bound successfully');
	        location.reload();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "CardSmartEdit",
	    components: { SmartEdit: _SmartEdit2.default },
	    data: function data() {
	        return {
	            options: {
	                translations: {},
	                types: {
	                    enabled: [true, false]
	
	                },
	                disabled: ["id"],
	                list: ["id", "driver", "uid"],
	                listMode: 'blacklist'
	            }
	        };
	    },
	    created: function created() {},
	
	    methods: {
	        updateFields: function updateFields(item) {
	            this.item = item;
	        },
	        edit: function edit() {
	
	            _backoffice2.default.cards.select(this.item.id).edit(this.item, function (response) {
	                _maggieHelper2.default.notification('edit-esit', 'Card edited successfully');
	                location.reload();
	            });
	        }
	    },
	    props: ['item']
	};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientSmartEdit',
	  components: { SmartEdit: _SmartEdit2.default },
	  data: function data() {
	    return {
	      clientTypes: [],
	      test: [],
	      items: null,
	      options: {
	        types: {
	          'client_type.code': []
	        },
	        translations: {},
	        disabled: ['id', 'profile_picture', 'status', 'created'],
	        list: ['id', 'client_type.id', 'client_type.type', 'status', 'uid', 'wallet', 'payment_methods', 'main_driver', 'drivers', 'created'],
	        listMode: 'blacklist'
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.clientTypes.list(1, 1000, null).all(function (data) {
	      _this.clientTypes = data.clientTypes;
	      _this.options.types['client_type.code'] = data.clientTypes.map(function (item) {
	        return item.code;
	      });
	    });
	
	    this.configuration.system.system_client_custom_fields.value.forEach(function (item) {
	      if (_this.item.extra === null) {
	        _this.$set(_this.item, 'extra', {});
	      }
	
	      if (typeof _this.item.extra[item.value] === 'undefined') {
	        _this.$set(_this.item.extra, item.value, null);
	      }
	    });
	  },
	
	  methods: {
	    updateFields: function updateFields(item) {
	      this.item = item;
	    },
	    edit: function edit() {
	      var _this2 = this;
	
	      var client_type_id = this.item.client_type.id;
	      this.clientTypes.forEach(function (item) {
	        if (item.code === _this2.item.client_type.code) {
	          client_type_id = item.id;
	        }
	      });
	
	      this.$set(this.item, 'client_type_id', client_type_id);
	      _backoffice2.default.clients.select(this.item.id).edit(this.item, function () {
	
	        _maggieHelper2.default.notification('edit-esit', 'Client edited successfully');
	        _maggieHelper2.default.closeRightPanel();
	        _this2.$emit('updated');
	      });
	    }
	  },
	  props: ['item'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }))
	};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverSmartEdit",
	  components: { SmartEdit: _SmartEdit2.default },
	  data: function data() {
	    return {
	      options: {
	        translations: {},
	        types: {
	          birthdate: 'date',
	          gender: ['-', 'M', 'F'],
	          title: ['-', 'Mr', 'Mrs', 'Ms', 'Miss']
	        },
	        disabled: ["id", "profile_picture", "status", "created"],
	        list: ["id", "client_id", "password", "uid", "status", "username", "client_name", "client_organization_name", "profile_picture", "created"],
	        listMode: 'blacklist'
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    updateFields: function updateFields(item) {
	      this.item = item;
	    },
	    edit: function edit() {
	      _backoffice2.default.drivers.select(this.item.id).edit(this.item, function (data) {
	        _maggieHelper2.default.notification('edit-esit', 'Driver edited');
	        location.reload();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "DriverPasswordSmartEdit",
	    components: { SmartEdit: _SmartEdit2.default },
	    data: function data() {
	        return {
	            options: {
	                translations: {},
	                types: {
	                    password: 'password'
	                },
	                disabled: ["id", "uid", "name", "surname"],
	                list: ["id", "uid", "name", "surname", "password"],
	                listMode: 'whitelist'
	            }
	        };
	    },
	    created: function created() {},
	
	    methods: {
	        updateFields: function updateFields(item) {
	            this.item = item;
	        },
	        edit: function edit() {
	            var _this = this;
	
	            _backoffice2.default.drivers.select(this.item.id).setNewPassword({ password: this.item.password }, function (data) {
	                _maggieHelper2.default.notification('Password updated', "Password for " + _this.item.name + " " + _this.item.surname + " (DR" + _this.item.id + ') was updated successfully. ');
	                _this.item = null;
	                _maggieHelper2.default.closeRightPanel();
	            });
	        }
	    },
	    props: ['item']
	};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getOwnPropertyNames = __webpack_require__(164);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _CreateDriverLicense = __webpack_require__(227);
	
	var _CreateDriverLicense2 = _interopRequireDefault(_CreateDriverLicense);
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _SelectizeCountry = __webpack_require__(149);
	
	var _SelectizeCountry2 = _interopRequireDefault(_SelectizeCountry);
	
	var _SelectizeDriverLicense = __webpack_require__(585);
	
	var _SelectizeDriverLicense2 = _interopRequireDefault(_SelectizeDriverLicense);
	
	var _SelectizeDocumentType = __webpack_require__(81);
	
	var _SelectizeDocumentType2 = _interopRequireDefault(_SelectizeDocumentType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverLicenseCreate',
	  components: {
	    SelectizeDocumentType: _SelectizeDocumentType2.default,
	    SelectizeDriverLicense: _SelectizeDriverLicense2.default,
	    SelectizeCountry: _SelectizeCountry2.default,
	    BackofficeDriverLicenseCreate: _CreateDriverLicense2.default,
	    DatePicker: _DatePicker2.default,
	    SmartEdit: _SmartEdit2.default,
	    Dropzone: _Dropzone2.default
	  },
	  data: function data() {
	    return {
	      documentType: null,
	      document: {
	        driver_id: null,
	        document_type_id: null,
	        expiry_date: null,
	        issuer: null,
	        issuer_country: null,
	        issue_date: null,
	        number: null,
	        attachments: {}
	      },
	      dropzoneUrl: _backoffice2.default.getUrlForDropzone()
	    };
	  },
	  created: function created() {
	    this.document.driver_id = this.item;
	  },
	
	  methods: {
	    selectDocType: function selectDocType(obj) {
	      this.documentType = obj;
	      this.document.document_type_id = obj.id;
	    },
	    create: function create() {
	
	      var propNames = (0, _getOwnPropertyNames2.default)(this.document);
	      for (var i = 0; i < propNames.length; i++) {
	        var propName = propNames[i];
	        if (this.document[propName] === '' || this.document[propName] === null || this.document[propName] === undefined) {
	          delete this.document[propName];
	        }
	      }
	      _backoffice2.default.documents.make(this.document, function (data) {
	        location.reload();
	      });
	    },
	    updateFields: function updateFields(item) {
	      this.document = item;
	    },
	    selectLicenseCountry: function selectLicenseCountry(country) {
	      this.driverLicense.issuer_country = country.name;
	    },
	    selectLicenseType: function selectLicenseType(driverLicense) {
	      this.driverLicense.license_type_id = driverLicense.id;
	    },
	
	    uploaded: function uploaded(file, response, view) {
	      this.document.attachments[view] = response.token;
	    }
	  },
	  props: ['item'],
	  computed: {
	    options: function options() {
	      var options = {
	        translations: {},
	
	        types: {
	          'expiry_date': 'date',
	          'issue_date': 'date'
	        },
	        disabled: ['id', 'status', 'created'],
	
	        list: ['id', 'uid', 'driver_id', 'driver', 'attachments', 'status', 'type', 'document_type_id'],
	        listMode: 'blacklist'
	      };
	
	      var docType = this.documentType;
	      if (docType) {
	        console.log(docType.has_number);
	        if (!docType.has_number) {
	          options.list.push('number');
	        }
	
	        if (!docType.has_expiry) {
	          options.list.push('expiry_date');
	        }
	
	        if (!docType.has_emission) {
	          options.list.push('issue_date');
	        }
	
	        if (!docType.has_issuer) {
	          options.list.push('issuer');
	        }
	
	        if (!docType.has_country) {
	          options.list.push('issuer_country');
	        }
	      }
	
	      return options;
	    }
	  }
	};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SelectizeDocumentType = __webpack_require__(81);
	
	var _SelectizeDocumentType2 = _interopRequireDefault(_SelectizeDocumentType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverLicenseSmartEdit',
	  components: {
	    SelectizeDocumentType: _SelectizeDocumentType2.default,
	    DatePicker: _DatePicker2.default,
	    SmartEdit: _SmartEdit2.default
	  },
	  data: function data() {
	    return {
	      documentType: null,
	      body: {}
	    };
	  },
	  created: function created() {
	    this.$set(this.body, 'body', this.item);
	  },
	
	  methods: {
	    selectDocType: function selectDocType(obj) {
	      this.documentType = obj;
	      this.$set(this.item, 'document_type_id', obj.id);
	      this.$set(this.item.type, 'id', obj.id);
	    },
	    updateFields: function updateFields(item) {
	      this.item = item;
	    },
	    edit: function edit() {
	      this.$set(this.item, 'document_type_id', this.item.type.id);
	      _backoffice2.default.documents.select(this.item.id).edit(this.item, function (data) {
	        location.reload();
	      });
	    }
	  },
	  computed: {
	    options: function options() {
	      var options = {
	        translations: {},
	
	        types: {
	          'expiry_date': 'date',
	          'issue_date': 'date'
	        },
	        disabled: ['id', 'status', 'created'],
	
	        list: ['id', 'uid', 'driver', 'attachments', 'status', 'type', 'document_type_id'],
	        listMode: 'blacklist'
	      };
	
	      var docType = this.documentType;
	      if (docType) {
	        if (!docType.has_expiry) {
	          options.list.push('expiry_date');
	        }
	
	        if (!docType.has_emission) {
	          options.list.push('issue_date');
	        }
	
	        if (!docType.has_issuer) {
	          options.list.push('issuer');
	        }
	
	        if (!docType.has_country) {
	          options.list.push('issuer_country');
	        }
	      }
	
	      return options;
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ParkingLotEdit",
	  components: { SmartEdit: _SmartEdit2.default },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.zones.list.all(function (data) {
	      _this.zones = data;
	      _this.zones.push({ name: null, id: null });
	
	      data.forEach(function (item) {
	        _this.options.types.allowed.push(item.name);
	        _this.options.types.undesiderable.push(item.name);
	        _this.options.types.forbidden.push(item.name);
	      });
	    });
	
	    this.editable = this.item;
	    this.editable.slots = this.item.parking_slots.length;
	    this.editable.allowed = this.item.allowed_zone ? this.item.allowed_zone.name : null;
	    this.editable.forbidden = this.item.forbidden_zone ? this.item.forbidden_zone.name : null;
	    this.editable.undesiderable = this.item.undesiderable_zone ? this.item.undesiderable_zone.name : null;
	
	    this.editable.coordinates = { lat: this.item.position.latitude, lng: this.item.position.longitude };
	  },
	
	  methods: {
	    updateFields: function updateFields(item) {
	      this.item = item;
	    },
	    updateParkingLot: function updateParkingLot() {
	      var _this2 = this;
	
	      this.editable.allowed_zone_id = this.getZoneId(this.item.allowed);
	      this.editable.forbidden_zone_id = this.getZoneId(this.item.forbidden);
	      this.editable.undesiderable_zone_id = this.getZoneId(this.item.undesiderable);
	
	      this.editable.latitude = this.item.coordinates.lat;
	      this.editable.longitude = this.item.coordinates.lng;
	
	      try {
	        this.item.config = JSON.parse(this.item.config);
	      } catch (e) {}
	      _backoffice2.default.parkingLots.select(this.item.id).update(this.item, function (data) {
	        _maggieHelper2.default.closeRightPanel();
	        _maggieHelper2.default.notification('update-esit', 'Parking lot updated');
	        _this2.$emit('refresh');
	      });
	    },
	    getZoneId: function getZoneId(zone) {
	
	      var id = null;
	      this.zones.forEach(function (item) {
	        if (zone === item.name) {
	          id = item.id;
	        }
	      });
	      return id;
	    }
	  },
	  data: function data() {
	    return {
	      editable: null,
	      zones: [],
	      options: {
	        translations: {
	          allowed: "Allowed zone",
	          undesiderable: "Undesiderable zone",
	          forbidden: "Forbidden zone",
	          coordinates: "Position"
	
	        },
	        types: {
	          allowed: [],
	          forbidden: [],
	          undesiderable: [],
	          coordinates: 'map',
	          picture: 'file',
	          description: 'editor'
	        },
	        file: {
	          selectedVisibility: 'public',
	          selectedPrefix: 'parking-lot'
	        },
	        disabled: [],
	        list: ["id", "uid", "parking_slots", "allowed_zone", "allowed_zone_id", "undesiderable_zone", "undesiderable_zone_id", "forbidden_zone", "forbidden_zone_id", "picture_external"],
	        listMode: 'blacklist'
	      }
	    };
	  },
	
	  props: ['item']
	
	};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _vuex = __webpack_require__(10);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PlanSmartEdit',
	  components: { SmartEdit: _SmartEdit2.default },
	  created: function created() {
	    if (this.item.toc) {
	      this.$set(this.item, 'toc_id', this.item.toc.id);
	    } else {
	      this.$set(this.item, 'toc_id', null);
	    }
	  },
	  data: function data() {
	
	    return {
	      options: {
	        types: {
	          valid_from: 'datetimes',
	          valid_to: 'datetimes',
	          status: ['AVAILABLE', 'UNAVAILABLE', 'DISABLED'],
	          featured: 'checkbox',
	          renewable: 'checkbox',
	          description: 'editor',
	          picture: 'file'
	        },
	        file: {
	          selectedVisibility: 'public',
	          selectedPrefix: 'plans'
	        },
	
	        translations: {
	          billing_cycle: 'BILLING CYCLE (DAYS)',
	          duration: 'Duration (DAYS)',
	          valid_from: 'Active from',
	          valid_to: 'Active to',
	          cost: 'Cost (vat excluded)'
	        },
	        translatable: this.item._translatable,
	        disabled: ['id', 'created'],
	        list: ['id', 'uid', 'created', 'toc', 'logs', '_translatable'],
	        listMode: 'blacklist'
	      }
	    };
	  },
	
	
	  methods: {
	    updateFields: function updateFields(item) {
	      this.item = item;
	    },
	    edit: function edit() {
	
	      if (!this.item.renewable) {
	        this.item.billing_cycle = this.item.duration;
	      }
	
	      _backoffice2.default.plans.select(this.$route.params.id).edit(this.item, function (data) {
	        _maggieHelper2.default.notification('Plan saved', 'Plan saved successfully', 'success');
	        _maggieHelper2.default.closeRightPanel();
	      });
	    }
	  },
	  props: ['item', 'tocs'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }))
	};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SearchVehicleAvailability = __webpack_require__(190);
	
	var _SearchVehicleAvailability2 = _interopRequireDefault(_SearchVehicleAvailability);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ReservationSmartEdit",
	  components: { SearchVehicleAvailability: _SearchVehicleAvailability2.default, SmartEdit: _SmartEdit2.default },
	  data: function data() {
	    return {
	      options: {
	        translations: {},
	        types: {
	          start: 'datetime',
	          end: 'datetime'
	
	        },
	        disabled: ["id"],
	        list: ['start', 'end'],
	        listMode: 'whitelist'
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    updateFields: function updateFields(item) {
	      this.item = item;
	    },
	    edit: function edit() {
	      var request = {
	        start: this.$convertTimestamp(this.item.start),
	        end: this.$convertTimestamp(this.item.end)
	      };
	
	      _backoffice2.default.reservations.select(this.item).edit(request, function () {
	        window.location.reload();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "SubscriptionSmartEdit",
	    components: { SmartEdit: _SmartEdit2.default },
	    data: function data() {
	        return {
	            options: {
	                translations: {},
	                types: {
	                    start: 'date',
	                    end: 'date',
	                    next_due_date: 'date',
	                    auto_renew: ['0', '1']
	                },
	                disabled: ["id"],
	                list: ["uid", "client", "plan", "drivers"],
	                listMode: 'blacklist'
	            }
	        };
	    },
	    created: function created() {},
	
	    methods: {
	        updateFields: function updateFields(item) {
	            this.item = item;
	        },
	        edit: function edit() {
	            _backoffice2.default.subscriptions.select(this.item.id).edit(this.item, function (data) {
	                _maggieHelper2.default.notification('edit-esit', 'Subscription edited');
	
	                location.reload();
	            });
	        }
	    },
	    props: ['item']
	};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleSmartEdit",
	  components: { SmartEdit: _SmartEdit2.default },
	  data: function data() {
	    return {
	      vehicleBrands: null,
	      vehicleCategories: null,
	      options: {
	        translations: { "category.name": "Name" },
	        types: {
	          picture: 'file',
	          brand: [],
	          'category.name': [],
	          fuel_type: ['PETROL', 'DIESEL', 'HYBRID', 'GAS', 'ELECTRIC', 'HYDROGEN', 'NONE', 'OTHER']
	        },
	        file: {
	          selectedVisibility: 'public',
	          selectedPrefix: 'vehicles'
	        },
	        disabled: [],
	        list: ["id", "uid", "hardware", "brand_logo", "odometer", "parking_lot", "door_status", "engine_status", "slot_id", "slot_name", "slot_disabled", "in_range", "position", "brand_id", "fuel_level", "category_id", "category.id", "category.description", "category.picture", "category.vehicle_type", "category.uid", "picture_external"],
	        listMode: 'blacklist'
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.selects.vehicleBrands(function (data) {
	      _this.vehicleBrands = data;
	      data.forEach(function (item) {
	        _this.options.types.brand.push(item.name);
	      });
	    });
	
	    _backoffice2.default.vehicleCategories.list(function (data) {
	      _this.vehicleCategories = data;
	      data.forEach(function (item) {
	        _this.options.types["category.name"].push(item.name);
	      });
	    });
	  },
	
	  methods: {
	    updateFields: function updateFields(item) {
	      this.item = item;
	    },
	    edit: function edit() {
	      var _this2 = this;
	
	      var brand_id = null;
	      var category_id = null;
	      this.vehicleBrands.forEach(function (item) {
	
	        if (item.name === _this2.item.brand) {
	          _this2.item.brand_id = item.id;
	        }
	      });
	
	      this.vehicleCategories.forEach(function (item) {
	        if (item.name === _this2.item.category.name) {
	          _this2.item.category_id = item.id;
	        }
	      });
	
	      _backoffice2.default.vehicles.select(this.item.id).edit(this.item, function (data) {
	        _maggieHelper2.default.notification('Edit', 'Vehicle edited successfully');
	        _maggieHelper2.default.closeRightPanel();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SmartEdit = __webpack_require__(42);
	
	var _SmartEdit2 = _interopRequireDefault(_SmartEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'WalletSmartEdit',
	    components: { SmartEdit: _SmartEdit2.default },
	    data: function data() {
	        return {
	            options: {
	                translations: {},
	                types: {
	                    'payment_method.name': this.paymentMethodList,
	                    'billing_strategy': []
	                },
	                disabled: ['id'],
	                list: ['id', 'uid', 'balance', 'default', 'amounts', 'payment_method.data', 'payment_method.created', 'payment_method.updated', 'payment_method.provider', 'payment_method.uid', 'payment_method.id'],
	                listMode: 'blacklist'
	            }
	        };
	    },
	    created: function created() {
	        if (!this.item.payment_method) {
	            this.item.payment_method = { id: null, name: null };
	        }
	        this.options.types.billing_strategy = ['IMMEDIATE', 'END OF MONTH', 'END OF NEXT MONTH'];
	    },
	
	    methods: {
	        updateFields: function updateFields(item) {
	            this.item = item;
	        },
	        edit: function edit() {
	            var _this = this;
	
	            this.paymentMethods.forEach(function (item) {
	                if (item.name === _this.item.payment_method.name) {
	                    _this.item.payment_method.id = item.id;
	                }
	            });
	            _backoffice2.default.wallets.select(this.item.id).edit(this.item, function (data) {
	                location.reload();
	            });
	        },
	        updatePaymentMethod: function updatePaymentMethod() {}
	    },
	    props: ['item', 'paymentMethods', 'paymentMethodList']
	};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AccountStatus = __webpack_require__(185);
	
	var _AccountStatus2 = _interopRequireDefault(_AccountStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AccontStatusFilter',
	  components: { AccountStatus: _AccountStatus2.default },
	  data: function data() {
	    return {
	      status: {
	        document_status: false,
	        payment_method: false,
	        subscription: false
	      }
	    };
	  },
	
	  methods: {
	    toggle: function toggle(val) {
	      this.status[val] = val === 'document_status' && this.status.document_status !== 'valid' ? 'valid' : !this.status[val];
	
	      var filter = (0, _extends3.default)({}, this.value, {
	        payment_method: this.status.payment_method ? 1 : 0,
	        document: this.status.document_status ? 1 : 0,
	        subscription: this.status.subscription ? 1 : 0
	      });
	      this.$emit('input', filter);
	    }
	  },
	  props: { value: {}, statuses: { type: Array, required: true } }
	};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _SelectizeVehicleAttribute = __webpack_require__(223);
	
	var _SelectizeVehicleAttribute2 = _interopRequireDefault(_SelectizeVehicleAttribute);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Attributes",
	  components: { LoadingSpinner: _LoadingSpinner2.default, SelectizeVehicleAttribute: _SelectizeVehicleAttribute2.default, ActionBar: _ActionBar2.default },
	  data: function data() {
	    return {
	      tempAttribute: null,
	      spin: false,
	      disabled: false
	    };
	  },
	
	  methods: {
	    addAttribute: function addAttribute() {
	      var temp = this.value;
	      temp.push(this.tempAttribute);
	      this.$emit('input', temp);
	      this.tempAttribute = null;
	    },
	    updateAttributes: function updateAttributes(obj) {
	      this.tempAttribute = {
	        id: null,
	        attribute_id: obj.id,
	        name: obj.name,
	        value: null
	      };
	    },
	    saveAttribute: function saveAttribute(attribute) {
	      var _this = this;
	
	      this.$emit('updateAttribute', attribute);
	      if (this.saveAction != null) {
	        this.disabled = true;
	        this.spin = true;
	        this.saveAction(attribute).then(function () {
	          _this.disabled = false;
	          _this.spin = false;
	        });
	      }
	    },
	    removeAttribute: function removeAttribute(index) {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Do you want to delete this attribute?', function () {
	        if (_this2.value[index].id) {
	          _this2.$emit('deleteAttribute', _this2.value[index]);
	        }
	
	        if (_this2.deleteAction != null && _this2.value[index].id != null) {
	          _this2.disabled = true;
	          _this2.spin = true;
	          _this2.deleteAction(_this2.value[index]).then(function () {
	            _this2.disabled = false;
	            _this2.spin = false;
	            var temp = _this2.value;
	            temp.splice(index, 1);
	          });
	          return;
	        }
	
	        var temp = _this2.value;
	        temp.splice(index, 1);
	      });
	    }
	  },
	
	  props: ['value', 'saveAction', 'deleteAction']
	};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Card = __webpack_require__(99);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverCards",
	  components: {
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    Card: _Card2.default
	  },
	  data: function data() {
	    return {
	      headers: ['Card name & ID', 'Driver', 'Chip id', 'Active'],
	      component: __webpack_require__(99)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      _backoffice2.default.clients.list(page, resultsPerPage, search).cards(this.$route.params.id, function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(242);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _InvoiceListForm = __webpack_require__(221);
	
	var _InvoiceListForm2 = _interopRequireDefault(_InvoiceListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _RefundableWalletRecords = __webpack_require__(2079);
	
	var _RefundableWalletRecords2 = _interopRequireDefault(_RefundableWalletRecords);
	
	var _WalletRecord = __webpack_require__(85);
	
	var _WalletRecord2 = _interopRequireDefault(_WalletRecord);
	
	var _Card = __webpack_require__(2012);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TabbedClientInvoices',
	  components: {
	    ActionButton: _ActionButton2.default,
	    Card: _Card2.default,
	    BackofficeWalletRecord: _WalletRecord2.default,
	    RefundableRecords: _RefundableWalletRecords2.default,
	    ActionBar: _ActionBar2.default,
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    InvoiceListForm: _InvoiceListForm2.default
	  },
	  data: function data() {
	    return {
	      selected: [],
	      refundable: [],
	      items: [],
	      component: __webpack_require__(85),
	      body: {
	        records: {},
	        refund_on_gateway: false,
	        emit_as_proforma: true,
	        reason: null
	      }
	    };
	  },
	  created: function created() {
	    this.dataLoader(function () {
	      return null;
	    }, 1, 5);
	  },
	
	  methods: {
	    emit: function emit() {
	      var _this = this;
	
	      return _backoffice2.default.wallets.select(this.$route.params.wallet_id).manualCreditNote(this.body, function (data) {
	        _this.$router.push({ name: 'invoice', params: { id: data.id } });
	      });
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      var _this2 = this;
	
	      _backoffice2.default.wallets.list(page, resultsPerPage).refundable(this.$route.params.wallet_id, search, function (data) {
	        callback(data);
	
	        data.items.forEach(function (item) {
	          if (_this2.items.findIndex(function (x) {
	            return x.id === item.id;
	          }) === -1) {
	            _this2.items.push(item);
	            _this2.refundable.push(item);
	          }
	        });
	      });
	    },
	    findRecord: function findRecord(recordId) {
	      return this.items.filter(function (item) {
	        return item.id === recordId;
	      })[0];
	    },
	    convertArrayToObject: function convertArrayToObject(array, key) {
	      var initialValue = {};
	      return array.reduce(function (obj, item) {
	        return (0, _extends4.default)({}, obj, (0, _defineProperty3.default)({}, item[key], item));
	      }, initialValue);
	    },
	    mapRecords: function mapRecords(input) {
	      var _this3 = this;
	
	      this.body.records = this.convertArrayToObject(this.refundable.filter(function (item) {
	        return input.includes('' + item.id);
	      }).map(function (item) {
	
	        var amount = _this3.body.records[item.id] !== undefined && _this3.body.records[item.id].hasOwnProperty('amount') ? _this3.body.records[item.id].amount : null;
	        var type = _this3.body.records[item.id] !== undefined && _this3.body.records[item.id].hasOwnProperty('type') ? _this3.body.records[item.id].type : 'DISCOUNT';
	        return { amount: amount, type: type, id: item.id };
	      }), 'id');
	    },
	    checkValue: function checkValue(event, recordId) {
	      var record = this.findRecord(recordId);
	      var total = Math.abs(record.amount + record.amount * -record.tax);
	      if (parseFloat(this.body.records[record.id].amount) > total) {
	        this.body.records[record.id].amount = total.toFixed(2);
	      }
	      if (parseFloat(this.body.records[record.id].amount) < 0) {
	        this.body.records[record.id].amount = 0;
	      }
	    },
	    getRecordAmount: function getRecordAmount(record) {
	
	      if (record.amount === null) {
	        return {};
	      }
	      var original = this.findRecord(record.id);
	      var originalAmount = Math.abs(this.$priceWithVat(original.amount, original.target));
	
	      var result = {
	        correct_amount: null,
	        give_back: null
	      };
	
	      switch (record.type) {
	        case 'DISCOUNT':
	          result.correct_amount = Math.abs(originalAmount - record.amount).toFixed(2);
	          result.give_back = record.amount;
	
	          break;
	        case 'EXACT_AMOUNT':
	          result.correct_amount = Math.abs(record.amount);
	          result.give_back = (originalAmount - record.amount).toFixed(2);
	          break;
	      }
	
	      return result;
	    }
	  },
	  computed: {
	    getSummary: function getSummary() {
	      var giveBack = 0;
	      for (var key in this.body.records) {
	        var record = this.body.records[key];
	        if (record.amount !== null) {
	          giveBack += Math.abs(this.getRecordAmount(record).give_back);
	        }
	      }
	      return giveBack;
	    },
	    records: function records() {
	      return this.convertArrayToObject(this.refundable, 'id');
	    }
	  },
	  props: []
	};

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ReservationListForm = __webpack_require__(124);
	
	var _ReservationListForm2 = _interopRequireDefault(_ReservationListForm);
	
	var _BookPanel = __webpack_require__(100);
	
	var _BookPanel2 = _interopRequireDefault(_BookPanel);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'TabbedClientDeposits',
	    components: {
	        ActionBar: _ActionBar2.default,
	        BaseList: _BaseList2.default,
	        BookPanel: _BookPanel2.default,
	        ReservationListForm: _ReservationListForm2.default
	    },
	    data: function data() {
	        return {
	            component: __webpack_require__(531),
	            reservations: [],
	            search: {
	                client_id: this.$route.params.id
	            },
	            drivers: [],
	            deposits: []
	        };
	    },
	    created: function created() {},
	
	    methods: {
	        dataLoader: function dataLoader(callback, page, resultsPerPage) {
	            var _this = this;
	
	            _backoffice2.default.clients.select(this.$route.params.id).deposits(page, resultsPerPage, function (data) {
	                callback(data);
	                _this.deposits = data;
	            });
	        }
	    }
	};

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ClientDrivers",
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(18)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.clients.list(page, resultsPerPage, { id: this.$route.params.id }).drivers(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _InvoiceListForm = __webpack_require__(221);
	
	var _InvoiceListForm2 = _interopRequireDefault(_InvoiceListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'TabbedClientInvoices',
	    components: {
	        ActionBar: _ActionBar2.default,
	        HeaderColumns: _HeaderColumns2.default,
	        BaseList: _BaseList2.default,
	        InvoiceListForm: _InvoiceListForm2.default
	    },
	    data: function data() {
	        return {
	            component: __webpack_require__(114),
	            expanded: true,
	            filterStatus: null,
	            filterType: null
	        };
	    },
	    created: function created() {},
	
	    methods: {
	        filterInvoices: function filterInvoices(body) {
	            this.filterStatus = body.status;
	            this.filterType = body.type;
	        },
	        dataLoader: function dataLoader(callback, page, resultsPerPage) {
	            _backoffice2.default.invoices.list(page, resultsPerPage, this.search).client(function (data) {
	                callback(data);
	            });
	        }
	    },
	    computed: {
	        search: function search() {
	            return {
	                client_id: this.$route.params.id,
	                wallet_id: this.wallet.id,
	                status: this.filterStatus,
	                type: this.filterType
	            };
	        }
	    },
	    props: ['wallet']
	};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Accordion = __webpack_require__(86);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _AccordionItem = __webpack_require__(87);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _Log = __webpack_require__(115);
	
	var _Log2 = _interopRequireDefault(_Log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverLogs",
	  components: {
	    Log: _Log2.default,
	    Accordion: _Accordion2.default,
	    AccordionItem: _AccordionItem2.default
	  },
	  data: function data() {
	    return {
	      items: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.clients.list(1, 1000).logs(this.$route.params.id, function (data) {
	      _this.items = data.items;
	    });
	  }
	};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TabbedClientPaymentMethods',
	  components: { ActionButton: _ActionButton2.default, ActionBar: _ActionBar2.default, BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(538),
	      payment_provider: ''
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.clients.list(page, resultsPerPage, { id: this.$route.params.id }).paymentMethods(function (data) {
	        callback(data);
	      });
	    },
	    handleCreatePayment: function handleCreatePayment() {
	      var _this = this;
	
	      return _backoffice2.default.payment_methods.make({
	        'provider': this.payment_provider,
	        'client_id': this.$route.params.id
	      }, function (success) {
	        _maggieHelper2.default.notification('payment-method-esit', 'Payment method added');
	        _this.$refs.loader.loadData();
	      });
	    }
	  },
	  computed: {},
	  props: ['defaultOnWallet']
	};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(243);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(94);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Client = __webpack_require__(53);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _DriverLicence = __webpack_require__(188);
	
	var _DriverLicence2 = _interopRequireDefault(_DriverLicence);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ClientProfile",
	  components: {
	    DriverLicence: _DriverLicence2.default,
	    Client: _Client2.default,
	    SelectizeDriver: _SelectizeDriver2.default
	  },
	  data: function data() {
	    return {
	      client: null,
	      driverLicenses: [],
	      driver_id: null,
	      options: null,
	      diffs: null,
	      client_status: null,
	      component: __webpack_require__(18)
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.clients.select(this.$route.params.id).get(function (data) {
	      _this.client = data;
	      _this.loadDriverLicenses(_this.client.main_driver.id);
	    });
	  },
	
	  methods: {
	    loadDriverLicenses: function loadDriverLicenses(id) {
	      var _this2 = this;
	
	      _backoffice2.default.drivers.select(id).getLicences(function (data) {
	        _this2.driverLicenses = data;
	      });
	    },
	    driverSelected: function driverSelected(driver) {
	      this.driver_id = driver.id;
	    },
	    updateMainDriver: function updateMainDriver() {
	      _backoffice2.default.clients.select(this.$route.params.id).setMainDriver(this.driver_id, function () {
	        MaggieHelper.notification('edit-esit', 'Main driver updated');
	      });
	    },
	    driverLoader: function driverLoader(callback, page, resultsPerPage) {
	      var _this3 = this;
	
	      _backoffice2.default.clients.list(page, resultsPerPage, { id: this.$route.params.id }).drivers(function (data) {
	        _this3.options = data.items;
	      });
	    },
	    getDifference: function getDifference(a, b) {
	      return Object.fromEntries((0, _entries2.default)(b).filter(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            key = _ref2[0],
	            val = _ref2[1];
	
	        return key in a && a[key] !== val;
	      }));
	    }
	  },
	  mounted: function mounted() {
	    this.driverLoader();
	  }
	};

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ReservationListForm = __webpack_require__(124);
	
	var _ReservationListForm2 = _interopRequireDefault(_ReservationListForm);
	
	var _BookPanel = __webpack_require__(100);
	
	var _BookPanel2 = _interopRequireDefault(_BookPanel);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ClientReservations",
	  components: {
	    BaseList: _BaseList2.default,
	    BookPanel: _BookPanel2.default,
	    ReservationListForm: _ReservationListForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(37),
	      reservations: [],
	      search: {
	        client_id: this.$route.params.id
	      },
	      drivers: []
	    };
	  },
	  created: function created() {
	    this.loadDrivers();
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.reservations.list(page, resultsPerPage, this.search).all(function (data) {
	        callback(data);
	      });
	    },
	    filterReservations: function filterReservations(body) {
	      this.$set(this.search, 'status', body.status);
	
	      if (this.search.status === '') {
	        delete this.search.status;
	      }
	    },
	    loadDrivers: function loadDrivers() {
	      var _this = this;
	
	      _backoffice2.default.clients.list(1, 10000, { id: this.$route.params.id }).drivers(function (data) {
	        _this.drivers = data.items;
	      });
	    }
	  }
	};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ClientPlanSubscriber = __webpack_require__(1901);
	
	var _ClientPlanSubscriber2 = _interopRequireDefault(_ClientPlanSubscriber);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ClientSubscriptions",
	  components: {
	    BaseList: _BaseList2.default,
	    ClientPlanSubscriber: _ClientPlanSubscriber2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(136)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.clients.list(page, resultsPerPage, { id: this.$route.params.id }).subscriptions(function (data) {
	        callback(data);
	      });
	    },
	    subscriptionAdded: function subscriptionAdded(op) {
	      if (op === 'added') {
	        this.$refs.tabbedList.loadData(1);
	      }
	    }
	  }
	};

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ClientTopUps',
	    components: { ActionBar: _ActionBar2.default, BaseList: _BaseList2.default },
	    data: function data() {
	        return {
	            component: __webpack_require__(1934)
	        };
	    },
	
	    methods: {
	        dataLoader: function dataLoader(callback) {
	            var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	            var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	
	            _backoffice2.default.topUps.list.all(this.$route.params.id, page, resultsPerPage, function (data) {
	                callback(data);
	            });
	        }
	    }
	};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _TransactionListForm = __webpack_require__(582);
	
	var _TransactionListForm2 = _interopRequireDefault(_TransactionListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TabbedClientTransactions",
	  components: {
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    TransactionListForm: _TransactionListForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(40),
	      headers: ['', 'Date', 'Payment method', 'Invoice', 'Amount', 'Status', ''],
	      search: {
	        client_id: this.$route.params.id
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    filterTransactions: function filterTransactions(body) {
	      this.$set(this.search, 'status', body.status);
	      if (this.search.status === '') {
	        delete this.search.status;
	      }
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.transactions.list(page, resultsPerPage, this.search).all(function (data) {
	        callback(data);
	      });
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _WalletRecord = __webpack_require__(85);
	
	var _WalletRecord2 = _interopRequireDefault(_WalletRecord);
	
	var _PaymentMethod = __webpack_require__(538);
	
	var _PaymentMethod2 = _interopRequireDefault(_PaymentMethod);
	
	var _WalletAddCost = __webpack_require__(544);
	
	var _WalletAddCost2 = _interopRequireDefault(_WalletAddCost);
	
	var _WalletEdit = __webpack_require__(1967);
	
	var _WalletEdit2 = _interopRequireDefault(_WalletEdit);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _MultiWallet = __webpack_require__(1987);
	
	var _MultiWallet2 = _interopRequireDefault(_MultiWallet);
	
	var _ClientInvoices = __webpack_require__(548);
	
	var _ClientInvoices2 = _interopRequireDefault(_ClientInvoices);
	
	var _CreditRecords = __webpack_require__(1978);
	
	var _CreditRecords2 = _interopRequireDefault(_CreditRecords);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ClientPaymentMethods = __webpack_require__(549);
	
	var _ClientPaymentMethods2 = _interopRequireDefault(_ClientPaymentMethods);
	
	var _ClientDeposits = __webpack_require__(547);
	
	var _ClientDeposits2 = _interopRequireDefault(_ClientDeposits);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ClientTopUps = __webpack_require__(1975);
	
	var _ClientTopUps2 = _interopRequireDefault(_ClientTopUps);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _CommonCostButtonModal = __webpack_require__(144);
	
	var _CommonCostButtonModal2 = _interopRequireDefault(_CommonCostButtonModal);
	
	var _AddCommonCostToWallet = __webpack_require__(2030);
	
	var _AddCommonCostToWallet2 = _interopRequireDefault(_AddCommonCostToWallet);
	
	var _PaidCreditRecords = __webpack_require__(1989);
	
	var _PaidCreditRecords2 = _interopRequireDefault(_PaidCreditRecords);
	
	var _PacketRecords = __webpack_require__(1988);
	
	var _PacketRecords2 = _interopRequireDefault(_PacketRecords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TabbedClientWallets',
	  components: {
	    TabbedPacketRecords: _PacketRecords2.default,
	    TabbedPaidCreditRecords: _PaidCreditRecords2.default,
	    AddCommonCostToWallet: _AddCommonCostToWallet2.default,
	    CommonCostButtonModal: _CommonCostButtonModal2.default,
	    ActionBar: _ActionBar2.default,
	    ClientTopUps: _ClientTopUps2.default,
	    ActionButton: _ActionButton2.default,
	    TabbedClientDeposits: _ClientDeposits2.default,
	    TabbedClientPaymentMethods: _ClientPaymentMethods2.default,
	    TabbedCreditRecords: _CreditRecords2.default,
	    TabbedClientInvoices: _ClientInvoices2.default,
	    BackofficeMultiWallet: _MultiWallet2.default,
	    BaseList: _BaseList2.default,
	    WalletEdit: _WalletEdit2.default,
	    WalletAddCost: _WalletAddCost2.default,
	    PaymentMethod: _PaymentMethod2.default,
	    BackofficeWalletRecord: _WalletRecord2.default
	  },
	  data: function data() {
	    return {
	      wallets: [],
	      paymentMethods: [],
	      selectedIndex: 0,
	      selectedWallet: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.loadWallet();
	    _backoffice2.default.clients.list(1, 1000, { id: this.$route.params.id }).paymentMethods(function (data) {
	      _this.paymentMethods = data.items;
	    });
	  },
	
	  methods: {
	    editWallet: function editWallet() {
	      var pm = [];
	      this.paymentMethods.forEach(function (item) {
	        pm.push(item.name);
	      });
	      _maggieHelper2.default.openRightPanel({
	        component: _WalletEdit2.default,
	        props: {
	          item: this.selectedWallet,
	          paymentMethodList: pm,
	          paymentMethods: this.paymentMethods
	        }
	      });
	    },
	    loadWallet: function loadWallet() {
	      var _this2 = this;
	
	      _backoffice2.default.clients.list(1, 1000).wallets(this.$route.params.id, function (data) {
	        _this2.wallets = data;
	        data.forEach(function (item, key) {
	          if (item.default) {
	            _this2.selectedIndex = key;
	            _this2.selectedWallet = item;
	          }
	        });
	      });
	    },
	    setActive: function setActive(index) {
	      this.selectedIndex = index;
	      this.selectedWallet = this.wallets[this.selectedIndex];
	    },
	    billWallet: function billWallet() {
	      var _this3 = this;
	
	      var c = 'kepler:bill-wallet wallet-id:' + this.selectedWallet.id;
	      return _backoffice2.default.console.run(c, function (ok) {
	        _this3.loadWallet();
	      });
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _PlanReservationRate = __webpack_require__(189);
	
	var _PlanReservationRate2 = _interopRequireDefault(_PlanReservationRate);
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _SelectizeReservationRate = __webpack_require__(588);
	
	var _SelectizeReservationRate2 = _interopRequireDefault(_SelectizeReservationRate);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreatePlanReservationRates",
	  components: {
	    ActionButton: _ActionButton2.default,
	    ModalReveal: _ModalReveal2.default,
	    BookingModeSelect: _BookingModeSelect2.default, DatePicker: _DatePicker2.default, SelectizeReservationRate: _SelectizeReservationRate2.default, SelectizeCategory: _SelectizeCategory2.default, PlanReservationRate: _PlanReservationRate2.default
	  },
	  data: function data() {
	    return {
	      plan_rate: {
	        name: null,
	        vehicle_category_id: null,
	        plan_id: null,
	        reservation_rate_id: null,
	        booking_mode: null,
	        time_resolution_method: "ITWILLBEDEADSOON",
	        time_resolution_cycle: 0,
	        distance_resolution_method: "ITWILLBEDEADSOON",
	        distance_resolution_cycle: 0,
	        valid_from: null,
	        valid_to: null,
	        disabled: false
	      },
	      booking_modes: []
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    selectCategory: function selectCategory(item) {
	      this.plan_rate.vehicle_category_id = item.id;
	    },
	    selectRate: function selectRate(item) {
	      this.plan_rate.reservation_rate_id = item.id;
	    },
	    savePlanRate: function savePlanRate() {
	      var _this = this;
	
	      this.plan_rate.booking_mode = this.bookingMode;
	      this.plan_rate.plan_id = this.planId;
	
	      return _backoffice2.default.planReservationRates.make(this.plan_rate, function (data) {
	        _maggieHelper2.default.notification('rate', 'Reservation rate created');
	        _this.$emit('added');
	        _this.$refs.revealPlanCreate.close();
	      });
	    }
	  },
	  computed: {},
	  props: {
	    planId: {},
	    bookingMode: {}
	  }
	};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TabbedCreditRecords',
	  components: { ActionButton: _ActionButton2.default, DatePicker: _DatePicker2.default, ActionBar: _ActionBar2.default, BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(187),
	      expanded: true,
	      addCredit: false,
	      body: {
	        amount: 0,
	        tax: null,
	        reason: null,
	        type: this.type.toUpperCase(),
	        service: null,
	        valid_from: null,
	        valid_to: null
	      }
	    };
	  },
	  created: function created() {},
	  mounted: function mounted() {
	    this.body.tax = this.$defaultVat();
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	
	      _backoffice2.default.credits.list.all(this.search, page, resultsPerPage, function (data) {
	        callback(data);
	      });
	    },
	    addNewCredit: function addNewCredit() {
	      var _this = this;
	
	      var body = (0, _extends3.default)({}, this.body, {
	        client_id: this.$route.params.id,
	        tax: this.body.tax / 100
	      });
	      return _backoffice2.default.credits.make(body, function () {
	        _this.$refs.listCr.loadData(1);
	      });
	    }
	  },
	  computed: {
	    search: function search() {
	      return {
	        client_id: this.$route.params.id,
	        type: this.type
	      };
	    }
	  },
	  props: ['type']
	};

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Card = __webpack_require__(99);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CreateCard = __webpack_require__(204);
	
	var _CreateCard2 = _interopRequireDefault(_CreateCard);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeCard = __webpack_require__(584);
	
	var _SelectizeCard2 = _interopRequireDefault(_SelectizeCard);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverCards",
	  components: {
	    SelectizeCard: _SelectizeCard2.default,
	    BaseList: _BaseList2.default,
	    CreateCard: _CreateCard2.default,
	    Card: _Card2.default
	  },
	  data: function data() {
	    return {
	      headers: ['Card name & ID', 'Driver', 'Chip id', 'Active'],
	      component: __webpack_require__(99),
	      selectedUnassignedCard: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    addCard: function addCard(event) {
	      if (event === 'added') {
	        this.$refs.list.loadData(1);
	      }
	    },
	    selectUnassignedCard: function selectUnassignedCard(card) {
	      this.selectedUnassignedCard = card;
	    },
	    assignCard: function assignCard() {
	      var _this = this;
	
	      var item = this.selectedUnassignedCard;
	      if (item) {
	        item.driver_id = this.$route.params.id;
	        _backoffice2.default.cards.select(item.id).edit(item, function () {
	          _maggieHelper2.default.notification('edit-esit', 'Card bound successfully');
	          _this.$refs.list.loadData(1);
	        });
	      }
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.drivers.list(page, resultsPerPage, { id: this.$route.params.id }).cards(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverCoupons",
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(530)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.drivers.list(page, resultsPerPage, { id: this.$route.params.id }).coupons(page = 1, resultsPerPage = 25, function (data) {
	        callback(data);
	      });
	    }
	  }
	
	};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DriverLicence = __webpack_require__(188);
	
	var _DriverLicence2 = _interopRequireDefault(_DriverLicence);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _DriverLicenseCreate = __webpack_require__(1962);
	
	var _DriverLicenseCreate2 = _interopRequireDefault(_DriverLicenseCreate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "DriverLicense",
	    components: {
	        DriverLicenseCreate: _DriverLicenseCreate2.default,
	        DriverLicence: _DriverLicence2.default
	    },
	    data: function data() {
	        return {
	            licenses: []
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        _backoffice2.default.drivers.select(this.$route.params.id).getLicences(function (data) {
	            _this.licenses = data;
	        });
	    },
	
	    methods: {
	        createDriverLicense: function createDriverLicense() {
	
	            _maggieHelper2.default.openRightPanel({
	                component: _DriverLicenseCreate2.default,
	                props: {
	                    item: this.$route.params.id
	                }
	            });
	        }
	    }
	};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Accordion = __webpack_require__(86);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _AccordionItem = __webpack_require__(87);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _Log = __webpack_require__(115);
	
	var _Log2 = _interopRequireDefault(_Log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverLogs",
	  components: {
	    Log: _Log2.default,
	    Accordion: _Accordion2.default,
	    AccordionItem: _AccordionItem2.default
	  },
	  data: function data() {
	    return {
	      items: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.drivers.list(1, 1000).logs(this.$route.params.id, function (data) {
	      _this.items = data.items;
	    });
	  }
	};

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _DriverGroup = __webpack_require__(1907);
	
	var _DriverGroup2 = _interopRequireDefault(_DriverGroup);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverProfile',
	  components: {
	    DriverGroup: _DriverGroup2.default,
	    ActionButton: _ActionButton2.default,
	    Driver: _Driver2.default
	  },
	  data: function data() {
	    return {
	      driver: null,
	      diffs: null,
	      driver_status: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.drivers.select(this.$route.params.id).get(function (data) {
	      _this.driver = data;
	      _this.driver_status = _this.driver.status;
	    });
	  },
	
	  methods: {
	    toggleSupervisor: function toggleSupervisor(val) {
	      _backoffice2.default.driverGroups.select(this.$route.params.id).toggleSupervisor({
	        group_id: val.id,
	        supervisor: val.supervisor
	      }, function () {
	        _maggieHelper2.default.notification('Supervisor', 'Driver updated');
	      });
	    }
	  }
	};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ReservationListForm = __webpack_require__(124);
	
	var _ReservationListForm2 = _interopRequireDefault(_ReservationListForm);
	
	var _BookPanel = __webpack_require__(100);
	
	var _BookPanel2 = _interopRequireDefault(_BookPanel);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverReservations',
	  components: {
	    BaseList: _BaseList2.default,
	    BookPanel: _BookPanel2.default,
	    ReservationListForm: _ReservationListForm2.default
	  },
	  data: function data() {
	    return {
	      reservations: [],
	      search: {},
	      component: __webpack_require__(37)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.drivers.list(page, resultsPerPage, this.search).reservations(this.$route.params.id, function (data) {
	        callback(data);
	      });
	    },
	    applyFilters: function applyFilters(body) {
	      this.$set(this.search, 'status', body.status);
	
	      if (this.search.status === '') {
	        delete this.search.status;
	      }
	    }
	  }
	};

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverSubscriptions",
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(136)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.drivers.list(page, resultsPerPage, { id: this.$route.params.id }).subscriptions(function (data) {
	        data.items_count = data.length;
	        data.items = data;
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Card = __webpack_require__(99);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CreateCard = __webpack_require__(204);
	
	var _CreateCard2 = _interopRequireDefault(_CreateCard);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeCard = __webpack_require__(584);
	
	var _SelectizeCard2 = _interopRequireDefault(_SelectizeCard);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverCards",
	  components: {
	    SelectizeCard: _SelectizeCard2.default,
	    BaseList: _BaseList2.default,
	    CreateCard: _CreateCard2.default,
	    Card: _Card2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1912)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      var tocs = {
	        current_page: 1,
	        current_page_count: 1,
	        items: [],
	        items_count: 10,
	        page_count: 1,
	        per_page_count: 25
	      };
	      _backoffice2.default.drivers.select(this.$route.params.id).tocs(function (data) {
	
	        tocs.items = data;
	        tocs.items_count = data.length;
	        callback(tocs);
	      });
	    }
	  }
	};

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _PlanReservationRate = __webpack_require__(189);
	
	var _PlanReservationRate2 = _interopRequireDefault(_PlanReservationRate);
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _SelectizeReservationRate = __webpack_require__(588);
	
	var _SelectizeReservationRate2 = _interopRequireDefault(_SelectizeReservationRate);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _eventBus = __webpack_require__(15);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "EditPlanReservationRates",
	  components: {
	    ActionButton: _ActionButton2.default,
	    ModalReveal: _ModalReveal2.default,
	    BookingModeSelect: _BookingModeSelect2.default, DatePicker: _DatePicker2.default, SelectizeReservationRate: _SelectizeReservationRate2.default, SelectizeCategory: _SelectizeCategory2.default, PlanReservationRate: _PlanReservationRate2.default
	  },
	  data: function data() {
	    return {
	      plan_rate: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.planReservationRates.select(this.rateId).get(function (data) {
	      _this.plan_rate = data;
	    });
	  },
	
	  methods: {
	    selectCategory: function selectCategory(item) {
	      this.plan_rate.vehicle_category_id = item.id;
	    },
	    selectRate: function selectRate(item) {
	      this.plan_rate.reservation_rate_id = item.id;
	    },
	    savePlanRate: function savePlanRate() {
	      var _this2 = this;
	
	      return _backoffice2.default.planReservationRates.select(this.rateId).edit(this.plan_rate, function (data) {
	        _maggieHelper2.default.notification('rate', 'Reservation rate edited');
	        _eventBus.EventBus.$emit('reload-list');
	        _this2.$refs.revealPlanEdit.close();
	      });
	    }
	  },
	  props: {
	    rateId: {}
	  },
	  computed: {}
	};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _WalletAddCost = __webpack_require__(544);
	
	var _WalletAddCost2 = _interopRequireDefault(_WalletAddCost);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'BackofficeMultiWallet',
	    components: { ActionButton: _ActionButton2.default, ActionBar: _ActionBar2.default, WalletAddCost: _WalletAddCost2.default, BaseList: _BaseList2.default },
	    data: function data() {
	        return {
	            wallets: [],
	            component: __webpack_require__(85),
	            selectedWallet: 0,
	            walletAddCostToggle: false,
	            expanded: true,
	            paymentMethods: []
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        _backoffice2.default.clients.list(1, 1000, { id: this.$route.params.id }).paymentMethods(function (data) {
	            _this.paymentMethods = data.items;
	        });
	    },
	
	
	    methods: {
	        refreshList: function refreshList() {
	            return this.$refs.wrList.loadData(1);
	        },
	        dataLoader: function dataLoader(callback, page, resultsPerPage) {
	            return _backoffice2.default.wallets.list(page, resultsPerPage).records(this.value.id, function (data) {
	                callback(data);
	            });
	        }
	    },
	    computed: {
	        search: function search() {
	            return {
	                wallet_id: this.value.id
	            };
	        }
	    },
	    props: ['value']
	};

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TabbedPacketRecords',
	  components: { ActionButton: _ActionButton2.default, DatePicker: _DatePicker2.default, ActionBar: _ActionBar2.default, BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(536)
	
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	
	      _backoffice2.default.packetRecords.list.all(this.$route.params.id, page, resultsPerPage, function (data) {
	        callback(data);
	      });
	    }
	  },
	  computed: {
	    search: function search() {
	      return {
	        client_id: this.$route.params.id,
	        type: this.type
	      };
	    }
	  },
	  props: ['type']
	};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _vuex = __webpack_require__(10);
	
	var _ToggleableButton = __webpack_require__(206);
	
	var _ToggleableButton2 = _interopRequireDefault(_ToggleableButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TabbedPaidCreditRecords',
	  components: { ToggleableButton: _ToggleableButton2.default, ActionButton: _ActionButton2.default, DatePicker: _DatePicker2.default, ActionBar: _ActionBar2.default, BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(187),
	      expanded: true,
	      addCredit: false,
	      body: {
	        amount: 0
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	
	      _backoffice2.default.credits.list.all(this.search, page, resultsPerPage, function (data) {
	        callback(data);
	      });
	    },
	    addNewCredit: function addNewCredit() {
	      var _this = this;
	
	      var body = (0, _extends3.default)({}, this.body, {
	        client_id: this.$route.params.id
	      });
	      return _backoffice2.default.credits.makePaid(body, function () {
	        _this.$refs.listCr.loadData(1);
	      });
	    }
	  },
	  computed: (0, _extends3.default)({
	    search: function search() {
	      return {
	        client_id: this.$route.params.id,
	        type: this.type
	      };
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    topupSizes: function topupSizes() {
	      var sizes = this.configuration.system.system_fields_configuration.value.find(function (item) {
	        return item.field === 'topup_sizes';
	      });
	
	      return sizes ? sizes.config.split(',') : [];
	    }
	  }),
	  props: ['type']
	};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ParkingLotBoundaries",
	  data: function data() {
	    return {
	      item: null,
	      mapsApiKey: window.env.GOOGLE_MAPS_KEY,
	      mapCenter: {
	        lat: 0,
	        lng: 0
	      }
	    };
	  },
	
	  components: {
	    GoogleMapContainer: _GoogleMapContainer2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    GoogleMap: _GoogleMap2.default,
	    GoogleMapPolygon: _GoogleMapPolygon2.default
	  },
	
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this.mapCenter.lat = data.application.application_default_latitude.value;
	      _this.mapCenter.lng = data.application.application_default_longitude.value;
	    });
	    _backoffice2.default.parkingLots.select(this.$route.params.id).get(function (data) {
	      _this.item = data;
	    });
	  }
	};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _AssetManagementActionButtons = __webpack_require__(209);
	
	var _AssetManagementActionButtons2 = _interopRequireDefault(_AssetManagementActionButtons);
	
	var _AddVehicleAsset = __webpack_require__(2065);
	
	var _AddVehicleAsset2 = _interopRequireDefault(_AddVehicleAsset);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _VehicleSlot = __webpack_require__(1939);
	
	var _VehicleSlot2 = _interopRequireDefault(_VehicleSlot);
	
	var _Card = __webpack_require__(77);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _SelectizeGroupedParkingAssets = __webpack_require__(91);
	
	var _SelectizeGroupedParkingAssets2 = _interopRequireDefault(_SelectizeGroupedParkingAssets);
	
	var _ArchiveVehicleSlots = __webpack_require__(2066);
	
	var _ArchiveVehicleSlots2 = _interopRequireDefault(_ArchiveVehicleSlots);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ParkingLotsManage',
	  components: {
	    ArchiveVehicleSlots: _ArchiveVehicleSlots2.default,
	    SelectizeGroupedParkingAssets: _SelectizeGroupedParkingAssets2.default,
	    ModalReveal: _ModalReveal2.default,
	    CardN: _CardN2.default,
	    Dropdown: _Dropdown2.default,
	    Card4: _Card2.default,
	    Vehicle: _Vehicle2.default,
	    VehicleSlot: _VehicleSlot2.default,
	    AddVehicleAsset: _AddVehicleAsset2.default,
	    AssetManagementActionButtons: _AssetManagementActionButtons2.default
	  },
	
	  data: function data() {
	    return {
	      item: null,
	      slots: []
	    };
	  },
	  created: function created() {
	    this.loadSlots();
	    this.getParkingLot();
	  },
	
	  methods: {
	    loadSlots: function loadSlots() {
	      var _this = this;
	
	      _backoffice2.default.parkingSlots.list.slots(this.$route.params.id, function (data) {
	        _this.slots = data;
	        _this.slots.push({ placeholder: true, vehicle_slots: [] });
	      });
	    },
	    getParkingLot: function getParkingLot() {
	      var _this2 = this;
	
	      _backoffice2.default.parkingLots.select(this.$route.params.id).get(function (data) {
	        _this2.item = data;
	      });
	    },
	    deleteParkingSlot: function deleteParkingSlot(item) {
	      var _this3 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to delete the parking slot ' + item.name + ' (PS-' + item.id + ')?', function () {
	        _backoffice2.default.parkingSlots.select(item.id).remove(function () {
	          _maggieHelper2.default.notification('Delete', 'Parking slot deleted');
	          _this3.getParkingLot();
	          _this3.loadSlots();
	        });
	      });
	    },
	    archiveParkingSlot: function archiveParkingSlot(destinationSlot, slot) {
	      _backoffice2.default.parkingSlots.select(slot).archive({ destination_parking_slot: destinationSlot.id }, function () {
	        _maggieHelper2.default.notification('Moved', 'Vehicle slots have been updated');
	      });
	    },
	    addParkingLot: function addParkingLot() {
	      var _this4 = this;
	
	      var body = {
	        parking_lot_id: this.$route.params.id,
	        name: 'PL' + this.item.id + ' N\xB0 ' + this.item.parking_slots.length++
	      };
	
	      _backoffice2.default.parkingSlots.make(body, function (data) {
	        _this4.loadSlots();
	        _this4.getParkingLot();
	        _maggieHelper2.default.notification('add-esit', 'Parking Lot Created');
	      });
	    }
	  },
	  computed: {
	    groupedStyle: function groupedStyle() {
	      return {
	        flexDirection: 'row',
	        paddingRight: '0.5em'
	      };
	    }
	  }
	};

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ParkingLotsOverview",
	  components: { LoadingSpinner: _LoadingSpinner2.default },
	  data: function data() {
	    return {
	      item: null,
	      tooltipText: "",
	      status: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.parkingLots.select(this.$route.params.id).get(function (data) {
	      _this.status = {};
	      data['parking_slots'].forEach(function (s) {
	        if (typeof s.occupied === "boolean") {
	          _this.status[s.name] = s.occupied;
	        }
	      });
	
	      _this.item = data;
	    });
	  },
	
	  methods: {
	    tooltip: function tooltip(id, g) {
	      this.tooltipText = id;
	    },
	    clicked: function clicked(id) {
	      alert(id);
	    },
	    getClass: function getClass(id) {
	      if (typeof this.status[id] === "undefined") {
	        return 'outline';
	      }
	      return this.status[id] ? 'occupied' : 'free';
	    }
	  }
	};

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _PlanReservationRate = __webpack_require__(189);
	
	var _PlanReservationRate2 = _interopRequireDefault(_PlanReservationRate);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _TabHeaders = __webpack_require__(121);
	
	var _TabHeaders2 = _interopRequireDefault(_TabHeaders);
	
	var _TabContent = __webpack_require__(120);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _CreatePlanReservationRates = __webpack_require__(550);
	
	var _CreatePlanReservationRates2 = _interopRequireDefault(_CreatePlanReservationRates);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PlanReservationRates",
	  components: { CreatePlanReservationRates: _CreatePlanReservationRates2.default, TabContent: _TabContent2.default, TabHeaders: _TabHeaders2.default, PlanReservationRate: _PlanReservationRate2.default },
	  data: function data() {
	    return {
	      planRates: [],
	      bookingModes: []
	    };
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    var _this = this;
	
	    _eventBus.EventBus.$on('reload-list', function () {
	      _this.loadModes();
	    });
	    this.loadModes();
	  },
	  destroyed: function destroyed() {
	    _eventBus.EventBus.$off('reload-list');
	  },
	
	  methods: {
	    hasPlanForBm: function hasPlanForBm(bm) {
	      return this.planRates.items !== undefined && (0, _keys2.default)(this.planRates.items).includes(bm);
	    },
	    getTotal: function getTotal(bm) {
	      if (this.hasPlanForBm(bm)) {
	        return this.planRates.items[bm].length;
	      }
	      return 0;
	    },
	    loadModes: function loadModes() {
	      var _this2 = this;
	
	      this.bookingModes = [];
	      this.planRates = [];
	      _backoffice2.default.reservations.list().modes(function (data) {
	        (0, _keys2.default)(data).map(function (key) {
	          data[key] = key;
	        });
	
	        _this2.bookingModes = data;
	        _this2.loadRates();
	      });
	    },
	    loadRates: function loadRates() {
	      var _this3 = this;
	
	      _backoffice2.default.plans.select(this.$route.params.id).rates(function (data) {
	        _this3.planRates = (0, _collect2.default)(data).groupBy('booking_mode');
	
	        _this3.$nextTick(function () {
	          $(_this3.$el).find('#tabs').foundation();
	        });
	      });
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _vuex = __webpack_require__(10);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _PlanReservationRates = __webpack_require__(552);
	
	var _PlanReservationRates2 = _interopRequireDefault(_PlanReservationRates);
	
	var _SelectizeToc = __webpack_require__(589);
	
	var _SelectizeToc2 = _interopRequireDefault(_SelectizeToc);
	
	var _TabHeaders = __webpack_require__(121);
	
	var _TabHeaders2 = _interopRequireDefault(_TabHeaders);
	
	var _TabContent = __webpack_require__(120);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _Accordion = __webpack_require__(86);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _AccordionItem = __webpack_require__(87);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _Log = __webpack_require__(115);
	
	var _Log2 = _interopRequireDefault(_Log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PlanSetup',
	  components: {
	    Log: _Log2.default,
	    AccordionItem: _AccordionItem2.default,
	    Accordion: _Accordion2.default, TabContent: _TabContent2.default, TabHeaders: _TabHeaders2.default, SelectizeToc: _SelectizeToc2.default, PlanReservationRates: _PlanReservationRates2.default, KeplerFileUpload: _KeplerFileUpload2.default, DatePicker: _DatePicker2.default },
	  data: function data() {
	    return {
	      plan: null,
	      vat: false,
	      readOnly: true,
	      mock: {
	        name: null,
	        toc_id: null,
	        picture: null,
	        title: null,
	        description: null,
	        cost: 0,
	        status: null,
	        featured: false,
	        renewable: true,
	        billing_cycle: 90,
	        max_drivers: 1,
	        duration: 30,
	        subscription_end: null,
	        valid_from: null,
	        valid_to: null,
	        color: null
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.plans.select(this.$route.params.id).get(function (data) {
	      _this.plan = data;
	      _this.plan.toc_id = data.toc ? data.toc.id : null;
	    });
	  },
	
	
	  methods: {},
	  props: {
	    create: {
	      type: Boolean,
	      default: false
	    },
	    item: {}
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    planPicture: function planPicture() {
	      return window.env.API_URL + '/storage/' + this.plan.picture;
	    },
	    planPictureStyle: function planPictureStyle() {
	      return {
	        backgroundImage: 'url(' + this.planPicture + ')',
	        height: '200px',
	        width: '100%',
	        backgroundRepeat: 'no-repeat',
	        backgroundSize: 'contain',
	        backgroundPosition: 'center center'
	      };
	    }
	  })
	};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _vuex = __webpack_require__(10);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _TranslationEdit = __webpack_require__(157);
	
	var _TranslationEdit2 = _interopRequireDefault(_TranslationEdit);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RateConfiguration',
	  components: {
	    TranslateField: _TranslateField2.default,
	    ModalReveal: _ModalReveal2.default,
	    TranslationEdit: _TranslationEdit2.default,
	    Editor: _Editor2.default,
	    ActionBar: _ActionBar2.default,
	    ActionButton: _ActionButton2.default
	  },
	  data: function data() {
	    return {
	      body: { inherited_reservation_rate_id: null, config: {}, name: null, description: "" },
	      available: [],
	      loaded: false,
	      translations: [],
	      translatable: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.reservationRates.list.rates(function (data) {
	      _this.available = data;
	    });
	
	    this.body.config = (0, _stringify2.default)({}, null, 2);
	
	    if (this.$route.params.id) {
	      _backoffice2.default.reservationRates.select(this.$route.params.id).get(function (data) {
	        _this.body.config = (0, _stringify2.default)(data.config, null, 2);
	        _this.body.name = data.name;
	        _this.body.description = data.description;
	        _this.body.inherited_reservation_rate_id = data.inherited_reservation_rate_id;
	        _this.translatable = data._translatable;
	        _this.loaded = true;
	      });
	    }
	  },
	
	  methods: {
	    save: function save() {
	      var _this2 = this;
	
	      var body = (0, _extends3.default)({}, this.body);
	      body.config = JSON.parse(this.body.config);
	      if (this.$route.params.id) {
	        return _backoffice2.default.reservationRates.select(this.$route.params.id).edit(body, function (data) {
	          _maggieHelper2.default.notification('rate', 'Base rate updated');
	          _this2.$router.push({ name: 'rates' });
	        });
	      }
	
	      return _backoffice2.default.reservationRates.make(body, function (data) {
	        _maggieHelper2.default.notification('rate', 'Base rate saved');
	        _this2.$router.push({ name: 'rates' });
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: ['item']
	};

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _CreateNoteModal = __webpack_require__(155);
	
	var _CreateNoteModal2 = _interopRequireDefault(_CreateNoteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ReservationNotes",
	  components: { BaseList: _BaseList2.default, CreateNoteModal: _CreateNoteModal2.default },
	  data: function data() {
	    return {
	      note: { type: 'App\\Models\\Reservation', id: null, description: null },
	      component: __webpack_require__(134)
	    };
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	
	      _backoffice2.default.notes.list().all({
	        per_page: resultsPerPage,
	        page_number: page,
	        type: 'App\\Models\\Reservation',
	        id: this.$route.params.id
	      }, function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _VehicleHardware = __webpack_require__(191);
	
	var _VehicleHardware2 = _interopRequireDefault(_VehicleHardware);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "TabbedTransaction",
	    components: {
	        Transaction: _Transaction2.default,
	        VehicleHardware: _VehicleHardware2.default,
	        Vehicle: _Vehicle2.default
	    },
	    data: function data() {
	        return {
	            transaction: null
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        _backoffice2.default.transactions.select(this.$route.params.id).get(function (data) {
	            _this.transaction = data;
	        });
	    }
	};

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CreateNote = __webpack_require__(154);
	
	var _CreateNote2 = _interopRequireDefault(_CreateNote);
	
	var _CreateNoteModal = __webpack_require__(155);
	
	var _CreateNoteModal2 = _interopRequireDefault(_CreateNoteModal);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _SelectizeInstructions = __webpack_require__(586);
	
	var _SelectizeInstructions2 = _interopRequireDefault(_SelectizeInstructions);
	
	var _LoadingAnimation = __webpack_require__(117);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ArrayEdit = __webpack_require__(88);
	
	var _ArrayEdit2 = _interopRequireDefault(_ArrayEdit);
	
	var _SelectizeVehicleAttributesArrayEdit = __webpack_require__(559);
	
	var _SelectizeVehicleAttributesArrayEdit2 = _interopRequireDefault(_SelectizeVehicleAttributesArrayEdit);
	
	var _SelectizeVehicleAttribute = __webpack_require__(223);
	
	var _SelectizeVehicleAttribute2 = _interopRequireDefault(_SelectizeVehicleAttribute);
	
	var _MdiIcon = __webpack_require__(80);
	
	var _MdiIcon2 = _interopRequireDefault(_MdiIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TabbedVehicleAttributes",
	  components: {
	    MdiIcon: _MdiIcon2.default,
	    SelectizeVehicleAttribute: _SelectizeVehicleAttribute2.default,
	    SelectizeVehicleAttributesArrayEdit: _SelectizeVehicleAttributesArrayEdit2.default,
	    ArrayEdit: _ArrayEdit2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    LoadingAnimation: _LoadingAnimation2.default,
	    SelectizeInstructions: _SelectizeInstructions2.default,
	    ActionBar: _ActionBar2.default,
	    CreateNoteModal: _CreateNoteModal2.default,
	    CreateNote: _CreateNote2.default,
	    ModalReveal: _ModalReveal2.default,
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      add: false,
	      addInProgress: false,
	      instruction_id: null,
	      component: __webpack_require__(542),
	      attributes: [],
	
	      tempAttribute: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicles.select(this.$route.params.id, null).attributes(function (data) {
	      _this.attributes = data;
	    });
	  },
	
	  methods: {
	    addAttribute: function addAttribute() {
	
	      this.attributes.push({
	        attribute_id: this.tempAttribute.id,
	        attribute: {
	          name: this.tempAttribute.name
	        },
	        vehicle_attribute_id: null,
	        value: null
	      });
	
	      this.tempAttribute = null;
	    },
	    updateAttributes: function updateAttributes(obj) {
	      this.tempAttribute = obj;
	    },
	    saveAttribute: function saveAttribute(attribute) {
	
	      if (attribute.attribute.id) {
	
	        _backoffice2.default.vehicleVehicleAttributes.select(attribute.id).edit({
	          vehicle_id: this.$route.params.id,
	          vehicle_attribute_id: attribute.attribute.id,
	          value: attribute.value
	        }, function () {
	          _maggieHelper2.default.notification('Updated', 'Attribute updated');
	        });
	        return;
	      }
	
	      _backoffice2.default.vehicleVehicleAttributes.make({
	        vehicle_id: this.$route.params.id,
	        vehicle_attribute_id: attribute.attribute_id,
	        value: attribute.value
	      }, function (data) {
	        _maggieHelper2.default.notification('Saved', 'Attribute saved');
	      });
	    },
	    removeAttribute: function removeAttribute(index) {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Do you want to delete this attribute?', function () {
	        if (_this2.attributes[index].id) {
	          _backoffice2.default.vehicleVehicleAttributes.select(_this2.attributes[index]).remove(function (data) {
	            _maggieHelper2.default.notification('Deleted', 'Attribute deleted');
	          });
	        }
	
	        _this2.attributes.splice(index, 1);
	      });
	    }
	  },
	  computed: {},
	  props: ['item']
	};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _VehicleAvailability = __webpack_require__(137);
	
	var _VehicleAvailability2 = _interopRequireDefault(_VehicleAvailability);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SearchVehicleAvailability = __webpack_require__(190);
	
	var _SearchVehicleAvailability2 = _interopRequireDefault(_SearchVehicleAvailability);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TabbedVehicleAvailability",
	  components: {
	    SearchVehicleAvailability: _SearchVehicleAvailability2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    DatePicker: _DatePicker2.default,
	    BackofficeVehicleAvailability: _VehicleAvailability2.default
	  },
	  data: function data() {
	    return {
	      vehicle: null,
	      bookRequest: {
	        plate: null,
	        start: null,
	        end: null,
	        driver_id: null
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicles.select(this.$route.params.id).get(function (data) {
	      _this.vehicle = data;
	      _this.bookRequest.plate = data.plate;
	    });
	  },
	
	  methods: {
	    selectDriver: function selectDriver(obj) {
	      this.bookRequest.driver_id = obj.id;
	    },
	    book: function book(data) {
	      var _this2 = this;
	
	      this.bookRequest = (0, _assign2.default)(this.bookRequest, data);
	
	      _backoffice2.default.reservations.make(this.bookRequest, function (response) {
	        _this2.reservation = response;
	        _this2.vehicles = [];
	        _maggieHelper2.default.notification('book-esit', "reservation created");
	        _this2.$emit('reservationCreated');
	      });
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _StatisticsCard = __webpack_require__(142);
	
	var _StatisticsCard2 = _interopRequireDefault(_StatisticsCard);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _VehicleCost = __webpack_require__(543);
	
	var _VehicleCost2 = _interopRequireDefault(_VehicleCost);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _vuex = __webpack_require__(10);
	
	var _RangePicker = __webpack_require__(200);
	
	var _RangePicker2 = _interopRequireDefault(_RangePicker);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TabbedVehicleCosts',
	  components: {
	    RangePicker: _RangePicker2.default,
	    DateRangePicker: _DateRangePicker2.default,
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    DatePicker: _DatePicker2.default,
	    CardN: _CardN2.default,
	    ModalReveal: _ModalReveal2.default,
	    VehicleCost: _VehicleCost2.default,
	    StatisticsCard4: _StatisticsCard2.default
	  },
	  data: function data() {
	    return {
	      roi: null,
	      costTypes: [],
	      cost: {
	        asset_cost_record_type_id: null,
	        description: null,
	        amount: null,
	        tax: null,
	        date: null
	      },
	      vatRate: 0,
	      headers: ['', 'Cost type', 'Description', 'Amount & Tax', 'Date'],
	      search: { start: null, end: null },
	      component: __webpack_require__(543)
	    };
	  },
	  created: function created() {
	    this.search.start = (0, _moment2.default)().startOf('month').format('YYYY-MM-DD');
	    this.search.end = (0, _moment2.default)().format('YYYY-MM-DD');
	    this.vatRate = this.configuration.commercial.commercial_vat_rate.value;
	    this.init();
	    this.loadCostTypes();
	  },
	
	  watch: {
	    search: function search(n, o) {
	      if (this.search.start === null) {
	        this.search.start = (0, _moment2.default)().startOf('month').format('YYYY-MM-DD');
	      }
	      if (this.search.end === null) {
	        this.search.end = (0, _moment2.default)().format('YYYY-MM-DD');
	      }
	    }
	
	  },
	  methods: {
	    dateRangeSelected: function dateRangeSelected(range) {
	      this.search = (0, _extends3.default)({}, this.search, {
	        start: range ? range.start : (0, _moment2.default)().startOf('month').format('YYYY-MM-DD'),
	        end: range ? range.end : (0, _moment2.default)().format('YYYY-MM-DD')
	      });
	    },
	    init: function init() {
	      this.loadRoi();
	    },
	    loadRoi: function loadRoi() {
	      var _this = this;
	
	      _backoffice2.default.vehicles.select(this.$route.params.id).roi(this.search.start, this.search.end, function (data) {
	        _this.roi = data;
	      });
	    },
	    loadCostTypes: function loadCostTypes() {
	      var _this2 = this;
	
	      _backoffice2.default.assetCosts.list.types(function (data) {
	        _this2.costTypes = data;
	      });
	    },
	    addCost: function addCost() {
	      var _this3 = this;
	
	      this.cost.tax = this.cost.amount * this.vatRate;
	      _backoffice2.default.vehicleCost.make(this.$route.params.id, this.cost, function () {
	        _this3.$refs.modalAddCost.close();
	        _this3.$refs.list.loadData(1);
	        _this3.init();
	      });
	    },
	    dataLoader: function dataLoader(callback) {
	      var _this4 = this;
	
	      var costs = {
	        current_page: 1,
	        current_page_count: 1,
	        items: [],
	        items_count: 0,
	        page_count: 1,
	        per_page_count: 25
	      };
	      _backoffice2.default.vehicles.select(this.$route.params.id).costs(this.search.start, this.search.end, function (data) {
	        costs.items_count = data.length;
	        costs.items = data;
	        _this4.loadRoi();
	        callback(costs);
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  })
	};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CreateNote = __webpack_require__(154);
	
	var _CreateNote2 = _interopRequireDefault(_CreateNote);
	
	var _CreateNoteModal = __webpack_require__(155);
	
	var _CreateNoteModal2 = _interopRequireDefault(_CreateNoteModal);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _SelectizeInstructions = __webpack_require__(586);
	
	var _SelectizeInstructions2 = _interopRequireDefault(_SelectizeInstructions);
	
	var _LoadingAnimation = __webpack_require__(117);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TabbedVehicleInstructions',
	  components: {
	    LoadingSpinner: _LoadingSpinner2.default,
	    LoadingAnimation: _LoadingAnimation2.default,
	    SelectizeInstructions: _SelectizeInstructions2.default,
	    ActionBar: _ActionBar2.default,
	    CreateNoteModal: _CreateNoteModal2.default,
	    CreateNote: _CreateNote2.default,
	    ModalReveal: _ModalReveal2.default,
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      add: false,
	      addInProgress: false,
	      instruction_id: null,
	      component: __webpack_require__(534)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    addNote: function addNote() {
	      this.$refs.baseList.loadData(1);
	    },
	    dataLoader: function dataLoader(callback) {
	      var _this = this;
	
	      var instructions = {
	        current_page: 1,
	        current_page_count: 1,
	        items: [],
	        items_count: 0,
	        page_count: 1,
	        per_page_count: 25
	      };
	
	      _backoffice2.default.vehicleInstructions.list.all(function (data) {
	        instructions.items = data.filter(function (item) {
	          return item.vehicle.id === parseInt(_this.$route.params.id);
	        });
	        instructions.items_count = instructions.items.length;
	        callback(instructions);
	      });
	    },
	    selectInstruction: function selectInstruction(obj) {
	      this.instruction_id = obj.id;
	    },
	    addInstruction: function addInstruction() {
	      var _this2 = this;
	
	      this.addInProgress = true;
	      _backoffice2.default.vehicleInstructions.make({
	        instruction_id: this.instruction_id,
	        vehicle_id: this.$route.params.id
	      }, function () {
	        _this2.$refs.baseList.loadData(1);
	        _this2.addInProgress = false;
	        _this2.add = false;
	        _this2.instruction_id = null;
	        _maggieHelper2.default.notification('Done', 'Instruction added');
	      });
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ReportingListForm = __webpack_require__(148);
	
	var _ReportingListForm2 = _interopRequireDefault(_ReportingListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _MaintenanceRequestList = __webpack_require__(156);
	
	var _MaintenanceRequestList2 = _interopRequireDefault(_MaintenanceRequestList);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TabbedVehicleInterventionRequests",
	  components: {
	    Dropdown: _Dropdown2.default,
	    ActionBar: _ActionBar2.default,
	    MaintenanceRequestList: _MaintenanceRequestList2.default,
	    DateRangePicker: _DateRangePicker2.default,
	    BaseList: _BaseList2.default,
	    ReportingListForm: _ReportingListForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(37),
	      search: {
	        start: '',
	        end: '',
	        vehicle_id: this.$route.params.id
	      }
	
	    };
	  },
	  created: function created() {},
	
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	
	      _backoffice2.default.vehicles.list(page, resultsPerPage, this.search).movements(function (data) {
	        callback(data);
	      });
	    },
	    dateRangeSelected: function dateRangeSelected(range) {
	      if (range.start == "" && range.end == "") {
	        this.filterReservation();
	      }
	      this.search.start = range.start;
	      this.search.end = range.end;
	    },
	    filterReservation: function filterReservation() {
	      this.$refs.list.debouncedLoader();
	    }
	  }
	
	};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapMarker = __webpack_require__(72);
	
	var _GoogleMapMarker2 = _interopRequireDefault(_GoogleMapMarker);
	
	var _GoogleMapCircle = __webpack_require__(152);
	
	var _GoogleMapCircle2 = _interopRequireDefault(_GoogleMapCircle);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TabbedVehicleMapPosition',
	  components: {
	    GoogleMapContainer: _GoogleMapContainer2.default,
	    GoogleMap: _GoogleMap2.default,
	    GoogleMapMarker: _GoogleMapMarker2.default,
	    GoogleMapCircle: _GoogleMapCircle2.default,
	    GoogleMapPolygon: _GoogleMapPolygon2.default
	  },
	  data: function data() {
	    return {
	      vehicle: null,
	      zones: {
	        allowed: null,
	        forbidden: null,
	        undesirable: null
	      }
	    };
	  },
	  created: function created() {
	    this.loadVehiclePosition();
	  },
	
	  methods: {
	    loadVehiclePosition: function loadVehiclePosition() {
	      var _this = this;
	
	      _backoffice2.default.vehicles.select(this.$route.params.id).get(function (data) {
	        _this.vehicle = data;
	        _backoffice2.default.parkingLots.select(_this.vehicle.parking_lot.id).get(function (data) {
	          _this.zones.allowed = data.allowed_zone;
	          _this.zones.forbidden = data.forbidden_zone;
	          _this.zones.undesirable = data.undesiderable_zone;
	        });
	      });
	    },
	    vehicleInRange: function vehicleInRange(vehicle) {
	      var icon = '/static/map_pin_blue.png';
	      if (!vehicle.in_range) {
	        icon = '/static/map_pin_red.png';
	      }
	
	      if (vehicle.has_reservation === 'normal') {
	        icon = '/static/map_pin_orange.png';
	      }
	
	      if (vehicle.has_reservation === 'maintenance') {
	        icon = '/static/map_pin_yellow.png';
	      }
	
	      if (vehicle.ev_plug_status === 'CHARGING') {
	        icon = '/static/charging.svg';
	      }
	
	      return icon;
	    }
	  },
	  computed: {
	    mapsAPI: function mapsAPI() {
	      return window.env.GOOGLE_MAPS_KEY;
	    }
	  }
	};

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CreateNote = __webpack_require__(154);
	
	var _CreateNote2 = _interopRequireDefault(_CreateNote);
	
	var _CreateNoteModal = __webpack_require__(155);
	
	var _CreateNoteModal2 = _interopRequireDefault(_CreateNoteModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TabbedVehicleMptes",
	  components: {
	    CreateNoteModal: _CreateNoteModal2.default,
	    CreateNote: _CreateNote2.default,
	    ModalReveal: _ModalReveal2.default,
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	
	      headers: ['', 'Cost type', 'Description', 'Amount & Tax', 'Date'],
	      note: { type: 'App\\Models\\Vehicle', id: null, description: null },
	      component: __webpack_require__(134)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    addNote: function addNote() {
	      this.$refs.baseList.loadData(1);
	    },
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	
	      _backoffice2.default.notes.list().all({
	        per_page: resultsPerPage,
	        page_number: page,
	        type: 'App\\Models\\Vehicle',
	        id: this.$route.params.id
	      }, function (data) {
	        callback(data);
	      });
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _VehicleHardware = __webpack_require__(191);
	
	var _VehicleHardware2 = _interopRequireDefault(_VehicleHardware);
	
	var _VehicleHardwareRevealCreate = __webpack_require__(2083);
	
	var _VehicleHardwareRevealCreate2 = _interopRequireDefault(_VehicleHardwareRevealCreate);
	
	var _SearchVehicleAvailability = __webpack_require__(190);
	
	var _SearchVehicleAvailability2 = _interopRequireDefault(_SearchVehicleAvailability);
	
	var _CreateVehicleSlot = __webpack_require__(573);
	
	var _CreateVehicleSlot2 = _interopRequireDefault(_CreateVehicleSlot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleOverview",
	  components: {
	    CreateVehicleSlot: _CreateVehicleSlot2.default,
	    SearchVehicleAvailability: _SearchVehicleAvailability2.default,
	    VehicleHardwareRevealCreate: _VehicleHardwareRevealCreate2.default,
	    VehicleHardware: _VehicleHardware2.default,
	    Vehicle: _Vehicle2.default
	  },
	  data: function data() {
	    return {
	      vehicle: null
	    };
	  },
	  created: function created() {
	    this.loadVehicle();
	  },
	
	  methods: {
	    loadVehicle: function loadVehicle() {
	      var _this = this;
	
	      _backoffice2.default.vehicles.select(this.$route.params.id).get(function (data) {
	        _this.vehicle = data;
	      });
	    }
	  }
	};

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ReportingListForm = __webpack_require__(148);
	
	var _ReportingListForm2 = _interopRequireDefault(_ReportingListForm);
	
	var _VehicleDamage = __webpack_require__(138);
	
	var _VehicleDamage2 = _interopRequireDefault(_VehicleDamage);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _VehicleDamageDetail = __webpack_require__(1938);
	
	var _VehicleDamageDetail2 = _interopRequireDefault(_VehicleDamageDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TabbedVehicleReports",
	  components: {
	    VehicleDamageDetail: _VehicleDamageDetail2.default,
	    BaseList: _BaseList2.default,
	    VehicleDamage: _VehicleDamage2.default,
	    ReportingListForm: _ReportingListForm2.default
	  },
	  data: function data() {
	    return {
	      damagePositions: [],
	      component: __webpack_require__(135),
	      search: {
	        vehicle_id: this.$route.params.id,
	        status: null
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.reportings.list(1, -1, { vehicle_id: this.$route.params.id }).all(function (data) {
	      data.items.forEach(function (item) {
	        if (item.damage_position_raw && (item.status === 'PENDING_REVIEW' || item.status === 'CONFIRMED')) {
	          item.damage_position_raw.forEach(function (damage) {
	            damage.id = item.id;
	            damage.uid = item.uid;
	            damage.description = item.description;
	            damage.status = item.status;
	            _this.damagePositions.push(damage);
	          });
	        }
	      });
	      _this.$refs.vehicleDamage.render();
	    });
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.reportings.list(page, resultsPerPage, this.search).all(function (data) {
	        callback(data);
	      });
	    },
	    applyFilters: function applyFilters(body) {
	      this.$set(this.search, 'status', body.status);
	      if (this.search.status === '') {
	        delete this.search.status;
	      }
	    }
	  },
	  computed: {},
	  props: {
	    item: {
	      default: null
	    }
	  }
	};

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ReportingListForm = __webpack_require__(148);
	
	var _ReportingListForm2 = _interopRequireDefault(_ReportingListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TabbedVehicleReservations",
	  components: {
	    DateRangePicker: _DateRangePicker2.default,
	    BaseList: _BaseList2.default,
	    ReportingListForm: _ReportingListForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(37),
	      search: {
	        start: '',
	        end: '',
	        vehicle_id: this.$route.params.id
	      }
	
	    };
	  },
	  created: function created() {},
	
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	
	      _backoffice2.default.vehicles.list(page, resultsPerPage, this.search).movements(function (data) {
	        callback(data);
	      });
	    },
	    dateRangeSelected: function dateRangeSelected(range) {
	      if (range.start == "" && range.end == "") {
	        this.filterReservation();
	      }
	      this.search.start = range.start;
	      this.search.end = range.end;
	    },
	    filterReservation: function filterReservation() {
	      this.$refs.list.debouncedLoader();
	    }
	  }
	
	};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Accordion = __webpack_require__(86);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _AccordionItem = __webpack_require__(87);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _Log = __webpack_require__(115);
	
	var _Log2 = _interopRequireDefault(_Log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverLogs",
	  components: {
	    Log: _Log2.default,
	    Accordion: _Accordion2.default,
	    AccordionItem: _AccordionItem2.default
	  },
	  data: function data() {
	    return {
	      items: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicleSlots.list(1, 1000).logs(this.item.slot_id, function (data) {
	      _this.items = data.items;
	    });
	  },
	
	  props: ['item']
	};

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "LoadingAnimation",
	  props: ['loading']
	};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseMultidimentionalChart = __webpack_require__(197);
	
	var _BaseMultidimentionalChart2 = _interopRequireDefault(_BaseMultidimentionalChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseMultidimentionalChart2.default.extend({
	  name: "BarChart",
	  methods: {
	    getChartType: function getChartType() {
	      return "bar";
	    }
	  }
	});

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _chart = __webpack_require__(244);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _vue = __webpack_require__(129);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _vue2.default.extend({
	  name: "BaseChart",
	
	  props: ['data'],
	  watch: {
	    data: function data(newVal) {
	      this.chart.data = this.buildDataset();
	      this.chart.update();
	    }
	  },
	  mounted: function mounted() {
	    var context = this.$el.getContext("2d");
	
	    if (typeof this.customBuilder == 'function') {
	      this.chart = this.customBuilder(context);
	    } else {
	      this.chart = new _chart2.default(context, this.config);
	    }
	  },
	
	  methods: {
	    getColor: function getColor(index) {
	      var baseColors = {
	        red: 'rgb(255, 99, 132)',
	        orange: 'rgb(255, 159, 64)',
	        yellow: 'rgb(255, 205, 86)',
	        green: 'rgb(75, 192, 192)',
	        blue: 'rgb(54, 162, 235)',
	        purple: 'rgb(153, 102, 255)',
	        grey: 'rgb(201, 203, 207)'
	      };
	
	      var color = baseColors[(0, _keys2.default)(baseColors)[index]];
	
	      if (!color) {
	        color = 'rgb(' + Math.floor(Math.random() * 255 + 0) + ',' + Math.floor(Math.random() * 255 + 0) + ',' + Math.floor(Math.random() * 255 + 0) + ')';
	      }
	
	      return color;
	    }
	  },
	  data: function data() {
	    return {
	      chart: null,
	      config: {
	        type: this.getChartType(),
	        data: this.buildDataset(),
	        options: {
	          title: {
	            text: "Chart.js"
	          }
	        }
	      }
	    };
	  }
	});

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(241);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _BaseChart = __webpack_require__(196);
	
	var _BaseChart2 = _interopRequireDefault(_BaseChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseChart2.default.extend({
	  name: "BaseMonodimentionalChart",
	  methods: {
	    buildDataset: function buildDataset() {
	
	      var backgroundColors = [];
	      var borderColors = [];
	
	      for (var counter = 0; counter < (0, _keys2.default)(this.data).length; counter++) {
	
	        var color = this.getColor(counter);
	
	        backgroundColors.push(Chart.helpers.color(color).alpha(0.5).rgbString());
	        borderColors.push(color);
	      }
	
	      return {
	        labels: (0, _keys2.default)(this.data),
	        datasets: [{
	          data: (0, _values2.default)(this.data),
	          backgroundColor: backgroundColors,
	          borderColor: borderColors,
	          fill: false
	        }]
	      };
	    }
	  }
	});

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _BaseChart = __webpack_require__(196);
	
	var _BaseChart2 = _interopRequireDefault(_BaseChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseChart2.default.extend({
	  name: "BaseMultidimentionalChart",
	  methods: {
	    buildDataset: function buildDataset() {
	      var datasets = [];
	
	      var reference = this.data[(0, _keys2.default)(this.data)[0]];
	
	      var counter = 0;
	      for (var propertyName in reference) {
	
	        var color = this.getColor(counter);
	
	        var data = [];
	
	        for (var keyName in this.data) {
	          var item = this.data[keyName];
	          data.push(item[propertyName]);
	        }
	
	        datasets.push({
	          label: propertyName,
	          backgroundColor: Chart.helpers.color(color).alpha(0.5).rgbString(),
	          borderColor: color,
	          fill: false,
	          data: data
	        });
	
	        counter++;
	      }
	
	      return {
	        labels: (0, _keys2.default)(this.data),
	        datasets: datasets
	      };
	    }
	  }
	});

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseMultidimentionalChart = __webpack_require__(197);
	
	var _BaseMultidimentionalChart2 = _interopRequireDefault(_BaseMultidimentionalChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseMultidimentionalChart2.default.extend({
	  name: "HorizontalBarChart",
	  methods: {
	    getChartType: function getChartType() {
	      return "horizontalBar";
	    }
	  }
	});

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseMultidimentionalChart = __webpack_require__(197);
	
	var _BaseMultidimentionalChart2 = _interopRequireDefault(_BaseMultidimentionalChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseMultidimentionalChart2.default.extend({
	  name: "LineChart",
	  methods: {
	    getChartType: function getChartType() {
	      return "line";
	    }
	  }
	});

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseMonodimentionalChart = __webpack_require__(2007);
	
	var _BaseMonodimentionalChart2 = _interopRequireDefault(_BaseMonodimentionalChart);
	
	var _chart = __webpack_require__(244);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseMonodimentionalChart2.default.extend({
	  name: "PolarChart",
	  methods: {
	    customBuilder: function customBuilder(context) {
	      return new _chart2.default.PolarArea(context, this.config);
	    },
	    getChartType: function getChartType() {
	      return "polar";
	    }
	  }
	});

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    methods: {
	        isClosable: function isClosable() {
	            return !(this.closable === undefined || this.closable === false);
	        }
	    },
	    props: ['color', 'size', 'closable']
	};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BookingModeSelect',
	  data: function data() {
	
	    return {
	      bookingModes: {},
	      selected: this.value
	    };
	  },
	
	  props: {
	    value: {},
	    isFilter: {
	      type: Boolean,
	      default: false
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    type: {
	      type: String,
	      default: 'select'
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.reservations.list().modes(function (data) {
	      (0, _keys2.default)(data).map(function (key) {
	        data[key] = data[key].replace('App\\Models\\ConcreteReservations\\', '').replace('Reservation', '');
	      });
	
	      _this.bookingModes = data;
	    });
	  }
	};

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card10",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card3",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card4",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card5",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card6",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card7",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        },
	        shouldShrink: function shouldShrink(slot) {
	
	            var t = false;
	            if (this.shrink) {
	
	                this.shrink.forEach(function (item) {
	
	                    if (item[slot]) {
	                        t = true;
	                    }
	                });
	            }
	
	            return t;
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction', 'shrink']
	};

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card8",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card9",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'CardN',
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        },
	        shouldShrink: function shouldShrink(slot) {
	
	            var t = false;
	            if (this.shrink) {
	
	                this.shrink.forEach(function (item) {
	
	                    if (item[slot]) {
	                        t = true;
	                    }
	                });
	            }
	
	            return t;
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction', 'shrink', 'columns']
	};

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Cards',
	  components: {
	    Dropdown: _Dropdown2.default,
	    LoadingSpinner: _LoadingSpinner2.default
	  },
	  props: ['data'],
	  computed: {
	    classes: function classes() {
	      if (this.data.length === 1) {
	        return 'small-12';
	      } else {
	        return 'small-12 medium-4 large-3';
	      }
	    }
	  }
	};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1884);
	
	__webpack_require__(1353);
	
	exports.default = {
	  name: 'DatePicker',
	  components: {},
	  data: function data() {
	    return {};
	  },
	  destroyed: function destroyed() {
	    var destroyFast = function destroyFast(container) {
	      var el = document.getElementsByClassName(container);
	      while (el.length > 0) {
	        el[0].remove();
	      }
	    };
	    destroyFast('datepicker datepicker-dropdown dropdown-menu');
	  },
	  mounted: function mounted() {
	    var self = this;
	    $(this.$el).find('.date-picker').fdatepicker({
	      format: this.format,
	      pickTime: this.pickTime,
	      closeButton: this.closeButton,
	      onRender: function onRender(date) {
	        if (self.disabledFrom) {
	          var now = new Date(self.disabledFrom);
	          return date.valueOf() < now.valueOf() ? 'disabled' : '';
	        }
	      }
	    }).trigger('change').on('change', function () {
	      var date = self.format === undefined ? this.value.split('-').reverse().join('-') : this.value;
	      self.$emit('input', date);
	    });
	  },
	
	  props: {
	    pickTime: {
	      type: Boolean,
	      default: false
	    },
	    closeButton: {
	      type: Boolean,
	      default: false
	    },
	    format: {
	      type: String,
	      default: 'yyyy-mm-dd'
	    },
	    placeholder: {
	      type: String,
	      default: ''
	    },
	    initialDate: {
	      type: String
	    },
	    disabledFrom: {
	      type: String
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    value: {},
	    ClearCb: function ClearCb() {
	      type: Function;
	    }
	  }
	};

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueCtkDateTimePicker = __webpack_require__(1895);
	
	var _vueCtkDateTimePicker2 = _interopRequireDefault(_vueCtkDateTimePicker);
	
	__webpack_require__(1355);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DateRangePicker',
	  components: {
	    VueCtkRangeDatePicker: _vueCtkDateTimePicker2.default
	  },
	  data: function data() {
	    return {
	      internalValue: null
	    };
	  },
	
	  props: {
	    value: {
	      type: Object,
	      default: function _default() {
	        return {
	          start: null,
	          end: null
	        };
	      }
	    },
	    label: { type: String, default: "Select range" },
	    format: { type: String, default: "YYYY-MM-DD" }
	  },
	  created: function created() {
	    this.internalValue = this.value;
	  },
	
	  watch: {
	    internalValue: function internalValue() {
	      var i = this.internalValue;
	      if (i === null) {
	        this.$emit('input', {
	          start: null,
	          end: null
	        });
	      } else if (i.start && i.end) {
	        this.$emit('input', this.internalValue);
	      }
	    },
	    value: function value(newVal) {
	      this.internalValue = newVal;
	    }
	  }
	};

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: {
	        id: {
	            type: String,
	            required: true
	        },
	        url: {
	            type: String,
	            required: true
	        },
	        clickable: {
	            type: Boolean,
	            default: true
	        },
	        acceptedFileTypes: {
	            type: String
	        },
	        thumbnailHeight: {
	            type: Number,
	            default: 200
	        },
	        thumbnailWidth: {
	            type: Number,
	            default: 200
	        },
	        showRemoveLink: {
	            type: Boolean,
	            default: true
	        },
	        maxFileSizeInMB: {
	            type: Number,
	            default: 40
	        },
	        maxNumberOfFiles: {
	            type: Number,
	            default: 10
	        },
	        autoProcessQueue: {
	            type: Boolean,
	            default: true
	        },
	        useFontAwesome: {
	            type: Boolean,
	            default: true
	        },
	        headers: {
	            type: Object
	        },
	        language: {
	            type: Object,
	            default: function _default() {
	                return {
	                    dictDefaultMessage: '<br>Drop files here to upload',
	                    dictCancelUpload: 'Cancel upload',
	                    dictCancelUploadConfirmation: 'Are you sure you want to cancel this upload?',
	                    dictFallbackMessage: 'Your browser does not support drag and drop file uploads.',
	                    dictFallbackText: 'Please use the fallback form below to upload your files like in the olden days.',
	                    dictFileTooBig: 'File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.',
	                    dictInvalidFileType: 'You can\'t upload files of this type.',
	                    dictMaxFilesExceeded: 'You can not upload any more files. (max: {{maxFiles}})',
	                    dictRemoveFile: 'Remove',
	                    dictRemoveFileConfirmation: null,
	                    dictResponseError: 'Server responded with {{statusCode}} code.'
	                };
	            }
	        },
	        useCustomDropzoneOptions: {
	            type: Boolean,
	            default: false
	        },
	        dropzoneOptions: {
	            type: Object
	        }
	    },
	    methods: {
	        setOption: function setOption(option, value) {
	            this.dropzone.options[option] = value;
	        },
	        removeAllFiles: function removeAllFiles() {
	            this.dropzone.removeAllFiles(true);
	        },
	        processQueue: function processQueue() {
	            this.dropzone.processQueue();
	        },
	        removeFile: function removeFile(file) {
	            this.dropzone.removeFile(file);
	        }
	    },
	    computed: {
	        cloudIcon: function cloudIcon() {
	            if (this.useFontAwesome) {
	                return '<i class="fa fa-cloud-upload"></i>';
	            } else {
	                return '<i class="material-icons">cloud_upload</i>';
	            }
	        },
	        doneIcon: function doneIcon() {
	            if (this.useFontAwesome) {
	                return '<i class="fa fa-check"></i>';
	            } else {
	                return ' <i class="material-icons">done</i>';
	            }
	        },
	        errorIcon: function errorIcon() {
	            if (this.useFontAwesome) {
	                return '<i class="fa fa-close"></i>';
	            } else {
	                return ' <i class="material-icons">error</i>';
	            }
	        }
	    },
	    mounted: function mounted() {
	        if (this.$isServer) {
	            return;
	        }
	
	        var Dropzone = __webpack_require__(1352);
	        Dropzone.autoDiscover = false;
	        var element = document.getElementById(this.id);
	        if (!this.useCustomDropzoneOptions) {
	            this.dropzone = new Dropzone(element, {
	                clickable: this.clickable,
	                thumbnailWidth: this.thumbnailWidth,
	                thumbnailHeight: this.thumbnailHeight,
	                maxFiles: this.maxNumberOfFiles,
	                maxFilesize: this.maxFileSizeInMB,
	                addRemoveLinks: this.showRemoveLink,
	                acceptedFiles: this.acceptedFileTypes,
	                autoProcessQueue: this.autoProcessQueue,
	                headers: this.headers,
	                previewTemplate: '<div class="dz-preview dz-file-preview"> <div class="dz-image" style="width:' + this.thumbnailWidth + 'px;height:' + this.thumbnailHeight + 'px"><img data-dz-thumbnail /></div>  <div class="dz-details">    <div class="dz-size"><span data-dz-size></span></div>    <div class="dz-filename"><span data-dz-name></span></div>  </div>  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>  <div class="dz-error-message"><span data-dz-errormessage></span></div>  <div class="dz-success-mark">' + this.doneIcon + ' </div>  <div class="dz-error-mark">' + this.errorIcon + '</div></div>',
	                dictDefaultMessage: this.cloudIcon + this.language.dictDefaultMessage,
	                dictCancelUpload: this.language.dictCancelUpload,
	                dictCancelUploadConfirmation: this.language.dictCancelUploadConfirmation,
	                dictFallbackMessage: this.language.dictFallbackMessage,
	                dictFallbackText: this.language.dictFallbackText,
	                dictFileTooBig: this.language.dictFileTooBig,
	                dictInvalidFileType: this.language.dictInvalidFileType,
	                dictMaxFilesExceeded: this.language.dictMaxFilesExceeded,
	                dictRemoveFile: this.language.dictRemoveFile,
	                dictRemoveFileConfirmation: this.language.dictRemoveFileConfirmation,
	                dictResponseError: this.language.dictResponseError
	            });
	        } else {
	            this.dropzone = new Dropzone(element, this.dropzoneOptions);
	        }
	
	        var vm = this;
	        this.dropzone.on('thumbnail', function (file) {
	            vm.$emit('vdropzone-thumbnail', file);
	        });
	        this.dropzone.on('addedfile', function (file) {
	            vm.$emit('vdropzone-file-added', file);
	        });
	
	        this.dropzone.on('removedfile', function (file) {
	            vm.$emit('vdropzone-removed-file', file);
	        });
	
	        this.dropzone.on('success', function (file, response) {
	            vm.$emit('vdropzone-success', file, response);
	        });
	
	        this.dropzone.on('successmultiple', function (file, response) {
	            vm.$emit('vdropzone-success-multiple', file, response);
	        });
	
	        this.dropzone.on('error', function (file, error, xhr) {
	            vm.$emit('vdropzone-error', file, error, xhr);
	        });
	
	        this.dropzone.on('sending', function (file, xhr, formData) {
	            vm.$emit('vdropzone-sending', file, xhr, formData);
	        });
	
	        this.dropzone.on('sendingmultiple', function (file, xhr, formData) {
	            vm.$emit('vdropzone-sending-multiple', file, xhr, formData);
	        });
	
	        this.dropzone.on('queuecomplete', function (file, xhr, formData) {
	            vm.$emit('vdropzone-queue-complete', file, xhr, formData);
	        });
	    },
	    updated: function updated() {},
	    beforeDestroy: function beforeDestroy() {
	        this.dropzone.destroy();
	    }
	};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(10);
	
	exports.default = {
	  name: 'IsModuleEnabled',
	  components: {},
	  data: function data() {
	    return {
	      moduleEnabled: false
	    };
	  },
	  mounted: function mounted() {},
	
	  props: {
	    module: String
	  },
	  computed: {}
	};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _MdiIcon = __webpack_require__(80);
	
	var _MdiIcon2 = _interopRequireDefault(_MdiIcon);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'KeplerFileUpload',
	  components: { ActionButton: _ActionButton2.default, MdiIcon: _MdiIcon2.default },
	  data: function data() {
	    return {
	      response: null,
	      prefix: '',
	      visibility: null,
	      filename: null,
	      listing: [],
	      advanced: false
	    };
	  },
	  mounted: function mounted() {
	    if (this.selectedPrefix) {
	      this.prefix = this.selectedPrefix;
	    }
	    if (this.selectedVisibility) {
	      this.visibility = this.selectedVisibility;
	    }
	    this.listPublic();
	  },
	
	
	  methods: {
	    listPublic: function listPublic() {
	      var _this = this;
	
	      this.listing = null;
	      _backoffice2.default.files.list.public(this.prefix, function (data) {
	        _this.listing = data;
	      });
	    },
	    startUpload: function startUpload() {
	      var _this2 = this;
	
	      var file = this.$refs.file.files[0];
	      _backoffice2.default.files.uploadImage(file, this.visibility, this.prefix, this.filename, function (data) {
	        _maggieHelper2.default.notification('upload', 'File uploaded successfully');
	
	        _this2.$emit('sel', data.internal_path);
	        _this2.listPublic();
	      });
	    },
	    getMime: function getMime(file) {
	      switch (file.mime) {
	        case 'pdf':
	          return 'fa-file-pdf-o';
	        case 'svg':
	          return 'fa-file-code-o';
	        default:
	          return 'fa-file';
	      }
	    },
	    imageSelected: function imageSelected(l) {
	      if (!this.selectable) {
	        _maggieHelper2.default.notification('upload', 'File path copied on the clipboard');
	        navigator.clipboard.writeText(l.internal_path);
	        return;
	      }
	      this.$emit('sel', l.internal_path);
	      _maggieHelper2.default.notification('upload', 'File selected successfully');
	      this.advanced = false;
	    },
	    deleteFile: function deleteFile(internalPath) {
	      var _this3 = this;
	
	      return _backoffice2.default.files.remove(internalPath, function () {
	        _maggieHelper2.default.notification('Deleted', 'File deleted sucessfully');
	        _this3.listPublic();
	      });
	    },
	
	    openUrl: function openUrl() {
	      window.open(this.fileUrl, '_blank');
	    },
	
	    preview: function preview(file) {
	      var extension = file.mime;
	      switch (extension) {
	        case 'png':
	        case 'jpg':
	        case 'jpeg':
	          return true;
	        default:
	          return false;
	      }
	    },
	    cardStyle: function cardStyle(item) {
	      if (this.preview(item)) {
	        return {
	          backgroundImage: 'url(' + item.external_url + ')',
	          width: '100%',
	          height: '150px',
	          backgroundRepeat: 'no-repeat',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          cursor: "pointer",
	          flexGrow: 1
	
	        };
	      }
	      return {
	        height: '150px',
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center',
	        cursor: "pointer",
	        flexGrow: 1
	      };
	    }
	  },
	  props: {
	    visibilityOptions: {
	      type: Array,
	      default: function _default() {
	        return ['public', 'private'];
	      }
	    },
	    prefixOptions: {
	      type: Array,
	      default: function _default() {
	        return ['vehicles', 'vehicle-brands', 'vehicle-categories', 'parking-lot', 'plans', 'tocs', 'vehicle-instructions', 'damage-picture'];
	      }
	    },
	    selectedPrefix: {
	      type: String
	    },
	    selectedVisibility: {
	      type: String
	    },
	    previewUrl: {
	      type: String
	    },
	    previewOnly: {
	      type: Boolean,
	      default: false
	    },
	    selectable: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    canPreview: function canPreview() {
	      if (this.previewUrl) {
	        var extension = this.previewUrl.split('.')[1];
	        switch (extension) {
	          case 'pdf':
	            return false;
	          default:
	            return true;
	        }
	      }
	
	      return false;
	    },
	    previewStyle: function previewStyle() {
	      return {
	        backgroundImage: 'url(' + this.fileUrl + ')',
	        height: '200px',
	        width: '100%',
	        backgroundRepeat: 'no-repeat',
	        backgroundSize: 'cover',
	        backgroundPosition: 'center center'
	      };
	    },
	    fileUrl: function fileUrl() {
	      return window.env.API_URL + '/storage/' + this.previewUrl;
	    }
	  }
	};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "LoadingSpinner",
	  props: {
	    height: {
	      type: String,
	      default: "130px"
	    }
	  }
	};

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Login",
	    data: function data() {
	        return {
	            login: {
	                username: null,
	                password: null
	            }
	        };
	    },
	
	    methods: {
	        formSubmit: function formSubmit() {
	            this.$emit('login', this.login);
	        }
	    }
	};

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Notification",
	    methods: {
	        removeNotification: function removeNotification() {
	            this.$store.dispatch('removeNotification', this.notification);
	        }
	    },
	    created: function created() {
	        var _this = this;
	
	        setTimeout(function () {
	            _this.removeNotification();
	        }, 5000);
	    },
	
	    props: ['notification']
	};

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _vuex = __webpack_require__(10);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	var _QuickSearch = __webpack_require__(2026);
	
	var _QuickSearch2 = _interopRequireDefault(_QuickSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'OffCanvas',
	  components: { QuickSearch: _QuickSearch2.default, SearchEntity: _SearchEntity2.default },
	  data: function data() {
	    return {
	      component: null,
	      userAuthenticated: _maggieHelper2.default.isAdminLoggedIn(),
	      time: null,
	      extra_pages: [],
	      searchOpen: false
	    };
	  },
	
	  props: ['menu_pages', 'title', 'action'],
	  computed: (0, _extends3.default)({
	    logo: function logo() {
	      if (window && window.env) {
	        return window.env.LOGO;
	      }
	    },
	    hideForAcl: function hideForAcl() {
	      return this.$route.name === 'plans' && !this.$acl('index-plan');
	    }
	  }, (0, _vuex.mapState)({
	    userStore: function userStore(state) {
	      return state.userStore.user;
	    }
	  })),
	  methods: {
	    getTime: function getTime() {
	      this.time = this.$dateFormat(new Date(), 'DD-MM-YYYY [ore] HH:mm:ss');
	    },
	    closeMenu: function closeMenu() {
	      $('#offCanvasLeft').foundation('close');
	    },
	    destroy: function destroy() {
	      this.component = null;
	    },
	    reload: function reload() {
	      window.location.reload(true);
	    },
	    gotoEntity: function gotoEntity(id, entity) {
	      switch (entity) {
	        case 'clients':
	          this.$router.push({ name: 'client', params: { id: id } });
	          break;
	        case 'drivers':
	          this.$router.push({ name: 'driver', params: { id: id } });
	          break;
	      }
	
	      this.searchOpen = false;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this.extra_pages = data.backoffice.backoffice_extra_menu_links.value;
	    });
	
	    this.getTime();
	    _maggieHelper2.default.registerCallback(function (payload) {
	      switch (payload.position) {
	        case 'right':
	          $('#offCanvasRight').foundation('toggle');
	          break;
	        case 'top':
	          break;
	      }
	      _this.component = payload;
	    });
	  },
	  updated: function updated() {
	    this.userAuthenticated = _maggieHelper2.default.isAdminLoggedIn();
	  },
	
	
	  watch: {
	    time: function time() {
	      setTimeout(this.getTime, 2000);
	    }
	  }
	};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RangePicker',
	  data: function data() {
	    return {
	      rangeLabel: null
	    };
	  },
	
	  props: {
	    value: {},
	    startDate: { type: String },
	    endDate: { type: String },
	    label: {
	      type: String
	    }
	  },
	  methods: {
	    rangeSelected: function rangeSelected(date) {
	      this.rangeLabel = date[0].format('YYYY-MM-DD') + ' - ' + date[1].format('YYYY-MM-DD');
	      this.$emit('input', { from: date[0].format('YYYY-MM-DD'), to: date[1].format('YYYY-MM-DD') });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    dateFormat: function dateFormat() {
	      return this.$toMomentFormat(this.configuration.locale.locale_date_format.value);
	    },
	    textLabel: function textLabel() {
	      var selectedRange = this.startDate !== undefined && this.endDate !== undefined;
	      if (this.rangeLabel !== null) {
	        return this.rangeLabel;
	      }
	      return selectedRange ? this.startDate + ' - ' + this.endDate : 'Select date range';
	    }
	  })
	};

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "SelectionList",
	    components: {},
	    data: function data() {
	        return {
	            selectedItem: null
	        };
	    },
	    methods: {
	        selectItem: function selectItem(index) {
	            this.selectedItem = this.items[index];
	        },
	        updated: function updated(payload) {
	            this.$emit("updated", payload);
	        }
	    },
	    props: {
	        component: Object,
	        items: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    }
	};

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _jquery = __webpack_require__(389);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1891);
	
	exports.default = {
	  name: "Selectize",
	  data: function data() {
	    return {
	      container: null,
	      selectize: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      return _this.loadSelectize();
	    });
	  },
	
	  methods: {
	    loadSelectize: function loadSelectize() {
	      var _this2 = this;
	
	      var selectize = (0, _jquery2.default)('#' + this._uid + '-selectize');
	
	      selectize.selectize({
	        maxItems: this.maxItems,
	        valueField: this.valueField,
	        labelField: this.labelField,
	        searchField: this.searchField,
	        items: this.items,
	        render: {
	          item: function item(_item, escape) {
	            return _this2.renderTemplate(_item, escape);
	          },
	          option: function option(item, escape) {
	            return _this2.optionTemplate(item, escape);
	          }
	        }
	      });
	
	      this.selectize = selectize[0].selectize;
	      this.options.forEach(function (item) {
	        _this2.addOption(item);
	      });
	
	      if (this.items) {
	        this.items.forEach(function (item) {
	          _this2.selectize.addItem(item, true);
	        });
	      }
	
	      this.selectize.on('item_add', this.itemAdded);
	      this.selectize.on('item_remove', this.itemRemoved);
	
	      if (this.selectedValue) {
	        this.selectize.setValue(this.selectedValue);
	      }
	      if (this.value) {
	        this.selectize.setValue(this.value);
	      }
	    },
	    itemAdded: function itemAdded(value) {
	      this.$emit('itemAdded', this.selectize.sifter.items[value]);
	    },
	    itemRemoved: function itemRemoved(value) {
	      this.$emit('itemRemoved', this.selectize.sifter.items[value]);
	    },
	    clearOptions: function clearOptions() {
	      this.selectize.clearOptions();
	    },
	    clearSelected: function clearSelected() {
	      this.selectize.clear();
	    },
	    addOption: function addOption(option) {
	      this.selectize.addOption(option);
	    }
	  },
	  computed: {},
	  props: {
	    maxItems: {
	      type: Number,
	      default: null
	    },
	    options: {
	      type: Array,
	      required: true
	    },
	    valueField: {
	      type: String,
	      default: function _default() {
	        return 'name';
	      }
	    },
	    labelField: {
	      type: String,
	      default: function _default() {
	        return 'name';
	      }
	    },
	
	    items: {
	      type: Array
	    },
	
	    searchField: {
	      type: Array,
	      default: function _default() {
	        var fields = [];
	        for (var key in this.options) {
	          fields = (0, _keys2.default)(this.options[key]);
	          break;
	        }
	        return fields;
	      }
	    },
	
	    optionTemplate: {
	      type: Function,
	      default: function _default(item, escape) {
	        return '<div>' + item.name + '</div>';
	      }
	    },
	
	    renderTemplate: {
	      type: Function,
	      default: function _default(item, escape) {
	        return '<div>' + item.name + '</div>';
	      }
	    },
	    placeholder: {
	      type: String
	    },
	    selectedValue: {},
	    disabled: {
	      type: Boolean
	    },
	    showAdd: {
	      type: Boolean
	    },
	    value: {}
	  },
	  watch: {
	    disabled: function disabled() {
	      this.disabled ? this.selectize.disable() : this.selectize.enable();
	    },
	    value: function value(v) {
	      if (v && this.selectize) {
	        this.selectize.setValue(v);
	      }
	    }
	  }
	};

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _SmartEditField = __webpack_require__(2017);
	
	var _SmartEditField2 = _interopRequireDefault(_SmartEditField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: { SmartEditField: _SmartEditField2.default },
	    name: "SmartEdit",
	    data: function data() {
	        return {
	            mutableItem: this.value
	        };
	    },
	
	    watch: {
	        mutableItem: function mutableItem(newValue, oldValue) {
	            this.$emit('input', newValue);
	        },
	        value: function value(newValue, oldValue) {
	            if ((0, _stringify2.default)(newValue) !== (0, _stringify2.default)(this.mutableItem)) {
	                this.mutableItem = newValue;
	            }
	        }
	    },
	    props: ['value', 'options']
	};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapMarker = __webpack_require__(72);
	
	var _GoogleMapMarker2 = _interopRequireDefault(_GoogleMapMarker);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { TranslateField: _TranslateField2.default, GoogleMapContainer: _GoogleMapContainer2.default, Editor: _Editor2.default, KeplerFileUpload: _KeplerFileUpload2.default, DatePicker: _DatePicker2.default, GoogleMap: _GoogleMap2.default, GoogleMapMarker: _GoogleMapMarker2.default },
	  name: "SmartEditField",
	  data: function data() {
	    return {
	      mutableField: this.value
	    };
	  },
	  watch: {
	    mutableField: function mutableField(newValue) {
	      this.$emit('input', newValue);
	    },
	    value: function value(newValue, oldValue) {
	      if ((0, _stringify2.default)(newValue) !== (0, _stringify2.default)(this.mutableItem)) {
	        this.mutableField = newValue;
	      }
	    }
	  },
	  methods: {
	    handleFileSelector: function handleFileSelector(path) {
	      this.mutableField = path;
	      this.showFileSelector = false;
	    },
	    mapClicked: function mapClicked(e) {
	      this.mutableField = { lat: e.lat(), lng: e.lng() };
	      this.$refs.marker.setPosition(this.mutableField);
	    }
	  },
	  computed: {
	    mapsAPI: function mapsAPI() {
	      return window.env.GOOGLE_MAPS_KEY;
	    },
	    type: function type() {
	      if (!this.options.types) {
	        return 'text';
	      }
	      if (this.options.types[this.name]) {
	        return this.options.types[this.name];
	      } else {
	        return 'text';
	      }
	    },
	    title: function title() {
	      if (this.options.translations[this.name]) {
	        return this.options.translations[this.name];
	      } else {
	        return this.name;
	      }
	    },
	    shouldShow: function shouldShow() {
	      var inList = this.options.list.indexOf(this.name) != -1;
	      switch (this.options.listMode) {
	        case 'whitelist':
	          return inList;
	          break;
	        case 'blacklist':
	          return !inList;
	          break;
	        default:
	          console.warn("No valid list mode for SmartEdit, using whitelist");
	          return inList;
	      }
	    },
	    shouldDisable: function shouldDisable() {
	      var inList = this.options.disabled.indexOf(this.name) != -1;
	      return inList;
	    }
	  },
	  props: ['value', 'name', 'options', 'entity']
	};

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Card7",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BaseForm",
	  props: {
	    value: Object
	  },
	  data: function data() {
	    return {
	      localValue: (0, _extends3.default)({}, this.value)
	    };
	  },
	
	  watch: {
	    localValue: {
	      handler: function handler() {
	        this.$emit('input', this.localValue);
	      },
	
	      deep: true
	    }
	  }
	};

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SelectizeDocumentType = __webpack_require__(81);
	
	var _SelectizeDocumentType2 = _interopRequireDefault(_SelectizeDocumentType);
	
	var _BaseForm = __webpack_require__(141);
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocumentRequirementForm',
	  extends: _BaseForm2.default,
	  components: { SelectizeDocumentType: _SelectizeDocumentType2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    documentTypeSelected: function documentTypeSelected(obj) {
	      this.localValue.document_type_id = obj.id;
	    }
	  },
	  props: ['value']
	};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseForm = __webpack_require__(141);
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocumentTypeForm',
	  extends: _BaseForm2.default,
	  components: {},
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  props: ['value']
	};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseForm = __webpack_require__(141);
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SelectizeInterventionRequest = __webpack_require__(2097);
	
	var _SelectizeInterventionRequest2 = _interopRequireDefault(_SelectizeInterventionRequest);
	
	var _SelectizeMaintenanceDriver = __webpack_require__(587);
	
	var _SelectizeMaintenanceDriver2 = _interopRequireDefault(_SelectizeMaintenanceDriver);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "InterventionRequestForm",
	  extends: _BaseForm2.default,
	  components: {
	    InputSwitch: _InputSwitch2.default,
	    SelectizeMaintenanceDriver: _SelectizeMaintenanceDriver2.default, SelectizeInterventionRequest: _SelectizeInterventionRequest2.default, DatePicker: _DatePicker2.default, SelectizeVehicle: _SelectizeVehicle2.default, BaseForm: _BaseForm2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    setVehicle: function setVehicle(obj) {
	      this.localValue.linked_intervention_request_id = obj.id;
	      this.localValue.vehicle_id = obj.vehicle.id;
	      this.$emit('input', this.localValue);
	    },
	    unSetVehicle: function unSetVehicle() {
	      this.localValue.linked_intervention_request_id = null;
	      this.localValue.vehicle_id = null;
	      this.$emit('input', this.localValue);
	    }
	  },
	  props: {
	    subRequest: {
	      default: false
	    },
	    edit: {
	      default: false
	    }
	  }
	};

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseForm = __webpack_require__(141);
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PacketForm",
	  extends: _BaseForm2.default,
	  components: { TranslateField: _TranslateField2.default, BaseForm: _BaseForm2.default, Editor: _Editor2.default }
	};

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Accordion",
	    components: {},
	    data: function data() {
	        return {};
	    },
	
	    methods: {},
	    props: ['titles', 'multiExpand', 'allClosed']
	};

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "Accordion",
	  mounted: function mounted() {
	    this.accordion = new Foundation.Accordion($(this.$el));
	  },
	  updated: function updated() {
	    if (this.accordion) {
	      this.accordion.destroy();
	      this.accordion = new Foundation.Accordion($(this.$el));
	    }
	  },
	  destroyed: function destroyed() {
	    this.accordion.destroy();
	  }
	};

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "AccordionItem",
	  components: {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  props: ['title']
	};

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Dropdown",
	    components: {},
	    data: function data() {
	        return {
	            mounted: false
	        };
	    },
	    mounted: function mounted() {
	        this.mounted = true;
	    },
	
	    methods: {},
	    props: ['position', 'icon']
	};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventBus = __webpack_require__(15);
	
	exports.default = {
	  name: 'ModalReveal',
	  components: {},
	  data: function data() {
	    return {
	      showModal: false
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      if (val) {
	        this.openModal();
	      } else {
	        this.close();
	      }
	    }
	  },
	  created: function created() {},
	
	  methods: {
	    close: function close() {
	      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      _eventBus.EventBus.$off('close-modal');
	      this.$emit('input', false);
	      this.showModal = false;
	      var killThis = id !== null ? id : this.id;
	      var destroyFast = function destroyFast(container) {
	        var el = document.getElementById(container);
	        while (el.firstChild) {
	          if ('' + el.firstChild.id === killThis) {
	            el.removeChild(el.firstChild);
	          }
	          break;
	        }
	      };
	      destroyFast('global-modal-container');
	    },
	    openModal: function openModal() {
	      var _this = this;
	
	      this.showModal = true;
	      _eventBus.EventBus.$on('close-modal', function (id) {
	        console.log(id);
	        _this.close(id);
	      });
	      document.getElementById('global-modal-container').appendChild(this.$refs[this.id]);
	      this.$emit('modalOpen');
	    }
	  },
	  props: {
	    sizing: {
	      type: String,
	      default: 'large'
	    },
	    id: {
	      type: String,
	      default: function _default() {
	        return 'r-' + this._uid;
	      }
	    },
	    resetOnClose: {
	      type: Boolean,
	      default: true
	    },
	    value: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(162);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: '',
	    components: {},
	    data: function data() {
	        return {
	            pageCount: null
	        };
	    },
	    created: function created() {},
	
	    methods: {
	        updatePage: function updatePage(index) {
	            this.$emit('pageUpdated', index);
	        },
	        pagination: function pagination(c, last) {
	            var current = c,
	                delta = 5,
	                left = current - delta,
	                right = current + delta + 1,
	                range = [],
	                rangeWithDots = [],
	                l;
	
	            for (var i = 1; i <= last; i++) {
	                if (i == 1 || i == last || i >= left && i < right) {
	                    range.push(i);
	                }
	            }
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(range), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _i = _step.value;
	
	                    if (l) {
	                        if (_i - l === 2) {
	                            rangeWithDots.push(l + 1);
	                        } else if (_i - l !== 1) {
	                            rangeWithDots.push(false);
	                        }
	                    }
	                    rangeWithDots.push(_i);
	                    l = _i;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return rangeWithDots;
	        }
	    },
	    computed: {
	        pages: function pages() {
	            var computedPageCount = Math.ceil(this.results / this.perPage);
	            if (!this.pageCount === null || computedPageCount > 0) {
	                this.pageCount = computedPageCount;
	            }
	
	            return this.pagination(this.currentPage, this.pageCount);
	        }
	    },
	    props: ['results', 'perPage', 'currentPage']
	};

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "FoundationReveal",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    props: ['id', 'options']
	};

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "RouterTabHeaders",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	    mounted: function mounted() {},
	
	    methods: {},
	    props: {
	        tabs: Array
	    }
	};

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "TabContent",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    mounted: function mounted() {},
	
	    props: ['headerName', 'id', 'active']
	};

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "TabHeaders",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    mounted: function mounted() {
	        $(this.$el).find('#' + this.id).foundation();
	    },
	    created: function created() {},
	
	    methods: {},
	    props: {
	        tabs: Array,
	        id: String,
	        activeIndex: Number,
	        deepLink: Boolean
	    }
	};

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "FoundationTooltip",
	    props: ['tip', 'open', 'position']
	};

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "simpleColumns2",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "simpleColumns3-3",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        actionClicked: function actionClicked() {
	            this.$emit('actionClicked');
	        },
	        bulletsClicked: function bulletsClicked() {
	            this.$emit('bulletsClicked');
	        }
	    },
	    computed: {},
	    props: ['showBullets', 'showAction']
	};

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "Thumbnail",
	  data: function data() {
	    return {};
	  },
	
	  props: {
	    image: {
	      type: String,
	      default: ''
	    }
	  },
	  computed: {
	    thumbStyle: function thumbStyle() {
	      return {
	        backgroundImage: "url(" + this.image + ")"
	      };
	    }
	  }
	};

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'ActionBar',
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    props: {
	        inverted: {
	            type: Boolean,
	            default: false
	        }
	
	    }
	};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ActionButton',
	  components: { ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      spin: false
	    };
	  },
	
	  methods: {
	    call: function call() {
	      var _this = this;
	
	      if (this.confirm) {
	        this.$confirm('Are you sure?', 'Do you really want to continue?', function () {
	          _this.callAction();
	        });
	      } else if (this.$scopedSlots.prompt !== undefined) {
	        this.$refs.prompt.openModal();
	      } else {
	        this.callAction();
	      }
	    },
	    callAction: function callAction() {
	      var _this2 = this;
	
	      this.spin = true;
	      this.action(this.value).then(function () {
	        _this2.spin = false;
	        if (_this2.$scopedSlots.prompt !== undefined) {
	          _this2.$refs.prompt.close();
	        }
	      }).catch(function () {
	        _this2.spin = false;
	        if (_this2.$scopedSlots.prompt !== undefined) {
	          _this2.$refs.prompt.close();
	        }
	      });
	    }
	  },
	  props: {
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    colorClass: {
	      type: String
	    },
	    button: {
	      type: Boolean,
	      default: true
	    },
	    action: {
	      default: function _default() {
	        return _promise2.default.resolve();
	      }
	    },
	    confirm: {
	      type: Boolean,
	      default: false
	    },
	    value: {
	      default: null
	    }
	  }
	};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ArrayEdit',
	  data: function data() {
	    return {
	      newName: null
	    };
	  },
	
	  methods: {
	    addField: function addField() {
	      try {
	        var values = JSON.parse("" + this.newName);
	
	        for (var key in values) {
	          this.$set(this.values, key, values[key]);
	        }
	        this.newName = null;
	      } catch (e) {
	        this.$set(this.values, this.newName, "--");
	        this.newName = null;
	        return false;
	      }
	    },
	    removeField: function removeField(label) {
	      this.$delete(this.values, label);
	    }
	  },
	  props: {
	    values: {
	      type: Object
	    },
	    options: {}
	  }
	};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Reservation = __webpack_require__(37);
	
	var _Reservation2 = _interopRequireDefault(_Reservation);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _VehicleAvailability = __webpack_require__(137);
	
	var _VehicleAvailability2 = _interopRequireDefault(_VehicleAvailability);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _GoogleMapSearchBox = __webpack_require__(592);
	
	var _GoogleMapSearchBox2 = _interopRequireDefault(_GoogleMapSearchBox);
	
	var _SelectizeCommonCost = __webpack_require__(71);
	
	var _SelectizeCommonCost2 = _interopRequireDefault(_SelectizeCommonCost);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BookVehicleFromMap = __webpack_require__(1898);
	
	var _BookVehicleFromMap2 = _interopRequireDefault(_BookVehicleFromMap);
	
	var _TabHeaders = __webpack_require__(121);
	
	var _TabHeaders2 = _interopRequireDefault(_TabHeaders);
	
	var _TabContent = __webpack_require__(120);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BookPanel',
	  components: {
	    SearchEntity: _SearchEntity2.default,
	    TabHeaders: _TabHeaders2.default,
	    TabContent: _TabContent2.default,
	    BookVehicleFromMap: _BookVehicleFromMap2.default,
	    SelectizeCommonCost: _SelectizeCommonCost2.default,
	    GoogleMapSearchBox: _GoogleMapSearchBox2.default,
	    BookingModeSelect: _BookingModeSelect2.default,
	    BackofficeVehicleAvailability: _VehicleAvailability2.default,
	    SelectizeVehicle: _SelectizeVehicle2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    Vehicle: _Vehicle2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    KeplerBackofficeSdk: _backoffice2.default,
	    DatePicker: _DatePicker2.default,
	    Reservation: _Reservation2.default
	  },
	
	  data: function data() {
	    return {
	      book: {
	        plate: null,
	        driver_id: null,
	        memo: null,
	        latitude: null,
	        longitude: null,
	        common_costs: [],
	        skip_apply_zone_cost_start: false
	      },
	      start: null,
	      end: null,
	      reservation: null,
	      vehicles: [],
	      booking_mode: 'RT',
	      loading: false,
	      hideSearchFields: false,
	      availability: [],
	      vehicle_id: null,
	      bookDirectly: true,
	      bookDirectlyHide: false,
	      vehicleLength: 0
	    };
	  },
	  created: function created() {
	    this.start = this.bookStart;
	    this.book.start = this.$convertTimestamp(this.bookStart);
	    this.book.end = this.$convertTimestamp(this.bookEnd);
	    this.book.driver_id = this.driverId;
	  },
	
	  methods: {
	    addCommonCost: function addCommonCost(obj) {
	      this.book.common_costs.push(obj.id);
	    },
	    removeCommonCost: function removeCommonCost(obj) {
	      var _this = this;
	
	      this.book.common_costs.find(function (item, key) {
	        if (item === obj.id) {
	          _this.book.common_costs.splice(key, 1);
	        }
	      });
	    },
	    setDriverPosition: function setDriverPosition(place) {
	      this.book.latitude = place.geometry.location.lat();
	      this.book.longitude = place.geometry.location.lng();
	    },
	    setDriverId: function setDriverId(driver) {
	      this.book.driver_id = driver.id;
	    },
	    setVehicle: function setVehicle(object) {
	      this.hideSearchFields = true;
	      this.book.start = this.$convertTimestamp(this.bookStart);
	      this.book.end = this.$convertTimestamp(this.bookEnd);
	      this.book.plate = object.plate;
	      this.vehicle_id = object.id;
	    },
	    unsetVehicle: function unsetVehicle() {
	      this.book.plate = null;
	      this.hideSearchFields = false;
	      this.end = null;
	      this.availability = [];
	    },
	    searchAvailability: function searchAvailability() {
	      var _this2 = this;
	
	      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	
	      _backoffice2.default.vehicles.select(this.vehicle_id, {
	        start: this.$convertTimestamp(this.start),
	        end: this.$convertTimestamp(this.end)
	      }).availability(function (data) {
	        data.forEach(function (a) {
	          (0, _assign2.default)(a, { selected: false });
	        });
	        _this2.availability = data;
	        _this2.availability.forEach(function (item) {
	          if (!item.available) {
	            _this2.bookDirectly = false;
	            _this2.bookDirectlyHide = true;
	          }
	        });
	        if (callback) callback();
	      });
	    },
	    bookNow: function bookNow(vehicle) {
	      this.book.plate = vehicle.plate;
	      this.sendBooking();
	    },
	    setDatesAndBook: function setDatesAndBook(date) {
	      this.book.start = date.start;
	      this.book.end = date.end;
	      this.sendBooking();
	    },
	    sendBooking: function sendBooking() {
	      var _this3 = this;
	
	      _backoffice2.default.reservations.make(this.book, function (response) {
	        _this3.reservation = response;
	        _this3.vehicles = [];
	        _maggieHelper2.default.notification('book-esit', 'reservation created');
	        _this3.$router.push({ name: 'reservation', params: { id: response.id } });
	        _this3.$emit('reservationCreated');
	      });
	    },
	    gridStyle: function gridStyle(slots) {
	      var auto = slots.length > 3 ? 'auto auto auto' : 'repeat(' + slots.length + ',auto)';
	      return {
	        gridTemplateColumns: auto
	      };
	    },
	    dataLoader: function dataLoader() {
	      var _this4 = this;
	
	      this.loading = true;
	      if (this.booking_mode === 'RT' || this.booking_mode === 'CRT') {
	        this.book.start = this.$convertTimestamp(this.start);
	        this.book.end = this.$convertTimestamp(this.end);
	      }
	
	      _backoffice2.default.vehicleSlots.search({
	        start: this.book.start,
	        end: this.book.end,
	        booking_mode: this.booking_mode,
	        latitude: this.book.latitude,
	        longitude: this.book.longitude
	      }, function (data) {
	        _this4.loading = false;
	        var vehicles = data.filter(function (item) {
	          return !item.disabled && !item.dismissed;
	        }).map(function (item) {
	          item.vehicle['distance'] = parseFloat(item.distance / 1000).toFixed(2);
	          return item.vehicle;
	        });
	        _this4.vehicles = vehicles;
	        _this4.vehicleLength = _this4.vehicles.length;
	      });
	    },
	    showExtraDay: function showExtraDay() {
	      this.end = this.$date(this.end).add(1, 'days').hours(23).minutes(30).seconds(0).format('YYYY-MM-DD HH:mm');
	      this.searchAvailability();
	    },
	    bookFast: function bookFast() {
	      var _this5 = this;
	
	      this.searchAvailability(function () {
	        if (_this5.bookDirectly) {
	          _this5.setDatesAndBook({ start: _this5.$convertTimestamp(_this5.start), end: _this5.$convertTimestamp(_this5.end) });
	        }
	      });
	    },
	    rangeSelection: function rangeSelection(range) {
	
	      if (range.start != null) {
	        this.start = _moment2.default.unix(range.start).format('YYYY-MM-DD HH:mm');
	      }
	      if (range.end != null) {
	        this.end = _moment2.default.unix(range.end).format('YYYY-MM-DD HH:mm');
	      }
	    }
	  },
	  computed: {
	    disabledFrom: function disabledFrom() {
	      var date = this.$date();
	      date.subtract(1, 'day');
	      date.hours(23);
	      date.minutes(59);
	      return this.$dateFormat(date, 'YYYY-MM-DD HH:mm');
	    },
	    bookStart: function bookStart() {
	      var date = this.$date();
	      if (date.minutes() < 30) {
	        date.minutes(0);
	      } else {
	        date.minutes(30);
	      }
	      return this.$dateFormat(date, 'YYYY-MM-DD HH:mm');
	    },
	    bookEnd: function bookEnd() {
	      var date = this.$date(this.start);
	      date.minutes(date.minutes() + 30);
	      return this.$dateFormat(date, 'YYYY-MM-DD HH:mm');
	    },
	    disabledSearchButton: function disabledSearchButton() {
	      var rt = this.booking_mode === 'RT';
	      return rt && !this.start && !this.end || !this.book.driver_id;
	    },
	    bookingDates: function bookingDates() {
	      return this.booking_mode === 'RT' ? {
	        start: this.book.start,
	        end: this.book.end
	      } : {
	        start: this.$date().unix(),
	        end: this.$date().add(7, 'days').unix()
	      };
	    },
	    slotsByLots: function slotsByLots() {
	      var c = (0, _collect2.default)(this.vehicles);
	      return c.groupBy(function (item) {
	        return item.parking_lot.name;
	      }).all();
	    },
	    getUserPosition: function getUserPosition() {
	      return this.book.latitude && this.book.longitude ? {
	        latitude: this.book.latitude,
	        longitude: this.book.longitude
	      } : null;
	    }
	  },
	  props: {
	    id: {
	      required: false
	    },
	    entityDrivers: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	    driverId: {
	      required: false
	    }
	  },
	  watch: {
	    booking_mode: {
	      handler: function handler(bm) {
	        if (bm === 'FF') {
	          this.end = null;
	          this.book.end = this.$date().add('2', 'hours').unix();
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientExtraFields',
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    console.log(this.configuration.system.system_client_custom_fields.value);
	  },
	
	  methods: {},
	  props: {
	    fields: {}
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }))
	};

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "ConfirmDialog",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        successClick: function successClick() {
	            this.$emit('successClicked');
	        }
	    },
	    props: ['title', 'message', 'formData', 'id']
	};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Reservation = __webpack_require__(37);
	
	var _Reservation2 = _interopRequireDefault(_Reservation);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreateCard",
	  components: {
	    SelectizeDriver: _SelectizeDriver2.default,
	    KeplerBackofficeSdk: _backoffice2.default,
	    DatePicker: _DatePicker2.default,
	    Reservation: _Reservation2.default
	  },
	  data: function data() {
	    return {
	      drivers: [],
	      body: {
	        driver_id: null,
	        chip_id: null,
	        name: null,
	        enabled: true,
	        standard: "2-ROTATED"
	      }
	    };
	  },
	  created: function created() {
	    this.body.driver_id = this.driver_id;
	  },
	
	  methods: {
	    addCard: function addCard() {
	      var _this = this;
	
	      _backoffice2.default.cards.make(this.body, function () {
	        _maggieHelper2.default.notification('card-result', 'Card added');
	        _this.$emit('cardCreated');
	        if (_this.$props.driver_id === undefined) {
	          _this.$router.go(-1);
	        } else {
	          _this.$emit('addCard', 'added');
	        }
	      });
	    },
	    setDriverId: function setDriverId(driver) {
	      this.body.driver_id = driver.id;
	    }
	  },
	  props: ['driver_id']
	};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverSubscriptionSlots",
	  components: {
	    SelectizeDriver: _SelectizeDriver2.default,
	    Dropdown: _Dropdown2.default,
	    KeplerBackofficeSdk: _backoffice2.default
	  },
	  data: function data() {
	    return {
	      selectizeDrivers: null,
	
	      placeholderImg: 'https://cdn4.iconfinder.com/data/icons/wirecons-free-vector-icons/32/add-128.png',
	      availableSlots: [],
	      availableDrivers: [],
	
	      selectableDrivers: [],
	      selectedDriver: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.setSlots(this.subscribedDrivers);
	    _backoffice2.default.clients.list(1, 10000, { id: this.clientId }).drivers(function (items) {
	      _this.selectizeDrivers = items.items;
	      items.items.forEach(function (driver) {
	        _this.availableDrivers.push(driver);
	      });
	    });
	  },
	
	  methods: {
	    setDriverId: function setDriverId(driver) {
	      this.selectedDriver = driver.id;
	    },
	    removeDriver: function removeDriver(index) {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to remove this driver?', function () {
	
	        var available = _this2.availableSlots[index];
	
	        _backoffice2.default.subscriptions.select(_this2.subscriptionId, { driver_id: available.id }).removeDriver(function (response) {
	          _this2.availableDrivers.push(available);
	
	          _this2.availableSlots.splice(index, 1, {
	            name: '',
	            surname: '',
	            available: true,
	            profile_picture: _this2.placeholderImg
	          });
	          _maggieHelper2.default.notification('remove-driver', response);
	        });
	      });
	    },
	    addDriver: function addDriver(slot) {
	      var _this3 = this;
	
	      this.availableDrivers.forEach(function (item, a) {
	        if (item.id == _this3.selectedDriver) {
	          _this3.availableSlots.splice(slot, 1, item);
	          _this3.availableDrivers.splice(a, 1);
	        }
	      });
	
	      _backoffice2.default.subscriptions.select(this.subscriptionId, { driver_id: this.selectedDriver }).addDriver(function () {
	        _maggieHelper2.default.notification('add-driver', 'Driver added to subscription');
	      });
	    },
	    setSlots: function setSlots(drivers) {
	      var _this4 = this;
	
	      var slotsLength = this.subscribedDrivers.length < this.maxDrivers ? this.subscribedDrivers.length + 1 : this.subscribedDrivers.length;
	      drivers.forEach(function (item) {
	        item.available = false;
	        _this4.availableSlots.push(item);
	      });
	
	      if (slotsLength > this.availableSlots.length) {
	        this.availableSlots.push({
	          name: '',
	          surname: '',
	          available: true,
	          profile_picture: this.placeholderImg
	        });
	      }
	    }
	  },
	  props: ['subscriptionId', 'maxDrivers', 'subscribedDrivers', 'clientId']
	};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ckeditor5BuildClassic = __webpack_require__(609);
	
	var _ckeditor5BuildClassic2 = _interopRequireDefault(_ckeditor5BuildClassic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Editor',
	  components: {},
	  data: function data() {
	    return {
	      editor: _ckeditor5BuildClassic2.default,
	      editorData: '',
	      editorConfig: {
	        toolbar: ['heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList', 'link'],
	        heading: {
	          options: [{ model: 'paragraph', title: 'Paragraph' }, { model: 'heading1', view: 'h1', title: 'Heading 1' }, { model: 'heading2', view: 'h2', title: 'Heading 2' }, { model: 'heading3', view: 'h3', title: 'Heading 3' }]
	        }
	      }
	    };
	  },
	
	  watch: {
	    editorData: function editorData(val) {
	      var emptyParagraph = new RegExp('<p>&nbsp;</p>', 'g');
	      if (emptyParagraph.test(val)) {
	        val = null;
	      }
	      this.$emit('input', val);
	    }
	  },
	  methods: {
	    setText: function setText() {
	      this.editorData = this.value;
	    }
	  },
	  computed: {},
	  props: {
	    value: {
	      type: String,
	      default: ''
	    },
	    disabled: {
	      type: Boolean
	    }
	  }
	};

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "HeaderColumns",
	    props: ['columns']
	};

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "InlineEditableField",
	  props: ['item'],
	  data: function data() {
	    return {
	      item_field: this.item,
	      editable: false
	    };
	  },
	  created: function created() {
	    this.test = this.item;
	  },
	
	  methods: {
	    update: function update(event) {
	
	      if (event.which === 13) {
	        var elt = event.target;
	        elt.innerText = elt.innerText.replace(/\n/g, ' ');
	        event.preventDefault();
	        this.saveAndClose();
	        return;
	      }
	
	      this.item_field = event.target.textContent;
	      var range, selection;
	
	      if (document.createRange) {
	        range = document.createRange();
	        range.selectNodeContents(event.target);
	        range.collapse(false);
	        selection = window.getSelection();
	        selection.removeAllRanges();
	        selection.addRange(range);
	      } else if (document.selection) {
	        range = document.body.createTextRange();
	        range.moveToElementText(event.target);
	        range.collapse(false);
	        range.select();
	      }
	    },
	    toggleEdit: function toggleEdit() {
	      this.editable = true;
	    },
	    saveAndClose: function saveAndClose() {
	      this.editable = false;
	      this.$emit('fieldUpdated', this.item_field);
	    },
	    closeAndRevert: function closeAndRevert() {
	      this.item_field = this.item;
	      this.editable = false;
	    }
	  }
	};

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'InputSwitch',
	  props: ['value', 'idEl'],
	  watch: {
	    active: {
	      handler: function handler() {}
	    }
	  },
	  data: function data() {
	    return {
	      active: this.value
	    };
	  },
	
	  methods: {
	    toggleSwitch: function toggleSwitch() {
	      this.active = !this.active;
	      this.$emit('input', this.active);
	    }
	  }
	};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InstructionStep',
	  components: { KeplerFileUpload: _KeplerFileUpload2.default, Editor: _Editor2.default },
	  watch: {
	    step: {
	      handler: function handler(val) {
	        if (val.type === 'linked_image') {
	          val.value = val.image_url + '|' + val.image_link;
	        }
	
	        if (val.type === 'youtube') {
	          var regex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|shorts\/|v\/)?)([\w\-]+)(\S+)?$/;
	          var result = val.value.match(regex);
	          try {
	            val.value = 'https://www.youtube.com/embed/' + result[5];
	          } catch (e) {}
	        }
	      },
	
	
	      deep: true
	    }
	  },
	  data: function data() {
	    return {
	      type: 'html',
	      value: ''
	    };
	  },
	
	  methods: {
	    handleFileSelector: function handleFileSelector(path, type) {
	      if (type === 'linked_image') {
	        this.$set(this.step, 'image_url', path);
	      } else {
	        this.$set(this.step, 'value', path);
	      }
	    }
	  },
	  props: ['step']
	};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _js = __webpack_require__(232);
	
	var mdi = _interopRequireWildcard(_js);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  name: "MdiIcon",
	  components: {},
	  data: function data() {
	    return {
	      icons: mdi
	
	    };
	  },
	  created: function created() {},
	
	  computed: {
	    icon: function icon() {
	      var iconName = this.name.replace(/-([a-z])/g, function (m, w) {
	        return w.toUpperCase();
	      });
	      return mdi[iconName];
	    }
	  },
	  props: {
	    name: {
	      type: String
	    },
	    showName: {
	      type: Boolean,
	      default: true
	    }
	  }
	};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "QuickSearch",
	  components: { SearchEntity: _SearchEntity2.default },
	  data: function data() {
	    return {
	      searchOpen: false
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    gotoEntity: function gotoEntity(id, entity) {
	      switch (entity) {
	        case 'clients':
	          this.$router.push({ name: 'client', params: { id: id } });
	          break;
	        case 'drivers':
	          this.$router.push({ name: 'driver', params: { id: id } });
	          break;
	        case 'reservations':
	          this.$router.push({ name: 'reservation', params: { id: id } });
	          break;
	        case 'vehicles':
	          this.$router.push({ name: 'vehicle', params: { id: id } });
	      }
	
	      this.searchOpen = false;
	    },
	    handleFocusout: function handleFocusout($evt) {
	      if ($evt.relatedTarget !== null) {
	        return;
	      }
	      this.searchOpen = false;
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }))
	};

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Reveal',
	  components: {},
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    new Foundation.Reveal($(this.$el).find('.reveal'));
	  },
	
	  methods: {
	    confirm: function confirm() {
	      this.$emit('confirm');
	    }
	  },
	  computed: {
	    uid: function uid() {
	      return 'reveal-' + this._uid;
	    }
	  },
	  props: ['confirmButtons']
	};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _LoadingAnimation = __webpack_require__(117);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SearchEntity",
	  components: { LoadingSpinner: _LoadingSpinner2.default, LoadingAnimation: _LoadingAnimation2.default },
	  data: function data() {
	
	    return {
	      searchQuery: '',
	      results: [],
	      debounceTimeout: null,
	      loading: false,
	      source: null,
	      showResults: false,
	      selected: null,
	      selectedForNewTab: false,
	      openInNewTab: false
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    showChar: function showChar(e) {
	      this.openInNewTab = e.keyCode === 17 && e.ctrlKey;
	    },
	    handleFocusIn: function handleFocusIn() {
	      if (this.loadedValues.length) {
	        this.results = this.loadedValues;
	      }
	
	      if (this.results.length) {
	        this.showResults = true;
	      }
	    },
	    handleFocusout: function handleFocusout($evt) {
	      if ($evt.relatedTarget !== null) {
	
	        return;
	      }
	      this.showResults = false;
	      this.loading = false;
	    },
	    debouncedSearch: function debouncedSearch() {
	      var _this = this;
	
	      if (this.loadedValues.length || this.searchQuery.length < 4) {
	        this.loading = false;
	        return;
	      }
	      clearTimeout(this.debounceTimeout);
	      this.$emit('input', null);
	
	      this.debounceTimeout = setTimeout(function () {
	        if (_this.source !== null) {
	          _this.source.cancel();
	          _this.results = [];
	          _this.loading = false;
	          _this.selected = null;
	          _this.$emit('input', null);
	        }
	
	        _this.source = _backoffice2.default.getSource();
	        _this.loading = true;
	        _this.search();
	      }, 300);
	    },
	    search: function search() {
	      var _this2 = this;
	
	      try {
	        this.selected = null;
	
	        if (this.searchQuery.length < 4) {
	          return;
	        }
	        _backoffice2.default[this.entity].list(1, -1, { query: this.searchQuery }).search(function (items) {
	          _this2.results = items.items;
	          _this2.loading = false;
	          _this2.showResults = true;
	        }, function () {
	          _this2.loading = false;
	        }, this.source.token);
	      } catch (error) {
	        this.loading = false;
	      }
	    },
	    select: function select($event, obj) {
	      $event.preventDefault();
	      this.searchQuery = "" + this.prefix + obj.id;
	      if (obj.name && obj.surname) {
	        this.searchQuery += " " + obj.name + " " + obj.surname;
	      }
	      this.selected = obj.id;
	      this.showResults = false;
	
	      if (this.results.length > 6) {
	
	        var index = this.results.findIndex(function (item) {
	          return item.id === obj.id;
	        });
	        if (index !== -1) {
	          if (this.results.length === 0 || obj.id !== this.results[index].id !== obj.id) {
	            this.results.splice(index, 1);
	
	            this.results.unshift(obj);
	          }
	        }
	      }
	
	      if (this.openInNewTab) {
	        var routeData = this.$router.resolve({ name: this.entity.slice(0, -1), params: { id: obj.id } });
	        window.open(routeData.href, '_blank');
	        return;
	      }
	
	      if (this.clearInput) {
	        this.searchQuery = null;
	        this.results = [];
	      }
	
	      this.$emit('input', obj.id);
	      this.$emit('selected', obj.id);
	    }
	  },
	  props: {
	    value: {},
	    clearInput: {
	      type: Boolean,
	      default: false
	    },
	    entity: {
	      type: String,
	      default: ""
	    },
	    loadedValues: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  computed: {
	    prefix: function prefix() {
	      return this.entity.slice(0, 2).toUpperCase();
	    }
	  }
	};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SelectizeVehicleAttribute = __webpack_require__(223);
	
	var _SelectizeVehicleAttribute2 = _interopRequireDefault(_SelectizeVehicleAttribute);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeVehicleAttributesArrayEdit',
	  components: { SelectizeVehicleAttribute: _SelectizeVehicleAttribute2.default },
	  data: function data() {
	    return {
	      newName: null
	    };
	  },
	
	  methods: {
	    addField: function addField() {
	      try {
	        var values = JSON.parse("" + this.newName);
	        console.log(values);
	
	        this.newName = null;
	      } catch (e) {
	        console.log(this.newName);
	
	        this.newName = null;
	        return false;
	      }
	    },
	    removeField: function removeField(label) {
	      this.$delete(this.values, label);
	    },
	    setValue: function setValue(obj) {
	      this.newName = obj.name;
	    }
	  },
	  props: {
	    values: {
	      type: Object
	    }
	  }
	};

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Slider',
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    updateStep: function updateStep(evt) {
	      this.$emit('input', parseInt(evt.target.value));
	    }
	  },
	  computed: {},
	  props: {
	    value: {
	      default: 0
	    },
	    min: {
	      default: 0
	    },
	    max: {
	      default: 100
	    },
	    step: {
	      default: 1
	    }
	  }
	};

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "StatisticsCard4",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    computed: {}
	};

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "StatisticsCard5",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    computed: {}
	};

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "StatisticsCard6",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    computed: {}
	};

/***/ }),
/* 874 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "StatisticsCard7",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    computed: {}
	};

/***/ }),
/* 875 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Status",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    computed: {},
	    props: ['status']
	};

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ToggleableButton',
	  data: function data() {
	    return {
	      toggled: this.active
	    };
	  },
	
	  computed: {
	    buttonClass: function buttonClass() {
	      return this.value ? 'active' : null;
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      if (this.selectable) {
	        this.$emit('input', !this.value);
	      }
	    }
	  },
	  props: {
	    disabled: {
	      type: Boolean
	    },
	    selectable: {
	      type: Boolean
	    },
	    value: {
	      type: Boolean
	    }
	  }
	};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tooltip = __webpack_require__(79);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _MdiIcon = __webpack_require__(80);
	
	var _MdiIcon2 = _interopRequireDefault(_MdiIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VehicleAdditionalStatus',
	  components: { MdiIcon: _MdiIcon2.default, Tooltip: _Tooltip2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    getName: function getName(key, value) {
	      switch (key) {
	        case "HELMET":
	          return "mdiRacingHelmet";
	        case "STAND":
	          if (value === "UP") {
	            return "mdiArrowUpThin";
	          }
	          return "mdiArrowDownThin";
	        case "TOP_CASE":
	          return "mdiTreasureChest";
	        default:
	          return false;
	      }
	    },
	    status: function status(itemStatus) {
	      switch (itemStatus) {
	        case 'UP':
	        case 'IN':
	        case 'CHARGING':
	        case 'PRESENT':
	        case 'CLOSED':
	        case 'ENABLED':
	          return 'green-status';
	        case 'NOT PRESENT':
	        case 'OPEN':
	        case 'DISABLED':
	        case 'DOWN':
	        case 'OUT':
	          return 'red-status';
	        case 'CONNECTED':
	          return 'orange-status';
	        case 'DISCONNECTED':
	          return 'grey-status';
	      }
	    }
	  },
	  computed: {},
	  props: {
	    item: { type: Object },
	    showToolTip: { type: Boolean, default: true }
	
	  }
	};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Tooltip = __webpack_require__(79);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapMarker = __webpack_require__(72);
	
	var _GoogleMapMarker2 = _interopRequireDefault(_GoogleMapMarker);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VehicleStatus',
	  components: { GoogleMapContainer: _GoogleMapContainer2.default, Tooltip: _Tooltip2.default, GoogleMap: _GoogleMap2.default, GoogleMapMarker: _GoogleMapMarker2.default },
	  data: function data() {
	    return {
	      showDetail: false
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    openDetail: function openDetail() {
	      this.showDetail = !this.showDetail;
	    },
	    fuelStatus: function fuelStatus() {
	      var fuelLevel = this.item.fuel_level === null ? ' --' : ' ' + this.item.fuel_level + '%';
	      var range = this.item.range === null ? '' : '(' + this.item.range + this.configuration.locale.locale_distance_unit.value + ')';
	      return '' + fuelLevel + range;
	    },
	    fuelLevel: function fuelLevel() {
	
	      if (this.item.fuel_level === null) {
	        return 'grey-status';
	      }
	      if (this.item.fuel_level < 20) {
	        return 'red-status';
	      } else if (this.item.fuel_level >= 50 && this.item.fuel_level <= 80) {
	        return 'yellow-status';
	      } else if (this.item.fuel_level > 80) {
	        return 'green-status';
	      }
	    },
	    status: function status(itemStatus) {
	      switch (itemStatus) {
	        case 'RUNNING':
	          return 'red-status';
	        case 'NOT RUNNING':
	          return 'green-status';
	      }
	    },
	    doorStatus: function doorStatus(itemStatus) {
	      switch (itemStatus) {
	        case 'UNLOCKED':
	          return 'door-open fa fa-unlock';
	        case 'LOCKED':
	          return 'door-closed fa fa-lock';
	      }
	    },
	    visibility: function visibility(hidden) {
	      if (hidden) {
	        return 'fa fa-map red-status';
	      }
	
	      return 'fa fa-map green-status';
	    },
	    inRange: function inRange() {
	      return this.item.in_range ? 'green-status' : 'red-status';
	    }
	  },
	  computed: (0, _extends3.default)({
	    mapsAPI: function mapsAPI() {
	      return window.env.GOOGLE_MAPS_KEY;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: {
	    item: { type: Object },
	    odometer: { type: Boolean, default: false },
	    showToolTip: { type: Boolean, default: true }
	  }
	};

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "ActionButtons",
	  props: ['actions', 'type']
	};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _VatAmountToggler = __webpack_require__(116);
	
	var _VatAmountToggler2 = _interopRequireDefault(_VatAmountToggler);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeCommonCost = __webpack_require__(71);
	
	var _SelectizeCommonCost2 = _interopRequireDefault(_SelectizeCommonCost);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AddCommonCostToWallet',
	  components: { SelectizeCommonCost: _SelectizeCommonCost2.default, ActionButton: _ActionButton2.default, VatAmountToggler: _VatAmountToggler2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      isDebit: false,
	      body: {
	        client_id: this.$route.params.id,
	        wallet_id: this.wallet,
	        common_cost_id: null
	      }
	    };
	  },
	  created: function created() {
	    if (this.cost) {
	      (0, _assign2.default)(this.body, this.cost);
	    }
	  },
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.commonCosts.select(this.body.common_cost_id).addToWallet(this.body, function () {
	        _maggieHelper2.default.notification('Common cost', 'Added successfully');
	        _this.$refs.addCommonCost.close();
	      });
	    },
	    selected: function selected(obj) {
	      this.body.common_cost_id = obj.id;
	    }
	  },
	  props: ['wallet']
	};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _VehicleList = __webpack_require__(607);
	
	var _VehicleList2 = _interopRequireDefault(_VehicleList);
	
	var _DismissAsset = __webpack_require__(215);
	
	var _DismissAsset2 = _interopRequireDefault(_DismissAsset);
	
	var _SwapAsset = __webpack_require__(217);
	
	var _SwapAsset2 = _interopRequireDefault(_SwapAsset);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _MoveAsset = __webpack_require__(216);
	
	var _MoveAsset2 = _interopRequireDefault(_MoveAsset);
	
	var _VehicleSlotButtons = __webpack_require__(44);
	
	var _VehicleSlotButtons2 = _interopRequireDefault(_VehicleSlotButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "AssetManagementActionButtons",
	  components: { VehicleSlotButtons: _VehicleSlotButtons2.default, MoveAsset: _MoveAsset2.default, SwapAsset: _SwapAsset2.default, DismissAsset: _DismissAsset2.default, VehicleSlotList: _VehicleList2.default, ModalReveal: _ModalReveal2.default },
	  props: ['item'],
	  created: function created() {},
	
	  methods: {
	    dismiss: function dismiss() {
	      var _this = this;
	
	      this.$confirm("Are you sure?", "Do you really want to dismiss the vehicle slot<br>" + this.item.name + " (VS-" + this.item.id + ")?", function () {
	        _backoffice2.default.vehicleSlots.select(_this.item).dismiss(function (data) {
	          _this.$emit('vehicleSlotDismissed', _this.item);
	          _maggieHelper2.default.notification('dismiss-esit', 'Vehicle slot dismissed');
	        });
	      });
	    },
	    assetMoved: function assetMoved(item) {
	      this.$emit('assetMoved', item);
	    },
	    processSwap: function processSwap(id) {
	      var _this2 = this;
	
	      this.$confirm("Are you sure?", "Do you really want to swap VS-" + this.item.id + " with VS-" + id + "?", function () {
	
	        _backoffice2.default.vehicleSlots.swap({
	          first_vehicle_slot_id: _this2.item.id,
	          second_vehicle_slot_id: id
	        }, function (data) {
	          _maggieHelper2.default.notification('swap-esit', data.result);
	        });
	      });
	    }
	  }
	
	};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(162);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _CardEdit = __webpack_require__(1959);
	
	var _CardEdit2 = _interopRequireDefault(_CardEdit);
	
	var _CardBind = __webpack_require__(1958);
	
	var _CardBind2 = _interopRequireDefault(_CardBind);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CardActionButtons",
	  components: {
	    CardSmartEdit: _CardEdit2.default
	  },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.card) {
	      _backoffice2.default.cards.select(this.$route.params.id).get(function (item) {
	        _this.entity = item;
	      });
	    } else {
	      this.entity = this.card;
	    }
	  },
	
	  computed: {
	    actions: function actions() {
	      var arr = [];
	      var aclArr = [{
	        acl: this.$acl('edit-cards'),
	        name: 'Edit',
	        callback: this.edit,
	        severity: 'success'
	      }, {
	        acl: this.$acl('unbind-card-cards'),
	        name: 'Unbind',
	        callback: this.unbind,
	        severity: 'warning'
	      }, {
	        acl: this.$acl('edit-cards'),
	        name: 'Bind',
	        callback: this.bind,
	        severity: 'warning'
	      }, {
	        acl: this.$acl('delete-cards'),
	        name: 'Delete',
	        callback: this.remove,
	        severity: 'alert'
	      }];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(aclArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var actn = _step.value;
	
	          var bound = this.card.driver;
	          if (actn.name === 'Unbind' && !bound) {
	            continue;
	          }
	          if (actn.name === 'Bind' && bound) {
	            continue;
	          }
	          if (actn.acl) {
	            delete actn.acl;
	            arr.push(actn);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return arr;
	    }
	  },
	  methods: {
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _CardEdit2.default, props: {
	          item: this.entity
	        }
	      });
	    },
	    bind: function bind() {
	      _maggieHelper2.default.openRightPanel({
	        component: _CardBind2.default, props: {
	          item: this.entity
	        }
	      });
	    },
	    unbind: function unbind() {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to unbind this card from its driver?', function () {
	        _backoffice2.default.cards.select(_this2.entity).unbind(function (response) {
	          _maggieHelper2.default.notification('unbind-esit', "Card disconnected");
	          location.reload();
	        });
	      });
	    },
	    remove: function remove() {
	      var _this3 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to delete this card?', function () {
	        _backoffice2.default.cards.select(_this3.entity).remove(function (response) {
	          _maggieHelper2.default.notification('remove-esit', "Card deleted");
	        });
	      });
	    }
	  },
	  props: ['card', 'item']
	};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ChargingSessionButtons",
	  components: { ActionButton: _ActionButton2.default },
	  methods: {
	    start: function start() {
	      return _backoffice2.default.chargingSessions.select(this.item).start(function () {
	        _eventBus.EventBus.$emit('reload-list');
	        _maggieHelper2.default.notification('Charging session', 'started successfully');
	      });
	    },
	    end: function end() {
	      return _backoffice2.default.chargingSessions.select(this.item).end(function () {
	        _eventBus.EventBus.$emit('reload-list');
	        _maggieHelper2.default.notification('Charging session', 'ended successfully');
	      });
	    }
	  },
	  props: ["item"]
	};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ClientEdit = __webpack_require__(545);
	
	var _ClientEdit2 = _interopRequireDefault(_ClientEdit);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ApplyRegistrationTokenReveal = __webpack_require__(2069);
	
	var _ApplyRegistrationTokenReveal2 = _interopRequireDefault(_ApplyRegistrationTokenReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ClientActionButtons",
	  components: {
	    RegistrationTokenReveal: _ApplyRegistrationTokenReveal2.default,
	    ModalReveal: _ModalReveal2.default,
	    ClientSmartEdit: _ClientEdit2.default
	  },
	  data: function data() {
	    return {
	      entity: null,
	      registrationTokens: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.client) {
	      _backoffice2.default.clients.select(this.$route.params.id).get(function (item) {
	        _this.entity = item;
	      });
	    } else {
	      this.entity = this.client;
	    }
	  },
	
	  methods: {
	    activate: function activate() {
	      var _this2 = this;
	
	      _backoffice2.default.clients.select(this.entity).activate(function (response) {
	        _this2.entity = response;
	        _maggieHelper2.default.notification('activate-esit', "Client activated");
	        location.reload();
	      });
	    },
	    suspend: function suspend() {
	      var _this3 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to suspend this client?', function () {
	        _backoffice2.default.clients.select(_this3.entity).suspend(function (response) {
	          _this3.entity = response;
	          _maggieHelper2.default.notification('suspend-esit', "Client suspended");
	        });
	      });
	    },
	    deleteClient: function deleteClient() {
	      var _this4 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to delete this client?', function () {
	        _backoffice2.default.clients.select(_this4.entity).delete(function (response) {
	          _this4.entity = response;
	          _maggieHelper2.default.notification('delete-esit', "client deleted");
	        });
	      });
	    },
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _ClientEdit2.default, props: {
	          item: this.entity
	        }
	      });
	    },
	    dump: function dump() {
	      _backoffice2.default.clients.select(this.entity).dump(function (response) {
	        navigator.clipboard.writeText((0, _stringify2.default)(response)).then(function () {
	          _maggieHelper2.default.notification('Copied', 'Client data copied to clipboard.');
	        }, function (err) {
	          console.error('Async: Could not copy text: ', err);
	        });
	      });
	    }
	  },
	  computed: {
	    canActivate: function canActivate() {
	      return this.$acl('activate-clients') && (this.entity.status === 'ON HOLD' || this.entity.status === 'SUSPENDED');
	    },
	    canSuspend: function canSuspend() {
	      return this.$acl('suspend-clients') && this.entity.status === 'ACTIVE';
	    },
	    canDelete: function canDelete() {
	      return this.$acl('delete-clients') && (this.entity.status === 'SUSPENDED' || this.entity.status === 'ON HOLD');
	    },
	    canEdit: function canEdit() {
	      return this.$acl('edit-clients');
	    },
	    canDump: function canDump() {
	      return this.$acl('dump-client');
	    },
	    canDo: function canDo() {
	      return this.canActivate || this.canSuspend || this.canDelete || this.canEdit || this.canDump;
	    }
	  },
	  props: ['client', 'item']
	};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientTypeButtons',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entity: (0, _extends3.default)({}, this.item)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to <strong>Remove</strong> the <strong>CT' + this.item.id + ' client type?</strong>', function () {
	        _backoffice2.default.clientTypes.select(_this.entity).remove(function () {
	          _maggieHelper2.default.notification('delete-esit', 'Client type removed');
	          window.location.reload();
	        });
	      });
	    },
	    edit: function edit() {
	      var _this2 = this;
	
	      this.entity.name = this.item.code;
	      return _backoffice2.default.clientTypes.select(this.item).edit(this.entity, function () {
	        _this2.$refs.editReveal.close();
	        _eventBus.EventBus.$emit('reload-list');
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _VatAmountToggler = __webpack_require__(116);
	
	var _VatAmountToggler2 = _interopRequireDefault(_VatAmountToggler);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AddCommonCostToWallet',
	  components: { ActionButton: _ActionButton2.default, VatAmountToggler: _VatAmountToggler2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      isDebit: false,
	      body: {
	        reason: null,
	        amount: 0,
	        tax: null,
	        configuration: 'debt',
	        common_cost_type_id: null
	      },
	      key: 0
	    };
	  },
	  created: function created() {
	    if (this.cost) {
	      (0, _assign2.default)(this.body, this.cost);
	    }
	  },
	  mounted: function mounted() {
	    this.isChecked();
	  },
	
	  watch: {
	    isDebit: function isDebit(newVal) {
	      if (!newVal) {
	        this.body.amount = -this.body.amount;
	      }
	    }
	  },
	  methods: {
	    isChecked: function isChecked() {
	      this.body.amount >= 0 ? this.isDebit = false : this.isDebit = true;
	    },
	    closeInput: function closeInput(event) {
	      if (!event) {
	        this.key++;
	      }
	    },
	    save: function save() {
	      var _this = this;
	
	      if (this.isDebit && this.body.amount > 0) {
	        this.body.amount = -this.body.amount;
	      }
	
	      if (this.cost) {
	        return this.edit();
	      }
	
	      return _backoffice2.default.commonCosts.make(this.body, function (data) {
	        _maggieHelper2.default.notification('Cost', 'Cost added');
	        _this.$emit('itemUpdated', 'added');
	        _this.key++;
	        _this.body = {
	          reason: null,
	          amount: 0,
	          tax: 0.22,
	          configuration: 'debt',
	          common_cost_type_id: null
	        }, _this.$refs.commonCostModal.close();
	      });
	    },
	    edit: function edit() {
	      var _this2 = this;
	
	      return _backoffice2.default.commonCosts.select(this.body).edit(this.body, function () {
	        _this2.$emit('itemUpdated');
	        _this2.key++;
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    vats: function vats(state) {
	      return state.configuration.vats;
	    },
	    commonCostTypes: function commonCostTypes(state) {
	      return state.configuration.commonCostTypes;
	    }
	  })),
	  props: ['cost']
	};

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CommonCostButtonModal = __webpack_require__(144);
	
	var _CommonCostButtonModal2 = _interopRequireDefault(_CommonCostButtonModal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CommonCostButtons',
	  components: { ActionButton: _ActionButton2.default, CommonCostButtonModal: _CommonCostButtonModal2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.commonCosts.select(this.item).delete(function () {
	        _maggieHelper2.default.notification('delete-esit', 'Cost removed');
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TocButtons",
	  components: {
	    ModalReveal: _ModalReveal2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    edit: function edit() {
	      var _this = this;
	
	      _backoffice2.default.commonCostType.edit(this.item, function () {
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PolicyReveal = __webpack_require__(63);
	
	var _PolicyReveal2 = _interopRequireDefault(_PolicyReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _CouponReveal = __webpack_require__(126);
	
	var _CouponReveal2 = _interopRequireDefault(_CouponReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CouponButtons',
	  components: { CouponReveal: _CouponReveal2.default, PolicyReveal: _PolicyReveal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.registrationTokens.select(this.item).remove(function () {
	        _maggieHelper2.default.notification('', 'Policy deleted');
	        _this.$emit('refresh');
	      });
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PolicyReveal = __webpack_require__(63);
	
	var _PolicyReveal2 = _interopRequireDefault(_PolicyReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _GroupEdit = __webpack_require__(93);
	
	var _GroupEdit2 = _interopRequireDefault(_GroupEdit);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _SelectizeParkingLot = __webpack_require__(150);
	
	var _SelectizeParkingLot2 = _interopRequireDefault(_SelectizeParkingLot);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateBookingFromReservationRequest',
	  components: { Vehicle: _Vehicle2.default, SelectizeParkingLot: _SelectizeParkingLot2.default, Driver: _Driver2.default, GroupReveal: _GroupEdit2.default, PolicyReveal: _PolicyReveal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      slots: [],
	      loading: false
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    collect: _collect2.default,
	    search: function search() {
	      var _this = this;
	
	      this.loading = true;
	      return _backoffice2.default.parkingSlots.list.slots(this.item.flags.pick_up_id, function (data) {
	        _this.slots = (0, _collect2.default)(data).filter(function (vs) {
	          return vs.vehicle_slot != null;
	        }).pluck('vehicle_slot').map(function (vs) {
	          return vs.vehicle;
	        }).all();
	        _this.loading = false;
	      });
	    },
	    bookNow: function bookNow(vehicle) {
	      var _this2 = this;
	
	      _backoffice2.default.reservations.makeDriverRequestBooking(this.item.id, { plate: vehicle.plate }, function (response) {
	        _maggieHelper2.default.notification('book-esit', 'reservation created');
	        _this2.$refs[_this2.modal].close();
	        _this2.$router.push({ name: 'reservation', params: { id: response.id } });
	      });
	    }
	  },
	  computed: {
	    modal: function modal() {
	      return 'modal-' + this._uid;
	    }
	  },
	  props: ['item', 'driver']
	};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _EditReportingType = __webpack_require__(127);
	
	var _EditReportingType2 = _interopRequireDefault(_EditReportingType);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateClientTypeButtonModal',
	  components: { EditReportingType: _EditReportingType2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      clientType: {
	        name: null,
	        type: 'PRIVATE'
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    save: function save() {
	      _backoffice2.default.clientTypes.make(this.clientType, function (data) {
	        window.location.reload();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SelectizeDocumentType = __webpack_require__(81);
	
	var _SelectizeDocumentType2 = _interopRequireDefault(_SelectizeDocumentType);
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _SelectizePlan = __webpack_require__(92);
	
	var _SelectizePlan2 = _interopRequireDefault(_SelectizePlan);
	
	var _SelectizeClientType = __webpack_require__(90);
	
	var _SelectizeClientType2 = _interopRequireDefault(_SelectizeClientType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateDocumentRequirementButtonModal',
	  components: { SelectizeClientType: _SelectizeClientType2.default, SelectizePlan: _SelectizePlan2.default, SelectizeCategory: _SelectizeCategory2.default, SelectizeDocumentType: _SelectizeDocumentType2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entity: null,
	      entityId: null,
	      entity_type: null,
	
	      body: {
	        "entity_type": null,
	        "entity_id": null,
	        "document_type_id": null,
	        "document_group": null
	      },
	      options: []
	    };
	  },
	  created: function created() {
	    this.loadEntity();
	  },
	
	  methods: {
	    documentTypeSelected: function documentTypeSelected(obj) {
	      this.body.document_type_id = obj.id;
	    },
	    entitySelected: function entitySelected(obj) {
	      this.body.entity_id = obj.id;
	      this.body.entity_type = this.capitalize(this.entity);
	    },
	    capitalize: function capitalize(s) {
	      return s.split('_').map(function (x) {
	        return x.charAt(0).toUpperCase() + x.slice(1);
	      }).join('');
	    },
	    loadEntity: function loadEntity() {
	      var _this = this;
	
	      _backoffice2.default.documentRequirements.entityAllowed().entityList(function (data) {
	        _this.options = data;
	      });
	    },
	    save: function save() {
	      _backoffice2.default.documentRequirements.make(this.body, function () {
	        window.location.reload();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _eventBus = __webpack_require__(15);
	
	var _DocumentTypeForm = __webpack_require__(558);
	
	var _DocumentTypeForm2 = _interopRequireDefault(_DocumentTypeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateDocumentTypeButtonModal',
	  components: { DocumentTypeForm: _DocumentTypeForm2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      documentType: {
	        name: null,
	        description: null,
	        attachment_views: [],
	        has_number: true,
	        has_emission: true,
	        has_expiry: true,
	        has_issuer: true,
	        has_country: true
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.documentTypes.make(this.documentType, function () {
	        _this.$refs.documentTypeReveal.close();
	        _eventBus.EventBus.$emit('reload-list');
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "CreateEntityButton",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {},
	    props: ['item']
	};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreateParkingGroup",
	  components: { BookingModeSelect: _BookingModeSelect2.default },
	  data: function data() {
	    return {
	      name: null,
	      reservation_type: null,
	      vat_id: null
	    };
	  },
	
	  methods: {
	    createParkingGroup: function createParkingGroup() {
	      var _this = this;
	
	      var body = {
	        name: this.name,
	        reservation_type: this.reservation_type,
	        vat_id: this.vat_id
	      };
	      _backoffice2.default.parkingGroups.make(body, function () {
	
	        _maggieHelper2.default.notification('create-esit', 'Parking group created successfully');
	        _this.$router.push({ path: 'assets', name: 'management' });
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    vats: function vats(state) {
	      return state.configuration.vats;
	    }
	  }))
	};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapMarker = __webpack_require__(72);
	
	var _GoogleMapMarker2 = _interopRequireDefault(_GoogleMapMarker);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreateParkingLot",
	  components: { GoogleMapContainer: _GoogleMapContainer2.default, Editor: _Editor2.default, KeplerFileUpload: _KeplerFileUpload2.default, GoogleMap: _GoogleMap2.default, GoogleMapMarker: _GoogleMapMarker2.default, GoogleMapPolygon: _GoogleMapPolygon2.default },
	  data: function data() {
	    return {
	      showFileSelector: false,
	      name: null,
	      description: "",
	      availableSlots: 0,
	      latitude: null,
	      longitude: null,
	      allowed_zone_id: null,
	      forbidden_zone_id: null,
	      undesiderable_zone_id: null,
	      picture: null,
	
	      openMap: false,
	      marker: {},
	      zones: null,
	      mapCenter: {
	        lat: 0,
	        lng: 0
	      },
	      markerPosition: {
	        lat: 0,
	        lng: 0
	      }
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this.mapCenter.lat = data.application.application_default_latitude.value;
	      _this.mapCenter.lng = data.application.application_default_longitude.value;
	    });
	  },
	  created: function created() {
	    this.getZones();
	  },
	
	  methods: {
	    hideMarker: function hideMarker() {
	      this.markerPosition = false;
	    },
	    updateMarker: function updateMarker(e) {
	      this.markerPosition = true;
	      this.mapCenter.lat = e.lat();
	      this.mapCenter.lng = e.lng();
	      this.latitude = e.lat();
	      this.longitude = e.lng();
	    },
	    handleFileSelector: function handleFileSelector(path) {
	      this.picture = path;
	      this.showFileSelector = false;
	    },
	    addParkingLot: function addParkingLot() {
	      var _this2 = this;
	
	      var body = {
	        name: this.name,
	        description: this.description,
	        parking_group_id: this.item.id,
	        slots: this.availableSlots,
	        latitude: this.latitude,
	        longitude: this.longitude,
	        picture: this.picture,
	        allowed_zone_id: this.allowed_zone_id,
	        forbidden_zone_id: this.forbidden_zone_id,
	        undesiderable_zone_id: this.undesiderable_zone_id
	      };
	
	      _backoffice2.default.parkingLots.make(body, function (data) {
	        _maggieHelper2.default.notification('add-esit', 'Parking lot added successfully');
	        _this2.$router.push({ name: 'parkingLot', params: { id: data.id } });
	      });
	    },
	    addPin: function addPin(e) {
	      this.latitude = e.lat();
	      this.longitude = e.lng();
	    },
	    getZones: function getZones() {
	      var _this3 = this;
	
	      _backoffice2.default.zones.list.all(function (data) {
	        _this3.zones = data;
	      });
	    }
	  },
	  computed: {
	    mapKey: function mapKey() {
	      return window.env.GOOGLE_MAPS_KEY;
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _EditReportingType = __webpack_require__(127);
	
	var _EditReportingType2 = _interopRequireDefault(_EditReportingType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateEntityButton',
	  components: { EditReportingType: _EditReportingType2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  props: ['item']
	};

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _EditReportingType = __webpack_require__(127);
	
	var _EditReportingType2 = _interopRequireDefault(_EditReportingType);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateTocTypeButtonModal',
	  components: { EditReportingType: _EditReportingType2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      tocType: {
	        name: null,
	        priority: 0,
	        group: 'ALL'
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    save: function save() {
	      _backoffice2.default.tocTypes.make(this.tocType, function () {
	        window.location.reload();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _CrediRecordUsageReveal = __webpack_require__(2071);
	
	var _CrediRecordUsageReveal2 = _interopRequireDefault(_CrediRecordUsageReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'CreditRecordButtons',
	    components: { CreditRecordUsageReveal: _CrediRecordUsageReveal2.default, ActionButton: _ActionButton2.default },
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        expireCredit: function expireCredit() {
	            var _this = this;
	
	            return _backoffice2.default.credits.select(this.item).expire(function () {
	                _maggieHelper2.default.notification('expire', 'Credit record expired');
	                _this.$emit('itemUpdated', 'ciao');
	            });
	        }
	    },
	    props: ['item']
	};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _CreateDocumentTypeButtonModal = __webpack_require__(564);
	
	var _CreateDocumentTypeButtonModal2 = _interopRequireDefault(_CreateDocumentTypeButtonModal);
	
	var _CreateDocumentRequirementButtonModal = __webpack_require__(563);
	
	var _CreateDocumentRequirementButtonModal2 = _interopRequireDefault(_CreateDocumentRequirementButtonModal);
	
	var _EditDocumentRequirementButtonModal = __webpack_require__(2043);
	
	var _EditDocumentRequirementButtonModal2 = _interopRequireDefault(_EditDocumentRequirementButtonModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocumentRequirementButtons',
	  components: {
	    EditDocumentRequirementButtonModal: _EditDocumentRequirementButtonModal2.default,
	    CreateDocumentRequirementButtonModal: _CreateDocumentRequirementButtonModal2.default, CreateDocumentTypeButtonModal: _CreateDocumentTypeButtonModal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.documentRequirements.select(this.item).remove(function () {
	        _maggieHelper2.default.notification('delete-esit', 'Document type removed');
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _eventBus = __webpack_require__(15);
	
	var _DocumentTypeForm = __webpack_require__(558);
	
	var _DocumentTypeForm2 = _interopRequireDefault(_DocumentTypeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocumentTypeButtons',
	  components: { DocumentTypeForm: _DocumentTypeForm2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      return _backoffice2.default.documentTypes.select(this.item).remove(function () {
	        _maggieHelper2.default.notification('delete-esit', 'Document type removed');
	        _eventBus.EventBus.$emit('reload-list');
	      });
	    },
	    edit: function edit() {
	      var _this = this;
	
	      return _backoffice2.default.documentTypes.select(this.item).edit(this.item, function () {
	        _eventBus.EventBus.$emit('reload-list');
	        _this.$refs.editReveal.close();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _DriverEdit = __webpack_require__(1960);
	
	var _DriverEdit2 = _interopRequireDefault(_DriverEdit);
	
	var _DriverEditPassword = __webpack_require__(1961);
	
	var _DriverEditPassword2 = _interopRequireDefault(_DriverEditPassword);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _eventBus = __webpack_require__(15);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _AddDriverFlagReveal = __webpack_require__(2068);
	
	var _AddDriverFlagReveal2 = _interopRequireDefault(_AddDriverFlagReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverActionButtons',
	  components: { AddDriverFlagReveal: _AddDriverFlagReveal2.default, ModalReveal: _ModalReveal2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.driver) {
	      _backoffice2.default.drivers.select(this.$route.params.id).get(function (item) {
	        _this.entity = item;
	      });
	    } else {
	      this.entity = this.driver;
	    }
	  },
	
	  methods: {
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _DriverEdit2.default, props: {
	          item: this.entity
	        }
	      });
	    },
	    setNewPassword: function setNewPassword() {
	      this.entity.password = '';
	      _maggieHelper2.default.openRightPanel({
	        component: _DriverEditPassword2.default, props: {
	          item: this.entity
	        }
	      });
	    },
	    sendPasswordResetEmail: function sendPasswordResetEmail() {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to send the password reset link to this driver?', function () {
	        _backoffice2.default.drivers.select(_this2.entity).sendPasswordResetLink(function () {
	          _maggieHelper2.default.notification('Reset password:', 'An email for password reset has been sent', 'success');
	        });
	      });
	    },
	    suspend: function suspend() {
	      var _this3 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to suspend this driver?', function () {
	        _backoffice2.default.drivers.select(_this3.entity).suspend(function (response) {
	          _this3.entity = response;
	          var message = 'Driver ' + response.name + ' ' + response.surname + ' ' + 'has been Suspended';
	          _maggieHelper2.default.notification('Driver Suspension:', message, 'success');
	        });
	      });
	    },
	    approve: function approve() {
	      var _this4 = this;
	
	      _backoffice2.default.drivers.select(this.entity).approve(function (response) {
	        _this4.entity = response;
	        var message = 'Driver ' + response.name + ' ' + response.surname + ' ' + 'has been approved';
	        _maggieHelper2.default.notification('Driver Approval:', message, 'success');
	        _this4.$nextTick(function () {
	          return location.reload();
	        });
	      });
	    },
	    reactivate: function reactivate() {
	      var _this5 = this;
	
	      _backoffice2.default.drivers.select(this.entity).reactivate(function (response) {
	        _this5.entity = response;
	        var message = 'Driver ' + response.name + ' ' + response.surname + ' ' + 'has been reactivated';
	        _maggieHelper2.default.notification('Driver Reactivation: ', message, 'success');
	      });
	    },
	    deleteDriver: function deleteDriver() {
	      var _this6 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to delete this driver?', function () {
	        _backoffice2.default.drivers.select(_this6.entity).delete(function (response) {
	          var message = 'Driver has been deleted';
	          _maggieHelper2.default.notification('Driver deletion: ', message, 'success');
	        });
	      });
	    },
	    deleteClientAccount: function deleteClientAccount() {
	      var c = 'kepler:delete-client-data client-id:' + this.driver.client_id;
	      return _backoffice2.default.console.run(c, function (ok) {
	        _eventBus.EventBus.$emit('reload-list');
	      });
	    }
	  },
	  computed: {
	    canApprove: function canApprove() {
	      return this.$acl('approve-drivers') && (this.entity.status === 'PENDING REVIEW' || this.entity.status === 'ON HOLD');
	    },
	    canReactivate: function canReactivate() {
	      return this.$acl('reactivate-drivers') && this.entity.status === 'SUSPENDED';
	    },
	    canSuspend: function canSuspend() {
	      return this.$acl('suspend-drivers') && this.entity.status === 'ACTIVE';
	    },
	    canDelete: function canDelete() {
	      return this.$acl('delete-drivers') && this.entity.status === 'SUSPENDED';
	    },
	    canEdit: function canEdit() {
	      return this.$acl('edit-drivers');
	    },
	    canResetPassword: function canResetPassword() {
	      return this.$acl('reset-password-driver');
	    },
	    canSendResetPassword: function canSendResetPassword() {
	      return this.$acl('send-reset-driver');
	    },
	    canDo: function canDo() {
	      return !this.pendingDelete && (this.canApprove || this.canReactivate || this.canSuspend || this.canDelete || this.canEdit || this.canResetPassword || this.canSendResetPassword);
	    }
	  },
	  props: ['driver', 'item', 'pendingDelete']
	};

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PolicyReveal = __webpack_require__(63);
	
	var _PolicyReveal2 = _interopRequireDefault(_PolicyReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _GroupEdit = __webpack_require__(93);
	
	var _GroupEdit2 = _interopRequireDefault(_GroupEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverGroupButtons',
	  components: { GroupReveal: _GroupEdit2.default, PolicyReveal: _PolicyReveal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.driverGroups.select(this.driver.id).detach({ group_id: this.item.id }, function () {
	        _maggieHelper2.default.notification('', 'Policy deleted');
	        _this.$emit('refresh');
	      });
	    }
	  },
	
	  props: ['item', 'driver']
	};

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ClientEdit = __webpack_require__(545);
	
	var _ClientEdit2 = _interopRequireDefault(_ClientEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverLicenseAttachmentActionButtons",
	  components: {
	    ClientSmartEdit: _ClientEdit2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    openUrl: function openUrl(url) {
	      window.open(url, '_blank');
	    },
	    deletec: function deletec() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to delete this attachment?', function () {
	        _backoffice2.default.driverLicenses.select(_this.licenseId).removeAttachment(_this.attachmentId, function () {
	          _maggieHelper2.default.notification('delete-esit', 'Attachment deleted');
	          window.location.reload();
	        });
	      });
	    }
	  },
	  props: ['attachmentId', 'licenseId', 'attachmentUrl']
	};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CreateBookingFromReservationRequest = __webpack_require__(2034);
	
	var _CreateBookingFromReservationRequest2 = _interopRequireDefault(_CreateBookingFromReservationRequest);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _eventBus = __webpack_require__(15);
	
	var _UpdateDriverReservationRequestStatus = __webpack_require__(2057);
	
	var _UpdateDriverReservationRequestStatus2 = _interopRequireDefault(_UpdateDriverReservationRequestStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverReservationRequestButtons",
	  components: { UpdateDriverReservationRequestStatus: _UpdateDriverReservationRequestStatus2.default, ActionButton: _ActionButton2.default, CreateBookingFromReservationRequest: _CreateBookingFromReservationRequest2.default },
	  methods: {
	    reject: function reject() {
	      return _backoffice2.default.reservations.rejectDriverRequestBooking(this.item.id, function () {
	        _eventBus.EventBus.$emit('reload-list');
	
	        _maggieHelper2.default.notification('Driver booking request', 'deleted successfully');
	      });
	    }
	  },
	  props: ["item"]
	};

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SelectizeDocumentType = __webpack_require__(81);
	
	var _SelectizeDocumentType2 = _interopRequireDefault(_SelectizeDocumentType);
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _SelectizePlan = __webpack_require__(92);
	
	var _SelectizePlan2 = _interopRequireDefault(_SelectizePlan);
	
	var _SelectizeClientType = __webpack_require__(90);
	
	var _SelectizeClientType2 = _interopRequireDefault(_SelectizeClientType);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _eventBus = __webpack_require__(15);
	
	var _DocumentRequirementForm = __webpack_require__(557);
	
	var _DocumentRequirementForm2 = _interopRequireDefault(_DocumentRequirementForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditDocumentRequirementButtonModal',
	  components: {
	    DocumentRequirementForm: _DocumentRequirementForm2.default,
	    ActionButton: _ActionButton2.default, SelectizeClientType: _SelectizeClientType2.default, SelectizePlan: _SelectizePlan2.default, SelectizeCategory: _SelectizeCategory2.default, SelectizeDocumentType: _SelectizeDocumentType2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entityId: null,
	      entity_type: null,
	
	      body: {
	        entity_type: this.item.entity_class.replace("App\\Models\\", ""),
	        entity_id: null,
	        document_type_id: this.item.document_type.id,
	        document_group: this.item.document_group,
	        minimum_document_emission_years: this.item.minimum_document_emission_years,
	        minimum_driver_age: this.item.minimum_driver_age,
	        minimum_driver_registration_seniority: this.item.minimum_driver_registration_seniority,
	        minimum_bookings_in_last_days: this.item.minimum_bookings_in_last_days,
	        minimum_client_invoiced: this.item.minimum_client_invoiced,
	        maximum_client_failed_transactions: this.item.maximum_client_failed_transactions
	      },
	      options: []
	    };
	  },
	  created: function created() {
	    this.loadEntity();
	  },
	
	  methods: {
	    documentTypeSelected: function documentTypeSelected(obj) {
	      this.body.document_type_id = obj.id;
	    },
	    entitySelected: function entitySelected(obj) {
	      this.body.entity_id = obj.id;
	      this.body.entity_type = this.capitalize(this.body.entity_type);
	    },
	    capitalize: function capitalize(s) {
	      return s.split('_').map(function (x) {
	        return x.charAt(0).toUpperCase() + x.slice(1);
	      }).join('');
	    },
	    loadEntity: function loadEntity() {
	      var _this = this;
	
	      _backoffice2.default.documentRequirements.entityAllowed().entityList(function (data) {
	        _this.options = data;
	      });
	    },
	    save: function save() {
	      var _this2 = this;
	
	      return _backoffice2.default.documentRequirements.select(this.item).edit(this.body, function () {
	        _eventBus.EventBus.$emit('reload-list');
	        _this2.$refs.editModal.close();
	      });
	    }
	  },
	  computed: {},
	  props: ['item']
	};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FederationButtons',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.federations.select(this.item).remove(function () {
	        _maggieHelper2.default.notification('Federation', 'Federation deleted');
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PolicyReveal = __webpack_require__(63);
	
	var _PolicyReveal2 = _interopRequireDefault(_PolicyReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _GroupEdit = __webpack_require__(93);
	
	var _GroupEdit2 = _interopRequireDefault(_GroupEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GroupButtons',
	  components: { GroupReveal: _GroupEdit2.default, PolicyReveal: _PolicyReveal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.groups.select(this.item).remove(function () {
	        _maggieHelper2.default.notification('Policy', 'Policy deleted');
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "InstructionButtons",
	  components: {},
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', "Do you really want to <strong>Remove</strong> the <strong>IN" + this.item.id + " instruction?</strong>", function () {
	        _backoffice2.default.instructions.select(_this.item).remove(function () {
	          _maggieHelper2.default.notification('delete-esit', "Instruction removed");
	          window.location.reload();
	        });
	      });
	    },
	    removeFromVehicle: function removeFromVehicle() {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', "Do you really want to <strong>Remove</strong> the <strong>IN" + this.item.id + " instruction?</strong>", function () {
	        _backoffice2.default.vehicleInstructions.select(_this2.item).remove(function () {
	          _maggieHelper2.default.notification('delete-esit', "Instruction removed");
	          window.location.reload();
	        });
	      });
	    }
	  },
	  props: ['item', 'vehicle']
	};

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CreateInterventionRequestReveal = __webpack_require__(153);
	
	var _CreateInterventionRequestReveal2 = _interopRequireDefault(_CreateInterventionRequestReveal);
	
	var _EditInterventionRequestReveal = __webpack_require__(2139);
	
	var _EditInterventionRequestReveal2 = _interopRequireDefault(_EditInterventionRequestReveal);
	
	var _DetailInterventionRequestReveal = __webpack_require__(599);
	
	var _DetailInterventionRequestReveal2 = _interopRequireDefault(_DetailInterventionRequestReveal);
	
	var _eventBus = __webpack_require__(15);
	
	var _CompleteInterventionRequestReveal = __webpack_require__(2118);
	
	var _CompleteInterventionRequestReveal2 = _interopRequireDefault(_CompleteInterventionRequestReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "InterventionRequestButtons",
	  components: {
	    CompleteInterventionRequestReveal: _CompleteInterventionRequestReveal2.default,
	    DetailInterventionRequestReveal: _DetailInterventionRequestReveal2.default,
	    EditInterventionRequestReveal: _EditInterventionRequestReveal2.default, InterventionRequestReveal: _CreateInterventionRequestReveal2.default, ModalReveal: _ModalReveal2.default, ActionButton: _ActionButton2.default
	  },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      return _backoffice2.default.maintenanceRequest.select(this.item).remove(function () {
	        _eventBus.EventBus.$emit('reload-list');
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ConfirmDialog = __webpack_require__(2023);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Reveal = __webpack_require__(122);
	
	var _Reveal2 = _interopRequireDefault(_Reveal);
	
	var _InvoiceRevealVoid = __webpack_require__(2077);
	
	var _InvoiceRevealVoid2 = _interopRequireDefault(_InvoiceRevealVoid);
	
	var _InvoiceRevealMarkAsPaid = __webpack_require__(2073);
	
	var _InvoiceRevealMarkAsPaid2 = _interopRequireDefault(_InvoiceRevealMarkAsPaid);
	
	var _InvoiceRevealPay = __webpack_require__(2074);
	
	var _InvoiceRevealPay2 = _interopRequireDefault(_InvoiceRevealPay);
	
	var _InvoiceRevealTransactions = __webpack_require__(2076);
	
	var _InvoiceRevealTransactions2 = _interopRequireDefault(_InvoiceRevealTransactions);
	
	var _IsModuleEnabled = __webpack_require__(199);
	
	var _IsModuleEnabled2 = _interopRequireDefault(_IsModuleEnabled);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _EinvoiceGetStatus = __webpack_require__(1954);
	
	var _EinvoiceGetStatus2 = _interopRequireDefault(_EinvoiceGetStatus);
	
	var _SendToExternalService = __webpack_require__(1955);
	
	var _SendToExternalService2 = _interopRequireDefault(_SendToExternalService);
	
	var _InvoiceRevealRecords = __webpack_require__(2075);
	
	var _InvoiceRevealRecords2 = _interopRequireDefault(_InvoiceRevealRecords);
	
	var _UpdateEinvoiceFileName = __webpack_require__(1956);
	
	var _UpdateEinvoiceFileName2 = _interopRequireDefault(_UpdateEinvoiceFileName);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ConvertProformaToCreditNote = __webpack_require__(2070);
	
	var _ConvertProformaToCreditNote2 = _interopRequireDefault(_ConvertProformaToCreditNote);
	
	var _DownloadInvoiceAsEvilVersion = __webpack_require__(1957);
	
	var _DownloadInvoiceAsEvilVersion2 = _interopRequireDefault(_DownloadInvoiceAsEvilVersion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvoiceActionButtons',
	  components: {
	    DownloadAsEvilVersion: _DownloadInvoiceAsEvilVersion2.default,
	    ConvertProformaToCreditNote: _ConvertProformaToCreditNote2.default,
	    ActionButton: _ActionButton2.default,
	    UpdateEinvoiceFileName: _UpdateEinvoiceFileName2.default,
	    InvoiceRecords: _InvoiceRevealRecords2.default,
	    InvoiceTransactions: _InvoiceRevealTransactions2.default,
	    InvoiceRevealPay: _InvoiceRevealPay2.default,
	    InvoiceRevealMarkAsPaid: _InvoiceRevealMarkAsPaid2.default,
	    InvoiceRevealVoid: _InvoiceRevealVoid2.default,
	    Reveal: _Reveal2.default,
	    ConfirmDialog: _ConfirmDialog2.default,
	    SendToExternal: _SendToExternalService2.default,
	    EinvoiceGetStatus: _EinvoiceGetStatus2.default,
	    ModalReveal: _ModalReveal2.default,
	    CardN: _CardN2.default,
	    IsModuleEnabled: _IsModuleEnabled2.default
	  },
	  data: function data() {
	    return {
	      entity: null,
	      xmlUrl: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.invoice) {
	      _backoffice2.default.invoices.select(this.$route.params.id).get(function (item) {
	        _this.entity = item;
	      });
	    } else {
	      this.entity = this.invoice;
	    }
	  },
	
	  methods: {
	    payInvoice: function payInvoice() {
	      var _this2 = this;
	
	      _backoffice2.default.invoices.select(this.entity).payInvoice(function (response) {
	        _this2.entity = response;
	        _maggieHelper2.default.notification('pay-esit', 'Invoice has been paid');
	      });
	    },
	    setPaid: function setPaid() {
	      var _this3 = this;
	
	      _backoffice2.default.invoices.select(this.entity).setPaid(function (response) {
	        _this3.entity = response;
	        _maggieHelper2.default.notification('paid-esit', 'Invoice has been set as paid');
	      });
	    },
	
	    openUrl: function openUrl(url) {
	      window.open(url, '_blank');
	    },
	    downloadXML: function downloadXML() {
	      _backoffice2.default.invoices.select(this.entity).downloadXML(function (data) {
	        window.open(data, '_blank');
	      });
	    },
	    markAsAwaitingPayment: function markAsAwaitingPayment() {
	      var _this4 = this;
	
	      return _backoffice2.default.invoices.select(this.entity).setAwaitingPayment(function (response) {
	        _this4.entity = response;
	        _maggieHelper2.default.notification('Invoice', 'Invoice has been set as awaiting payment');
	      });
	    }
	  },
	  props: ['invoice', 'item']
	};

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _PacketForm = __webpack_require__(202);
	
	var _PacketForm2 = _interopRequireDefault(_PacketForm);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _eventBus = __webpack_require__(15);
	
	var _EditPageReveal = __webpack_require__(601);
	
	var _EditPageReveal2 = _interopRequireDefault(_EditPageReveal);
	
	var _EditPacketReveal = __webpack_require__(2072);
	
	var _EditPacketReveal2 = _interopRequireDefault(_EditPacketReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PacketButtons",
	  components: { EditPacketReveal: _EditPacketReveal2.default, EditPageReveal: _EditPageReveal2.default, PacketForm: _PacketForm2.default, ModalReveal: _ModalReveal2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  props: ['item']
	};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _PacketRecordUsageReveal = __webpack_require__(2078);
	
	var _PacketRecordUsageReveal2 = _interopRequireDefault(_PacketRecordUsageReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PacketRecordButtons',
	  components: { PacketRecordUsageReveal: _PacketRecordUsageReveal2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  props: ['item']
	};

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PacketVehicleCategoryModal = __webpack_require__(577);
	
	var _PacketVehicleCategoryModal2 = _interopRequireDefault(_PacketVehicleCategoryModal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PacketVehicleCategoryButton",
	  components: { PacketVehicleCategoryModal: _PacketVehicleCategoryModal2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.packetVehicleCategories.select(this.item).delete(this.item, function (data) {
	        _maggieHelper2.default.notification('delete-esit', data.result_code);
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _EditPageReveal = __webpack_require__(601);
	
	var _EditPageReveal2 = _interopRequireDefault(_EditPageReveal);
	
	var _eventBus = __webpack_require__(15);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PageButtons',
	  components: { PageReveal: _EditPageReveal2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    preview: function preview() {
	      return this.configuration.company.company_start_url.value.replace('registration?client_token=', '');
	    },
	    remove: function remove() {
	      return _backoffice2.default.pages.select(this.item.id).remove(function () {
	        _maggieHelper2.default.notification('', 'Policy deleted');
	        _eventBus.EventBus.$emit('reload-list');
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    appUrl: function appUrl() {
	      return this.configuration.company.company_start_url.value.replace('registration?client_token=', 'pages/' + this.item.slug);
	    }
	  }),
	  props: ['item']
	};

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _VehicleEdit = __webpack_require__(193);
	
	var _VehicleEdit2 = _interopRequireDefault(_VehicleEdit);
	
	var _AssetManagementActionButtons = __webpack_require__(209);
	
	var _AssetManagementActionButtons2 = _interopRequireDefault(_AssetManagementActionButtons);
	
	var _SwapAsset = __webpack_require__(217);
	
	var _SwapAsset2 = _interopRequireDefault(_SwapAsset);
	
	var _MoveAsset = __webpack_require__(216);
	
	var _MoveAsset2 = _interopRequireDefault(_MoveAsset);
	
	var _DismissAsset = __webpack_require__(215);
	
	var _DismissAsset2 = _interopRequireDefault(_DismissAsset);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ForceRebook = __webpack_require__(576);
	
	var _ForceRebook2 = _interopRequireDefault(_ForceRebook);
	
	var _VehicleSlotDisableReveal = __webpack_require__(578);
	
	var _VehicleSlotDisableReveal2 = _interopRequireDefault(_VehicleSlotDisableReveal);
	
	var _EditParkingGroup = __webpack_require__(575);
	
	var _EditParkingGroup2 = _interopRequireDefault(_EditParkingGroup);
	
	var _DeleteParkingGroup = __webpack_require__(574);
	
	var _DeleteParkingGroup2 = _interopRequireDefault(_DeleteParkingGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ParkingGroupButtons',
	  components: {
	    DeleteParkingGroup: _DeleteParkingGroup2.default,
	    EditParkingGroup: _EditParkingGroup2.default,
	    VehicleSlotDisableReveal: _VehicleSlotDisableReveal2.default,
	    ForceRebook: _ForceRebook2.default,
	    DatePicker: _DatePicker2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    ModalReveal: _ModalReveal2.default, DismissAsset: _DismissAsset2.default, MoveAsset: _MoveAsset2.default, SwapAsset: _SwapAsset2.default, AssetManagementActionButtons: _AssetManagementActionButtons2.default, VehicleSmartEdit: _VehicleEdit2.default
	  },
	  data: function data() {
	    return {
	      entity: null,
	      start: null,
	      end: null
	    };
	  },
	  created: function created() {},
	
	  methods: {},
	  props: ['item'],
	  computed: {}
	};

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ParkingLotEdit = __webpack_require__(1964);
	
	var _ParkingLotEdit2 = _interopRequireDefault(_ParkingLotEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ParkingLotActionButtons',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entity: { config: null }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.entity.config = (0, _stringify2.default)({}, null, 2);
	
	    if (this.parkingLot === null) {
	      _backoffice2.default.parkingLots.select(this.$route.params.id).get(function (item) {
	        _this.entity = item;
	        _this.entity.config = (0, _stringify2.default)(_this.entity.config, null, 2);
	      });
	    }
	  },
	
	  methods: {
	    save: function save() {
	      var body = (0, _extends3.default)({}, this.entity);
	      body.slots = this.entity.parking_slots.length;
	      body.latitude = this.entity.position.latitude;
	      body.longitude = this.entity.position.longitude;
	      body.config = JSON.parse(this.entity.config);
	      return _backoffice2.default.parkingLots.select(this.$route.params.id).update(body, function (data) {
	        _maggieHelper2.default.notification('update-esit', 'Parking lot updated');
	        _eventBus.EventBus.$emit('close-modal');
	      });
	    },
	    remove: function remove() {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Will be tried a hard delete on all the parking slots and vehicle slots connected', function () {
	        _backoffice2.default.parkingLots.select(_this2.parkingLot).remove(function () {
	          _maggieHelper2.default.notification('Deleted', 'Parking lot and on all the parking slots and vehicle slots connected have been deleted');
	        });
	      });
	    },
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _ParkingLotEdit2.default, props: {
	          item: this.entity
	        }
	      });
	    }
	  },
	  props: {
	    parkingLot: {
	      default: null
	    }
	  }
	};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PolicyReveal = __webpack_require__(63);
	
	var _PolicyReveal2 = _interopRequireDefault(_PolicyReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _CouponReveal = __webpack_require__(126);
	
	var _CouponReveal2 = _interopRequireDefault(_CouponReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PaymentMethodButtons',
	  components: { CouponReveal: _CouponReveal2.default, PolicyReveal: _PolicyReveal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.payment_methods.select(this.item).remove(function () {
	        _maggieHelper2.default.notification('', 'Payment method deleted');
	        _this.$emit('refresh');
	      });
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _PlanEdit = __webpack_require__(1965);
	
	var _PlanEdit2 = _interopRequireDefault(_PlanEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PlanActionButtons",
	  components: {
	    plan: null
	  },
	  data: function data() {
	    return {
	      tocs: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.plans.select(this.$route.params.id).get(function (item) {
	      _this.entity = item;
	    });
	
	    _backoffice2.default.tocs.list.all(function (data) {
	      data.forEach(function (item) {
	        _this.tocs[item.id] = item.name;
	      });
	    });
	  },
	
	  methods: {
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _PlanEdit2.default, props: {
	          item: this.entity,
	          tocs: this.tocs
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _eventBus = __webpack_require__(15);
	
	var _EditPlanReservationRates = __webpack_require__(551);
	
	var _EditPlanReservationRates2 = _interopRequireDefault(_EditPlanReservationRates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PlanReservationRateActionButtons",
	  components: { EditPlanReservationRates: _EditPlanReservationRates2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'Do you really want delete this plan reservation rate?', function () {
	        _backoffice2.default.planReservationRates.select(_this.item).remove(function () {
	          _maggieHelper2.default.notification('Deleted', 'Plan reservation rate deleted successfully');
	          _eventBus.EventBus.$emit('reload-list');
	        });
	      });
	    }
	  },
	  computed: {},
	  props: ['item']
	};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PolicyReveal = __webpack_require__(63);
	
	var _PolicyReveal2 = _interopRequireDefault(_PolicyReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PolicyButtons',
	  components: { PolicyReveal: _PolicyReveal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.policies.select(this.item).remove(function () {
	        _maggieHelper2.default.notification('', 'Policy deleted');
	        location.reload();
	        _this.$emit('refresh');
	      });
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _CashInPreauthReveal = __webpack_require__(2110);
	
	var _CashInPreauthReveal2 = _interopRequireDefault(_CashInPreauthReveal);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PreauthButtons",
	  components: { CashInPreauthReveal: _CashInPreauthReveal2.default, ActionButton: _ActionButton2.default },
	  methods: {
	    cancelPreauth: function cancelPreauth() {
	      return _backoffice2.default.preauth.select(this.item.id).cancel(function () {
	        _maggieHelper2.default.notification('', 'preauth canceled');
	        _eventBus.EventBus.$emit('reload-list');
	      });
	    },
	    refresh: function refresh() {
	      return _backoffice2.default.preauth.select(this.item.id).refresh(function () {
	        _maggieHelper2.default.notification('', 'preauth refreshed');
	        _eventBus.EventBus.$emit('reload-list');
	      });
	    }
	  },
	  props: ["item"]
	};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PolicyReveal = __webpack_require__(63);
	
	var _PolicyReveal2 = _interopRequireDefault(_PolicyReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _CouponReveal = __webpack_require__(126);
	
	var _CouponReveal2 = _interopRequireDefault(_CouponReveal);
	
	var _RegistrationTokenReveal = __webpack_require__(603);
	
	var _RegistrationTokenReveal2 = _interopRequireDefault(_RegistrationTokenReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RegistrationTokenButtons',
	  components: { RegistrationTokenReveal: _RegistrationTokenReveal2.default, CouponReveal: _CouponReveal2.default, PolicyReveal: _PolicyReveal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.registrationTokens.select(this.item.id).remove(function () {
	        _maggieHelper2.default.notification('', 'Token deleted');
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "ReportingActionButtons",
	    components: {},
	    data: function data() {
	        return {
	            entity: null
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        if (!this.reporting) {
	            _backoffice2.default.reportings.select(this.$route.params.id).get(function (item) {
	                _this.entity = item;
	            });
	        } else {
	            this.entity = this.reporting;
	        }
	    },
	
	    methods: {
	        confirm: function confirm() {
	            var _this2 = this;
	
	            this.$confirm('Are you sure?', 'Do you really want to confirm?', function () {
	                _backoffice2.default.reportings.select(_this2.entity.id).setConfirmed(function () {
	                    _maggieHelper2.default.notification('update-esit', 'Reporting confirmed');
	                    location.reload();
	                });
	            });
	        },
	        resolve: function resolve() {
	            var _this3 = this;
	
	            this.$confirm('Are you sure?', 'Do you really want to resolve?', function () {
	                _backoffice2.default.reportings.select(_this3.entity.id).setResolved(function () {
	                    _maggieHelper2.default.notification('update-esit', 'Reporting resolved');
	                    location.reload();
	                });
	            });
	        },
	        voided: function voided() {
	            var _this4 = this;
	
	            this.$confirm('Are you sure?', 'Do you really want to void?', function () {
	                _backoffice2.default.reportings.select(_this4.entity.id).setVoided(function () {
	                    _maggieHelper2.default.notification('update-esit', 'Reporting voided');
	                    location.reload();
	                });
	            });
	        }
	    },
	    props: ['reporting', 'item']
	};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SelectizeDocumentType = __webpack_require__(81);
	
	var _SelectizeDocumentType2 = _interopRequireDefault(_SelectizeDocumentType);
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _SelectizePlan = __webpack_require__(92);
	
	var _SelectizePlan2 = _interopRequireDefault(_SelectizePlan);
	
	var _SelectizeClientType = __webpack_require__(90);
	
	var _SelectizeClientType2 = _interopRequireDefault(_SelectizeClientType);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _DocumentRequirementList = __webpack_require__(600);
	
	var _DocumentRequirementList2 = _interopRequireDefault(_DocumentRequirementList);
	
	var _DocumentRequirement = __webpack_require__(532);
	
	var _DocumentRequirement2 = _interopRequireDefault(_DocumentRequirement);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _DocumentRequirementForm = __webpack_require__(557);
	
	var _DocumentRequirementForm2 = _interopRequireDefault(_DocumentRequirementForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RequirementModal',
	  components: {
	    DocumentRequirementForm: _DocumentRequirementForm2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    DocumentRequirement: _DocumentRequirement2.default,
	    RequirementList: _DocumentRequirementList2.default,
	    ActionButton: _ActionButton2.default, SelectizeClientType: _SelectizeClientType2.default, SelectizePlan: _SelectizePlan2.default, SelectizeCategory: _SelectizeCategory2.default, SelectizeDocumentType: _SelectizeDocumentType2.default, ModalReveal: _ModalReveal2.default
	  },
	  data: function data() {
	    return {
	      body: {
	        entity_type: this.entity_type,
	        entity_id: this.entity_id,
	        document_type_id: null,
	        document_group: null,
	        minimum_document_emission_years: null,
	        minimum_driver_age: null,
	        minimum_driver_registration_seniority: null,
	        minimum_bookings_in_last_days: null,
	        minimum_client_invoiced: null,
	        maximum_client_failed_transactions: null
	      },
	      requirements: [],
	      loading: false
	    };
	  },
	  created: function created() {
	    this.hide = !this.hide;
	    this.loadRequirements();
	  },
	
	  methods: {
	    loadRequirements: function loadRequirements() {
	      var _this = this;
	
	      this.requirements = [];
	      this.loading = true;
	      _backoffice2.default.documentRequirements.list().all(function (data) {
	        _this.requirements = data.filter(function (item) {
	          return _this.entity_id === item.entity.id && _this.entity_type === item.entity_class.replace(/App\\Models\\/, '');
	        });
	        _this.loading = false;
	      });
	    },
	    save: function save() {
	      var _this2 = this;
	
	      return _backoffice2.default.documentRequirements.make(this.body, function () {
	        _this2.$emit('itemUpdated');
	        _this2.loadRequirements();
	      });
	    }
	  },
	  props: ['entity_id', 'entity_type'],
	  computed: {}
	};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ReservationEdit = __webpack_require__(1966);
	
	var _ReservationEdit2 = _interopRequireDefault(_ReservationEdit);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeParkingLot = __webpack_require__(150);
	
	var _SelectizeParkingLot2 = _interopRequireDefault(_SelectizeParkingLot);
	
	var _ReservationUncoveredAmount = __webpack_require__(2173);
	
	var _ReservationUncoveredAmount2 = _interopRequireDefault(_ReservationUncoveredAmount);
	
	var _TerminateReservationReveal = __webpack_require__(2056);
	
	var _TerminateReservationReveal2 = _interopRequireDefault(_TerminateReservationReveal);
	
	var _ChargingSessionReveal = __webpack_require__(593);
	
	var _ChargingSessionReveal2 = _interopRequireDefault(_ChargingSessionReveal);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _PreauthReveal = __webpack_require__(2165);
	
	var _PreauthReveal2 = _interopRequireDefault(_PreauthReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _SelectizeMaintenanceDriver = __webpack_require__(587);
	
	var _SelectizeMaintenanceDriver2 = _interopRequireDefault(_SelectizeMaintenanceDriver);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationActionButtons',
	  components: {
	    SelectizeMaintenanceDriver: _SelectizeMaintenanceDriver2.default,
	    ModalReveal: _ModalReveal2.default,
	    PreauthReveal: _PreauthReveal2.default,
	    ChargingSessionReveal: _ChargingSessionReveal2.default,
	    TerminateReservationReveal: _TerminateReservationReveal2.default,
	    ReservationUncoveredAmountReveal: _ReservationUncoveredAmount2.default,
	    SelectizeParkingLot: _SelectizeParkingLot2.default,
	    DatePicker: _DatePicker2.default,
	    ActionButton: _ActionButton2.default
	  },
	  data: function data() {
	    return {
	      replaceDriverBody: {
	        driver_id: null
	      },
	      strategy: null,
	      value: null,
	      entity: null,
	      extra: {
	        owff_dropoff_parking_lot: null
	      },
	      extendComponent: __webpack_require__(1916),
	      completeAsOriginalEnd: false,
	      completeModal: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.reservation) {
	      _backoffice2.default.reservations.select(this.$route.params.id).get(function (item) {
	        _this.entity = item;
	      });
	    } else {
	      this.entity = this.reservation;
	    }
	  },
	
	  methods: {
	    open: function open() {
	      _backoffice2.default.reservations.select(this.entity.number).open(function () {
	        _maggieHelper2.default.notification('open-esit', 'vehicle open signal sent');
	      });
	    },
	    close: function close() {
	      _backoffice2.default.reservations.select(this.entity.number).close(function () {
	        _maggieHelper2.default.notification('close-esit', 'vehicle close signal sent');
	      });
	    },
	    voidR: function voidR() {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to <strong>Void</strong> the reservation <strong>' + this.entity.number + '</strong>?', function () {
	        _backoffice2.default.reservations.select(_this2.entity.number).void(function () {
	          _maggieHelper2.default.notification('void-esit', 'reservation voided');
	        });
	      });
	    },
	    complete: function complete() {
	      var value = null;
	      if (this.value !== null) {
	        value = this.$convertTimestamp(this.value);
	      }
	
	      return _backoffice2.default.reservations.select(this.entity.number).complete({
	        strategy: this.strategy,
	        value: value,
	        extra: this.extra
	      }, function () {
	        _maggieHelper2.default.notification('complete-esit', 'reservation completed');
	      });
	    },
	    cancel: function cancel() {
	      var _this3 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to <strong>Cancel</strong> the reservation <strong>' + this.entity.number + '</strong>?', function () {
	        _backoffice2.default.reservations.select(_this3.entity.number).cancel(function () {
	          _maggieHelper2.default.notification('cancel-esit', 'reservation cancelled');
	        });
	      });
	    },
	    resend: function resend() {
	      var _this4 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to <strong>Force resend</strong> the reservation <strong>' + this.entity.number + '</strong>?', function () {
	        _backoffice2.default.reservations.select(_this4.entity.number).resend(function () {
	          _maggieHelper2.default.notification('resend-esit', 'reservation sent');
	        });
	      });
	    },
	    extend: function extend() {
	      _maggieHelper2.default.openTopPanel({
	        component: this.extendComponent,
	        props: {
	          reservation: this.entity
	        }
	      });
	    },
	    findReplace: function findReplace() {
	      this.$router.push({ name: 'replace-vehicle' });
	    },
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _ReservationEdit2.default,
	        props: {
	          item: this.entity
	        }
	      });
	    },
	    reconciliate: function reconciliate() {
	      return _backoffice2.default.reservations.select(this.entity.number).reconciliate(function () {
	        _maggieHelper2.default.notification('Reconciliation', 'Reservation has been processed');
	      });
	    },
	    uncoveredAmount: function uncoveredAmount() {
	      return _backoffice2.default.reservations.select(this.entity.number).uncoveredAmount(function (data) {
	
	        alert(data.uncovered_amount);
	      });
	    },
	    cleanup: function cleanup() {
	      return _backoffice2.default.reservations.select(this.entity.number).cleanUp(function (data) {
	        _maggieHelper2.default.notification('Cleanup', 'Cleanup command sent to vehicle');
	      });
	    },
	    save: function save() {
	      return _backoffice2.default.reservations.select(this.entity.number).replaceMaintenanceDriver(this.replaceDriverBody, function () {
	        _maggieHelper2.default.notification('Replace', 'Operator changed');
	        _eventBus.EventBus.$emit('close-modal');
	        _eventBus.EventBus.$emit('refresh-entity');
	      });
	    }
	  },
	  computed: {
	    canBeReplaced: function canBeReplaced() {
	      return (this.entity.status === 'CONFIRMED' || this.entity.status === 'STARTED' || this.entity.status === 'PLANNED' || this.entity.status === 'SENT') && this.entity.booking_mode === 'RT';
	    }
	  },
	  props: ['reservation', 'item']
	};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PolicyReveal = __webpack_require__(63);
	
	var _PolicyReveal2 = _interopRequireDefault(_PolicyReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _CouponReveal = __webpack_require__(126);
	
	var _CouponReveal2 = _interopRequireDefault(_CouponReveal);
	
	var _SegmentRateReveal = __webpack_require__(605);
	
	var _SegmentRateReveal2 = _interopRequireDefault(_SegmentRateReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SegmentButtons',
	  components: { SegmentRevealRate: _SegmentRateReveal2.default, CouponReveal: _CouponReveal2.default, PolicyReveal: _PolicyReveal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.segmentRates.select(this.item.id).remove(function () {
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SegmentReveal',
	  components: {
	    TranslateField: _TranslateField2.default,
	    KeplerFileUpload: _KeplerFileUpload2.default,
	    Editor: _Editor2.default,
	    ActionButton: _ActionButton2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    ModalReveal: _ModalReveal2.default
	
	  },
	  data: function data() {
	    return {
	      body: {
	        name: null,
	        description: "",
	        hint: null,
	        picture: null
	
	      }
	
	    };
	  },
	  created: function created() {
	    if (this.segment !== null) {
	      for (var key in this.segment) {
	        switch (key) {
	          case 'segment_rates':
	            this.body[key] = this.segment[key].map(function (item) {
	              return item.id;
	            });
	            break;
	          default:
	            this.body[key] = this.segment[key];
	        }
	      }
	    }
	  },
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      if (this.segment !== null) {
	        return _backoffice2.default.segments.select(this.segment.id).edit(this.body, function () {
	          _this.$emit('itemUpdated');
	          _this.$refs[_this.componentId].close();
	        });
	      }
	      return _backoffice2.default.segments.make(this.body, function () {
	        _this.$emit('itemUpdated');
	        _this.$refs[_this.componentId].close();
	      });
	    },
	    handleFileSelector: function handleFileSelector(path) {
	      this.body.picture = path;
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      var item = this.item !== null ? this.item : this.segment;
	      var id = item == null ? this._uuid : item.id;
	      return "segmentReveal-" + id;
	    }
	  },
	  props: {
	    item: {
	      type: Object,
	      default: null
	    },
	    segment: {
	      type: Object,
	      default: null
	    }
	
	  }
	};

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(163);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SubscriptionEdit = __webpack_require__(546);
	
	var _SubscriptionEdit2 = _interopRequireDefault(_SubscriptionEdit);
	
	var _ActionButtons = __webpack_require__(2029);
	
	var _ActionButtons2 = _interopRequireDefault(_ActionButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SubscriptionActionButtons",
	  components: { ActionButtons: _ActionButtons2.default, SubscriptionSmartEdit: _SubscriptionEdit2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.subscription) {
	      _backoffice2.default.subscriptions.select(this.$route.params.id).get(function (data) {
	        _this.entity = data;
	      });
	    } else {
	      this.entity = this.subscription;
	    }
	  },
	
	  methods: {
	    remove: function remove() {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to <strong>Delete</strong> the subsription <strong>' + this.entity.id + '</strong>?', function () {
	        _backoffice2.default.subscriptions.select(_this2.entity.id).remove(function () {
	          _maggieHelper2.default.notification('delete-esit', "Subscription deleted");
	        });
	      });
	    },
	    renew: function renew() {
	      var _this3 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to <strong>Renew</strong> the subsription <strong>' + this.entity.id + '</strong>?', function () {
	        _backoffice2.default.subscriptions.select(_this3.entity.id).renew(function () {
	          _maggieHelper2.default.notification('renew-esit', "Subscription renewed");
	        });
	      });
	    },
	    disable: function disable() {
	      var _this4 = this;
	
	      this.$confirm('Are you sure?', 'Do you really <strong>Void</strong> the subscription <strong>' + this.entity.id + '</strong>?', function () {
	        _backoffice2.default.subscriptions.select(_this4.entity.id).disable(function () {
	          _maggieHelper2.default.notification('void-esit', "Subscription voided");
	        });
	      });
	    },
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _SubscriptionEdit2.default,
	        props: {
	          item: this.entity
	        }
	      });
	    }
	  },
	  props: ['subscription', 'item', 'type'],
	  computed: {
	    actions: function actions() {
	      var _this5 = this;
	
	      var arr = [];
	      var aclMap = new _map2.default([['renew-subscriptions', {
	        name: 'Renew',
	        callback: this.renew,
	        severity: 'success'
	      }], ['void-subscription-subscriptions', {
	        name: 'Void',
	        callback: this.disable,
	        severity: 'alert'
	      }], ['edit-subscriptions', {
	        name: 'Edit',
	        callback: this.edit,
	        severity: 'alert'
	      }], ['delete-subscriptions', {
	        name: 'Delete',
	        callback: this.remove,
	        severity: 'alert'
	      }]]);
	      aclMap.forEach(function (val, key) {
	        if (_this5.$acl(key)) {
	          arr.push(val);
	        }
	      });
	      return arr;
	    }
	  }
	};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TerminateReservationReveal',
	  components: { ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	
	  data: function data() {
	    return {
	      terminateBody: {
	        acceptUndesiderable: false,
	        forceForbidden: false
	      }
	    };
	  },
	
	  methods: {
	    terminate: function terminate() {
	      return _backoffice2.default.reservations.select(this.entity.number).terminate(this.terminateBody, function () {
	        _maggieHelper2.default.notification('terminate-esit', 'reservation ended');
	        this.$refs.terminateModal.close();
	      });
	    }
	  },
	  props: {
	    entity: {}
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }))
	};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TocButtons",
	  components: {},
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', "Do you really want to <strong>Remove</strong> the <strong>T" + this.item.id + " toc?</strong>", function () {
	        _backoffice2.default.tocs.select(_this.item).remove(function () {
	          _maggieHelper2.default.notification('delete-esit', "Toc removed");
	          window.location.reload();
	        });
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TocTypeButtons',
	  components: { ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to <strong>Remove</strong> the <strong>TT' + this.item.id + ' toc type?</strong>', function () {
	        _backoffice2.default.tocTypes.select(_this.item).remove(function () {
	          _maggieHelper2.default.notification('delete-esit', 'Toc removed');
	          window.location.reload();
	        });
	      });
	    },
	    edit: function edit() {
	      _backoffice2.default.tocTypes.select(this.item).edit(this.item, function () {
	        window.location.reload();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _TransactionRevealRefund = __webpack_require__(2082);
	
	var _TransactionRevealRefund2 = _interopRequireDefault(_TransactionRevealRefund);
	
	var _gatewayUrlHelper = __webpack_require__(239);
	
	var _gatewayUrlHelper2 = _interopRequireDefault(_gatewayUrlHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "TransactionActionButtons",
	    components: {
	        TransactionRevealRefund: _TransactionRevealRefund2.default
	    },
	    data: function data() {
	        return {
	            entity: null,
	            refundFields: {
	                amount: null
	            }
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        if (!this.transaction) {
	            _backoffice2.default.transactions.select(this.$route.params.id).get(function (item) {
	                _this.entity = item;
	            });
	        } else {
	            this.entity = this.transaction;
	        }
	    },
	
	    methods: {
	        refund: function refund() {
	            var _this2 = this;
	
	            _maggieHelper2.default.showPreloader();
	
	            _backoffice2.default.transactions.select(this.entity).refund(this.refundFields, function (response) {
	                _this2.entity = response;
	                _maggieHelper2.default.hidePreloader();
	            }, function (response) {
	                _maggieHelper2.default.notification('refund-esit', response, 'error');
	                _maggieHelper2.default.hidePreloader();
	            });
	        },
	        viewOnGateway: function viewOnGateway() {
	            var url = _gatewayUrlHelper2.default.transactionUrl(this.entity.payment_method_provider, this.entity.transaction_uid);
	            window.open(url, '_blank');
	        }
	    },
	    props: ['transaction', 'item']
	};

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TranslationButtons",
	  components: {},
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', "Do you really want to <strong>Remove</strong> the <strong>T" + this.item.id + " translation?</strong>", function () {
	        _backoffice2.default.translations.select(_this.item).remove(function () {
	          _maggieHelper2.default.notification('delete-esit', "Translation removed");
	          _this.$nextTick(function () {
	            window.location.reload();
	          });
	        });
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PolicyReveal = __webpack_require__(63);
	
	var _PolicyReveal2 = _interopRequireDefault(_PolicyReveal);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _GroupEdit = __webpack_require__(93);
	
	var _GroupEdit2 = _interopRequireDefault(_GroupEdit);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _SelectizeParkingLot = __webpack_require__(150);
	
	var _SelectizeParkingLot2 = _interopRequireDefault(_SelectizeParkingLot);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UpdateDriverReservationRequestStatus',
	  components: { Vehicle: _Vehicle2.default, SelectizeParkingLot: _SelectizeParkingLot2.default, Driver: _Driver2.default, GroupReveal: _GroupEdit2.default, PolicyReveal: _PolicyReveal2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      slots: [],
	      loading: false,
	      body: {
	        status: null
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    collect: _collect2.default,
	    search: function search() {
	      this.loading = true;
	    },
	    updateStatus: function updateStatus() {
	      var _this = this;
	
	      return _backoffice2.default.reservations.updateStatusRequest(this.item.id, { status: this.body.status }, function (response) {
	        _maggieHelper2.default.notification('Driver reservation request', 'Request updated');
	        _eventBus.EventBus.$emit('reload-list');
	        _this.$refs[_this.modal].close();
	      });
	    },
	    bookNow: function bookNow(vehicle) {
	      var _this2 = this;
	
	      _backoffice2.default.reservations.makeDriverRequestBooking(this.item.id, { plate: vehicle.plate }, function (response) {
	        _maggieHelper2.default.notification('book-esit', 'reservation created');
	        _this2.$refs[_this2.modal].close();
	        _this2.$router.push({ name: 'reservation', params: { id: response.id } });
	      });
	    }
	  },
	  computed: {
	    modal: function modal() {
	      return 'modal-' + this._uid;
	    }
	  },
	  props: ['item', 'driver']
	};

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UserButtons',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.users.select(this.item).remove(function () {
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _EditReportingType = __webpack_require__(127);
	
	var _EditReportingType2 = _interopRequireDefault(_EditReportingType);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VatButtonModal',
	  components: { ActionButton: _ActionButton2.default, EditReportingType: _EditReportingType2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      body: {
	        name: null,
	        description: null,
	        percentage: null
	      },
	      clientType: {
	        name: null,
	        type: 'PRIVATE'
	      },
	      key: 0
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    closeInput: function closeInput(event) {
	      if (!event) {
	        this.key++;
	        this.body = {};
	      }
	    },
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.vats.make(this.body, function () {
	        _this.key++;
	        _this.body = {};
	        _this.$refs[_this.componentId].close();
	        _this.$store.dispatch('loadVat');
	        location.reload();
	      });
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return 'vatReveal-' + this._uid;
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VatButtons',
	  components: { ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to <strong>Remove</strong> the <strong>V' + this.item.id + ' vat?</strong>', function () {
	        _backoffice2.default.vats.select(_this.item.id).remove(function () {
	          _maggieHelper2.default.notification('', 'Vat deleted');
	          _this.$emit('itemUpdated');
	          _this.$store.dispatch('loadVat');
	        });
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VehicleAttributeButtons',
	  components: {},
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to <strong>Remove</strong> the <strong>VA' + this.item.id + ' attribute?</strong>', function () {
	        _backoffice2.default.vehicleAttributes.select(_this.item).remove(function () {
	          _maggieHelper2.default.notification('delete-esit', 'Attribute removed');
	          window.location.reload();
	        });
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleCostButtons",
	  components: {},
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', "Do you really want to <strong>Remove</strong> the <strong>VC" + this.item.id + " " + this.item.type.name + "</strong> cost?", function () {
	        _backoffice2.default.assetCosts.select(_this.item).remove(function () {
	          _maggieHelper2.default.notification('delete-esit', "Cost removed");
	        });
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ConfigurationItem = __webpack_require__(529);
	
	var _ConfigurationItem2 = _interopRequireDefault(_ConfigurationItem);
	
	var _ArrayEdit = __webpack_require__(88);
	
	var _ArrayEdit2 = _interopRequireDefault(_ArrayEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleHardwareActionButtons",
	  components: { ArrayEdit: _ArrayEdit2.default, ConfigurationItem: _ConfigurationItem2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	
	    return {
	      clipboard: null,
	      managers: null,
	      manager: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    var extra = this.item.extra.length === 0 || this.item.length !== undefined ? {} : this.item.extra;
	    this.item.extra = extra;
	    this.$set(this.item.extra, extra);
	    _backoffice2.default.vehicleHardware.list.managers(function (data) {
	      _this.managers = data;
	      switch (_this.item.manager) {
	        case _this.managers.manual:
	          _this.manager = 'manual';
	          break;
	        case _this.managers.convadis:
	          _this.manager = 'convadis';
	          break;
	
	      }
	    });
	  },
	
	  methods: {
	    exportConfiguration: function exportConfiguration() {
	
	      var testingCodeToCopy = document.querySelector('#clipboard');
	      testingCodeToCopy.setAttribute('type', 'text');
	      testingCodeToCopy.select();
	
	      try {
	        document.execCommand('copy');
	        _maggieHelper2.default.notification('Copied', 'Configuration copied successfully');
	      } catch (err) {
	        alert('Oops, unable to copy');
	      }
	
	      testingCodeToCopy.setAttribute('type', 'hidden');
	      window.getSelection().removeAllRanges();
	    },
	    remove: function remove() {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', "Do you really want to remove VH" + this.item.id, function () {
	        _backoffice2.default.vehicleHardware.select(_this2.item.id).remove(function (data) {
	          _maggieHelper2.default.notification('remove-esit', 'Vehicle hardware deleted');
	          _this2.$emit('update');
	        });
	      });
	    },
	    editHardware: function editHardware() {
	      var _this3 = this;
	
	      this.item.manager = this.managers[this.manager];
	
	      _backoffice2.default.vehicleHardware.select(this.item.id).edit(this.item, function () {
	        _maggieHelper2.default.notification('update-esit', 'Vehicle hardware updated');
	
	        _this3.$refs.modalUpdateHardware.close();
	        _this3.$emit('update');
	      });
	    },
	    importConfiguration: function importConfiguration() {
	      this.item.extra = JSON.parse(this.clipboard);
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleNoteButtons",
	  components: { ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.notes.select(this.item).remove(function () {
	        _this.$emit('itemUpdated');
	        _maggieHelper2.default.notification('delete-esit', "Note removed");
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _VehicleEdit = __webpack_require__(193);
	
	var _VehicleEdit2 = _interopRequireDefault(_VehicleEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleReplaceButtons",
	  components: { VehicleSmartEdit: _VehicleEdit2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {},
	  props: ['item']
	};

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _VehicleEdit = __webpack_require__(193);
	
	var _VehicleEdit2 = _interopRequireDefault(_VehicleEdit);
	
	var _AssetManagementActionButtons = __webpack_require__(209);
	
	var _AssetManagementActionButtons2 = _interopRequireDefault(_AssetManagementActionButtons);
	
	var _SwapAsset = __webpack_require__(217);
	
	var _SwapAsset2 = _interopRequireDefault(_SwapAsset);
	
	var _MoveAsset = __webpack_require__(216);
	
	var _MoveAsset2 = _interopRequireDefault(_MoveAsset);
	
	var _DismissAsset = __webpack_require__(215);
	
	var _DismissAsset2 = _interopRequireDefault(_DismissAsset);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ForceRebook = __webpack_require__(576);
	
	var _ForceRebook2 = _interopRequireDefault(_ForceRebook);
	
	var _VehicleSlotDisableReveal = __webpack_require__(578);
	
	var _VehicleSlotDisableReveal2 = _interopRequireDefault(_VehicleSlotDisableReveal);
	
	var _ToggleHiddenOnMap = __webpack_require__(2081);
	
	var _ToggleHiddenOnMap2 = _interopRequireDefault(_ToggleHiddenOnMap);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VehicleSlotButtons',
	  components: {
	    ActionButton: _ActionButton2.default,
	    ToggleHiddenOnMap: _ToggleHiddenOnMap2.default,
	    VehicleSlotDisableReveal: _VehicleSlotDisableReveal2.default,
	    ForceRebook: _ForceRebook2.default,
	    DatePicker: _DatePicker2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    ModalReveal: _ModalReveal2.default, DismissAsset: _DismissAsset2.default, MoveAsset: _MoveAsset2.default, SwapAsset: _SwapAsset2.default, AssetManagementActionButtons: _AssetManagementActionButtons2.default, VehicleSmartEdit: _VehicleEdit2.default
	  },
	  data: function data() {
	    return {
	      entity: null,
	      start: null,
	      end: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (!this.vehicle) {
	      _backoffice2.default.vehicles.select(this.$route.params.id).get(function (item) {
	        _this.entity = item;
	      });
	    } else {
	      this.entity = this.vehicle;
	    }
	  },
	
	  methods: {
	    closeDoors: function closeDoors() {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to close the doors?', function () {
	
	        _backoffice2.default.vehicles.select(_this2.entity.id, null).closeDoors(function () {
	          _this2.$emit('update');
	          _maggieHelper2.default.notification('Close Request', 'Door close signal has been sent');
	        });
	      });
	    },
	    openDoors: function openDoors() {
	      var _this3 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to open the doors?', function () {
	
	        _backoffice2.default.vehicles.select(_this3.entity.id, null).openDoors(function () {
	          _this3.$emit('update');
	          _maggieHelper2.default.notification('Close Request', 'Door open signal has been sent');
	        });
	      });
	    },
	    edit: function edit() {
	      _maggieHelper2.default.openRightPanel({
	        component: _VehicleEdit2.default, props: {
	          item: this.entity
	        }
	      });
	    },
	    activateImmo: function activateImmo() {
	      return _backoffice2.default.vehicle.select(this.entity).activateImmo(function () {
	        _maggieHelper2.default.notification('Activate immobilizer', 'request sent');
	      });
	    },
	    requestData: function requestData() {
	      _backoffice2.default.vehicles.select(this.entity.id, null).getData(function (response) {
	        _maggieHelper2.default.notification('data-request-esit', response);
	      });
	    },
	
	    enable: function enable() {
	      _backoffice2.default.vehicleSlots.select(this.entity.slot_id).enable(function (response) {
	        _maggieHelper2.default.notification('enable-esit', 'vehicle slot enabled');
	      });
	    },
	    dismiss: function dismiss() {
	      var _this4 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to dismiss the vehicle slot<br>' + this.entity.slot_name + ' (VS-' + this.entity.slot_id + ')?', function () {
	        _backoffice2.default.vehicleSlots.select(_this4.entity.slot_id).dismiss(function (data) {
	          _this4.$emit('vehicleSlotDismissed', _this4.vehicleSlot);
	          _maggieHelper2.default.notification('dismiss-esit', 'Vehicle slot dismissed');
	        });
	      });
	    },
	    archive: function archive() {
	      var _this5 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want archive this vehicle?', function () {
	        _backoffice2.default.vehicles.list().archive(_this5.entity.id, function (data) {
	          _maggieHelper2.default.notification('Archive Request', 'Vehicle archived');
	        });
	      });
	    },
	    assetMoved: function assetMoved(item) {
	      this.$emit('assetMoved', item);
	    },
	    processSwap: function processSwap(id) {
	      var _this6 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to swap VS-' + this.vehicleSlot.id + ' with VS-' + id + '?', function () {
	
	        _backoffice2.default.vehicleSlots.swap({
	          first_vehicle_slot_id: _this6.vehicleSlot.id,
	          second_vehicle_slot_id: id
	        }, function (data) {
	          _maggieHelper2.default.notification('swap-esit', data.result);
	        });
	      });
	    }
	  },
	  props: ['vehicle', 'item'],
	  computed: {
	    vehicleSlot: function vehicleSlot() {
	      return { id: this.entity.slot_id, name: this.entity.slot_name };
	    }
	  }
	};

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CommonCostButtonModal = __webpack_require__(144);
	
	var _CommonCostButtonModal2 = _interopRequireDefault(_CommonCostButtonModal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ZoneConfigButtons',
	  components: { ActionButton: _ActionButton2.default, CommonCostButtonModal: _CommonCostButtonModal2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entity: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      return _backoffice2.default.zoneConfigurations.select(this.item).delete(function () {
	        _maggieHelper2.default.notification('delete-esit', 'Zone cost deleted');
	        _this.$emit('itemUpdated');
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _SelectizeVehicleSlot = __webpack_require__(151);
	
	var _SelectizeVehicleSlot2 = _interopRequireDefault(_SelectizeVehicleSlot);
	
	var _SelectizeAvailableVehicleSlot = __webpack_require__(2094);
	
	var _SelectizeAvailableVehicleSlot2 = _interopRequireDefault(_SelectizeAvailableVehicleSlot);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AddVehicleAsset',
	  components: { BookingModeSelect: _BookingModeSelect2.default, SelectizeAvailableVehicleSlot: _SelectizeAvailableVehicleSlot2.default, SelectizeVehicleSlot: _SelectizeVehicleSlot2.default, SelectizeVehicle: _SelectizeVehicle2.default, ModalReveal: _ModalReveal2.default },
	  props: ['item'],
	  data: function data() {
	    return {
	      itemSelected: null,
	      bookingMode: 'RT',
	      addEnabled: false
	    };
	  },
	
	  methods: {
	    selected: function selected(item) {
	      this.itemSelected = item;
	    },
	    add: function add() {
	      var _this = this;
	
	      var body = {
	        'vehicle_id': this.itemSelected.id,
	        'booking_mode': this.bookingMode,
	        'parking_slot_id': this.item.id,
	        'name': this.item.name + '-' + this.itemSelected.model + ' ' + this.itemSelected.plate
	      };
	      _backoffice2.default.vehicleSlots.make(body, function (data) {
	        _maggieHelper2.default.notification('add-esit', 'Vehicle Added');
	        _this.$emit('addVehicleAsset');
	        _this.addEnabled = false;
	      });
	    }
	  }
	};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _SelectizeGroupedParkingAssets = __webpack_require__(91);
	
	var _SelectizeGroupedParkingAssets2 = _interopRequireDefault(_SelectizeGroupedParkingAssets);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ArchiveVehicleSlots',
	  components: { BookingModeSelect: _BookingModeSelect2.default, SelectizeGroupedParkingAssets: _SelectizeGroupedParkingAssets2.default, ModalReveal: _ModalReveal2.default },
	  created: function created() {},
	  data: function data() {
	    return {
	      parkingSlot: null
	
	    };
	  },
	
	  methods: {
	    archive: function archive() {
	      this.$emit('slotForArchiveSelected', this.parkingSlot);
	    },
	    setParkingSlot: function setParkingSlot(val) {
	      this.parkingSlot = val;
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SelectizeGroupedParkingAssets = __webpack_require__(91);
	
	var _SelectizeGroupedParkingAssets2 = _interopRequireDefault(_SelectizeGroupedParkingAssets);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreateVehicleSlot",
	  components: { BookingModeSelect: _BookingModeSelect2.default, SelectizeGroupedParkingAssets: _SelectizeGroupedParkingAssets2.default, ModalReveal: _ModalReveal2.default },
	  created: function created() {
	    this.body.vehicle_id = this.item.id;
	  },
	  data: function data() {
	    return {
	      parkinSlot: null,
	      body: {
	        name: this.item.brand + " " + this.item.model + " " + this.item.plate,
	        parking_slot_id: null,
	        booking_mode: 'RT',
	        vehicle_id: null
	      }
	    };
	  },
	
	  methods: {
	    createVehicleSlot: function createVehicleSlot() {
	      var _this = this;
	
	      this.body.name = this.parkingSlot.name + "-" + this.item.model + " " + this.item.plate;
	      _backoffice2.default.vehicleSlots.make(this.body, function (data) {
	        _this.$refs.createVehicleSlotModal.close();
	        _maggieHelper2.default.notification('slot-create', 'Vehicle slot created sucessfully');
	        _this.$emit('update');
	      });
	    },
	    setParkingSlot: function setParkingSlot(val) {
	      this.body.parking_slot_id = val.id;
	      this.parkingSlot = val;
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DeleteParkingGroup',
	  components: { BookingModeSelect: _BookingModeSelect2.default, ModalReveal: _ModalReveal2.default },
	  props: ['item'],
	  methods: {
	    remove: function remove() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'All connected parking lots, parking slots and vehicle slots will be deleted', function () {
	        _backoffice2.default.parkingGroups.select(_this.item.id).remove(function (data) {
	          _maggieHelper2.default.notification('deleted', 'Parking group deleted');
	          location.reload();
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DismissAsset",
	  components: { ModalReveal: _ModalReveal2.default },
	
	  methods: {
	    dismiss: function dismiss() {}
	  }
	};

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "EditParkingGroup",
	  components: { BookingModeSelect: _BookingModeSelect2.default, ModalReveal: _ModalReveal2.default },
	  props: ['item'],
	  data: function data() {
	    return {
	      vat_id: null
	    };
	  },
	  created: function created() {
	    if (this.item.vat) {
	      this.vat_id = this.item.vat.id;
	    }
	  },
	
	  methods: {
	    edit: function edit() {
	
	      var modal = this.$refs.modalEditPG;
	      this.item.vat_id = this.vat_id;
	
	      _backoffice2.default.parkingGroups.select(this.item.id).edit(this.item, function (data) {
	        modal.close();
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    vats: function vats(state) {
	      return state.configuration.vats;
	    }
	  }))
	};

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditVehicleCategory',
	  components: { KeplerFileUpload: _KeplerFileUpload2.default, Dropzone: _Dropzone2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      dropzoneUrl: _backoffice2.default.getUrlForDropzone(),
	      vehicleTypes: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicleTypes.list.all(function (data) {
	      _this.vehicleTypes = data;
	    });
	  },
	
	  methods: {
	    editVehicleCategory: function editVehicleCategory() {
	      var _this2 = this;
	
	      this.item.vehicle_type_id = this.item.vehicle_type.id;
	      _backoffice2.default.vehicleCategories.select(this.item.id).edit(this.item, function () {
	        _maggieHelper2.default.notification('Edit', 'Vehicle category updated');
	        _this2.$refs.modalEditVehicleCategory.close();
	      });
	    },
	    handleFileSelector: function handleFileSelector(path) {
	      this.item.picture = path;
	    },
	    handleFileDamageSelector: function handleFileDamageSelector(path) {
	      this.item.damage_picture = path;
	    }
	  },
	
	  props: ['item']
	};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SelectizeGroupedParkingAssets = __webpack_require__(91);
	
	var _SelectizeGroupedParkingAssets2 = _interopRequireDefault(_SelectizeGroupedParkingAssets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'MoveAsset',
	  components: { SelectizeGroupedParkingAssets: _SelectizeGroupedParkingAssets2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      parking_slot_id: null,
	      moveEnabled: false
	    };
	  },
	
	  methods: {
	    parkingSlotSelected: function parkingSlotSelected(val) {
	      this.parking_slot_id = val.id;
	    },
	    move: function move() {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to move ' + this.item.name + ' (VS-' + this.item.id + ')?', function () {
	
	        var body = { parking_slot_id: _this.parking_slot_id };
	        _backoffice2.default.vehicleSlots.select(_this.item.id).move(body, function (data) {
	          _this.$emit('assetMoved', _this.item);
	          _this.moveEnabled = false;
	          _maggieHelper2.default.notification('move-esit', 'Vehicle slot moved sucessfully');
	        });
	      });
	    }
	  },
	  created: function created() {},
	
	  props: ['item']
	
	};

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _SelectizeVehicleSlot = __webpack_require__(151);
	
	var _SelectizeVehicleSlot2 = _interopRequireDefault(_SelectizeVehicleSlot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SwapAsset',
	  components: { SelectizeVehicleSlot: _SelectizeVehicleSlot2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      swapEnabled: false
	    };
	  },
	  props: ['item', 'itemList'],
	  methods: {
	    selected: function selected(item) {
	      this.itemSelected = item.id;
	    },
	    processSwap: function processSwap() {
	      this.$emit('processSwap', this.itemSelected);
	      this.swapEnabled = false;
	    }
	  }
	
	};

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ArrayEdit = __webpack_require__(88);
	
	var _ArrayEdit2 = _interopRequireDefault(_ArrayEdit);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AddDriverFlagReveal',
	  components: { ArrayEdit: _ArrayEdit2.default, BaseList: _BaseList2.default, Transaction: _Transaction2.default, ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      body: {
	        flags: {}
	      },
	      extras: [{
	        "Verification": [{
	          "kyc_requested": "Kyc verification"
	        }]
	      }]
	    };
	  },
	
	  methods: {
	    add: function add() {
	      return _backoffice2.default.drivers.select(this.item).setFlags(this.body, function () {
	        _maggieHelper2.default.notification("flag", "Flag set");
	        _eventBus.EventBus.$emit('close-modal');
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ApplyRegistrationTokenReveal',
	  components: { BaseList: _BaseList2.default, Transaction: _Transaction2.default, ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      registrationTokens: [],
	      body: {
	        registrationToken: null
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.registrationTokens.list(1, -1).all(function (data) {
	      _this.registrationTokens = data.items;
	    });
	  },
	
	
	  methods: {
	    add: function add() {
	      return _backoffice2.default.registrationTokens.select(this.selected.id).apply(this.item.id, function () {
	        _maggieHelper2.default.notification('Token', 'Token applied');
	      });
	    }
	  },
	  computed: {
	    selected: function selected() {
	      var _this2 = this;
	
	      var id = this.registrationTokens.findIndex(function (i) {
	        return i.id === _this2.body.registrationToken;
	      });
	      return id !== -1 ? this.registrationTokens[id] : null;
	    },
	    componentId: function componentId() {
	      return 'reveal-' + this.item.id;
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ConvertProformaToCreditNote',
	  components: { ModalReveal: _ModalReveal2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      refund_on_gateway: false,
	      openReveal: false
	    };
	  },
	
	  methods: {
	    closeReveal: function closeReveal() {
	      this.openReveal = false;
	    },
	    open: function open() {
	      this.openReveal = true;
	    },
	    convertToCreditNote: function convertToCreditNote() {
	      var _this = this;
	
	      return _backoffice2.default.invoices.select(this.invoice).convertToCreditNote({
	        refund_on_gateway: this.refund_on_gateway
	      }, function (data) {
	        _this.openReveal = false;
	
	        _this.$router.go();
	        _maggieHelper2.default.notification('Completed', 'Credit note issued');
	      });
	    }
	  },
	  props: ['invoice']
	};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _PacketForm = __webpack_require__(202);
	
	var _PacketForm2 = _interopRequireDefault(_PacketForm);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreatePacketReveal",
	  components: {
	    PacketForm: _PacketForm2.default,
	    Editor: _Editor2.default,
	    ModalReveal: _ModalReveal2.default,
	    ActionButton: _ActionButton2.default
	  },
	  data: function data() {
	    return {
	      body: {
	        name: null,
	        description: "",
	        amount: null,
	        minutes: null,
	        distance: null,
	        duration: null,
	        max_uses: null,
	        status: null
	      }
	    };
	  },
	  created: function created() {},
	
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.packets.make(this.body, function (data) {
	        _maggieHelper2.default.notification('New packet added ', 'id: ' + data.id);
	        _eventBus.EventBus.$emit('reload-list');
	        _this.$refs.packetModal.close();
	      });
	    }
	  },
	  props: ['packet']
	};

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreditRecordUsageReveal',
	  components: { Cards: _Cards2.default, BaseList: _BaseList2.default, Transaction: _Transaction2.default, ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(187),
	      items: [],
	      loaded: false
	    };
	  },
	  created: function created() {},
	
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      var _this = this;
	
	      _backoffice2.default.credits.usages(this.item.id, page, resultsPerPage, function (data) {
	        _this.items = data.items;
	        _this.loaded = true;
	        callback(data);
	      });
	    }
	  },
	  computed: {
	    creditData: function creditData() {
	      var left = '--';
	
	      if (this.loaded) {
	        left = 0;
	        this.items.forEach(function (item) {
	          left += item.amount;
	        });
	        left = this.$priceWithcurrency(this.item.amount + left);
	      }
	
	      return [{
	        title: 'Amount',
	        value: this.$priceWithcurrency(this.item.amount)
	      }, {
	        title: 'Amount Left',
	        value: left
	      }];
	    }
	  },
	
	  props: ['buttons', 'item']
	};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _PacketForm = __webpack_require__(202);
	
	var _PacketForm2 = _interopRequireDefault(_PacketForm);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "EditPacketReveal",
	  components: {
	    PacketForm: _PacketForm2.default,
	    Editor: _Editor2.default,
	    ModalReveal: _ModalReveal2.default,
	    ActionButton: _ActionButton2.default
	  },
	  data: function data() {
	    return {
	      body: (0, _extends3.default)({}, this.item)
	    };
	  },
	  created: function created() {},
	
	
	  methods: {
	    edit: function edit() {
	      var _this = this;
	
	      return _backoffice2.default.packets.select(this.body).edit(this.body, function (data) {
	        _maggieHelper2.default.notification('Updated packet ', 'id:' + data.id);
	        _eventBus.EventBus.$emit('reload-list');
	        _this.$refs.editPacketModal.close();
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ForceRebook',
	  components: { ActionButton: _ActionButton2.default, DatePicker: _DatePicker2.default, SelectizeDriver: _SelectizeDriver2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      body: {
	        driver_id: null,
	        start: null,
	        end: null,
	        memo: null
	
	      }
	    };
	  },
	
	  methods: {
	    setDriver: function setDriver(obj) {
	      this.body.driver_id = obj.id;
	    },
	    forceRebook: function forceRebook() {
	      var body = this.body;
	      body.start = this.$date(this.body.start).unix();
	      body.end = this.$date(this.body.end).unix();
	      return _backoffice2.default.vehicles.select(this.vehicle).forceRebook(body, function () {
	        _maggieHelper2.default.notification('rebook', 'Booking created');
	      });
	    }
	  },
	  props: ['vehicle']
	};

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Reveal = __webpack_require__(122);
	
	var _Reveal2 = _interopRequireDefault(_Reveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "InvoiceRevealMarkAsPaid",
	    components: { Reveal: _Reveal2.default },
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        setPaid: function setPaid() {
	            this.$emit('setPaid');
	        }
	    },
	    computed: {},
	    props: ['buttons', 'invoice']
	};

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Reveal = __webpack_require__(122);
	
	var _Reveal2 = _interopRequireDefault(_Reveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "InvoiceRevealPay",
	    components: { Reveal: _Reveal2.default },
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        payInvoice: function payInvoice() {
	            this.$emit('payInvoice');
	        }
	    },
	    computed: {},
	    props: ['buttons', 'invoice']
	};

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _BilledRecords = __webpack_require__(528);
	
	var _BilledRecords2 = _interopRequireDefault(_BilledRecords);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvoiceRecords',
	  components: { BilledRecords: _BilledRecords2.default, BaseList: _BaseList2.default, Transaction: _Transaction2.default, ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(85)
	    };
	  },
	  created: function created() {},
	
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      callback(this.records);
	    }
	  },
	  computed: {
	    records: function records() {
	      return {
	        current_page: 1,
	        per_page_count: 10000,
	        current_page_count: 1,
	        items: this.invoice.records,
	        items_count: this.invoice.records.length,
	        page_count: 1
	      };
	    }
	  },
	  props: ['buttons', 'invoice']
	};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvoiceTransactions',
	  components: { BaseList: _BaseList2.default, Transaction: _Transaction2.default, ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(40)
	    };
	  },
	  created: function created() {},
	
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      callback(this.transactions);
	    }
	  },
	  computed: {
	    transactions: function transactions() {
	      return {
	        current_page: 1,
	        per_page_count: 10000,
	        current_page_count: 1,
	        items: this.invoice.transactions,
	        items_count: this.invoice.transactions.length,
	        page_count: 1
	      };
	    }
	  },
	  props: ['buttons', 'invoice']
	};

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _VatAmountToggler = __webpack_require__(116);
	
	var _VatAmountToggler2 = _interopRequireDefault(_VatAmountToggler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvoiceRevealVoid',
	  components: { VatAmountToggler: _VatAmountToggler2.default, ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      records: [],
	      voidFields: {
	        records: [],
	        amount: 0,
	        reason: '',
	        refundOnGateway: false
	      }
	    };
	  },
	  created: function created() {
	    var obj = {};
	    (0, _collect2.default)(this.invoice.records).each(function (item) {
	      obj[item.id] = false;
	    });
	
	    this.voidFields.records = obj;
	  },
	
	  methods: {
	    checkValue: function checkValue(record) {
	      var total = Math.abs(record.amount + record.amount * -record.tax);
	
	      if (parseFloat(this.voidFields.records[record.id]) > total) {
	        this.voidFields.records[record.id] = total.toFixed(2);
	      }
	
	      if (parseFloat(this.voidFields.records[record.id]) < 0) {
	        this.voidFields.records[record.id] = Math.abs(this.voidFields.records[record.id]);
	      }
	
	      if (isNaN(parseFloat(this.voidFields.records[record.id]))) {
	        this.voidFields.records[record.id] = true;
	      }
	    },
	    voidInvoice: function voidInvoice() {
	      var _this = this;
	
	      this.voidFields.amount = this.fullRefund ? null : this.recordsAmount;
	      return _backoffice2.default.invoices.select(this.invoice).voidInvoice(this.voidFields, function (data) {
	        _maggieHelper2.default.notification('void-esit', 'Invoice has been voided');
	        _this.$refs[_this.componentId].close();
	      });
	    },
	
	    isNumber: function isNumber(evt) {
	      var charCode = evt.which ? evt.which : evt.keyCode;
	      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
	        evt.preventDefault();
	      } else {
	        return true;
	      }
	    }
	  },
	  computed: {
	    recordsAmount: function recordsAmount() {
	      var _this2 = this;
	
	      var records = 0;
	      (0, _collect2.default)(this.voidFields.records).each(function (item, id) {
	        var amount = item === false || item === true ? 0 : parseFloat(item);
	        if (item === false) {
	          amount = 0;
	        } else if (item === true) {
	
	          var record = _this2.invoice.records.find(function (item) {
	            return item.id === Number(id);
	          });
	          amount += Number(Math.abs(record.amount + record.amount * -record.tax).toFixed(2));
	        }
	        records += amount;
	      });
	
	      if (records > this.invoice.total) {
	        records = this.invoice.total;
	      }
	      return records.toFixed(2);
	    },
	    componentId: function componentId() {
	      return 'voidReveal-' + this.invoice.internal_id;
	    }
	  },
	  props: ['buttons', 'invoice']
	};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PacketRecordUsageReveal',
	  components: { Cards: _Cards2.default, BaseList: _BaseList2.default, Transaction: _Transaction2.default, ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(536),
	      items: [],
	      loaded: false
	    };
	  },
	  created: function created() {},
	
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      var _this = this;
	
	      _backoffice2.default.packetRecords.list.usages(this.item.id, page, resultsPerPage, function (data) {
	        _this.items = data.items;
	        _this.loaded = true;
	        callback(data);
	      }, function (e) {
	        return alert(e);
	      });
	    }
	  },
	  computed: {
	    packetData: function packetData() {
	      return [{
	        title: 'Minutes',
	        value: this.item.minutes
	      }, {
	        title: 'Remaining minutes',
	        value: this.item.remaining_minutes
	      }, {
	        title: 'Distance',
	        value: this.item.distance
	      }, {
	        title: 'Remaining distance',
	        value: this.item.remaining_distance
	      }];
	    }
	  },
	
	  props: ['buttons', 'item']
	};

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _SelectizePacket = __webpack_require__(2098);
	
	var _SelectizePacket2 = _interopRequireDefault(_SelectizePacket);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _InlineEditableField = __webpack_require__(205);
	
	var _InlineEditableField2 = _interopRequireDefault(_InlineEditableField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PacketVehicleCategoryModal",
	  components: { InlineEditableField: _InlineEditableField2.default, SelectizePacket: _SelectizePacket2.default, SelectizeCategory: _SelectizeCategory2.default, ModalReveal: _ModalReveal2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      body: {
	        vehicle_category_id: null,
	        packet_id: null
	      },
	      key: 0,
	      selectedCategory: null,
	      selectedPacket: null
	    };
	  },
	  created: function created() {
	    if (this.packetCategory) {
	      (0, _assign2.default)(this.body, this.packetCategory);
	      this.selectedCategory = this.packetCategory.category.id;
	      this.selectedPacket = this.packetCategory.packet.id;
	      this.body.packet_id = this.selectedPacket;
	    }
	  },
	
	  methods: {
	    closeInput: function closeInput(event) {
	      if (!event) {
	        this.key++;
	      }
	    },
	    selectCategory: function selectCategory(item) {
	      this.body.vehicle_category_id = item.id;
	    },
	    selectPacket: function selectPacket(item) {
	      this.body.packet_id = item.id;
	    },
	    save: function save() {
	      var _this = this;
	
	      if (this.packetCategory) {
	        return this.edit();
	      }
	      return _backoffice2.default.packetVehicleCategories.make(this.body, function (data) {
	        if (data && typeof data.id === "number") {
	          _maggieHelper2.default.notification('Packet vehicle category added', 'id: ' + data.id);
	          _this.$emit('itemUpdated', 'added');
	        } else {
	          _maggieHelper2.default.notification('esit: ', data.result_code);
	        }
	        _this.body = {
	          vehicle_category_id: null,
	          packet_id: null
	        };
	
	        _this.$refs.packetCategoryModal.close();
	      });
	    },
	    edit: function edit() {
	      var _this2 = this;
	
	      return _backoffice2.default.packetVehicleCategories.select(this.body).edit(this.body, function (data) {
	        if (data && typeof data.id === "number") {
	          _maggieHelper2.default.notification('Updated packet vehicle category ', 'id:' + data.id);
	          _this2.$emit('itemUpdated', 'added');
	        } else {
	          _maggieHelper2.default.notification('esit: ', data.result_code);
	        }
	
	        _this2.key++;
	        _this2.$refs.packetCategoryModal.close();
	      });
	    }
	  },
	  props: ['packetCategory']
	};

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(242);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _VatAmountToggler = __webpack_require__(116);
	
	var _VatAmountToggler2 = _interopRequireDefault(_VatAmountToggler);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RefundableRecords',
	  components: { BaseList: _BaseList2.default, VatAmountToggler: _VatAmountToggler2.default, ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(85),
	      refundable: {},
	      search: { wallet_record_id: null, invoice_id: null }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    convertArrayToObject: function convertArrayToObject(array, key) {
	      var initialValue = {};
	      return array.reduce(function (obj, item) {
	        return (0, _extends4.default)({}, obj, (0, _defineProperty3.default)({}, item[key], item));
	      }, initialValue);
	    },
	    close: function close() {
	      this.$emit('select', this.selected);
	      this.$refs[this.componentId].close();
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return 'refundableRecords-' + this._uid;
	    }
	  },
	  props: ['dataLoader', 'selected']
	};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _vuex = __webpack_require__(10);
	
	var _MdiIcon = __webpack_require__(80);
	
	var _MdiIcon2 = _interopRequireDefault(_MdiIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TocAttachmentTranslationReveal',
	  components: { MdiIcon: _MdiIcon2.default, KeplerFileUpload: _KeplerFileUpload2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      translation: {},
	      selectedLanguage: null,
	      show: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.allowedLanguages.forEach(function (lang) {
	      if (lang in _this.value) {
	        _this.translation[lang] = _this.value[lang];
	      } else {
	        _this.translation[lang] = null;
	      }
	    });
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({
	    allowedLanguages: function allowedLanguages() {
	      var systemFields = (0, _collect2.default)(this.configuration.system.system_fields_configuration.value);
	      var defaultLang = this.configuration.application.application_default_language.value;
	      var config = systemFields.first(function (i) {
	        return i.field === 'allowedLanguages';
	      });
	      if (config.config === null) {
	        return [];
	      }
	      return (0, _collect2.default)(this.configuration.system.system_fields_configuration.value).first(function (i) {
	        return i.field === 'allowedLanguages';
	      }).config.split(',').filter(function (lang) {
	        return lang !== defaultLang;
	      });
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: ['value']
	};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _eventBus = __webpack_require__(15);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ToggleHiddenOnMap',
	  components: { Vehicle: _Vehicle2.default, ActionButton: _ActionButton2.default, DatePicker: _DatePicker2.default, SelectizeDriver: _SelectizeDriver2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      body: {
	        hidden: this.vehicle.vehicle_slot_hidden
	      }
	    };
	  },
	
	  methods: {
	    setDriver: function setDriver(obj) {
	      this.body.driver_id = obj.id;
	    },
	    toggleHidden: function toggleHidden() {
	      return _backoffice2.default.vehicles.select(this.vehicle.slot_id).toggleHidden({
	        hidden: this.body.hidden
	      }, function () {
	        _maggieHelper2.default.notification('Vehicle', 'Vehicle visibility  updated');
	        _eventBus.EventBus.$emit('reload-list');
	        _eventBus.EventBus.$emit('close-modal');
	      });
	    }
	  },
	  props: ['vehicle']
	};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Reveal = __webpack_require__(122);
	
	var _Reveal2 = _interopRequireDefault(_Reveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "TransactionRevealRefund",
	    components: { Reveal: _Reveal2.default },
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        refundTransaction: function refundTransaction() {
	            this.$emit('refundTransaction');
	        }
	    },
	    computed: {},
	    props: ['buttons', 'transaction', 'refundFields']
	};

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ArrayEdit = __webpack_require__(88);
	
	var _ArrayEdit2 = _interopRequireDefault(_ArrayEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleHardwareRevealCreate",
	  components: { ArrayEdit: _ArrayEdit2.default, ModalReveal: _ModalReveal2.default },
	  methods: {
	    addHardware: function addHardware() {
	      var _this = this;
	
	      this.body.manager = this.managers[this.manager];
	
	      _backoffice2.default.vehicleHardware.make(this.body, function (data) {
	        _this.$refs.modalAddVehicleHardware.close();
	        _maggieHelper2.default.notification('create-esit', 'Vehicle hardware created successfully');
	        _this.$emit('update');
	      });
	    }
	  },
	  data: function data() {
	    return {
	      managers: null,
	      manager: null,
	
	      body: {
	        vehicle_id: this.item.id,
	        serial: null,
	        manager: null,
	        extra: {}
	      }
	    };
	  },
	  created: function created() {
	    var _this2 = this;
	
	    _backoffice2.default.vehicleHardware.list.managers(function (data) {
	      _this2.managers = data;
	    });
	  },
	
	  props: ['item']
	};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VehicleSlotDisableReveal',
	  components: { ActionButton: _ActionButton2.default, InputSwitch: _InputSwitch2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      body: { reason: null },
	      noreason: false
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    disable: function disable() {
	      var _this = this;
	
	      return _backoffice2.default.vehicleSlots.select(this.item.slot_id).disable(this.body, function (response) {
	        _maggieHelper2.default.notification('disable-esit', 'vehicle slot disabled');
	        _this.$refs[_this.componentId].close();
	      });
	    },
	    toggleReason: function toggleReason() {
	      this.body.reason = this.noreason ? '<>' : null;
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return 'vehicle-slot-disable-' + this.item.id;
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Status = __webpack_require__(69);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverFields",
	  components: { Status: _Status2.default },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: (0, _extends3.default)({
	    type: function type() {
	      return this.fieldName;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: {
	    item: Object,
	    fieldName: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Transaction: _Transaction2.default },
	  name: "InvoiceFields",
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  }),
	  props: {
	    item: Object,
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "PaymentMethodFields",
	    components: {},
	    data: function data() {
	        return {};
	    },
	    created: function created() {},
	
	    methods: {
	        viewPMOnGateway: function viewPMOnGateway() {
	            var url = GatewayUrlHelper.paymentMethod(this.item.provider, this.item.data.braintree_card_token);
	            window.open(url, '_blank');
	        },
	        viewClientOnGateway: function viewClientOnGateway() {
	            var url = GatewayUrlHelper.clientUrl(this.item.provider, this.item.data.braintree_client_id);
	            window.open(url, '_blank');
	        }
	    },
	    computed: {
	        type: function type() {
	            return this.fieldName;
	        }
	    },
	    props: {
	        item: Object,
	        fieldName: {
	            type: String,
	            default: ''
	        }
	    }
	};

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Status = __webpack_require__(69);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ReportingFields",
	  components: {
	    Vehicle: _Vehicle2.default,
	    Driver: _Driver2.default,
	    Status: _Status2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: (0, _extends3.default)({
	    type: function type() {
	      return this.fieldName;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: {
	    item: Object,
	    fieldName: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Status = __webpack_require__(69);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _VehicleFields = __webpack_require__(220);
	
	var _VehicleFields2 = _interopRequireDefault(_VehicleFields);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ReservationFields",
	  components: {
	    VehicleFields: _VehicleFields2.default,
	    Status: _Status2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: (0, _extends3.default)({
	    type: function type() {
	      return this.fieldName;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  }),
	  props: {
	    item: Object,
	    fieldName: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SubscriptionFields",
	  components: {},
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: (0, _extends3.default)({
	    type: function type() {
	      return this.fieldName;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  }),
	  props: {
	    item: Object,
	    fieldName: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TransactionFields",
	  components: {},
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: (0, _extends3.default)({
	    type: function type() {
	      return this.fieldName;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  }),
	  props: {
	    item: Object,
	    fieldName: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Status = __webpack_require__(69);
	
	var _Status2 = _interopRequireDefault(_Status);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _VehicleStatus = __webpack_require__(208);
	
	var _VehicleStatus2 = _interopRequireDefault(_VehicleStatus);
	
	var _VehicleAdditionalStatus = __webpack_require__(207);
	
	var _VehicleAdditionalStatus2 = _interopRequireDefault(_VehicleAdditionalStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VehicleFields',
	  components: {
	    VehicleStatus: _VehicleStatus2.default,
	    Vehicle: _Vehicle2.default,
	    Driver: _Driver2.default,
	    Status: _Status2.default,
	    VehicleAdditionalStatus: _VehicleAdditionalStatus2.default
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {
	    type: function type() {
	      return this.fieldName;
	    },
	
	    pointStatusColor: function pointStatusColor() {
	      return {
	        'orange-status': this.item.has_reservation === 'normal',
	        'yellow-status': this.item.has_reservation === 'maintenance',
	        'red-status': !!this.item.slot_disabled,
	        'green-status': !this.item.slot_disabled
	      };
	    }
	  },
	  props: {
	    item: Object,
	    fieldName: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'WalletRecordFields',
	  components: {},
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	
	  methods: {
	    viewPMOnGateway: function viewPMOnGateway() {
	      var url = GatewayUrlHelper.paymentMethod(this.item.provider, this.item.data.braintree_card_token);
	      window.open(url, '_blank');
	    },
	    viewClientOnGateway: function viewClientOnGateway() {
	      var url = GatewayUrlHelper.clientUrl(this.item.provider, this.item.data.braintree_client_id);
	      window.open(url, '_blank');
	    }
	  },
	  computed: (0, _extends3.default)({
	    type: function type() {
	      return this.fieldName;
	    },
	    walletableType: function walletableType() {
	      return this.item.walletable_type.replace(/App\\Models\\/, '');
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  }),
	  props: {
	    item: Object,
	    fieldName: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AlarmListForm',
	  components: {
	    SelectizeVehicle: _SelectizeVehicle2.default
	  },
	  data: function data() {
	    return {
	      vehicles: [],
	      search: {
	        code: null,
	        vehicle_id: null,
	        source: null
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    setVehicleId: function setVehicleId(vehicle) {
	
	      this.search.vehicle_id = vehicle.id;
	    },
	    filterAlarms: function filterAlarms() {
	
	      this.$emit('filterAlarms', this.search);
	    },
	    unsetVehicleId: function unsetVehicleId() {
	      this.search.vehicle_id = null;
	    }
	  },
	  computed: {},
	  props: ['type']
	};

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "InvoiceListForm",
	  components: {
	    SelectizeDriver: _SelectizeDriver2.default,
	    KeplerBackofficeSdk: _backoffice2.default,
	    DatePicker: _DatePicker2.default
	  },
	  data: function data() {
	    return {
	      drivers: [],
	      search: {
	        "driver_id": null,
	        "chip_id": null
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    setDriverId: function setDriverId(driver) {
	      this.search.driver_id = driver.id;
	    },
	    filterCards: function filterCards() {
	      this.$emit('filterCards', this.search);
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _InputForm = __webpack_require__(123);
	
	var _InputForm2 = _interopRequireDefault(_InputForm);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SelectizeClientType = __webpack_require__(90);
	
	var _SelectizeClientType2 = _interopRequireDefault(_SelectizeClientType);
	
	var _RangePicker = __webpack_require__(200);
	
	var _RangePicker2 = _interopRequireDefault(_RangePicker);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientListForm',
	  components: { SearchEntity: _SearchEntity2.default, RangePicker: _RangePicker2.default, SelectizeClientType: _SelectizeClientType2.default, DatePicker: _DatePicker2.default, InputForm: _InputForm2.default },
	  data: function data() {
	    return {
	      search: {
	        client_type: null,
	        query: null,
	        status: null
	      }
	    };
	  },
	
	  methods: {
	    selectClient: function selectClient(id) {
	      this.$router.push({ name: 'client', params: { id: id } });
	    },
	    setRange: function setRange(range) {
	      this.search.created_from = range.from;
	      this.search.created_to = range.to;
	    },
	    setSearch: function setSearch(obj) {
	      this.search = (0, _assign2.default)({}, obj);
	      this.$emit('setSearch', this.search);
	    },
	    setFilters: function setFilters() {
	      this.search.query = null;
	      this.$emit('setSearch', this.search);
	    },
	    setClientType: function setClientType(obj) {
	      this.search.client_type = obj.id;
	    }
	  }
	};

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _InputForm = __webpack_require__(123);
	
	var _InputForm2 = _interopRequireDefault(_InputForm);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverListForm',
	  components: { DateRangePicker: _DateRangePicker2.default, DatePicker: _DatePicker2.default, InputForm: _InputForm2.default },
	  data: function data() {
	    return {
	      advanced: false,
	      search: {
	        client_type: null,
	        created_from: null,
	        created_to: null,
	        query: null,
	        status: ['ACTIVE', 'SUSPENDED']
	      }
	    };
	  },
	  created: function created() {
	    this.setFilters();
	  },
	
	  methods: {
	    setSearch: function setSearch(obj) {
	      this.search = (0, _assign2.default)({}, obj);
	      this.$emit('setSearch', this.search);
	    },
	    setFilters: function setFilters() {
	      this.search.query = null;
	      this.search.balance = null;
	      this.$emit('setSearch', this.search);
	    },
	    dateRangeSelected: function dateRangeSelected(range) {
	      this.search.created_from = range.start + ' 00:00:00';
	      this.search.created_to = range.end + ' 23:59:59';
	    }
	  },
	  props: ['type']
	};

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "InputForm",
	  components: {},
	  data: function data() {
	    return {
	      data: {},
	      deboucedEmitter: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.deboucedEmitter = this.$debounce(function () {
	      _this.$emit('updatedData', _this.data);
	    }, 350);
	  },
	
	  methods: {
	    updatedData: function updatedData() {
	      for (var field in this.data) {
	        if (this.data[field] === null || this.data[field] === undefined || this.data[field] === "") {
	          delete this.data[field];
	        }
	      }
	
	      this.deboucedEmitter();
	    }
	  },
	  props: {
	    fields: {
	      type: Array,
	      required: true
	    },
	    placeholders: {
	      type: Array,
	      required: false
	    }
	  }
	};

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vuex = __webpack_require__(10);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SelectizeClient = __webpack_require__(89);
	
	var _SelectizeClient2 = _interopRequireDefault(_SelectizeClient);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _RangePicker = __webpack_require__(200);
	
	var _RangePicker2 = _interopRequireDefault(_RangePicker);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _IsModuleEnabled = __webpack_require__(199);
	
	var _IsModuleEnabled2 = _interopRequireDefault(_IsModuleEnabled);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvoiceListForm',
	  components: {
	    SearchEntity: _SearchEntity2.default,
	    DateRangePicker: _DateRangePicker2.default,
	    IsModuleEnabled: _IsModuleEnabled2.default,
	    ActionButton: _ActionButton2.default,
	    RangePicker: _RangePicker2.default,
	    InputSwitch: _InputSwitch2.default,
	    SelectizeClient: _SelectizeClient2.default,
	    KeplerBackofficeSdk: _backoffice2.default,
	    DatePicker: _DatePicker2.default
	  },
	  data: function data() {
	    return {
	      search: {
	        client_id: null,
	        from: null,
	        to: null,
	        status: null,
	        sectional: null,
	        type: null,
	        proforma: null,
	        sdi: null,
	        final_sectional: null
	      }
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    selectClient: function selectClient(client) {
	      this.search.client_id = client.id;
	    },
	    unsetClient: function unsetClient() {
	      this.search.client_id = null;
	    },
	    dateRangeSelected: function dateRangeSelected(range) {
	      this.search.from = range.start;
	      this.search.to = range.end;
	    },
	    filterProforma: function filterProforma(val) {
	      this.search.proforma = val;
	      this.filterInvoices();
	    },
	    filterInvoices: function filterInvoices() {
	      var search = {};
	      $.map(this.search, function (value, key) {
	        if (value !== null && value !== '') {
	          search[key] = value;
	        }
	      });
	
	      this.$emit('filterInvoices', search);
	    },
	    downloadZip: function downloadZip() {
	      var url = _backoffice2.default.invoices.archiveXml(this.search);
	      window.open(url, '_blank');
	    },
	    bulkOperations: function bulkOperations() {
	      this.$store.dispatch('setBulkFilters', (0, _assign2.default)({}, this.search));
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    sectionals: function sectionals() {
	      if (this.configuration.commercial == null) {
	        return [];
	      }
	
	      var numberFormat = this.configuration.commercial.commercial_invoice_number_format;
	      if (numberFormat == null) {
	        return [];
	      }
	      return this.configuration.commercial.commercial_invoice_number_format.value.map(function (item) {
	        return item.sectional;
	      });
	    }
	  }), props: {
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SearchInputForm = __webpack_require__(125);
	
	var _SearchInputForm2 = _interopRequireDefault(_SearchInputForm);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReportingListForm',
	  components: {
	    SearchEntity: _SearchEntity2.default,
	    SelectizeVehicle: _SelectizeVehicle2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    KeplerBackofficeSdk: _backoffice2.default,
	    DatePicker: _DatePicker2.default,
	    SearchInputForm: _SearchInputForm2.default
	  },
	  data: function data() {
	    return {
	      vehicles: [],
	      reportingTypes: [],
	      search: {
	        driver_id: null,
	        vehicle_id: null,
	        reporting_type_id: null,
	        status: null
	      }
	    };
	  },
	  created: function created() {
	    this.getReportingTypes();
	  },
	
	  methods: {
	    setDriverId: function setDriverId(driver) {
	      this.search.driver_id = driver.id;
	    },
	    setVehicleId: function setVehicleId(vehicle) {
	      this.search.vehicle_id = vehicle.id;
	    },
	    filterReportings: function filterReportings() {
	      this.$emit('filterReportings', this.search);
	    },
	    unsetDriverId: function unsetDriverId() {
	      this.search.driver_id = null;
	    },
	    unsetVehicleId: function unsetVehicleId() {
	      this.search.vehicle_id = null;
	    },
	    getReportingTypes: function getReportingTypes() {
	      var _this = this;
	
	      _backoffice2.default.reportings.list(1, -1).types(function (data) {
	        _this.reportingTypes = data;
	      });
	    }
	  },
	  computed: {},
	  props: ['type']
	};

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SearchInputForm = __webpack_require__(125);
	
	var _SearchInputForm2 = _interopRequireDefault(_SearchInputForm);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _InlineEditableField = __webpack_require__(205);
	
	var _InlineEditableField2 = _interopRequireDefault(_InlineEditableField);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationListForm',
	  components: {
	    InputSwitch: _InputSwitch2.default,
	    InlineEditableField: _InlineEditableField2.default,
	    BookingModeSelect: _BookingModeSelect2.default,
	    SelectizeVehicle: _SelectizeVehicle2.default,
	    KeplerBackofficeSdk: _backoffice2.default,
	    SearchInputForm: _SearchInputForm2.default,
	    DateRangePicker: _DateRangePicker2.default
	
	  },
	  data: function data() {
	    return {
	      vehicleCategories: [],
	      search: {
	        from: null,
	        to: null,
	        status: null,
	        billing_status: null,
	        query: null,
	        vehicle_slot_id: null,
	        vehicle_plate: null,
	        booking_mode: null,
	        flag: null,
	        order_by: null,
	        order_direction: 'DESC',
	        ending_date: false
	      }
	    };
	  },
	  created: function created() {
	    this.filterReservations();
	  },
	  mounted: function mounted() {
	    $(this.$el).foundation();
	  },
	
	  methods: {
	    filterReservations: function filterReservations() {
	      for (var propNamesKey in this.search) {
	        if (propNamesKey in this.search && !this.search[propNamesKey] && this.search[propNamesKey] !== 0) {
	          delete this.search[propNamesKey];
	        }
	      }
	      this.$emit('filterReservations', this.search);
	    },
	    toggleDirection: function toggleDirection() {
	      this.search.order_direction = this.search.order_direction === 'ASC' ? 'DESC' : 'ASC';
	    },
	    searchFromInput: function searchFromInput(search) {
	      this.$emit('searchReservations', search);
	    },
	    vehicleSelected: function vehicleSelected(data) {
	      this.search.vehicle_slot_id = data.vehicle_slot_id;
	      this.search.vehicle_plate = data.plate;
	    },
	    dateRangeSelected: function dateRangeSelected(range) {
	      this.search = (0, _extends3.default)({}, this.search, {
	        from: range ? range.start : null,
	        to: range ? range.end : null
	      });
	      this.$emit('filterReservations', this.search);
	    },
	    toggleCheckbox: function toggleCheckbox() {
	      this.search.checkbox = !this.search.checkbox;
	    }
	  },
	  computed: {
	    sortAsc: function sortAsc() {
	      return this.search.order_direction === 'ASC';
	    }
	  },
	  props: ['type']
	};

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "ClientListFilterForm",
	  components: {},
	  created: function created() {},
	  data: function data() {
	    return {
	      search: {
	        query: null,
	        balance: null
	      }
	    };
	  },
	
	  methods: {
	    enterSubmit: function enterSubmit(e) {
	      if (e.keyCode === 13) {
	        this.filteredSearch();
	      }
	    },
	    balanceSubmit: function balanceSubmit(e) {
	      if (e.keyCode === 13) {
	        this.balanceSearch();
	      }
	    },
	    filteredSearch: function filteredSearch() {
	      this.$emit('filteredSearch', this.search);
	    },
	    balanceSearch: function balanceSearch() {
	      this.$emit('balanceSearch', this.search.balance);
	    }
	  },
	  props: ['placeholder', 'actionButton', 'rowUnstack', 'balance']
	};

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SelectizeClient = __webpack_require__(89);
	
	var _SelectizeClient2 = _interopRequireDefault(_SelectizeClient);
	
	var _SelectizePlan = __webpack_require__(92);
	
	var _SelectizePlan2 = _interopRequireDefault(_SelectizePlan);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SubscriptionListForm",
	  components: {
	    SearchEntity: _SearchEntity2.default,
	    SelectizePlan: _SelectizePlan2.default,
	    SelectizeClient: _SelectizeClient2.default,
	    KeplerBackofficeSdk: _backoffice2.default,
	    DatePicker: _DatePicker2.default
	  },
	  data: function data() {
	    return {
	      search: {
	        client_id: null,
	        plan_id: null,
	        expire_from: null,
	        expire_to: null,
	        status: null,
	        active: null
	      }
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    selectClient: function selectClient(client) {
	      this.search.client_id = client.id;
	    },
	    selectPlan: function selectPlan(plan) {
	      this.search.plan_id = plan.id;
	    },
	    filterSubscriptions: function filterSubscriptions() {
	      this.$cleanObject(this.search);
	      this.$emit("filterSubscriptions", this.search);
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SelectizeClient = __webpack_require__(89);
	
	var _SelectizeClient2 = _interopRequireDefault(_SelectizeClient);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TransactionListForm',
	  components: {
	    DateRangePicker: _DateRangePicker2.default,
	    SelectizeClient: _SelectizeClient2.default,
	    KeplerBackofficeSdk: _backoffice2.default
	  },
	  data: function data() {
	    return {
	      clients: [],
	      search: {
	        client_id: null,
	        date_from: null,
	        date_to: null,
	        status: null,
	        type: null
	      }
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    setRange: function setRange(range) {
	      this.search.date_from = range.from;
	      this.search.date_to = range.to;
	    },
	    selectClient: function selectClient(client) {
	      this.search.client_id = client.id;
	    },
	    filterTransactions: function filterTransactions() {
	      var search = {};
	
	      $.map(this.search, function (value, key) {
	        if (value !== null && value !== '') {
	          search[key] = value;
	        }
	      });
	
	      this.$emit('filterTransactions', search);
	    },
	    dateRangeSelected: function dateRangeSelected(range) {
	      this.search.date_from = range.start;
	      this.search.date_to = range.end;
	    }
	  },
	  computed: {},
	  props: {
	    type: {
	      type: String,
	      default: ''
	    }
	  }
	};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _SelectizeVehicleSlot = __webpack_require__(151);
	
	var _SelectizeVehicleSlot2 = _interopRequireDefault(_SelectizeVehicleSlot);
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _SelectizeSegment = __webpack_require__(2100);
	
	var _SelectizeSegment2 = _interopRequireDefault(_SelectizeSegment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleListForm",
	  components: {
	    SelectizeSegment: _SelectizeSegment2.default,
	    SelectizeCategory: _SelectizeCategory2.default,
	    SelectizeVehicleSlot: _SelectizeVehicleSlot2.default,
	    SelectizeVehicle: _SelectizeVehicle2.default,
	    KeplerBackofficeSdk: _backoffice2.default
	  },
	  data: function data() {
	    return {
	      drivers: [],
	      search: {
	        vehicle_slot_id: null,
	        vehicle_category_id: null,
	        vehicle_id: null,
	        hw_serial: null,
	        active: null,
	        segment_id: null,
	        engine_status: null,
	        immobilizer_status: null,
	        door_status: null,
	        key_status: null,
	        ev_plug_status: null,
	        door_open_status: null
	      }
	    };
	  },
	  created: function created() {},
	
	  computed: {},
	  watch: {
	    search: {
	      handler: function handler() {
	        this.filterVehicles();
	      },
	
	      deep: true
	    }
	  },
	  methods: {
	    selectVehicleCategory: function selectVehicleCategory(category) {
	      this.search.vehicle_category_id = category.id;
	    },
	    unselectVehicle: function unselectVehicle() {
	      this.search.vehicle_id = null;
	      this.$emit('filterVehicles', {});
	    },
	    unselectVehicleSlot: function unselectVehicleSlot() {
	      this.search.vehicle_slot_id = null;
	      this.$emit('filterVehicles', {});
	    },
	    enterSubmit: function enterSubmit(e) {
	      if (e.keyCode === 13) {
	        this.filterVehicles();
	      }
	    },
	    selectVehicle: function selectVehicle(vehicle, x) {
	      this.search.vehicle_id = vehicle.id;
	    },
	    selectVehicleSlot: function selectVehicleSlot(vehicleSlot) {
	      this.search.vehicle_slot_id = vehicleSlot.id;
	    },
	    filterVehicles: function filterVehicles() {
	      var copy = JSON.parse((0, _stringify2.default)(this.search));
	      this.$cleanObject(copy);
	      this.$emit('filterVehicles', copy);
	    }
	  }
	};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "FuelTypeSelect",
	  components: {
	    Selectize: _Selectize2.default
	  },
	  data: function data() {
	    return {
	      fuelTypes: [{ id: 'PETROL', name: 'PETROL' }, { id: 'DIESEL', name: 'DIESEL' }, { id: 'HYBRID', name: 'HYBRID' }, { id: 'GAS', name: 'GAS' }, { id: 'ELECTRIC', name: 'ELECTRIC' }, { id: 'HYDROGEN', name: 'HYDROGEN' }, { id: 'NONE', name: 'NONE' }, { id: 'OTHER', name: 'OTHER' }]
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    selected: function selected(id) {
	      this.$emit('fuelTypeSelected', id);
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(104);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BaseSelectize',
	  data: function data() {
	    return {
	      options: null
	    };
	  },
	
	  computed: {
	    items: function items() {
	      if (this.selectedValues === null) {
	        return [];
	      }
	
	      if (Array.isArray(this.selectedValues)) {
	        return this.selectedValues.map(function (item) {
	          return item.id;
	        });
	      } else if ((0, _typeof3.default)(this.selectedValues) === 'object') {
	        return [this.selectedValues.id];
	      }
	    }
	  },
	  methods: {
	    optionSelected: function optionSelected(option) {
	      this.$emit('optionSelected', option);
	      if (this.valueField) {
	        this.$emit('input', option.id);
	      } else {
	        this.$emit('input', option);
	      }
	    },
	    optionRemoved: function optionRemoved(option) {
	      this.$emit('optionRemoved', option);
	      this.$emit('input', null);
	    }
	  },
	  props: {
	    selectedValues: {
	      default: null
	    },
	    selectedValue: {
	      default: null
	    },
	
	    maxItems: {
	      default: 1
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    allowEmptyOption: {
	      type: Boolean,
	      default: false
	    },
	    value: {},
	    valueField: {
	      default: null
	    }
	  }
	};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeAvailableVehicleSlot",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name', 'brand', 'model', 'plate']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicleSlots.list().available(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      var template = '';
	      template += '<div>';
	      template += "<div><small><i class=\"fa fa-car\"></i>V" + item.id + "</small></div>";
	      template += "<div>" + item.brand + " " + item.model + "<br><small>" + item.plate + "</small></div>";
	      template += '</div>';
	
	      return template;
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div>" + item.brand + " " + item.model + "<br><small>" + item.plate + "</small></div>";
	    }
	  }
	};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeCard",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    this.dataLoader();
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div><small>" + item.id + "</small></div><div>" + item.name + "</div></div>";
	    },
	    dataLoader: function dataLoader(page, resultsPerPage, search) {
	      var _this = this;
	
	      if (this.nullDriver) {
	        _backoffice2.default.cards.list(page, resultsPerPage, search).unassigned(function (data) {
	          _this.options = data.items;
	        });
	      } else {
	        _backoffice2.default.cards.list(page, resultsPerPage, search).all(function (data) {
	          _this.options = data.items;
	        });
	      }
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div>" + item.name + "</div>";
	    }
	  },
	  props: ['selectedValue', 'nullDriver']
	};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeCategory',
	  extends: _BaseSelectize2.default,
	  components: { LoadingSpinner: _LoadingSpinner2.default, Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      loading: true,
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.selects.vehicleCategories(function (data) {
	      _this.options = data;
	      _this.loading = false;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      if (item.id) {
	        return '<div><div><small>C' + item.id + '</small></div><div>' + item.name + '</div></div>';
	      }
	      return '<div><div>Select category</div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      if (item.id) {
	        return '<div>' + item.name + '</div>';
	      }
	      return '<div>Select category</div>';
	    }
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeClient",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	
	    return {
	      searchableFields: ['id', 'organization_name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.selects.clients(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div><small>C" + item.id + "</small></div><div>" + item.organization_name + "</div></div>";
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div>" + item.organization_name + "</div>";
	    },
	    clearSelected: function clearSelected() {
	      this.$refs.selectize.clearSelected();
	    }
	  }
	};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeClientType',
	  extends: _BaseSelectize2.default,
	  components: { LoadingSpinner: _LoadingSpinner2.default, Selectize: _Selectize2.default }, data: function data() {
	    return {
	      loading: true,
	      searchableFields: ['id', 'code']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.clientTypes.list(1, 1000, null).all(function (data) {
	      _this.options = data.clientTypes;
	      _this.loading = false;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div><div>CT' + item.id + ' ' + item.code + '</div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div><div>CT' + item.id + ' ' + item.code + '</div></div>';
	    },
	    optionsLoader: function optionsLoader() {}
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeCommonCost',
	  extends: _BaseSelectize2.default,
	  components: { LoadingSpinner: _LoadingSpinner2.default, Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      loading: true,
	      searchableFields: ['id', 'reason']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.commonCosts.list().all(1, 10000, function (data) {
	      _this.options = data.items;
	      _this.loading = false;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      if (item.id) {
	        var amount = this.$priceWithVat(item.amount, item.tax);
	        return '<div><div><small>CC' + item.id + '</small></div><div>' + item.reason + '</div><div><small>' + this.$priceWithcurrency(amount) + '</small></div></div>';
	      }
	      return '<div><div>Select cost</div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      if (item.id) {
	        return '<div>CC' + item.id + ' ' + item.reason + '</div>';
	      }
	      return '<div><div>Select cpst</div></div>';
	    },
	    optionsLoader: function optionsLoader() {}
	  }
	};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _CountryList = __webpack_require__(238);
	
	var _CountryList2 = _interopRequireDefault(_CountryList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeCountry",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['name', 'code']
	    };
	  },
	  created: function created() {
	    this.options = _CountryList2.default.countries;
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div><div><small>' + item.code + '</small></div><div>' + item.name + '</div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div><div><small>' + item.code + '</small></div><div>' + item.name + '</div></div>';
	    }
	  }
	};

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeDocumentType',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    this.dataLoader();
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div><div><small>DT' + item.id + '</small></div><div>' + item.name + '</div></div>';
	    },
	    dataLoader: function dataLoader(page, resultsPerPage, search) {
	      var _this = this;
	
	      if (this.nullDriver) {
	        _backoffice2.default.documentTypes.list(page, resultsPerPage, search).all(function (data) {
	          _this.options = data;
	        });
	      } else {
	        _backoffice2.default.documentTypes.list(page, resultsPerPage, search).all(function (data) {
	          _this.options = data;
	        });
	      }
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div><div>' + item.name + '</div></div>';
	    }
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeDriver',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	
	    return {
	      searchableFields: ['id', 'name', 'surname', 'username']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.clientDrivers.length > 0) {
	      this.options = this.clientDrivers;
	      return;
	    }
	    _backoffice2.default.selects.drivers(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div><div>D' + item.id + ' - ' + item.name + ' ' + item.surname + '</div><div><small>Username: ' + item.username + '</small></div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div><div><small>D' + item.id + '</small></div> <div>' + item.name + ' ' + item.surname + '</div></div>';
	    }
	  },
	  props: {
	    clientDrivers: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedValue: {}
	  }
	};

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeDriverLicense",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    this.options = [{ id: "VEWwEX", name: 'Patente b' }];
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div><small>DL" + item.id + "</small></div><div>" + item.name + "</div></div>";
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div>" + item.name + "</div>";
	    }
	  }
	};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeFederation",
	  extends: _BaseSelectize2.default,
	  components: { LoadingSpinner: _LoadingSpinner2.default, Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      loading: true,
	
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    this.dataLoader();
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div><small>" + item.id + "</small></div><div>" + item.name + "</div></div>";
	    },
	    dataLoader: function dataLoader(page, resultsPerPage, search) {
	      var _this = this;
	
	      _backoffice2.default.federations.list(page, -1).all(function (data) {
	        _this.options = data.items;
	        _this.loading = false;
	      });
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div>" + item.name + "</div>";
	    }
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeGroupedParkingAssets",
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      parkingGroups: null,
	      parkingLots: null,
	      parkingSlots: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.parkingGroups.list.all(function (data) {
	      _this.parkingGroups = data;
	    });
	  },
	
	  methods: {
	    optionPgTemplate: function optionPgTemplate(item, escape) {
	      return "<div>PG" + item.id + " " + item.name + "</div>";
	    },
	    renderPgTemplate: function renderPgTemplate(item, escape) {
	      return "<div>" + item.name + "</div>";
	    },
	    plUnselected: function plUnselected() {
	      this.parkingSlots = null;
	      if (this.$refs.selectizeParkingSlots !== undefined) {
	        this.$refs.selectizeParkingSlots.clearOptions();
	      }
	    },
	    pgSelected: function pgSelected(pg) {
	      var _this2 = this;
	
	      this.clearLotAndSlot();
	      this.parkingGroups.forEach(function (item) {
	        if (pg.id === item.id) {
	          if (_this2.$refs.selectizeParkingLots !== undefined) {
	            _this2.$refs.selectizeParkingLots.addOption(item.parking_lots);
	          }
	          _this2.parkingLots = item.parking_lots;
	        }
	      });
	    },
	    plSelected: function plSelected(pl) {
	      var _this3 = this;
	
	      this.parkingSlots = null;
	      if (this.$refs.selectizeParkingSlots !== undefined) {
	        this.$refs.selectizeParkingSlots.clearOptions();
	      }
	
	      _backoffice2.default.parkingLots.select(pl.id).get(function (data) {
	        _this3.parkingSlots = data.parking_slots;
	      });
	    },
	    clearLotAndSlot: function clearLotAndSlot() {
	      this.parkingLots = null;
	      if (this.$refs.selectizeParkingLots !== undefined) {
	        this.$refs.selectizeParkingLots.clearOptions();
	      }
	      this.plUnselected();
	    },
	    psSelected: function psSelected(ps) {
	      this.$emit('parkingSlotSelected', ps);
	    }
	  }
	};

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(94);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _js = __webpack_require__(232);
	
	var mdi = _interopRequireWildcard(_js);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeIcon",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      options: null,
	      searchableFields: ['name']
	    };
	  },
	  created: function created() {
	
	    var kebabize = function kebabize(str) {
	      return str.split('').map(function (letter, idx) {
	        return letter.toUpperCase() === letter ? '' + (idx !== 0 ? '-' : '') + letter.toLowerCase() : letter;
	      }).join('');
	    };
	
	    this.options = (0, _entries2.default)(mdi).splice(1).map(function (icon) {
	      return {
	        name: kebabize(icon[0].replace("mdi", "")),
	        iconName: kebabize(icon[0]),
	        id: kebabize(icon[0]),
	        path: icon[1]
	      };
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div class="selectable-item"><svg xmlns=\'http://www.w3.org/2000/svg\'><path fill="currentColor" d="' + item.path + '"></path></svg><span>' + item.name + '</span></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div class="selected-item"><svg xmlns=\'http://www.w3.org/2000/svg\'><path fill="currentColor" d="' + item.path + '"></path></svg><span>' + item.name + '</span></div>';
	    }
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeInstructions",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.instructions.list.all(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div>IN" + item.id + " " + item.title + "</div><div><small>" + item.subtitle + "</small></div></div>";
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div><div>IN" + item.id + " " + item.title + "</div><div><small>" + item.subtitle + "</small></div></div>";
	    },
	    optionsLoader: function optionsLoader() {}
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeInterventionRequest',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'status', 'type', 'description']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.maintenanceRequest.list(1, -1).all({}, function (data) {
	      _this.options = data.items;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div><div><small>IR' + item.id + ' ' + item.status + ' ' + item.type + '</small></div><div>V' + item.vehicle.id + ' ' + item.vehicle.brand + ' ' + item.vehicle.model + '</div> <div><small>' + item.vehicle.plate + '</small></div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div><div>IR' + item.id + ' ' + item.status + '</div></div>';
	    },
	    optionsLoader: function optionsLoader() {},
	    clearSelected: function clearSelected() {
	      this.$refs.selectize.clearSelected();
	    }
	  },
	  props: ['selectedValue', 'disabledSlot', 'archived']
	};

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeMaintenanceDriver',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	
	    return {
	      searchableFields: ['id', 'name', 'surname', 'username']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.drivers.list(1, -1, {}).maintenance(function (data) {
	      _this.options = data.items;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div><div>D' + item.id + ' - ' + item.name + ' ' + item.surname + '</div><div><small>Username: ' + item.username + '</small></div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div><div><small>D' + item.id + '</small></div> <div>' + item.name + ' ' + item.surname + '</div></div>';
	    }
	  },
	  props: {
	    clientDrivers: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    },
	    selectedValue: {}
	  }
	};

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(94);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizePacket',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default, LoadingSpinner: _LoadingSpinner2.default },
	  data: function data() {
	    return {
	      loading: true,
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.packets.list.all(1, -1, function (data) {
	      _this.options = (0, _entries2.default)(data);
	      _this.loading = false;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      if (item.id) {
	        return '<div><div><small>P' + item.id + '</small></div><div>' + item.name + '</div></div>';
	      }
	      return '<div><div>Select packet</div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      if (item.id) {
	        return '<div>P' + item.id + ' ' + item.name + '</div>';
	      }
	      return '<div><div>Select packet</div></div>';
	    },
	    optionsLoader: function optionsLoader() {}
	  }
	};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeParkingGroup',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.parkingGroups.list.all(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div>PG' + item.id + ' ' + item.name + '</div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div>PG' + item.id + '<br><small>' + item.name + '</small></div>';
	    },
	    optionsLoader: function optionsLoader() {},
	    clearSelected: function clearSelected() {
	      this.$refs.selectize.clearSelected();
	    }
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeParkingLot',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.parkingLots.list.all(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div><div>PL' + item.id + ' - ' + item.name + '</div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div><div>PL' + item.id + ' - ' + item.name + '</div></div>';
	    },
	    optionSelected: function optionSelected(option) {
	      this.$emit('optionSelected', option);
	      this.$emit('input', option.id);
	    }
	  },
	  props: {
	
	    selectedValue: {}
	  }
	};

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizePlan',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default, LoadingSpinner: _LoadingSpinner2.default },
	  data: function data() {
	    return {
	      loading: true,
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.selects.plans(this.disabled, function (data) {
	      _this.options = data;
	      _this.loading = false;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      if (item.id) {
	        return '<div><div><small>PL' + item.id + '</small></div><div>' + item.name + '</div></div>';
	      }
	      return '<div><div>Select plan</div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      if (item.id) {
	        return '<div>PL' + item.id + ' ' + item.name + '</div>';
	      }
	      return '<div><div>Select plan</div></div>';
	    },
	    optionsLoader: function optionsLoader() {}
	  }
	};

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizePolicy',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.policies.list(1, -1).all(function (data) {
	      _this.options = data.items;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      if (item.id) {
	        return '<div><div><small>P' + item.id + '</small></div><div>' + item.name + '</div><div>' + item.type + '</div></div>';
	      }
	      return '<div><div>Select Policy</div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      if (item.id) {
	        return '<div><div><small>P' + item.id + '</small></div><div>' + item.name + '</div></div>';
	      }
	      return '<div>Select Policy</div>';
	    }
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeReservationRate',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.reservationRates.list.rates(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div>\n                <div><small>RR' + item.id + '</small></div>\n                <div>' + item.name + '</div>\n                </div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div>' + item.name + '</div>';
	    }
	  },
	  props: ['selectedValue'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  })
	};

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeSegment',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'brand', 'model', 'plate', 'parking_lot_id', 'parking_lot_name', 'parking_slot']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.segments.list(1, -1).all(function (data) {
	      _this.options = data.items;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div><div>S' + item.id + ' ' + item.name + '</div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div><div>S' + item.id + ' ' + item.name + '</div></div>';
	    },
	    optionsLoader: function optionsLoader() {},
	    clearSelected: function clearSelected() {
	      this.$refs.selectize.clearSelected();
	    }
	  },
	  props: ['selectedValue', 'disabledSlot', 'archived']
	};

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeToc",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.tocs.list.all(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div>T" + item.id + " " + item.name + "</div><div><small>" + item.toc_type.name + "</small></div></div>";
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div>T" + item.id + " " + item.name + "</div>";
	    },
	    optionsLoader: function optionsLoader() {}
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeTocType',
	  extends: _BaseSelectize2.default,
	  components: { ModalReveal: _ModalReveal2.default, Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    this.loadTocs();
	  },
	
	  methods: {
	    loadTocs: function loadTocs() {
	      var _this = this;
	
	      _backoffice2.default.tocTypes.list.all(function (data) {
	        _this.options = data;
	      });
	    },
	    optionTemplate: function optionTemplate(item, escape) {
	      return '<div><div><small>TT' + item.id + '</small></div><div>' + item.name + '</div><div><small>' + item.group + '</small></div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div>' + item.name + '</div>';
	    }
	  },
	  props: ['selectedValue']
	
	};

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SelectizeVehicle',
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'brand', 'model', 'plate', 'parking_lot_id', 'parking_lot_name', 'parking_slot'],
	      rerender: 0
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.selects.vehicles(this.disabledSlot, this.archived, function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      var parkingLotName = item.parking_lot_name !== null ? item.parking_lot_name : '';
	      var parkingLotId = item.parking_lot_id !== null ? '<i class="fa fa-car"></i>PS' + item.parking_lot_id : '';
	
	      var vehicleSlotId = item.vehicle_slot_id !== null ? 'VS' + item.vehicle_slot_id : '';
	      return '<div><div><small>' + parkingLotId + ' ' + parkingLotName + '</small></div><div>V' + item.id + ' ' + item.brand + ' ' + item.model + '</div> <div><small>' + vehicleSlotId + ' ' + item.plate + '</small></div></div>';
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return '<div>' + item.brand + ' ' + item.model + '<br><small>' + item.plate + '</small></div>';
	    },
	    optionsLoader: function optionsLoader() {},
	    clearSelected: function clearSelected() {
	      this.$refs.selectize.clearSelected();
	    }
	  },
	  props: ['selectedValue', 'disabledSlot', 'archived']
	
	};

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeVehicleAttribute",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicleAttributes.list.all(function (data) {
	      if (_this.filterType) {
	        _this.options = data.filter(function (item) {
	
	          return item.vehicle_type.id === _this.filterType;
	        });
	      } else {
	        _this.options = data;
	      }
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div>VA" + item.id + " " + item.name + "</div><div><small>VT" + item.vehicle_type.id + " " + item.vehicle_type.name + " - " + item.description + "</small></div></div>";
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div><div>VT" + item.id + " " + item.name + "</div><div><small>" + item.description + "</small></div></div>";
	    },
	    optionsLoader: function optionsLoader() {}
	  },
	  props: ['selectedValue', 'filterType']
	};

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeVehicleBrand",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.clientDrivers.length > 0) {
	      this.options = this.clientDrivers;
	      return;
	    }
	    _backoffice2.default.selects.vehicleBrands(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div><small>B" + item.id + "</small></div> <div>" + item.name + "</div></div>";
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div><div><small>B" + item.id + "</small></div> <div>" + item.name + "</div></div>";
	    }
	  },
	  props: {
	    clientDrivers: {
	      type: Array,
	      required: false,
	      default: function _default() {
	        return [];
	      }
	    }
	  }
	};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeVehicleSlot",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.selects.vehicleSlots(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div><small><i class=\"fa fa-car\"></i>VS" + item.id + "</small></div><div>" + item.name + "</div></div>";
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div>" + item.name + "</div>";
	    }
	  }
	};

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseSelectize = __webpack_require__(19);
	
	var _BaseSelectize2 = _interopRequireDefault(_BaseSelectize);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SelectizeVehicleType",
	  extends: _BaseSelectize2.default,
	  components: { Selectize: _Selectize2.default },
	  data: function data() {
	    return {
	      searchableFields: ['id', 'name']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicleTypes.list.all(function (data) {
	      _this.options = data;
	    });
	  },
	
	  methods: {
	    optionTemplate: function optionTemplate(item, escape) {
	      return "<div><div>VA" + item.id + " " + item.name + "</div><div><small>" + item.description + "</small></div></div>";
	    },
	    renderTemplate: function renderTemplate(item, escape) {
	      return "<div>VA" + item.id + " " + item.name + "</div>";
	    },
	    optionsLoader: function optionsLoader() {}
	  },
	  props: ['selectedValue']
	};

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _GoogleMapMarker = __webpack_require__(72);
	
	var _GoogleMapMarker2 = _interopRequireDefault(_GoogleMapMarker);
	
	var _GoogleMapSearchBox = __webpack_require__(592);
	
	var _GoogleMapSearchBox2 = _interopRequireDefault(_GoogleMapSearchBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GoogleMap',
	  data: function data() {
	    return {
	      map: null,
	      search_marker: null
	    };
	  },
	
	  components: {
	    GoogleMapSearchBox: _GoogleMapSearchBox2.default,
	    GoogleMapMarker: _GoogleMapMarker2.default
	  },
	  mounted: function mounted() {
	    if (!this.ready) {
	      this.createGoogleMaps().then(this.initGoogleMaps, this.googleMapsFailedToLoad);
	    }
	  },
	
	  methods: {
	    createGoogleMaps: function createGoogleMaps() {
	      var self = this;
	      return new _promise2.default(function (resolve, reject) {
	        if (document.getElementById('google-map-loader') === null) {
	          var gmap = document.createElement('script');
	          gmap.setAttribute('id', 'google-map-loader');
	          gmap.src = self.url;
	          gmap.type = 'text/javascript';
	          gmap.onload = resolve;
	          gmap.onerror = reject;
	          document.body.appendChild(gmap);
	        } else {
	          resolve();
	        }
	      });
	    },
	    googleMapsFailedToLoad: function googleMapsFailedToLoad() {
	      alert('Google maps failed to load!');
	    },
	    initGoogleMaps: function initGoogleMaps() {
	      var _this = this;
	
	      this.map = new google.maps.Map(document.getElementById(this._uid), {
	        zoom: this.zoom,
	        center: this.center,
	        mapTypeId: this.mapTypeId,
	        scrollwheel: this.scrollWheelZoom,
	        styles: this.mapStyle,
	
	        zoomControl: this.zoomControl,
	        scaleControl: false,
	        clickableIcons: false,
	        streetViewControl: false,
	
	        fullscreenControl: false,
	        disableDefaultUI: true,
	        mapTypeControl: this.mapTypeControl,
	        draggable: this.draggable,
	        panControl: this.panControl
	      });
	
	      this.$emit('map-ready');
	
	      if (this.listenForClick) {
	        this.map.addListener('click', function (e) {
	          if (_this.search_marker) {
	            _this.search_marker = false;
	          }
	          _this.$emit('mapClicked', e.latLng);
	        });
	      }
	    },
	    panToPosition: function panToPosition(place) {
	      this.pan(place.geometry.location.lat(), place.geometry.location.lng());
	
	      this.search_marker = {
	        position: {
	          lat: place.geometry.location.lat(),
	          lng: place.geometry.location.lng()
	        },
	        title: place.formatted_address,
	        label: ''
	      };
	    },
	
	    getMap: function getMap() {
	      return this.map;
	    },
	    pan: function pan(lat, lng) {
	      if (this.map) {
	        this.map.panTo(new google.maps.LatLng(lat, lng));
	      }
	    },
	    getBounds: function getBounds(markers, centerPoint) {
	      if (this.ready) {
	        var bounds = new google.maps.LatLngBounds();
	        bounds.extend(new google.maps.LatLng(centerPoint.lat, centerPoint.lng));
	        var c = 2;
	        for (var i = 0; i < c; i++) {
	          if (markers[i].position) {
	            bounds.extend(new google.maps.LatLng(markers[i].position.lat, markers[i].position.lng));
	          }
	        }
	        this.map.fitBounds(bounds);
	      }
	    }
	  },
	  computed: {
	    ready: function ready() {
	      return this.map != null;
	    },
	    url: function url() {
	      var libraries = this.libraries.join(',');
	      return this.proxyUrl && this.proxyUrl !== '' ? this.proxyUrl : 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey + '&libraries=' + libraries;
	    }
	  },
	  props: {
	    apiKey: {
	      type: String
	    },
	    mapTypeId: {
	      type: String,
	      default: 'roadmap'
	    },
	    center: {
	      type: Object
	    },
	
	    zoom: {
	      type: Number,
	      default: 13
	    },
	    scrollWheelZoom: {
	      type: Boolean,
	      default: true
	    },
	    searchBar: {
	      type: Boolean,
	      default: false
	    },
	    mapStyle: {
	      type: Array,
	      default: null
	    },
	    draggable: {
	      type: Boolean,
	      default: true
	    },
	    panControl: {
	      type: Boolean,
	      default: true
	    },
	    proxyUrl: {
	      type: String
	    },
	    libraries: {
	      type: Array,
	      default: function _default() {
	        return ['places', 'visualization'];
	      }
	    },
	    listenForClick: {
	      type: Boolean,
	      default: false
	    },
	    zoomControl: {
	      type: Boolean,
	      default: false
	    },
	    mapTypeControl: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'GoogleMapChildren',
	  data: function data() {
	    return {
	      item: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.$parent.ready) {
	      this.init();
	    } else {
	      this.$parent.$on('map-ready', function () {
	        _this.init();
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.item.setMap(null);
	  },
	
	  methods: {
	    getMap: function getMap() {
	      return this.$parent.getMap();
	    },
	    addButton: function addButton(title, callback) {
	      var buttonDiv = document.createElement('div');
	
	
	      var borderDiv = document.createElement('div');
	      borderDiv.style.backgroundColor = '#fff';
	      borderDiv.style.border = '2px solid #fff';
	      borderDiv.style.borderRadius = '3px';
	      borderDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
	      borderDiv.style.cursor = 'pointer';
	      borderDiv.style.margin = '5px';
	      borderDiv.style.textAlign = 'center';
	
	      buttonDiv.appendChild(borderDiv);
	
	      var contentDiv = document.createElement('div');
	      contentDiv.style.color = 'rgb(25,25,25)';
	      contentDiv.style.fontFamily = 'Roboto,Arial,sans-serif';
	      contentDiv.style.lineHeight = '20px';
	      contentDiv.style.paddingLeft = '5px';
	      contentDiv.style.paddingRight = '5px';
	      contentDiv.innerHTML = title;
	      borderDiv.appendChild(contentDiv);
	
	      borderDiv.addEventListener('click', callback);
	
	      this.getMap().controls[google.maps.ControlPosition.TOP_CENTER].push(buttonDiv);
	    }
	  }
	};

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GoogleMapChildren = __webpack_require__(103);
	
	var _GoogleMapChildren2 = _interopRequireDefault(_GoogleMapChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GoogleMapCircle',
	  extends: _GoogleMapChildren2.default,
	  beforeDestroy: function beforeDestroy() {
	    if (this.info_item) {
	      this.info_item.close();
	    }
	  },
	
	  methods: {
	    init: function init() {
	      if (this.item == null) {
	
	        var self = this;
	
	        this.item = new google.maps.Circle({
	          strokeColor: self.strokeColor,
	          strokeOpacity: 0.8,
	          strokeWeight: 2,
	          fillColor: self.fillColor,
	          fillOpacity: 0.35,
	          map: this.getMap(),
	          center: new google.maps.LatLng(self.position.lat, self.position.lng),
	          radius: self.radius
	        });
	
	        if (this.forceInfo || typeof this.$slots.default != 'undefined') {
	          this.info_item = new google.maps.InfoWindow({
	            content: document.getElementById(self._uid).firstChild
	          });
	
	          this.item.addListener('click', function (circle) {
	            self.info_item.setPosition(new google.maps.LatLng(self.position.lat, self.position.lng));
	            self.info_item.open(self.$parent.getMap(), self.item);
	          });
	        }
	      }
	    }
	  },
	  props: {
	    forceInfo: {
	      type: Boolean,
	      default: false
	    },
	    position: {
	      type: Object,
	      required: true
	    },
	    radius: {
	      type: Number,
	      default: 50
	    },
	    strokeColor: {
	      type: String,
	      default: "#ff6b0c"
	    },
	    fillColor: {
	      type: String,
	      default: "#ff6b0c"
	    }
	  },
	  watch: {
	    position: function position() {
	      if (this.item) {
	        this.item.setCenter(new google.maps.LatLng(this.position.lat, this.position.lng));
	        this.item.setRadius(this.radius);
	      }
	    }
	  }
	};

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'GoogleMapDirectionsService',
	  data: function data() {
	    return {
	      directionsDisplay: null,
	      directionsService: null,
	      originMarker: null,
	      destinationMarker: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.$parent.ready) {
	      this.init();
	    } else {
	      this.$parent.$on('map-ready', function () {
	        _this.init();
	      });
	    }
	  },
	  destroyed: function destroyed() {
	    this.directionsDisplay.setMap(null);
	    this.originMarker.setMap(null);
	    this.destinationMarker.setMap(null);
	  },
	
	  methods: {
	    init: function init() {
	      var _this2 = this;
	
	      if (this.$parent.ready) {
	        this.directionsService = new google.maps.DirectionsService();
	        this.directionsDisplay = new google.maps.DirectionsRenderer({
	          suppressMarkers: true,
	          polylineOptions: { strokeColor: this.color }
	        });
	        this.directionsDisplay.setMap(this.getMap());
	        this.directionsDisplay.setOptions({ suppressMarkers: true });
	        this.directionsService.route({
	          origin: this.origin,
	          destination: this.destination,
	          travelMode: this.travelMode
	        }, function (response, status) {
	          if (status === google.maps.DirectionsStatus.OK) {
	            _this2.setDirections(response);
	          } else {
	            _this2.$emit('directionsRequestFailed');
	          }
	        });
	      }
	    },
	    getMap: function getMap() {
	      return this.$parent.getMap();
	    },
	    setDirections: function setDirections(response) {
	      this.directionsDisplay.setDirections(response);
	      var leg = response.routes[0].legs[0];
	      if (this.originMarker !== null) {
	        this.originMarker.setMap(null);
	      }
	      this.originMarker = this.addMarker(leg.start_location, this.iconStart, 'title');
	      if (this.destinationMarker !== null) {
	        this.destinationMarker.setMap(null);
	      }
	      this.destinationMarker = this.addMarker(leg.end_location, this.iconEnd, 'title');
	    },
	    addMarker: function addMarker(latLng, icon) {
	      return new google.maps.Marker({
	        position: latLng,
	        map: this.getMap(),
	        title: '[[*pagetitle]]',
	        icon: {
	          url: icon,
	
	          scaledSize: new google.maps.Size(30, 30),
	          origin: new google.maps.Point(0, 0),
	
	          anchor: new google.maps.Point(15, 15) }
	      });
	    }
	  },
	  watch: {
	    origin: {
	      handler: function handler() {
	        if (this.originMarker && this.destinationMarker) {
	          this.directionsDisplay.setMap(null);
	          this.originMarker.setMap(null);
	          this.destinationMarker.setMap(null);
	        }
	        this.init();
	      },
	
	      deep: true
	    },
	    destination: {
	      handler: function handler() {
	        if (this.originMarker && this.destinationMarker) {
	          this.directionsDisplay.setMap(null);
	          this.originMarker.setMap(null);
	          this.destinationMarker.setMap(null);
	        }
	        this.init();
	      },
	
	      deep: true
	    }
	  },
	  props: {
	    origin: {
	      type: Object,
	      required: true
	    },
	
	    destination: {
	      type: Object,
	      required: true
	    },
	    travelMode: {
	      type: String,
	      default: 'WALKING'
	    },
	    color: {
	      type: String,
	      default: '#FF0000'
	    },
	    iconStart: {
	      default: 'http://maps.google.com/mapfiles/ms/micons/blue.png',
	      type: String
	    },
	    iconEnd: {
	      default: 'http://maps.google.com/mapfiles/ms/micons/green.png',
	      type: String
	    }
	
	  }
	};

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GoogleMapChildren = __webpack_require__(103);
	
	var _GoogleMapChildren2 = _interopRequireDefault(_GoogleMapChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GoogleMapDrawingManager',
	  extends: _GoogleMapChildren2.default,
	  data: function data() {
	    return {
	      item: null,
	      overlays: [],
	      selectedOverlay: null
	    };
	  },
	
	  methods: {
	    init: function init() {
	      var _this = this;
	
	      if (this.item == null) {
	        this.item = new google.maps.drawing.DrawingManager({
	          drawingMode: google.maps.drawing.OverlayType.POLYGON,
	          drawingControl: true,
	          drawingControlOptions: {
	            position: google.maps.ControlPosition.TOP_CENTER,
	            drawingModes: ['polygon']
	          }
	        });
	        this.item.setMap(this.$parent.getMap());
	
	        if (this.initial) {
	          this.initial.forEach(function (p) {
	            var p = new google.maps.Polygon({
	              path: p
	            });
	
	            p.setMap(_this.$parent.getMap());
	
	            _this.overlays.push(p);
	
	            google.maps.event.addListener(p, 'click', function () {
	              _this.selectOverlay(p);
	            });
	          });
	        }
	
	        this.addButton('Delete selected', function () {
	          _this.deleteSelection();
	        });
	
	        this.addButton('Confirm', function () {
	          _this.handleComplete();
	        });
	
	        google.maps.event.addListener(this.item, 'overlaycomplete', this.overlayComplete);
	      }
	    },
	    overlayComplete: function overlayComplete(e) {
	      var _this2 = this;
	
	      var overlay = e.overlay;
	
	      this.overlays.push(overlay);
	
	      google.maps.event.addListener(overlay, 'click', function () {
	        _this2.selectOverlay(overlay);
	      });
	
	      this.item.setDrawingMode(null);
	    },
	    selectOverlay: function selectOverlay(overlay) {
	      this.selectedOverlay = overlay;
	      overlay.setEditable(true);
	    },
	    deselectOverlay: function deselectOverlay() {
	      this.selectedOverlay.setEditable(false);
	      this.selectedOverlay = null;
	    },
	    deleteSelection: function deleteSelection() {
	      if (!this.selectedOverlay) {
	        alert('You must select a overlay before editing');
	        return;
	      }
	      var index = this.overlays.indexOf(this.selectedOverlay);
	      this.overlays.splice(index, 1);
	      this.selectedOverlay.setMap(null);
	      this.selectedOverlay = null;
	      this.handleComplete();
	    },
	    handleComplete: function handleComplete() {
	
	      var GeoJSONCollection = {
	        type: 'FeatureCollection',
	        features: []
	      };
	
	      this.overlays.forEach(function (overlay) {
	        var GeoJSON = {
	          type: 'Feature',
	          properties: {},
	          geometry: {
	            type: 'Polygon',
	            coordinates: [[]]
	          }
	        };
	
	        overlay.getPath().getArray().forEach(function (point) {
	          GeoJSON.geometry.coordinates[0].push([point.lng(), point.lat()]);
	        });
	
	        GeoJSON.geometry.coordinates[0].push(GeoJSON.geometry.coordinates[0][0]);
	        GeoJSONCollection.features.push(GeoJSON);
	      });
	
	      this.$emit('updated', GeoJSONCollection);
	    }
	  },
	  props: ['initial']
	};

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GoogleMapChildren = __webpack_require__(103);
	
	var _GoogleMapChildren2 = _interopRequireDefault(_GoogleMapChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GoogleMapMarker',
	  extends: _GoogleMapChildren2.default,
	  data: function data() {
	    return {
	      info_item: null
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.info_item) {
	      this.info_item.close();
	    }
	  },
	
	  methods: {
	    init: function init() {
	      if (this.item == null) {
	        var self = this;
	        this.item = new google.maps.Marker({
	          position: new google.maps.LatLng(self.position.lat, self.position.lng),
	          label: self.label,
	          title: self.title,
	          clickable: this.clickable,
	          map: this.$parent.getMap(),
	          animation: google.maps.Animation.DROP,
	
	          icon: self.icon ? {
	            url: self.icon,
	
	            scaledSize: new google.maps.Size(this.iconSize.width, this.iconSize.height),
	            origin: new google.maps.Point(this.iconOrigin[0], this.iconOrigin[1]),
	
	            anchor: new google.maps.Point(this.iconAnchor[0], this.iconAnchor[1]),
	            labelOrigin: new google.maps.Point(this.labelOrigin[0], this.labelOrigin[1])
	          } : null
	        });
	
	        if (this.clickable !== false) {
	          this.item.addListener('click', function (marker) {
	            self.$emit('click', marker);
	          });
	        }
	
	        if (this.forceInfo || typeof this.$slots.default != 'undefined') {
	          this.info_item = new google.maps.InfoWindow({
	            content: document.getElementById(self._uid).firstChild
	          });
	
	          this.item.addListener('click', function (marker) {
	            self.info_item.open(self.$parent.getMap(), self.item);
	          });
	        }
	      }
	    }
	  },
	  props: {
	    forceInfo: {
	      type: Boolean,
	      default: false
	    },
	    position: {
	      type: Object,
	      required: true
	    },
	
	    title: {
	      type: String,
	      required: true
	    },
	
	    label: {
	      type: String,
	      required: true
	    },
	    labelOrigin: {
	      type: Array,
	      default: function _default() {
	        return [15, 15];
	      }
	    },
	
	    icon: {
	      type: String,
	      default: null
	    },
	    iconSize: {
	      type: Object,
	      default: function _default() {
	        return { width: 30, height: 30 };
	      }
	    },
	    iconOrigin: {
	      type: Array,
	      default: function _default() {
	        return [0, 0];
	      }
	    },
	    iconAnchor: {
	      type: Array,
	      default: function _default() {
	        return [15, 15];
	      }
	    },
	    clickable: {
	      type: Boolean,
	      default: true
	    }
	  },
	  watch: {
	    position: {
	      handler: function handler() {
	        if (this.item) {
	          this.item.setPosition(new google.maps.LatLng(this.position.lat, this.position.lng));
	        }
	      },
	      deep: true
	    },
	    icon: function icon(val) {
	      this.item.setIcon({
	        url: val,
	
	        scaledSize: new google.maps.Size(this.iconSize.width, this.iconSize.height),
	        origin: new google.maps.Point(0, 0),
	
	        anchor: new google.maps.Point(15, 15) });
	    }
	  }
	};

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _markerclusterer = __webpack_require__(1177);
	
	var _markerclusterer2 = _interopRequireDefault(_markerclusterer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GoogleMapMarkerCluster',
	  data: function data() {
	    return {
	      item: null,
	      markers: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.$parent.ready) {
	      this.init();
	    } else {
	      this.$parent.$on('map-ready', function () {
	        _this.init();
	      });
	    }
	  },
	
	  methods: {
	    getMap: function getMap() {
	      return this.$parent.getMap();
	    },
	    init: function init() {
	      var _this2 = this;
	
	      this.$emit('map-ready');
	      this.markers = [];
	      this.$children.forEach(function (childrenMarker) {
	        _this2.markers.push(childrenMarker.item);
	      });
	      this.item = new _markerclusterer2.default(this.getMap(), this.markers, {
	        imagePath: this.iconBase,
	        maxZoom: 17
	      });
	    }
	  },
	  updated: function updated() {
	    if (this.item) {
	      this.item.clearMarkers();
	    }
	    this.init();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.item) {
	      this.item.clearMarkers();
	      delete this.item;
	    }
	  },
	
	  props: {
	    iconBase: {
	      type: String,
	      default: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
	    }
	  }
	};

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GoogleMapChildren = __webpack_require__(103);
	
	var _GoogleMapChildren2 = _interopRequireDefault(_GoogleMapChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GoogleMapPolygon',
	  extends: _GoogleMapChildren2.default,
	
	  methods: {
	    init: function init() {
	      if (this.$parent.ready && this.item == null) {
	        var self = this;
	
	        this.item = new google.maps.Polygon({
	          path: self.positions,
	          strokeColor: self.color,
	          strokeOpacity: 1.0,
	          strokeWeight: 2,
	          fillColor: self.fillColor,
	          fillOpacity: 0.35
	        });
	
	        this.item.setMap(this.getMap());
	      }
	    }
	  },
	  watch: {
	    positions: function positions(n, o) {
	      this.item.setPath(this.positions);
	    },
	    fillColor: function fillColor(n, o) {
	      this.item.setOptions({ fillColor: this.fillColor });
	    },
	    color: function color(n, o) {
	      this.item.setOptions({ strokeColor: this.color });
	    }
	  },
	
	  props: {
	    positions: {
	      type: Array,
	      required: true
	    },
	    color: {
	      type: String,
	      default: '#FF0000'
	    },
	    fillColor: {
	      type: String,
	      default: '#FF0000'
	    }
	  }
	};

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GoogleMapChildren = __webpack_require__(103);
	
	var _GoogleMapChildren2 = _interopRequireDefault(_GoogleMapChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GoogleMapPolyline',
	  extends: _GoogleMapChildren2.default,
	  watch: {
	    positions: function positions(_positions) {
	      this.item.setPath(_positions);
	    }
	  },
	  methods: {
	    init: function init() {
	      if (this.$parent.ready && this.item == null) {
	        var self = this;
	
	        this.item = new google.maps.Polyline({
	          path: self.positions,
	          geodesic: true,
	          strokeColor: self.color,
	          strokeOpacity: 1.0,
	          strokeWeight: 2
	        });
	
	        this.item.setMap(this.getMap());
	      }
	    }
	  },
	  props: {
	    positions: {
	      type: Array,
	      required: true
	    },
	    color: {
	      type: String,
	      default: '#FF0000'
	    }
	  }
	};

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _GoogleMapChildren = __webpack_require__(103);
	
	var _GoogleMapChildren2 = _interopRequireDefault(_GoogleMapChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GoogleMapSearchBox',
	  extends: _GoogleMapChildren2.default,
	  data: function data() {
	    return {
	      searchBox: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (!this.embeddedOnMap && this.item == null) {
	      this.createGoogleMaps().then(function () {
	        _this.init();
	      });
	    }
	  },
	
	  methods: {
	    createGoogleMaps: function createGoogleMaps() {
	      var self = this;
	      return new _promise2.default(function (resolve, reject) {
	        if (document.getElementById('google-map-loader') === null) {
	          var gmap = document.createElement('script');
	          gmap.setAttribute('id', 'google-map-loader');
	          gmap.src = self.url;
	          gmap.type = 'text/javascript';
	          gmap.onload = resolve;
	          gmap.onerror = reject;
	          document.body.appendChild(gmap);
	        } else {
	          resolve();
	        }
	      });
	    },
	
	    init: function init() {
	      var _this2 = this;
	
	      var input = document.getElementById(this._uid + '-search-input');
	      var searchBox = new google.maps.places.SearchBox(input);
	      if (this.embeddedOnMap) {
	        this.getMap().controls[google.maps.ControlPosition.TOP_LEFT].push(input);
	        this.getMap().addListener('bounds_changed', function () {
	          searchBox.setBounds(_this2.getMap().getBounds());
	        });
	      }
	      searchBox.addListener('places_changed', function () {
	        var place = searchBox.getPlaces()[0];
	        _this2.$emit('placesChanged', place);
	      });
	    }
	  },
	  props: {
	    embeddedOnMap: {
	      type: Boolean,
	      default: false
	    },
	    apiKey: {
	      type: String
	    }
	  },
	  computed: {
	    url: function url() {
	      return this.proxyUrl && this.proxyUrl !== '' ? this.proxyUrl : 'https://maps.googleapis.com/maps/api/js?key=' + window.env.GOOGLE_MAPS_KEY + '&libraries=places,visualization';
	    }
	  }
	};

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _main = __webpack_require__(240);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _vuex = __webpack_require__(10);
	
	var _OffCanvas = __webpack_require__(2016);
	
	var _OffCanvas2 = _interopRequireDefault(_OffCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Backoffice',
	  components: {
	    OffCanvas: _OffCanvas2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    userStore: function userStore(state) {
	      return state.userStore;
	    }
	  }), {
	    title: function title() {
	      if (window && window.env.WHITELABEL_MODE === 'on') {
	        return "";
	      }
	      return 'PLAYMOOVE BOOKING SYSTEM ' + window.env.RELEASE + ' @ ' + window.env.API_URL;
	    },
	    user: function user() {
	      return this.userStore.user;
	    },
	    menu: function menu() {
	      var _this = this;
	
	      var routes = _main2.default[1].children.map(function (i) {
	        var hasPermission = function hasPermission(menu) {
	          if (_this.userIsRoot) {
	            return true;
	          }
	          var permission = '_menu_' + menu;
	          var allowed = _this.menuPermissions.find(function (item) {
	            return item.name === permission;
	          });
	          return allowed !== undefined && allowed.name === permission;
	        };
	
	        var hideInMenu = hasPermission(i.path);
	        return !hideInMenu ? false : {
	          path: i.path,
	          name: i.meta.path ? i.meta.path : i.name,
	          display_name: i.meta && i.meta.breadcrumb ? i.meta.breadcrumb : 'NO NAME',
	          childrens: i.children ? i.children.map(function (i2) {
	            return !hasPermission(i.path + '_' + i2.path) || !i2.meta || i2.meta.hideInMenu ? false : {
	              path: i2.path,
	              name: i2.meta.path ? i2.meta.path : i2.name,
	              display_name: i2.meta && i2.meta.breadcrumb ? i2.meta.breadcrumb : 'NO NAME'
	            };
	          }).filter(function (item) {
	            return item;
	          }) : null
	        };
	      }).filter(function (item) {
	        return item;
	      });
	
	      return routes;
	    },
	    userIsRoot: function userIsRoot() {
	      var role = this.userStore.user.roles.find(function (item) {
	        return item.name === 'ROOT';
	      });
	      return role !== undefined && role.name === 'ROOT';
	    },
	    userPermissions: function userPermissions() {
	      var permissions = this.userStore.user.roles.flatMap(function (item) {
	        return item.permissions;
	      });
	      return permissions;
	    },
	    menuPermissions: function menuPermissions() {
	      var menuPermissions = this.userPermissions.filter(function (item) {
	        return item.name.startsWith('_menu_');
	      });
	      return menuPermissions;
	    },
	
	
	    action: function action() {
	      return this.$route.meta.action;
	    }
	  })
	};

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "HwSim",
	  mounted: function mounted() {
	    this.updateReservation();
	    this.poolStart();
	  },
	  data: function data() {
	    return {
	      serial: 'MAN002',
	      fuel_level: 100,
	
	      ignition: null,
	      trip_start: null,
	      trip_end: null,
	      trip_distance: 100,
	
	      ignition_status: false,
	      door_status: false,
	
	      loading: false,
	      running: false,
	      clientOnBoard: false,
	
	      reservation: null,
	      pooler: null
	    };
	  },
	
	  methods: {
	    toggleDoors: function toggleDoors() {
	      var _this = this;
	
	      if (this.serial && this.serial.length > 5) {
	        var stat = !this.door_status ? "UNLOCKED" : "LOCKED";
	        _backoffice2.default.hooks.manual({
	          serial: this.serial,
	          ignition: this.ignition_status ? "RUNNING" : "NOT_RUNNING",
	          fuel_level: this.fuel_level,
	          door_status: stat
	        }, function () {
	          _this.door_status = !_this.door_status;
	        });
	      }
	    },
	    toggleIgnition: function toggleIgnition() {
	      var _this2 = this;
	
	      if (this.serial && this.serial.length > 5) {
	        var stat = !this.ignition_status ? "RUNNING" : "NOT_RUNNING";
	        _backoffice2.default.hooks.manual({
	          serial: this.serial,
	          door_status: this.door_status ? "UNLOCKED" : "LOCKED",
	          fuel_level: this.fuel_level,
	          ignition: stat
	        }, function (data) {
	          _this2.ignition_status = !_this2.ignition_status;
	        });
	      }
	    },
	    sendTrip: function sendTrip() {
	      var _this3 = this;
	
	      if (this.readyToSend) {
	        this.loading = true;
	        var body = {
	          serial: this.serial,
	          fuel_level: this.fuel_level,
	          door_status: this.door_status,
	          ignition: this.ignition,
	          action: "NEW_TRIP",
	          action_data: {
	            trip_start: this.trip_start,
	            trip_end: this.trip_end,
	            trip_distance: this.trip_distance
	          }
	        };
	        _backoffice2.default.hooks.manual(body, function () {
	          _this3.loading = false;
	        });
	      }
	    },
	    updateReservation: function updateReservation() {
	      var _this4 = this;
	
	      _backoffice2.default.hooks.vehicleStatus(this.serial, function (data) {
	        _this4.reservation = data;
	        _this4.door_status = data.vehicle_status.doors === 'UNLOCKED';
	        _this4.ignition_status = data.vehicle_status.engine === 'RUNNING';
	      });
	    },
	    poolStart: function poolStart() {
	      var _this5 = this;
	
	      this.pooler = setTimeout(function () {
	        _this5.updateReservation();
	        _this5.poolStart();
	      }, 5000);
	    },
	    format: function format(date) {
	      var m = (0, _moment2.default)(date);
	      return {
	        date: m.format('DD MMMM YYYY'),
	        time: m.format('hh:mm')
	      };
	    }
	  },
	  computed: {
	    readyToSend: function readyToSend() {
	      return this.serial && this.serial.length > 5 && this.fuel_level && this.trip_distance;
	    }
	  }
	};

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Login = __webpack_require__(2014);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'LoginPage',
	  components: {
	    Login: _Login2.default
	
	  },
	  created: function created() {},
	
	  methods: {
	    tokenLogin: function tokenLogin() {
	      var token = prompt("insert token");
	      localStorage.setItem('backoffice-token', token);
	      window.location.href = '/';
	    },
	    loginHandler: function loginHandler(payload) {
	      var _this = this;
	
	      _backoffice2.default.login(payload, function (response) {
	        _this.$store.dispatch('login', response.operator).then(function (user) {
	          localStorage.setItem('backoffice-token', response.api_token);
	          window.location.href = '/';
	        });
	      });
	    }
	  },
	  data: function data() {
	    return {
	      error_message: null
	    };
	  },
	
	  computed: {
	    positiveLogo: function positiveLogo() {
	      if (window && window.env) {
	        return window.env.LOGO;
	      }
	    }
	  }
	};

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _AlarmListForm = __webpack_require__(2089);
	
	var _AlarmListForm2 = _interopRequireDefault(_AlarmListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Alarms',
	  components: {
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    AlarmListForm: _AlarmListForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(526),
	      headers: [''],
	      search: null
	    };
	  },
	
	
	  methods: {
	    setSearch: function setSearch(search) {
	      this.search = search;
	      console.log(this.search);
	
	      this.$refs.list.debouncedLoader();
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	
	      _backoffice2.default.alarms.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      }, function () {
	        return null;
	      }, this.search);
	    }
	  }
	};

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Accordion = __webpack_require__(86);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _AccordionItem = __webpack_require__(87);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _CreateParkingLot = __webpack_require__(211);
	
	var _CreateParkingLot2 = _interopRequireDefault(_CreateParkingLot);
	
	var _EditParkingGroup = __webpack_require__(575);
	
	var _EditParkingGroup2 = _interopRequireDefault(_EditParkingGroup);
	
	var _DeleteParkingGroup = __webpack_require__(574);
	
	var _DeleteParkingGroup2 = _interopRequireDefault(_DeleteParkingGroup);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _ParkingGroupButtons = __webpack_require__(2049);
	
	var _ParkingGroupButtons2 = _interopRequireDefault(_ParkingGroupButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AssetManagement',
	  components: {
	    ParkingGroupButtons: _ParkingGroupButtons2.default,
	    Dropdown: _Dropdown2.default,
	    DeleteParkingGroup: _DeleteParkingGroup2.default,
	    EditParkingGroup: _EditParkingGroup2.default,
	    CreateParkingLot: _CreateParkingLot2.default,
	    ModalReveal: _ModalReveal2.default,
	    BaseList: _BaseList2.default,
	    Accordion: _Accordion2.default,
	    AccordionItem: _AccordionItem2.default
	  },
	  data: function data() {
	    return {
	      parkingGroups: null,
	      parking_group: null,
	      parkingLots: {},
	      component: __webpack_require__(537),
	      search: {},
	      activeIndex: 0
	    };
	  },
	  created: function created() {
	    this.loadParkingGroups();
	  },
	
	  methods: {
	    loadParkingGroups: function loadParkingGroups() {
	      var _this = this;
	
	      var activeIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      _backoffice2.default.parkingGroups.list.allv3(function (data) {
	        _this.parkingGroups = data.items;
	        _this.setSearch(activeIndex, _this.parkingGroups[0]);
	      });
	    },
	    setSearch: function setSearch(index, parkingGroup) {
	      this.parking_group = parkingGroup;
	      this.activeIndex = index;
	      this.search = {
	        parking_group_id: parkingGroup.id
	      };
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      return _backoffice2.default.parkingGroups.select(this.parking_group).parkingLots({
	        per_page: resultsPerPage,
	        page_number: page
	      }, function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _Pagination = __webpack_require__(2018);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BaseList',
	  components: {
	    LoadingSpinner: _LoadingSpinner2.default,
	    Pagination: _Pagination2.default,
	    EventBus: _eventBus.EventBus
	  },
	  data: function data() {
	    return {
	      selected: [],
	      data: [],
	      currentPage: 1,
	      debouncedLoader: null,
	      searchRange: null,
	      lastSearchRange: null,
	      resultsPerPageSelect: null,
	      selectAll: false
	    };
	  },
	  methods: {
	    setResultsPerPage: function setResultsPerPage() {
	      this.loadData(this.currentPage);
	    },
	    loadData: function loadData(page) {
	      var _this = this;
	
	      this.data = [];
	      this.currentPage = page;
	      this.$emit('pageChanged', { page: page, comp: this.$props.component.name });
	      var loader = this.dataLoader(function (data) {
	        _this.selectAll = false;
	        _this.data = data;
	      }, page, this.resultsPerPageSelect, this.search);
	      this.searchRange = (0, _assign2.default)({}, this.search);
	      if (typeof this.searchRangeDataLoader !== 'undefined') {
	
	        if (this.search === null || this.search.from === null || this.search.to === null) {
	          this.searchRange.start = this.$date().startOf('month').subtract(1, 'month').format('YYYY-MM-DD');
	          this.searchRange.end = this.$date().endOf('month').subtract(1, 'month').format('YYYY-MM-DD');
	        } else {
	          this.searchRange.start = this.search.from;
	          this.searchRange.end = this.search.to;
	        }
	
	        if (typeof this.searchRange.start === 'undefined') {
	          this.searchRange.start = this.$date().startOf('month').subtract(1, 'month').format('YYYY-MM-DD');
	        }
	
	        if (typeof this.searchRange.end === 'undefined') {
	          this.searchRange.end = this.$date().endOf('month').subtract(1, 'month').format('YYYY-MM-DD');
	        }
	
	        this.searchRangeDataLoader(this.searchRange);
	        this.lastSearchRange = (0, _assign2.default)({}, this.searchRange);
	      }
	      return loader;
	    },
	    checkboxChanged: function checkboxChanged(index, evt) {
	      if (evt.checked) {
	        this.selected.push(evt.value);
	      } else {
	        var position = this.selected.indexOf(evt.value);
	        this.selected.splice(position, 1);
	      }
	
	      this.$emit('input', this.selected);
	    },
	    selectAllCheckboxes: function selectAllCheckboxes() {
	      if (!this.selectAll === true) {
	        this.selected = this.data.items.map(function (item) {
	          return item.id;
	        });
	      } else {
	        this.selected = [];
	      }
	
	      this.$emit('input', this.selected);
	    }
	  },
	  destroyed: function destroyed() {
	    _eventBus.EventBus.$off('reload-list');
	  },
	  created: function created() {
	    var _this2 = this;
	
	    _eventBus.EventBus.$on('reload-list', function () {
	      _this2.loadData(1);
	    });
	
	    if (this.selectableList) {
	      this.selected = this.value;
	    }
	
	    this.resultsPerPageSelect = this.resultsPerPage;
	    this.debouncedLoader = this.$debounce(function () {
	      _this2.loadData(1);
	    }, 350);
	
	    this.debouncedLoader();
	  },
	
	  watch: {
	    search: {
	      handler: function handler(newVal, oldVal) {
	        this.debouncedLoader();
	      },
	      deep: true
	    }
	  },
	
	  props: {
	    component: {
	      type: Object,
	      required: true
	    },
	
	    componentType: {
	      type: String,
	      required: false,
	      default: 'listing'
	    },
	
	    dataLoader: {
	      type: Function,
	      required: true
	    },
	
	    search: {
	      type: Object,
	      required: false,
	      default: null
	    },
	
	    resultsPerPage: {
	      type: Number,
	      required: false,
	      default: 25 },
	
	    searchRangeDataLoader: {
	      type: Function,
	      required: false
	    },
	    showPerPageSelect: {
	      type: Boolean,
	      default: true
	    },
	    selectableList: {
	      type: Boolean,
	      default: false
	    },
	    value: {}
	  }
	};

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _CardListForm = __webpack_require__(2090);
	
	var _CardListForm2 = _interopRequireDefault(_CardListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CardList",
	  components: {
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    KeplerBackofficeSdk: _backoffice2.default,
	    CardListForm: _CardListForm2.default
	  },
	  data: function data() {
	    return {
	      headers: ['Card name & ID', 'Driver', 'Chip id', 'Active', 'id/uid'],
	      component: __webpack_require__(99),
	      search: null
	    };
	  },
	  methods: {
	    setSearch: function setSearch(search) {
	      this.search = search;
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      _backoffice2.default.cards.list(page, resultsPerPage, search).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _entries = __webpack_require__(94);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectionList = __webpack_require__(556);
	
	var _SelectionList2 = _interopRequireDefault(_SelectionList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Cargo",
	  components: {
	    SelectionList: _SelectionList2.default,
	    ActionButton: _ActionButton2.default,
	    KeplerFileUpload: _KeplerFileUpload2.default,
	    BaseList: _BaseList2.default,
	    ModalReveal: _ModalReveal2.default
	
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(186),
	
	      jsonOperation: "",
	      dataList: '',
	      attachmentToken: null,
	      jsonError: false,
	      voidContent: false,
	      spin: false,
	      disabled: false,
	      key: 0,
	
	      preset: "",
	
	      presets: {
	        "import_fuel_codes": {
	          "description": "Import fuel codes",
	          "cargo": {
	            "operation": "import",
	            "payload": {
	              "is_sync": false,
	              "import": {
	                "type": "fuel_codes",
	                "attachment_token": "@attachment_token:#attachment_token#@"
	              }
	            }
	          }
	        },
	        "fuel_codes_export": {
	          "description": "Get all fuel_codes usage data",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "fuel_codes"
	              }
	            }
	          }
	        },
	        "erogate_cashback_activity": {
	          "description": "Erogate cashback for period",
	          "cargo": {
	            "operation": "activity",
	            "payload": {
	              "is_sync": false,
	              "activity": {
	                "type": "cashback",
	                "params": {
	                  "dry": false,
	                  "month": "@CASHBACK-MONTH:#DATE_MONTH#@",
	                  "reason": "@CASHBACK-REASON:CASHBACK_#DATE_MONTH#@",
	                  "amount_remap": [{
	                    "min": 100,
	                    "to": 10
	                  }, {
	                    "min": 60,
	                    "to": 5
	                  }, {
	                    "min": 30,
	                    "to": 2
	                  }]
	                }
	              }
	            }
	          }
	        },
	        "perform_book_planning_activity": {
	          "description": "Book a specific vehicle for a period",
	          "cargo": {
	            "operation": "activity",
	            "payload": {
	              "is_sync": false,
	              "activity": {
	                "type": "book_planning",
	                "params": {
	                  "driver_id": 1,
	                  "plate": "@VEHICLE-PLATE:T787959C@",
	                  "plan_id": "@PLAN-ID:9@",
	                  "week_planning": ["#c2c2c2 MON|SAT 09:00 12:00"],
	                  "contract_duration": "@CONTRACT-DURATION:30@",
	                  "start_date": "@START-DATE:#START_DATE#@"
	                }
	              }
	            }
	          }
	        },
	        "bonus_export": {
	          "description": "Get all bonus usage data",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "bonus",
	                "params": {
	                  "bonus_name": "@BONUS-NAME@",
	                  "type": "@TYPE:USE@"
	                }
	              }
	            }
	          }
	        },
	        "invoices_export": {
	          "description": "Get all invoices data inclusive of sdi status",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "invoices",
	                "params": {}
	              }
	            }
	          }
	        },
	        "invoices_not_paid_export": {
	          "description": "Get all invoices data inclusive of sdi status",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "invoices_not_paid",
	                "params": {}
	              }
	            }
	          }
	        },
	        "transactions_export": {
	          "description": "Get transactions data inclusive of uid",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "transations",
	                "params": {}
	              }
	            }
	          }
	        },
	        "coupons_export": {
	          "description": "Get used coupons and its users",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "coupons",
	                "params": {
	                  "common_cost_id": "@COMMON_COST_ID:49@"
	                }
	              }
	            }
	          }
	        },
	        "clients_export": {
	          "description": "All clients in given periods",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "clients",
	                "params": {}
	              }
	            }
	          }
	        },
	        "clients_with_status_export": {
	          "description": "All clients in given periods having a specific status|statuses comma separated",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "clients",
	                "params": {
	                  "status": "@STATUS:ACTIVE@"
	                }
	              }
	            }
	          }
	        },
	        "mail_chimp_drivers_export": {
	          "description": "Driver with a particular status|statuses and|or client type can be extracted by configuring status and client_type.",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "type": "mail_chimp_drivers",
	                "params": {
	                  "status": "@STATUS:ACTIVE@",
	                  "client_type": "@CLIENT_TYPE:PRIVATE@"
	                }
	              }
	            }
	          }
	        },
	        "drivers_export": {
	          "description": "Get only basic info or tocs accepted info and|or plan subscribed by configuring 'tocs_id' and|or plan_id params",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "drivers",
	                "params": {
	                  "toc_id": "@TOCS_ID:13@",
	                  "plan_id": "@PLAN_ID:29@"
	                }
	              }
	            }
	          }
	        },
	        "driver_reservation_requests_export": {
	          "description": "Get driver booking request info, like booking_request_received_date_time, booking_request_status, booking_request_from_user",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "driver_reservation_requests",
	                "params": {}
	              }
	            }
	          }
	        },
	        "reservation_simple_export": {
	          "description": "Get basic reservation info",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "reservations_simple",
	                "params": {}
	              }
	            }
	          }
	        },
	        "reservation_export": {
	          "description": "Get complete reservation info like detailed cost,plan related,travel info and more",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "reservations",
	                "params": {}
	              }
	            }
	          }
	        },
	        "reservation_filtered_export": {
	          "description": "Get complete reservation info. Reservations can be also filtered by setting (all,one or some) parameters",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "reservations",
	                "params": {
	                  "id": "@ID:0@",
	                  "status": "@STATUS:ACTIVE@",
	                  "billing_status": "@BILLING_STATUS:CHARGED@",
	                  "booking_mode": "@BOOKING_MODE:FF@",
	                  "maintenance": "@MAINTENANCE:true@",
	                  "flag": "@FLAG@",
	                  "vehicle_plate": "@VEHICLE_PLATE:PC12345@",
	                  "vehicle_type": "@VEHICLE_TYPE:car@",
	                  "vehicle_slot_id": "@VEHICLE_SLOT_ID:0@",
	                  "driver_id": "@DRIVER_ID:0@"
	                }
	              }
	            }
	          }
	        },
	        "vehicles_export": {
	          "description": "Get basic reservation info",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "vehicles",
	                "params": {}
	              }
	            }
	          }
	        },
	        "vehicles_archived_export": {
	          "description": "Get basic reservation info. Get archived vehicle by setting 'archived' params",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "vehicles",
	                "params": {
	                  "archived": "archived"
	                }
	              }
	            }
	          }
	        },
	        "vehicle_slot_periods_export": {
	          "description": "Get info about status enabled duration in minutes",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "vehicles_slot_periods",
	                "params": {}
	              }
	            }
	          }
	        },
	        "vehicle_position_log_export": {
	          "description": "Get info about vehicle position with reverse geocode",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	
	                "type": "vehicle_position_log",
	                "params": {
	                  "plate": "@VEHICLE-PLATE:@",
	                  "start": "@START_DATE:@",
	                  "end": "@END_DATE:@"
	                }
	              }
	            }
	          }
	        },
	        "vehicles_reservations_export": {
	          "description": "Get vehicle reserved_charged_time_hours and vehicle trip_charged_time_hours in period",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "vehicles_reservations",
	                "params": {}
	              }
	            }
	          }
	        },
	        "vehicle_charging_time_export": {
	          "description": "Get info about pre-charge and post-charge level, duration recharge and when vehicle has been recharged",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "vehicle_charging_time",
	                "params": {
	                  "vehicle_type": "@VEHICLE_TYPE:car@",
	                  "parking_group_name": "@PARKING_GROUP_NAME:MAINTENANCE@"
	                }
	              }
	            }
	          }
	        },
	        "reporting_export": {
	          "description": "Get reporting list in period. Reporting can be also filtered by setting status",
	          "cargo": {
	            "operation": "export",
	            "payload": {
	              "is_sync": false,
	              "export": {
	                "start": "@START_DATE:#START_DATE#@",
	                "end": "@END_DATE:#END_DATE#@",
	                "type": "reporting",
	                "params": {
	                  "status": "@STATUS:PENDING_REVIEW@"
	                }
	              }
	            }
	          }
	        },
	        "perform_reservation_report_activity": {
	          "description": "Reservation report with driver data document",
	          "cargo": {
	            "operation": "activity",
	            "payload": {
	              "is_sync": false,
	              "activity": {
	                "type": "reservation_report",
	                "params": {
	                  "text": "<p>Insert text you want</p>",
	                  "recipient_info": ["Insert info"],
	                  "document_info": [{
	                    "title": "ID",
	                    "value": "reservation id"
	                  }],
	                  "header_info": [{
	                    "title": "Insert a title",
	                    "value": "Insert text"
	                  }],
	                  "prev_next_reservations": 0
	                }
	              }
	            }
	          }
	        }
	      }
	    };
	  },
	
	  watch: {
	
	    jsonOperation: function jsonOperation(newValue) {
	      this.jsonOperation = newValue;
	    }
	
	  },
	  mounted: function mounted() {
	    this.dataLoader();
	    this.preset = "";
	  },
	
	  methods: {
	    usePreset: function usePreset(event) {
	      var tmpContent = (0, _stringify2.default)(this.presets[this.preset].cargo, null, 2);
	
	      var matches = tmpContent.match(/#[A-Za-z0-9-_:#]+#/g);
	
	      var today = new Date(),
	          year = today.getFullYear(),
	          tempMonth = today.getMonth() + 1;
	      var lastDayTemp = new Date(year, tempMonth, 0);
	      var month = tempMonth < 10 && tempMonth > 0 ? "0" + tempMonth : tempMonth;
	
	      var yearMonth = year + "-" + month;
	      var firstDay = yearMonth + "-" + "01";
	      var lastDay = yearMonth + "-" + lastDayTemp.getDate();
	
	      if (matches) {
	        matches.forEach(function (r) {
	          var v = void 0;
	          switch (r) {
	            case "#START_DATE#":
	              v = firstDay;
	              break;
	            case "#END_DATE#":
	              v = lastDay;
	              break;
	            case "#DATE_MONTH#":
	              v = yearMonth;
	              break;
	            default:
	              v = "undefined";
	          }
	          tmpContent = tmpContent.replace(r, v);
	        });
	      }
	
	      matches = tmpContent.match(/@[A-Za-z0-9-_:#]+@/g);
	
	      if (matches) {
	        matches.forEach(function (r) {
	          var r2 = r.replaceAll("@", "");
	          var sp = r2.split(":");
	          var v = prompt("VALUE FOR " + sp[0] + "?", sp[1]);
	          tmpContent = tmpContent.replace(r, v);
	        });
	      }
	      this.jsonOperation = tmpContent;
	    },
	    changeContent: function changeContent(event) {
	      console.log(event.target.value);
	      if (!this.isJson(event.target.value)) {
	        _maggieHelper2.default.notification('Operation esit', 'Insert json text', 'alert');
	        this.jsonError = false;
	      } else {
	        this.jsonError = true;
	      }
	    },
	    closeInput: function closeInput(event) {
	      if (!event) {
	        this.jsonOperation = '';
	        this.attachmentToken = '';
	        this.key++;
	      }
	    },
	    doOperation: function doOperation() {
	      var _this = this;
	
	      if (!this.isJson(this.jsonOperation)) {
	        _maggieHelper2.default.notification('Operation esit', 'Insert json text', 'alert');
	        this.operationError = true;
	        return _promise2.default.resolve();
	      }
	      return _backoffice2.default.cargo.cargoOperationCreate(JSON.parse(this.jsonOperation), function (data) {
	        _this.$refs.list.loadData(1);
	        _this.jsonOperation = '';
	        _this.attachmentToken = '';
	        _this.key++;
	        _this.$refs.modalOperation.close();
	
	        var p = (0, _entries2.default)(data);
	        _maggieHelper2.default.notification('Operation id', p[0], 'success');
	      });
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      return _backoffice2.default.cargo.operationList(1, 25, function (data) {
	        callback(data);
	      });
	    },
	    handleFile: function handleFile(path) {
	      var _this2 = this;
	
	      this.spin = true;
	      if (!this.isJson(this.jsonOperation)) {
	        this.jsonOperation = (0, _stringify2.default)({});
	        this.voidContent = true;
	      }
	      var self = this;
	      var file = this.$refs.file.files[0];
	
	      _backoffice2.default.cargo.import(file, function (data) {
	        self.response = data;
	        _maggieHelper2.default.notification('upload', 'File uploaded successfully');
	        _this2.spin = false;
	        var jsonObj = JSON.parse(self.jsonOperation);
	
	        if ((0, _keys2.default)(jsonObj).length === 0 || self.voidContent) {
	
	          jsonObj = {
	            "operation": "import",
	            "payload": {
	              "import": {
	                "attachment_token": ""
	              }
	            }
	          };
	        }
	        jsonObj.payload.import.attachment_token = self.response.token;
	        self.jsonOperation = (0, _stringify2.default)(jsonObj);
	        self.voidContent = false;
	      });
	    },
	    isJson: function isJson(str) {
	      try {
	        var obj = JSON.parse(str);
	        if (obj && typeof obj === "object") {
	          return true;
	        }
	      } catch (err) {
	        return false;
	      }
	      return false;
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _eventBus = __webpack_require__(15);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CashInPreauthReveal',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      body: {
	        amount: this.preauth.amount,
	        reason: null,
	        tax: null
	      }
	
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.preauth.select(this.preauth.id).cashIn(this.body, function () {
	        _maggieHelper2.default.notification('', 'preauth created');
	        _eventBus.EventBus.$emit('reload-list');
	        _this.$refs[_this.componentId].close();
	      });
	    }
	  },
	  computed: (0, _extends3.default)({
	    componentId: function componentId() {
	      return 'cashInReveal-' + this._uid;
	    }
	  }, (0, _vuex.mapState)({
	    vats: function vats(state) {
	      return state.configuration.vats;
	    },
	    commonCostTypes: function commonCostTypes(state) {
	      return state.configuration.commonCostTypes;
	    }
	  })),
	  props: {
	    preauth: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _EditVehicleCategory = __webpack_require__(2067);
	
	var _EditVehicleCategory2 = _interopRequireDefault(_EditVehicleCategory);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _RequirementModal = __webpack_require__(2053);
	
	var _RequirementModal2 = _interopRequireDefault(_RequirementModal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CategoryList",
	  components: {
	    ActionButton: _ActionButton2.default,
	    RequirementModal: _RequirementModal2.default,
	    Dropdown: _Dropdown2.default,
	    EditVehicleCategory: _EditVehicleCategory2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      categories: [],
	      activeIndex: null,
	      search: null,
	      emptyList: true,
	      component: __webpack_require__(20)
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicleCategories.list(function (data) {
	      _this.categories = data;
	      _this.setSearch(0);
	    });
	  },
	
	  methods: {
	    setSearch: function setSearch(index) {
	
	      if (this.activeIndex === index) {
	        return;
	      }
	      this.activeIndex = index;
	      this.search = {
	        vehicle_category_id: this.categories[index].id
	      };
	    },
	    deleteCategory: function deleteCategory() {
	      return _backoffice2.default.vehicleCategories.select(this.categories[this.activeIndex].id).remove(function (data) {
	        _maggieHelper2.default.notification('category', data.result_code);
	      });
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      var _this2 = this;
	
	      _backoffice2.default.vehicles.list(page, resultsPerPage).all(search, function (items) {
	        _this2.emptyList = items.items_count === 0;
	        callback(items);
	      });
	    }
	  }
	};

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ChargingSessionReveal',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      port_id: null,
	      reservation_id: null
	    };
	  },
	  created: function created() {
	    if (this.reservation !== null) {
	      this.reservation_id = this.reservation.id;
	    }
	  },
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.chargingSessions.make({
	        port_id: this.port_id,
	        reservation_id: this.reservation_id
	      }, function () {
	        _maggieHelper2.default.notification('', 'charging session created');
	
	        _this.$refs[_this.componentId].close();
	      });
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return 'chargeReveal-' + this._uid;
	    }
	  },
	  props: {
	    reservation: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ChargingSessionsList",
	  components: { BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(1900)
	    };
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	
	      var body = this.reservation ? { reservation_id: this.reservation.id } : null;
	      _backoffice2.default.chargingSessions.list(page, resultsPerPage, body).all(function (data) {
	        callback(data);
	      });
	    }
	  },
	  props: {
	    reservation: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SearchInputForm = __webpack_require__(125);
	
	var _SearchInputForm2 = _interopRequireDefault(_SearchInputForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _AccontStatusFilter = __webpack_require__(194);
	
	var _AccontStatusFilter2 = _interopRequireDefault(_AccontStatusFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientList',
	  components: {
	    AccontStatusFilter: _AccontStatusFilter2.default,
	    BaseList: _BaseList2.default,
	    SearchInputForm: _SearchInputForm2.default,
	    HeaderColumns: _HeaderColumns2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(53),
	      headers: [' ', 'Client Name/ID', 'Client Type', 'Address', 'Billing Address', 'Main Driver'],
	      search: {
	        status: 'ON HOLD',
	        order_field: 'updated_at',
	        sort_order: 'desc',
	        query: null,
	        payment_method: 0,
	        document: 0,
	        subscription: 0
	      }
	    };
	  },
	  methods: {
	    setSearch: function setSearch(search) {
	      search.status = 'ON HOLD';
	      this.search = search;
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      _backoffice2.default.clients.list(page, resultsPerPage, search).approval(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _InputForm = __webpack_require__(123);
	
	var _InputForm2 = _interopRequireDefault(_InputForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _ClientListForm = __webpack_require__(2091);
	
	var _ClientListForm2 = _interopRequireDefault(_ClientListForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientList',
	  components: {
	    ClientListForm: _ClientListForm2.default,
	    Cards: _Cards2.default,
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    InputForm: _InputForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(53),
	      reports: null,
	      search: {
	        status: 'ACTIVE'
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    var start = this.$date().startOf('month').format('Y-MM-DD');
	    var end = this.$date().endOf('month').format('Y-MM-DD');
	    _backoffice2.default.reports.list({ start: start, end: end }).clients(function (data) {
	      _this.reports = data;
	    });
	  },
	
	  methods: {
	    setSearch: function setSearch(search) {
	      this.search = search;
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      if (search && (search.query || search.balance)) {
	        if (this.$isset(search.query)) {
	          _backoffice2.default.clients.list(page, resultsPerPage, search).search(function (items) {
	            callback(items);
	          });
	        }
	      } else {
	        _backoffice2.default.clients.list(page, resultsPerPage, search).all(function (data) {
	          callback(data);
	        });
	      }
	    },
	    getReports: function getReports(range) {
	      var _this2 = this;
	
	      this.reports = null;
	      _backoffice2.default.reports.list(range).clients(function (data) {
	        _this2.reports = data;
	      });
	    }
	  },
	  computed: {
	    parsedReports: function parsedReports() {
	      if (!this.reports) {
	        return [];
	      }
	
	      return [{
	        title: 'Active clients',
	        value: this.reports.total_active_clients
	      }, {
	        title: 'On hold clients',
	        value: this.reports.total_on_hold_clients
	      }, {
	        title: 'Suspended clients',
	        value: this.reports.total_suspended_clients
	      }];
	    }
	  }
	};

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TocList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1902)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      _backoffice2.default.clientTypes.list().all(function (data) {
	        var clientTypes = {
	          current_page: 1,
	          current_page_count: 1,
	          items: [],
	          items_count: 10,
	          page_count: 1,
	          per_page_count: 25
	        };
	
	        clientTypes.items = data.clientTypes;
	        clientTypes.items_count = clientTypes.items.length;
	        callback(clientTypes);
	      });
	    }
	  }
	};

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _SelectionList = __webpack_require__(556);
	
	var _SelectionList2 = _interopRequireDefault(_SelectionList);
	
	var _Operations = __webpack_require__(229);
	
	var _Operations2 = _interopRequireDefault(_Operations);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CloneVehicle",
	  components: { SelectizeVehicle: _SelectizeVehicle2.default, Operations: _Operations2.default, SelectionList: _SelectionList2.default },
	  data: function data() {
	    return {
	      dataCsv: '',
	      eol: '\n',
	
	      sep: undefined,
	      headerColumn: [],
	      firstRow: [],
	      rows: [],
	      vehicle_id: null,
	      showCloneForm: false,
	      deletedCsvField: false,
	      clonedisabled: false,
	      import_type: 'clone_vehicle',
	      data: ''
	
	    };
	  },
	
	
	  watch: {
	    dataCsv: function dataCsv(newValue, oldValue) {
	      var _this = this;
	
	      this.getRows();
	
	      var max = 0;
	      if (this.rows.length > 0) {
	        var row = this.rows[0];
	        ['\t', ';', ','].forEach(function (x) {
	          var l = row.split(x).length;
	          if (l > max) {
	            max = l;
	            _this.sep = x;
	          }
	        });
	      }
	    }
	
	  },
	  methods: {
	    clone: function clone() {
	      var _this2 = this;
	
	      var duplicates = this.headerColumn.filter(function (e, i, a) {
	        return a.indexOf(e) !== i;
	      });
	
	      if (duplicates.length) {
	        alert('Please check for duplicates header: ' + duplicates);
	        return;
	      }
	      var choosen = this.headerColumn.filter(function (x) {
	        return x;
	      }).length;
	      if (choosen !== 3) {
	        alert('Please choose all headers mapping');
	        return;
	      }
	      var mappings = {};
	      this.headerColumn.forEach(function (x, idx) {
	        if (!!x) {
	          if (x === 'vin') {
	            mappings['attributes'] = { 'vin': idx };
	          } else {
	            mappings[x] = idx;
	          }
	        }
	      });
	
	      var config = {
	        'vehicle_id': this.vehicle_id,
	        'mappings': mappings,
	        'data': this.createDataString()
	      };
	      var body = {
	        'import_type': this.import_type,
	        config: config
	      };
	      this.clonedisabled = true;
	
	      _backoffice2.default.clone.cloneVehicle(body, function (data) {
	        alert((0, _stringify2.default)(data));
	        _this2.clonedisabled = false;
	      });
	      console.log(config);
	    },
	    createDataString: function createDataString() {
	      var _this3 = this;
	
	      var arrTmp = [];
	      this.rows.forEach(function (item) {
	        arrTmp.push(item.split(_this3.sep));
	      });
	
	      var arr = [];
	      arrTmp.forEach(function (i) {
	        arr.push(i.join('\t'));
	      });
	      this.data = arr.join('\n');
	      this.data = this.data + "\n";
	
	      return this.data;
	    },
	    updateTextArea: function updateTextArea(event) {
	      this.dataCsv = event.target.value;
	    },
	    setVehicle: function setVehicle(object) {
	      this.showCloneForm = true;
	      this.vehicle_id = object.id;
	    },
	    unsetVehicle: function unsetVehicle(object) {
	      this.showCloneForm = false;
	      this.vehicle_id = null;
	    },
	    getRows: function getRows() {
	      this.rows = this.dataCsv.replaceAll(' ', '').split(this.eol).filter(function (x) {
	        return x;
	      });
	    }
	  },
	
	  computed: {
	    firstRows: function firstRows() {
	      var _this4 = this;
	
	      this.getRows();
	      if (this.rows.length <= 0) {
	
	        return null;
	      }
	
	      if (this.deletedCsvField) this.rows = this.rows.slice(1);
	      var grid = [];
	      this.rows.slice(0, 3).forEach(function (s) {
	        grid.push(s.split(_this4.sep));
	      });
	      grid.push(new Array(grid[0].length).fill('...............'));
	      return grid;
	    }
	
	  }
	};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _CommonCostButtonModal = __webpack_require__(144);
	
	var _CommonCostButtonModal2 = _interopRequireDefault(_CommonCostButtonModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CommonCostList',
	  components: {
	    BaseList: _BaseList2.default,
	    CommonCostButtonModal: _CommonCostButtonModal2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1903)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	
	      _backoffice2.default.commonCosts.list().all(page, resultsPerPage, function (data) {
	        callback(data);
	      });
	    },
	    itemUpdated: function itemUpdated(op) {
	      if (op === 'added') {
	        this.$refs.list.loadData(1);
	      }
	    }
	  }
	};

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CommonCostTypeList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1904),
	      items: null
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      _backoffice2.default.commonCostType.list.all(1, 25, function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _InterventionRequestForm = __webpack_require__(119);
	
	var _InterventionRequestForm2 = _interopRequireDefault(_InterventionRequestForm);
	
	var _eventBus = __webpack_require__(15);
	
	var _MaintenanceRequestList = __webpack_require__(156);
	
	var _MaintenanceRequestList2 = _interopRequireDefault(_MaintenanceRequestList);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _CreateInterventionRequestReveal = __webpack_require__(153);
	
	var _CreateInterventionRequestReveal2 = _interopRequireDefault(_CreateInterventionRequestReveal);
	
	var _vuex = __webpack_require__(10);
	
	var _CreateSubInterventionRequestReveal = __webpack_require__(596);
	
	var _CreateSubInterventionRequestReveal2 = _interopRequireDefault(_CreateSubInterventionRequestReveal);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CompleteInterventionRequestReveal',
	  components: {
	    InputSwitch: _InputSwitch2.default,
	    CreateSubInterventionRequestReveal: _CreateSubInterventionRequestReveal2.default,
	    InterventionRequestReveal: _CreateInterventionRequestReveal2.default,
	    Vehicle: _Vehicle2.default,
	    MaintenanceRequestList: _MaintenanceRequestList2.default,
	    InterventionRequestForm: _InterventionRequestForm2.default,
	    SelectizeVehicle: _SelectizeVehicle2.default,
	    ActionButton: _ActionButton2.default,
	    ModalReveal: _ModalReveal2.default,
	    DatePicker: _DatePicker2.default
	  },
	  data: function data() {
	    return {
	      body: {
	        complete_all: false
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    save: function save() {
	      return _backoffice2.default.maintenanceRequest.select(this.request).complete(this.body, function () {
	        _maggieHelper2.default.notification('', 'maintenance request completed');
	        _eventBus.EventBus.$emit('reload-list');
	        _eventBus.EventBus.$emit('close-modal');
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: {
	    request: null,
	    open: false
	  }
	};

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Accordion = __webpack_require__(86);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _AccordionItem = __webpack_require__(87);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _ConfigurationItem = __webpack_require__(529);
	
	var _ConfigurationItem2 = _interopRequireDefault(_ConfigurationItem);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Configuration',
	  components: {
	    ConfigurationItem: _ConfigurationItem2.default,
	    Accordion: _Accordion2.default,
	    AccordionItem: _AccordionItem2.default
	  },
	  data: function data() {
	    return {
	      conf: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this.conf = data;
	    });
	  },
	
	  methods: {
	    updateItem: function updateItem(key, value) {
	      var _this2 = this;
	
	      _maggieHelper2.default.notification('Updating', 'Update sent', 'info');
	
	      _backoffice2.default.configuration.update(key, value, function (data) {
	        _this2.$store.dispatch('getConfiguration', true).then(function () {
	          _maggieHelper2.default.notification('Updated', 'Configuration updated', 'success');
	        });
	      }, function (e) {
	        _maggieHelper2.default.notification(e.result, e.result_code, 'alert');
	      });
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Console",
	  components: { LoadingSpinner: _LoadingSpinner2.default },
	  data: function data() {
	    return {
	      currentCommand: "",
	      consoleLog: ["     []  ,----.___\n", "   __||_/___      '. Welcome back to 1991\n", "  /  ||    /|       )\n", " /   \"\"   / /       \\_.= Loading Playmoove Core Console....\n", "/________/ /\n", "|________|/         /!\\ WARNING: SOME COMMANDS CAN AFFECT SYSTEM PERFORMANCE /!\\\n"],
	
	      isRunning: false,
	      availableCommands: null
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    _backoffice2.default.console.list(function (ok) {
	      self.availableCommands = ok;
	
	      self.pushCommand("\nConsole loaded: please enter your command in the field below");
	    }, function (error) {
	      console.error(error);
	    });
	  },
	
	  computed: {
	    hasPound: function hasPound() {
	      return this.currentCommand.includes("#");
	    }
	  },
	  methods: {
	    handleButtonPress: function handleButtonPress(c) {
	      this.currentCommand = c;
	      this.$refs.input.focus();
	    },
	    handleCommand: function handleCommand(event) {
	      this.runCommand(this.currentCommand);
	    },
	    pushCommand: function pushCommand(command) {
	      this.consoleLog.push(command + "\n");
	
	      var e = this.$refs.console;
	      this.$nextTick(function () {
	        e.scrollTop = e.scrollHeight;
	      });
	    },
	    runCommand: function runCommand(command) {
	      if (!this.isRunning) {
	        var self = this;
	        this.isRunning = true;
	
	        this.pushCommand('> ' + command);
	        var c = this.currentCommand;
	        this.currentCommand = '';
	
	        _backoffice2.default.console.run(c, function (ok) {
	          self.pushCommand(ok.response);
	
	          self.isRunning = false;
	        }, function (error) {
	          self.pushCommand("# ERROR " + error.response.status + ":");
	          self.pushCommand((0, _stringify2.default)(error.response.data, null, 2));
	          self.isRunning = false;
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CouponInUseList',
	  components: {
	    DateRangePicker: _DateRangePicker2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(530),
	      searchRequest: {
	        driver_id: '',
	        coupon_code: '',
	        from: '',
	        to: ''
	      },
	      search: null,
	      componentKey: 0,
	      pickerLabel: "Select created range",
	      options: null
	    };
	  },
	  mounted: function mounted() {
	    this.couponsLoader();
	  },
	
	
	  methods: {
	    couponsLoader: function couponsLoader(callback) {
	      var _this = this;
	
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	
	      _backoffice2.default.coupons.list(page, resultsPerPage).all(function (data) {
	        _this.options = data.items;
	      });
	    },
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	      var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.searchRequest;
	
	      _backoffice2.default.coupons.list(page, resultsPerPage, body).list(function (data) {
	        callback(data);
	      });
	
	      this.searchRequest = {
	        from: '',
	        to: ''
	      };
	    },
	    selectDriver: function selectDriver(obj) {
	      this.searchRequest.driver_id = obj.id;
	    },
	    unsetDriverId: function unsetDriverId() {
	      this.search.driver_id = null;
	    },
	    dateRangeSelected: function dateRangeSelected(range) {
	      this.searchRequest.from = range.start;
	      this.searchRequest.to = range.end;
	    },
	    searchFilter: function searchFilter() {
	      this.search = this.searchRequest;
	    }
	  }
	
	};

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CouponList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1905)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      return _backoffice2.default.coupons.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _StartEndTimePicker = __webpack_require__(128);
	
	var _StartEndTimePicker2 = _interopRequireDefault(_StartEndTimePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeCommonCost = __webpack_require__(71);
	
	var _SelectizeCommonCost2 = _interopRequireDefault(_SelectizeCommonCost);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CouponReveal',
	  components: { SelectizeCommonCost: _SelectizeCommonCost2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default, StartEndTimePicker: _StartEndTimePicker2.default, DatePicker: _DatePicker2.default },
	  data: function data() {
	    return {
	      type: 'Fixed',
	      body: {
	        code: null,
	        start: null,
	        end: null,
	        max_uses: null,
	        max_uses_per_driver: null,
	        max_days: null,
	        common_cost_id: null,
	        discount_rate: null
	      },
	      key: 0
	    };
	  },
	  created: function created() {
	    if (this.couponProp !== null) {
	      this.type = this.couponProp.common_cost === null ? 'Percentage' : 'Fixed';
	      for (var key in this.couponProp) {
	        if (key === 'common_cost' && this.couponProp[key] !== null) {
	          this.body.common_cost_id = this.couponProp.common_cost.id;
	        } else {
	          this.body[key] = this.couponProp[key];
	        }
	      }
	    }
	  },
	
	  methods: {
	    closeInput: function closeInput(event) {
	      if (!event) {
	        this.key++;
	      }
	    },
	    setCommonCost: function setCommonCost(obj) {
	      this.body.common_cost_id = obj.id;
	    },
	    save: function save() {
	      var _this = this;
	
	      if (this.couponProp === null) {
	        return _backoffice2.default.coupons.make(this.body, function () {
	          _maggieHelper2.default.notification('', 'coupon created');
	          _this.key++;
	          location.reload();
	          _this.$refs[_this.componentId].close();
	        });
	      }
	      if (this.body.discount_rate !== null && this.type === 'Percentage') {
	        this.body.common_cost_id = null;
	      } else {
	        this.body.discount_rate = null;
	      }
	
	      return _backoffice2.default.coupons.select(this.couponProp.id).edit(this.body, function (data) {
	        _maggieHelper2.default.notification('', 'coupon updated');
	        _this.$emit('itemUpdated');
	        _this.$refs[_this.componentId].close();
	      });
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return this.couponProp !== null ? 'voidReveal-' + this.couponProp.id : 'voidReveal-' + this._uid;
	    }
	  },
	  props: {
	    couponProp: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getOwnPropertyNames = __webpack_require__(164);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _CountryList = __webpack_require__(238);
	
	var _CountryList2 = _interopRequireDefault(_CountryList);
	
	var _AlertBox = __webpack_require__(2011);
	
	var _AlertBox2 = _interopRequireDefault(_AlertBox);
	
	var _Reveal = __webpack_require__(2019);
	
	var _Reveal2 = _interopRequireDefault(_Reveal);
	
	var _CreateDriverLicense = __webpack_require__(227);
	
	var _CreateDriverLicense2 = _interopRequireDefault(_CreateDriverLicense);
	
	var _SelectizeCountry = __webpack_require__(149);
	
	var _SelectizeCountry2 = _interopRequireDefault(_SelectizeCountry);
	
	var _ClientExtraFields = __webpack_require__(2022);
	
	var _ClientExtraFields2 = _interopRequireDefault(_ClientExtraFields);
	
	var _vuex = __webpack_require__(10);
	
	var _Tooltip = __webpack_require__(79);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeClientRegistration',
	  components: {
	    Tooltip: _Tooltip2.default,
	    ClientExtraFields: _ClientExtraFields2.default,
	    SelectizeCountry: _SelectizeCountry2.default,
	    BackofficeDriverLicenseCreate: _CreateDriverLicense2.default,
	    DatePicker: _DatePicker2.default,
	    Dropzone: _Dropzone2.default,
	    AlertBox: _AlertBox2.default,
	    Reveal: _Reveal2.default
	  },
	  data: function data() {
	    return {
	      address: true,
	      document: false,
	      clientTypes: [],
	      body: {
	        extra: {},
	        client_type_id: null,
	        name: null,
	        surname: null,
	        email: null,
	        mobile: null,
	        birthdate: null,
	        fiscal_code: null,
	        vat_number: null,
	        organization_name: null,
	        address: {
	          country: null,
	          region: null,
	          city: null,
	          postal_code: null,
	          street: null
	        },
	        billing_address: {
	          country: null,
	          region: null,
	          city: null,
	          postal_code: null,
	          street: null
	        },
	        accepted_tocs_id: []
	      }
	
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    countryList: function countryList() {
	      var list = [];
	      $.map(_CountryList2.default.countries, function (obj) {
	        list.push({ id: obj.name, text: obj.name });
	      });
	      return list;
	    },
	    isBusinessAccount: function isBusinessAccount() {
	      var _this = this;
	
	      var clientType = this.clientTypes.find(function (item) {
	        return item.id === _this.body.client_type_id;
	      });
	
	      return clientType && clientType.type === 'BUSINESS';
	    }
	  }),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.configuration.system.system_client_custom_fields.value.forEach(function (item) {
	      _this2.$set(_this2.body.extra, item.value, null);
	    });
	  },
	  created: function created() {
	    var _this3 = this;
	
	    _backoffice2.default.clientTypes.list(1, 1000, null).all(function (data) {
	      _this3.clientTypes = data.clientTypes;
	    });
	  },
	
	  methods: {
	    setAddressCountry: function setAddressCountry(country) {
	      this.body.address.country = country.name;
	    },
	    setBillingAddressCountry: function setBillingAddressCountry(country) {
	      this.body.billing_address.country = country.name;
	    },
	    setDriverLicenseFields: function setDriverLicenseFields(driverLicense) {
	      this.body.document = driverLicense;
	    },
	
	
	    uploaded: function uploaded(file, response) {
	      this.body.document.attachments.push(response.token);
	    },
	    formSubmit: function formSubmit(val) {
	      var _this4 = this;
	
	      if (this.document) {
	        var propNames = (0, _getOwnPropertyNames2.default)(this.body.document);
	        for (var i = 0; i < propNames.length; i++) {
	          var propName = propNames[i];
	          if (this.body.document[propName] === '' || this.body.document[propName] === null || this.body.document[propName] === undefined) {
	            delete this.body.document[propName];
	          }
	        }
	      } else {
	        delete this.body.document;
	      }
	
	      if (this.address) {
	        this.body.billing_address = this.body.address;
	      }
	
	      if (!this.isBusinessAccount) {
	        this.body.organization_name = this.body.name + ' ' + this.body.surname;
	      }
	
	      _backoffice2.default.clients.make(this.body, function (data) {
	        _this4.$router.push({ name: 'client', params: { id: data.client_id } });
	      });
	    }
	  }
	};

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreateCommonCostType",
	  components: {},
	  data: function data() {
	    return {
	      vehicleBrands: [],
	      showFileSelector: false,
	      body: {
	        name: '',
	        description: ''
	      }
	    };
	  },
	
	  methods: {
	    formSubmit: function formSubmit() {
	      var _this = this;
	
	      _backoffice2.default.commonCostType.make(this.body, function () {
	        _this.$router.push({ name: 'common-cost-types' });
	      });
	    }
	  }
	};

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getOwnPropertyNames = __webpack_require__(164);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _CreateDriverLicense = __webpack_require__(227);
	
	var _CreateDriverLicense2 = _interopRequireDefault(_CreateDriverLicense);
	
	var _SelectizeClient = __webpack_require__(89);
	
	var _SelectizeClient2 = _interopRequireDefault(_SelectizeClient);
	
	var _SelectizeCountry = __webpack_require__(149);
	
	var _SelectizeCountry2 = _interopRequireDefault(_SelectizeCountry);
	
	var _Tooltip = __webpack_require__(79);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeDriverCreate',
	  components: {
	    SearchEntity: _SearchEntity2.default,
	    SelectizeCountry: _SelectizeCountry2.default,
	    SelectizeClient: _SelectizeClient2.default,
	    BackofficeDriverLicenseCreate: _CreateDriverLicense2.default,
	    DatePicker: _DatePicker2.default,
	    Dropzone: _Dropzone2.default,
	    Tooltip: _Tooltip2.default
	  },
	  data: function data() {
	    return {
	      document: false,
	      body: {
	        client_id: null,
	        name: null,
	        title: null,
	        surname: null,
	        birthdate: null,
	        gender: null,
	        email: null,
	        mobile_phone: null,
	        address: {
	          country: null,
	          region: null,
	          city: null,
	          postal_code: null,
	          street: null
	        },
	        accepted_tocs_id: []
	      }
	
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {},
	
	  methods: {
	    selectCountry: function selectCountry(country) {
	      this.body.address.country = country.name;
	    },
	    selectLicenseCountry: function selectLicenseCountry(id) {
	      this.body.driver_license.issuer_country = id;
	    },
	    selectClientId: function selectClientId(client) {
	      this.body.client_id = client.id;
	    },
	    setDriverLicenseFields: function setDriverLicenseFields(driverLicense) {
	      this.body.document = driverLicense;
	    },
	    formSubmit: function formSubmit() {
	      var _this = this;
	
	      if (this.document) {
	        var propNames = (0, _getOwnPropertyNames2.default)(this.body.document);
	        for (var i = 0; i < propNames.length; i++) {
	          var propName = propNames[i];
	          if (this.body.document[propName] === '' || this.body.document[propName] === null || this.body.document[propName] === undefined) {
	            delete this.body.document[propName];
	          }
	        }
	      } else {
	        delete this.body.document;
	      }
	
	      _backoffice2.default.drivers.make(this.body, function (data) {
	        _this.$router.push({ name: 'driver', params: { id: data.id } });
	      });
	    }
	  }
	};

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _SelectizeCountry = __webpack_require__(149);
	
	var _SelectizeCountry2 = _interopRequireDefault(_SelectizeCountry);
	
	var _SelectizeDriverLicense = __webpack_require__(585);
	
	var _SelectizeDriverLicense2 = _interopRequireDefault(_SelectizeDriverLicense);
	
	var _SelectizeDocumentType = __webpack_require__(81);
	
	var _SelectizeDocumentType2 = _interopRequireDefault(_SelectizeDocumentType);
	
	var _Tooltip = __webpack_require__(79);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeDriverLicenseCreate',
	  components: {
	    SelectizeDocumentType: _SelectizeDocumentType2.default,
	    SelectizeDriverLicense: _SelectizeDriverLicense2.default,
	    SelectizeCountry: _SelectizeCountry2.default,
	    DatePicker: _DatePicker2.default,
	    Dropzone: _Dropzone2.default,
	    Tooltip: _Tooltip2.default
	  },
	  data: function data() {
	    return {
	      documentType: null,
	      dropzoneUrl: _backoffice2.default.getUrlForDropzone(),
	
	      document: {
	        document_type_id: null,
	        expiry_date: null,
	        issuer: null,
	        issuer_country: null,
	        issue_date: null,
	        number: null,
	        attachments: {}
	      }
	
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {
	    this.dropzoneUrl = _backoffice2.default.getUrlForDropzone();
	  },
	
	  methods: {
	    selectLicenseCountry: function selectLicenseCountry(country) {
	      this.document.issuer_country = country.name;
	      this.driverLicenseUpdated();
	    },
	    selectDocumentType: function selectDocumentType(document) {
	      this.document.document_type_id = document.id;
	      this.documentType = document;
	      this.driverLicenseUpdated();
	    },
	
	    uploaded: function uploaded(file, response, view) {
	      this.document.attachments[view] = response.token;
	      this.driverLicenseUpdated();
	    },
	    driverLicenseUpdated: function driverLicenseUpdated() {
	      this.$emit('driverLicenseUpdated', this.document);
	    }
	  }
	};

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _InstructionStep = __webpack_require__(2025);
	
	var _InstructionStep2 = _interopRequireDefault(_InstructionStep);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateInstruction',
	  components: { InstructionStep: _InstructionStep2.default, ActionBar: _ActionBar2.default, Editor: _Editor2.default, KeplerFileUpload: _KeplerFileUpload2.default },
	  data: function data() {
	    return {
	      instruction: {
	        title: null,
	        subtitle: null,
	        steps: [{
	          type: 'html',
	          value: ''
	        }]
	      }
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      _backoffice2.default.instructions.select(this.$route.params.id).get(function (data) {
	        _this.instruction = data;
	        _this.instruction.steps = data.steps.map(function (item) {
	          if (item.type === 'image' && item.value.split('|').length == 2) {
	            var value = item.value.split('|');
	            return { type: 'linked_image', image_url: value[0], image_link: value[1] };
	          }
	
	          return item;
	        });
	      });
	    }
	  },
	
	  methods: {
	    addStep: function addStep() {
	      this.instruction.steps.push({
	        type: 'html',
	        value: ''
	      });
	    },
	    removeStep: function removeStep(index) {
	      this.instruction.steps.splice(index, 1);
	    },
	    resetStep: function resetStep(index) {
	      this.instruction.steps[index].value = '';
	    },
	    saveInstruction: function saveInstruction() {
	      var _this2 = this;
	
	      this.instruction.steps = this.instruction.steps.map(function (item) {
	        if (item.type === 'linked_image') {
	          return { type: 'image', value: item.image_url + '|' + item.image_link };
	        }
	        return item;
	      });
	
	      if (this.$route.params.id) {
	        _backoffice2.default.instructions.select(this.$route.params.id).edit(this.instruction, function (data) {
	          _this2.instruction = data;
	          _maggieHelper2.default.notification('Edited', 'Instruction Edited');
	          _this2.$router.push({ name: 'instructions' });
	        });
	
	        return;
	      }
	      _backoffice2.default.instructions.make(this.instruction, function (data) {
	        _maggieHelper2.default.notification('Created', 'Instruction Created');
	        _this2.$router.push({ name: 'instructions' });
	      });
	    }
	  }
	};

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _eventBus = __webpack_require__(15);
	
	var _InterventionRequestForm = __webpack_require__(119);
	
	var _InterventionRequestForm2 = _interopRequireDefault(_InterventionRequestForm);
	
	var _DetailInterventionRequestReveal = __webpack_require__(599);
	
	var _DetailInterventionRequestReveal2 = _interopRequireDefault(_DetailInterventionRequestReveal);
	
	var _BookPanel = __webpack_require__(100);
	
	var _BookPanel2 = _interopRequireDefault(_BookPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateInterventionRequestReveal',
	  components: {
	    BookPanel: _BookPanel2.default,
	    DetailInterventionRequestReveal: _DetailInterventionRequestReveal2.default,
	    InterventionRequestForm: _InterventionRequestForm2.default, SelectizeVehicle: _SelectizeVehicle2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default, DatePicker: _DatePicker2.default
	  },
	  data: function data() {
	    return {
	      body: {
	        status: "NEW",
	        linked_intervention_request_id: null,
	        maintenance_driver_id: null,
	        vehicle_id: null,
	        priority: null,
	        type: [],
	        description: null,
	        start_at: null,
	        expiry: null,
	        disable_vehicle_slot: false,
	        create_reservation: false,
	        has_linked_requests: false
	      }
	    };
	  },
	
	  methods: {
	    check: function check() {
	      if (this.body.has_linked_requests) {
	        this.body.maintenance_driver_id = null;
	        this.body.expiry = null;
	        this.body.status = "NEW";
	      }
	    },
	    save: function save() {
	      return _backoffice2.default.maintenanceRequest.make(this.body, function () {
	        _maggieHelper2.default.notification('', 'maintenance request created');
	
	        _eventBus.EventBus.$emit('reload-list');
	        _eventBus.EventBus.$emit('close-modal');
	      });
	    },
	    close: function close(val) {
	      if (val !== false) {
	        return;
	      }
	      this.body = {
	        status: "NEW",
	        linked_intervention_request_id: null,
	        maintenance_driver_id: null,
	        vehicle_id: null,
	        priority: null,
	        type: [],
	        description: null,
	        start_at: null,
	        expiry: null,
	        disable_vehicle_slot: false,
	        has_linked_requests: false
	      };
	      _eventBus.EventBus.$emit('close-modal');
	    }
	  },
	  computed: {},
	  props: {
	    request: null
	  }
	};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _NoteForm = __webpack_require__(535);
	
	var _NoteForm2 = _interopRequireDefault(_NoteForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreateNote",
	  components: { NoteForm: _NoteForm2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      note: { description: null }
	    };
	  },
	
	  methods: {
	    createNote: function createNote(obj) {
	      var _this = this;
	
	      this.note.description = obj.description;
	      this.note.valid_from = obj.valid_from;
	      this.note.valid_to = obj.valid_to;
	
	      _backoffice2.default.notes.make(this.note, function () {
	        _maggieHelper2.default.notification('Note', 'Note created successfully');
	        _this.$router.push({ path: 'assets', name: 'notes-management' });
	      });
	    }
	  },
	  computed: {
	    isEntityNote: function isEntityNote() {
	      return this.entity && this.entityId;
	    }
	  },
	  props: {
	    entity: {
	      type: String,
	      required: false
	    },
	    entityId: {
	      type: Number,
	      required: false
	    }
	  }
	};

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _NoteForm = __webpack_require__(535);
	
	var _NoteForm2 = _interopRequireDefault(_NoteForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateNoteModal',
	  components: { NoteForm: _NoteForm2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      note: { description: null }
	    };
	  },
	
	  methods: {
	    createNote: function createNote(obj) {
	      var _this = this;
	
	      this.note.description = obj.description;
	      this.note.valid_from = obj.valid_from;
	      this.note.valid_to = obj.valid_to;
	      this.note.type = this.entity;
	      this.note.id = this.entityId;
	
	      _backoffice2.default.notes.make(this.note, function () {
	        _maggieHelper2.default.notification('Note', 'Note created successfully');
	        _this.$refs.modalAddNote.close();
	        _this.$emit('noteCreated');
	      });
	    }
	  },
	  computed: {
	    isEntityNote: function isEntityNote() {
	      return this.entity && this.entityId;
	    }
	  },
	  props: {
	    entity: {
	      type: String,
	      required: false
	    },
	    entityId: {
	      required: false
	    }
	  }
	};

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _vuex = __webpack_require__(10);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PageReveal',
	  components: { Editor: _Editor2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      langs: [],
	      body: {
	        title: null,
	        content: "",
	        button_labels: null,
	        action: "",
	        slug: ""
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.pages.make(this.body, function () {
	        _maggieHelper2.default.notification('page', 'page created');
	        _eventBus.EventBus.$emit('reload-list');
	        _this.$refs[_this.componentId].close();
	      });
	    }
	  },
	  computed: (0, _extends3.default)({
	    componentId: function componentId() {
	      return 'pageReveal-' + this._uid;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: {
	    item: {}
	  }
	};

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlanSetup = __webpack_require__(553);
	
	var _PlanSetup2 = _interopRequireDefault(_PlanSetup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreatePlan",
	  components: { PlanSetup: _PlanSetup2.default },
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {},
	
	  methods: {}
	};

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _VehicleDamage = __webpack_require__(138);
	
	var _VehicleDamage2 = _interopRequireDefault(_VehicleDamage);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeCreateReporting',
	  components: {
	    SelectizeDriver: _SelectizeDriver2.default,
	    SelectizeVehicle: _SelectizeVehicle2.default,
	    VehicleDamage: _VehicleDamage2.default,
	    Dropzone: _Dropzone2.default
	  },
	  data: function data() {
	    return {
	      reportingTypes: [],
	      pins: [],
	      showVehicleSelect: null,
	      body: {
	        damage_position_raw: [],
	        reporting_type_id: null,
	        vehicle_id: null,
	        status: null,
	        description: null,
	        attachments: []
	      },
	      damageReport: false,
	      dropzoneUrl: _backoffice2.default.getUrlForDropzone(),
	      vehicleType: null,
	      category: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.selects.reportingTypes(function (data) {
	      _this.reportingTypes = data;
	    });
	    if (this.$route.params.vehicleId) {
	      this.body.vehicle_id = this.$route.params.vehicleId;
	    }
	  },
	
	  methods: {
	    updateDamages: function updateDamages(pins) {
	      this.body.damage_position_raw = pins;
	    },
	    driverSelected: function driverSelected(driver) {
	      this.body.driver_id = driver.id;
	    },
	    vehicleSelected: function vehicleSelected(vehicle) {
	      var _this2 = this;
	
	      this.body.vehicle_id = vehicle.id;
	      _backoffice2.default.vehicles.select(vehicle.id).get(function (data) {
	        _this2.vehicleType = data.category.vehicle_type.name;
	        _this2.category = data.category;
	      });
	    },
	    isDamageReport: function isDamageReport() {
	      var damageReportId = this.configuration.application.application_damage_report_id.value;
	      this.damageReport = this.body.reporting_type_id === damageReportId;
	    },
	
	    uploaded: function uploaded(file, response) {
	      this.body.attachments.push(response.token);
	    },
	    submit: function submit() {
	      var _this3 = this;
	
	      if (this.item) {
	        if (this.body.driver_id == '') {
	          this.body.driver_id = null;
	        }
	
	        _backoffice2.default.reportings.select(this.$route.params.id).edit(this.body, function (data) {
	          _this3.$router.push({ name: 'reporting', params: { id: data.id } });
	        });
	      } else {
	        _backoffice2.default.reportings.make(this.body.vehicle_id, this.body, function (data) {
	          _this3.$router.push({ name: 'reporting', params: { id: data.id } });
	        });
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: ['item']
	};

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _InterventionRequestForm = __webpack_require__(119);
	
	var _InterventionRequestForm2 = _interopRequireDefault(_InterventionRequestForm);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateSubInterventionRequestReveal',
	  components: { InterventionRequestForm: _InterventionRequestForm2.default, SelectizeVehicle: _SelectizeVehicle2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default, DatePicker: _DatePicker2.default },
	  data: function data() {
	    return {
	      body: {}
	    };
	  },
	
	  methods: {
	    save: function save() {
	      return _backoffice2.default.maintenanceRequest.make(this.body, function () {
	        _eventBus.EventBus.$emit('reload-list');
	        _eventBus.EventBus.$emit('close-modal');
	      });
	    },
	    open: function open() {
	      this.body = {
	        status: null,
	        linked_intervention_request_id: this.request.linked_intervention_request_id,
	        vehicle_id: this.request.vehicle_id,
	        maintenance_driver_id: null,
	        priority: null,
	        type: [],
	        description: null,
	        expiry: null,
	        has_linked_requests: false,
	        disable_vehicle_slot: false
	      };
	    },
	    close: function close(val) {
	      _eventBus.EventBus.$emit('close-modal');
	    }
	  },
	  computed: {},
	  props: {
	    request: null
	  }
	};

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SelectizeTocType = __webpack_require__(590);
	
	var _SelectizeTocType2 = _interopRequireDefault(_SelectizeTocType);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _MdiIcon = __webpack_require__(80);
	
	var _MdiIcon2 = _interopRequireDefault(_MdiIcon);
	
	var _TocAttachmentTranslationReveal = __webpack_require__(2080);
	
	var _TocAttachmentTranslationReveal2 = _interopRequireDefault(_TocAttachmentTranslationReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateToc',
	  components: {
	    TocAttachmentTranslationReveal: _TocAttachmentTranslationReveal2.default,
	    MdiIcon: _MdiIcon2.default, ModalReveal: _ModalReveal2.default, TranslateField: _TranslateField2.default, Editor: _Editor2.default, KeplerFileUpload: _KeplerFileUpload2.default, SelectizeTocType: _SelectizeTocType2.default, DatePicker: _DatePicker2.default
	  },
	  data: function data() {
	    return {
	      toc: {
	        id: null,
	        content: '',
	        required_from: null,
	        link: null,
	        attachment: null,
	        attachment_translations: {},
	        name: null,
	        acceptance_statement: null,
	        version: null,
	        optional: 0,
	        priority: 0,
	        toc_type: {
	          id: 1,
	          name: null,
	          group: null,
	          priority: 0,
	          uid: null
	        },
	        disabled: false
	      }
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      this.toc = null;
	      _backoffice2.default.tocs.select(this.$route.params.id).get(function (data) {
	        _this.toc = (0, _assign2.default)({}, data);
	        _this.toc.toc_type_id = data.toc_type_id;
	      });
	    }
	  },
	
	  methods: {
	    setTocType: function setTocType(obj) {
	      this.toc.toc_type_id = obj.id;
	    },
	    createToc: function createToc() {
	      var _this2 = this;
	
	      if (this.$route.params.id) {
	        _backoffice2.default.tocs.select(this.toc.id).edit(this.toc, function (data) {
	          _maggieHelper2.default.notification('edited', 'Toc edited successfully');
	          _this2.$router.push({ name: 'tocs' });
	        });
	      } else {
	        _backoffice2.default.tocs.make(this.toc, function (data) {
	          _maggieHelper2.default.notification('created', 'Toc created successfully');
	          _this2.$router.push({ name: 'tocs' });
	        });
	      }
	    },
	    handleFileSelector: function handleFileSelector(path) {
	      this.toc.attachment = path;
	    }
	  }
	};

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _FuelTypeSelect = __webpack_require__(2093);
	
	var _FuelTypeSelect2 = _interopRequireDefault(_FuelTypeSelect);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _SelectizeCategory = __webpack_require__(61);
	
	var _SelectizeCategory2 = _interopRequireDefault(_SelectizeCategory);
	
	var _SelectizeVehicleBrand = __webpack_require__(2101);
	
	var _SelectizeVehicleBrand2 = _interopRequireDefault(_SelectizeVehicleBrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficeCreateVehicle",
	  components: {
	    SelectizeVehicleBrand: _SelectizeVehicleBrand2.default,
	    SelectizeCategory: _SelectizeCategory2.default,
	    KeplerFileUpload: _KeplerFileUpload2.default,
	    FuelTypeSelect: _FuelTypeSelect2.default,
	    Dropzone: _Dropzone2.default
	  },
	  data: function data() {
	    return {
	      vehicleBrands: [],
	      showFileSelector: false,
	      body: {
	        plate: null,
	        model: null,
	        color: null,
	        brand_id: null,
	        category_id: null,
	        fuel_type: null,
	        odometer: null,
	        picture: null,
	        position: {
	          latitude: 0,
	          longitude: 0
	        }
	      }
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {},
	
	  methods: {
	    handleFileSelector: function handleFileSelector(path) {
	      this.body.picture = path;
	      this.showFileSelector = false;
	    },
	    selectBrand: function selectBrand(brand) {
	      this.body.brand_id = brand.id;
	    },
	    selectCategory: function selectCategory(category) {
	      this.body.category_id = category.id;
	    },
	    selectFuel: function selectFuel(fuel) {
	      this.body.fuel_type = fuel.id;
	    },
	    formSubmit: function formSubmit() {
	      var _this = this;
	
	      _backoffice2.default.vehicles.make(this.body, function (data) {
	        _this.$router.push({ name: 'vehicle', params: { id: data.id } });
	      });
	    }
	  }
	};

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _SelectizeTocType = __webpack_require__(590);
	
	var _SelectizeTocType2 = _interopRequireDefault(_SelectizeTocType);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _SelectizeVehicleType = __webpack_require__(224);
	
	var _SelectizeVehicleType2 = _interopRequireDefault(_SelectizeVehicleType);
	
	var _SelectizeIcon = __webpack_require__(2096);
	
	var _SelectizeIcon2 = _interopRequireDefault(_SelectizeIcon);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "CreateVehicleAttribute",
	  components: {
	    TranslateField: _TranslateField2.default,
	    SelectizeIcon: _SelectizeIcon2.default, SelectizeVehicleType: _SelectizeVehicleType2.default, Editor: _Editor2.default, KeplerFileUpload: _KeplerFileUpload2.default, SelectizeTocType: _SelectizeTocType2.default, DatePicker: _DatePicker2.default },
	  data: function data() {
	    return {
	      attribute: {
	        name: null,
	        description: null,
	        recommended: false,
	        vehicle_type_id: null,
	        type: null,
	        icon: null,
	        private: false
	      }
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {},
	  created: function created() {
	    var _this = this;
	
	    if (this.$route.params.id) {
	      _backoffice2.default.vehicleAttributes.select(this.$route.params.id).get(function (data) {
	        _this.attribute = data;
	        _this.attribute.vehicle_type_id = data.vehicle_type.id;
	      });
	    }
	  },
	
	  methods: {
	    setVehicleType: function setVehicleType(obj) {
	      this.attribute.vehicle_type_id = obj.id;
	    },
	    createAttribute: function createAttribute() {
	      var _this2 = this;
	
	      if (this.$route.params.id) {
	        _backoffice2.default.vehicleAttributes.select(this.attribute).edit(this.attribute, function () {
	          _maggieHelper2.default.notification('Edited', 'Vehicle attribute edited');
	          _this2.$router.push({ name: 'attributes' });
	        });
	        return;
	      }
	
	      _backoffice2.default.vehicleAttributes.make(this.attribute, function () {
	        _maggieHelper2.default.notification('Created', 'Vehicle attribute created');
	        _this2.$router.push({ name: 'attributes' });
	      });
	    }
	  }
	};

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateVehicleCategory',
	  components: { KeplerFileUpload: _KeplerFileUpload2.default, Dropzone: _Dropzone2.default },
	  data: function data() {
	    return {
	      dropzoneUlr: _backoffice2.default.getUrlForDropzone(),
	      vehicleTypes: null,
	
	      body: {
	        name: null,
	        vehicle_type_id: null,
	        description: null,
	        picture: null,
	        damage_picture: null
	
	      },
	      attachment_token: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicleTypes.list.all(function (data) {
	      _this.vehicleTypes = data;
	    });
	  },
	
	  methods: {
	    addVehicleCategory: function addVehicleCategory() {
	      var _this2 = this;
	
	      _backoffice2.default.vehicleCategories.make(this.body, function (data) {
	        _maggieHelper2.default.notification('Vehicle Category', 'Vehicle Category Created');
	        if (!_this2.attachment_token) {
	
	          _this2.$router.push({ path: 'assets', name: 'categories' });
	        } else {
	          var body = { attachment_token: _this2.attachment_token };
	          _backoffice2.default.vehicleCategories.select(data.id).addPicture(body, function (data) {
	            _this2.$router.push({ path: 'assets', name: 'categories' });
	          });
	        }
	      });
	    },
	    handleFileSelector: function handleFileSelector(path) {
	      this.body.picture = path;
	    },
	    handleFileDamageSelector: function handleFileDamageSelector(path) {
	      this.body.damage_picture = path;
	    }
	  }
	};

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficeCreateVehicleType",
	  components: {},
	  data: function data() {
	    return {
	      vehicleBrands: [],
	      showFileSelector: false,
	      body: {
	        name: '',
	        description: ''
	      }
	    };
	  },
	
	  methods: {
	    formSubmit: function formSubmit() {
	      var _this = this;
	
	      _backoffice2.default.vehicleTypes.make(this.body, function () {
	        _this.$router.push({ name: 'types' });
	      });
	    }
	  }
	};

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapDrawingManager = __webpack_require__(591);
	
	var _GoogleMapDrawingManager2 = _interopRequireDefault(_GoogleMapDrawingManager);
	
	var _vuex = __webpack_require__(10);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateZone',
	  components: { GoogleMapContainer: _GoogleMapContainer2.default, GoogleMap: _GoogleMap2.default, GoogleMapDrawingManager: _GoogleMapDrawingManager2.default },
	  data: function data() {
	    return {
	      apiKey: null,
	      geoData: null,
	      body: {
	        name: null,
	        poly: null
	      },
	      mapCenter: {
	        lat: 0,
	        lng: 0
	      }
	    };
	  },
	  created: function created() {
	    this.apiKey = window.env.GOOGLE_MAPS_KEY;
	  },
	
	  methods: {
	    shapeUpdated: function shapeUpdated(data) {
	      this.body.poly = data;
	    },
	    createZone: function createZone() {
	      var _this = this;
	
	      _backoffice2.default.zones.make(this.body, function () {
	        _maggieHelper2.default.notification('Zone', 'Zone created successfully');
	        _this.$router.push({ path: 'assets', name: 'zone-management' });
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this2.mapCenter.lat = data.application.application_default_latitude.value;
	      _this2.mapCenter.lng = data.application.application_default_longitude.value;
	    });
	  }
	};

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _InterventionRequestForm = __webpack_require__(119);
	
	var _InterventionRequestForm2 = _interopRequireDefault(_InterventionRequestForm);
	
	var _eventBus = __webpack_require__(15);
	
	var _MaintenanceRequestList = __webpack_require__(156);
	
	var _MaintenanceRequestList2 = _interopRequireDefault(_MaintenanceRequestList);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _CreateInterventionRequestReveal = __webpack_require__(153);
	
	var _CreateInterventionRequestReveal2 = _interopRequireDefault(_CreateInterventionRequestReveal);
	
	var _vuex = __webpack_require__(10);
	
	var _CreateSubInterventionRequestReveal = __webpack_require__(596);
	
	var _CreateSubInterventionRequestReveal2 = _interopRequireDefault(_CreateSubInterventionRequestReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DetailInterventionRequestReveal',
	  components: {
	    CreateSubInterventionRequestReveal: _CreateSubInterventionRequestReveal2.default,
	    InterventionRequestReveal: _CreateInterventionRequestReveal2.default,
	    Vehicle: _Vehicle2.default,
	    MaintenanceRequestList: _MaintenanceRequestList2.default,
	    InterventionRequestForm: _InterventionRequestForm2.default,
	    SelectizeVehicle: _SelectizeVehicle2.default,
	    ActionButton: _ActionButton2.default,
	    ModalReveal: _ModalReveal2.default,
	    DatePicker: _DatePicker2.default
	  },
	  data: function data() {
	    return {
	      filters: {
	        parent_intervention_request_id: this.request.id,
	        vehicle_id: null
	      },
	      body: {
	        status: null,
	        linked_intervention_request_id: this.request.id,
	        maintenance_driver_id: null,
	        vehicle_id: this.request.vehicle.id,
	        priority: null,
	        type: null,
	        description: null,
	        expiry: null,
	        has_linked_requests: true
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    save: function save() {
	      return _backoffice2.default.maintenanceRequest.select(this.request).update(this.request, function () {
	        _maggieHelper2.default.notification('', 'maintenance request updated');
	        _eventBus.EventBus.$emit('reload-list');
	        _eventBus.EventBus.$emit('close-modal');
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: {
	    request: null,
	    open: false
	  }
	};

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RequirementList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(532)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    reloadList: function reloadList() {
	      this.$refs.baseList.loadData(1);
	    },
	    dataLoader: function dataLoader(callback) {
	      _backoffice2.default.documentRequirements.list().all(function (data) {
	        var items = data;
	        var tocs = {
	          current_page: 1,
	          current_page_count: 1,
	          items: items,
	          items_count: items.length,
	          page_count: 1,
	          per_page_count: 25
	        };
	        callback(tocs);
	      });
	    }
	  },
	  props: ['entity_type', 'entity_id']
	};

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DocumentTypeList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1906)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      _backoffice2.default.documentTypes.list().all(function (data) {
	        var tocs = {
	          current_page: 1,
	          current_page_count: 1,
	          items: [],
	          items_count: 10,
	          page_count: 1,
	          per_page_count: 25
	        };
	
	        tocs.items = data;
	        tocs.items_count = data.length;
	        callback(tocs);
	      });
	    }
	  }
	};

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _AccontStatusFilter = __webpack_require__(194);
	
	var _AccontStatusFilter2 = _interopRequireDefault(_AccontStatusFilter);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverApprovalQueue',
	  components: {
	    SearchEntity: _SearchEntity2.default,
	    AccontStatusFilter: _AccontStatusFilter2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(18),
	      headers: [' ', 'Driver ID / Name', 'City', 'Requested date', 'Phone & Mail', ''],
	      search: {
	        status: ['PENDING REVIEW', 'ON HOLD'],
	        order_field: 'updated_at',
	        sort_order: 'desc',
	        driver_id: null,
	        payment_method: 0,
	        document: 0,
	        subscription: 0
	      }
	    };
	  },
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      _backoffice2.default.drivers.list(page, resultsPerPage, search).approval(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeDocumentType = __webpack_require__(81);
	
	var _SelectizeDocumentType2 = _interopRequireDefault(_SelectizeDocumentType);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverLicenseApprovalQueue',
	  components: {
	    SearchEntity: _SearchEntity2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    SelectizeDocumentType: _SelectizeDocumentType2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(188),
	      test: [],
	      search: {
	        driver_id: null,
	        document_type_id: null
	      }
	    };
	  },
	  methods: {
	    unsetType: function unsetType() {
	      this.search.document_type_id = null;
	    },
	    selectType: function selectType(obj) {
	      this.search.document_type_id = obj.id;
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      var _this = this;
	
	      _backoffice2.default.driverLicenses.list(page, resultsPerPage, search).approval(function (data) {
	        _this.test = data;
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _InputForm = __webpack_require__(123);
	
	var _InputForm2 = _interopRequireDefault(_InputForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _DriverListForm = __webpack_require__(581);
	
	var _DriverListForm2 = _interopRequireDefault(_DriverListForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverList",
	  components: {
	    DriverListForm: _DriverListForm2.default,
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    InputForm: _InputForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(18),
	      headers: ['', 'Driver ID', 'Name', 'Client', 'City', 'Registered', 'Phone & Mail', ''],
	      search: {}
	    };
	  },
	  methods: {
	    setSearch: function setSearch(search) {
	      this.search = search;
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      if (search && search.query) {
	
	        _backoffice2.default.drivers.list(page, resultsPerPage, search).search(function (items) {
	          callback(items);
	        });
	      } else {
	        _backoffice2.default.drivers.list(page, resultsPerPage, search).all(function (data) {
	          callback(data);
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _AccontStatusFilter = __webpack_require__(194);
	
	var _AccontStatusFilter2 = _interopRequireDefault(_AccontStatusFilter);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DriverPendingDeleteQueue',
	  components: {
	    AccontStatusFilter: _AccontStatusFilter2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(18),
	      headers: [' ', 'Driver ID / Name', 'City', 'Requested date', 'Phone & Mail', '']
	    };
	  },
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.drivers.list(page, resultsPerPage).pendingDelete(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _InputForm = __webpack_require__(123);
	
	var _InputForm2 = _interopRequireDefault(_InputForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _DriverListForm = __webpack_require__(581);
	
	var _DriverListForm2 = _interopRequireDefault(_DriverListForm);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriversReservationRequestList",
	  components: {
	    InputSwitch: _InputSwitch2.default,
	    DriverListForm: _DriverListForm2.default,
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    InputForm: _InputForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1911),
	      search: {
	        status: null,
	        sub_status: null,
	        deleted: false
	      }
	    };
	  },
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.reservations.list(page, resultsPerPage).driversReservationRequests(this.search, function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInteger = __webpack_require__(1197);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _InterventionRequestForm = __webpack_require__(119);
	
	var _InterventionRequestForm2 = _interopRequireDefault(_InterventionRequestForm);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditInterventionRequestReveal',
	  components: { InterventionRequestForm: _InterventionRequestForm2.default, SelectizeVehicle: _SelectizeVehicle2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default, DatePicker: _DatePicker2.default },
	  data: function data() {
	    return {
	      body: {}
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    open: function open() {
	      this.body = {
	        status: this.request.status,
	        linked_intervention_request_id: this.request.linked_intervention_request_id,
	        maintenance_driver_id: this.request.hasOwnProperty('driver') && this.request.driver ? this.request.driver.id : null,
	        vehicle_id: this.request.hasOwnProperty('vehicle') && this.request.vehicle ? this.request.vehicle.id : null,
	        priority: this.request.priority,
	        type: this.request.type,
	        description: this.request.description,
	        start_at: this.request.start_at,
	        expiry: this.request.expiry,
	        has_linked_requests: this.request.has_linked_requests
	      };
	    },
	    save: function save() {
	      var _this = this;
	
	      if (!(0, _isInteger2.default)(this.body.linked_intervention_request_id) && this.body.linked_intervention_request_id !== null) {
	        this.body.linked_intervention_request_id = this.body.linked_intervention_request_id.id;
	      }
	      return _backoffice2.default.maintenanceRequest.select(this.request).update(this.body, function () {
	        _eventBus.EventBus.$emit('reload-list');
	        _eventBus.EventBus.$emit('close-modal', 'maintenance-' + _this._uid);
	      });
	    },
	    close: function close(val) {
	      _eventBus.EventBus.$emit('close-modal');
	    }
	  },
	  computed: {},
	  props: {
	    request: null
	  }
	};

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _vuex = __webpack_require__(10);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _eventBus = __webpack_require__(15);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditPageReveal',
	  components: { TranslateField: _TranslateField2.default, Editor: _Editor2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      langs: [],
	      body: {
	        title: {},
	        content: {},
	        buttonLabels: {},
	        action: ""
	      }
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    update: function update() {
	      var _this = this;
	
	      return _backoffice2.default.pages.select(this.item.id).edit(this.item, function () {
	        _maggieHelper2.default.notification('page updated', 'page updated');
	        _eventBus.EventBus.$emit('reload-list');
	        _this.$refs[_this.componentId].close();
	      });
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return 'pageReveal-' + this._uid;
	    }
	  },
	  props: {
	    item: {}
	  }
	};

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropzone = __webpack_require__(58);
	
	var _Dropzone2 = _interopRequireDefault(_Dropzone);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _VehicleDamage = __webpack_require__(138);
	
	var _VehicleDamage2 = _interopRequireDefault(_VehicleDamage);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeEditReporting',
	  components: {
	    SelectizeDriver: _SelectizeDriver2.default,
	    SelectizeVehicle: _SelectizeVehicle2.default,
	    VehicleDamage: _VehicleDamage2.default,
	    Dropzone: _Dropzone2.default
	  },
	  data: function data() {
	    return {
	      reportingTypes: [],
	      pins: [],
	      showVehicleSelect: null,
	      body: {
	        damage_position_raw: [],
	        reporting_type_id: null,
	        vehicle_id: null,
	        status: null,
	        description: null,
	        attachments: []
	      },
	      vehicle: null,
	      damageReport: false,
	      dropzoneUrl: _backoffice2.default.getUrlForDropzone()
	
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.body.damage_position_raw = this.item.damage_position_raw ? this.item.damage_position_raw : [];
	    this.body.status = this.item.status;
	    this.body.reporting_type_id = this.item.type.id;
	    this.body.description = this.item.description;
	    this.body.vehicle_id = this.item.vehicle.id;
	
	    this.vehicle = this.item.vehicle;
	
	    this.body.reporting_type_id = this.item.type.id;
	    if (this.item.driver) {
	      this.body.driver_id = this.item.driver.id;
	    }
	    this.isDamageReport();
	
	    this.body.vehicle_id = this.item.vehicle.id;
	
	    _backoffice2.default.selects.reportingTypes(function (data) {
	      _this.reportingTypes = data;
	    });
	  },
	
	  methods: {
	    updateDamages: function updateDamages(pins) {
	      this.body.damage_position_raw = pins;
	    },
	    driverSelected: function driverSelected(driver) {
	      this.body.driver_id = driver.id;
	    },
	    vehicleSelected: function vehicleSelected(vehicle) {
	      var _this2 = this;
	
	      this.body.vehicle_id = vehicle.id;
	      this.vehicle = vehicle;
	      _backoffice2.default.vehicles.select(vehicle.id).get(function (data) {
	        _this2.item.vehicle.category = data.category;
	      });
	    },
	    isDamageReport: function isDamageReport() {
	      var damageReportId = 3;
	      this.damageReport = this.body.reporting_type_id === damageReportId;
	    },
	
	    uploaded: function uploaded(file, response) {
	      this.body.attachments.push(response.token);
	    },
	    submit: function submit() {
	      var _this3 = this;
	
	      if (this.item) {
	        if (this.body.driver_id == '') {
	          this.body.driver_id = null;
	        }
	
	        _backoffice2.default.reportings.select(this.$route.params.id).edit(this.body, function (data) {
	          _this3.$router.push({ name: 'reporting', params: { id: data.id } });
	        });
	      } else {
	        _backoffice2.default.reportings.make(this.body.vehicle_id, this.body, function (data) {
	          _this3.$router.push({ name: 'reporting', params: { id: data.id } });
	        });
	      }
	    }
	  },
	  computed: {},
	  props: ['item']
	};

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditReportingType',
	  data: function data() {
	    return {
	      body: {
	        name: null,
	        description: null,
	        position_required: false,
	        description_required: false
	      }
	    };
	  },
	  mounted: function mounted() {
	    if (this.reportingType) {
	      this.body = (0, _assign2.default)({}, this.reportingType);
	    }
	  },
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      if (this.reportingType) {
	        _backoffice2.default.reportingTypes.select(this.reportingType.id).edit(this.body, function () {
	          _maggieHelper2.default.notification('Edited', 'Reporting type edited successfully');
	          _this.$emit('reportingTypeEdited');
	        });
	
	        return;
	      }
	
	      _backoffice2.default.reportingTypes.make(this.body, function () {
	        _maggieHelper2.default.notification('Created', 'Reporting type created successfully');
	        window.location.reload();
	      });
	    }
	  },
	  props: ['reportingType']
	};

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapDrawingManager = __webpack_require__(591);
	
	var _GoogleMapDrawingManager2 = _interopRequireDefault(_GoogleMapDrawingManager);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "EditZone",
	  components: { TranslateField: _TranslateField2.default, GoogleMapContainer: _GoogleMapContainer2.default, LoadingSpinner: _LoadingSpinner2.default, GoogleMap: _GoogleMap2.default, GoogleMapDrawingManager: _GoogleMapDrawingManager2.default },
	  data: function data() {
	    return {
	      apiKey: null,
	      geoData: null,
	      body: {
	        name: null,
	        poly: null
	      },
	      mapCenter: {
	        lat: 0,
	        lng: 0
	      },
	      zone: {},
	      confirmed: false
	    };
	  },
	  created: function created() {
	    this.apiKey = window.env.GOOGLE_MAPS_KEY;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this.mapCenter.lat = data.application.application_default_latitude.value;
	      _this.mapCenter.lng = data.application.application_default_longitude.value;
	    });
	
	    _backoffice2.default.zones.select(this.$route.params.id).get(function (data) {
	      _this.zone = data;
	    });
	  },
	
	  methods: {
	    shapeUpdated: function shapeUpdated(data) {
	      this.zone.poly = data;
	      this.confirmed = true;
	    },
	    updateZone: function updateZone() {
	      var _this2 = this;
	
	      if (this.confirmed) {
	        _backoffice2.default.zones.select(this.$route.params.id).update(this.zone, function () {
	          _maggieHelper2.default.notification('Zone', 'Zone edited successfully');
	          _this2.$router.push({ path: 'assets', name: 'zone-management' });
	        });
	      } else {
	        alert("PRESS CONFIRM ON THE MAP BEFORE UPDATING THE ZONE");
	      }
	    }
	  }
	};

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "EntityPage",
	  components: {},
	  data: function data() {
	    return {
	      itemComponent: null,
	      item: null,
	      type: 'expanded'
	    };
	  },
	  created: function created() {
	    this.$watch(function () {
	      return this.$route.meta;
	    }, function (newVal, oldVal) {
	      this.setup();
	    });
	    this.setup();
	    _eventBus.EventBus.$on('refresh-entity', this.refresh);
	  },
	  destroyed: function destroyed() {
	    _eventBus.EventBus.$off('refresh-entity');
	  },
	
	  methods: {
	    setup: function setup() {
	      var _this = this;
	
	      var source = this.$route.meta.source;
	
	      _backoffice2.default[source].select(this.$route.params.id).get(function (response) {
	        _this.item = response;
	        _this.itemComponent = _this.$route.meta.entityComponent;
	      });
	    },
	    refresh: function refresh() {
	      this.setup();
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Export",
	  components: {
	    DateRangePicker: _DateRangePicker2.default
	  },
	  data: function data() {
	    return {
	
	      reports: '',
	      selectReport: '',
	      search: {
	        'delimiter': null
	      },
	      componentKey: 0,
	      formFields: '',
	      viewUrl: false,
	      url: ''
	
	    };
	  },
	
	  watch: {
	    selectReport: function selectReport() {
	      this.resetData();
	    },
	    search: function search() {}
	  },
	  mounted: function mounted() {
	    this.loadFormFields();
	  },
	
	  methods: {
	    dateRangeSelected: function dateRangeSelected(range) {
	      this.search.from = range.start;
	      this.search.to = range.end;
	    },
	    resetData: function resetData() {
	      this.search = {};
	      this.componentKey += 1;
	      this.viewUrl = false;
	    },
	    loadFormFields: function loadFormFields() {
	      var _this = this;
	
	      _backoffice2.default.export.getTypes(function (data) {
	        _this.formFields = data;
	        _this.reports = (0, _keys2.default)(data);
	        var k = (0, _keys2.default)(_this.formFields);
	        if (k.includes('coupons')) {
	          _this.formFields['coupons'][0] = 'common_cost_id';
	        }
	      });
	    },
	    stringReplacer: function stringReplacer(str) {
	      return str.replace(/_/g, ' ');
	    },
	    getUrl: function getUrl() {
	      var body = {};
	      body = this.createBody('from', 'to');
	
	      return _backoffice2.default.export.getCsv(this.selectReport, body);
	    },
	    copyURL: function copyURL() {
	      this.viewUrl = true;
	      this.url = this.getUrl();
	
	      setTimeout(function () {
	        document.getElementById('myInput').select();
	        document.execCommand("copy");
	        _maggieHelper2.default.notification('Url copied to Clipboard');
	      }, 100);
	    },
	    openCsv: function openCsv() {
	      this.url = this.getUrl();
	
	      this.copyURL(this.url);
	      window.open(this.url, '_blank');
	    },
	    createBody: function createBody(fromField, toField) {
	      var _this2 = this;
	
	      var body = {
	        start: this.search[fromField],
	        end: this.search[toField],
	        params: {}
	      };
	      if (this.search.delimiter) {
	        this.search.delimiter = this.search.delimiter.trim();
	      }
	
	      (0, _keys2.default)(this.search).filter(function (k) {
	        return !!_this2.search[k] && k != fromField && k != toField;
	      }).forEach(function (f) {
	        return body.params[f] = _this2.search[f];
	      });
	      return body;
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FederationAdd',
	  components: { ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      body: {
	        name: null
	      }
	    };
	  },
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.federations.make(this.body, function (data) {
	
	        _maggieHelper2.default.notification('Done', 'Federation created');
	        _this.$router.push({ name: 'federations' });
	      });
	    }
	  },
	  props: []
	};

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _SelectizeGroupedParkingAssets = __webpack_require__(91);
	
	var _SelectizeGroupedParkingAssets2 = _interopRequireDefault(_SelectizeGroupedParkingAssets);
	
	var _SelectizeParkingGroup = __webpack_require__(222);
	
	var _SelectizeParkingGroup2 = _interopRequireDefault(_SelectizeParkingGroup);
	
	var _SelectizeClient = __webpack_require__(89);
	
	var _SelectizeClient2 = _interopRequireDefault(_SelectizeClient);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SearchEntity = __webpack_require__(54);
	
	var _SearchEntity2 = _interopRequireDefault(_SearchEntity);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CreateFederationButtonModal',
	  components: {
	    SearchEntity: _SearchEntity2.default,
	    ActionButton: _ActionButton2.default,
	    SelectizeClient: _SelectizeClient2.default, SelectizeParkingGroup: _SelectizeParkingGroup2.default, SelectizeGroupedParkingAssets: _SelectizeGroupedParkingAssets2.default, SelectizeVehicle: _SelectizeVehicle2.default, BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      search: null,
	      entity: null,
	      component: __webpack_require__(53),
	      loadedItems: [],
	      selected: {
	
	        add: [],
	        delete: []
	
	      },
	      body: {
	        name: []
	      }
	    };
	  },
	  created: function created() {
	    if (this.item !== null) {
	      for (var key in this.item) {
	        this.entity[key] = this.item[key];
	      }
	    }
	  },
	
	  methods: {
	    add: function add(val) {
	      var _this = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to add CL' + val + '?', function () {
	        _this.selected.add.push(val);
	        _this.search = null;
	        _this.save();
	      });
	    },
	    save: function save() {
	      var _this2 = this;
	
	      var body = (0, _extends3.default)({
	        'entity': 'client'
	      }, this.selected);
	
	      return _backoffice2.default.federations.select(this.$route.params.id).updateFederated(body, function () {
	        _eventBus.EventBus.$emit('reload-list');
	        _this2.selected.add = [];
	        _this2.selected.delete = [];
	      });
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      var _this3 = this;
	
	      _backoffice2.default['' + this.$route.meta.name].select(this.$route.params.id).get(function (data) {
	        callback(data);
	        _this3.loaded = true;
	        _this3.loadedItems = data.items.map(function (item) {
	          return '' + item.id;
	        });
	      }, function () {}, page, resultsPerPage);
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FederationList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1917)
	    };
	  },
	  created: function created() {
	    this.dataLoader();
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.federations.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _SelectizeGroupedParkingAssets = __webpack_require__(91);
	
	var _SelectizeGroupedParkingAssets2 = _interopRequireDefault(_SelectizeGroupedParkingAssets);
	
	var _SelectizeParkingGroup = __webpack_require__(222);
	
	var _SelectizeParkingGroup2 = _interopRequireDefault(_SelectizeParkingGroup);
	
	var _SelectizeClient = __webpack_require__(89);
	
	var _SelectizeClient2 = _interopRequireDefault(_SelectizeClient);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FederationParkingGroupsEdit',
	  components: {
	    ActionButton: _ActionButton2.default,
	    SelectizeClient: _SelectizeClient2.default, SelectizeParkingGroup: _SelectizeParkingGroup2.default, SelectizeGroupedParkingAssets: _SelectizeGroupedParkingAssets2.default, SelectizeVehicle: _SelectizeVehicle2.default, BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      entity: null,
	      loadedItems: [],
	      component: __webpack_require__(1924),
	      selected: {
	
	        add: [],
	        delete: []
	
	      },
	      body: {
	        name: []
	      }
	    };
	  },
	  created: function created() {
	    if (this.item !== null) {
	      for (var key in this.item) {
	        this.entity[key] = this.item[key];
	      }
	    }
	  },
	
	  methods: {
	    add: function add(val) {
	      var position = this.loadedItems.indexOf('' + val.id);
	      if (position !== -1) {
	        this.selected.add.splice(position, 1);
	        this.selected.delete.push(val.id);
	      } else {
	        this.selected.add.push('' + val.id);
	      }
	    },
	    remove: function remove(val) {
	      var position = this.loadedItems.indexOf('' + val.id);
	      this.selected.add.splice(position, 1);
	    },
	    save: function save() {
	      var _this = this;
	
	      var body = (0, _extends3.default)({
	        'entity': 'parking_group'
	      }, this.selected);
	
	      return _backoffice2.default.federations.select(this.$route.params.id).updateFederated(body, function () {
	        _this.$refs.list.loadData(1);
	        _this.$refs.select.clearSelected();
	        _this.selected.add = [];
	        _this.selected.delete = [];
	      });
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      var _this2 = this;
	
	      _backoffice2.default['' + this.$route.meta.name].select(this.$route.params.id).get(function (data) {
	        callback(data);
	        _this2.loaded = true;
	        _this2.loadedItems = data.items.map(function (item) {
	          return '' + item.id;
	        });
	      }, function () {}, page, resultsPerPage);
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _SelectizeGroupedParkingAssets = __webpack_require__(91);
	
	var _SelectizeGroupedParkingAssets2 = _interopRequireDefault(_SelectizeGroupedParkingAssets);
	
	var _SelectizeParkingGroup = __webpack_require__(222);
	
	var _SelectizeParkingGroup2 = _interopRequireDefault(_SelectizeParkingGroup);
	
	var _SelectizeClient = __webpack_require__(89);
	
	var _SelectizeClient2 = _interopRequireDefault(_SelectizeClient);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FederationVehiclesEdit',
	  components: {
	    ActionButton: _ActionButton2.default,
	    SelectizeClient: _SelectizeClient2.default, SelectizeParkingGroup: _SelectizeParkingGroup2.default, SelectizeGroupedParkingAssets: _SelectizeGroupedParkingAssets2.default, SelectizeVehicle: _SelectizeVehicle2.default, BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      entity: null,
	      component: __webpack_require__(20),
	      loadedItems: [],
	      selected: {
	
	        add: [],
	        delete: []
	
	      },
	      body: {
	        name: []
	      }
	    };
	  },
	  created: function created() {
	    if (this.item !== null) {
	      for (var key in this.item) {
	        this.entity[key] = this.item[key];
	      }
	    }
	  },
	
	  methods: {
	    add: function add(val) {
	      var position = this.loadedItems.indexOf('' + val.id);
	      if (position !== -1) {
	        this.selected.add.splice(position, 1);
	        this.selected.delete.push(val.id);
	      } else {
	        this.selected.add.push('' + val.id);
	      }
	    },
	    remove: function remove(val) {
	      var position = this.loadedItems.indexOf('' + val.id);
	      this.selected.add.splice(position, 1);
	    },
	    save: function save() {
	      var _this = this;
	
	      var body = (0, _extends3.default)({
	        'entity': 'vehicle'
	      }, this.selected);
	
	      return _backoffice2.default.federations.select(this.$route.params.id).updateFederated(body, function () {
	        _this.$refs.list.loadData(1);
	        _this.$refs.select.clearSelected();
	        _this.selected.add = [];
	        _this.selected.delete = [];
	      });
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      var _this2 = this;
	
	      _backoffice2.default['' + this.$route.meta.name].select(this.$route.params.id).get(function (data) {
	        callback(data);
	        _this2.loaded = true;
	        _this2.loadedItems = data.items.map(function (item) {
	          return '' + item.id;
	        });
	      }, function () {}, page, resultsPerPage);
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapMarker = __webpack_require__(72);
	
	var _GoogleMapMarker2 = _interopRequireDefault(_GoogleMapMarker);
	
	var _GoogleMapCircle = __webpack_require__(152);
	
	var _GoogleMapCircle2 = _interopRequireDefault(_GoogleMapCircle);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	var _GoogleMapMarkerCluster = __webpack_require__(226);
	
	var _GoogleMapMarkerCluster2 = _interopRequireDefault(_GoogleMapMarkerCluster);
	
	var _GoogleMapDirectionsService = __webpack_require__(225);
	
	var _GoogleMapDirectionsService2 = _interopRequireDefault(_GoogleMapDirectionsService);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	var _SelectizeVehicleType = __webpack_require__(224);
	
	var _SelectizeVehicleType2 = _interopRequireDefault(_SelectizeVehicleType);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FleetMap',
	  data: function data() {
	    return {
	      showfilter: false,
	      vehicles: null,
	      mapCenter: {
	        lat: 0,
	        lng: 0
	      },
	      userPosition: null,
	      vehiclePosition: null,
	      zones: [],
	      showAllowed: true,
	      showForbidden: true,
	      showUndesirable: true,
	      plate: null,
	      body: {
	        vehicle_type_id: null,
	        active_vehicle_slots: null,
	        reservation_type: null,
	        page_number: 1,
	        per_page: -1
	      },
	      filtered: [],
	      reservation_types: []
	    };
	  },
	
	  methods: {
	    optionSelected: function optionSelected(obj) {
	      this.body.vehicle_type_id = obj.id;
	    },
	    optionRemoved: function optionRemoved() {
	      this.body.vehicle_type_id = null;
	    },
	    loadVehicles: function loadVehicles() {
	      var _this = this;
	
	      return _backoffice2.default.vehicles.list().fleetMap(this.body, function (data) {
	        _this.vehicles = data.items;
	      });
	    },
	    filter: function filter(evt) {
	      var plate = evt.target.value;
	      this.filtered = this.vehicles.filter(function (vehicle) {
	        return vehicle.plate.includes(plate);
	      });
	    },
	    vehicleInRange: function vehicleInRange(vehicle) {
	      var icon = '/static/map_pin_blue.png';
	      if (!vehicle.in_range) {
	        icon = '/static/map_pin_red.png';
	      }
	
	      if (vehicle.has_reservation === 'normal') {
	        icon = '/static/map_pin_orange.png';
	      }
	
	      if (vehicle.has_reservation === 'maintenance') {
	        icon = '/static/map_pin_yellow.png';
	      }
	
	      if (vehicle.ev_plug_status === 'CHARGING') {
	        icon = '/static/charging.svg';
	      }
	
	      return icon;
	    },
	    updateUserPosition: function updateUserPosition(position) {
	      this.userPosition = position.location;
	    },
	    updateSelectedVehicle: function updateSelectedVehicle(position) {
	      this.vehiclePosition = position.latLng;
	    },
	    showFilterPanel: function showFilterPanel() {
	      this.showfilter = !this.showfilter;
	    }
	  },
	  components: {
	    InputSwitch: _InputSwitch2.default,
	    ActionButton: _ActionButton2.default,
	    SelectizeVehicleType: _SelectizeVehicleType2.default,
	    GoogleMapContainer: _GoogleMapContainer2.default,
	    GoogleMapDirectionsService: _GoogleMapDirectionsService2.default,
	    Vehicle: _Vehicle2.default,
	    GoogleMap: _GoogleMap2.default,
	    GoogleMapMarker: _GoogleMapMarker2.default,
	    GoogleMapCircle: _GoogleMapCircle2.default,
	    GoogleMapMarkerCluster: _GoogleMapMarkerCluster2.default,
	    GoogleMapPolygon: _GoogleMapPolygon2.default
	  },
	  computed: {
	    mapsAPI: function mapsAPI() {
	      return window.env.GOOGLE_MAPS_KEY;
	    },
	    filteredVehicles: function filteredVehicles() {
	      return this.plate === null || this.plate === '' ? this.vehicles : this.filtered;
	    }
	  },
	  created: function created() {
	    this.loadVehicles();
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this2.mapCenter.lat = data.application.application_default_latitude.value;
	      _this2.mapCenter.lng = data.application.application_default_longitude.value;
	    });
	
	    _backoffice2.default.zones.list.grouped(function (data) {
	      _this2.zones = data;
	    });
	
	    _backoffice2.default.reservations.list().modes(function (data) {
	      (0, _keys2.default)(data).map(function (key) {
	        data[key] = data[key].replace('App\\Models\\ConcreteReservations\\', '').replace('Reservation', '');
	      });
	
	      _this2.reservation_types = data;
	    });
	  }
	};

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizePolicy = __webpack_require__(2099);
	
	var _SelectizePolicy2 = _interopRequireDefault(_SelectizePolicy);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GroupEdit',
	  components: { BaseList: _BaseList2.default, SelectizeDriver: _SelectizeDriver2.default, SelectizePolicy: _SelectizePolicy2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      componentDriver: __webpack_require__(18),
	      selected: [],
	      loaded: false,
	      group: {
	        id: null,
	        global: false,
	        name: null,
	        drivers: [],
	        policies: []
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.item !== null) {
	      for (var key in this.item) {
	        this.group[key] = this.item[key];
	      }
	
	      this.loadDrivers(function (data) {
	        _this.selected = data.items.map(function (item) {
	          return '' + item.id;
	        });
	      }, 1, -1);
	    }
	  },
	
	  methods: {
	    updatePolicies: function updatePolicies(val) {
	      this.group.policies.push(val);
	    },
	    removePolicies: function removePolicies(val) {
	      var policy = this.group.policies.findIndex(function (item) {
	        return item.id === val.id;
	      });
	
	      this.group.policies.splice(policy, 1);
	    },
	    updateDrivers: function updateDrivers(val) {
	
	      var position = this.selected.indexOf('' + val.id);
	      if (position !== -1) {
	        this.selected.splice(position, 1);
	      } else {
	        this.selected.push('' + val.id);
	      }
	    },
	    removeDrivers: function removeDrivers(val) {
	      var position = this.selected.indexOf('' + val.id);
	      this.selected.splice(position, 1);
	    },
	    save: function save() {
	      var _this2 = this;
	
	      var body = this.group;
	      if (this.group.global === false) {
	        body.drivers = this.selected;
	      }
	
	      body.policies = this.group.policies.map(function (item) {
	        return item.id == null ? item : item.id;
	      });
	
	      if (this.group.id === null) {
	        return _backoffice2.default.groups.make(body, function (data) {
	          _maggieHelper2.default.notification('Group', 'group created');
	          _this2.$router.push({ name: 'groups' });
	        });
	      }
	
	      return _backoffice2.default.groups.select(this.group.id).edit(body, function (data) {
	        _maggieHelper2.default.notification('Group', 'group updated');
	        _this2.$router.push({ name: 'groups' });
	      });
	    },
	    loadDrivers: function loadDrivers(callback, page, resultsPerPage) {
	      var _this3 = this;
	
	      _backoffice2.default.groups.select(this.group.id).drivers(page, resultsPerPage, function (data) {
	        callback(data);
	        _this3.loaded = true;
	      });
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return this.groupProp !== null ? 'groupReveal-' + this.groupProp.id : 'groupReveal-' + this._uid;
	    }
	  },
	  props: {
	    groupProp: {
	      type: Object,
	      default: null
	    },
	    item: {
	      type: Object,
	      default: null
	    }
	
	  }
	};

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GroupList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1918)
	    };
	  },
	  created: function created() {
	    this.dataLoader();
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.groups.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _TranslationEdit = __webpack_require__(157);
	
	var _TranslationEdit2 = _interopRequireDefault(_TranslationEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GroupedTranslation',
	  components: { TranslationEdit: _TranslationEdit2.default, LoadingSpinner: _LoadingSpinner2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      selected: {}
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    openEditor: function openEditor(key, group) {
	      this.selected = this.translations[group].filter(function (item) {
	        return item.key === key;
	      })[0];
	    }
	  },
	  computed: {},
	  props: ['translations']
	};

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LineChart = __webpack_require__(2009);
	
	var _LineChart2 = _interopRequireDefault(_LineChart);
	
	var _PolarChart = __webpack_require__(2010);
	
	var _PolarChart2 = _interopRequireDefault(_PolarChart);
	
	var _BarChart = __webpack_require__(2006);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _HorizontalBarChart = __webpack_require__(2008);
	
	var _HorizontalBarChart2 = _interopRequireDefault(_HorizontalBarChart);
	
	var _DateRangePicker = __webpack_require__(57);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _LoadingAnimation = __webpack_require__(117);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _BaseChart = __webpack_require__(196);
	
	var _BaseChart2 = _interopRequireDefault(_BaseChart);
	
	var _Home = __webpack_require__(2196);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _ActionBar = __webpack_require__(32);
	
	var _ActionBar2 = _interopRequireDefault(_ActionBar);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _store = __webpack_require__(161);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _deepmerge = __webpack_require__(1351);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'BackofficeHome',
	  components: {
	    ActionBar: _ActionBar2.default,
	    HomeController: _Home2.default,
	    BaseChart: _BaseChart2.default,
	    LoadingAnimation: _LoadingAnimation2.default,
	    HorizontalBarChart: _HorizontalBarChart2.default,
	    BarChart: _BarChart2.default,
	    PolarChart: _PolarChart2.default,
	    LineChart: _LineChart2.default,
	    DateRangePicker: _DateRangePicker2.default
	  },
	
	  watch: {
	    'form.bracketing': {
	      handler: function handler(val) {
	        this.loadData();
	      }
	    }
	  },
	  mounted: function mounted() {
	    _store2.default.dispatch('getConfiguration');
	  },
	  created: function created() {
	    var start = (0, _moment2.default)().startOf('month').format('YYYY-MM-DD');
	    var end = (0, _moment2.default)().format('YYYY-MM-DD');
	    this.form.start = start;
	    this.form.end = end;
	    this.form = {
	      start: start,
	      end: end,
	      bracketing: 'D'
	    };
	    this.myRange = { "start": this.form.start, "end": this.form.end };
	    this.loadData();
	  },
	
	  methods: {
	    dateRangeSelected: function dateRangeSelected(range) {
	      this.form.start = range.start;
	      this.form.end = range.end;
	      if (this.form.start !== "" && this.form.end !== "" && this.form.end !== null) {
	        this.loadData();
	      }
	    },
	
	    loadData: function loadData() {
	      var _this = this;
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	      this.timeout = setTimeout(function () {
	        _this.loadDataReal();
	      }, 333);
	    },
	    loadDataReal: function loadDataReal() {
	      var _this2 = this;
	
	      var chartLoader = _backoffice2.default.charts.for(this.form.start, this.form.end, this.form.bracketing);
	
	      if (this.$acl('charged-reservations-charts')) {
	        chartLoader.charged_reservations(function (data) {
	          _this2.res = data;
	        });
	      }
	      if (this.$acl('driven-distance-charts')) {
	        chartLoader.driven_distance(function (data) {
	          _this2.dis = data;
	        });
	      }
	      if (this.$acl('driver-registrations-charts') && this.$acl('client-registrations-charts')) {
	        chartLoader.driver_registrations(function (drivers) {
	          chartLoader.client_registrations(function (clients) {
	            _this2.reg = (0, _deepmerge2.default)(clients, drivers);
	          });
	        });
	      }
	      if (this.$acl('vehicle-reservations-charts') && this.$acl('vehicle-distance-charts')) {
	        chartLoader.vehicle_reservations(function (res) {
	          chartLoader.vehicle_distance(function (dis) {
	            _this2.vei = (0, _deepmerge2.default)(res, dis);
	          });
	        });
	      }
	
	      if (this.$acl('vehicles-by-zone-charts') && !this.loadingVeiByZ) {
	        this.loadingVeiByZ = true;
	        chartLoader.vehicles_by_zone(function (res) {
	          _this2.loadingVeiByZ = false;
	          var temp = {};
	          for (var key in res) {
	            temp[key] = { vehicles: res[key] };
	          }
	          _this2.veiByZ = temp;
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      form: {
	        start: null,
	        end: null,
	        bracketing: null
	      },
	      myRange: null,
	      formLoading: false,
	      dis: null,
	      res: null,
	      reg: null,
	      vei: null,
	      veiByZ: null,
	      loadingVeiByZ: false,
	      timeout: null
	    };
	  }
	};

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "InstructionList",
	  components: { BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(534)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    loadZones: function loadZones(callback) {
	      var instructions = {
	        current_page: 1,
	        current_page_count: 1,
	        items: [],
	        items_count: 10,
	        page_count: 1,
	        per_page_count: 25
	      };
	      _backoffice2.default.instructions.list.all(function (data) {
	        instructions.items = data;
	        instructions.items_count = data.length;
	        callback(instructions);
	      });
	    }
	  }
	};

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _InvoiceListForm = __webpack_require__(221);
	
	var _InvoiceListForm2 = _interopRequireDefault(_InvoiceListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "BackofficeInvoiceList",
	  components: {
	    Cards: _Cards2.default,
	    InvoiceListForm: _InvoiceListForm2.default,
	    BaseList: _BaseList2.default,
	    HeaderColumns: _HeaderColumns2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(114),
	      headers: ['', 'Internal ID / ID', 'Emission Date', 'Due date', 'Client Name', 'Tax', 'Total', 'Status', ''],
	      search: null,
	      reports: null
	    };
	  },
	
	  methods: {
	    setSearch: function setSearch(search) {
	      console.log(search);
	      this.search = search;
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      if (search !== null && (typeof search.from !== 'undefined' || typeof search.to !== 'undefined')) {
	        search.emission_from = search.from;
	        search.emission_to = search.to;
	      }
	
	      _backoffice2.default.invoices.list(page, resultsPerPage, search).all(function (data) {
	        callback(data);
	      });
	    },
	    getReports: function getReports(range) {
	      var _this = this;
	
	      if (typeof range.start === 'undefined' || typeof range.end === 'undefined') {
	        return;
	      }
	      this.reports = null;
	      _backoffice2.default.reports.list(range).invoices(function (data) {
	        _this.reports = data;
	      });
	    }
	  },
	  computed: {
	    parsedReports: function parsedReports() {
	      if (!this.reports) {
	        return [];
	      }
	
	      return [{
	        title: "Total invoices",
	        value: this.reports.invoice_number,
	        color: '#6CB2B0'
	      }, {
	        title: "Total billed cost",
	        value: this.$priceWithcurrency(this.reports.total_billed_cost),
	        color: '#E10D5A'
	      }, {
	        title: "Total unpaid cost",
	        value: this.$priceWithcurrency(this.reports.total_unpaid_cost),
	        color: '#2BACC1'
	      }, {
	        title: "Average cost",
	        value: this.$priceWithcurrency(this.reports.average_invoice_cost)
	      }];
	    }
	  }
	};

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "BackofficeLogout",
	    components: {},
	    created: function created() {
	        localStorage.removeItem('backoffice-token');
	        location.reload();
	    },
	
	    methods: {}
	};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "MaintenanceRequestList",
	  components: { SelectizeVehicle: _SelectizeVehicle2.default, BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      search: {
	        type: null,
	        priority: null,
	        status: null,
	        vehicle_id: null
	
	      },
	      component: __webpack_require__(1919)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      var body = (0, _extends3.default)({}, search, this.filters);
	      _backoffice2.default.maintenanceRequest.list(page, resultsPerPage).all(body, function (data) {
	        callback(data);
	      });
	    }
	  },
	  props: {
	    filters: {
	      type: Object,
	      default: function _default() {}
	    },
	    listingType: {
	      type: String,
	      default: "listing"
	    }
	  }
	};

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'MergeZone',
	  components: {},
	  data: function data() {
	    return {
	      numOfTextArea: 0,
	      numGeoJsonToMerge: [],
	      geoJsonToMerge: {},
	      mergedGeoJson: '',
	      geoJson: {},
	      disable: 'true',
	      copyMerged: false,
	      spin: false,
	      validationJson: {}
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    mergeGeoJson: function mergeGeoJson() {
	      var _this = this;
	
	      this.spin = false;
	      this.isJson(this.geoJsonToMerge);
	      this.sanitazeNullValues(this.geoJsonToMerge);
	      alert((0, _stringify2.default)(this.validationJson));
	      this.geoJson = { 'geoJson': this.geoJsonToMerge };
	      _backoffice2.default.zones.mergeGeoJson(this.geoJson, function (data) {
	        _this.mergedGeoJson = (0, _stringify2.default)(data);
	        _this.spin = true;
	      });
	    },
	    copyToClipboard: function copyToClipboard() {
	      document.getElementById('geoJsonToCopy').select();
	      document.execCommand("copy");
	      _maggieHelper2.default.notification('GeoJson copied to Clipboard');
	    },
	    sanitazeNullValues: function sanitazeNullValues(obj) {
	      for (var key in obj) {
	        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
	          delete obj[key];
	        }
	      }
	    },
	    isJson: function isJson(jsons) {
	      var _this2 = this;
	
	      (0, _keys2.default)(jsons).forEach(function (key) {
	        try {
	          var obj = JSON.parse(jsons[key]);
	          if (obj && typeof obj === 'object') {
	            _this2.validationJson[key] = 'OK';
	          } else {
	            _this2.validationJson[key] = 'WRONG';
	          }
	        } catch (err) {
	          _this2.validationJson[key] = 'error';
	        }
	      });
	    }
	  },
	  watch: {
	    numOfTextArea: function numOfTextArea(newVal, oldVal) {
	      this.mergedGeoJson = '';
	      this.spin = false;
	      if (newVal <= 0 || newVal === undefined || newVal === null) {
	        this.geoJsonToMerge = {};
	        this.disable = 'false';
	      }
	      if (this.numGeoJsonToMerge.length > 0) {
	        if (newVal > oldVal) {
	          var newGeoJsonToAdd = newVal - oldVal;
	        } else {
	          var newGeoJsonToSub = oldVal - newVal;
	        }
	        var lastGeoJson = this.numGeoJsonToMerge.length;
	        if (this.numGeoJsonToMerge.length < newVal) {
	          for (var n = 1; n <= newGeoJsonToAdd; n++) {
	            this.numGeoJsonToMerge.push(lastGeoJson + n);
	          }
	        }
	        if (this.numGeoJsonToMerge.length > newVal) {
	          for (var n = 1; n <= newGeoJsonToSub; n++) {
	            this.numGeoJsonToMerge.pop();
	          }
	        }
	        return this.numGeoJsonToMerge;
	      }
	      for (var i = 1; i <= newVal; i++) {
	        this.numGeoJsonToMerge.push(i);
	      }
	      this.disable = false;
	      return this.numGeoJsonToMerge.length;
	    }
	  },
	  computed: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "NoteList",
	  components: { BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	
	      note: { type: 'App\\Models\\Vehicle', id: null, description: null },
	      component: __webpack_require__(134)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    loadZones: function loadZones(callback, page, resultsPerPage) {
	      _backoffice2.default.notes.list(page, resultsPerPage).all("App\\Models\\Vehicle", function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'NotificationList',
	  components: {
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1920),
	      headers: ['user id', 'user type', 'message type', 'sent at', '']
	    };
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      return _backoffice2.default.notifications.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _CreatePacketReveal = __webpack_require__(218);
	
	var _CreatePacketReveal2 = _interopRequireDefault(_CreatePacketReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PacketList",
	  components: { PacketModal: _CreatePacketReveal2.default, BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(1921),
	      title: 'Create new packet'
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      _backoffice2.default.packets.list.all(1, 25, function (data) {
	        callback(data);
	      });
	    },
	    itemUpdated: function itemUpdated(op) {
	      if (op === 'added') {
	        this.$refs.list.loadData(1);
	      }
	    }
	  }
	};

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PacketVehicleCategoryModal = __webpack_require__(577);
	
	var _PacketVehicleCategoryModal2 = _interopRequireDefault(_PacketVehicleCategoryModal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PacketVehicleCategoryList",
	  components: { PacketVehicleCategoryModal: _PacketVehicleCategoryModal2.default, BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(1922)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      _backoffice2.default.packetVehicleCategories.list.all(1, 25, function (data) {
	        callback(data);
	      });
	    },
	    itemUpdated: function itemUpdated(op) {
	      if (op === 'added') {
	        this.$refs.list.loadData(1);
	      }
	    }
	  }
	};

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _vuex = __webpack_require__(10);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PageConfigList',
	  components: { Editor: _Editor2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default, BaseList: _BaseList2.default, GoogleMap: _GoogleMap2.default, GoogleMapPolygon: _GoogleMapPolygon2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(1923),
	
	      pages: []
	
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      return _backoffice2.default.pages.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PendingRecordsList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1941),
	      data: []
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      var _this = this;
	
	      return _backoffice2.default.walletRecords.list(page, resultsPerPage).uninvoiced(function (data) {
	        callback(data);
	        console.log(data);
	        _this.data = data;
	      });
	    }
	  }
	};

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SearchInputForm = __webpack_require__(125);
	
	var _SearchInputForm2 = _interopRequireDefault(_SearchInputForm);
	
	var _vuex = __webpack_require__(10);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PlanList",
	  components: {
	    SearchInputForm: _SearchInputForm2.default
	  },
	  data: function data() {
	    return {
	      items: {},
	      resultsPerPage: 50,
	      component: __webpack_require__(539)
	    };
	  },
	  methods: {
	    getUrl: function getUrl(item) {
	      if (item != null) {
	        return 'url(' + window.env.API_URL + '/storage/' + item + ')';
	      } else {
	        return "none";
	      }
	    },
	
	
	    updated: function updated() {
	      var _this = this;
	
	      if (this.$acl('index-plan')) {
	        _backoffice2.default.plans.list().all(function (response) {
	          _this.items = (0, _collect2.default)(response).sortBy('status').groupBy('status').all();
	        });
	      }
	    }
	  },
	  created: function created() {
	    this.updated();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  })
	};

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SelectizeToc = __webpack_require__(589);
	
	var _SelectizeToc2 = _interopRequireDefault(_SelectizeToc);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _KeplerFileUpload = __webpack_require__(39);
	
	var _KeplerFileUpload2 = _interopRequireDefault(_KeplerFileUpload);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _VatAmountToggler = __webpack_require__(116);
	
	var _VatAmountToggler2 = _interopRequireDefault(_VatAmountToggler);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _vuex = __webpack_require__(10);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CouponReveal',
	  components: { Editor: _Editor2.default, VatAmountToggler: _VatAmountToggler2.default, ModalReveal: _ModalReveal2.default, DatePicker: _DatePicker2.default, KeplerFileUpload: _KeplerFileUpload2.default, ActionButton: _ActionButton2.default, SelectizeToc: _SelectizeToc2.default },
	  data: function data() {
	    return {
	      plan: {
	        name: null,
	        title: null,
	        toc_id: null,
	        picture: null,
	        notice: null,
	        color: null,
	        description: "",
	        cost: 0,
	        status: "AVAILABLE",
	        featured: false,
	        renewable: true,
	        billing_cycle: 90,
	        max_drivers: 1,
	        duration: 30,
	        valid_from: null,
	        valid_to: null,
	        subscription_end: null
	      },
	      key: 0
	    };
	  },
	  created: function created() {},
	
	  watch: {
	    'plan.subscription_end': function planSubscription_end(newVal, oldVal) {
	      if (newVal != null) {
	        var end = (0, _moment2.default)(newVal, 'YYYY-MM-DD');
	        this.plan.duration = end.diff((0, _moment2.default)().format('YYYY-MM-DD'), 'days');
	      }
	    }
	  },
	  methods: {
	    setTocId: function setTocId(obj) {
	      this.plan.toc_id = obj.id;
	    },
	    closeInput: function closeInput(event) {
	      if (!event) {
	        this.key++;
	      }
	    },
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.plans.make(this.plan, function (data) {
	        _maggieHelper2.default.notification('Plan saved', 'Plan saved successfully', 'success');
	        _this.key++;
	        _this.$refs[_this.componentId].close();
	        location.reload();
	      });
	    },
	    handleFileSelector: function handleFileSelector(path) {
	      this.plan.picture = path;
	    }
	  },
	  computed: (0, _extends3.default)({
	    componentId: function componentId() {
	      return "planReveal-" + this._uid;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: {
	    couponProp: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'PolicyList',
	    components: {
	        BaseList: _BaseList2.default
	    },
	    data: function data() {
	        return {
	            component: __webpack_require__(1925)
	        };
	    },
	    created: function created() {
	        this.dataLoader();
	    },
	
	    methods: {
	        dataLoader: function dataLoader(callback, page, resultsPerPage) {
	            _backoffice2.default.policies.list(page, resultsPerPage).all(function (data) {
	                console.log(data);
	                callback(data);
	            });
	        }
	    }
	};

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _StartEndTimePicker = __webpack_require__(128);
	
	var _StartEndTimePicker2 = _interopRequireDefault(_StartEndTimePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PolicyReveal',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default, StartEndTimePicker: _StartEndTimePicker2.default, DatePicker: _DatePicker2.default },
	  data: function data() {
	    return {
	      policy: {
	        name: null,
	        type: 'DRIVER',
	
	        configuration: {
	          booking_days: [],
	          max_bookable: 24,
	          min_bookable: null,
	          booking_hours: { start: null, end: null }
	        }
	      },
	      key: 0
	    };
	  },
	  created: function created() {
	    if (this.policyProp !== null) {
	      for (var key in this.policyProp) {
	        if (key === 'configuration') {
	          for (var confKey in this.policyProp.configuration) {
	            this.policy.configuration[confKey] = this.policyProp.configuration[confKey];
	          }
	        } else {
	          this.policy[key] = this.policyProp[key];
	        }
	      }
	    }
	  },
	
	  methods: {
	    checkHour: function checkHour(value) {
	      var pattern = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/;
	      if (value === null || value === '') {
	        return true;
	      }
	      return pattern.test(value);
	    },
	    closeInput: function closeInput(event) {
	      if (!event) {
	        this.policy = {
	          name: null,
	          type: 'DRIVER',
	
	          configuration: {
	            booking_days: [],
	            max_bookable: 24,
	            min_bookable: null,
	            booking_hours: { start: null, end: null }
	          }
	        };
	        this.key++;
	      }
	    },
	    save: function save() {
	      var _this = this;
	
	      if (this.policyProp === null) {
	        return _backoffice2.default.policies.make(this.policy, function () {
	          _maggieHelper2.default.notification('', 'policy created');
	          _this.key++;
	          location.reload();
	          _this.$refs[_this.componentId].close();
	        });
	      }
	
	      return _backoffice2.default.policies.select(this.policy.id).edit(this.policy, function (data) {
	        _maggieHelper2.default.notification('', 'policy updated');
	        _this.key++;
	        location.reload();
	        _this.$refs[_this.componentId].close();
	      });
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return this.policyProp !== null ? 'voidReveal-' + this.policyProp.id : 'voidReveal-' + this._uid;
	    },
	    startValid: function startValid() {
	      var pattern = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/;
	      if (this.policy.configuration.booking_hours.start === null || this.policy.configuration.booking_hours.start === '') {
	        return true;
	      }
	      return pattern.test(this.policy.configuration.booking_hours.start);
	    },
	    endValid: function endValid() {
	      var pattern = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/;
	      if (this.policy.configuration.booking_hours.end === null || this.policy.configuration.booking_hours.end === '') {
	        return true;
	      }
	      return pattern.test(this.policy.configuration.booking_hours.end);
	    }
	  },
	  props: {
	    policyProp: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PreauthList",
	  components: { BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(1926)
	    };
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
	
	      var body = this.reservation ? { reservation_id: this.reservation.id } : null;
	      return _backoffice2.default.reservations.list(page, resultsPerPage).preauths(body, function (data) {
	        callback(data);
	      });
	    }
	  },
	  props: {
	    reservation: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _eventBus = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PreauthReveal',
	  components: { ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      amount: 0
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      return _backoffice2.default.reservations.select(this.reservation.id).requestPreauth(this.amount, function () {
	        _maggieHelper2.default.notification('', 'preauth created');
	        _eventBus.EventBus.$emit('reload-list');
	        _this.$refs[_this.componentId].close();
	      });
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return 'chargeReveal-' + this._uid;
	    }
	  },
	  props: {
	    reservation: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'NotificationList',
	  components: {
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1927)
	    };
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      return _backoffice2.default.registrationTokens.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _StartEndTimePicker = __webpack_require__(128);
	
	var _StartEndTimePicker2 = _interopRequireDefault(_StartEndTimePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeCommonCost = __webpack_require__(71);
	
	var _SelectizeCommonCost2 = _interopRequireDefault(_SelectizeCommonCost);
	
	var _SelectizePlan = __webpack_require__(92);
	
	var _SelectizePlan2 = _interopRequireDefault(_SelectizePlan);
	
	var _SelectizeFederation = __webpack_require__(2095);
	
	var _SelectizeFederation2 = _interopRequireDefault(_SelectizeFederation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RegistrationTokenReveal',
	  components: {
	    SelectizeFederation: _SelectizeFederation2.default,
	    SelectizePlan: _SelectizePlan2.default, SelectizeCommonCost: _SelectizeCommonCost2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default, StartEndTimePicker: _StartEndTimePicker2.default, DatePicker: _DatePicker2.default
	  },
	  data: function data() {
	    return {
	      destinations: {
	        'App\\Models\\Plan': 'Plan',
	        'App\\Models\\Federation': 'Federation',
	        'App\\Models\\CommonCost': 'Common Cost'
	      },
	      body: {
	        token: null,
	        destination_type: null,
	        destination_id: null,
	        additional: []
	      },
	      additional_type: null,
	      additional_id: null,
	      key: 0
	    };
	  },
	  created: function created() {
	    if (this.item !== null) {
	      for (var key in this.item) {
	        this.body[key] = this.item[key];
	        if (key === 'additional' && this.item[key] === null || this.item[key] === "[]") {
	          this.body[key] = [];
	        }
	      }
	    }
	  },
	
	  methods: {
	    closeInput: function closeInput(event) {
	      if (!event) {
	        this.key++;
	      }
	    },
	    save: function save() {
	      var _this = this;
	
	      if (this.type !== 'edit') {
	        return _backoffice2.default.registrationTokens.make(this.body, function () {
	          _maggieHelper2.default.notification('', 'token created');
	          _this.body = {};
	          _this.$emit('itemUpdated');
	          _this.$refs[_this.componentId].close();
	          window.location.reload();
	        });
	      }
	
	      return _backoffice2.default.registrationTokens.select(this.item.id).edit(this.body, function (data) {
	        _maggieHelper2.default.notification('', 'token updated');
	        _this.$emit('itemUpdated');
	        _this.$refs[_this.componentId].close();
	      });
	    },
	    addAdditional: function addAdditional() {
	      this.body.additional.push({ class: this.additional_type, id: this.additional_id });
	      this.additional_type = null;
	
	      this.additional_id = null;
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return this.item !== null ? 'token-' + this.item.id : 'token-' + this._uid;
	    }
	  },
	  props: {
	    item: {
	      type: Object,
	      default: null
	    },
	    type: {
	      default: null
	    }
	  }
	};

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ReportingListForm = __webpack_require__(148);
	
	var _ReportingListForm2 = _interopRequireDefault(_ReportingListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ReportingList",
	  components: {
	    ReportingListForm: _ReportingListForm2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(135),
	      search: null
	    };
	  },
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      _backoffice2.default.reportings.list(page, resultsPerPage, search).all(function (data) {
	        callback(data);
	      });
	    },
	    setSearch: function setSearch(search) {
	      this.search = search;
	    }
	  }
	};

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _EditReportingType = __webpack_require__(127);
	
	var _EditReportingType2 = _interopRequireDefault(_EditReportingType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReportingTypesList',
	  components: { EditReportingType: _EditReportingType2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      types: [],
	      activeIndex: null
	
	    };
	  },
	  created: function created() {
	    this.loadReportingTypes();
	  },
	
	  methods: {
	    setSearch: function setSearch(index) {
	      this.activeIndex = index;
	    },
	    reportEdited: function reportEdited(type) {
	      this.$refs['reveal-' + type.uid][0].close();
	      this.loadReportingTypes();
	    },
	    loadReportingTypes: function loadReportingTypes() {
	      var _this = this;
	
	      _backoffice2.default.reportings.list(null, null).types(function (data) {
	        _this.types = data;
	      });
	    }
	  }
	};

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ReservationListForm = __webpack_require__(124);
	
	var _ReservationListForm2 = _interopRequireDefault(_ReservationListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationList',
	  components: {
	    Cards: _Cards2.default,
	    HeaderColumns: _HeaderColumns2.default,
	    ReservationListForm: _ReservationListForm2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(37),
	      headers: ['', 'Reservation', 'Vehicle', 'Start', 'End', 'B.mode', 'Distance', 'Time', 'Cost', 'Status'],
	      search: null,
	      reports: null,
	      timeToSearch: null,
	      timeFromSearch: null
	    };
	  },
	
	  methods: {
	    setSearch: function setSearch(search) {
	      this.search = search;
	      this.$refs.list.debouncedLoader();
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      if (search && search.query) {
	        _backoffice2.default.reservations.list(page, resultsPerPage, search).search(function (data) {
	          callback(data);
	        });
	        return;
	      }
	      _backoffice2.default.reservations.list(page, resultsPerPage, search).all(function (data) {
	        callback(data);
	      });
	    },
	    getReports: function getReports(range) {
	      var _this = this;
	
	      this.reports = null;
	      if (this.$acl('reservations-reports')) {
	        _backoffice2.default.reports.list(range).reservations(function (data) {
	          _this.reports = data;
	        });
	        this.timeFromSearch = range.start;
	        this.timeToSearch = range.end;
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    parsedReports: function parsedReports() {
	      if (!this.reports) {
	        return [];
	      }
	
	      return [{
	        title: 'Average distance',
	        value: this.reports.average_km + ('' + this.configuration.locale.locale_distance_unit.value)
	      }, {
	        title: 'Tot. Reserv.',
	        value: this.reports.reservation_count
	      }, {
	        title: 'Booked hours',
	        value: this.reports.total_booked_hours
	      }, {
	        title: 'Driven distance',
	        value: this.reports.total_driven_km + ('' + this.configuration.locale.locale_distance_unit.value)
	      }];
	    }
	  })
	};

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(104);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _SelectizeDriver = __webpack_require__(25);
	
	var _SelectizeDriver2 = _interopRequireDefault(_SelectizeDriver);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _SelectizeParkingLot = __webpack_require__(150);
	
	var _SelectizeParkingLot2 = _interopRequireDefault(_SelectizeParkingLot);
	
	var _SelectizePlan = __webpack_require__(92);
	
	var _SelectizePlan2 = _interopRequireDefault(_SelectizePlan);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationPlanner',
	  components: {
	    SelectizePlan: _SelectizePlan2.default,
	    SelectizeParkingLot: _SelectizeParkingLot2.default,
	    SelectizeDriver: _SelectizeDriver2.default,
	    Vehicle: _Vehicle2.default,
	    ActionButton: _ActionButton2.default,
	    DatePicker: _DatePicker2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(37),
	      driver: null,
	      startDate: null,
	      contractDuration: 3,
	      parkingLotId: null,
	      planId: null,
	      selectedPresets: [],
	      selectedPreset: null,
	      customShifts: '',
	      vehicles: [],
	      plans: [],
	      multipleMode: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.selects.plans(true, function (data) {
	      _this.plans = data;
	      _this.loading = false;
	    });
	  },
	
	  methods: {
	    setParkingLot: function setParkingLot(obj) {
	      this.parkingLotId = obj.id;
	    },
	    unsetParkingSlot: function unsetParkingSlot() {
	      this.parkingLotId = null;
	    },
	    bookVehicle: function bookVehicle(plate) {
	      var _this2 = this;
	
	      if (this.driver === null) {
	        return;
	      }
	
	      return _backoffice2.default.reservations.bookPlanning(this.getBody(plate), function (x) {
	        _maggieHelper2.default.notification('Cargo', 'In progress');
	        console.log(x);
	        _this2.$router.push({ name: 'cargo-operation', params: { id: x.cargo_id } });
	      });
	    },
	    search: function search() {
	      var _this3 = this;
	
	      return _backoffice2.default.reservations.planning(this.getBody(), function (data) {
	        _this3.vehicles = data;
	      });
	    },
	    getBody: function getBody(plate) {
	      return {
	        driver_id: this.driver ? this.driver.id : null,
	        plate: plate,
	        parking_lot_id: this.parkingLotId,
	        plan_id: this.planId,
	        week_planning: this.shifts,
	        contract_duration: this.contractDuration,
	        start_date: this.startDate
	      };
	    },
	    gridStyle: function gridStyle(slots) {
	      var auto = slots.length > 3 ? 'auto auto auto' : 'repeat(' + slots.length + ',auto)';
	      return {
	        gridTemplateColumns: auto
	      };
	    },
	    getPlanName: function getPlanName(id) {
	      var v = null;
	      this.plans.forEach(function (p) {
	        if (p.id == id) {
	          v = p.name;
	          return;
	        }
	      });
	      return v;
	    }
	  },
	  watch: {
	    selectedPreset: function selectedPreset(n, o) {
	      if ((0, _typeof3.default)(this) !== undefined) {
	        this.planId = this.shiftsPresets[this.selectedPreset].plan_id;
	      }
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    shiftsPresets: function shiftsPresets() {
	      if (this.configuration) {
	        return this.configuration.visual.visual_shifts.value;
	      } else {
	        return [];
	      }
	    },
	    shifts: function shifts() {
	      var result = [];
	      if (this.multipleMode) {
	        var len = this.shiftsPresets.length;
	        var plan = null;
	        for (var i = 0; i < len; i++) {
	          if (this.selectedPresets[i]) {
	            if (!plan) {
	              plan = this.shiftsPresets[i].plan_id;
	            }
	            result.push(this.shiftsPresets[i].color + " " + this.shiftsPresets[i].shift);
	          }
	        }
	        if (plan) {
	          this.planId = plan;
	        }
	        this.customShifts.split('\n').forEach(function (i) {
	          var trim = i.trim();
	          if (trim.split(" ").length === 4) {
	            result.push(trim);
	          }
	        });
	      } else {
	        if (this.shiftsPresets[this.selectedPreset]) {
	          result.push(this.shiftsPresets[this.selectedPreset].color + " " + this.shiftsPresets[this.selectedPreset].shift);
	        }
	      }
	      return result;
	    },
	    slotsByLots: function slotsByLots() {
	      var c = (0, _collect2.default)(this.vehicles);
	      return c.groupBy(function (item) {
	        return item.vehicle.parking_lot.name;
	      }).all();
	    }
	  })
	};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ReservationRate = __webpack_require__(540);
	
	var _ReservationRate2 = _interopRequireDefault(_ReservationRate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "NoteList",
	  components: { ReservationRate: _ReservationRate2.default, BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      reservation_rates: [],
	      component: __webpack_require__(540)
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.reservationRates.list.rates(function (data) {
	      _this.reservation_rates = data.reverse();
	    });
	  },
	
	  methods: {}
	};

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapMarker = __webpack_require__(72);
	
	var _GoogleMapMarker2 = _interopRequireDefault(_GoogleMapMarker);
	
	var _GoogleMapPolyline = __webpack_require__(2102);
	
	var _GoogleMapPolyline2 = _interopRequireDefault(_GoogleMapPolyline);
	
	var _Slider = __webpack_require__(2027);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _vuex = __webpack_require__(10);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationRoute',
	  components: {
	    GoogleMapContainer: _GoogleMapContainer2.default,
	    Slider: _Slider2.default,
	    GoogleMap: _GoogleMap2.default,
	    GoogleMapMarker: _GoogleMapMarker2.default,
	    GoogleMapPolyline: _GoogleMapPolyline2.default,
	    GoogleMapPolygon: _GoogleMapPolygon2.default
	  },
	  data: function data() {
	    return {
	      routes: [],
	      showMarkers: true,
	      currentPointStep: 0,
	      autoPlay: false,
	      player: null,
	      zones: {
	        allowed: null,
	        forbidden: null,
	        undesirable: null
	      }
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.parkingLots.select(this.item.vehicle.parking_lot.id).get(function (data) {
	      _this.zones.allowed = data.allowed_zone;
	      _this.zones.forbidden = data.forbidden_zone;
	      _this.zones.undesirable = data.undesiderable_zone;
	    });
	    _backoffice2.default.reservations.select(this.item).route(function (data) {
	      _this.routes = data;
	    });
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    center: function center(value) {
	      if (value === 0) {
	        return;
	      }
	      this.$refs.logs.pan(this.routes[this.currentPoint]);
	    },
	    togglePlay: function togglePlay() {
	      var _this2 = this;
	
	      this.autoPlay = !this.autoPlay;
	
	      if (this.autoPlay === false) {
	        clearInterval(this.player);
	        return;
	      }
	
	      if (this.currentPointStep === this.routes.length) {
	        this.currentPointStep = 0;
	      }
	
	      this.player = setInterval(function () {
	        _this2.center();
	        _this2.currentPointStep++;
	
	        if (_this2.currentPointStep === _this2.routes.length) {
	          _this2.autoPlay = false;
	          clearInterval(_this2.player);
	        }
	      }, 1500);
	    },
	    formatDate: function formatDate(date) {
	      var formatted = this.$date(date).format('DD MMM YYYY~HH:mm:ss');
	      return formatted.split('~');
	    }
	  },
	  computed: (0, _extends3.default)({
	    mapsAPI: function mapsAPI() {
	      return window.env.GOOGLE_MAPS_KEY;
	    },
	    showRoute: function showRoute() {
	      return this.routes.slice(0, this.currentPointStep);
	    },
	    autoPlayClass: function autoPlayClass() {
	      return this.autoPlay ? 'fa-pause' : 'fa-play';
	    },
	    currentPoint: function currentPoint() {
	      return this.currentPointStep === 0 ? 0 : this.currentPointStep - 1;
	    },
	    mapCenter: function mapCenter() {
	      if (this.item.extra[this.item.booking_mode.toLowerCase()] !== undefined && this.item.extra[this.item.booking_mode.toLowerCase()].position !== undefined) {
	        return this.item.extra[this.item.booking_mode.toLowerCase()].pickup.position;
	      }
	
	      return {
	        lat: this.configuration.application.application_default_latitude.default,
	        lng: this.configuration.application.application_default_longitude.default
	      };
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: ['item']
	};

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _StartEndTimePicker = __webpack_require__(128);
	
	var _StartEndTimePicker2 = _interopRequireDefault(_StartEndTimePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeCommonCost = __webpack_require__(71);
	
	var _SelectizeCommonCost2 = _interopRequireDefault(_SelectizeCommonCost);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationUncoveredAmountReveal',
	  components: { SelectizeCommonCost: _SelectizeCommonCost2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default, StartEndTimePicker: _StartEndTimePicker2.default, DatePicker: _DatePicker2.default },
	  data: function data() {
	    return {
	      body: {
	        code: null,
	        start: null,
	        end: null,
	        max_uses: null,
	        max_days: null,
	        common_cost_id: null
	      }
	    };
	  },
	  created: function created() {
	    if (this.couponProp !== null) {
	      for (var key in this.couponProp) {
	        if (key === 'common_cost') {
	          this.body.common_cost_id = this.couponProp.common_cost.id;
	        } else {
	          this.body[key] = this.couponProp[key];
	        }
	      }
	    }
	  },
	
	  methods: {
	    setCommonCost: function setCommonCost(obj) {
	      this.body.common_cost_id = obj.id;
	    },
	    save: function save() {}
	  },
	  computed: {
	    componentId: function componentId() {
	      return this.couponProp !== null ? 'voidReveal-' + this.couponProp.id : 'voidReveal-' + this._uid;
	    }
	  },
	  props: {}
	};

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(37),
	
	      search: {
	        flag: 'HOLD_BILLING'
	      }
	    };
	  },
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      if (search) {
	        _backoffice2.default.reservations.list(page, resultsPerPage, search).all(function (data) {
	          callback(data);
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(1202);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RoleEdit',
	  components: { ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      permissions: [],
	      role: {
	        name: null,
	        description: null,
	        permissions: [],
	        menu: []
	      },
	      available: [],
	      defaultPermissions: ['profile-user', 'drivers-select-list', 'clients-select-list', 'plans-select-list', 'categories-select-list', 'vehicles-select-list', 'vehicle-slots-select-list', 'parking-lots-select-list', 'reporting-types-select-list', 'reservation-rates-select-list', 'distance-rates-select-list', 'time-rates-select-list', 'vehicle-brands-select-list', 'search-search']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.roles.list().permissions(function (data) {
	      _this.available = data;
	    });
	
	    if (this.$route.params.id !== undefined) {
	
	      this.role.name = this.item.name;
	      this.role.description = this.item.description;
	
	      this.item.permissions.forEach(function (item) {
	
	        if (item.name.startsWith('menu')) {
	          _this.role.menu.push(item.name);
	        } else {
	          _this.role.permissions.push(item.name);
	        }
	      });
	    }
	  },
	
	  methods: {
	    save: function save() {
	      var _this2 = this;
	
	      var permissions = [].concat((0, _toConsumableArray3.default)(this.selectedMesh), (0, _toConsumableArray3.default)(this.defaultPermissions));
	      this.role.permissions = [];
	      this.available.forEach(function (item) {
	        permissions.forEach(function (selected) {
	          if (item.name === selected) {
	            _this2.role.permissions.push(item.id);
	          }
	        });
	      });
	
	      if (this.$route.params.id !== undefined) {
	        return _backoffice2.default.roles.select(this.item).edit(this.role, function () {
	          _maggieHelper2.default.notification('Done', 'Role updated');
	          _this2.$router.push({ name: 'roles' });
	        });
	      }
	
	      return _backoffice2.default.roles.make(this.role, function (data) {
	        _maggieHelper2.default.notification('Done', 'Role created');
	        _this2.$router.push({ name: 'roles' });
	      });
	    }
	  },
	  computed: {
	    selectedMesh: function selectedMesh() {
	      var _this3 = this;
	
	      var mesh = [];
	      this.role.menu.forEach(function (item, key) {
	        mesh.push.apply(mesh, (0, _toConsumableArray3.default)(_this3.permissionsMesh[item]));
	      });
	
	      return mesh;
	    },
	    permissionsMesh: function permissionsMesh() {
	      return {
	        'menu_overview': ['charged-reservations-charts', 'client-registrations-charts', 'driven-distance-charts', 'driver-registrations-charts', 'index-reporting', 'index-reservations', 'index-vehicle-alarm', 'index-vehicles', 'index-zone', 'vehicle-distance-charts', 'vehicle-reservations-charts'],
	        'menu_todo': ['activate-clients', 'add-attachment-driver-licenses', 'approval-client', 'approval-document', 'approval-driver', 'approve-driver-licenses', 'approve-drivers', 'balance-billing', 'delete-clients', 'delete-driver-licenses', 'get-clients', 'get-drivers-clients', 'index-document-type', 'licenses-drivers', 'patch-document', 'refuse-driver-licenses'],
	        'menu_customers': ['all-cards', 'approve-drivers', 'availability-vehicles', 'cards-drivers', 'clients-reports', 'create-cards', 'driver-index-reservations', 'edit-drivers', 'get-driver-subscriptions-subscriptions', 'get-drivers', 'get-subscriptions-subscriptions', 'index-client-types', 'index-clients', 'index-document-type', 'index-drivers', 'index-log', 'licenses-drivers', 'reactivate-drivers', 'reset-password-driver', 'send-reset-driver', 'store-document', 'store-driver', 'suspend-drivers', 'tocs-driver', 'get-clients', 'get-drivers-clients', 'index-reservations', 'plan-select-list', 'balance-billing', 'get-client-subscriptions-subscriptions', 'index-transactions'],
	        'menu_booking': ['availability-vehicles', 'complete-reservation', 'debug-info-reservations', 'delete-reservation', 'deposits-reservation', 'edit-reservation', 'get-reservations', 'index-note', 'index-reservations', 'new-book-reservation', 'open-reservation', 'resend-to-vehicle-reservation', 'reservations-reports', 'route-reservation', 'search-vehicle-slots', 'void-reservation-reservation', 'vehicles-select-list'],
	        'menu_billing': ['get-clients', 'get-invoices', 'index-invoices', 'invoices-reports', 'pay-invoices', 'payed-invoices', 'void-invoices', 'index-transactions'],
	        'menu_assets': ['availability-vehicles', 'close-vehicle', 'compute-roi-vehicle', 'create-parking-slot', 'create-vehicle-categories', 'create-vehicle-types', 'data-vehicles', 'delete-note', 'delete-vehicle-attributes', 'delete-zone', 'deposits-reservation', 'disable-vehicle-slots', 'dismiss-vehicle-slot', 'drain-vehicle-slot', 'edit-vehicle-categories', 'get-parking-groups', 'get-parking-lots', 'get-reservations', 'get-vehicle-slots', 'get-vehicles', 'index-instruction', 'index-note', 'index-parking-groups', 'index-public-file', 'index-reporting', 'index-reservations', 'index-vehicle-attributes', 'index-vehicle-categories', 'index-vehicle-instruction', 'index-vehicle-slot', 'index-vehicle-types', 'index-vehicles', 'index-zone', 'list-attributes-vehicle', 'managers-vehicle-hardware', 'movements-vehicles', 'open-vehicle', 'patch-vehicle-attributes', 'patch-zone', 'put-note', 'route-reservation', 'show-zone', 'slots-parking-lot', 'store-vehicle-attributes', 'swap-vehicle-slot', 'types-asset-costs', 'vehicles-reports', 'vehicles-reports', 'view-vehicle-attributes'],
	        'menu_support': ['create-reporting', 'delete-instruction', 'edit-reporting', 'get-reporting', 'get-vehicles', 'index-instruction', 'index-reporting', 'patch-instruction', 'patch-reporting-type', 'types-reporting', 'update-status-reporting', 'store-reporting-type', 'view-instruction'],
	        'menu_config': ['index-client-types', 'index-document-requirement', 'index-document-type', 'index-federation', 'index-group', 'index-plan', 'index-policy', 'index-reservation-rate', 'index-role', 'index-toc', 'index-toc-type', 'list-commands-console']
	      };
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _Role = __webpack_require__(541);
	
	var _Role2 = _interopRequireDefault(_Role);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'RoleList',
	  components: {
	    Role: _Role2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(541),
	      roles: []
	    };
	  },
	  created: function created() {
	    this.dataLoader();
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.roles.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _Attributes = __webpack_require__(195);
	
	var _Attributes2 = _interopRequireDefault(_Attributes);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SegmentAttributesReveal",
	  components: { Attributes: _Attributes2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      body: {
	        attributes: this.segment.attributes
	      }
	    };
	  },
	
	  methods: {
	    updateAttribute: function updateAttribute(attribute) {
	      var _this = this;
	
	      if (attribute.id) {
	        return _backoffice2.default.segmentAttributes.select(attribute.id).edit({ value: attribute.value }, function (data) {
	          return data;
	        });
	      }
	      attribute.segment_id = this.segment.id;
	      return _backoffice2.default.segmentAttributes.make(attribute, function (data) {
	        _this.body.attributes[_this.body.attributes.length - 1].id = data.id;
	        return data;
	      });
	    },
	    deleteAttribute: function deleteAttribute(attribute) {
	      return _backoffice2.default.segmentAttributes.select(attribute.id).delete(function () {
	        _maggieHelper2.default.notification('attribute', 'Attribute deleted');
	      });
	    }
	  },
	
	  computed: {
	    componentId: function componentId() {
	      return this.segment !== null ? "segmentAttributeReveal-" + this.segment.id : "segmentAttributeReveal-" + this._uid;
	    }
	  },
	
	  props: {
	    segment: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _SegmentReveal = __webpack_require__(2055);
	
	var _SegmentReveal2 = _interopRequireDefault(_SegmentReveal);
	
	var _SegmentRateReveal = __webpack_require__(605);
	
	var _SegmentRateReveal2 = _interopRequireDefault(_SegmentRateReveal);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SegmentAttributesReveal = __webpack_require__(2176);
	
	var _SegmentAttributesReveal2 = _interopRequireDefault(_SegmentAttributesReveal);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _SegmentSlotsReveal = __webpack_require__(2178);
	
	var _SegmentSlotsReveal2 = _interopRequireDefault(_SegmentSlotsReveal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SegmentList',
	  components: {
	    SegmentSlotsReveal: _SegmentSlotsReveal2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    SegmentAttributesReveal: _SegmentAttributesReveal2.default,
	    ActionButton: _ActionButton2.default,
	    Dropdown: _Dropdown2.default,
	    SegmentRateReveal: _SegmentRateReveal2.default,
	    SegmentReveal: _SegmentReveal2.default,
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1930),
	      segments: [],
	      activeIndex: 0,
	      loading: false,
	      search: {
	        segment_id: null
	      }
	    };
	  },
	  created: function created() {
	    this.loadSegments();
	  },
	
	  methods: {
	    loadSegments: function loadSegments() {
	      var _this = this;
	
	      this.loading = true;
	      _backoffice2.default.segments.list(1, -1).all(function (data) {
	        _this.segments = data.items;
	        _this.loading = false;
	      });
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      return _backoffice2.default.segmentRates.list(page, resultsPerPage, this.segments[this.activeIndex].id).all(function (data) {
	        callback(data);
	      });
	    },
	    setSearch: function setSearch(index) {
	      if (this.activeIndex === index) {
	        return;
	      }
	
	      this.activeIndex = index;
	      this.search.segment_id = this.segments[index].id;
	    }
	  }
	};

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _StartEndTimePicker = __webpack_require__(128);
	
	var _StartEndTimePicker2 = _interopRequireDefault(_StartEndTimePicker);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _SelectizeCommonCost = __webpack_require__(71);
	
	var _SelectizeCommonCost2 = _interopRequireDefault(_SelectizeCommonCost);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _SelectizeVehicleAttributesArrayEdit = __webpack_require__(559);
	
	var _SelectizeVehicleAttributesArrayEdit2 = _interopRequireDefault(_SelectizeVehicleAttributesArrayEdit);
	
	var _Attributes = __webpack_require__(195);
	
	var _Attributes2 = _interopRequireDefault(_Attributes);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _TranslateField = __webpack_require__(64);
	
	var _TranslateField2 = _interopRequireDefault(_TranslateField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SegmentRateReveal',
	  components: {
	    TranslateField: _TranslateField2.default,
	    Editor: _Editor2.default,
	    Attributes: _Attributes2.default,
	    SelectizeVehicleAttributesArrayEdit: _SelectizeVehicleAttributesArrayEdit2.default,
	    LoadingSpinner: _LoadingSpinner2.default, SelectizeCommonCost: _SelectizeCommonCost2.default, ActionButton: _ActionButton2.default, ModalReveal: _ModalReveal2.default, StartEndTimePicker: _StartEndTimePicker2.default, DatePicker: _DatePicker2.default
	  },
	  data: function data() {
	    return {
	      body: {
	        segment_id: this.segment !== null ? this.segment.id : null,
	        description: "",
	        extended_description: "",
	        reservation_rate_id: null
	      },
	      reservation_rates: [],
	      loading: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    _backoffice2.default.reservationRates.list.rates(function (rates) {
	      _this.reservation_rates = rates.reverse();
	      _this.loading = false;
	      if (_this.item !== null) {
	        for (var key in _this.item) {
	          switch (key) {
	            case 'reservation_rate':
	              _this.body.reservation_rate_id = _this.item['reservation_rate'].id;
	              break;
	            case 'segment':
	              _this.body.segment_id = _this.item['segment'].id;
	              break;
	            default:
	              _this.body[key] = _this.item[key];
	
	          }
	        }
	      }
	    });
	  },
	
	  methods: {
	    save: function save() {
	      var _this2 = this;
	
	      if (this.item !== null) {
	        return _backoffice2.default.segmentRates.select(this.item.id).edit(this.body, function () {
	          _this2.$emit('itemUpdated');
	          _this2.$refs[_this2.componentId].close();
	        });
	      } else {
	        return _backoffice2.default.segmentRates.make(this.body, function () {
	          _this2.$emit('itemUpdated');
	          _this2.$refs[_this2.componentId].close();
	        });
	      }
	    },
	    updateAttribute: function updateAttribute(attribute) {
	      var _this3 = this;
	
	      if (attribute.id) {
	        return _backoffice2.default.segmentAttributes.select(attribute.id).edit({ value: attribute.value }, function () {
	          _maggieHelper2.default.notification('attribute', 'Attribute updated');
	        });
	      }
	      attribute.segment_id = this.item.id;
	      _backoffice2.default.segmentAttributes.make(attribute, function (data) {
	        _this3.body.attributes[_this3.body.attributes.length - 1].id = data.id;
	      });
	    },
	    deleteAttribute: function deleteAttribute(attribute) {
	      return _backoffice2.default.segmentAttributes.select(attribute.id).delete(function () {
	        _maggieHelper2.default.notification('attribute', 'Attribute updated');
	      });
	    }
	  },
	  computed: {
	    componentId: function componentId() {
	      return this.item !== null ? 'segmentRateReveal-' + this.item.id : 'segmentRateReveal-' + this._uid;
	    }
	  },
	  props: {
	    item: {
	      type: Object,
	      default: null
	    },
	    segment: {
	      type: Object,
	      default: null
	    }
	
	  }
	};

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _Attributes = __webpack_require__(195);
	
	var _Attributes2 = _interopRequireDefault(_Attributes);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SelectizeVehicle = __webpack_require__(26);
	
	var _SelectizeVehicle2 = _interopRequireDefault(_SelectizeVehicle);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SegmentSlotsReveal",
	  components: { ActionButton: _ActionButton2.default, BaseList: _BaseList2.default, SelectizeVehicle: _SelectizeVehicle2.default, Attributes: _Attributes2.default, ModalReveal: _ModalReveal2.default },
	  data: function data() {
	    return {
	      entity: null,
	      component: __webpack_require__(20),
	      loadedItems: [],
	      selected: {
	
	        add: [],
	        delete: []
	
	      },
	      body: {
	        name: []
	
	      }
	    };
	  },
	
	  methods: {
	    add: function add(val) {
	      this.selected.add.push(val.id);
	    },
	    saveVehicles: function saveVehicles() {
	      var _this = this;
	
	      var body = {
	        vehicles: this.selected.add
	      };
	      return _backoffice2.default.segments.select(this.segment.id).addVehicles(body, function () {
	        _this.$refs.list.loadData(1);
	        _this.$refs.select.clearSelected();
	        _this.selected.add = [];
	      });
	    },
	    deleteVehicles: function deleteVehicles() {
	      var _this2 = this;
	
	      var body = {
	        vehicles: this.selected.delete
	      };
	      return _backoffice2.default.segments.select(this.segment.id).removeVehicles(body, function () {
	        _this2.$refs.list.loadData(1);
	        _this2.$refs.select.clearSelected();
	        _this2.selected.delete = [];
	      });
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.segments.select(this.segment.id).vehicles(page, resultsPerPage, function (data) {
	        callback(data);
	      });
	    }
	  },
	
	  computed: {
	    componentId: function componentId() {
	      return "segmentVehicleReveal-" + this.segment.id;
	    }
	  },
	
	  props: {
	    segment: {
	      type: Object,
	      default: null
	    }
	  }
	};

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapMarker = __webpack_require__(72);
	
	var _GoogleMapMarker2 = _interopRequireDefault(_GoogleMapMarker);
	
	var _GoogleMapCircle = __webpack_require__(152);
	
	var _GoogleMapCircle2 = _interopRequireDefault(_GoogleMapCircle);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	var _GoogleMapMarkerCluster = __webpack_require__(226);
	
	var _GoogleMapMarkerCluster2 = _interopRequireDefault(_GoogleMapMarkerCluster);
	
	var _GoogleMapDirectionsService = __webpack_require__(225);
	
	var _GoogleMapDirectionsService2 = _interopRequireDefault(_GoogleMapDirectionsService);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	var _SelectizeVehicleType = __webpack_require__(224);
	
	var _SelectizeVehicleType2 = _interopRequireDefault(_SelectizeVehicleType);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _InputSwitch = __webpack_require__(33);
	
	var _InputSwitch2 = _interopRequireDefault(_InputSwitch);
	
	var _Reservation = __webpack_require__(37);
	
	var _Reservation2 = _interopRequireDefault(_Reservation);
	
	var _Alarm = __webpack_require__(526);
	
	var _Alarm2 = _interopRequireDefault(_Alarm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Sentinel',
	  data: function data() {
	    return {
	      reservations: [],
	      alarms: [],
	      component: __webpack_require__(1931),
	
	      pooler: null,
	      mapCenter: {
	        lat: 0,
	        lng: 0
	      },
	      userPosition: null,
	      zones: [],
	      search: {
	        sentinellable: null
	      }
	    };
	  },
	
	
	  methods: {
	    test: function test(index) {
	      var clusterer = this.$refs.cluster;
	
	      var map = clusterer.getMap();
	
	      map.panTo(this.$refs.cluster.markers[index].position);
	      map.setZoom(20);
	      google.maps.event.trigger(this.$refs.cluster.markers[index], 'click');
	    },
	    pool: function pool() {
	      var _this = this;
	
	      this.pooler = setInterval(function () {
	        _this.loadReservations();
	        _this.$refs.baseList.loadData(1);
	      }, 15000);
	    },
	    optionSelected: function optionSelected(obj) {
	      this.body.vehicle_type_id = obj.id;
	    },
	    optionRemoved: function optionRemoved() {
	      this.body.vehicle_type_id = null;
	    },
	    loadReservations: function loadReservations() {
	      return _backoffice2.default.reservations.list(1, 25, {
	        status: 'STARTED'
	      }).all(function (data) {
	        return data;
	      });
	    },
	    loadAlarms: function loadAlarms(callback, page, resultsPerPage, search) {
	      return _backoffice2.default.sentinel.list(page, resultsPerPage, search).all(function (data) {
	        callback(data);
	      });
	    },
	    vehicleInRange: function vehicleInRange(inRange) {
	      return inRange ? '/static/map_pin_blue.png' : '/static/map_pin_red.png';
	    },
	    fullScreen: function fullScreen() {
	      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
	        if (document.exitFullscreen) {
	          document.exitFullscreen();
	        } else if (document.mozCancelFullScreen) {
	          document.mozCancelFullScreen();
	        } else if (document.webkitExitFullscreen) {
	          document.webkitExitFullscreen();
	        } else if (document.msExitFullscreen) {
	          document.msExitFullscreen();
	        }
	      } else {
	        var element = document.getElementById('fullscreenme');
	        if (element.requestFullscreen) {
	          element.requestFullscreen();
	        } else if (element.mozRequestFullScreen) {
	          element.mozRequestFullScreen();
	        } else if (element.webkitRequestFullscreen) {
	          element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
	        } else if (element.msRequestFullscreen) {
	          element.msRequestFullscreen();
	        }
	      }
	    }
	  },
	  components: {
	    BaseList: _BaseList2.default,
	    Alarm: _Alarm2.default,
	    Reservation: _Reservation2.default,
	    InputSwitch: _InputSwitch2.default,
	    ActionButton: _ActionButton2.default,
	    SelectizeVehicleType: _SelectizeVehicleType2.default,
	    GoogleMapContainer: _GoogleMapContainer2.default,
	    GoogleMapDirectionsService: _GoogleMapDirectionsService2.default,
	    Vehicle: _Vehicle2.default,
	    GoogleMap: _GoogleMap2.default,
	    GoogleMapMarker: _GoogleMapMarker2.default,
	    GoogleMapCircle: _GoogleMapCircle2.default,
	    GoogleMapMarkerCluster: _GoogleMapMarkerCluster2.default,
	    GoogleMapPolygon: _GoogleMapPolygon2.default
	  },
	  computed: {
	    mapsAPI: function mapsAPI() {
	      return window.env.GOOGLE_MAPS_KEY;
	    }
	  },
	  created: function created() {
	    var _this2 = this;
	
	    _backoffice2.default.reservations.list(1, 25, {
	      status: 'STARTED'
	    }).all(function (response) {
	      _this2.reservations = response.items.filter(function (item) {
	        return item.maintenance == false;
	      });
	    });
	
	    this.pool();
	  },
	  destroyed: function destroyed() {
	    clearInterval(this.pooler);
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this3.mapCenter.lat = data.application.application_default_latitude.value;
	      _this3.mapCenter.lng = data.application.application_default_longitude.value;
	    });
	
	    _backoffice2.default.zones.list.grouped(function (data) {
	      _this3.zones = data;
	    });
	  }
	};

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'StartEndTimePicker',
	
	    computed: {
	        hours: function hours() {
	            var date = (0, _moment2.default)().hours(0).minutes(0).seconds(0);
	            console.log(date);
	            var hours = [];
	            hours.push(date.format('HH:mm'));
	
	            for (var i = 0; i < 47; i++) {
	                hours.push(date.add(30, 'minutes').format('HH:mm'));
	            }
	            return hours;
	        }
	    },
	    props: ['value']
	
	};

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _SubscriptionListForm = __webpack_require__(2092);
	
	var _SubscriptionListForm2 = _interopRequireDefault(_SubscriptionListForm);
	
	var _StatisticsCard = __webpack_require__(142);
	
	var _StatisticsCard2 = _interopRequireDefault(_StatisticsCard);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _HeaderColumns = __webpack_require__(29);
	
	var _HeaderColumns2 = _interopRequireDefault(_HeaderColumns);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SubscriptionList",
	  components: {
	    HeaderColumns: _HeaderColumns2.default,
	    BaseList: _BaseList2.default,
	    StatisticsCard4: _StatisticsCard2.default,
	    SubscriptionListForm: _SubscriptionListForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(136),
	      headers: ["", "Subscription and Client ID", "Plan name", "B.mode", "Drivers", "Billing cycle", "Expiry", "Cost", ""],
	      search: null,
	      reports: null
	    };
	  },
	
	  methods: {
	    setSearch: function setSearch(search) {
	      this.search = search;
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      var _this = this;
	
	      if (search) {
	        if (search.active === "") {
	          delete search["active"];
	        }
	      }
	      console.log(search);
	      _backoffice2.default.subscriptions.list(page, resultsPerPage, search).all(function (data) {
	        callback(data);
	        _this.getReports(search);
	      });
	    },
	    getReports: function getReports(range) {
	      var _this2 = this;
	
	      var start = this.$date().startOf('month').format("Y-MM-DD");
	      var end = this.$date().endOf('month').format("Y-MM-DD");
	      if (range && range.expire_from && range.expire_to) {
	        start = range.expire_from;
	        end = range.expire_to;
	      }
	
	      _backoffice2.default.reports.list({ start: "2019-01-01", end: "2019-12-31" }).subscriptions(function (data) {
	        _this2.reports = data;
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    }
	  })
	};

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TocList",
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1932)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      _backoffice2.default.tocs.list.all(function (data) {
	        var tocs = {
	          current_page: 1,
	          current_page_count: 1,
	          items: [],
	          items_count: 10,
	          page_count: 1,
	          per_page_count: 25
	        };
	
	        tocs.items = data;
	        tocs.items_count = data.length;
	        callback(tocs);
	      });
	    }
	  }
	};

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TocList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1933)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback) {
	      _backoffice2.default.tocTypes.list.all(function (data) {
	        var tocs = {
	          current_page: 1,
	          current_page_count: 1,
	          items: [],
	          items_count: 10,
	          page_count: 1,
	          per_page_count: 25
	        };
	
	        tocs.items = data;
	        tocs.items_count = data.length;
	        callback(tocs);
	      });
	    }
	  }
	};

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _TransactionListForm = __webpack_require__(582);
	
	var _TransactionListForm2 = _interopRequireDefault(_TransactionListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "TransactionList",
	  components: {
	    BaseList: _BaseList2.default,
	    TransactionListForm: _TransactionListForm2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(40),
	      headers: ['', 'Date', 'Client', 'Payment method', 'Invoice', 'Amount', 'Status', ''],
	      search: null
	    };
	  },
	
	  methods: {
	    setSearch: function setSearch(search) {
	      this.search = search;
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      _backoffice2.default.transactions.list(page, resultsPerPage, search).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _TransactionButtons = __webpack_require__(147);
	
	var _TransactionButtons2 = _interopRequireDefault(_TransactionButtons);
	
	var _TranslationButtons = __webpack_require__(214);
	
	var _TranslationButtons2 = _interopRequireDefault(_TranslationButtons);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _TranslationEdit = __webpack_require__(157);
	
	var _TranslationEdit2 = _interopRequireDefault(_TranslationEdit);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _MdiIcon = __webpack_require__(80);
	
	var _MdiIcon2 = _interopRequireDefault(_MdiIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TranslateField',
	  components: {
	    MdiIcon: _MdiIcon2.default,
	    ModalReveal: _ModalReveal2.default,
	    TranslationEdit: _TranslationEdit2.default, Editor: _Editor2.default, TranslationButtons: _TranslationButtons2.default, TransactionActionButtons: _TransactionButtons2.default, LoadingSpinner: _LoadingSpinner2.default, ActionButton: _ActionButton2.default
	  },
	  data: function data() {
	    return {
	      translations: []
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    loadLang: function loadLang() {
	      var _this = this;
	
	      _backoffice2.default.translations.list.overridable([this.group], this.field, function (data) {
	        _this.translations = data;
	      });
	    }
	  },
	  computed: {},
	  props: {
	    group: {
	      type: String
	    },
	    field: {
	      type: String
	    },
	    label: {
	      type: String
	    },
	    value: {
	      type: String
	    },
	    showInput: {
	      type: Boolean,
	      default: false
	    },
	    editor: {
	      type: Boolean,
	      default: false
	    },
	    editable: {
	      type: Boolean,
	      default: true
	    }
	  }
	};

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(94);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TranslationAdd',
	  components: { LoadingSpinner: _LoadingSpinner2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      body: {
	        group: '',
	        key: '',
	        value: {}
	      },
	      name: '',
	
	      groups: ['notifications', 'exception', 'exceptions', 'flows', 'flow-image', 'hardware', 'paymentmethods', 'profile', 'reservation', 'reservations', 'results', 'subscription'],
	      langs: [],
	      firstSaving: true,
	      otherSaving: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this.langs = (0, _keys2.default)(data.application['application_default_language']['possibile']);
	    });
	  },
	
	  methods: {
	    sanitazeNullValues: function sanitazeNullValues(obj) {
	      (0, _entries2.default)(obj).forEach(function (o) {
	        return o[1] === null ? delete obj[o[0]] : 0;
	      });
	    },
	    save: function save() {
	      var _this2 = this;
	
	      this.body.group.trim();
	      this.body.key.trim();
	      this.sanitazeNullValues(this.body.value);
	      return _backoffice2.default.translations.make(this.body, function (data) {
	        _maggieHelper2.default.notification('Done', 'Translation created');
	        _this2.firstSaving = _this2.otherSaving;
	        _this2.body = {
	          group: '',
	          key: '',
	          value: {}
	        };
	      });
	    }
	  },
	  computed: {},
	  props: ['item']
	};

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _vuex = __webpack_require__(10);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _TransactionButtons = __webpack_require__(147);
	
	var _TransactionButtons2 = _interopRequireDefault(_TransactionButtons);
	
	var _TranslationButtons = __webpack_require__(214);
	
	var _TranslationButtons2 = _interopRequireDefault(_TranslationButtons);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TranslationEdit',
	  components: { Editor: _Editor2.default, TranslationButtons: _TranslationButtons2.default, TransactionActionButtons: _TransactionButtons2.default, LoadingSpinner: _LoadingSpinner2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      bodyDefault: {
	        group: '',
	        key: '',
	        value: []
	      },
	      otherValues: {
	        value: []
	      },
	      existingKeys: []
	    };
	  },
	  created: function created() {
	    this.existingKeys = (0, _keys2.default)(this.item.value);
	  },
	
	  methods: {
	    sanitazeNullValues: function sanitazeNullValues(obj) {
	      for (var key in obj) {
	        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
	          delete obj[key];
	        }
	      }
	    },
	    update: function update() {
	      this.body.group.trim();
	      this.body.key.trim();
	      (0, _assign2.default)(this.body.value, this.otherValues.value);
	      this.sanitazeNullValues(this.body.value);
	      this.body.editable = this.editable;
	      if (this.item.id !== undefined) {
	        return _backoffice2.default.translations.select(this.item.id).update(this.body, function (data) {
	          _maggieHelper2.default.notification('Done', 'Translation Updated');
	        });
	      } else {
	        return _backoffice2.default.translations.make(this.body, function (data) {
	          _maggieHelper2.default.notification('Done', 'Translation created');
	        });
	      }
	    }
	  },
	  computed: (0, _extends3.default)({
	    body: {
	      get: function get() {
	        this.bodyDefault.group = this.item.group;
	        this.bodyDefault.key = this.item.key;
	        this.sanitazeNullValues(this.item.value);
	        this.bodyDefault.value = this.item.value;
	        return this.bodyDefault;
	      },
	      set: function set(item) {
	
	        this.bodyDefault.group = item.group;
	        this.bodyDefault.key = item.key;
	        this.sanitazeNullValues(item.value);
	        this.bodyDefault.value = item.value;
	      }
	    }
	
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    allowedLanguages: function allowedLanguages() {
	      var systemFields = (0, _collect2.default)(this.configuration.system.system_fields_configuration.value);
	      var defaultLang = this.configuration.application.application_default_language.value;
	      var config = systemFields.first(function (i) {
	        return i.field === 'allowedLanguages';
	      });
	      if (config.config === null) {
	        return [];
	      }
	      if (config.field === 'allowedLanguages') {
	        var allowedLanguages = (0, _collect2.default)(this.configuration.system.system_fields_configuration.value).first(function (i) {
	          return i.field === 'allowedLanguages';
	        }).config.split(',');
	        if (this.skipDefaultLang) {
	          allowedLanguages = allowedLanguages.filter(function (lang) {
	            return lang !== defaultLang;
	          });
	        }
	        return allowedLanguages;
	      } else {
	        return [];
	      }
	    },
	    editableKeys: function editableKeys() {
	      var _this = this;
	
	      if (this.item.editable) {
	        return this.allowedLanguages;
	      }
	
	      return this.allowedLanguages.filter(function (k) {
	        return !_this.existingKeys.includes(k);
	      });
	    }
	  }),
	  props: {
	    item: {
	      type: Object
	    },
	    deleteButton: {
	      type: Boolean
	    },
	    editor: {
	      type: Boolean
	    },
	    skipDefaultLang: {
	      type: Boolean
	    },
	    editable: {
	      type: Boolean,
	      default: true
	    }
	  }
	};

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _vuex = __webpack_require__(10);
	
	var _GroupedTranslation = __webpack_require__(2149);
	
	var _GroupedTranslation2 = _interopRequireDefault(_GroupedTranslation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TranslationList',
	  components: {
	    GroupedTranslation: _GroupedTranslation2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1935),
	      overriddenTranslations: {},
	      overridableTranslations: {}
	    };
	  },
	  created: function created() {
	    this.loadOverridden();
	    this.loadOverridable();
	  },
	
	  methods: {
	    loadOverridden: function loadOverridden() {
	      var _this = this;
	
	      _backoffice2.default.translations.list.all(1, -1, function (data) {
	        _this.overriddenTranslations = (0, _collect2.default)(data.items).groupBy('group').all();
	      });
	    },
	    loadOverridable: function loadOverridable() {
	      var _this2 = this;
	
	      _backoffice2.default.translations.list.overridable(['notifications', 'exception', 'exceptions', 'flows', 'hardware', 'paymentmethods', 'profile', 'reservation', 'reservations', 'results', 'subscription', 'rate_descriptor', 'walletables'], null, function (data) {
	        _this2.overridableTranslations = (0, _collect2.default)(data).groupBy('group').all();
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    allowedLanguages: function allowedLanguages() {
	      return (0, _collect2.default)(this.configuration.system.system_fields_configuration.value).first(function (i) {
	        return i.field === 'allowedLanguages';
	      }).config.split(',');
	    }
	  })
	};

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UserEdit',
	  components: { ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      user: {
	        id: null,
	        federation_id: null,
	        username: null,
	        email: null,
	        enabled: false,
	        roles: []
	      },
	      roles: [],
	      federations: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.roles.list().all(function (data) {
	      _this.roles = data.items;
	    });
	    _backoffice2.default.federations.list(1, -1).all(function (data) {
	      _this.federations = data;
	    });
	
	    if (this.$route.params.id !== undefined) {
	      this.user = (0, _extends3.default)({}, this.item);
	      this.user.federation_id = this.item.federation !== null ? this.item.federation.id : null;
	
	      this.user.roles = this.user.roles.map(function (item) {
	        return item.id;
	      });
	    }
	  },
	
	  methods: {
	    save: function save() {
	      var _this2 = this;
	
	      if (this.$route.params.id !== undefined) {
	        return _backoffice2.default.users.select(this.item).edit(this.user, function () {
	          _maggieHelper2.default.notification('user', 'User updated');
	          _this2.$router.push({ name: 'users' });
	        });
	      }
	
	      return _backoffice2.default.users.make(this.user, function () {
	        _maggieHelper2.default.notification('user', 'User created');
	        _this2.$router.push({ name: 'users' });
	      });
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UserList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1936)
	    };
	  },
	  created: function created() {
	    this.dataLoader();
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.users.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VatList',
	  components: {
	    BaseList: _BaseList2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(1937)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.vats.list(page, resultsPerPage).all(function (data) {
	        callback(data);
	      });
	    }
	  }
	};

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VehicleAttributeList',
	  components: { BaseList: _BaseList2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(542)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    loadZones: function loadZones(callback) {
	      var instructions = {
	        current_page: 1,
	        current_page_count: 1,
	        items: [],
	        items_count: 10,
	        page_count: 1,
	        per_page_count: 25
	      };
	      _backoffice2.default.vehicleAttributes.list.all(function (data) {
	        instructions.items = data;
	        instructions.items_count = data.length;
	        callback(instructions);
	      });
	    }
	  }
	};

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _StatisticsCard = __webpack_require__(560);
	
	var _StatisticsCard2 = _interopRequireDefault(_StatisticsCard);
	
	var _VehicleListForm = __webpack_require__(583);
	
	var _VehicleListForm2 = _interopRequireDefault(_VehicleListForm);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleSlotList",
	  components: {
	    Cards: _Cards2.default,
	    BaseList: _BaseList2.default,
	    VehicleListForm: _VehicleListForm2.default,
	    StatisticsCard7: _StatisticsCard2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(20),
	      reports: null,
	      search: null
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    parsedReports: function parsedReports() {
	      if (!this.reports) {
	        return [];
	      }
	
	      return [{
	        title: "Total Driven distance",
	        value: this.reports.total_driven_km.toFixed(0) + ("" + this.configuration.locale.locale_distance_unit.value)
	      }, {
	        title: "Reservation / day",
	        value: this.reports.reservations_per_day
	      }, {
	        title: "Maintenance Res.",
	        value: this.reports.total_maintenance_reservation + " (" + this.reports.average_maintenance_reservations.toFixed(2) + "%" + ")"
	      }, {
	        title: "Res. number",
	        value: this.reports.total_reservation_number
	      }, {
	        title: "Reserved hours.",
	        value: this.reports.total_reserved_hours + "h"
	      }, {
	        title: "Fleet allocation.",
	        value: this.reports.vehicle_allocation + "%"
	      }];
	    }
	  }),
	  created: function created() {
	    this.getReports();
	  },
	
	  methods: {
	    setSearch: function setSearch(search) {
	      console.log(search);
	      this.search = search;
	    },
	    dataLoader: function dataLoader(callback, page, resultsPerPage, search) {
	      _backoffice2.default.vehicles.list(page, resultsPerPage).all(search, function (items) {
	        if (search && search.active !== null) {
	
	          items.items.forEach(function (item, index) {
	            if (search.active && item.slot_disabled === 1) {} else if (search.active && item.slot_disabled === 0) {
	              items.items.splice(index, 1);
	            }
	          });
	        }
	        callback(items);
	      });
	    },
	    getReports: function getReports() {
	      var _this = this;
	
	      var range = {
	        start: this.$date().startOf('month').subtract(1, 'month').format("YYYY-MM-DD"),
	        end: this.$date().endOf('month').subtract(1, 'month').format("YYYY-MM-DD")
	      };
	
	      _backoffice2.default.reports.list(range).vehicles(function (data) {
	        _this.reports = data;
	      });
	    }
	  }
	};

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "VehicleTypesList",
	  components: {},
	  data: function data() {
	    return {
	      types: [],
	      activeIndex: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicleTypes.list.all(function (data) {
	      _this.types = data;
	      _this.setSearch(0);
	    });
	  },
	
	  methods: {
	    setSearch: function setSearch(index) {
	      this.activeIndex = index;
	    },
	    deleteType: function deleteType() {
	      var _this2 = this;
	
	      this.$confirm('Are you sure?', 'Do you really want to delete this type?', function () {
	        _backoffice2.default.vehicleTypes.select(_this2.types[_this2.activeIndex].id).remove(function (data) {
	          _maggieHelper2.default.notification('type', data.result_code);
	          window.location.reload();
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EasyWeeksWrapper = __webpack_require__(1914);
	
	var _EasyWeeksWrapper2 = _interopRequireDefault(_EasyWeeksWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'WeekPlanner',
	  components: {
	    EasyWeeksWrapper: _EasyWeeksWrapper2.default
	  },
	  created: function created() {
	    var h = localStorage.getItem("hourOffset");
	    this.hourOffset = h ? parseInt(h) : 0;
	    this.daysToShow = 14;
	    var x = localStorage.getItem("shiftCount");
	    this.shiftCount = x ? parseInt(x) : 0;
	    this.shiftCounts = {
	      'auto': 0,
	      '2': 2,
	      '4': 4,
	      '6': 6,
	      '12': 12,
	      '24': 24
	    };
	  },
	
	  methods: {},
	  data: function data() {
	    return {
	      daysToShow: Number,
	      shiftCount: Number,
	      hourOffset: Number
	    };
	  }
	};

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _vuex = __webpack_require__(10);
	
	var _GoogleMapContainer = __webpack_require__(46);
	
	var _GoogleMapContainer2 = _interopRequireDefault(_GoogleMapContainer);
	
	var _SelectizeCommonCost = __webpack_require__(71);
	
	var _SelectizeCommonCost2 = _interopRequireDefault(_SelectizeCommonCost);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ZoneConfigForm',
	  components: { ActionButton: _ActionButton2.default, SelectizeCommonCost: _SelectizeCommonCost2.default, GoogleMapContainer: _GoogleMapContainer2.default, GoogleMap: _GoogleMap2.default, GoogleMapPolygon: _GoogleMapPolygon2.default },
	  data: function data() {
	    return {
	      apiKey: null,
	      zones: [],
	      options: [],
	      body: {
	        zone_id: null,
	        show: true,
	        start_common_cost_id: null,
	        end_common_cost_id: null,
	        max_vehicles: 0,
	        min_fuel_level: 0,
	        max_speed: null,
	        color: null,
	        type: null
	      }
	
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.apiKey = window.env.GOOGLE_MAPS_KEY;
	    _backoffice2.default.zones.list.all(function (data) {
	      _this.zones = data;
	    });
	    if (this.item !== null) {
	      (0, _assign2.default)(this.body, this.item);
	      this.body.zone_id = this.item.zone.id;
	      this.body.start_common_cost_id = this.item.common_cost_start !== null ? this.item.common_cost_start.id : null;
	      this.body.end_common_cost_id = this.item.common_cost_end !== null ? this.item.common_cost_end.id : null;
	    }
	  },
	
	  methods: {
	    setCommonCost: function setCommonCost(type, obj) {
	      this.body[type] = obj.id;
	    },
	    unsetCommonCost: function unsetCommonCost(type) {
	      this.body[type] = null;
	    },
	    save: function save() {
	      var _this2 = this;
	
	      if (this.item !== null) {
	        return _backoffice2.default.zoneConfigurations.select(this.item).edit(this.body, function () {
	          _maggieHelper2.default.notification('Zone configuration', 'Configuration edited');
	          _this2.$router.push({ name: 'zone-configuration' });
	        });
	      }
	
	      return _backoffice2.default.zoneConfigurations.make(this.body, function () {
	        _maggieHelper2.default.notification('Zone configuration', 'Configuration created');
	
	        _this2.$router.push({ name: 'zone-configuration' });
	      });
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    mapCenter: function mapCenter() {
	      return {
	        lat: this.configuration.application.application_default_latitude.value,
	        lng: this.configuration.application.application_default_longitude.value
	      };
	    },
	    selectedZone: function selectedZone() {
	      var _this3 = this;
	
	      return this.zones.findIndex(function (item) {
	        return item.id === _this3.body.zone_id;
	      });
	    },
	    selectedPoly: function selectedPoly() {
	      return this.selectedZone !== -1 ? this.zones[this.selectedZone].poly : [];
	    }
	  }),
	  props: {
	    item: {
	      default: null
	    }
	  }
	};

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ZoneList',
	  components: { BaseList: _BaseList2.default, GoogleMap: _GoogleMap2.default, GoogleMapPolygon: _GoogleMapPolygon2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(1942)
	
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.zoneConfigurations.list().all(page, resultsPerPage, function (data) {
	        callback(data);
	      });
	    },
	    editZone: function editZone() {
	      var zone = this.zones[this.activeIndex];
	      this.$router.push({ name: 'edit-zone', params: { id: zone.id } });
	    }
	  }
	};

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(30);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _GoogleMap = __webpack_require__(38);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _GoogleMapPolygon = __webpack_require__(62);
	
	var _GoogleMapPolygon2 = _interopRequireDefault(_GoogleMapPolygon);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ZoneList',
	  components: { Dropdown: _Dropdown2.default, LoadingSpinner: _LoadingSpinner2.default, GoogleMap: _GoogleMap2.default, GoogleMapPolygon: _GoogleMapPolygon2.default, ModalReveal: _ModalReveal2.default, ActionButton: _ActionButton2.default },
	  data: function data() {
	    return {
	      activeIndex: 0,
	      zones: [],
	      mapsApiKey: window.env.GOOGLE_MAPS_KEY,
	      mapCenter: {
	        lat: 0,
	        lng: 0
	      },
	      geoJson: '',
	      spin: true,
	      geoJsonMerged: ''
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.configuration.get(function (data) {
	      _this.mapCenter.lat = data.application.application_default_latitude.value;
	      _this.mapCenter.lng = data.application.application_default_longitude.value;
	    });
	    this.loadZones();
	  },
	
	  methods: {
	    loadZones: function loadZones() {
	      var _this2 = this;
	
	      _backoffice2.default.zones.list.all(function (data) {
	        _this2.zones = data;
	      });
	    },
	    deleteZone: function deleteZone() {
	      var _this3 = this;
	
	      var zone = this.zones[this.activeIndex];
	      this.$confirm('Are you sure?', 'Do you really want to delete Z' + zone.id + ' - ' + zone.name + '?', function () {
	
	        _backoffice2.default.zones.select(zone.id).remove(function (data) {
	          _this3.loadZones();
	          _maggieHelper2.default.notification('zone-delete', 'Zone deleted successfully');
	          _this3.activeIndex = 0;
	        });
	      });
	    },
	    showGeoJson: function showGeoJson() {
	      var _this4 = this;
	
	      this.geoJson = '';
	      this.spin = true;
	      var zone = this.zones[this.activeIndex];
	      _backoffice2.default.zones.select(zone.id).getGeoJson(function (data) {
	        _this4.geoJson = (0, _stringify2.default)(data);
	        _this4.spin = false;
	      });
	    },
	    copyToClipboard: function copyToClipboard() {
	      document.getElementById('geoJsonToCopy').select();
	      document.execCommand("copy");
	      _maggieHelper2.default.notification('GeoJson copied to Clipboard');
	    }
	  }
	};

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Cargo = __webpack_require__(186);
	
	var _Cargo2 = _interopRequireDefault(_Cargo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CargoOperationController',
	  components: { Cargo: _Cargo2.default },
	  data: function data() {
	    return {
	      component: __webpack_require__(186),
	      id: null,
	      item: '',
	      t: 'detail'
	    };
	  },
	  mounted: function mounted() {
	    this.id = this.$route.params.id;
	    this.dataLoader();
	  },
	
	
	  methods: {
	    dataLoader: function dataLoader() {
	      var _this = this;
	
	      _backoffice2.default.cargo.getOperation(this.id, function (data) {
	        _this.item = data;
	        console.log(_this.item);
	      });
	    }
	  },
	  computed: {}
	
	};

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(104);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _map = __webpack_require__(163);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _RouterTabHeaders = __webpack_require__(68);
	
	var _RouterTabHeaders2 = _interopRequireDefault(_RouterTabHeaders);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Client = __webpack_require__(53);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Card = __webpack_require__(76);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientController',
	  components: {
	    Card3: _Card2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    Cards: _Cards2.default,
	    Client: _Client2.default,
	    Driver: _Driver2.default,
	    RouterTabHeaders: _RouterTabHeaders2.default
	  },
	  data: function data() {
	    return {
	      tabs: [{
	        headerName: 'Profile',
	        name: 'client',
	        pathName: 'profile'
	      }, {
	        headerName: 'Drivers',
	        name: 'client-drivers',
	        pathName: 'drivers'
	      }],
	      balance: null,
	      balanceLoader: false,
	      checkLoader: false,
	      checkedData: null,
	      showCheck: false
	    };
	  },
	  mounted: function mounted() {},
	  created: function created() {
	    var _this = this;
	
	    this.balanceLoader = true;
	    var aclMap = new _map2.default([['booking', {
	      headerName: 'Reservations',
	      name: 'client-reservations',
	      pathName: 'reservations'
	    }], ['get-client-subscriptions-subscriptions', {
	      headerName: 'Subscriptions',
	      name: 'client-subscriptions',
	      pathName: 'subscriptions'
	    }], ['index-transactions', {
	      headerName: 'Transactions',
	      name: 'client-transactions',
	      pathName: 'transactions'
	    }], ['payment-methods-clients', {
	      headerName: 'Payment methods',
	      name: 'client-payment-methods',
	      pathName: 'payment-methods'
	    }], ['balance-billing', {
	      headerName: 'Billing',
	      name: 'client-wallets',
	      pathName: 'wallets'
	    }], ['cards-clients', {
	      headerName: 'Cards',
	      name: 'client-cards',
	      pathName: 'client-cards'
	    }], ['index-log', {
	      headerName: 'Logs',
	      name: 'client-logs',
	      pathName: 'client-logs'
	    }], ['index-log', {
	      headerName: 'Logs',
	      name: 'client-logs',
	      pathName: 'client-logs'
	    }]]);
	    aclMap.forEach(function (val, key) {
	      if (_this.$acl(key)) {
	        _this.tabs.push(val);
	      }
	    });
	
	    if (this.$acl('balance-billing')) {
	      _backoffice2.default.credits.select(this.item).balance(function (data) {
	        _this.balance = data;
	        _this.balanceLoader = false;
	      }, function () {
	        _this.balanceLoader = false;
	      });
	    }
	  },
	
	  methods: {
	    showObject: function showObject(k, obj) {
	      var _this2 = this;
	
	      var columnClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'columns small-6 large-6';
	
	      self = this;
	      var ret = '';
	      if (k) {
	        ret = ret + '<div class="' + columnClass + '">';
	        ret = ret + '<span>' + this.cleanKey(k) + '</span>';
	        ret = ret + "<div style='padding-left:10px'>" + this.showObject(null, obj, '') + "</div>";
	        ret = ret + '</div>';
	        return ret;
	      }
	      if (obj) (0, _keys2.default)(obj).forEach(function (i) {
	        if (Array.isArray(obj[i])) {
	          ret = ret + _this2.showArray(i, obj[i], columnClass);
	        } else if ((0, _typeof3.default)(obj[i]) === 'object') {
	          ret = ret + _this2.showObject(i, obj[i], columnClass);
	        } else ret = ret + _this2.showString(i, obj[i], columnClass);
	      });
	      return ret;
	    },
	    showString: function showString(k, v, columnClass) {
	      if (k == 'No problems found') {
	        return '<div class="' + columnClass + '"><span>' + this.cleanKey(k) + '</span></div>';
	      }
	      return '<div class="' + columnClass + '"><span>' + this.cleanKey(k) + '</span>: ' + v + '</div>';
	    },
	    showArray: function showArray(k, a, columnClass) {
	      return '<div class="' + columnClass + '"><span>' + this.cleanKey(k) + '</span>: <br> ' + a.join(", ") + '</div>';
	    },
	    cleanKey: function cleanKey(k) {
	      return k.replace(/-/g, ' ').replace(/_/g, ' ');
	    },
	    showHideCheckButton: function showHideCheckButton() {
	      this.showCheck = !this.showCheck;
	    },
	    loadCheckedData: function loadCheckedData(lookupType) {
	      var _this3 = this;
	
	      this.checkLoader = true;
	
	      _backoffice2.default.clients.select(this.item).checkClientData(function (data) {
	        if (!(0, _keys2.default)(data).length) {
	          data = { 'No problems found': '' };
	        }
	        _this3.checkedData = data;
	        _this3.checkLoader = false;
	      }, function () {
	        _this3.checkLoader = false;
	      }, lookupType);
	
	      this.showHideCheckButton();
	      return this.checkedData;
	    }
	  },
	  computed: {
	    clientMetrics: function clientMetrics() {
	      if (this.balance === null) {
	        return [];
	      }
	
	      return [{
	        title: 'Promo Credit',
	        value: this.$priceWithcurrency(this.balance.promo)
	      }, {
	        title: 'Paid Credit',
	        value: this.$priceWithcurrency(this.balance.credit)
	      }, {
	        title: 'Wallet balance',
	        value: this.$priceWithcurrency(this.balance.wallets)
	      }, {
	        title: 'Unpaid Invoices',
	        value: this.$priceWithcurrency(this.balance.invoices)
	      }, {
	        title: 'Uninvoiced Records',
	        value: this.$priceWithcurrency(this.balance.uninvoiced)
	      }];
	    }
	  },
	  props: ['item']
	};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RouterTabHeaders = __webpack_require__(68);
	
	var _RouterTabHeaders2 = _interopRequireDefault(_RouterTabHeaders);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Client = __webpack_require__(53);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Card = __webpack_require__(76);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ClientCreditNoteController',
	  components: {
	    Card3: _Card2.default,
	    LoadingSpinner: _LoadingSpinner2.default,
	    Cards: _Cards2.default,
	    Client: _Client2.default,
	    Driver: _Driver2.default,
	    RouterTabHeaders: _RouterTabHeaders2.default
	  },
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {},
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: ['item']
	};

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(163);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _RouterTabHeaders = __webpack_require__(68);
	
	var _RouterTabHeaders2 = _interopRequireDefault(_RouterTabHeaders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "DriverController",
	  components: {
	    RouterTabHeaders: _RouterTabHeaders2.default,
	    Driver: _Driver2.default
	  },
	  data: function data() {
	    return {
	      driverLicense: null,
	      tabs: [{
	        headerName: 'Profile',
	        name: 'driver',
	        pathName: 'profile'
	      }]
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    var aclMap = new _map2.default([['driver-index-reservations', {
	      headerName: 'Reservations',
	      name: 'driver-reservations',
	      pathName: 'reservations'
	    }], ['get-driver-subscriptions-subscriptions', {
	      headerName: 'Subscriptions',
	      name: 'driver-subscriptions',
	      pathName: 'subscriptions'
	    }], ['licenses-drivers', {
	      headerName: 'Driver Licenses',
	      name: 'driver-licenses',
	      pathName: 'driver-licenses'
	    }], ['coupons-driver', {
	      headerName: 'Coupons',
	      name: 'driver-coupons',
	      pathName: 'driver-coupons'
	    }], ['cards-drivers', {
	      headerName: 'Cards',
	      name: 'driver-cards',
	      pathName: 'driver-cards'
	    }], ['tocs-driver', {
	      headerName: 'Tocs',
	      name: 'driver-tocs',
	      pathName: 'driver-tocs'
	    }], ['index-log', {
	      headerName: 'Logs',
	      name: 'driver-logs',
	      pathName: 'driver-logs'
	    }]]);
	    aclMap.forEach(function (val, key) {
	      if (_this.$acl(key)) {
	        _this.tabs.push(val);
	      }
	    });
	  },
	
	  methods: {},
	  computed: {},
	  props: ['item']
	
	};

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RouterTabHeaders = __webpack_require__(68);
	
	var _RouterTabHeaders2 = _interopRequireDefault(_RouterTabHeaders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Federation',
	  components: { RouterTabHeaders: _RouterTabHeaders2.default },
	  data: function data() {
	    return {
	      tabs: [{
	        headerName: 'Vehicles',
	        name: 'federation-vehicles',
	        pathName: 'vehicles'
	      }, {
	        headerName: 'Clients',
	        name: 'federation-clients',
	        pathName: 'clients'
	      }, {
	        headerName: 'Parking Groups',
	        name: 'federation-parking-groups',
	        pathName: 'parking-groups'
	      }]
	    };
	  },
	
	
	  props: ['item']
	};

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _VehicleReplaceButtons = __webpack_require__(2063);
	
	var _VehicleReplaceButtons2 = _interopRequireDefault(_VehicleReplaceButtons);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _BookingModeSelect = __webpack_require__(41);
	
	var _BookingModeSelect2 = _interopRequireDefault(_BookingModeSelect);
	
	var _LoadingAnimation = __webpack_require__(117);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FindAReplaceVehicle',
	  components: {
	    LoadingSpinner: _LoadingSpinner2.default,
	    LoadingAnimation: _LoadingAnimation2.default, BookingModeSelect: _BookingModeSelect2.default, ActionButton: _ActionButton2.default, Cards: _Cards2.default, DatePicker: _DatePicker2.default, VehicleReplaceButtons: _VehicleReplaceButtons2.default, Vehicle: _Vehicle2.default
	  },
	  props: ['item'],
	  data: function data() {
	    return {
	      vehicles: [],
	      bookRequest: {
	        plate: null,
	        driver_id: null,
	        start: null,
	        end: null
	      },
	      loading: false
	    };
	  },
	  mounted: function mounted() {
	    this.bookRequest.driver_id = this.item.driver.id;
	    this.bookRequest.start = this.initialStart;
	    this.bookRequest.end = this.initialEnd;
	    this.dataLoader();
	  },
	
	  methods: {
	    search: function search() {
	      this.vehicles = [];
	      this.dataLoader();
	    },
	    cancelAndBook: function cancelAndBook(item) {
	      var _this = this;
	
	      var confirmed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!confirmed) {
	        this.confirm('Cancel', item, this.cancelAndBook);
	        return;
	      }
	      this.bookRequest.plate = item.plate;
	      _backoffice2.default.reservations.select(this.item).cancel(function () {
	        _this.book();
	      });
	    },
	    voidAndBook: function voidAndBook(item) {
	      var _this2 = this;
	
	      var confirmed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!confirmed) {
	        this.confirm('Cancel', item, this.voidAndBook);
	        return;
	      }
	      this.bookRequest.plate = item.plate;
	      _backoffice2.default.reservations.select(this.item).void(function () {
	        _this2.book();
	      });
	    },
	    replaceVehicleSlot: function replaceVehicleSlot(item) {
	      var _this3 = this;
	
	      var confirmed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!confirmed) {
	        this.confirm('hard replace', item, this.replaceVehicleSlot);
	        return;
	      }
	      _backoffice2.default.reservations.select(this.item).replaceVehicleSlot({ plate: item.plate }, function (r) {
	        _this3.$router.push({ name: 'reservation', params: { id: r.number } });
	      });
	    },
	    dataLoader: function dataLoader() {
	      var _this4 = this;
	
	      this.loading = true;
	      var latitude = this.item.vehicle.parking_lot.position.latitude;
	      var longitude = this.item.vehicle.parking_lot.position.longitude;
	
	      if (this.item.booking_mode === 'FF') {
	        latitude = this.item.vehicle.position.latitude;
	        longitude = this.item.vehicle.position.longitude;
	      }
	
	      _backoffice2.default.vehicleSlots.search({
	        start: this.$dateFormat(this.bookRequest.start, 'X'),
	        end: this.$dateFormat(this.bookRequest.end, 'X'),
	        latitude: latitude,
	        longitude: longitude
	      }, function (data) {
	        var vehicles = data.map(function (item) {
	          item.vehicle['distance'] = parseFloat(item.distance / 1000).toFixed(2);
	          return item.vehicle;
	        });
	        _this4.vehicles = vehicles;
	        _this4.loading = false;
	      });
	    },
	    book: function book() {
	      var _this5 = this;
	
	      this.bookRequest.start = parseInt(this.$dateFormat(this.bookRequest.start, 'X'));
	      this.bookRequest.end = parseInt(this.$dateFormat(this.bookRequest.end, 'X'));
	      _backoffice2.default.reservations.make(this.bookRequest, function (r) {
	        _maggieHelper2.default.notification('Create', 'New reservation created');
	        _this5.$router.push({ name: 'reservation', params: { id: r.number } });
	      });
	    },
	    confirm: function confirm(action, vehicle, callback) {
	      this.$confirm('Are you sure?', 'Do you really want to ' + action + ' R' + this.item.number + ' and book V' + vehicle.id + ' - ' + vehicle.brand + ' ' + vehicle.model + ' ' + vehicle.plate, function () {
	        callback(vehicle, true);
	      });
	    },
	    gridStyle: function gridStyle(slots) {
	      var auto = slots.length > 3 ? 'auto auto auto' : 'repeat(' + slots.length + ',auto)';
	      return {
	        gridTemplateColumns: auto
	      };
	    }
	  },
	  computed: {
	    slotsByLots: function slotsByLots() {
	
	      var c = (0, _collect2.default)(this.vehicles);
	      return c.groupBy(function (item) {
	        return item.parking_lot.name;
	      }).all();
	    },
	    initialStart: function initialStart() {
	      return this.item.status === 'STARTED' ? new Date() : new Date(this.item.start);
	    },
	    initialEnd: function initialEnd() {
	      return new Date(this.item.end);
	    },
	    selectedDates: function selectedDates() {
	      return [{
	        title: 'Start',
	        value: this.$dateFormat(this.item.start, this.$toMomentFormat(this.$configurationDateTimeFormat()))
	      }, {
	        title: 'End',
	        value: this.$dateFormat(this.item.end, this.$toMomentFormat(this.$configurationDateTimeFormat()))
	      }, {
	        title: 'Vehicle',
	        value: this.item.vehicle.brand + ' ' + this.item.vehicle.model + '<br>' + this.item.vehicle.plate
	      }, {
	        title: 'Parking lot',
	        value: '' + this.item.vehicle.parking_lot.name
	      }];
	    }
	  }
	};

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BookPanel = __webpack_require__(100);
	
	var _BookPanel2 = _interopRequireDefault(_BookPanel);
	
	var _ReservationListForm = __webpack_require__(124);
	
	var _ReservationListForm2 = _interopRequireDefault(_ReservationListForm);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _EntitiesSearch = __webpack_require__(1915);
	
	var _EntitiesSearch2 = _interopRequireDefault(_EntitiesSearch);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "HomeController",
	  components: {
	    BaseList: _BaseList2.default,
	    EntitiesSearch: _EntitiesSearch2.default,
	    ReservationListForm: _ReservationListForm2.default,
	    BookPanel: _BookPanel2.default
	  },
	  data: function data() {
	    return {
	      component: __webpack_require__(37),
	      reportingsComponent: __webpack_require__(135)
	    };
	  },
	  created: function created() {},
	
	  methods: {
	    reservationDataLoader: function reservationDataLoader(callback, page, resultsPerPage, search) {
	      _backoffice2.default.reservations.list(page, 3, { status: 'STARTED' }).all(function (data) {
	        callback(data);
	      });
	    },
	    reportingsDataLoader: function reportingsDataLoader(callback, page, resultsPerPage, search) {
	      _backoffice2.default.reportings.list(page, 3, { status: 'PENDING_REVIEW' }).all(function (data) {
	        callback(data);
	      });
	    }
	  },
	  computed: {}
	};

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Client = __webpack_require__(53);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Invoice = __webpack_require__(114);
	
	var _Invoice2 = _interopRequireDefault(_Invoice);
	
	var _vuex = __webpack_require__(10);
	
	var _collect = __webpack_require__(28);
	
	var _collect2 = _interopRequireDefault(_collect);
	
	var _Deposit = __webpack_require__(531);
	
	var _Deposit2 = _interopRequireDefault(_Deposit);
	
	var _CardN = __webpack_require__(14);
	
	var _CardN2 = _interopRequireDefault(_CardN);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvoiceController',
	  components: {
	    BaseList: _BaseList2.default,
	    CardN: _CardN2.default,
	    Deposit: _Deposit2.default,
	    Invoice: _Invoice2.default,
	    Client: _Client2.default,
	    Driver: _Driver2.default
	  },
	  data: function data() {
	    return {
	      client: null,
	      component: __webpack_require__(114)
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.clients.select(this.item.billing_info.client_id).get(function (item) {
	      _this.client = item;
	    });
	  },
	
	  methods: {
	    explodeReason: function explodeReason(reason) {
	      return reason.replace(/\|/g, '<br>');
	    },
	    xmlName: function xmlName(n) {
	      var chars = '0123456789abcdefghijklmnopqrstuvwxyz';
	      var base = chars.length;
	      var converted = '';
	      while (n > 0) {
	        converted = chars.substr(n % base, 1) + converted;
	        n = Math.floor(n / base);
	      }
	      var codiceIva = this.configuration['italian-e-invoice']['italian-e-invoice_codice-iva']['value'];
	      var paeseIva = this.configuration['italian-e-invoice']['italian-e-invoice_paese-iva']['value'];
	      var progressivo = this.configuration['italian-e-invoice']['italian-e-invoice_prefisso_progressivo_univoco']['value'];
	      return '' + paeseIva + codiceIva + '_' + (progressivo ? progressivo : '') + converted + '.xml';
	    },
	    xmlStatus: function xmlStatus(callback) {
	      callback({
	        current_page: 1,
	        current_page_count: 1,
	        items: this.item.extra.einvoice.results.reverse(),
	        items_count: this.item.extra.einvoice.results.length,
	        page_count: 1,
	        per_page_count: this.item.extra.einvoice.results.length
	      });
	    },
	    cleanString: function cleanString(string, char) {
	      var r = new RegExp('' + char, 'gi');
	      return string.replace(r, "");
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    },
	    depositsPaid: function depositsPaid() {
	      return (0, _collect2.default)(this.item.deposits).sum('amount');
	    }
	  }),
	  filters: {
	    walletableType: function walletableType(value) {
	      return value.replace(/App\\Models\\/, '');
	    }
	  },
	  props: ['item']
	
	};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Accordion = __webpack_require__(86);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _AccordionItem = __webpack_require__(87);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _Reservation = __webpack_require__(37);
	
	var _Reservation2 = _interopRequireDefault(_Reservation);
	
	var _SelectizeVehicleSlot = __webpack_require__(151);
	
	var _SelectizeVehicleSlot2 = _interopRequireDefault(_SelectizeVehicleSlot);
	
	var _Selectize = __webpack_require__(17);
	
	var _Selectize2 = _interopRequireDefault(_Selectize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Operations",
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.vehicleSlots.list().allV2(function (data) {
	      _this.options = data;
	    });
	  },
	  data: function data() {
	
	    return {
	      results: null,
	      options: null,
	      vehicle_slots_id: "",
	      cardData: [{ title: 'VS' + this.item.id, value: this.item.name }, {
	        title: 'PL' + this.item.parking_slot.id,
	        value: "<a href=\"/administration/assets/management/" + this.item.vehicle.parking_lot.id + "\">" + this.item.vehicle.parking_lot.name + "</a>"
	      }, { title: 'PS' + this.item.parking_slot.id, value: this.item.parking_slot.name }, { title: 'V' + this.item.vehicle.id, value: this.item.vehicle.brand + ' ' + this.item.vehicle.model }]
	    };
	  },
	
	  methods: {
	    updateVehicleSlots: function updateVehicleSlots() {
	      this.vehicle_slots_id = this.$refs.selectize.$data.selectize.getValue();
	    },
	    drain: function drain() {
	      var _this2 = this;
	
	      _backoffice2.default.vehicleSlots.select(this.item.id).drain({ vehicle_slots_id: [this.vehicle_slots_id] }, function (data) {
	
	        _maggieHelper2.default.notification('drain-result', "Migrated: " + data.migrated.length + " -  Stalled: " + data.stalled.length);
	        _this2.results = data;
	      });
	    },
	    optionTemplate: function optionTemplate(item, escape) {
	
	      return "<div><div><small><i class=\"fa fa-car\"></i> VS" + item.id + " " + item.name + "</small></div><div>V" + item.vehicle.id + " " + item.vehicle.brand + " " + item.vehicle.model + "</div> <div><small>" + item.vehicle.plate + "</small></div></div>";
	    }
	  },
	  components: { Selectize: _Selectize2.default, SelectizeVehicleSlot: _SelectizeVehicleSlot2.default, Reservation: _Reservation2.default, AccordionItem: _AccordionItem2.default, Accordion: _Accordion2.default, Cards: _Cards2.default },
	  props: ['item']
	};

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _RouterTabHeaders = __webpack_require__(68);
	
	var _RouterTabHeaders2 = _interopRequireDefault(_RouterTabHeaders);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _LoadingSpinner = __webpack_require__(16);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "ParkingLot",
	    components: {
	        LoadingSpinner: _LoadingSpinner2.default,
	        RouterTabHeaders: _RouterTabHeaders2.default,
	        Cards: _Cards2.default
	    },
	    props: ['item'],
	
	    created: function created() {
	        var _this = this;
	
	        _backoffice2.default.parkingGroups.list.all(function (data) {
	
	            data.forEach(function (pg) {
	                pg.parking_lots.forEach(function (pl) {
	                    if (pl.id === _this.item.id) {
	
	                        _this.parkingGroup = pg;
	                        _this.bookingMode = pg.reservation_type;
	                    }
	                });
	            });
	        });
	    },
	
	
	    data: function data() {
	        return {
	            tabs: [{
	                headerName: 'Overview',
	                name: 'parkingLot',
	                pathName: 'parkingLot'
	            }, {
	                headerName: 'Manage',
	                name: 'manage',
	                pathName: 'manage'
	            }, {
	                headerName: 'Zones',
	                name: 'zones',
	                pathName: 'zones'
	            }],
	            bookingMode: null,
	            parkingGroup: null
	        };
	    }
	};

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RouterTabHeaders = __webpack_require__(68);
	
	var _RouterTabHeaders2 = _interopRequireDefault(_RouterTabHeaders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "PlanController",
	  components: { RouterTabHeaders: _RouterTabHeaders2.default },
	  data: function data() {
	    return {
	
	      tabs: [{
	        headerName: 'Setup',
	        name: 'plan',
	        pathName: 'setup'
	      }, {
	        headerName: 'Plan reservation rates',
	        name: 'plan-reservation-rates',
	        pathName: 'plan-reservation-rates'
	      }]
	    };
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: ['item']
	
	};

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ArrayEdit = __webpack_require__(88);
	
	var _ArrayEdit2 = _interopRequireDefault(_ArrayEdit);
	
	var _Editor = __webpack_require__(24);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ReportReservation",
	  components: { ActionButton: _ActionButton2.default, Editor: _Editor2.default, ArrayEdit: _ArrayEdit2.default },
	  data: function data() {
	    return {
	      headers: ['document_info', 'header_info'],
	      recipient_info: "",
	      body: {
	        text: "",
	        recipient_info: [],
	        document_info: [{ title: "ID", value: this.$route.params.id }],
	        header_info: [],
	        prev_next_reservations: 0
	      }
	    };
	  },
	
	  methods: {
	    addField: function addField(data) {
	      this.body[data].push({ title: "", value: "" });
	    },
	    save: function save() {
	      this.body.recipient_info = this.recipient_info.split("\n");
	
	      return _backoffice2.default.reservations.select(this.$route.params.id).report(this.body, function (response) {
	        window.open(response, '_blank');
	      });
	    }
	  }
	};

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StatisticsCard = __webpack_require__(142);
	
	var _StatisticsCard2 = _interopRequireDefault(_StatisticsCard);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _RouterTabHeaders = __webpack_require__(68);
	
	var _RouterTabHeaders2 = _interopRequireDefault(_RouterTabHeaders);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _Attachment = __webpack_require__(527);
	
	var _Attachment2 = _interopRequireDefault(_Attachment);
	
	var _VehicleDamage = __webpack_require__(138);
	
	var _VehicleDamage2 = _interopRequireDefault(_VehicleDamage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "ReportingController",
	    components: {
	        VehicleDamage: _VehicleDamage2.default,
	        BackofficeAttachment: _Attachment2.default,
	        Vehicle: _Vehicle2.default,
	        Driver: _Driver2.default,
	        RouterTabHeaders: _RouterTabHeaders2.default,
	        StatisticsCard4: _StatisticsCard2.default,
	        KeplerBackofficeSdk: _backoffice2.default
	    },
	    data: function data() {
	        return {
	            lastUsed: null
	
	        };
	    },
	    created: function created() {},
	
	    methods: {},
	    computed: {},
	    props: ['item']
	};

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _maggieHelper = __webpack_require__(3);
	
	var _maggieHelper2 = _interopRequireDefault(_maggieHelper);
	
	var _Accordion = __webpack_require__(78);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _DatePicker = __webpack_require__(13);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _Dropdown = __webpack_require__(11);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Card = __webpack_require__(140);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ReservationActionButtons = __webpack_require__(101);
	
	var _ReservationActionButtons2 = _interopRequireDefault(_ReservationActionButtons);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _Vehicle = __webpack_require__(20);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _StatisticsCard = __webpack_require__(142);
	
	var _StatisticsCard2 = _interopRequireDefault(_StatisticsCard);
	
	var _TabHeaders = __webpack_require__(121);
	
	var _TabHeaders2 = _interopRequireDefault(_TabHeaders);
	
	var _TabContent = __webpack_require__(120);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _AppliedRates = __webpack_require__(1897);
	
	var _AppliedRates2 = _interopRequireDefault(_AppliedRates);
	
	var _ReservationLogTimeLine = __webpack_require__(1929);
	
	var _ReservationLogTimeLine2 = _interopRequireDefault(_ReservationLogTimeLine);
	
	var _ModalReveal = __webpack_require__(7);
	
	var _ModalReveal2 = _interopRequireDefault(_ModalReveal);
	
	var _ReservationNotes = __webpack_require__(1993);
	
	var _ReservationNotes2 = _interopRequireDefault(_ReservationNotes);
	
	var _vuex = __webpack_require__(10);
	
	var _ReservationRoute = __webpack_require__(2172);
	
	var _ReservationRoute2 = _interopRequireDefault(_ReservationRoute);
	
	var _Reservation = __webpack_require__(37);
	
	var _Reservation2 = _interopRequireDefault(_Reservation);
	
	var _Cards = __webpack_require__(47);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _ActionButton = __webpack_require__(6);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _StatisticsCard3 = __webpack_require__(143);
	
	var _StatisticsCard4 = _interopRequireDefault(_StatisticsCard3);
	
	var _SelectizeCommonCost = __webpack_require__(71);
	
	var _SelectizeCommonCost2 = _interopRequireDefault(_SelectizeCommonCost);
	
	var _ReservationFlag = __webpack_require__(1928);
	
	var _ReservationFlag2 = _interopRequireDefault(_ReservationFlag);
	
	var _Reporting = __webpack_require__(135);
	
	var _Reporting2 = _interopRequireDefault(_Reporting);
	
	var _VehicleAdditionalStatus = __webpack_require__(207);
	
	var _VehicleAdditionalStatus2 = _interopRequireDefault(_VehicleAdditionalStatus);
	
	var _ChargingSessionsList = __webpack_require__(594);
	
	var _ChargingSessionsList2 = _interopRequireDefault(_ChargingSessionsList);
	
	var _PreauthList = __webpack_require__(2164);
	
	var _PreauthList2 = _interopRequireDefault(_PreauthList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ReservationController',
	  components: {
	    PreauthList: _PreauthList2.default,
	    ChargingSessionsList: _ChargingSessionsList2.default,
	    VehicleAdditionalStatus: _VehicleAdditionalStatus2.default,
	    Reporting: _Reporting2.default,
	    ReservationFlag: _ReservationFlag2.default,
	    SelectizeCommonCost: _SelectizeCommonCost2.default,
	    StatisticsCard5: _StatisticsCard4.default,
	    ActionButton: _ActionButton2.default,
	    Cards: _Cards2.default,
	    BackofficeReservation: _Reservation2.default,
	    ReservationRoute: _ReservationRoute2.default,
	    ReservationNotes: _ReservationNotes2.default,
	    ModalReveal: _ModalReveal2.default,
	    ReservationLogTimeLine: _ReservationLogTimeLine2.default,
	    AppliedRates: _AppliedRates2.default,
	    TabContent: _TabContent2.default,
	    TabHeaders: _TabHeaders2.default,
	    StatisticsCard4: _StatisticsCard2.default,
	    Accordion: _Accordion2.default,
	    DatePicker: _DatePicker2.default,
	    Dropdown: _Dropdown2.default,
	    Card9: _Card2.default,
	    ReservationActionButtons: _ReservationActionButtons2.default,
	    Driver: _Driver2.default,
	    Vehicle: _Vehicle2.default
	  },
	  data: function data() {
	    return {
	      debugInfo: null,
	      accordionData: {
	        'Cost breakdown': 'Cost breakdown',
	        'Applied Rates & Overrides': 'Applied Rates & Overrides',
	        'Deposits': 'Deposits',
	        'Preauths': 'Preauths'
	      },
	      segmentData: {
	        'Segment': 'Segment',
	        'Rental agreement': 'Rental agreement'
	      },
	      extendTime: null,
	      logs: null,
	      deposits: [],
	      bookedTimes: null,
	      tabs: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    _backoffice2.default.reservations.select(this.item).debugInfo(function (data) {
	      _this.debugInfo = data;
	      _this.logs = data.logs;
	    });
	
	    _backoffice2.default.reservations.select(this.item).deposits(function (data) {
	      _this.deposits = data;
	    });
	
	    _backoffice2.default.reservations.select(this.item).bookedTimes(function (data) {
	      _this.bookedTimes = data;
	    });
	  },
	  mounted: function mounted() {
	    this.getTabHeaders();
	  },
	
	  methods: {
	    getTabHeaders: function getTabHeaders() {
	      this.tabs = ['Billing & Costs', 'Trips Data', 'Notes', 'Reports', 'Charging sessions'];
	      if (this.item.booking_mode === 'STR') {
	        this.tabs.push('STR Detail');
	      }
	      return this.tabs;
	    },
	    getDistanceCost: function getDistanceCost() {
	      var calculatedCosts = this.debugInfo.calculated_cost;
	      return calculatedCosts ? this.currency + calculatedCosts.distance_cost : '-';
	    },
	    getTimeCost: function getTimeCost() {
	      var calculatedCosts = this.debugInfo.calculated_cost;
	      return calculatedCosts ? this.currency + calculatedCosts.time_cost : '-';
	    },
	    getAppliedRates: function getAppliedRates() {
	      var calculatedCosts = this.debugInfo.calculated_cost;
	      return calculatedCosts ? this.debugInfo.calculated_cost : [];
	    },
	    getOverTimeCost: function getOverTimeCost() {
	      var overtimeCost = this.debugInfo.overtime;
	
	      return overtimeCost ? this.currency + overtimeCost.amount : '-';
	    },
	    getOverHeadCost: function getOverHeadCost() {
	      var overHeadCost = this.debugInfo.overhead;
	      return overHeadCost ? this.currency + overHeadCost.amount : '-';
	    },
	    getOtherCosts: function getOtherCosts() {
	      var overtimeCost = this.debugInfo.overtime ? this.debugInfo.overtime.amount : 0;
	      var overHeadCost = this.debugInfo.overhead ? this.debugInfo.overhead.amount : 0;
	
	      var total = overtimeCost + overHeadCost;
	      return !isNaN(parseFloat(total)) && isFinite(total) ? this.currency + total : '-';
	    },
	
	    extend: function extend() {
	      _backoffice2.default.reservations.select(this.item.number).extend(this.convertTimestamp(this.extendTime), function (response) {
	        _maggieHelper2.default.notification('extend-esit', 'reservation extended');
	      });
	    },
	    convertTimestamp: function convertTimestamp(datetime) {
	      var t = datetime.split(/[- :]/);
	      var date = new Date(t[0], t[1] - 1, t[2], t[3], t[4]);
	      return Math.round(date.getTime() / 1000);
	    },
	    handleExtend: function handleExtend(timestamp) {
	      this.extendTime = timestamp;
	      this.extend();
	    },
	    parseMinutes: function parseMinutes(val) {
	      if (val < 1440) {
	        switch (val) {
	          case 1:
	            return 'minute';
	          case 60:
	            return 'hour';
	          default:
	            if (!(val % 60)) {
	              return 'hours ' + val / 60;
	            } else {
	              return 'minutes ' + val;
	            }
	        }
	      } else {
	        var d = val / 1440;
	        switch (d) {
	          case 1:
	            return 'day';
	          case 7:
	            return 'week';
	          case 30:
	            return 'month';
	          case 60:
	            return 'two months';
	          case 90:
	            return 'three months';
	          case 365:
	            return 'year';
	          default:
	            if (!(d % 30)) {
	              return 'months ' + d / 60;
	            } else if (!(d % 7)) {
	              return 'weeks ' + d / 7;
	            } else {
	              return 'days ' + d;
	            }
	        }
	      }
	    }
	  },
	  computed: (0, _extends3.default)({
	    distanceConfig: function distanceConfig() {
	      var _this2 = this;
	
	      var distance = [];
	      var distanceConfig = this.item.reservation_rate.config.distance_config.reverse();
	      distance = distanceConfig.map(function (config) {
	        var conf = config.split(" ");
	        var distanceUnit = _this2.configuration.locale.locale_distance_unit.value;
	        var distance = '' + conf[0] + distanceUnit;
	        var cost = conf[1].split('|');
	
	        return distance + ' - ' + cost[0] + '\u20AC/' + cost[1] + distanceUnit;
	      });
	
	      return distance;
	    },
	    timeConfig: function timeConfig() {
	      var _this3 = this;
	
	      var times = [];
	      var timeConfig = this.item.reservation_rate.config.time_config.reverse();
	      times = timeConfig.map(function (time) {
	        var timesArray = time.split("|");
	        var timesRateToSplit = timesArray[0].split(" ");
	        var timeAndCost = timesRateToSplit[0] + "min -" + timesRateToSplit[1] + "" + _this3.configuration.commercial.commercial_currency.value;
	        var perTime = timesArray[1] + "" + _this3.parseMinutes(1);
	
	        return timeAndCost + '/' + perTime;
	      });
	      return times;
	    },
	    vehicle: function vehicle() {
	      return this.item.vehicle;
	    }
	  }, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  }), {
	    currency: function currency() {
	      return this.configuration.commercial.commercial_currency.value;
	    },
	    cardData: function cardData() {
	      var _this4 = this;
	
	      var dateFormat = this.configuration.locale.locale_datetime_format.value;
	
	      var extendComponent = null;
	      var callback = {};
	
	      if (this.item.status !== 'COMPLETED' && this.item.booking_mode === 'RT') {
	        extendComponent = function extendComponent() {
	          _maggieHelper2.default.openTopPanel({
	            component: __webpack_require__(1953),
	            props: {
	              reservation: _this4.item
	            }
	          });
	        };
	
	        callback.func = extendComponent;
	        callback.class = 'fa fa-arrow-right';
	      }
	      return [{
	        title: 'Start',
	        value: this.$dateFormat(this.item.start, this.$toMomentFormat(dateFormat)),
	        color: '#5EB9CF'
	
	      }, {
	        title: 'End',
	        value: this.$dateFormat(this.item.end, this.$toMomentFormat(dateFormat)),
	        color: '#5EB9CF'
	      }, {
	        title: 'Total duration',
	        value: this.$dateDifference(this.item.start, this.item.end),
	        color: '#5EB9CF'
	      }, {
	        title: 'Total driven distance',
	        value: '' + Math.round(this.item.distance) + this.configuration.locale.locale_distance_unit.value,
	        color: '#5EB9CF'
	      }];
	    }
	  }),
	  props: ['item']
	
	};

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StatisticsCard = __webpack_require__(143);
	
	var _StatisticsCard2 = _interopRequireDefault(_StatisticsCard);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _RouterTabHeaders = __webpack_require__(68);
	
	var _RouterTabHeaders2 = _interopRequireDefault(_RouterTabHeaders);
	
	var _Client = __webpack_require__(53);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _Subscription = __webpack_require__(136);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _Driver = __webpack_require__(18);
	
	var _Driver2 = _interopRequireDefault(_Driver);
	
	var _TabHeaders = __webpack_require__(121);
	
	var _TabHeaders2 = _interopRequireDefault(_TabHeaders);
	
	var _TabContent = __webpack_require__(120);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _BaseList = __webpack_require__(8);
	
	var _BaseList2 = _interopRequireDefault(_BaseList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SubscriptionController",
	  components: {
	    BaseList: _BaseList2.default,
	    TabContent: _TabContent2.default,
	    TabHeaders: _TabHeaders2.default,
	    Driver: _Driver2.default,
	    Subscription: _Subscription2.default,
	    Client: _Client2.default,
	    RouterTabHeaders: _RouterTabHeaders2.default,
	    StatisticsCard5: _StatisticsCard2.default,
	    KeplerBackofficeSdk: _backoffice2.default
	  },
	  data: function data() {
	    return {
	      logs: [],
	      component: __webpack_require__(115),
	      tabHeaders: ['Subscription']
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    if (this.$acl('index-log')) {
	      this.tabHeaders.push('Logs');
	      this.dataLoader(function (data) {
	        _this.logs = data;
	      }, 1, 10);
	    }
	  },
	
	  methods: {
	    dataLoader: function dataLoader(callback, page, resultsPerPage) {
	      _backoffice2.default.logs.list(page, resultsPerPage).all('subscription', this.$route.params.id, function (data) {
	        callback(data);
	      });
	    }
	  },
	  computed: {},
	  props: ['item']
	
	};

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "TocController",
	  data: function data() {},
	  created: function created() {},
	
	  methods: {},
	  computed: {},
	  props: ['item']
	
	};

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Client = __webpack_require__(53);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _Transaction = __webpack_require__(40);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "TransactionController",
	    components: {
	        Transaction: _Transaction2.default,
	        Client: _Client2.default
	    },
	    data: function data() {
	        return {
	            client: null
	        };
	    },
	    created: function created() {},
	
	    methods: {},
	    computed: {},
	    props: ['item']
	
	};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _StatisticsCard = __webpack_require__(143);
	
	var _StatisticsCard2 = _interopRequireDefault(_StatisticsCard);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	var _RouterTabHeaders = __webpack_require__(68);
	
	var _RouterTabHeaders2 = _interopRequireDefault(_RouterTabHeaders);
	
	var _vuex = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'VehicleController',
	  components: {
	    RouterTabHeaders: _RouterTabHeaders2.default,
	    StatisticsCard5: _StatisticsCard2.default,
	    KeplerBackofficeSdk: _backoffice2.default
	  },
	  data: function data() {
	    return {
	      lastUsed: null,
	      tabs: [{
	        headerName: 'Overview',
	        name: 'vehicle',
	        pathName: 'vehicle'
	      }, {
	        headerName: 'Reservations',
	        name: 'vehicle-reservations',
	        pathName: 'vehicle-reservations'
	      }, {
	        headerName: 'Status',
	        name: 'vehicle-reports',
	        pathName: 'vehicle-reports'
	      }, {
	        headerName: 'Maintenance requests',
	        name: 'maintenance-requests',
	        pathName: 'maintenance-requests'
	      }, {
	        headerName: 'Map position',
	        name: 'vehicle-position',
	        pathName: 'position'
	      }, {
	        headerName: 'Costs',
	        name: 'vehicle-costs',
	        pathName: 'costs'
	      }, {
	        headerName: 'Notes',
	        name: 'vehicle-notes',
	        pathName: 'notes'
	      }, {
	        headerName: 'Instructions',
	        name: 'vehicle-instructions',
	        pathName: 'instructions'
	      }, {
	        headerName: 'Attributes',
	        name: 'vehicle-attributes',
	        pathName: 'attributes'
	      }, {
	        headerName: 'Logs',
	        name: 'vehicle-logs',
	        pathName: 'vehicle-logs'
	      }]
	    };
	  },
	  created: function created() {},
	
	  methods: {},
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    configuration: function configuration(state) {
	      return state.configuration;
	    }
	  })),
	  props: ['item']
	
	};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(104);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(34);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MarkerClusterer(map, opt_markers, opt_options) {
	  this.extend(MarkerClusterer, google.maps.OverlayView);
	  this.map_ = map;
	
	  this.markers_ = [];
	
	  this.clusters_ = [];
	
	  this.sizes = [53, 56, 66, 78, 90];
	
	  this.styles_ = [];
	
	  this.ready_ = false;
	
	  var options = opt_options || {};
	
	  this.gridSize_ = options['gridSize'] || 60;
	
	  this.minClusterSize_ = options['minimumClusterSize'] || 2;
	
	  this.maxZoom_ = options['maxZoom'] || null;
	
	  this.styles_ = options['styles'] || [];
	
	  this.imagePath_ = options['imagePath'] || this.MARKER_CLUSTER_IMAGE_PATH_;
	
	  this.imageExtension_ = options['imageExtension'] || this.MARKER_CLUSTER_IMAGE_EXTENSION_;
	
	  this.zoomOnClick_ = true;
	
	  if (options['zoomOnClick'] != undefined) {
	    this.zoomOnClick_ = options['zoomOnClick'];
	  }
	
	  this.averageCenter_ = false;
	
	  if (options['averageCenter'] != undefined) {
	    this.averageCenter_ = options['averageCenter'];
	  }
	
	  this.setupStyles_();
	
	  this.setMap(map);
	
	  this.prevZoom_ = this.map_.getZoom();
	
	  var that = this;
	  google.maps.event.addListener(this.map_, 'zoom_changed', function () {
	    var zoom = that.map_.getZoom();
	    var minZoom = that.map_.minZoom || 0;
	    var maxZoom = Math.min(that.map_.maxZoom || 100, that.map_.mapTypes[that.map_.getMapTypeId()].maxZoom);
	    zoom = Math.min(Math.max(zoom, minZoom), maxZoom);
	
	    if (that.prevZoom_ != zoom) {
	      that.prevZoom_ = zoom;
	      that.resetViewport();
	    }
	  });
	
	  google.maps.event.addListener(this.map_, 'idle', function () {
	    that.redraw();
	  });
	
	  if (opt_markers && (opt_markers.length || (0, _keys2.default)(opt_markers).length)) {
	    this.addMarkers(opt_markers, false);
	  }
	}
	
	MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../images/m';
	
	MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png';
	
	MarkerClusterer.prototype.extend = function (obj1, obj2) {
	  return function (object) {
	    for (var property in object.prototype) {
	      this.prototype[property] = object.prototype[property];
	    }
	    return this;
	  }.apply(obj1, [obj2]);
	};
	
	MarkerClusterer.prototype.onAdd = function () {
	  this.setReady_(true);
	};
	
	MarkerClusterer.prototype.draw = function () {};
	
	MarkerClusterer.prototype.setupStyles_ = function () {
	  if (this.styles_.length) {
	    return;
	  }
	
	  for (var i = 0, size; size = this.sizes[i]; i++) {
	    this.styles_.push({
	      url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
	      height: size,
	      width: size
	    });
	  }
	};
	
	MarkerClusterer.prototype.fitMapToMarkers = function () {
	  var markers = this.getMarkers();
	  var bounds = new google.maps.LatLngBounds();
	  for (var i = 0, marker; marker = markers[i]; i++) {
	    bounds.extend(marker.getPosition());
	  }
	
	  this.map_.fitBounds(bounds);
	};
	
	MarkerClusterer.prototype.setStyles = function (styles) {
	  this.styles_ = styles;
	};
	
	MarkerClusterer.prototype.getStyles = function () {
	  return this.styles_;
	};
	
	MarkerClusterer.prototype.isZoomOnClick = function () {
	  return this.zoomOnClick_;
	};
	
	MarkerClusterer.prototype.isAverageCenter = function () {
	  return this.averageCenter_;
	};
	
	MarkerClusterer.prototype.getMarkers = function () {
	  return this.markers_;
	};
	
	MarkerClusterer.prototype.getTotalMarkers = function () {
	  return this.markers_.length;
	};
	
	MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
	  this.maxZoom_ = maxZoom;
	};
	
	MarkerClusterer.prototype.getMaxZoom = function () {
	  return this.maxZoom_;
	};
	
	MarkerClusterer.prototype.calculator_ = function (markers, numStyles) {
	  var index = 0;
	  var count = markers.length;
	  var dv = count;
	  while (dv !== 0) {
	    dv = parseInt(dv / 10, 10);
	    index++;
	  }
	
	  index = Math.min(index, numStyles);
	  return {
	    text: count,
	    index: index
	  };
	};
	
	MarkerClusterer.prototype.setCalculator = function (calculator) {
	  this.calculator_ = calculator;
	};
	
	MarkerClusterer.prototype.getCalculator = function () {
	  return this.calculator_;
	};
	
	MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
	  if (markers.length) {
	    for (var i = 0, marker; marker = markers[i]; i++) {
	      this.pushMarkerTo_(marker);
	    }
	  } else if ((0, _keys2.default)(markers).length) {
	    for (var marker in markers) {
	      this.pushMarkerTo_(markers[marker]);
	    }
	  }
	  if (!opt_nodraw) {
	    this.redraw();
	  }
	};
	
	MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
	  marker.isAdded = false;
	  if (marker['draggable']) {
	    var that = this;
	    google.maps.event.addListener(marker, 'dragend', function () {
	      marker.isAdded = false;
	      that.repaint();
	    });
	  }
	  this.markers_.push(marker);
	};
	
	MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
	  this.pushMarkerTo_(marker);
	  if (!opt_nodraw) {
	    this.redraw();
	  }
	};
	
	MarkerClusterer.prototype.removeMarker_ = function (marker) {
	  var index = -1;
	  if (this.markers_.indexOf) {
	    index = this.markers_.indexOf(marker);
	  } else {
	    for (var i = 0, m; m = this.markers_[i]; i++) {
	      if (m == marker) {
	        index = i;
	        break;
	      }
	    }
	  }
	
	  if (index == -1) {
	    return false;
	  }
	
	  marker.setMap(null);
	
	  this.markers_.splice(index, 1);
	
	  return true;
	};
	
	MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
	  var removed = this.removeMarker_(marker);
	
	  if (!opt_nodraw && removed) {
	    this.resetViewport();
	    this.redraw();
	    return true;
	  } else {
	    return false;
	  }
	};
	
	MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
	  var removed = false;
	
	  for (var i = 0, marker; marker = markers[i]; i++) {
	    var r = this.removeMarker_(marker);
	    removed = removed || r;
	  }
	
	  if (!opt_nodraw && removed) {
	    this.resetViewport();
	    this.redraw();
	    return true;
	  }
	};
	
	MarkerClusterer.prototype.setReady_ = function (ready) {
	  if (!this.ready_) {
	    this.ready_ = ready;
	    this.createClusters_();
	  }
	};
	
	MarkerClusterer.prototype.getTotalClusters = function () {
	  return this.clusters_.length;
	};
	
	MarkerClusterer.prototype.getMap = function () {
	  return this.map_;
	};
	
	MarkerClusterer.prototype.setMap = function (map) {
	  this.map_ = map;
	};
	
	MarkerClusterer.prototype.getGridSize = function () {
	  return this.gridSize_;
	};
	
	MarkerClusterer.prototype.setGridSize = function (size) {
	  this.gridSize_ = size;
	};
	
	MarkerClusterer.prototype.getMinClusterSize = function () {
	  return this.minClusterSize_;
	};
	
	MarkerClusterer.prototype.setMinClusterSize = function (size) {
	  this.minClusterSize_ = size;
	};
	
	MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
	  var projection = this.getProjection();
	
	  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
	  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng());
	
	  var trPix = projection.fromLatLngToDivPixel(tr);
	  trPix.x += this.gridSize_;
	  trPix.y -= this.gridSize_;
	
	  var blPix = projection.fromLatLngToDivPixel(bl);
	  blPix.x -= this.gridSize_;
	  blPix.y += this.gridSize_;
	
	  var ne = projection.fromDivPixelToLatLng(trPix);
	  var sw = projection.fromDivPixelToLatLng(blPix);
	
	  bounds.extend(ne);
	  bounds.extend(sw);
	
	  return bounds;
	};
	
	MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
	  return bounds.contains(marker.getPosition());
	};
	
	MarkerClusterer.prototype.clearMarkers = function () {
	  this.resetViewport(true);
	
	  this.markers_ = [];
	};
	
	MarkerClusterer.prototype.resetViewport = function (opt_hide) {
	  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
	    cluster.remove();
	  }
	
	  for (var i = 0, marker; marker = this.markers_[i]; i++) {
	    marker.isAdded = false;
	    if (opt_hide) {
	      marker.setMap(null);
	    }
	  }
	
	  this.clusters_ = [];
	};
	
	MarkerClusterer.prototype.repaint = function () {
	  var oldClusters = this.clusters_.slice();
	  this.clusters_.length = 0;
	  this.resetViewport();
	  this.redraw();
	
	  window.setTimeout(function () {
	    for (var i = 0, cluster; cluster = oldClusters[i]; i++) {
	      cluster.remove();
	    }
	  }, 0);
	};
	
	MarkerClusterer.prototype.redraw = function () {
	  this.createClusters_();
	};
	
	MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
	  if (!p1 || !p2) {
	    return 0;
	  }
	
	  var R = 6371;
	  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
	  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
	  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
	  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  var d = R * c;
	  return d;
	};
	
	MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
	  var distance = 40000;
	  var clusterToAddTo = null;
	  var pos = marker.getPosition();
	  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
	    var center = cluster.getCenter();
	    if (center) {
	      var d = this.distanceBetweenPoints_(center, marker.getPosition());
	      if (d < distance) {
	        distance = d;
	        clusterToAddTo = cluster;
	      }
	    }
	  }
	
	  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
	    clusterToAddTo.addMarker(marker);
	  } else {
	    var cluster = new Cluster(this);
	    cluster.addMarker(marker);
	    this.clusters_.push(cluster);
	  }
	};
	
	MarkerClusterer.prototype.createClusters_ = function () {
	  if (!this.ready_) {
	    return;
	  }
	
	  var mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(), this.map_.getBounds().getNorthEast());
	  var bounds = this.getExtendedBounds(mapBounds);
	
	  for (var i = 0, marker; marker = this.markers_[i]; i++) {
	    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
	      this.addToClosestCluster_(marker);
	    }
	  }
	};
	
	function Cluster(markerClusterer) {
	  this.markerClusterer_ = markerClusterer;
	  this.map_ = markerClusterer.getMap();
	  this.gridSize_ = markerClusterer.getGridSize();
	  this.minClusterSize_ = markerClusterer.getMinClusterSize();
	  this.averageCenter_ = markerClusterer.isAverageCenter();
	  this.center_ = null;
	  this.markers_ = [];
	  this.bounds_ = null;
	  this.clusterIcon_ = new ClusterIcon(this, markerClusterer.getStyles(), markerClusterer.getGridSize());
	}
	
	Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
	  if (this.markers_.indexOf) {
	    return this.markers_.indexOf(marker) != -1;
	  } else {
	    for (var i = 0, m; m = this.markers_[i]; i++) {
	      if (m == marker) {
	        return true;
	      }
	    }
	  }
	  return false;
	};
	
	Cluster.prototype.addMarker = function (marker) {
	  if (this.isMarkerAlreadyAdded(marker)) {
	    return false;
	  }
	
	  if (!this.center_) {
	    this.center_ = marker.getPosition();
	    this.calculateBounds_();
	  } else {
	    if (this.averageCenter_) {
	      var l = this.markers_.length + 1;
	      var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
	      var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
	      this.center_ = new google.maps.LatLng(lat, lng);
	      this.calculateBounds_();
	    }
	  }
	
	  marker.isAdded = true;
	  this.markers_.push(marker);
	
	  var len = this.markers_.length;
	  if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
	    marker.setMap(this.map_);
	  }
	
	  if (len == this.minClusterSize_) {
	    for (var i = 0; i < len; i++) {
	      this.markers_[i].setMap(null);
	    }
	  }
	
	  if (len >= this.minClusterSize_) {
	    marker.setMap(null);
	  }
	
	  this.updateIcon();
	  return true;
	};
	
	Cluster.prototype.getMarkerClusterer = function () {
	  return this.markerClusterer_;
	};
	
	Cluster.prototype.getBounds = function () {
	  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
	  var markers = this.getMarkers();
	  for (var i = 0, marker; marker = markers[i]; i++) {
	    bounds.extend(marker.getPosition());
	  }
	  return bounds;
	};
	
	Cluster.prototype.remove = function () {
	  this.clusterIcon_.remove();
	  this.markers_.length = 0;
	  delete this.markers_;
	};
	
	Cluster.prototype.getSize = function () {
	  return this.markers_.length;
	};
	
	Cluster.prototype.getMarkers = function () {
	  return this.markers_;
	};
	
	Cluster.prototype.getCenter = function () {
	  return this.center_;
	};
	
	Cluster.prototype.calculateBounds_ = function () {
	  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
	  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
	};
	
	Cluster.prototype.isMarkerInClusterBounds = function (marker) {
	  return this.bounds_.contains(marker.getPosition());
	};
	
	Cluster.prototype.getMap = function () {
	  return this.map_;
	};
	
	Cluster.prototype.updateIcon = function () {
	  var zoom = this.map_.getZoom();
	  var mz = this.markerClusterer_.getMaxZoom();
	
	  if (mz && zoom > mz) {
	    for (var i = 0, marker; marker = this.markers_[i]; i++) {
	      marker.setMap(this.map_);
	    }
	    return;
	  }
	
	  if (this.markers_.length < this.minClusterSize_) {
	    this.clusterIcon_.hide();
	    return;
	  }
	
	  var numStyles = this.markerClusterer_.getStyles().length;
	  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
	  this.clusterIcon_.setCenter(this.center_);
	  this.clusterIcon_.setSums(sums);
	  this.clusterIcon_.show();
	};
	
	function ClusterIcon(cluster, styles, opt_padding) {
	  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);
	
	  this.styles_ = styles;
	  this.padding_ = opt_padding || 0;
	  this.cluster_ = cluster;
	  this.center_ = null;
	  this.map_ = cluster.getMap();
	  this.div_ = null;
	  this.sums_ = null;
	  this.visible_ = false;
	
	  this.setMap(this.map_);
	}
	
	ClusterIcon.prototype.triggerClusterClick = function () {
	  var markerClusterer = this.cluster_.getMarkerClusterer();
	
	  google.maps.event.trigger(markerClusterer, 'clusterclick', this.cluster_);
	
	  if (markerClusterer.isZoomOnClick()) {
	    this.map_.fitBounds(this.cluster_.getBounds());
	  }
	};
	
	ClusterIcon.prototype.onAdd = function () {
	  this.div_ = document.createElement('DIV');
	  if (this.visible_) {
	    var pos = this.getPosFromLatLng_(this.center_);
	    this.div_.style.cssText = this.createCss(pos);
	    this.div_.innerHTML = this.sums_.text;
	  }
	
	  var panes = this.getPanes();
	  panes.overlayMouseTarget.appendChild(this.div_);
	
	  var that = this;
	  google.maps.event.addDomListener(this.div_, 'click', function () {
	    that.triggerClusterClick();
	  });
	};
	
	ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
	  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
	  pos.x -= parseInt(this.width_ / 2, 10);
	  pos.y -= parseInt(this.height_ / 2, 10);
	  return pos;
	};
	
	ClusterIcon.prototype.draw = function () {
	  if (this.visible_) {
	    var pos = this.getPosFromLatLng_(this.center_);
	    this.div_.style.top = pos.y + 'px';
	    this.div_.style.left = pos.x + 'px';
	  }
	};
	
	ClusterIcon.prototype.hide = function () {
	  if (this.div_) {
	    this.div_.style.display = 'none';
	  }
	  this.visible_ = false;
	};
	
	ClusterIcon.prototype.show = function () {
	  if (this.div_) {
	    var pos = this.getPosFromLatLng_(this.center_);
	    this.div_.style.cssText = this.createCss(pos);
	    this.div_.style.display = '';
	  }
	  this.visible_ = true;
	};
	
	ClusterIcon.prototype.remove = function () {
	  this.setMap(null);
	};
	
	ClusterIcon.prototype.onRemove = function () {
	  if (this.div_ && this.div_.parentNode) {
	    this.hide();
	    this.div_.parentNode.removeChild(this.div_);
	    this.div_ = null;
	  }
	};
	
	ClusterIcon.prototype.setSums = function (sums) {
	  this.sums_ = sums;
	  this.text_ = sums.text;
	  this.index_ = sums.index;
	  if (this.div_) {
	    this.div_.innerHTML = sums.text;
	  }
	
	  this.useStyle();
	};
	
	ClusterIcon.prototype.useStyle = function () {
	  var index = Math.max(0, this.sums_.index - 1);
	  index = Math.min(this.styles_.length - 1, index);
	  var style = this.styles_[index];
	  this.url_ = style['url'];
	  this.height_ = style['height'];
	  this.width_ = style['width'];
	  this.textColor_ = style['textColor'];
	  this.anchor_ = style['anchor'];
	  this.textSize_ = style['textSize'];
	  this.backgroundPosition_ = style['backgroundPosition'];
	};
	
	ClusterIcon.prototype.setCenter = function (center) {
	  this.center_ = center;
	};
	
	ClusterIcon.prototype.createCss = function (pos) {
	  var style = [];
	  style.push('background-image:url(' + this.url_ + ');');
	  var backgroundPosition = this.backgroundPosition_ ? this.backgroundPosition_ : '0 0';
	  style.push('background-position:' + backgroundPosition + ';');
	
	  if ((0, _typeof3.default)(this.anchor_) === 'object') {
	    if (typeof this.anchor_[0] === 'number' && this.anchor_[0] > 0 && this.anchor_[0] < this.height_) {
	      style.push('height:' + (this.height_ - this.anchor_[0]) + 'px; padding-top:' + this.anchor_[0] + 'px;');
	    } else {
	      style.push('height:' + this.height_ + 'px; line-height:' + this.height_ + 'px;');
	    }
	    if (typeof this.anchor_[1] === 'number' && this.anchor_[1] > 0 && this.anchor_[1] < this.width_) {
	      style.push('width:' + (this.width_ - this.anchor_[1]) + 'px; padding-left:' + this.anchor_[1] + 'px;');
	    } else {
	      style.push('width:' + this.width_ + 'px; text-align:center;');
	    }
	  } else {
	    style.push('height:' + this.height_ + 'px; line-height:' + this.height_ + 'px; width:' + this.width_ + 'px; text-align:center;');
	  }
	
	  var txtColor = this.textColor_ ? this.textColor_ : 'black';
	  var txtSize = this.textSize_ ? this.textSize_ : 11;
	
	  style.push('cursor:pointer; top:' + pos.y + 'px; left:' + pos.x + 'px; color:' + txtColor + '; position:absolute; font-size:' + txtSize + 'px; font-family:Arial,sans-serif; font-weight:bold');
	  return style.join('');
	};
	
	exports.default = MarkerClusterer;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _configuration = __webpack_require__(130);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$is = function (index) {
	      return index.split('|').includes(this.type);
	    };
	
	    Vue.prototype.$isModuleEnabled = function (item) {
	      var module = _configuration2.default.state.modules.modules_enabled.value.find(function (module) {
	        return item === module;
	      });
	
	      return item === module;
	    };
	
	    Vue.prototype.$isNot = function (index) {
	      return !this.$is(index);
	    };
	
	    Vue.directive('click-outside', {
	      bind: function bind(el, binding, vnode) {
	        el.clickOutsideEvent = function (event) {
	          if (!(el == event.target || el.contains(event.target))) {
	            vnode.context[binding.expression](event);
	          }
	        };
	        document.body.addEventListener('click', el.clickOutsideEvent);
	      },
	      unbind: function unbind(el) {
	        document.body.removeEventListener('click', el.clickOutsideEvent);
	      }
	    });
	  }
	};

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperties = __webpack_require__(1198);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function plugin(Vue) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  (0, _defineProperties2.default)(Vue.prototype, {
	    $breadcrumbs: {
	      get: function get() {
	
	        var crumbs = [];
	        for (var i = 0; i < this.$route.matched.length; i++) {
	
	          var crumb = this.$route.matched[i].meta.breadcrumb;
	          var display_name = crumb != undefined && typeof crumb === 'string' && crumb.startsWith('#') ? "" + crumb + this.$route.params.id : crumbs;
	
	          if (crumb != undefined && crumb.startsWith('#')) {
	            crumb = display_name;
	          }
	          crumbs.push({
	            display_name: crumb,
	            route_name: this.$route.matched[i].name,
	            route_path: this.$route.matched[i].path + '/'
	          });
	        }
	        return crumbs;
	      }
	    }
	  });
	
	  Vue.prototype.$breadcrumbsTarget = function (item) {
	    if (item.route_name) {
	      return { name: item.route_name };
	    } else {
	      if (item.route_path.indexOf(":") !== -1) {
	        return { path: item.route_path.replace(/:[a-z]+/, this.$route.params.id) };
	      } else {
	        return { path: item.route_path };
	      }
	    }
	  }, Vue.component('breadcrumbs', {
	    template: '<div class="row">' + '<nav aria-label="You are here:" role="navigation" v-if="$breadcrumbs.length">' + '<ul class="breadcrumbs">' + '<li v-for="(crumb, index) in $breadcrumbs">' + '<router-link :to="$breadcrumbsTarget(crumb)">{{ crumb.display_name }}</router-link>' + '</li>' + '</ul>' + '</nav>' + '</div>'
	  });
	}
	
	plugin.version = '0.3.0';
	
	exports.default = plugin;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _configuration = __webpack_require__(130);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$priceWithVat = function (price) {
	      var vat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var p = parseFloat(price);
	
	      var vatRate = _configuration2.default.state.commercial.commercial_vat_rate.value;
	      if (vat !== null) {
	        vatRate = vat;
	      }
	      return p + p * vatRate;
	    };
	
	    Vue.prototype.$priceWithoutVat = function (price) {
	      var vat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var vatRate = _configuration2.default.state.commercial.commercial_vat_rate.value;
	      if (vat !== null) {
	        vatRate = vat;
	      }
	      return (price / (1 + vatRate)).toFixed(2);
	    };
	    Vue.prototype.$defaultVat = function () {
	      var vat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var vatRate = _configuration2.default.state.commercial.commercial_vat_rate.value;
	      return vatRate * 100;
	    };
	
	    Vue.prototype.$priceWithcurrency = function (price) {
	      return '' + _configuration2.default.state.commercial.commercial_currency.value + price;
	    };
	
	    Vue.prototype.$vatPart = function (price) {
	      var vat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var p = parseFloat(price);
	      var vatRate = _configuration2.default.state.commercial.commercial_vat_rate.value;
	      if (vat !== null) {
	        vatRate = vat;
	      }
	      return p / (1 + vatRate);
	    };
	  }
	};

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _configuration = __webpack_require__(130);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = __webpack_require__(4);
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$dateDifference = function (dateEnd) {
	      var dateStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (dateStart === null) {
	        dateStart = moment();
	      } else {
	        dateStart = moment(dateStart);
	      }
	      var dateEnd = moment(dateEnd);
	      var diffDuration = moment.duration(dateStart.diff(dateEnd));
	      return diffDuration.humanize();
	    };
	
	    Vue.prototype.$dateFormat = function (date) {
	      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (format == null) {
	        format = this.$toMomentFormat(_configuration2.default.state.locale.locale_datetime_format.value);
	      }
	      return date ? moment(date).format(format) : null;
	    };
	
	    Vue.prototype.$daysNumberToHuman = function (days) {
	      if (days >= 365) {
	        return 'years';
	      } else {
	        return 'month';
	      }
	      return days >= 365;
	    };
	
	    Vue.prototype.$diffInDays = function (dateEnd) {
	      var dateStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var date1 = new Date(dateStart);
	      var date2 = new Date(dateEnd);
	      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
	      return Math.ceil(timeDiff / (1000 * 3600 * 24));
	    };
	    Vue.prototype.$date = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      return date ? moment(date) : moment();
	    };
	
	    Vue.prototype.$convertTimestamp = function (datetime) {
	
	      if (typeof datetime === 'string') {
	        var t = datetime.split(/[- :]/);
	        var date = new Date(t[0], t[1] - 1, t[2], t[3], t[4]);
	        return Math.round(date.getTime() / 1000);
	      }
	
	      return datetime;
	    };
	
	    Vue.prototype.$toMomentFormat = function (format) {
	      var conversions = {
	        'd': 'DD',
	        'D': 'ddd',
	        'j': 'D',
	        'l': 'dddd',
	        'N': 'E',
	        'S': 'o',
	        'w': 'e',
	        'z': 'DDD',
	        'W': 'W',
	        'F': 'MMMM',
	        'm': 'MM',
	        'M': 'MMM',
	        'n': 'M',
	        't': '',
	        'L': '',
	        'o': 'YYYY',
	        'Y': 'YYYY',
	        'y': 'YY',
	        'a': 'a',
	        'A': 'A',
	        'B': '',
	        'g': 'h',
	        'G': 'H',
	        'h': 'hh',
	        'H': 'HH',
	        'i': 'mm',
	        's': 'ss',
	        'u': 'SSS',
	        'e': 'zz',
	        'I': '',
	        'O': '',
	        'P': '',
	        'T': '',
	        'Z': '',
	        'c': '',
	        'r': '',
	        'U': 'X'
	      };
	      return format.replace(/[A-Za-z]+/g, function (match) {
	        return conversions[match] || match;
	      });
	    };
	    Vue.prototype.$configurationDateFormat = function () {
	      return _configuration2.default.state.locale.locale_date_format.value;
	    };
	    Vue.prototype.$configurationDateTimeFormat = function () {
	      return _configuration2.default.state.locale.locale_datetime_format.value;
	    };
	  }
	};

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  install: function install(Vue) {
	    Vue.directive('f-dropdown-menu', {
	      bind: function bind(el) {
	        new Foundation.DropdownMenu($(el));
	      },
	      unbind: function unbind(el) {
	        $(el).foundation('destroy');
	      }
	    });
	
	    Vue.directive('f-off-canvas', {
	      bind: function bind(el) {
	        new Foundation.OffCanvas($(el), { transitionTime: 500 });
	      },
	      unbind: function unbind(el) {
	        $(el).foundation('destroy');
	      }
	    });
	
	    Vue.directive('f-slider', {
	      bind: function bind(el) {
	        new Foundation.Slider($(el));
	      },
	      unbind: function unbind(el) {
	        $(el).foundation('destroy');
	      }
	    });
	
	    Vue.directive('f-tabs', {
	      bind: function bind(el) {
	        new Foundation.Tabs($(el));
	      },
	      unbind: function unbind(el) {
	        $(el).foundation('destroy');
	      }
	    });
	
	    Vue.directive('f-dropdown', {
	      inserted: function inserted(el) {
	        $(el).foundation();
	      },
	      unbind: function unbind(el) {
	        $(el).foundation('destroy');
	      }
	    });
	
	    Vue.directive('f-accordion', {
	      bind: function bind(el) {
	        new Foundation.Accordion($(el));
	      },
	      unbind: function unbind(el) {
	        $(el).foundation('destroy');
	      }
	    });
	    Vue.directive('f', {
	      bind: function bind(el) {
	        $(el).foundation();
	      },
	      unbind: function unbind(el) {
	        $(el).foundation('destroy');
	      }
	    });
	
	    Vue.directive('f-nd', {
	      bind: function bind(el) {
	        $(el).foundation();
	      }
	    });
	
	    Vue.prototype.$confirm = function (title, message, callback) {
	      var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	      var modal = '<div class="reveal small" id="confirmation">' + '<h2>' + title + '</h2>' + '<p class="lead">' + message + '</p>' + '<div class="content">' + extra + '</div> ' + '<button class="button success yes">Yes</button>' + '<button class="button alert float-right" data-close>No</button>' + '</div>';
	
	      $('body').append(modal);
	
	      var confirmation = new Foundation.Reveal($('#confirmation'));
	
	      confirmation.open();
	
	
	      $('#confirmation').children('.yes').on('click', function () {
	        confirmation.close();
	        $('#confirmation').remove();
	
	        callback.call();
	      });
	      $(document).on('closed.zf.reveal', '#confirmation', function () {
	        $('#confirmation').remove();
	      });
	    };
	  }
	};

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  install: function install(Vue) {
	
	    Vue.prototype.$toDashedString = function (string) {
	      return string.toLowerCase().replace('&', '').replace(/ /g, '-').replace(/[-]+/g, '-').replace(/[^\w-]+/g, '');
	    };
	
	    Vue.prototype.$debounce = function (func) {
	      var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
	      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var timeout;
	      return function () {
	        var context = this,
	            args = arguments;
	        var later = function later() {
	          timeout = null;
	          if (!immediate) func.apply(context, args);
	        };
	        var callNow = immediate && !timeout;
	        clearTimeout(timeout);
	        timeout = setTimeout(later, wait);
	        if (callNow) func.apply(context, args);
	      };
	    };
	
	    Vue.prototype.$isset = function (value) {
	      return typeof value !== "undefined";
	    };
	
	    Vue.prototype.$cleanObject = function (object) {
	      for (var field in object) {
	        if (object[field] === null || object[field] === undefined || object[field] === "") {
	          delete object[field];
	        }
	      }
	    };
	  }
	};

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var state = {
	    readOnly: true
	};
	
	var mutations = {
	    TOGGLE_EDIT: function TOGGLE_EDIT(state, toggle) {
	        state.readOnly = toggle ? toggle : !state.readOnly;
	    }
	};
	
	var actions = {
	    togglePlanEdit: function togglePlanEdit(_ref, toggle) {
	        var commit = _ref.commit;
	
	        commit('TOGGLE_EDIT', toggle);
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keplerSdk = __webpack_require__(65);
	
	var _keplerSdk2 = _interopRequireDefault(_keplerSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    brands: [],
	    categories: [],
	    vehicles: [],
	    fuels: []
	};
	
	var mutations = {
	    SET_BRAND_LIST: function SET_BRAND_LIST(state, brands) {
	        state.brands = brands;
	    },
	    SET_VEHICLE_LIST: function SET_VEHICLE_LIST(state, vehicles) {
	        state.vehicles = vehicles;
	    },
	    SET_CATEGORY_LIST: function SET_CATEGORY_LIST(state, categories) {
	        state.categories = categories;
	    },
	    SET_FUEL_TYPE_LIST: function SET_FUEL_TYPE_LIST(state, fuels) {
	        state.fuels = fuels;
	    }
	};
	
	var actions = {
	    setBrandList: function setBrandList(_ref, force) {
	        var commit = _ref.commit;
	
	        _keplerSdk2.default.brands(function (data) {
	            commit('SET_BRAND_LIST', data);
	        }, function (error) {
	            alert(error);
	        });
	    },
	    setFuelTypeList: function setFuelTypeList(_ref2, force) {
	        var commit = _ref2.commit;
	
	        _keplerSdk2.default.fuelTypes(function (data) {
	            commit('SET_FUEL_TYPE_LIST', data);
	        }, function (error) {
	            alert(error);
	        });
	    },
	    setCategoriesList: function setCategoriesList(_ref3, force) {
	        var commit = _ref3.commit;
	
	        _keplerSdk2.default.vehicleCategories(function (data) {
	            commit('SET_CATEGORY_LIST', data);
	        }, function (error) {
	            alert(error);
	        });
	    },
	    setVehicleList: function setVehicleList(_ref4, force) {
	        var commit = _ref4.commit;
	
	        _keplerSdk2.default.vehicles(function (data) {
	            commit('SET_VEHICLE_LIST', data);
	        }, function (error) {
	            alert(error);
	        });
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keplerSdk = __webpack_require__(65);
	
	var _keplerSdk2 = _interopRequireDefault(_keplerSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    clientTypes: [],
	    clientTypesLastFetch: null
	};
	
	var mutations = {
	    SET_CLIENT_TYPES_LIST: function SET_CLIENT_TYPES_LIST(state, message) {
	        state.clientTypes = message;
	    },
	    SET_CLIENT_TYPES_LAST_FETCH: function SET_CLIENT_TYPES_LAST_FETCH(state, message) {
	        state.clientTypesLastFetch = message;
	    }
	};
	
	var actions = {
	    fetchClientTypes: function fetchClientTypes(_ref, payload) {
	        var commit = _ref.commit;
	
	        if (state.clientTypesLastFetch == null) {
	            _keplerSdk2.default.getClientTypes(function (data) {
	                commit('SET_CLIENT_TYPES_LAST_FETCH', Math.floor(Date.now() / 1000));
	                commit('SET_CLIENT_TYPES_LIST', data);
	            });
	        }
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keplerSdk = __webpack_require__(65);
	
	var _keplerSdk2 = _interopRequireDefault(_keplerSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    drivers: [],
	    driversLastFetch: null
	};
	
	var mutations = {
	    SET_DRIVERS_LIST: function SET_DRIVERS_LIST(state, message) {
	        state.drivers = message;
	    },
	    SET_DRIVERS_LAST_FETCH: function SET_DRIVERS_LAST_FETCH(state, message) {
	        state.driversLastFetch = message;
	    }
	};
	
	var actions = {
	    fetchDrivers: function fetchDrivers(_ref, payload) {
	        var commit = _ref.commit;
	
	        if (state.driversLastFetch == null) {
	            _keplerSdk2.default.drivers(function (data) {
	                commit('SET_DRIVERS_LAST_FETCH', Math.floor(Date.now() / 1000));
	                commit('SET_DRIVERS_LIST', data);
	            }, function (error) {});
	        }
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keplerSdk = __webpack_require__(65);
	
	var _keplerSdk2 = _interopRequireDefault(_keplerSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    licenseTypes: [],
	    licenseTypesLastFetch: null
	};
	
	var mutations = {
	    SET_LICENSE_TYPES_LIST: function SET_LICENSE_TYPES_LIST(state, message) {
	        state.licenseTypes = message;
	    },
	    SET_LICENSE_TYPES_LAST_FETCH: function SET_LICENSE_TYPES_LAST_FETCH(state, message) {
	        state.licenseTypesLastFetch = message;
	    }
	};
	
	var actions = {
	    fetchLicenseTypes: function fetchLicenseTypes(_ref, payload) {
	        var commit = _ref.commit;
	
	        if (state.licenseTypesLastFetch == null) {
	            _keplerSdk2.default.getDriverLicense(function (data) {
	                commit('SET_LICENSE_TYPES_LAST_FETCH', Math.floor(Date.now() / 1000));
	                commit('SET_LICENSE_TYPES_LIST', data);
	            }, function (data) {});
	        }
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keplerSdk = __webpack_require__(65);
	
	var _keplerSdk2 = _interopRequireDefault(_keplerSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    paymentMethods: [],
	    paymentMethodsLastFetch: null
	};
	
	var mutations = {
	    SET_PAYMENT_METHODS_LIST: function SET_PAYMENT_METHODS_LIST(state, message) {
	        state.paymentMethods = message;
	    },
	    SET_PAYMENT_METHODS_LAST_FETCH: function SET_PAYMENT_METHODS_LAST_FETCH(state, message) {
	        state.paymentMethodsLastFetch = message;
	    }
	};
	
	var actions = {
	    sample_call_all: function sample_call_all(_ref, payload) {
	        var dispatch = _ref.dispatch,
	            commit = _ref.commit;
	    },
	    fetchPaymentMethods: function fetchPaymentMethods(_ref2, payload) {
	        var commit = _ref2.commit;
	
	        if (state.paymentMethodsLastFetch == null) {
	            _keplerSdk2.default.paymentMethodsList(function (data) {
	                commit('SET_PAYMENT_METHODS_LAST_FETCH', Math.floor(Date.now() / 1000));
	                commit('SET_PAYMENT_METHODS_LIST', data);
	            }, function (error) {});
	        }
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keplerSdk = __webpack_require__(65);
	
	var _keplerSdk2 = _interopRequireDefault(_keplerSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    reservations: [],
	    reservationsLastFetch: null
	};
	
	var mutations = {
	    SET_RESERVATION_LIST: function SET_RESERVATION_LIST(state, message) {
	        state.reservations = message;
	    },
	    SET_RESERVATION_LAST_FETCH: function SET_RESERVATION_LAST_FETCH(state, message) {
	        state.reservationsLastFetch = message;
	    }
	};
	
	var actions = {
	    fetchReservations: function fetchReservations(_ref, payload) {
	        var commit = _ref.commit;
	
	        if (state.reservationsLastFetch == null) {
	            _keplerSdk2.default.reservationList(function (data) {
	                commit('SET_RESERVATION_LAST_FETCH', Math.floor(Date.now() / 1000));
	                commit('SET_RESERVATION_LIST', data);
	            }, function (error) {});
	        }
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keplerSdk = __webpack_require__(65);
	
	var _keplerSdk2 = _interopRequireDefault(_keplerSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    subscriptions: [],
	    subscriptionsLastFetch: null
	};
	
	var mutations = {
	    SET_SUBSCRIPTIONS_LIST: function SET_SUBSCRIPTIONS_LIST(state, message) {
	        state.subscriptions = message;
	    },
	    SET_SUBSCRIPTIONS_LAST_FETCH: function SET_SUBSCRIPTIONS_LAST_FETCH(state, message) {
	        state.subscriptionsLastFetch = message;
	    }
	};
	
	var actions = {
	    sample_call_all: function sample_call_all(_ref, payload) {
	        var dispatch = _ref.dispatch,
	            commit = _ref.commit;
	    },
	    fetchSubscriptions: function fetchSubscriptions(_ref2, payload) {
	        var commit = _ref2.commit;
	
	        if (state.subscriptionsLastFetch == null) {
	            _keplerSdk2.default.getSubscriptions(function (data) {
	                commit('SET_SUBSCRIPTIONS_LAST_FETCH', Math.floor(Date.now() / 1000));
	                commit('SET_SUBSCRIPTIONS_LIST', data);
	            }, function (error) {});
	        }
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keplerSdk = __webpack_require__(65);
	
	var _keplerSdk2 = _interopRequireDefault(_keplerSdk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	    wallets: [],
	    walletsLastFetch: null
	};
	
	var mutations = {
	    SET_WALLETS_LIST: function SET_WALLETS_LIST(state, message) {
	        state.wallets = message;
	    },
	    SET_WALLETS_LAST_FETCH: function SET_WALLETS_LAST_FETCH(state, message) {
	        state.walletsLastFetch = message;
	    }
	};
	
	var actions = {
	    fetchWallets: function fetchWallets(_ref, payload) {
	        var commit = _ref.commit;
	
	        if (state.walletsLastFetch == null) {
	            _keplerSdk2.default.getWallets(function (data) {
	                commit('SET_WALLETS_LAST_FETCH', Math.floor(Date.now() / 1000));
	                commit('SET_WALLETS_LIST', data);
	            }, function (error) {});
	        }
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var state = {
	    notifications: []
	};
	
	var mutations = {
	    ADD_NOTIFICATION: function ADD_NOTIFICATION(state, message) {
	        state.notifications.push(message);
	    },
	    REMOVE_NOTIFICATION: function REMOVE_NOTIFICATION(state, notification_id) {
	        state.notifications.splice(notification_id, 1);
	    }
	};
	
	var actions = {
	    newNotification: function newNotification(_ref, message) {
	        var commit = _ref.commit;
	
	        commit('ADD_NOTIFICATION', message);
	    },
	    removeNotification: function removeNotification(_ref2, notification_id) {
	        var commit = _ref2.commit;
	
	        commit('REMOVE_NOTIFICATION', notification_id);
	    }
	};
	
	exports.default = {
	    state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(95);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _backoffice = __webpack_require__(2);
	
	var _backoffice2 = _interopRequireDefault(_backoffice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  user: null,
	  token: null,
	  logged_in: false,
	
	  isRoot: false,
	  userPermissions: [],
	  menuPermissions: []
	};
	
	var mutations = {
	  SET_USER: function SET_USER(state, user) {
	    state.user = user;
	    state.logged_in = true;
	  },
	  SET_TOKEN: function SET_TOKEN(state, token) {
	    state.token = token;
	  },
	  SET_IS_ROOT: function SET_IS_ROOT(state, user) {
	    var role = user.roles.find(function (item) {
	      return item.name === 'ROOT';
	    });
	    state.isRoot = role !== undefined && role.name === 'ROOT';
	  },
	  SET_USER_PERMISSIONS: function SET_USER_PERMISSIONS(state, user) {
	    state.userPermissions = user.roles.flatMap(function (item) {
	      return item.permissions;
	    });
	  },
	  SET_MENU_PERMISSIONS: function SET_MENU_PERMISSIONS(state) {
	    state.menuPermissions = state.userPermissions.filter(function (item) {
	      return item.name.startsWith('menu_');
	    });
	  }
	};
	
	var actions = {
	  login: function login(_ref, payload) {
	    var commit = _ref.commit;
	
	
	    return new _promise2.default(function (resolve) {
	
	      commit('SET_USER', payload);
	      commit('SET_IS_ROOT', payload);
	      commit('SET_USER_PERMISSIONS', payload);
	      commit('SET_MENU_PERMISSIONS');
	      resolve(state);
	    });
	  },
	  setToken: function setToken(_ref2, payload) {
	    var commit = _ref2.commit;
	
	    commit('SET_TOKEN', payload);
	    localStorage.setItem('token', payload);
	  },
	
	  profile: function profile(_ref3) {
	    var commit = _ref3.commit;
	
	    return _backoffice2.default.users.profile().then(function (response) {
	      commit('SET_USER', response.data);
	      commit('SET_IS_ROOT', response.data);
	    });
	  },
	  test: function test(_ref4) {
	    var commit = _ref4.commit;
	
	    commit('SET_IS_ROOT', state.user);
	  }
	};
	
	exports.default = {
	  state: state, mutations: mutations, actions: actions
	};

/***/ }),
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 245,
		"./af.js": 245,
		"./ar": 252,
		"./ar-dz": 246,
		"./ar-dz.js": 246,
		"./ar-kw": 247,
		"./ar-kw.js": 247,
		"./ar-ly": 248,
		"./ar-ly.js": 248,
		"./ar-ma": 249,
		"./ar-ma.js": 249,
		"./ar-sa": 250,
		"./ar-sa.js": 250,
		"./ar-tn": 251,
		"./ar-tn.js": 251,
		"./ar.js": 252,
		"./az": 253,
		"./az.js": 253,
		"./be": 254,
		"./be.js": 254,
		"./bg": 255,
		"./bg.js": 255,
		"./bm": 256,
		"./bm.js": 256,
		"./bn": 257,
		"./bn.js": 257,
		"./bo": 258,
		"./bo.js": 258,
		"./br": 259,
		"./br.js": 259,
		"./bs": 260,
		"./bs.js": 260,
		"./ca": 261,
		"./ca.js": 261,
		"./cs": 262,
		"./cs.js": 262,
		"./cv": 263,
		"./cv.js": 263,
		"./cy": 264,
		"./cy.js": 264,
		"./da": 265,
		"./da.js": 265,
		"./de": 268,
		"./de-at": 266,
		"./de-at.js": 266,
		"./de-ch": 267,
		"./de-ch.js": 267,
		"./de.js": 268,
		"./dv": 269,
		"./dv.js": 269,
		"./el": 270,
		"./el.js": 270,
		"./en-au": 271,
		"./en-au.js": 271,
		"./en-ca": 272,
		"./en-ca.js": 272,
		"./en-gb": 273,
		"./en-gb.js": 273,
		"./en-ie": 274,
		"./en-ie.js": 274,
		"./en-il": 275,
		"./en-il.js": 275,
		"./en-nz": 276,
		"./en-nz.js": 276,
		"./eo": 277,
		"./eo.js": 277,
		"./es": 280,
		"./es-do": 278,
		"./es-do.js": 278,
		"./es-us": 279,
		"./es-us.js": 279,
		"./es.js": 280,
		"./et": 281,
		"./et.js": 281,
		"./eu": 282,
		"./eu.js": 282,
		"./fa": 283,
		"./fa.js": 283,
		"./fi": 284,
		"./fi.js": 284,
		"./fo": 285,
		"./fo.js": 285,
		"./fr": 288,
		"./fr-ca": 286,
		"./fr-ca.js": 286,
		"./fr-ch": 287,
		"./fr-ch.js": 287,
		"./fr.js": 288,
		"./fy": 289,
		"./fy.js": 289,
		"./gd": 290,
		"./gd.js": 290,
		"./gl": 291,
		"./gl.js": 291,
		"./gom-latn": 292,
		"./gom-latn.js": 292,
		"./gu": 293,
		"./gu.js": 293,
		"./he": 294,
		"./he.js": 294,
		"./hi": 295,
		"./hi.js": 295,
		"./hr": 296,
		"./hr.js": 296,
		"./hu": 297,
		"./hu.js": 297,
		"./hy-am": 298,
		"./hy-am.js": 298,
		"./id": 299,
		"./id.js": 299,
		"./is": 300,
		"./is.js": 300,
		"./it": 301,
		"./it.js": 301,
		"./ja": 302,
		"./ja.js": 302,
		"./jv": 303,
		"./jv.js": 303,
		"./ka": 304,
		"./ka.js": 304,
		"./kk": 305,
		"./kk.js": 305,
		"./km": 306,
		"./km.js": 306,
		"./kn": 307,
		"./kn.js": 307,
		"./ko": 308,
		"./ko.js": 308,
		"./ky": 309,
		"./ky.js": 309,
		"./lb": 310,
		"./lb.js": 310,
		"./lo": 311,
		"./lo.js": 311,
		"./lt": 312,
		"./lt.js": 312,
		"./lv": 313,
		"./lv.js": 313,
		"./me": 314,
		"./me.js": 314,
		"./mi": 315,
		"./mi.js": 315,
		"./mk": 316,
		"./mk.js": 316,
		"./ml": 317,
		"./ml.js": 317,
		"./mn": 318,
		"./mn.js": 318,
		"./mr": 319,
		"./mr.js": 319,
		"./ms": 321,
		"./ms-my": 320,
		"./ms-my.js": 320,
		"./ms.js": 321,
		"./mt": 322,
		"./mt.js": 322,
		"./my": 323,
		"./my.js": 323,
		"./nb": 324,
		"./nb.js": 324,
		"./ne": 325,
		"./ne.js": 325,
		"./nl": 327,
		"./nl-be": 326,
		"./nl-be.js": 326,
		"./nl.js": 327,
		"./nn": 328,
		"./nn.js": 328,
		"./pa-in": 329,
		"./pa-in.js": 329,
		"./pl": 330,
		"./pl.js": 330,
		"./pt": 332,
		"./pt-br": 331,
		"./pt-br.js": 331,
		"./pt.js": 332,
		"./ro": 333,
		"./ro.js": 333,
		"./ru": 334,
		"./ru.js": 334,
		"./sd": 335,
		"./sd.js": 335,
		"./se": 336,
		"./se.js": 336,
		"./si": 337,
		"./si.js": 337,
		"./sk": 338,
		"./sk.js": 338,
		"./sl": 339,
		"./sl.js": 339,
		"./sq": 340,
		"./sq.js": 340,
		"./sr": 342,
		"./sr-cyrl": 341,
		"./sr-cyrl.js": 341,
		"./sr.js": 342,
		"./ss": 343,
		"./ss.js": 343,
		"./sv": 344,
		"./sv.js": 344,
		"./sw": 345,
		"./sw.js": 345,
		"./ta": 346,
		"./ta.js": 346,
		"./te": 347,
		"./te.js": 347,
		"./tet": 348,
		"./tet.js": 348,
		"./tg": 349,
		"./tg.js": 349,
		"./th": 350,
		"./th.js": 350,
		"./tl-ph": 351,
		"./tl-ph.js": 351,
		"./tlh": 352,
		"./tlh.js": 352,
		"./tr": 353,
		"./tr.js": 353,
		"./tzl": 354,
		"./tzl.js": 354,
		"./tzm": 356,
		"./tzm-latn": 355,
		"./tzm-latn.js": 355,
		"./tzm.js": 356,
		"./ug-cn": 357,
		"./ug-cn.js": 357,
		"./uk": 358,
		"./uk.js": 358,
		"./ur": 359,
		"./ur.js": 359,
		"./uz": 361,
		"./uz-latn": 360,
		"./uz-latn.js": 360,
		"./uz.js": 361,
		"./vi": 362,
		"./vi.js": 362,
		"./x-pseudo": 363,
		"./x-pseudo.js": 363,
		"./yo": 364,
		"./yo.js": 364,
		"./zh-cn": 365,
		"./zh-cn.js": 365,
		"./zh-hk": 366,
		"./zh-hk.js": 366,
		"./zh-tw": 367,
		"./zh-tw.js": 367
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1203;


/***/ }),
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1662 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1670 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1673 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1674 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1676 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1843 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1865 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1870 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1874 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1875 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1876 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1878 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1880 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1881 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1882 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1884 */,
/* 1885 */,
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 390,
		"./af.js": 390,
		"./ar": 397,
		"./ar-dz": 391,
		"./ar-dz.js": 391,
		"./ar-kw": 392,
		"./ar-kw.js": 392,
		"./ar-ly": 393,
		"./ar-ly.js": 393,
		"./ar-ma": 394,
		"./ar-ma.js": 394,
		"./ar-sa": 395,
		"./ar-sa.js": 395,
		"./ar-tn": 396,
		"./ar-tn.js": 396,
		"./ar.js": 397,
		"./az": 398,
		"./az.js": 398,
		"./be": 399,
		"./be.js": 399,
		"./bg": 400,
		"./bg.js": 400,
		"./bm": 401,
		"./bm.js": 401,
		"./bn": 403,
		"./bn-bd": 402,
		"./bn-bd.js": 402,
		"./bn.js": 403,
		"./bo": 404,
		"./bo.js": 404,
		"./br": 405,
		"./br.js": 405,
		"./bs": 406,
		"./bs.js": 406,
		"./ca": 407,
		"./ca.js": 407,
		"./cs": 408,
		"./cs.js": 408,
		"./cv": 409,
		"./cv.js": 409,
		"./cy": 410,
		"./cy.js": 410,
		"./da": 411,
		"./da.js": 411,
		"./de": 414,
		"./de-at": 412,
		"./de-at.js": 412,
		"./de-ch": 413,
		"./de-ch.js": 413,
		"./de.js": 414,
		"./dv": 415,
		"./dv.js": 415,
		"./el": 416,
		"./el.js": 416,
		"./en-au": 417,
		"./en-au.js": 417,
		"./en-ca": 418,
		"./en-ca.js": 418,
		"./en-gb": 419,
		"./en-gb.js": 419,
		"./en-ie": 420,
		"./en-ie.js": 420,
		"./en-il": 421,
		"./en-il.js": 421,
		"./en-in": 422,
		"./en-in.js": 422,
		"./en-nz": 423,
		"./en-nz.js": 423,
		"./en-sg": 424,
		"./en-sg.js": 424,
		"./eo": 425,
		"./eo.js": 425,
		"./es": 429,
		"./es-do": 426,
		"./es-do.js": 426,
		"./es-mx": 427,
		"./es-mx.js": 427,
		"./es-us": 428,
		"./es-us.js": 428,
		"./es.js": 429,
		"./et": 430,
		"./et.js": 430,
		"./eu": 431,
		"./eu.js": 431,
		"./fa": 432,
		"./fa.js": 432,
		"./fi": 433,
		"./fi.js": 433,
		"./fil": 434,
		"./fil.js": 434,
		"./fo": 435,
		"./fo.js": 435,
		"./fr": 438,
		"./fr-ca": 436,
		"./fr-ca.js": 436,
		"./fr-ch": 437,
		"./fr-ch.js": 437,
		"./fr.js": 438,
		"./fy": 439,
		"./fy.js": 439,
		"./ga": 440,
		"./ga.js": 440,
		"./gd": 441,
		"./gd.js": 441,
		"./gl": 442,
		"./gl.js": 442,
		"./gom-deva": 443,
		"./gom-deva.js": 443,
		"./gom-latn": 444,
		"./gom-latn.js": 444,
		"./gu": 445,
		"./gu.js": 445,
		"./he": 446,
		"./he.js": 446,
		"./hi": 447,
		"./hi.js": 447,
		"./hr": 448,
		"./hr.js": 448,
		"./hu": 449,
		"./hu.js": 449,
		"./hy-am": 450,
		"./hy-am.js": 450,
		"./id": 451,
		"./id.js": 451,
		"./is": 452,
		"./is.js": 452,
		"./it": 454,
		"./it-ch": 453,
		"./it-ch.js": 453,
		"./it.js": 454,
		"./ja": 455,
		"./ja.js": 455,
		"./jv": 456,
		"./jv.js": 456,
		"./ka": 457,
		"./ka.js": 457,
		"./kk": 458,
		"./kk.js": 458,
		"./km": 459,
		"./km.js": 459,
		"./kn": 460,
		"./kn.js": 460,
		"./ko": 461,
		"./ko.js": 461,
		"./ku": 462,
		"./ku.js": 462,
		"./ky": 463,
		"./ky.js": 463,
		"./lb": 464,
		"./lb.js": 464,
		"./lo": 465,
		"./lo.js": 465,
		"./lt": 466,
		"./lt.js": 466,
		"./lv": 467,
		"./lv.js": 467,
		"./me": 468,
		"./me.js": 468,
		"./mi": 469,
		"./mi.js": 469,
		"./mk": 470,
		"./mk.js": 470,
		"./ml": 471,
		"./ml.js": 471,
		"./mn": 472,
		"./mn.js": 472,
		"./mr": 473,
		"./mr.js": 473,
		"./ms": 475,
		"./ms-my": 474,
		"./ms-my.js": 474,
		"./ms.js": 475,
		"./mt": 476,
		"./mt.js": 476,
		"./my": 477,
		"./my.js": 477,
		"./nb": 478,
		"./nb.js": 478,
		"./ne": 479,
		"./ne.js": 479,
		"./nl": 481,
		"./nl-be": 480,
		"./nl-be.js": 480,
		"./nl.js": 481,
		"./nn": 482,
		"./nn.js": 482,
		"./oc-lnc": 483,
		"./oc-lnc.js": 483,
		"./pa-in": 484,
		"./pa-in.js": 484,
		"./pl": 485,
		"./pl.js": 485,
		"./pt": 487,
		"./pt-br": 486,
		"./pt-br.js": 486,
		"./pt.js": 487,
		"./ro": 488,
		"./ro.js": 488,
		"./ru": 489,
		"./ru.js": 489,
		"./sd": 490,
		"./sd.js": 490,
		"./se": 491,
		"./se.js": 491,
		"./si": 492,
		"./si.js": 492,
		"./sk": 493,
		"./sk.js": 493,
		"./sl": 494,
		"./sl.js": 494,
		"./sq": 495,
		"./sq.js": 495,
		"./sr": 497,
		"./sr-cyrl": 496,
		"./sr-cyrl.js": 496,
		"./sr.js": 497,
		"./ss": 498,
		"./ss.js": 498,
		"./sv": 499,
		"./sv.js": 499,
		"./sw": 500,
		"./sw.js": 500,
		"./ta": 501,
		"./ta.js": 501,
		"./te": 502,
		"./te.js": 502,
		"./tet": 503,
		"./tet.js": 503,
		"./tg": 504,
		"./tg.js": 504,
		"./th": 505,
		"./th.js": 505,
		"./tk": 506,
		"./tk.js": 506,
		"./tl-ph": 507,
		"./tl-ph.js": 507,
		"./tlh": 508,
		"./tlh.js": 508,
		"./tr": 509,
		"./tr.js": 509,
		"./tzl": 510,
		"./tzl.js": 510,
		"./tzm": 512,
		"./tzm-latn": 511,
		"./tzm-latn.js": 511,
		"./tzm.js": 512,
		"./ug-cn": 513,
		"./ug-cn.js": 513,
		"./uk": 514,
		"./uk.js": 514,
		"./ur": 515,
		"./ur.js": 515,
		"./uz": 517,
		"./uz-latn": 516,
		"./uz-latn.js": 516,
		"./uz.js": 517,
		"./vi": 518,
		"./vi.js": 518,
		"./x-pseudo": 519,
		"./x-pseudo.js": 519,
		"./yo": 520,
		"./yo.js": 520,
		"./zh-cn": 521,
		"./zh-cn.js": 521,
		"./zh-hk": 522,
		"./zh-hk.js": 522,
		"./zh-mo": 523,
		"./zh-mo.js": 523,
		"./zh-tw": 524,
		"./zh-tw.js": 524
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1886;


/***/ }),
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1827)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(630),
	  /* template */
	  __webpack_require__(2684),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1650)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(633),
	  /* template */
	  __webpack_require__(2501),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1482)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(636),
	  /* template */
	  __webpack_require__(2330),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1727)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(637),
	  /* template */
	  __webpack_require__(2581),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1465)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(640),
	  /* template */
	  __webpack_require__(2313),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1810)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(642),
	  /* template */
	  __webpack_require__(2666),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1357)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(643),
	  /* template */
	  __webpack_require__(2203),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1444)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(644),
	  /* template */
	  __webpack_require__(2291),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1721)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(645),
	  /* template */
	  __webpack_require__(2575),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1392)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(647),
	  /* template */
	  __webpack_require__(2239),
	  /* scopeId */
	  "data-v-0aaa06dd",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1758)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(652),
	  /* template */
	  __webpack_require__(2613),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1872)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(654),
	  /* template */
	  __webpack_require__(2729),
	  /* scopeId */
	  "data-v-f665bae0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1557)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(656),
	  /* template */
	  __webpack_require__(2406),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1563)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(657),
	  /* template */
	  __webpack_require__(2412),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1725)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(659),
	  /* template */
	  __webpack_require__(2579),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1469)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(660),
	  /* template */
	  __webpack_require__(2317),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1690)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(661),
	  /* template */
	  __webpack_require__(2544),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1369)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(662),
	  /* template */
	  __webpack_require__(2215),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1377)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(663),
	  /* template */
	  __webpack_require__(2224),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1400)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(664),
	  /* template */
	  __webpack_require__(2247),
	  /* scopeId */
	  "data-v-0d599b00",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1837)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(665),
	  /* template */
	  __webpack_require__(2694),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1736)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(666),
	  /* template */
	  __webpack_require__(2590),
	  /* scopeId */
	  "data-v-75d927fa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1458)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(668),
	  /* template */
	  __webpack_require__(2305),
	  /* scopeId */
	  "data-v-1ded1ad0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1554)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(670),
	  /* template */
	  __webpack_require__(2403),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1795)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(675),
	  /* template */
	  __webpack_require__(2650),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1471)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(676),
	  /* template */
	  __webpack_require__(2319),
	  /* scopeId */
	  "data-v-20d30b82",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1359)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(678),
	  /* template */
	  __webpack_require__(2205),
	  /* scopeId */
	  "data-v-01211f3b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1604)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(679),
	  /* template */
	  __webpack_require__(2455),
	  /* scopeId */
	  "data-v-4a9d1ef4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1646)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(680),
	  /* template */
	  __webpack_require__(2497),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1591)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(685),
	  /* template */
	  __webpack_require__(2441),
	  /* scopeId */
	  "data-v-454f6de9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1798)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(686),
	  /* template */
	  __webpack_require__(2653),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1883)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(687),
	  /* template */
	  __webpack_require__(2740),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1549)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(690),
	  /* template */
	  __webpack_require__(2397),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1539)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(691),
	  /* template */
	  __webpack_require__(2387),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1865)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(695),
	  /* template */
	  __webpack_require__(2722),
	  /* scopeId */
	  "data-v-ec1567e8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1588)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(696),
	  /* template */
	  __webpack_require__(2438),
	  /* scopeId */
	  "data-v-43655c1b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1767)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(698),
	  /* template */
	  __webpack_require__(2622),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1750)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(699),
	  /* template */
	  __webpack_require__(2605),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1573)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(700),
	  /* template */
	  __webpack_require__(2423),
	  /* scopeId */
	  "data-v-3f2ab669",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1724)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(702),
	  /* template */
	  __webpack_require__(2578),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1831)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(703),
	  /* template */
	  __webpack_require__(2688),
	  /* scopeId */
	  "data-v-d0d6087c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1395)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(704),
	  /* template */
	  __webpack_require__(2242),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1474)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(711),
	  /* template */
	  __webpack_require__(2322),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1606)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(713),
	  /* template */
	  __webpack_require__(2457),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1746)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(714),
	  /* template */
	  __webpack_require__(2601),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1835)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(717),
	  /* template */
	  __webpack_require__(2692),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1556)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(718),
	  /* template */
	  __webpack_require__(2405),
	  /* scopeId */
	  "data-v-3a371576",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1624)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(719),
	  /* template */
	  __webpack_require__(2475),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1644)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(720),
	  /* template */
	  __webpack_require__(2495),
	  /* scopeId */
	  "data-v-567c8a20",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1403)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(721),
	  /* template */
	  __webpack_require__(2250),
	  /* scopeId */
	  "data-v-0e1a8854",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1522)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(723),
	  /* template */
	  __webpack_require__(2370),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1372)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(724),
	  /* template */
	  __webpack_require__(2219),
	  /* scopeId */
	  "data-v-05311f62",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1544)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(725),
	  /* template */
	  __webpack_require__(2392),
	  /* scopeId */
	  "data-v-36143fb2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1663)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(726),
	  /* template */
	  __webpack_require__(2515),
	  /* scopeId */
	  "data-v-5cfbae5c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1513)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(727),
	  /* template */
	  __webpack_require__(2361),
	  /* scopeId */
	  "data-v-2d2c9680",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1378)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(728),
	  /* template */
	  __webpack_require__(2225),
	  /* scopeId */
	  "data-v-067f55e4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1871)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(730),
	  /* template */
	  __webpack_require__(2728),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1735)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(731),
	  /* template */
	  __webpack_require__(2589),
	  /* scopeId */
	  "data-v-75d30d52",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1526)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(732),
	  /* template */
	  __webpack_require__(2374),
	  /* scopeId */
	  "data-v-30f47178",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1862)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(733),
	  /* template */
	  __webpack_require__(2719),
	  /* scopeId */
	  "data-v-e46c39c2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1424)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(734),
	  /* template */
	  __webpack_require__(2271),
	  /* scopeId */
	  "data-v-13a48cb0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1728)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(735),
	  /* template */
	  __webpack_require__(2582),
	  /* scopeId */
	  "data-v-73ff95ca",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1700)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(736),
	  /* template */
	  __webpack_require__(2554),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1450)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(737),
	  /* template */
	  __webpack_require__(2297),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1422)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(739),
	  /* template */
	  __webpack_require__(2269),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1771)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(740),
	  /* template */
	  __webpack_require__(2626),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1668)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(741),
	  /* template */
	  __webpack_require__(2520),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1548)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(742),
	  /* template */
	  __webpack_require__(2396),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1407)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(743),
	  /* template */
	  __webpack_require__(2254),
	  /* scopeId */
	  "data-v-0f0254eb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1616)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(744),
	  /* template */
	  __webpack_require__(2467),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1498)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(745),
	  /* template */
	  __webpack_require__(2346),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1709)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(748),
	  /* template */
	  __webpack_require__(2563),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1362)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(751),
	  /* template */
	  __webpack_require__(2208),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1441)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(752),
	  /* template */
	  __webpack_require__(2288),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1510)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(754),
	  /* template */
	  __webpack_require__(2358),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1849)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(756),
	  /* template */
	  __webpack_require__(2706),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1495)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(758),
	  /* template */
	  __webpack_require__(2343),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1678)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(759),
	  /* template */
	  __webpack_require__(2530),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1600)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(760),
	  /* template */
	  __webpack_require__(2451),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1792)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(761),
	  /* template */
	  __webpack_require__(2647),
	  /* scopeId */
	  "data-v-aca4cd6c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1446)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(762),
	  /* template */
	  __webpack_require__(2293),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1776)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(763),
	  /* template */
	  __webpack_require__(2631),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1868)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(765),
	  /* template */
	  __webpack_require__(2725),
	  /* scopeId */
	  "data-v-ef9a9d86",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1373)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(766),
	  /* template */
	  __webpack_require__(2220),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1717)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(767),
	  /* template */
	  __webpack_require__(2571),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1741)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(768),
	  /* template */
	  __webpack_require__(2595),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1518)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(769),
	  /* template */
	  __webpack_require__(2366),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1423)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(770),
	  /* template */
	  __webpack_require__(2270),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1637)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(771),
	  /* template */
	  __webpack_require__(2488),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1505)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(772),
	  /* template */
	  __webpack_require__(2353),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1691)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(773),
	  /* template */
	  __webpack_require__(2545),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1766)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(775),
	  /* template */
	  __webpack_require__(2621),
	  /* scopeId */
	  "data-v-8ab69d74",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1682)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(776),
	  /* template */
	  __webpack_require__(2534),
	  /* scopeId */
	  "data-v-6570d04e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1796)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(777),
	  /* template */
	  __webpack_require__(2651),
	  /* scopeId */
	  "data-v-b01edc5e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1434)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(778),
	  /* template */
	  __webpack_require__(2281),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1408)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(779),
	  /* template */
	  __webpack_require__(2255),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1726)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(780),
	  /* template */
	  __webpack_require__(2580),
	  /* scopeId */
	  "data-v-730940e7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1541)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(784),
	  /* template */
	  __webpack_require__(2389),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1630)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(785),
	  /* template */
	  __webpack_require__(2481),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1747)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(786),
	  /* template */
	  __webpack_require__(2602),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1623)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(787),
	  /* template */
	  __webpack_require__(2474),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1664)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(788),
	  /* template */
	  __webpack_require__(2516),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1686)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(789),
	  /* template */
	  __webpack_require__(2539),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1537)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(790),
	  /* template */
	  __webpack_require__(2385),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1356)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(791),
	  /* template */
	  __webpack_require__(2202),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1622)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(792),
	  /* template */
	  __webpack_require__(2473),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1540)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(793),
	  /* template */
	  __webpack_require__(2388),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1648)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(794),
	  /* template */
	  __webpack_require__(2499),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1590)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(795),
	  /* template */
	  __webpack_require__(2440),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1452)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(796),
	  /* template */
	  __webpack_require__(2299),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(798),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(800),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(802),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(803),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(804),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1571)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(805),
	  /* template */
	  __webpack_require__(2421),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1429)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(807),
	  /* template */
	  __webpack_require__(2276),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1592)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(808),
	  /* template */
	  __webpack_require__(2442),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1602)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(824),
	  /* template */
	  __webpack_require__(2453),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1459)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(825),
	  /* template */
	  __webpack_require__(2306),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1665)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(826),
	  /* template */
	  __webpack_require__(2517),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1381)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(831),
	  /* template */
	  __webpack_require__(2228),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1380)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(843),
	  /* template */
	  __webpack_require__(2227),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1787)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(844),
	  /* template */
	  __webpack_require__(2642),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1670)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(849),
	  /* template */
	  __webpack_require__(2522),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1420)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(850),
	  /* template */
	  __webpack_require__(2267),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1598)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(856),
	  /* template */
	  __webpack_require__(2449),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1445)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(857),
	  /* template */
	  __webpack_require__(2292),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1484)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(859),
	  /* template */
	  __webpack_require__(2332),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1809)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(864),
	  /* template */
	  __webpack_require__(2665),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1833)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(866),
	  /* template */
	  __webpack_require__(2690),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1697)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(870),
	  /* template */
	  __webpack_require__(2551),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1612)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(873),
	  /* template */
	  __webpack_require__(2463),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1875)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(879),
	  /* template */
	  __webpack_require__(2732),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1645)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(880),
	  /* template */
	  __webpack_require__(2496),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1524)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(882),
	  /* template */
	  __webpack_require__(2372),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1797)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(887),
	  /* template */
	  __webpack_require__(2652),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1464)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(888),
	  /* template */
	  __webpack_require__(2312),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1811)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(890),
	  /* template */
	  __webpack_require__(2667),
	  /* scopeId */
	  "data-v-c0bf0b44",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1552)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(891),
	  /* template */
	  __webpack_require__(2401),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1503)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(895),
	  /* template */
	  __webpack_require__(2351),
	  /* scopeId */
	  "data-v-2ba81fc2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1769)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(897),
	  /* template */
	  __webpack_require__(2624),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1681)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(898),
	  /* template */
	  __webpack_require__(2533),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1706)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(900),
	  /* template */
	  __webpack_require__(2560),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1375)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(903),
	  /* template */
	  __webpack_require__(2222),
	  /* scopeId */
	  "data-v-05d06826",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1562)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(904),
	  /* template */
	  __webpack_require__(2411),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1428)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(905),
	  /* template */
	  __webpack_require__(2275),
	  /* scopeId */
	  "data-v-1508b52c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1582)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(906),
	  /* template */
	  __webpack_require__(2432),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1511)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(910),
	  /* template */
	  __webpack_require__(2359),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1478)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(912),
	  /* template */
	  __webpack_require__(2326),
	  /* scopeId */
	  "data-v-23688f2d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1712)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(913),
	  /* template */
	  __webpack_require__(2566),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1654)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(914),
	  /* template */
	  __webpack_require__(2505),
	  /* scopeId */
	  "data-v-5a04af48",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1662)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(915),
	  /* template */
	  __webpack_require__(2514),
	  /* scopeId */
	  "data-v-5cc64474",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1673)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(916),
	  /* template */
	  __webpack_require__(2525),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1657)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(918),
	  /* template */
	  __webpack_require__(2508),
	  /* scopeId */
	  "data-v-5ad629d6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1790)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(922),
	  /* template */
	  __webpack_require__(2645),
	  /* scopeId */
	  "data-v-ac31b3dc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1610)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(923),
	  /* template */
	  __webpack_require__(2461),
	  /* scopeId */
	  "data-v-4bce4006",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1680)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(925),
	  /* template */
	  __webpack_require__(2532),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1755)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(927),
	  /* template */
	  __webpack_require__(2610),
	  /* scopeId */
	  "data-v-7fce3caa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1574)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(928),
	  /* template */
	  __webpack_require__(2424),
	  /* scopeId */
	  "data-v-3f7d52b4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(930),
	  /* template */
	  __webpack_require__(2399),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1430)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(935),
	  /* template */
	  __webpack_require__(2277),
	  /* scopeId */
	  "data-v-15a81f42",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1385)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(936),
	  /* template */
	  __webpack_require__(2232),
	  /* scopeId */
	  "data-v-090511ec",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1468)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(937),
	  /* template */
	  __webpack_require__(2316),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1803)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(938),
	  /* template */
	  __webpack_require__(2659),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1514)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(939),
	  /* template */
	  __webpack_require__(2362),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1546)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(941),
	  /* template */
	  __webpack_require__(2394),
	  /* scopeId */
	  "data-v-370df01a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1394)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(943),
	  /* template */
	  __webpack_require__(2241),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1516)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(945),
	  /* template */
	  __webpack_require__(2364),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1784)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(946),
	  /* template */
	  __webpack_require__(2639),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1693)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(947),
	  /* template */
	  __webpack_require__(2547),
	  /* scopeId */
	  "data-v-687c2ed0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1859)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(952),
	  /* template */
	  __webpack_require__(2716),
	  /* scopeId */
	  "data-v-e1a40aa6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1497)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(955),
	  /* template */
	  __webpack_require__(2345),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1777)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(956),
	  /* template */
	  __webpack_require__(2632),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1867)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(957),
	  /* template */
	  __webpack_require__(2724),
	  /* scopeId */
	  "data-v-edcbed7a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1870)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(959),
	  /* template */
	  __webpack_require__(2727),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1525)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(960),
	  /* template */
	  __webpack_require__(2373),
	  /* scopeId */
	  "data-v-30afe635",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1626)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(962),
	  /* template */
	  __webpack_require__(2477),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1386)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(963),
	  /* template */
	  __webpack_require__(2233),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1788)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(964),
	  /* template */
	  __webpack_require__(2643),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1858)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(965),
	  /* template */
	  __webpack_require__(2715),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1635)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(966),
	  /* template */
	  __webpack_require__(2486),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1740)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(967),
	  /* template */
	  __webpack_require__(2594),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1416)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(969),
	  /* template */
	  __webpack_require__(2263),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1853)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(970),
	  /* template */
	  __webpack_require__(2710),
	  /* scopeId */
	  "data-v-dd11faae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1535)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(971),
	  /* template */
	  __webpack_require__(2383),
	  /* scopeId */
	  "data-v-33a428d9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1785)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(972),
	  /* template */
	  __webpack_require__(2640),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1489)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(973),
	  /* template */
	  __webpack_require__(2337),
	  /* scopeId */
	  "data-v-2642ae57",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1824)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(977),
	  /* template */
	  __webpack_require__(2681),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1625)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(978),
	  /* template */
	  __webpack_require__(2476),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1413)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(980),
	  /* template */
	  __webpack_require__(2260),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1366)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(981),
	  /* template */
	  __webpack_require__(2212),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1876)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(983),
	  /* template */
	  __webpack_require__(2733),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1391)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(984),
	  /* template */
	  __webpack_require__(2238),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1672)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(985),
	  /* template */
	  __webpack_require__(2524),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1553)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(986),
	  /* template */
	  __webpack_require__(2402),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1774)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(993),
	  /* template */
	  __webpack_require__(2629),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1716)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(996),
	  /* template */
	  __webpack_require__(2570),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1718)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(998),
	  /* template */
	  __webpack_require__(2572),
	  /* scopeId */
	  "data-v-7104d2ae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1393)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1008),
	  /* template */
	  __webpack_require__(2240),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1828)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1010),
	  /* template */
	  __webpack_require__(2685),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1595)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1012),
	  /* template */
	  __webpack_require__(2445),
	  /* scopeId */
	  "data-v-46ff27db",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1765)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1014),
	  /* template */
	  __webpack_require__(2620),
	  /* scopeId */
	  "data-v-8a004096",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1411)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1018),
	  /* template */
	  __webpack_require__(2258),
	  /* scopeId */
	  "data-v-10b8d35f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1620)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1020),
	  /* template */
	  __webpack_require__(2471),
	  /* scopeId */
	  "data-v-4f20ae56",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1675)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1025),
	  /* template */
	  __webpack_require__(2527),
	  /* scopeId */
	  "data-v-6296b4b0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1370)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1036),
	  /* template */
	  __webpack_require__(2217),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1638)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1038),
	  /* template */
	  __webpack_require__(2489),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1533)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1039),
	  /* template */
	  __webpack_require__(2381),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1841)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1040),
	  /* template */
	  __webpack_require__(2698),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1694)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1041),
	  /* template */
	  __webpack_require__(2548),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1881)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1042),
	  /* template */
	  __webpack_require__(2738),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1481)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1044),
	  /* template */
	  __webpack_require__(2329),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1584)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1045),
	  /* template */
	  __webpack_require__(2434),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1046),
	  /* template */
	  __webpack_require__(2537),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1847)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1047),
	  /* template */
	  __webpack_require__(2704),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1707)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1050),
	  /* template */
	  __webpack_require__(2561),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1402)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1051),
	  /* template */
	  __webpack_require__(2249),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1627)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1052),
	  /* template */
	  __webpack_require__(2478),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1383)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1053),
	  /* template */
	  __webpack_require__(2230),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1448)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1054),
	  /* template */
	  __webpack_require__(2295),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1778)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1055),
	  /* template */
	  __webpack_require__(2633),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1473)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1056),
	  /* template */
	  __webpack_require__(2321),
	  /* scopeId */
	  "data-v-2198182f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1431)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1057),
	  /* template */
	  __webpack_require__(2278),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1363)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1058),
	  /* template */
	  __webpack_require__(2209),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1618)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1059),
	  /* template */
	  __webpack_require__(2469),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1360)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1060),
	  /* template */
	  __webpack_require__(2206),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1780)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1062),
	  /* template */
	  __webpack_require__(2635),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1576)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1063),
	  /* template */
	  __webpack_require__(2426),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1857)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1064),
	  /* template */
	  __webpack_require__(2714),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1502)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1070),
	  /* template */
	  __webpack_require__(2350),
	  /* scopeId */
	  "data-v-2b985b65",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1594)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1071),
	  /* template */
	  __webpack_require__(2444),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1550)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1072),
	  /* template */
	  __webpack_require__(2398),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1569)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1075),
	  /* template */
	  __webpack_require__(2418),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1846)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1077),
	  /* template */
	  __webpack_require__(2703),
	  /* scopeId */
	  "data-v-dab1061e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1704)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1078),
	  /* template */
	  __webpack_require__(2558),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1390)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1079),
	  /* template */
	  __webpack_require__(2237),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1379)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1082),
	  /* template */
	  __webpack_require__(2226),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1751)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1083),
	  /* template */
	  __webpack_require__(2606),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1397)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1084),
	  /* template */
	  __webpack_require__(2244),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1839)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1085),
	  /* template */
	  __webpack_require__(2696),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1729)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1086),
	  /* template */
	  __webpack_require__(2583),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1483)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1087),
	  /* template */
	  __webpack_require__(2331),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1461)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1088),
	  /* template */
	  __webpack_require__(2308),
	  /* scopeId */
	  "data-v-1e9ec67e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1877)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1092),
	  /* template */
	  __webpack_require__(2734),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1410)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1094),
	  /* template */
	  __webpack_require__(2257),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1531)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1095),
	  /* template */
	  __webpack_require__(2379),
	  /* scopeId */
	  "data-v-32acdaa1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1585)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1096),
	  /* template */
	  __webpack_require__(2435),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1757)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1097),
	  /* template */
	  __webpack_require__(2612),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1436)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1098),
	  /* template */
	  __webpack_require__(2283),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1732)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1099),
	  /* template */
	  __webpack_require__(2586),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1470)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1100),
	  /* template */
	  __webpack_require__(2318),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1475)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1102),
	  /* template */
	  __webpack_require__(2323),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1749)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1103),
	  /* template */
	  __webpack_require__(2604),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1643)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1104),
	  /* template */
	  __webpack_require__(2494),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1509)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1105),
	  /* template */
	  __webpack_require__(2357),
	  /* scopeId */
	  "data-v-2cc59e62",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1419)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1106),
	  /* template */
	  __webpack_require__(2266),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1536)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1107),
	  /* template */
	  __webpack_require__(2384),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1560)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1109),
	  /* template */
	  __webpack_require__(2409),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1440)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1110),
	  /* template */
	  __webpack_require__(2287),
	  /* scopeId */
	  "data-v-1a45febd",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1826)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1111),
	  /* template */
	  __webpack_require__(2683),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1499)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1112),
	  /* template */
	  __webpack_require__(2347),
	  /* scopeId */
	  "data-v-2b6147da",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1364)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1113),
	  /* template */
	  __webpack_require__(2210),
	  /* scopeId */
	  "data-v-024b5523",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1781)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1114),
	  /* template */
	  __webpack_require__(2636),
	  /* scopeId */
	  "data-v-a39ec288",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1628)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1115),
	  /* template */
	  __webpack_require__(2479),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1756)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1116),
	  /* template */
	  __webpack_require__(2611),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1467)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1117),
	  /* template */
	  __webpack_require__(2315),
	  /* scopeId */
	  "data-v-1ff60323",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1401)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1118),
	  /* template */
	  __webpack_require__(2248),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1120),
	  /* template */
	  __webpack_require__(2658),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1121),
	  /* template */
	  __webpack_require__(2311),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1368)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1122),
	  /* template */
	  __webpack_require__(2214),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1538)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1124),
	  /* template */
	  __webpack_require__(2386),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1667)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1125),
	  /* template */
	  __webpack_require__(2519),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1384)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1126),
	  /* template */
	  __webpack_require__(2231),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1487)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1127),
	  /* template */
	  __webpack_require__(2335),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1555)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1128),
	  /* template */
	  __webpack_require__(2404),
	  /* scopeId */
	  "data-v-3a35778d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1684)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1129),
	  /* template */
	  __webpack_require__(2536),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1852)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1130),
	  /* template */
	  __webpack_require__(2709),
	  /* scopeId */
	  "data-v-dcd6db14",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1679)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1131),
	  /* template */
	  __webpack_require__(2531),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1836)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1133),
	  /* template */
	  __webpack_require__(2693),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1743)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1135),
	  /* template */
	  __webpack_require__(2597),
	  /* scopeId */
	  "data-v-7723094c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1658)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1136),
	  /* template */
	  __webpack_require__(2510),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1447)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1138),
	  /* template */
	  __webpack_require__(2294),
	  /* scopeId */
	  "data-v-1b125308",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1443)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1139),
	  /* template */
	  __webpack_require__(2290),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1863)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1141),
	  /* template */
	  __webpack_require__(2720),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1753)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1142),
	  /* template */
	  __webpack_require__(2608),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1519)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1143),
	  /* template */
	  __webpack_require__(2367),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1854)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1144),
	  /* template */
	  __webpack_require__(2711),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1651)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1146),
	  /* template */
	  __webpack_require__(2502),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1695)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1148),
	  /* template */
	  __webpack_require__(2549),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1603)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1150),
	  /* template */
	  __webpack_require__(2454),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1486)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1151),
	  /* template */
	  __webpack_require__(2334),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1711)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1152),
	  /* template */
	  __webpack_require__(2565),
	  /* scopeId */
	  "data-v-6f59d3ca",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1768)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1154),
	  /* template */
	  __webpack_require__(2623),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1723)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1155),
	  /* template */
	  __webpack_require__(2577),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1466)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1157),
	  /* template */
	  __webpack_require__(2314),
	  /* scopeId */
	  "data-v-1faaadce",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1759)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1158),
	  /* template */
	  __webpack_require__(2614),
	  /* scopeId */
	  "data-v-863dcf12",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1388)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1159),
	  /* template */
	  __webpack_require__(2235),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1597)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1161),
	  /* template */
	  __webpack_require__(2448),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1382)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1164),
	  /* template */
	  __webpack_require__(2229),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1880)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1165),
	  /* template */
	  __webpack_require__(2737),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1708)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1170),
	  /* template */
	  __webpack_require__(2562),
	  /* scopeId */
	  "data-v-6e5e6f83",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1632)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1171),
	  /* template */
	  __webpack_require__(2483),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1583)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1172),
	  /* template */
	  __webpack_require__(2433),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1173),
	  /* template */
	  __webpack_require__(2420),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1804)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(1175),
	  /* template */
	  __webpack_require__(2660),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 2202 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.vehicle) ? _c('div', {
	    staticClass: "component-tabbed-vehicle-map-position"
	  }, [_c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Vehicle Position " + _vm._s(_vm.vehicle.vehicle_slot_address) + "  " + _vm._s(_vm.vehicle.has_reservation ? ' - ' + _vm.vehicle.has_reservation : ''))])])]), _c('div', {
	    staticClass: "wrap"
	  }, [_c('GoogleMapContainer', [_c('GoogleMap', {
	    attrs: {
	      "center": {
	        lat: _vm.vehicle.position.latitude,
	        lng: _vm.vehicle.position.longitude
	      },
	      "api-key": _vm.mapsAPI,
	      "searchBar": true,
	      "zoom": 17,
	      "zoomControl": true,
	      "mapTypeControl": true
	    }
	  }, [(_vm.zones.allowed) ? _c('div', _vm._l((_vm.zones.allowed.poly), function(allowed) {
	    return _c('google-map-polygon', {
	      attrs: {
	        "positions": allowed,
	        "color": "green",
	        "fillColor": "green"
	      }
	    })
	  }), 1) : _vm._e(), (_vm.zones.forbidden) ? _c('div', _vm._l((_vm.zones.forbidden.poly), function(forbidden) {
	    return (_vm.zones.forbidden !== null) ? _c('google-map-polygon', {
	      attrs: {
	        "positions": forbidden
	      }
	    }) : _vm._e()
	  }), 1) : _vm._e(), (_vm.zones.undesiderable) ? _c('div', [_vm._l((_vm.zones.undesiderable.poly), function(undesiderable) {
	    return (_vm.zones.undesiderable) ? _c('google-map-polygon', {
	      attrs: {
	        "positions": undesiderable,
	        "color": "yellow",
	        "fillColor": "yellow"
	      }
	    }) : _vm._e()
	  }), _c('GoogleMapPolygon')], 2) : _vm._e(), _c('GoogleMapMarker', {
	    attrs: {
	      "position": {
	        lat: _vm.vehicle.position.latitude,
	        lng: _vm.vehicle.position.longitude
	      },
	      "title": _vm.vehicle.model,
	      "label": _vm.vehicle.model,
	      "icon": _vm.vehicleInRange(_vm.vehicle)
	    }
	  }), _c('GoogleMapCircle', {
	    attrs: {
	      "position": {
	        lat: _vm.vehicle.parking_lot.position.latitude,
	        lng: _vm.vehicle.parking_lot.position.longitude
	      }
	    }
	  })], 1)], 1)], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-client-type"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 2
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('ClientTypeButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("CT" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Name")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.code))])])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2204 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "thumb-container"
	  }, [_c('div', {
	    staticClass: "thumb",
	    style: (_vm.thumbStyle)
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-packet-vehicle-category"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card-n', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('packet-vehicle-category-button', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("PVC" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Packet")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("id: " + _vm._s(_vm.item.packet.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("name: " + _vm._s(_vm.item.packet.name))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Category")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("id: " + _vm._s(_vm.item.category.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("name: " + _vm._s(_vm.item.category.name))])])], 1)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2206 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-coupon-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "has-tip",
	    class: _vm.position,
	    attrs: {
	      "data-tooltip": "",
	      "aria-haspopup": "true",
	      "data-disable-hover": "false",
	      "tabindex": _vm._uid,
	      "title": _vm.tip,
	      "data-click-open": _vm.open
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-reservations"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  }, [_c('header-columns', {
	    attrs: {
	      "slot": "before",
	      "columns": _vm.headers
	    },
	    slot: "before"
	  })], 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('h2', [_vm._v("Cards")])])
	}]}

/***/ }),
/* 2209 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-console row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column large-3 p-0"
	  }, [(!_vm.availableCommands) ? _c('LoadingSpinner') : [_c('ul', {
	    directives: [{
	      name: "f-accordion",
	      rawName: "v-f-accordion"
	    }],
	    staticClass: "accordion",
	    attrs: {
	      "data-accordion": "",
	      "data-allow-all-closed": "true"
	    }
	  }, _vm._l((_vm.availableCommands), function(commands, group) {
	    return _c('li', {
	      staticClass: "accordion-item",
	      attrs: {
	        "data-accordion-item": ""
	      }
	    }, [_c('a', {
	      staticClass: "accordion-title",
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v(_vm._s(group.toUpperCase()))]), _c('div', {
	      staticClass: "accordion-content",
	      attrs: {
	        "data-tab-content": ""
	      }
	    }, _vm._l((commands), function(command, key) {
	      return _c('div', {
	        staticClass: "button expand",
	        on: {
	          "click": function($event) {
	            return _vm.handleButtonPress(command)
	          }
	        }
	      }, [_vm._v(_vm._s(key.replace("kepler:", "")))])
	    }), 0)])
	  }), 0)]], 2), _c('div', {
	    staticClass: "column large-9 small-12"
	  }, [_c('pre', {
	    ref: "console",
	    staticClass: "console"
	  }, _vm._l((_vm.consoleLog), function(log) {
	    return _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(log)
	      }
	    })
	  }), 0), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentCommand),
	      expression: "currentCommand"
	    }],
	    ref: "input",
	    staticClass: "input",
	    attrs: {
	      "type": "text",
	      "disabled": _vm.isRunning
	    },
	    domProps: {
	      "value": (_vm.currentCommand)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.handleCommand($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentCommand = $event.target.value
	      }
	    }
	  }), (_vm.hasPound) ? _c('h3', [_vm._v("REMEMBER TO REPLACE THE # WITH THE ENTITY NUMBER!")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 2210 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-packet-vehicle-category-list"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-offset-11 text-right"
	  }, [_c('PacketVehicleCategoryModal', {
	    on: {
	      "itemUpdated": _vm.itemUpdated
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-note"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 6
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('VehicleAttributeButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("VA" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.description))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("VT" + _vm._s(_vm.item.vehicle_type.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.vehicle_type.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v("Type:")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.item.type))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v("Private: " + _vm._s(_vm.item.private))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v("Recommended: " + _vm._s(_vm.item.recommended))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [(_vm.item.icon) ? [_c('MdiIcon', {
	    attrs: {
	      "name": _vm.item.icon
	    }
	  })] : _vm._e()], 2), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'attribute',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])], 1)]) : _vm._e(), (_vm.$is('entityList')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('VehicleAttributeButtons', {
	    attrs: {
	      "item": _vm.item,
	      "vehicle": true
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("IN" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.instruction.title))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.instruction.subtitle))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("N° of steps")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.instruction.steps.length))]), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'instruction',
	        params: {
	          id: _vm.item.instruction.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2212 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('transaction-id')) ? _c('div', {
	    staticClass: "field-transaction-id-and-date"
	  }, [_c('div', {
	    staticClass: "transaction-id"
	  }, [_vm._v("TR" + _vm._s(_vm.item.id))])]) : (_vm.$is('transaction-date')) ? _c('div', {
	    staticClass: "field-transaction-id-and-date"
	  }, [_c('div', {
	    staticClass: "trasaction-date"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('transaction-client')) ? _c('div', {
	    staticClass: "field-transaction-client"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.client_id
	        }
	      }
	    }
	  }, [(_vm.item.client_organization_name) ? _c('span', [_vm._v(_vm._s(_vm.item.client_organization_name))]) : _c('span', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])])], 1) : (_vm.$is('transaction-payment-method')) ? _c('div', {
	    staticClass: "field-transaction-payment-method"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("PM" + _vm._s(_vm.item.payment_method_id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.payment_name))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.payment_method_provider))])]) : (_vm.$is('transaction-created')) ? _c('div', {
	    staticClass: "field-transaction-created"
	  }, [_c('div', {
	    staticClass: "trasaction-date"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('transaction-amount')) ? _c('div', {
	    staticClass: "field-transaction-amount"
	  }, [_c('div', {
	    staticClass: "field",
	    style: (_vm.item.amount < 0 ? 'color:#cc4b37' : '')
	  }, [_vm._v(_vm._s(_vm.item.amount.toFixed(2)) + _vm._s(_vm.currency))])]) : (_vm.$is('transaction-status')) ? _c('div', {
	    staticClass: "field-transaction-status"
	  }, [_c('p', {
	    staticClass: "label",
	    class: {
	      alert: _vm.item.status !== 'SUCCESS'
	    }
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('p', [_vm._v(_vm._s(_vm.item.response.message))])]) : (_vm.$is('transaction-date')) ? _c('div', {
	    staticClass: "field-transaction-date"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('invoice-link')) ? _c('div', {
	    staticClass: "field-invoice-link"
	  }, [(_vm.item.invoice.id) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'invoice',
	        params: {
	          id: _vm.item.invoice.id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.invoice.type) + _vm._s(_vm.item.invoice_internal_id) + " (" + _vm._s(_vm.item.invoice_id) + ")")])]) : _c('p', [_vm._v("not invoiced yet")])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2213 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 2214 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-notification-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2215 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "easy-week-component"
	  }, [_c('div', {
	    staticClass: "grid-container",
	    style: (_vm.gridCss)
	  }, [_c('div', {
	    staticClass: "grid-row-header grid-column-header plate"
	  }, [_c('span', [_vm._v(_vm._s(_vm.plate))])]), _vm._l((_vm.shifts), function(shift) {
	    return _c('div', {
	      staticClass: "grid-column-header shift-header",
	      style: ({
	        'grid-row': shift.name + shift.id
	      })
	    }, [_c('b', [_vm._v(_vm._s(shift.name))]), _c('span', [_vm._v(_vm._s(shift.start))]), _c('span', [_vm._v(_vm._s(shift.end))])])
	  }), _vm._l((_vm.doDays), function(dayShift, idx) {
	    return [_c('div', {
	      staticClass: "grid-row-header"
	    }, [_c('span', [_vm._v(_vm._s(dayShift.name) + " " + _vm._s(dayShift.date))])]), _vm._l((dayShift.shifts), function(shift) {
	      return _c('div', {
	        staticClass: "bracket",
	        style: ({
	          'grid-row': shift.name + shift.id,
	          'grid-column': idx + 2,
	          'background-color': _vm.getBackgroundColor(shift)
	        })
	      }, [(shift.reservations.length) ? _c('div', {
	        staticClass: "bracket-reservations"
	      }, _vm._l((shift.reservations), function(res) {
	        return _c('div', {
	          key: res.reservation_id,
	          staticClass: "bracket-reservation",
	          class: res.status.toLowerCase(),
	          style: ({
	            'background-color': dayShift.color || _vm.getColor(res, shift) || '#fafafa'
	          })
	        }, [_c('p', {
	          on: {
	            "click": function($event) {
	              return _vm.getDetails(res)
	            }
	          }
	        }, [(_vm.daysToShow <= 21) ? [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'driver',
	              params: {
	                id: res.driver_id
	              }
	            }
	          }
	        }, [_c('b', [_vm._v("DR" + _vm._s(res.driver_id))])]), _c('br'), _c('router-link', {
	          attrs: {
	            "to": {
	              name: 'reservation',
	              params: {
	                id: res.reservation_id
	              }
	            }
	          }
	        }, [_c('span', {
	          staticClass: "reservation-id"
	        }, [_vm._v("R" + _vm._s(res.reservation_id))])])] : _vm._e()], 2)])
	      }), 0) : _vm._e()])
	    })]
	  })], 2), (_vm.details || _vm.loadingDetails) ? _c('div', {
	    staticClass: "details-container"
	  }, [_c('button', {
	    staticClass: "close-button",
	    attrs: {
	      "aria-label": "Close alert",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.clearDetails
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), (_vm.loadingDetails) ? _c('LoadingSpinner') : (_vm.details) ? _c('div', {
	    staticClass: "row"
	  }, [(_vm.details.reservation) ? _c('div', {
	    staticClass: "columns small-12"
	  }, [_c('h4', [_vm._v("reservation details")]), _c('Reservation', {
	    attrs: {
	      "type": "listing",
	      "item": _vm.details.reservation
	    }
	  })], 1) : _vm._e()]) : _vm._e()], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2216 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm.componentId,
	    ref: _vm.componentId
	  }, [(_vm.reservation !== null) ? _c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Charge session")]) : _c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Port"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.port_id),
	      expression: "port_id"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.port_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.port_id = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Reservation ID"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.reservation_id),
	      expression: "reservation_id"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": _vm.reservation
	    },
	    domProps: {
	      "value": (_vm.reservation_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.reservation_id = $event.target.value
	      }
	    }
	  })])])]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2217 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": this._uid
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 2218 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-switch"
	  }, [_c('div', {
	    staticClass: "switch",
	    on: {
	      "click": _vm.toggleSwitch
	    }
	  }, [_c('input', {
	    staticClass: "switch-input",
	    attrs: {
	      "id": _vm.idEl,
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.active,
	      "value": _vm.active
	    }
	  }), _c('label', {
	    staticClass: "switch-paddle",
	    attrs: {
	      "for": _vm.idEl
	    }
	  }, [_c('span', {
	    class: {
	      'switch-active': _vm.value, 'switch-inactive': !_vm.value
	    },
	    domProps: {
	      "innerHTML": _vm._s(Boolean(_vm.active) ? 'Yes' : 'No')
	    }
	  })])]), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 2219 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-fleet-position"
	  }, _vm._l((_vm.value), function(elem, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('DeleteConf', {
	      on: {
	        "click": function($event) {
	          return _vm.value.splice(index, 1)
	        }
	      }
	    }), _vm._l((elem), function(val, inx, key) {
	      return _c('div', {
	        staticClass: "column"
	      }, [(inx === 'vehicle_category_id') ? _c('SelectizeCategory', {
	        on: {
	          "optionSelected": function($event) {
	            return _vm.updateCategory($event, key)
	          }
	        },
	        model: {
	          value: (_vm.value[index][inx]),
	          callback: function($$v) {
	            _vm.$set(_vm.value[index], inx, $$v)
	          },
	          expression: "value[index][inx]"
	        }
	      }) : _vm._e(), (inx === 'booking_mode') ? _c('BookingModeSelect', {
	        model: {
	          value: (_vm.value[index][inx]),
	          callback: function($$v) {
	            _vm.$set(_vm.value[index], inx, $$v)
	          },
	          expression: "value[index][inx]"
	        }
	      }) : _vm._e()], 1)
	    })], 2)
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2220 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-card"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "cards tabs-inner-content"
	  }, [_c('div', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "is-hidden",
	    attrs: {
	      "id": "create-card",
	      "data-toggler": "is-hidden"
	    }
	  }, [_c('h3', [_vm._v("select an unassigned card")]), _c('selectize-card', {
	    attrs: {
	      "nullDriver": true
	    },
	    on: {
	      "optionSelected": _vm.selectUnassignedCard
	    }
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-center"
	  }, [(_vm.selectedUnassignedCard !== null) ? _c('button', {
	    staticClass: "button",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.assignCard
	    }
	  }, [_vm._v("assign to driver")]) : _vm._e()])]), _c('h3', [_vm._v("create a new card")]), _c('create-card', {
	    attrs: {
	      "driver_id": _vm.$route.params.id
	    },
	    on: {
	      "addCard": _vm.addCard
	    }
	  })], 1), _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Driver cards")])]), _c('div', {
	    staticClass: "action"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    attrs: {
	      "data-toggle": "create-card"
	    }
	  })])])
	}]}

/***/ }),
/* 2221 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-note"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 5
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('VehicleNoteButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("N" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.description))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.annotable))]), (_vm.item.valid_from) ? _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v("From")]) : _vm._e(), (_vm.item.valid_from) ? _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.valid_from, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e(), (_vm.item.valid_to) ? _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v("To")]) : _vm._e(), (_vm.item.valid_to) ? _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.valid_to, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e(), (_vm.item.annotable_type) ? _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.noteUrl
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1) : _vm._e()])], 1)]) : _vm._e(), (_vm.$is('entityList')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('VehicleNoteButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("N" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.description))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.valid_from))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.valid_to))])])], 1)]) : _vm._e(), (_vm.$is('table')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Description")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(" " + _vm._s(_vm.item.description))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('label', [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.created_at))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('VehicleNoteButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)])])]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2222 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.remove
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2223 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selection-list"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, _vm._l((_vm.items), function(i, index) {
	    return _c('div', {
	      staticClass: "wrapper",
	      on: {
	        "click": function($event) {
	          return _vm.selectItem(index)
	        }
	      }
	    }, [_c(_vm.component, {
	      tag: "component",
	      attrs: {
	        "item": i,
	        "type": 'list'
	      }
	    })], 1)
	  }), 0), _c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c(_vm.component, {
	    tag: "component",
	    attrs: {
	      "item": _vm.selectedItem,
	      "type": 'expanded'
	    },
	    on: {
	      "updated": _vm.updated
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2224 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "easy-week-wrapper card"
	  }, _vm._l((_vm.vehicles), function(data, plate) {
	    return _c('EasyWeeks', {
	      key: plate,
	      attrs: {
	        "shifts": data.shifts,
	        "reservations": data.reservations,
	        "plate": plate,
	        "daysToShow": _vm.daysToShow
	      }
	    })
	  }), 1)
	},staticRenderFns: []}

/***/ }),
/* 2225 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component component-backoffice-system-configuration"
	  }, _vm._l((_vm.value), function(elem, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('DeleteConf', {
	      on: {
	        "click": function($event) {
	          return _vm.value.splice(index, 1)
	        }
	      }
	    }), _vm._l((elem), function(val, inx) {
	      return _c('div', {
	        staticClass: "column"
	      }, [(inx !== 'config' && inx !== 'default') ? _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index][inx]),
	          expression: "value[index][inx]"
	        }],
	        attrs: {
	          "type": "text",
	          "placeholder": inx
	        },
	        domProps: {
	          "value": (_vm.value[index][inx])
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.value[index], inx, $event.target.value)
	          }
	        }
	      }) : (inx !== 'default') ? _c('ValidationConfig', {
	        attrs: {
	          "validation-key": "config"
	        },
	        model: {
	          value: (_vm.value[index]),
	          callback: function($$v) {
	            _vm.$set(_vm.value, index, $$v)
	          },
	          expression: "value[index]"
	        }
	      }) : _vm._e()], 1)
	    })], 2)
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2226 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2227 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-pagination"
	  }, [_c('ul', {
	    staticClass: "pagination",
	    attrs: {
	      "role": "navigation",
	      "aria-label": "Pagination"
	    }
	  }, [_c('li', {
	    staticClass: "pagination-previous",
	    class: {
	      disabled: _vm.currentPage === 1
	    }
	  }, [(_vm.currentPage !== 1) ? _c('a', {
	    attrs: {
	      "aria-label": "Previous page"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.updatePage(_vm.currentPage - 1)
	      }
	    }
	  }, [_vm._v("Previous"), _c('span', {
	    staticClass: "show-for-sr"
	  }, [_vm._v("page")])]) : _vm._e()]), _vm._l((_vm.pages), function(page, index) {
	    return _c('li', {
	      class: {
	        current: page === _vm.currentPage, ellipsis: page === false
	      }
	    }, [(page !== false) ? _c('a', {
	      attrs: {
	        "aria-label": "'page '+page"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.updatePage(page)
	        }
	      }
	    }, [_vm._v(_vm._s(page))]) : _vm._e()])
	  }), _c('li', {
	    staticClass: "pagination-next",
	    class: {
	      disabled: _vm.currentPage === _vm.pageCount || !_vm.pageCount
	    }
	  }, [(_vm.currentPage !== _vm.pageCount && _vm.pageCount) ? _c('a', {
	    attrs: {
	      "aria-label": "Next page"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.updatePage(_vm.currentPage + 1)
	      }
	    }
	  }, [_vm._v("Next"), _c('span', {
	    staticClass: "show-for-sr"
	  }, [_vm._v("page")])]) : _vm._e()])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2228 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.shouldShow) ? _c('div', {
	    staticClass: "component-smart-edit-field"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v(" " + _vm._s(_vm.title))])]), (typeof _vm.value == 'object' && _vm.value !== null && _vm.type !== 'map' && _vm.type !== 'select') ? _c('div', {
	    staticClass: "object"
	  }, _vm._l((_vm.mutableField), function(item, index) {
	    return _c('div', {
	      staticClass: "field"
	    }, [_c('smart-edit-field', {
	      attrs: {
	        "name": _vm.name + '.' + index,
	        "options": _vm.options
	      },
	      model: {
	        value: (_vm.mutableField[index]),
	        callback: function($$v) {
	          _vm.$set(_vm.mutableField, index, $$v)
	        },
	        expression: "mutableField[index]"
	      }
	    })], 1)
	  }), 0) : _c('div', {
	    staticClass: "line"
	  }, [(_vm.type === 'date') ? _c('date-picker', {
	    attrs: {
	      "disabled": _vm.shouldDisable,
	      "initialDate": _vm.mutableField,
	      "format": 'yyyy-mm-dd'
	    },
	    model: {
	      value: (_vm.mutableField),
	      callback: function($$v) {
	        _vm.mutableField = $$v
	      },
	      expression: "mutableField"
	    }
	  }) : (_vm.type === 'datetime') ? _c('date-picker', {
	    attrs: {
	      "disabled": _vm.shouldDisable,
	      "initialDate": _vm.mutableField,
	      "pickTime": true,
	      "format": 'yyyy-mm-dd hh:ii'
	    },
	    model: {
	      value: (_vm.mutableField),
	      callback: function($$v) {
	        _vm.mutableField = $$v
	      },
	      expression: "mutableField"
	    }
	  }) : (_vm.type === 'datetimes') ? _c('date-picker', {
	    attrs: {
	      "disabled": _vm.shouldDisable,
	      "initialDate": _vm.mutableField,
	      "pickTime": true,
	      "format": 'yyyy-mm-dd hh:ii:ss'
	    },
	    model: {
	      value: (_vm.mutableField),
	      callback: function($$v) {
	        _vm.mutableField = $$v
	      },
	      expression: "mutableField"
	    }
	  }) : (_vm.type instanceof Array) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mutableField),
	      expression: "mutableField"
	    }],
	    attrs: {
	      "disabled": _vm.shouldDisable
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mutableField = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.type), function(option) {
	    return _c('option', {
	      domProps: {
	        "value": option
	      }
	    }, [_vm._v(_vm._s(option))])
	  }), 0) : (_vm.type === 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mutableField),
	      expression: "mutableField"
	    }],
	    attrs: {
	      "type": "password",
	      "disabled": _vm.shouldDisable
	    },
	    domProps: {
	      "value": (_vm.mutableField)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mutableField = $event.target.value
	      }
	    }
	  }) : (_vm.type === 'checkbox') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mutableField),
	      expression: "mutableField"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.shouldDisable
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.mutableField) ? _vm._i(_vm.mutableField, null) > -1 : (_vm.mutableField)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.mutableField,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.mutableField = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.mutableField = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.mutableField = $$c
	        }
	      }
	    }
	  }) : (_vm.type === 'select') ? _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mutableField),
	      expression: "mutableField"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mutableField = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.options.select), function(value, id) {
	    return _c('option', {
	      domProps: {
	        "value": id
	      }
	    }, [_vm._v(_vm._s(id) + " " + _vm._s(value))])
	  }), 0)]) : (_vm.type === 'file') ? _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mutableField),
	      expression: "mutableField"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": (_vm.mutableField)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mutableField = $event.target.value
	      }
	    }
	  }), _c('kepler-file-upload', {
	    attrs: {
	      "selectedVisibility": _vm.options.file.selectedVisibility,
	      "selectedPrefix": _vm.options.file.selectedPrefix
	    },
	    on: {
	      "sel": _vm.handleFileSelector
	    }
	  })], 1) : (_vm.type === 'map') ? _c('div', {
	    attrs: {
	      "id": "map"
	    }
	  }, [_c('GoogleMapContainer', [_c('google-map', {
	    ref: "map",
	    staticStyle: {
	      "height": "10px"
	    },
	    attrs: {
	      "api-key": _vm.mapsAPI,
	      "searchBar": true,
	      "mapTypeId": 'roadmap',
	      "mapTypeControl": true,
	      "center": _vm.mutableField,
	      "zoom": 20,
	      "listenForClick": true
	    },
	    on: {
	      "mapClicked": _vm.mapClicked
	    }
	  }, [_c('google-map-marker', {
	    ref: "marker",
	    attrs: {
	      "position": _vm.mutableField,
	      "label": "",
	      "title": ""
	    }
	  })], 1)], 1)], 1) : (_vm.options.hasOwnProperty('translatable') && Object.keys(_vm.options.translatable).includes(_vm.name)) ? [(_vm.type === 'editor') ? [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.options.translatable[_vm.name],
	      "value": _vm.mutableField,
	      "editor": true
	    }
	  }), _c('Editor', {
	    attrs: {
	      "value": _vm.mutableField
	    },
	    model: {
	      value: (_vm.mutableField),
	      callback: function($$v) {
	        _vm.mutableField = $$v
	      },
	      expression: "mutableField"
	    }
	  })] : [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.options.translatable[_vm.name],
	      "label": _vm.title,
	      "value": _vm.mutableField
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mutableField),
	      expression: "mutableField"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.mutableField)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mutableField = $event.target.value
	      }
	    }
	  })])]] : (_vm.type === 'editor') ? _c('Editor', {
	    attrs: {
	      "value": _vm.mutableField
	    },
	    model: {
	      value: (_vm.mutableField),
	      callback: function($$v) {
	        _vm.mutableField = $$v
	      },
	      expression: "mutableField"
	    }
	  }) : _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mutableField),
	      expression: "mutableField"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": _vm.shouldDisable
	    },
	    domProps: {
	      "value": (_vm.mutableField)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mutableField = $event.target.value
	      }
	    }
	  })], 2)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2229 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "find-a-replace-vehicle"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('cards', {
	    attrs: {
	      "data": _vm.selectedDates
	    }
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Start"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "format": 'yyyy-mm-dd hh:ii',
	      "initialDate": _vm.$dateFormat(_vm.initialStart, 'YYYY-MM-DD HH:mm')
	    },
	    model: {
	      value: (_vm.bookRequest.start),
	      callback: function($$v) {
	        _vm.$set(_vm.bookRequest, "start", $$v)
	      },
	      expression: "bookRequest.start"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("End"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "format": 'yyyy-mm-dd hh:ii',
	      "initialDate": _vm.$dateFormat(_vm.initialEnd, 'YYYY-MM-DD HH:mm')
	    },
	    model: {
	      value: (_vm.bookRequest.end),
	      callback: function($$v) {
	        _vm.$set(_vm.bookRequest, "end", $$v)
	      },
	      expression: "bookRequest.end"
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "text-right"
	  }, [_c('button', {
	    staticClass: "button small",
	    on: {
	      "click": _vm.search
	    }
	  }, [_vm._v("Search")])])])]), _c('div', {
	    staticClass: "row columns"
	  }, [(_vm.loading) ? _c('loading-spinner') : _vm._e(), _vm._l((_vm.slotsByLots), function(slots, key) {
	    return _c('div', {
	      staticClass: "grouped card",
	      style: (_vm.gridStyle(slots))
	    }, [_c('h1', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(key))]), _vm._l((slots), function(vehicle) {
	      return _c('vehicle', {
	        attrs: {
	          "item": vehicle,
	          "type": "search-result"
	        }
	      }, [_c('div', {
	        staticClass: "text-center"
	      }, [_c('button', {
	        staticClass: "button small",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.cancelAndBook(vehicle)
	          }
	        }
	      }, [_vm._v("Cancel & Book")]), _c('span', [_vm._v(" ")]), _c('button', {
	        staticClass: "button small",
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.voidAndBook(vehicle)
	          }
	        }
	      }, [_vm._v("Void & Book")]), _c('button', {
	        staticClass: "button small",
	        on: {
	          "click": function($event) {
	            return _vm.replaceVehicleSlot(vehicle)
	          }
	        }
	      }, [_vm._v("Force replace vehicle slot")])])])
	    })], 2)
	  })], 2)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2230 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12 large-2"
	  }, [_c('selectize-vehicle', {
	    on: {
	      "optionSelected": _vm.setVehicle,
	      "optionRemoved": _vm.unsetVehicle
	    }
	  })], 1), (_vm.showCloneForm) ? _c('div', {
	    staticClass: "column small-12 large-10"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataCsv),
	      expression: "dataCsv"
	    }],
	    attrs: {
	      "rows": "10",
	      "placeholder": "Paste your csv"
	    },
	    domProps: {
	      "value": (_vm.dataCsv)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.dataCsv = $event.target.value
	      }
	    }
	  })]) : _vm._e()]), (_vm.firstRows && _vm.showCloneForm) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-4 large2"
	  }, [_c('label', [_vm._v("CSV separator")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sep),
	      expression: "sep"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.sep = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": undefined
	    }
	  }, [_vm._v("select your csv delimiter")]), _c('option', {
	    attrs: {
	      "value": "\t"
	    }
	  }, [_vm._v("tab(\\t)")]), _c('option', {
	    attrs: {
	      "value": ";"
	    }
	  }, [_vm._v(";")]), _c('option', {
	    attrs: {
	      "value": ","
	    }
	  }, [_vm._v(",")])])]), _c('div', {
	    staticClass: "column small-4 large2"
	  }, [_c('label', [_vm._v("Remove first row header")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.deletedCsvField),
	      expression: "deletedCsvField"
	    }],
	    ref: "checkbox",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.deletedCsvField) ? _vm._i(_vm.deletedCsvField, null) > -1 : (_vm.deletedCsvField)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.deletedCsvField,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.deletedCsvField = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.deletedCsvField = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.deletedCsvField = $$c
	        }
	      }
	    }
	  })])]) : _vm._e(), (_vm.firstRows && _vm.showCloneForm) ? _c('div', {
	    staticStyle: {
	      "border": "1px solid blue",
	      "padding": "5px"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.firstRows[0]), function(row, index) {
	    return _c('div', {
	      staticClass: "column"
	    }, [_c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.headerColumn[index]),
	        expression: "headerColumn[index]"
	      }],
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(_vm.headerColumn, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "selected": "selected"
	      },
	      domProps: {
	        "value": undefined
	      }
	    }, [_vm._v("select correct header")]), _c('option', {
	      attrs: {
	        "value": "vin"
	      }
	    }, [_vm._v("vin")]), _c('option', {
	      attrs: {
	        "value": "plate"
	      }
	    }, [_vm._v("plate")]), _c('option', {
	      attrs: {
	        "value": "hw_serial"
	      }
	    }, [_vm._v("serial")])])])
	  }), 0), _vm._l((_vm.firstRows), function(row, index) {
	    return _c('div', {
	      staticClass: "row",
	      staticStyle: {
	        "margin-bottom": "5px"
	      }
	    }, _vm._l((row), function(i) {
	      return _c('div', {
	        staticClass: "column"
	      }, [_c('span', [_vm._v(_vm._s(i))])])
	    }), 0)
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "button",
	    attrs: {
	      "disabled": _vm.clonedisabled
	    },
	    on: {
	      "click": _vm.clone
	    }
	  }, [_vm._v("clone")])])])], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2231 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-list row column"
	  }, [_c('reservation-list-form', {
	    on: {
	      "filterReservations": _vm.setSearch,
	      "searchReservations": _vm.setSearch
	    }
	  }), _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search,
	      "searchRangeDataLoader": _vm.getReports
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2232 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2233 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-pay"
	  }, [(_vm.invoice.status !== 'PAID') ? _c('reveal', {
	    attrs: {
	      "confirm": true
	    },
	    on: {
	      "confirm": _vm.payInvoice
	    }
	  }, [(_vm.buttons) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Pay")]) : _c('a', {
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Pay via gateway")]), _c('h2', [_vm._v("Do you really want to pay the invoice"), _c('strong', [_vm._v("INV" + _vm._s(_vm.invoice.internal_id) + "(" + _vm._s(_vm.invoice.id) + ")")])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2234 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ModalReveal', {
	    ref: "editReveal"
	  }, [_c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "slot": "trigger",
	      "type": "button"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('DocumentTypeForm', {
	    model: {
	      value: (_vm.item),
	      callback: function($$v) {
	        _vm.item = $$v
	      },
	      expression: "item"
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.edit
	    },
	    slot: "footer"
	  }, [_vm._v("Save")])], 1), _c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2235 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-detail"
	  }, [_c('Cargo', {
	    attrs: {
	      "item": _vm.item,
	      "type": _vm.t
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2236 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-driver driver"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 5
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('driver-action-buttons', {
	    attrs: {
	      "driver": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "small-6",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('thumbnail', {
	    attrs: {
	      "image": _vm.item.profile_picture
	    }
	  })], 1), _c('driver-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'driver-info'
	    },
	    slot: "n2"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'city'
	    },
	    slot: "n3"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'created'
	    },
	    slot: "n4"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'phone-and-email'
	    },
	    slot: "n5"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1), _c('DriverNotification', {
	    attrs: {
	      "driver_id": _vm.item.id
	    }
	  })], 1)], 1)]) : _vm._e(), (_vm.$is('pendingDelete')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 5
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('driver-action-buttons', {
	    attrs: {
	      "driver": _vm.item,
	      "pending-delete": true
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "small-6",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('thumbnail', {
	    attrs: {
	      "image": _vm.item.profile_picture
	    }
	  })], 1), _c('driver-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'driver-info'
	    },
	    slot: "n2"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'city'
	    },
	    slot: "n3"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'created'
	    },
	    slot: "n4"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'phone-and-email'
	    },
	    slot: "n5"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1)]) : _vm._e(), (_vm.$is('approvalListing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('driver-action-buttons', {
	    attrs: {
	      "driver": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-1 align-self-middle thumb-container"
	  }, [_c('thumbnail', {
	    attrs: {
	      "image": _vm.item.profile_picture
	    }
	  })], 1), _c('div', {
	    staticClass: "columns n2 align-self-middle"
	  }, [_c('driver-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'driver-info-no-status'
	    },
	    slot: "n2"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'phone-and-email'
	    },
	    slot: "n5"
	  })], 1), _c('div', {
	    staticClass: "columns small-6 align-self-middle text-center"
	  }, [_c('AccountStatus', {
	    attrs: {
	      "statuses": ['client', 'address', 'subscription', 'document_status'],
	      "accountStatus": _vm.accountStatus
	    }
	  })], 1), _c('div', {
	    staticClass: "columns shrink n4 align-self-middle"
	  }, [_c('driver-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'created'
	    },
	    slot: "n5"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'updated'
	    },
	    slot: "n5"
	  })], 1)])]), _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])])])]) : _vm._e(), (_vm.$is('onlyname')) ? _c('div', {
	    staticClass: "onlyname"
	  }, [_c('driver-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'driver-fullname'
	    }
	  })], 1) : _vm._e(), (_vm.$is('oneLook')) ? _c('div', {
	    staticClass: "onelook"
	  }, [_c('driver-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'driver-info'
	    },
	    slot: "n1"
	  })], 1) : _vm._e(), (_vm.$is('driver-card')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "driver-card inner-content"
	  }, [_c('div', {
	    staticClass: "row collapse align-middle"
	  }, [_c('div', {
	    staticClass: "columns shrink"
	  }, [_c('thumbnail', {
	    attrs: {
	      "image": _vm.item.profile_picture
	    }
	  })], 1), _c('div', {
	    staticClass: "columns small-offset-1"
	  }, [_c('div', {
	    staticClass: "driver"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname) + " (DR" + _vm._s(_vm.item.id) + ")")])])], 1), _c('div', {
	    staticClass: "client"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.client_id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.client_organization_name) + " (CL" + _vm._s(_vm.item.client_id) + ")")])])], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [(_vm.fakePicture) ? _c('div', {
	    staticClass: "columns shrink"
	  }, [_c('a', {
	    staticClass: "m-1 fa fa-search-plus large fa-lg",
	    on: {
	      "click": function($event) {
	        return _vm.openPicture(_vm.item.profile_picture_original)
	      }
	    }
	  }), _c('a', {
	    staticClass: "m-1 fa fa-trash large fa-lg",
	    on: {
	      "click": _vm.deletePicture
	    }
	  }), _c('ModalReveal', {
	    ref: "reveal"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.pictureOriginal,
	      "width": "90%"
	    }
	  })])], 1) : _vm._e()]), _c('div', {
	    staticClass: "row align-right align-middle"
	  }, [(_vm.item.mobile) ? _c('a', {
	    staticClass: "pr-2 fa fa-comments fa-lg",
	    attrs: {
	      "href": 'https://wa.me/' + _vm.item.mobile.replace('-', '').replace('+', ''),
	      "target": "_blank"
	    }
	  }) : _vm._e(), (_vm.item.mobile) ? _c('a', {
	    staticClass: "pr-2 fa fa-phone fa-lg",
	    attrs: {
	      "href": 'tel:' + _vm.item.mobile
	    }
	  }) : _vm._e(), (this.c2cEnabled && _vm.item.mobile) ? _c('CallButton', {
	    attrs: {
	      "phone": _vm.item.mobile
	    }
	  }) : _vm._e(), (_vm.item.email) ? _c('a', {
	    staticClass: "pr-2 fa fa-envelope fa-lg",
	    attrs: {
	      "href": 'mailto:' + _vm.item.email
	    }
	  }) : _vm._e(), _c('DriverNotes', {
	    attrs: {
	      "driver_id": _vm.item.id,
	      "type": 'noteCard'
	    }
	  }), _c('DriverNotification', {
	    attrs: {
	      "driver_id": _vm.item.id
	    }
	  })], 1)])]) : _vm._e(), (_vm.$is('driver-card-approval')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "driver-card inner-content"
	  }, [_c('CardN', {
	    attrs: {
	      "columns": 12
	    }
	  }, [_c('thumbnail', {
	    attrs: {
	      "slot": "n1",
	      "image": _vm.item.profile_picture
	    },
	    slot: "n1"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'driver-info'
	    },
	    slot: "n2"
	  })], 1)], 1)]) : _vm._e(), (_vm.$is('driver-data')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('simple-columns33', [_c('div', {
	    staticClass: "field field-first-name",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("First Name")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "field-last-name",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Last name")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.surname))])]), _c('div', {
	    staticClass: "field-birthday",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Date Of Birth")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.birthdate, 'DD MMMM YYYY')))])]), _c('div', {
	    staticClass: "field-gender",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Gender")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.gender))])]), _c('div', {
	    staticClass: "field-country",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Country")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.address.country))])]), _c('div', {
	    staticClass: "field-address",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Address")]), _c('div', {
	    staticClass: "address"
	  }, [_vm._v(_vm._s(_vm.item.address.street) + " " + _vm._s(_vm.item.address.city) + " " + _vm._s(_vm.item.address.country))]), _c('div', {
	    staticClass: "postal-code"
	  }, [_vm._v(_vm._s(_vm.item.address.postal_code))])])]), _c('simple-columns33', [_c('div', {
	    staticClass: "field-username",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Username")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.username))])]), _c('div', {
	    staticClass: "field-member-id",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Member Id")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.id) + " - " + _vm._s(_vm.item.uid))])]), _c('div', {
	    staticClass: "field-created",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Member Since")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, 'DD MMMM YYYY')))])]), _c('div', {
	    staticClass: "field-status",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))])])]), _c('simple-columns33', [_c('div', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('driver-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'created'
	    }
	  })], 1), _c('div', {
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Updated")]), _c('driver-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'updated'
	    }
	  })], 1)]), _c('simple-columns33', [_c('div', {
	    staticClass: "field-email",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Email")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.email))])]), _c('div', {
	    staticClass: "field-phone",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Phone")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.phone))])]), _c('div', {
	    staticClass: "field-mobile",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Mobile")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.mobile))])])]), (_vm.item.extra && _vm.item.extra['app-version']) ? [_c('hr'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("App version")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.extra['app-version']))])])]), _c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.item.extra.device), function(extra, key, index) {
	    return _c('div', {
	      staticClass: "column large-4 small-6",
	      attrs: {
	        "slot": "n" + index
	      },
	      slot: "n" + index
	    }, [_c('div', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s(key))]), _c('div', {
	      staticClass: "field-value"
	    }, [_vm._v(_vm._s(extra))])])
	  }), 0)] : _vm._e()], 2) : _vm._e(), (_vm.$is('client-drivers')) ? _c('div', {
	    staticClass: "client-drivers"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card10', {
	    attrs: {
	      "showBullets": true
	    }
	  }, [_c('driver-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'driver-id'
	    },
	    slot: "n1"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'driver-uid'
	    },
	    slot: "n1"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'driver-name'
	    },
	    slot: "n2"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'driver-surname'
	    },
	    slot: "n3"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'driver-gender'
	    },
	    slot: "n4"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'driver-country'
	    },
	    slot: "n5"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'city'
	    },
	    slot: "n6"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n7",
	      "item": _vm.item,
	      "fieldName": 'driver-status'
	    },
	    slot: "n7"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n8",
	      "item": _vm.item,
	      "fieldName": 'created'
	    },
	    slot: "n8"
	  }), _c('driver-fields', {
	    attrs: {
	      "slot": "n9",
	      "item": _vm.item,
	      "fieldName": 'updated'
	    },
	    slot: "n9"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('driver-action-buttons', {
	    attrs: {
	      "driver": _vm.item
	    }
	  })], 1)], 1)], 1)], 1)])]) : _vm._e(), (_vm.$is('groupList')) ? _c('div', {
	    staticClass: "group-drivers"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Driver")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("D" + _vm._s(_vm.item.id) + " " + _vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])]) : _vm._e(), ((_vm.item.status === 'SUSPENDED' || _vm.item.status === 'ON HOLD') && _vm.type === 'highlightedNotes') ? _c('div', {
	    staticClass: "card"
	  }, [_c('DriverNotes', {
	    attrs: {
	      "driver_id": _vm.item.id,
	      "type": 'highlightedNotes'
	    },
	    on: {
	      "notes": _vm.retriveLastNotes
	    }
	  }), _c('div', {
	    staticClass: "row column pl-2 pr-2 pt-2 pb-2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("last two notes " + _vm._s(_vm.type))]), _vm._l((_vm.lastNotes), function(lastNote, key) {
	    return _c('div', {
	      staticClass: "row column small-12"
	    }, [_vm._v(_vm._s(lastNote))])
	  })], 2)], 1) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2237 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-create-zone"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12 large-6"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row column"
	  }, [_c('label', [_vm._v("Add from geojson"), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.poly),
	      expression: "body.poly"
	    }],
	    attrs: {
	      "rows": "10"
	    },
	    domProps: {
	      "value": (_vm.body.poly)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "poly", $event.target.value)
	      }
	    }
	  })]), _c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('GoogleMap', {
	    ref: "map",
	    staticStyle: {
	      "height": "500px"
	    },
	    attrs: {
	      "search-bar": true,
	      "api-key": _vm.apiKey,
	      "center": _vm.mapCenter,
	      "libraries": ['places', 'visualization', 'drawing'],
	      "zoomControl": true,
	      "mapTypeControl": true
	    }
	  }, [_c('GoogleMapDrawingManager', {
	    on: {
	      "updated": _vm.shapeUpdated
	    }
	  })], 1) : _vm._e()], 1), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.body.name || !_vm.body.poly
	    },
	    on: {
	      "click": _vm.createZone
	    }
	  }, [_vm._v("Create")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2238 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-alarm-list-filter-form filter-form"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.code),
	      expression: "search.code"
	    }],
	    staticClass: "noBorderClass",
	    attrs: {
	      "placeholder": "code"
	    },
	    domProps: {
	      "value": (_vm.search.code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, "code", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "columns"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.source),
	      expression: "search.source"
	    }],
	    staticClass: "noBorderClass",
	    attrs: {
	      "placeholder": "source"
	    },
	    domProps: {
	      "value": (_vm.search.source)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, "source", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "columns"
	  }, [_c('selectize-vehicle', {
	    on: {
	      "optionSelected": _vm.setVehicleId,
	      "optionRemoved": _vm.unsetVehicleId
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('a', {
	    staticClass: "fa fa-search fa-2x",
	    on: {
	      "click": _vm.filterAlarms
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2239 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('CouponButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("CP" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v("Code: " + _vm._s(_vm.item.code))])]), (_vm.item.common_cost !== null) ? _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v(_vm._s(_vm.item.common_cost.reason))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(_vm.item.common_cost.amount, _vm.item.common_cost.tax).toFixed(2))))])]) : _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Discount " + _vm._s(_vm.item.discount_rate) + "%")])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Valid from")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.start))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Valid to")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.end))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Max Uses")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.max_uses === null ? 'unlimited' : _vm.item.max_uses))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Max Uses per driver")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.max_uses_per_driver === null ? 'unlimited' : _vm.item.max_uses_per_driver))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Expiry Date")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.expiry_date === null ? 'unlimited' : _vm.item.expiry_date))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Max Days")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.max_days === null ? 'unlimited' : _vm.item.max_days))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Service")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.service === null ? 'All' : _vm.item.service))])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2240 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.options) ? _c('selectize', {
	    attrs: {
	      "value": _vm.value,
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Federation"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-replace-action-buttons"
	  }, [_c('div', {
	    staticClass: "button-group small text-center"
	  }, [_c('button', {
	    staticClass: "button small",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('cancelAndBook', _vm.item)
	      }
	    }
	  }, [_vm._v("Cancel & Book")]), _c('button', {
	    staticClass: "button small",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('voidAndBook', _vm.item)
	      }
	    }
	  }, [_vm._v("Void & Book")])])])
	},staticRenderFns: []}

/***/ }),
/* 2242 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-client-type"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('VatButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("ID")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("V" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Name")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.description) + " (" + _vm._s(_vm.item.name) + ")")]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Percentage")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.percentage) + "%")])])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2243 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-vehicle-slot-avaiability"
	  }, [(_vm.availability.length) ? _c('div', {
	    staticClass: "time-slots",
	    style: (_vm.showRows)
	  }, [_vm._l((_vm.availability), function(timeSlot, index) {
	    return [_c('label', [_c('ToggleableButton', {
	      key: timeSlot.start_timestamp,
	      staticClass: "small",
	      class: {
	        'fake-selection': _vm.fakeSelection(index)
	      },
	      style: ({}),
	      attrs: {
	        "disabled": !timeSlot.available,
	        "selectable": _vm.selectable
	      },
	      nativeOn: {
	        "click": function($event) {
	          return _vm.checkIndex($event)
	        }
	      },
	      model: {
	        value: (timeSlot.selected),
	        callback: function($$v) {
	          _vm.$set(timeSlot, "selected", $$v)
	        },
	        expression: "timeSlot.selected"
	      }
	    }, [_vm._v(_vm._s(_vm.formatUnix(timeSlot.end_timestamp)))])], 1), (_vm.isStartOfDay(timeSlot.end_timestamp)) ? _c('div', {
	      staticClass: "grid-break"
	    }, [_c('span', [_vm._v(_vm._s(_vm.timeBreak(timeSlot.end_timestamp)) + ", " + _vm._s(_vm.$dateFormat(timeSlot.end, 'DD MMM YYYY')))])]) : _vm._e()]
	  })], 2) : _vm._e(), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "button-group"
	  }, [_c('div', {
	    staticClass: "button",
	    on: {
	      "click": _vm.loadMore
	    }
	  }, [_vm._v("Load more")])])]), (_vm.selectable) ? _c('div', {
	    staticClass: "row columns"
	  }, [_vm._t("default"), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.selectionValid,
	      "dark": _vm.selectionValid,
	      "light": true
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('slotsSelected', _vm.selectedSlots)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.selectionValid ? _vm.extend ? 'Extend ' : 'Book' : 'Select range'))])], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2244 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-driver-license-approval-list row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('SearchEntity', {
	    attrs: {
	      "entity": "drivers"
	    },
	    model: {
	      value: (_vm.search.driver_id),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "driver_id", $$v)
	      },
	      expression: "search.driver_id"
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('SelectizeDocumentType', {
	    on: {
	      "optionSelected": _vm.selectType,
	      "optionRemoved": _vm.unsetType
	    }
	  })], 1)]), _c('BaseList', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search,
	      "componentType": "license-approval-list"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2245 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-client-invoices"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Invoices")]), (_vm.expanded) ? _c('InvoiceListForm', {
	    attrs: {
	      "slot": "action",
	      "type": "entity-filter"
	    },
	    on: {
	      "filterInvoices": _vm.filterInvoices
	    },
	    slot: "action"
	  }) : _vm._e(), (_vm.expanded) ? _c('InvoiceListForm', {
	    attrs: {
	      "slot": "action",
	      "type": "type-filter"
	    },
	    on: {
	      "filterInvoices": _vm.filterInvoices
	    },
	    slot: "action"
	  }) : _vm._e(), _c('i', {
	    staticClass: "fa fa-2x",
	    class: {
	      'fa-eye-slash': _vm.expanded, 'fa-eye': !_vm.expanded
	    },
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": function($event) {
	        _vm.expanded = !_vm.expanded
	      }
	    },
	    slot: "action"
	  })], 1), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.expanded),
	      expression: "expanded"
	    }],
	    staticClass: "tabs-inner-content"
	  }, [_c('div', {
	    staticClass: "text-right"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'credit-note',
	        params: {
	          client_id: _vm.$route.params.id,
	          wallet_id: _vm.wallet.id
	        }
	      }
	    }
	  }, [_c('span', {
	    staticClass: "button"
	  }, [_vm._v("Emit manual credit note")])])], 1)]), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "search": _vm.search,
	      "dataLoader": _vm.dataLoader,
	      "resultsPerPage": 5,
	      "componentType": "client-invoices"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2246 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-list-form"
	  }, [_c('div', {
	    staticClass: "statuses"
	  }, _vm._l((['ACTIVE', 'APPROVED', 'SUSPENDED', 'REFUSED', 'ON HOLD', 'PENDING REVIEW']), function(status) {
	    return _c('div', {
	      staticClass: "ml-3 status"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.search.status),
	        expression: "search.status"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": status,
	        "checked": Array.isArray(_vm.search.status) ? _vm._i(_vm.search.status, status) > -1 : (_vm.search.status)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.search.status,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = status,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(_vm.search, "status", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(_vm.search, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(_vm.search, "status", $$c)
	          }
	        }
	      }
	    }), _c('label', [_vm._v(_vm._s(status))])])
	  }), 0), _c('div', {
	    staticClass: "row"
	  }, [(_vm.$isNot('export-form')) ? _c('div', {
	    staticClass: "columns shrink"
	  }, [_c('a', {
	    staticClass: "fa fa-search fa-2x",
	    on: {
	      "click": function($event) {
	        _vm.advanced = !_vm.advanced
	      }
	    }
	  })]) : _vm._e(), (!_vm.advanced) ? _c('div', {
	    staticClass: "basic row"
	  }, [_c('div', {
	    staticClass: "columns ml-2 large-12"
	  }, [_c('date-range-picker', {
	    on: {
	      "input": _vm.dateRangeSelected
	    }
	  })], 1)]) : _vm._e(), (_vm.advanced) ? _c('div', {
	    staticClass: "advanced"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('input-form', {
	    attrs: {
	      "fields": ['query'],
	      "placeholders": ['Driver search']
	    },
	    on: {
	      "updatedData": _vm.setSearch
	    }
	  })], 1)]) : _vm._e(), (!_vm.advanced && _vm.$isNot('export-form')) ? _c('div', {
	    staticClass: "columns small-1 text-right"
	  }, [_c('a', {
	    staticClass: "fa fa-filter fa-2x",
	    on: {
	      "click": _vm.setFilters
	    }
	  })]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2247 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-entities-search callout"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12 medium-3"
	  }, [_c('search-input-form', {
	    attrs: {
	      "placeholder": 'Client'
	    },
	    on: {
	      "filteredSearch": _vm.setClientComponent
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        _vm.component = null
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "column small-12 medium-3"
	  }, [_c('search-input-form', {
	    attrs: {
	      "placeholder": 'Driver'
	    },
	    on: {
	      "filteredSearch": _vm.setDriverComponent
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        _vm.component = null
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "column small-12 medium-3"
	  }, [_c('search-input-form', {
	    attrs: {
	      "placeholder": 'Reservation (id or client name)'
	    },
	    on: {
	      "filteredSearch": _vm.setReservationComponent
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        _vm.component = null
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "column small-12-medium-3"
	  }, [_c('search-input-form', {
	    attrs: {
	      "placeholder": "Vehicle license plate"
	    },
	    on: {
	      "filteredSearch": _vm.setVehicleComponent
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        _vm.component = null
	      }
	    }
	  })], 1)]), (_vm.component) ? _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2248 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-policy-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2249 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-client-list row column"
	  }, [_c('cards', {
	    attrs: {
	      "data": _vm.parsedReports
	    }
	  }), _c('client-list-form', {
	    on: {
	      "setSearch": _vm.setSearch
	    }
	  }), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2250 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-credit-bonus-configuration"
	  }, [_c('ModalReveal', {
	    ref: "bonusModal",
	    on: {
	      "modalOpen": _vm.load
	    }
	  }, [(_vm.item.amount !== null) ? _c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Info")]) : _vm._e(), (_vm.info !== null) ? _c('div', {
	    staticClass: "row text-center"
	  }, [(_vm.checkConfig.length) ? [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Used Amount")]), _c('h3', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.info.used_amount)))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Amount Left")]), _c('h3', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.info.amount_left)))])])] : _vm._e(), _c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Use count")]), _c('h3', [_vm._v(_vm._s(_vm.info.use_count))])])], 2) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2251 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-plan-controller"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('router-view', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2252 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component component-backoffice-note-form"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-12"
	  }, [_c('label', [_vm._v("Valid from"), _c('DatePicker', {
	    model: {
	      value: (_vm.note.valid_from),
	      callback: function($$v) {
	        _vm.$set(_vm.note, "valid_from", $$v)
	      },
	      expression: "note.valid_from"
	    }
	  })], 1), _c('label', [_vm._v("Valid to"), _c('DatePicker', {
	    model: {
	      value: (_vm.note.valid_to),
	      callback: function($$v) {
	        _vm.$set(_vm.note, "valid_to", $$v)
	      },
	      expression: "note.valid_to"
	    }
	  })], 1), _c('label', [_vm._v("Description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.note.description),
	      expression: "note.description"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.note.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.note, "description", $event.target.value)
	      }
	    }
	  })]), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.note.description
	    },
	    on: {
	      "click": _vm.noteCompleted
	    }
	  }, [_vm._v("Create")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2253 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('vehicle-id')) ? _c('div', {
	    staticClass: "field-vehicle-id"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("V" + _vm._s(_vm.item.id))])]) : (_vm.$is('vehicle-image')) ? _c('div', {
	    staticClass: "field-vehicle-image"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.item.picture_external
	    }
	  })])]) : (_vm.$is('vehicle-brand-and-lot')) ? _c('div', {
	    staticClass: "field-vehicle-brand-and-lot"
	  }, [(_vm.item.archived_at) ? _c('div', {
	    staticClass: "field-value",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("Archived")]) : _vm._e(), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.parking_lot.name))])]) : (_vm.$is('vehicle-lot')) ? _c('div', {
	    staticClass: "field-vehicle-lot"
	  }, [(_vm.item.parking_lot.name) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("PL " + _vm._s(_vm.item.parking_lot.name))]) : _vm._e(), (_vm.item.vehicle_slot_address) ? _c('div', {
	    staticClass: "field-value",
	    staticStyle: {
	      "max-width": "fit-content"
	    }
	  }, [_vm._v("VS" + _vm._s(_vm.item.slot_id) + " " + _vm._s(_vm.item.vehicle_slot_address))]) : _vm._e(), (_vm.item.federation !== null) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Federation: " + _vm._s(_vm.item.federation.name))]) : _vm._e()]) : (_vm.$is('vehicle-brand')) ? _c('div', {
	    staticClass: "field-vehicle-brand"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))])]) : (_vm.$is('vehicle-lot-address')) ? _c('div', {
	    staticClass: "field-vehicle-lot"
	  }, [(_vm.item.vehicle_slot_address) ? _c('div', {
	    staticClass: "field-value mb-1"
	  }, [_vm._v("VS" + _vm._s(_vm.item.slot_id) + " " + _vm._s(_vm.item.vehicle_slot_address))]) : _vm._e(), (_vm.item.federation !== null) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Federation: " + _vm._s(_vm.item.federation.name))]) : _vm._e()]) : (_vm.$is('vehicle-brand')) ? _c('div', {
	    staticClass: "field-vehicle-brand"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))])]) : (_vm.$is('vehicle-plate')) ? _c('div', {
	    staticClass: "field-vehicle-plate"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_c('router-link', {
	    staticClass: "hollow button secondary small",
	    attrs: {
	      "to": {
	        name: 'vehicle',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.item.plate))])], 1)]) : (_vm.$is('vehicle-fuel-type')) ? _c('div', {
	    staticClass: "field-vehicle-fuel-type"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Fuel Type")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.fuel_type))])]) : (_vm.$is('vehicle-category')) ? _c('div', {
	    staticClass: "field-vehicle-category"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Category")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.category.name))])]) : (_vm.$is('vehicle-lot')) ? _c('div', {
	    staticClass: "field-vehicle-lot"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Assigned lot")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.slot_name))])]) : (_vm.$is('vehicle-status')) ? _c('div', {
	    staticClass: "field-vehicle-status"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status  "), (_vm.item.slot_id !== null) ? _c('span', {
	    staticClass: "float-right fa fa-circle",
	    class: _vm.pointStatusColor
	  }) : _vm._e()]), _c('vehicle-status', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1) : (_vm.$is('vehicle-additional-status')) ? _c('div', {
	    staticClass: "field-vehicle-additional-status"
	  }, [_c('vehicle-additional-status', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2254 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-smart-edit"
	  }, [_c('smart-edit', {
	    attrs: {
	      "value": _vm.editable,
	      "options": _vm.options
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.updateParkingLot
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2255 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-backoffice-parking-slots"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "cards"
	  }, [_c('div', {
	    staticClass: "help-text text-center"
	  }, [_vm._v("With OWFF mode, it can happen that vehicle slots are on the same parking slot because one has a started reservation and the other is physically on the parking slot")]), _c('div', {
	    staticClass: "grouped"
	  }, _vm._l((_vm.slots), function(parkingSlot) {
	    return _c('div', {
	      staticClass: "parking-slot callout"
	    }, [(parkingSlot.placeholder) ? _c('div', {
	      staticClass: "placeholder"
	    }, [_c('a', {
	      staticClass: "fa fa-plus fa-3x",
	      on: {
	        "click": _vm.addParkingLot
	      }
	    })]) : (parkingSlot.vehicle_slots.length === 0) ? _c('div', {
	      staticClass: "empty"
	    }, [_c('strong', [_vm._v("PS-" + _vm._s(parkingSlot.id))]), _c('add-vehicle-asset', {
	      attrs: {
	        "item": parkingSlot
	      },
	      on: {
	        "addVehicleAsset": _vm.loadSlots
	      }
	    }), _c('div', {
	      staticClass: "slot"
	    }, [_c('div', {
	      staticClass: "button-group small"
	    }, [_c('ArchiveVehicleSlots', {
	      on: {
	        "slotForArchiveSelected": function($event) {
	          return _vm.archiveParkingSlot($event, parkingSlot)
	        }
	      }
	    }), _c('button', {
	      staticClass: "button alert small",
	      on: {
	        "click": function($event) {
	          return _vm.deleteParkingSlot(parkingSlot)
	        }
	      }
	    }, [_vm._v("Delete Slot")])], 1)])], 1) : _vm._l((parkingSlot.vehicle_slots), function(slot) {
	      return _c('div', {
	        staticClass: "parking-slots"
	      }, [_c('h3', [_vm._v("PS" + _vm._s(parkingSlot.id))]), _c('Vehicle', {
	        attrs: {
	          "item": slot.vehicle,
	          "type": "search-result"
	        }
	      }, [_c('h4', [_vm._v("VS" + _vm._s(slot.id) + " - " + _vm._s(slot.reservation_type))])]), _c('asset-management-action-buttons', {
	        attrs: {
	          "item": slot
	        },
	        on: {
	          "assetMoved": _vm.loadSlots,
	          "vehicleSlotDismissed": _vm.loadSlots
	        }
	      })], 1)
	    })], 2)
	  }), 0)])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Parking lot Management")])])])
	}]}

/***/ }),
/* 2256 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "swap-vehicle-asset"
	  }, [_c('a', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        _vm.swapEnabled = !_vm.swapEnabled
	      }
	    }
	  }, [_vm._v("Swap")]), (_vm.swapEnabled) ? _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        _vm.swapEnabled = false
	      }
	    }
	  }, [_vm._v("x")]), _c('h2', [_vm._v("VS" + _vm._s(_vm.item.id))]), _c('p', [_vm._v("Select the destination from the dropdown list")]), _c('selectize-vehicle-slot', {
	    on: {
	      "optionSelected": _vm.selected
	    }
	  }), _c('button', {
	    staticClass: "button",
	    class: {
	      disabled: !_vm.itemSelected
	    },
	    on: {
	      "click": _vm.processSwap
	    }
	  }, [_vm._v("Confirm")])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2257 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-list row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12 large-4"
	  }), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectReport),
	      expression: "selectReport"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectReport = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Select Report")]), _vm._l((_vm.reports), function(report, index) {
	    return _c('option', {
	      domProps: {
	        "value": report.toLowerCase()
	      }
	    }, [_vm._v(_vm._s(report))])
	  })], 2)]), (_vm.selectReport != '') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-3 large-3"
	  }, [_c('label', [_vm._v("Select Range")]), _c('date-range-picker', {
	    key: _vm.componentKey,
	    on: {
	      "input": _vm.dateRangeSelected
	    }
	  })], 1), _vm._l((_vm.formFields[_vm.selectReport]), function(formField) {
	    return _c('div', {
	      staticClass: "column small-2 large-2"
	    }, [_c('label', [_vm._v(_vm._s(_vm.stringReplacer(formField)))]), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.search[formField]),
	        expression: "search[formField]"
	      }],
	      staticClass: "roundedBorder",
	      attrs: {
	        "type": "string",
	        "placeholder": ""
	      },
	      domProps: {
	        "value": (_vm.search[formField])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.search, formField, $event.target.value)
	        }
	      }
	    })])
	  }), _c('div', {
	    staticClass: "column small-1 large-1"
	  }, [_c('label', [_vm._v("Delimiter")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search['delimiter']),
	      expression: "search['delimiter']"
	    }],
	    staticClass: "text-center",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.search['delimiter'])
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, 'delimiter', $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "column small-1 large-1"
	  }, [_c('div', {
	    staticClass: "buttonContainer"
	  }, [_c('a', {
	    staticClass: "fa fa-3x fa-file-excel-o",
	    attrs: {
	      "title": "download csv"
	    },
	    on: {
	      "click": _vm.openCsv
	    }
	  })])]), _c('div', {
	    staticClass: "column small-1 large-1"
	  }, [_c('div', {
	    staticClass: "buttonContainer"
	  }, [_c('a', {
	    staticClass: "fa fa-3x fa-copy",
	    attrs: {
	      "title": "copy url to clipboard"
	    },
	    on: {
	      "click": _vm.copyURL
	    }
	  })])]), (_vm.viewUrl) ? _c('div', {
	    staticClass: "column"
	  }, [_c('input', {
	    attrs: {
	      "type": "text",
	      "id": "myInput"
	    },
	    domProps: {
	      "value": _vm.url
	    }
	  })]) : _vm._e()], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2258 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "allowEmptyOption": _vm.allowEmptyOption,
	      "placeholder": "Policies"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2259 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-credit-records"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "component-credit-record"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column expanded"
	  }, [_c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v("CR" + _vm._s(_vm.item.id)), (_vm.item.service) ? _c('small', [_vm._v(" " + _vm._s(_vm.item.service) + " only")]) : _vm._e()]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('small', [_c('span', [_vm._v(_vm._s(_vm.item.type))]), (_vm.item.type === 'USE') ? _c('span', [_vm._v("  " + _vm._s(_vm.item.walletable_type ? _vm.item.walletable_type : '--') + " " + _vm._s(_vm.item.walletable_id ? _vm.item.walletable_id : '--'))]) : _vm._e()]), _c('div', {
	    staticClass: "description",
	    attrs: {
	      "slot": "bottom"
	    },
	    slot: "bottom"
	  }, [_vm._v(_vm._s(_vm.item.reason.replace('|', ' - ')))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "fiel-content"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])])]), _c('div', {
	    staticClass: "column shrink pl-0"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('CreditRecordButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1)]), _c('div', {
	    staticClass: "row text-center pt-0"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Valid From")]), (_vm.item.valid_from) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.valid_from, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("--")])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Valid To")]), (_vm.item.valid_to) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.valid_to, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("--")])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Amount")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount)))])])])])])]) : _vm._e(), (_vm.$is('usages')) ? _c('div', {
	    staticClass: "component-credit-record"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("CR" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('small', [_c('span', [_vm._v(_vm._s(_vm.item.type))]), (_vm.item.type === 'USE') ? _c('span', [_vm._v("  " + _vm._s(_vm.item.walletable_type ? _vm.item.walletable_type : '--') + " " + _vm._s(_vm.item.walletable_id ? _vm.item.walletable_id : '--'))]) : _vm._e()])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Amount")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount)))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Reason")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.reason))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "fiel-content"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.created_at))])])])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2260 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('subscription-id-and-client')) ? _c('div', {
	    staticClass: "field-subscription-id-and-client"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.client.name) + " " + _vm._s(_vm.item.client.surname))])]) : (_vm.$is('plan-name')) ? _c('div', {
	    staticClass: "field-plan-name"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.plan.name))])]) : (_vm.$is('subscription-booking-mode')) ? _c('div', {
	    staticClass: "field-subscription-booking-mode iconized"
	  }, [_c('i', {
	    staticClass: "pm-icon subs-bookingtype"
	  }), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.plan.booking_mode))])]) : (_vm.$is('subscription-max-drivers')) ? _c('div', {
	    staticClass: "field-subscription-max-drivers iconized"
	  }, [_c('i', {
	    staticClass: "pm-icon subs-drivers"
	  }), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.drivers.length) + "/" + _vm._s(_vm.item.plan.max_drivers))])]) : (_vm.$is('subscription-expire-in')) ? _c('div', {
	    staticClass: "field-expire-in"
	  }, [(_vm.item.start && _vm.item.end) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("EXPIRE IN: " + _vm._s(_vm.item.start) + " " + _vm._s(_vm.item.end) + " " + _vm._s(_vm.$diffInDays(_vm.item.end, _vm.item.start)) + " days")]) : _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Unactive subscription")])]) : (_vm.$is('plan-billing-cycle')) ? _c('div', {
	    staticClass: "field-plan-billing-cycle iconized"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("*/" + _vm._s(_vm.item.plan.billing_cycle) + " days")])]) : (_vm.$is('renew-info')) ? _c('div', {
	    staticClass: "field-auto-renew iconized"
	  }, [_c('i', {
	    staticClass: "pm-icon subs-expiry",
	    style: ({
	      color: _vm.item.auto_renew == '1' ? 'green' : 'red'
	    })
	  }), (_vm.item.auto_renew == '1' && (_vm.item.start && _vm.item.end)) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$diffInDays(_vm.item.start, _vm.item.end) - 1) + " days")]) : _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Unactive/Disabled")])]) : (_vm.$is('plan-cost-billing-cycle')) ? _c('div', {
	    staticClass: "field-plan-cost-billing-cycle"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.item.plan.cost) + _vm._s(_vm.currency) + "/" + _vm._s(_vm.$daysNumberToHuman(_vm.item.plan.billing_cycle)))])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "field-value"
	  }, [_c('i', {
	    staticClass: "pm-icon subs-billing"
	  })])
	}]}

/***/ }),
/* 2261 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-book-panel",
	    attrs: {
	      "id": _vm.id
	    }
	  }, [_c('div', {
	    staticClass: "row columns"
	  }, [_c('div', {
	    staticClass: "callout"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('label', [_vm._v("Booking Mode"), _c('BookingModeSelect', {
	    attrs: {
	      "disabled": _vm.hideSearchFields
	    },
	    model: {
	      value: (_vm.booking_mode),
	      callback: function($$v) {
	        _vm.booking_mode = $$v
	      },
	      expression: "booking_mode"
	    }
	  })], 1)]), (!_vm.driverId) ? _c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('label', [_vm._v("Driver")]), _c('SearchEntity', {
	    attrs: {
	      "entity": "drivers",
	      "loadedValues": _vm.entityDrivers
	    },
	    model: {
	      value: (_vm.book.driver_id),
	      callback: function($$v) {
	        _vm.$set(_vm.book, "driver_id", $$v)
	      },
	      expression: "book.driver_id"
	    }
	  })], 1) : _vm._e()]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('label', [_vm._v("Vehicle"), _c('selectize-vehicle', {
	    attrs: {
	      "disabledSlot": 0
	    },
	    on: {
	      "optionSelected": _vm.setVehicle,
	      "optionRemoved": _vm.unsetVehicle
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Driver position"), _c('GoogleMapSearchBox', {
	    on: {
	      "placesChanged": _vm.setDriverPosition
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('label', [_vm._v("Memo"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.book.memo),
	      expression: "book.memo"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.book.memo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.book, "memo", $event.target.value)
	      }
	    }
	  })])])]), _c('h2', [_vm._v("Extra costs")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Costs")]), _c('selectize-common-cost', {
	    attrs: {
	      "maxItems": null
	    },
	    on: {
	      "optionSelected": _vm.addCommonCost,
	      "optionRemoved": _vm.removeCommonCost
	    }
	  })], 1)]), (['RT', 'CRT', 'SRT', 'STR'].includes(_vm.booking_mode) && !_vm.hideSearchFields) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Start"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "initialDate": _vm.bookStart,
	      "disabledFrom": _vm.disabledFrom,
	      "format": 'yyyy-mm-dd hh:ii'
	    },
	    model: {
	      value: (_vm.start),
	      callback: function($$v) {
	        _vm.start = $$v
	      },
	      expression: "start"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("End"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "initialDate": _vm.end,
	      "disabledFrom": _vm.disabledFrom,
	      "format": 'yyyy-mm-dd hh:ii'
	    },
	    model: {
	      value: (_vm.end),
	      callback: function($$v) {
	        _vm.end = $$v
	      },
	      expression: "end"
	    }
	  })], 1)])]) : _vm._e(), (!_vm.hideSearchFields) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.disabledSearchButton
	    },
	    on: {
	      "click": _vm.dataLoader
	    }
	  }, [_vm._v("Search vehicle")])])]) : _vm._e(), (!_vm.hideSearchFields) ? _c('div', {
	    staticClass: "search-results"
	  }, [(_vm.loading) ? _c('loading-spinner') : (_vm.vehicleLength > 0) ? _c('tab-headers', {
	    attrs: {
	      "tabs": ['Vehicles Map', 'Vehicles List'],
	      "id": 'book-vehicle',
	      "activeIndex": 0
	    }
	  }, [_c('tab-content', {
	    attrs: {
	      "headerName": 'Vehicles Map',
	      "active": true
	    }
	  }, [_c('book-vehicle-from-map', {
	    attrs: {
	      "vehicles": _vm.vehicles,
	      "userPosition": _vm.getUserPosition
	    },
	    on: {
	      "getVehicleSelected": _vm.bookNow
	    }
	  })], 1), _c('tab-content', {
	    attrs: {
	      "headerName": 'Vehicles List',
	      "active": true
	    }
	  }, _vm._l((_vm.slotsByLots), function(slots, key) {
	    return _c('div', {
	      staticClass: "grouped card",
	      style: (_vm.gridStyle(slots))
	    }, [_c('h1', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(key))]), _vm._l((slots), function(vehicle, id) {
	      return (!vehicle.disabled) ? _c('vehicle', {
	        key: id,
	        attrs: {
	          "item": vehicle,
	          "type": "search-result"
	        },
	        on: {
	          "bookVehicle": _vm.bookNow
	        }
	      }) : _vm._e()
	    })], 2)
	  }), 0)], 1) : _vm._e()], 1) : _c('div', {
	    staticClass: "availability"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Start"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "initialDate": _vm.start,
	      "disabledFrom": _vm.disabledFrom,
	      "format": 'yyyy-mm-dd hh:ii'
	    },
	    model: {
	      value: (_vm.start),
	      callback: function($$v) {
	        _vm.start = $$v
	      },
	      expression: "start"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("End"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "initialDate": _vm.end,
	      "disabledFrom": _vm.disabledFrom,
	      "format": 'yyyy-mm-dd hh:ii'
	    },
	    model: {
	      value: (_vm.end),
	      callback: function($$v) {
	        _vm.end = $$v
	      },
	      expression: "end"
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row columns"
	  }, [(_vm.book.driver_id && !_vm.bookDirectlyHide) ? _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.end
	    },
	    on: {
	      "click": _vm.bookFast
	    }
	  }, [_vm._v("Book")]) : _vm._e()]), _c('div', {
	    staticClass: "row columns"
	  }), (_vm.availability.length && !_vm.bookDirectly) ? _c('backoffice-vehicle-availability', {
	    attrs: {
	      "availability": _vm.availability
	    },
	    on: {
	      "slotsSelected": _vm.setDatesAndBook,
	      "loadExtra": _vm.showExtraDay,
	      "rangeSelection": _vm.rangeSelection
	    }
	  }) : _vm._e()], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 2262 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-card card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [(!_vm.driver_id) ? _c('div', {
	    staticClass: "driver"
	  }, [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("Create a new card for your client")]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Driver id")]), _c('selectize-driver', {
	    on: {
	      "optionSelected": _vm.setDriverId
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Chip id"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.chip_id),
	      expression: "body.chip_id"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "chip id"
	    },
	    domProps: {
	      "value": (_vm.body.chip_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "chip_id", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Card Active")]), _c('div', {
	    staticClass: "switch small"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.enabled),
	      expression: "body.enabled"
	    }],
	    staticClass: "switch-input",
	    attrs: {
	      "id": "enabled",
	      "type": "checkbox",
	      "name": "enabled"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.body.enabled) ? _vm._i(_vm.body.enabled, null) > -1 : (_vm.body.enabled)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.body.enabled,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.body, "enabled", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.body, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.body, "enabled", $$c)
	        }
	      }
	    }
	  }), _vm._m(0)])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Card name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "card name"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Standard"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.standard),
	      expression: "body.standard"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "standard", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', [_vm._v("RAW")]), _c('option', [_vm._v("2-ROTATED")])])])])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-center"
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.addCard
	    }
	  }, [_vm._v("Add card")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "switch-paddle",
	    attrs: {
	      "for": "enabled"
	    }
	  }, [_c('span', {
	    staticClass: "show-for-sr"
	  }, [_vm._v("Enabled")]), _c('span', {
	    staticClass: "switch-active",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("Yes")]), _c('span', {
	    staticClass: "switch-inactive",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("No")])])
	}]}

/***/ }),
/* 2263 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-refundable-records"
	  }, [_c('ModalReveal', {
	    ref: _vm.componentId
	  }, [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Select records")]), _c('div', {
	    staticClass: "header",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('h2', [_vm._v("Select records to refund")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column large-6"
	  }, [_c('label', [_vm._v("Invoice final sectional / Internal id"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.invoice_id),
	      expression: "search.invoice_id"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.search.invoice_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, "invoice_id", $event.target.value)
	      }
	    }
	  })])])])]), _c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    attrs: {
	      "id": "refundable-list",
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search,
	      "resultsPerPage": 5,
	      "selectableList": true
	    },
	    model: {
	      value: (_vm.selected),
	      callback: function($$v) {
	        _vm.selected = $$v
	      },
	      expression: "selected"
	    }
	  })], 1), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": _vm.close
	    },
	    slot: "footer"
	  }, [_vm._v("Add records")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Close")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2264 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-operations"
	  }, [(_vm.item) ? _c('cards', {
	    attrs: {
	      "data": _vm.cardData
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "row columns"
	  }, [_c('label', [_vm._v("Select where the reservations will be moved"), (_vm.options) ? _c('selectize', {
	    ref: "selectize",
	    attrs: {
	      "options": _vm.options,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.optionTemplate,
	      "valueField": "id"
	    },
	    on: {
	      "itemAdded": _vm.updateVehicleSlots,
	      "itemRemoved": _vm.updateVehicleSlots
	    }
	  }) : _vm._e()], 1), _c('button', {
	    staticClass: "button",
	    class: {
	      disabled: !_vm.vehicle_slots_id
	    },
	    attrs: {
	      "disabled": !_vm.vehicle_slots_id
	    },
	    on: {
	      "click": _vm.drain
	    }
	  }, [_vm._v("Drain vehicle slot")])]), (_vm.results) ? _c('div', {
	    staticClass: "row columns"
	  }, [_c('accordion', [_c('accordion-item', {
	    attrs: {
	      "title": "Migrated"
	    }
	  }, _vm._l((_vm.results.migrated), function(reservation) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column"
	    }, [_c('h2', [_vm._v("Old Reservation")]), _c('reservation', {
	      attrs: {
	        "item": reservation.old,
	        "type": "shortList"
	      }
	    })], 1), _c('div', {
	      staticClass: "column"
	    }, [_c('h2', [_vm._v("New Reservation")]), _c('reservation', {
	      attrs: {
	        "item": reservation.new,
	        "type": "shortList"
	      }
	    })], 1)])
	  }), 0), _c('accordion-item', {
	    attrs: {
	      "title": "Stalled"
	    }
	  }, _vm._l((_vm.results.stalled), function(reservation) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column"
	    }, [_c('h2', [_vm._v("Stalled")]), _c('reservation', {
	      attrs: {
	        "item": reservation,
	        "type": "shortList"
	      }
	    })], 1)])
	  }), 0)], 1)], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2265 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-log"
	  }, [_c('b', [_vm._v("User:  ")]), (_vm.item.user_id) ? _c('b', [_vm._v(_vm._s(_vm.item.user_id) + " [" + _vm._s(_vm.item.user_type) + "] @ " + _vm._s(_vm.item.ip_address))]) : _c('b', [_vm._v(_vm._s(_vm.item.ip_address))]), _c('hr'), _c('b', [_vm._v("Entity snapshot:")]), _c('pre', [_vm._v(_vm._s(_vm.item.snapshot))])])
	},staticRenderFns: []}

/***/ }),
/* 2266 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-invoice-list row column"
	  }, [_c('cards', {
	    attrs: {
	      "data": _vm.parsedReports
	    }
	  }), _c('invoice-list-form', {
	    on: {
	      "filterInvoices": _vm.setSearch
	    }
	  }), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search,
	      "searchRangeDataLoader": _vm.getReports
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2267 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-simple-columns3-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns n1 small-4"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns n2 small-4"
	  }, [_vm._t("n2")], 2), _c('div', {
	    staticClass: "columns n3 small-4"
	  }, [_vm._t("n3")], 2)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns n4 small-4"
	  }, [_vm._t("n4")], 2), _c('div', {
	    staticClass: "columns n5 small-4"
	  }, [_vm._t("n5")], 2), _c('div', {
	    staticClass: "columns n6 small-4"
	  }, [_vm._t("n6")], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 2268 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder,
	      "id": _vm._uid + '-selectize'
	    }
	  }), (_vm.showAdd) ? _c('div', {
	    staticClass: "input-group-button"
	  }, [_c('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('toggleAdd')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "fa fa-plus"
	  })])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2269 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$acl('edit-drivers')) ? _c('div', {
	    staticClass: "component-client-smart-edit"
	  }, [_c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1) : _c('h3', [_vm._v("Your account doesn't have permission to edit drivers.")])
	},staticRenderFns: []}

/***/ }),
/* 2270 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.driver !== null) ? _c('div', {
	    staticClass: "component-driver-profile"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "driver-profile tabs-inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'driver-data',
	      "item": _vm.driver
	    }
	  })], 1)]), _c('hr'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Groups")]), _vm._l((_vm.driver.groups), function(group) {
	    return _c('DriverGroup', {
	      attrs: {
	        "item": group,
	        "driver": _vm.driver
	      },
	      on: {
	        "toggleSupervisor": _vm.toggleSupervisor
	      }
	    })
	  })], 2)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('h2', [_vm._v("Driver Profile")])])
	}]}

/***/ }),
/* 2271 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-einvoice-status"
	  }, [_c('ModalReveal', {
	    on: {
	      "input": _vm.closeSdiStatus
	    },
	    model: {
	      value: (_vm.openSdiStatus),
	      callback: function($$v) {
	        _vm.openSdiStatus = $$v
	      },
	      expression: "openSdiStatus"
	    }
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    on: {
	      "click": _vm.open
	    },
	    slot: "trigger"
	  }, [_vm._v("Aggiorna filename")]), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Filename"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filename),
	      expression: "filename"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.filename)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filename = $event.target.value
	      }
	    }
	  })])])])]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.getStatus
	    },
	    slot: "footer"
	  }, [_vm._v("Update")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-edit-parking-group"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])])
	},staticRenderFns: []}

/***/ }),
/* 2273 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-vehicle-additional-status"
	  }, [(_vm.showToolTip) ? _c('div', {
	    staticClass: "row align-middle align-center"
	  }, [(_vm.item.door_open_status) ? _c('tooltip', {
	    staticClass: "has-tip",
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Door: ' + _vm.item.door_open_status
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-exclamation fa-lg",
	    class: _vm.status(_vm.item.door_open_status),
	    attrs: {
	      "id": "door"
	    }
	  })]) : _vm._e(), (_vm.item.ev_plug_status) ? _c('tooltip', {
	    staticClass: "has-tip",
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'ev_plug_status: ' + _vm.item.ev_plug_status
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-plug fa-lg",
	    class: _vm.status(_vm.item.ev_plug_status)
	  })]) : _vm._e(), (_vm.item.key_status) ? _c('tooltip', {
	    staticClass: "has-tip",
	    attrs: {
	      "open": true,
	      "tip": 'key_status: ' + _vm.item.key_status
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-key fa-lg",
	    class: _vm.status(_vm.item.key_status)
	  })]) : _vm._e(), (_vm.item.immobilizer_status) ? _c('tooltip', {
	    staticClass: "has-tip",
	    attrs: {
	      "open": true,
	      "tip": 'immo_status: ' + _vm.item.immobilizer_status
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-link fa-lg",
	    class: _vm.status(_vm.item.immobilizer_status)
	  })]) : _vm._e()], 1) : _c('div', {
	    staticClass: "row align-middle align-center"
	  }, [_c('span', {
	    staticClass: "fa fa-exclamation fa-lg",
	    class: _vm.status(_vm.item.door_open_status)
	  }), _c('span', {
	    staticClass: "fa fa-plug fa-lg",
	    class: _vm.status(_vm.item.ev_plug_status)
	  }), _c('span', {
	    staticClass: "fa fa-key fa-lg",
	    class: _vm.status(_vm.item.key_status)
	  }), _c('span', {
	    staticClass: "fa fa-link fa-lg",
	    class: _vm.status(_vm.item.immobilizer_status)
	  }), (_vm.item.battery_voltage) ? _c('span', [_vm._v(" " + _vm._s(_vm.item.battery_voltage) + "V")]) : _vm._e()]), (_vm.item.statuses) ? [_c('div', {
	    staticClass: "row align-middle align-center text-center"
	  }, _vm._l((_vm.item.statuses), function(value, key) {
	    return _c('tooltip', {
	      staticClass: "has-tip",
	      attrs: {
	        "tip": (key + ": " + value)
	      }
	    }, [_c('mdi-icon', {
	      class: _vm.status(value),
	      attrs: {
	        "name": _vm.getName(key, value),
	        "show-name": false
	      }
	    }, [_c('small', [_vm._v(_vm._s(key) + ": " + _vm._s(value))])])], 1)
	  }), 1)] : _vm._e(), (_vm.item.battery_voltage && _vm.showToolTip) ? _c('span', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.item.battery_voltage) + "V")]) : _vm._e()], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2274 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reject-driver-request-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.start,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("Start")]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.end,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("End")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2275 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item.deleted_at === null) ? _c('div', {
	    staticClass: "component-reject-driver-request-buttons"
	  }, [_c('CreateBookingFromReservationRequest', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _c('UpdateDriverReservationRequestStatus', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.reject,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("Delete request")])], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle",
	    on: {
	      "click": _vm.bulletsClicked
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-ellipsis-v fa-2x"
	  })]) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns shrink"
	  }, [_vm._t("header_left")], 2), _c('div', {
	    staticClass: "columns"
	  }, [_vm._t("header")], 2), _c('div', {
	    staticClass: "columns shrink"
	  }, [_vm._t("header_right")], 2)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_vm._t("default")], 2)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns shrink"
	  }, [_vm._t("footer_left")], 2), _c('div', {
	    staticClass: "columns"
	  }, [_vm._t("footer")], 2), _c('div', {
	    staticClass: "columns shrink"
	  }, [_vm._t("footer_right")], 2)])]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle",
	    on: {
	      "click": _vm.actionClicked
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2277 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-update-driver-reservation-requests"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ModalReveal', {
	    ref: _vm.modal
	  }, [_c('a', {
	    attrs: {
	      "slot": "trigger"
	    },
	    on: {
	      "click": _vm.search
	    },
	    slot: "trigger"
	  }, [_vm._v("Update status")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('Driver', {
	    attrs: {
	      "item": _vm.item.driver,
	      "type": "driver-card"
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Dates")]), _c('div', [_vm._v("From: " + _vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMM YYYY HH:mm')) + " - " + _vm._s(_vm.item.pick_up.name))]), _c('div', [_vm._v("To: " + _vm._s(_vm.$dateFormat(_vm.item.end, 'DD MMM YYYY HH:mm')) + "  - " + _vm._s(_vm.item.drop_off.name))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Passengers")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.flags.passengers))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Offroad")]), _c('span', {
	    staticClass: "fa",
	    class: {
	      "offroad": _vm.item.flags.offroad, "fa-times": !_vm.item.flags.offroad, "fa-check": _vm.item.flags.offroad
	    }
	  })])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Notes")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.notes))])])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Select status")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.status),
	      expression: "body.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', [_vm._v("NEW")]), _c('option', [_vm._v("WAITING")]), _c('option', [_vm._v("ACCEPTED")]), _c('option', [_vm._v("REJECTED")])]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.updateStatus
	    }
	  }, [_vm._v("Update")])], 1)])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2278 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-configuration row column"
	  }, [_c('accordion', _vm._l((_vm.conf), function(section, i) {
	    return _c('accordion-item', {
	      attrs: {
	        "title": i
	      }
	    }, _vm._l((section), function(c, ic) {
	      return _c('configuration-item', {
	        attrs: {
	          "item": c,
	          "itemKey": ic
	        },
	        on: {
	          "updateItem": _vm.updateItem
	        }
	      })
	    }), 1)
	  }), 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2279 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-backoffice-plan"
	  }, [(_vm.$is('plan-data')) ? _c('div', {
	    staticClass: "plan-data"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('strong', [_vm._v("Plan Details")]), _c('h2', [_vm._v(_vm._s(_vm.item.name))]), _c('p', [_vm._v(_vm._s(_vm.item.descriptions))])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('strong', [_vm._v("Duration")]), _c('h3', [_vm._v(_vm._s(_vm.item.duration) + " Days")])]), _vm._m(0), _vm._m(1)])]) : _vm._e(), (_vm.$is('listing')) ? _c('div', {
	    staticClass: "plan-list"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card4', {
	    attrs: {
	      "showAction": true
	    }
	  }, [_c('div', {
	    staticClass: "field-plan-name",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "field-booking-mode",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.booking_mode))])]), _c('div', {
	    staticClass: "field-plan-cost",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.item.cost))])]), _c('div', {
	    staticClass: "field-plan-status",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'plan',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])], 1)])]) : _vm._e()]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns"
	  }, [_c('span', [_c('strong', [_vm._v("Min Driving Price")]), _c('h3', [_vm._v("--")])]), _c('span', [_c('strong', [_vm._v("Max Driving Price")]), _c('h3', [_vm._v("--")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns"
	  }, [_c('span', [_c('strong', [_vm._v("Min Reserv. Price")]), _c('h3', [_vm._v("--")])]), _c('span', [_c('strong', [_vm._v("Max Reserv. Price")]), _c('h3', [_vm._v("--")])])])
	}]}

/***/ }),
/* 2280 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-plan-configuration"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "column row"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Rate configuration")])]), _c('div', {
	    staticClass: "tabs-inner-content callout"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column large-4"
	  }, [_c('label', [_vm._v("Inherited reservation rate"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.inherited_reservation_rate_id),
	      expression: "body.inherited_reservation_rate_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "inherited_reservation_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Not inherited")]), _vm._l((_vm.available), function(rate) {
	    return _c('option', {
	      domProps: {
	        "value": rate.id
	      }
	    }, [_vm._v(_vm._s(rate.name))])
	  })], 2)]), _c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [(_vm.loaded) ? _c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.translatable.description,
	      "label": "Description"
	    },
	    model: {
	      value: (_vm.body.description),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "description", $$v)
	      },
	      expression: "body.description"
	    }
	  }) : _vm._e(), (_vm.loaded) ? _c('Editor', {
	    model: {
	      value: (_vm.body.description),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "description", $$v)
	      },
	      expression: "body.description"
	    }
	  }) : _vm._e()], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Configuration")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.config),
	      expression: "body.config"
	    }],
	    attrs: {
	      "rows": "25"
	    },
	    domProps: {
	      "value": (_vm.body.config)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "config", $event.target.value)
	      }
	    }
	  })])]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2281 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "components-backoffice-parking-lot-zones"
	  }, [_c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('google-map', {
	    ref: "map",
	    staticStyle: {
	      "height": "200px"
	    },
	    attrs: {
	      "searchBar": true,
	      "mapTypeId": 'roadmap',
	      "mapTypeControl": true,
	      "api-key": _vm.mapsApiKey,
	      "center": _vm.mapCenter,
	      "zoom": 12
	    }
	  }, [(_vm.item.allowed_zone) ? _c('div', _vm._l((_vm.item.allowed_zone.poly), function(allowed) {
	    return _c('google-map-polygon', {
	      attrs: {
	        "positions": allowed,
	        "color": "green",
	        "fillColor": "green"
	      }
	    })
	  }), 1) : _vm._e(), (_vm.item.forbidden_zone) ? _c('div', _vm._l((_vm.item.forbidden_zone.poly), function(forbidden) {
	    return (_vm.item.forbidden_zone !== null) ? _c('google-map-polygon', {
	      attrs: {
	        "positions": forbidden
	      }
	    }) : _vm._e()
	  }), 1) : _vm._e(), (_vm.item.undesiderable_zone) ? _c('div', _vm._l((_vm.item.undesiderable_zone.poly), function(undesiderable) {
	    return (_vm.item.undesiderable_zone) ? _c('google-map-polygon', {
	      attrs: {
	        "positions": undesiderable,
	        "color": "yellow",
	        "fillColor": "yellow"
	      }
	    }) : _vm._e()
	  }), 1) : _vm._e()]) : _vm._e()], 1)], 1) : _c('loading-spinner')
	},staticRenderFns: []}

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-smart-edit card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, _vm._l((_vm.mutableItem), function(item, index) {
	    return _c('div', {
	      staticClass: "field"
	    }, [_c('smart-edit-field', {
	      attrs: {
	        "name": index,
	        "options": _vm.options
	      },
	      model: {
	        value: (_vm.mutableItem[index]),
	        callback: function($$v) {
	          _vm.$set(_vm.mutableItem, index, $$v)
	        },
	        expression: "mutableItem[index]"
	      }
	    })], 1)
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('div', {
	    staticClass: "row column card p-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Parking Groups"), _c('SelectizeParkingGroup', {
	    ref: "select",
	    attrs: {
	      "maxItems": null
	    },
	    on: {
	      "optionSelected": _vm.add,
	      "optionRemoved": _vm.remove
	    }
	  })], 1), _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "componentType": "federationList",
	      "selectableList": true,
	      "resultsPerPage": 5
	    },
	    model: {
	      value: (_vm.selected.delete),
	      callback: function($$v) {
	        _vm.$set(_vm.selected, "delete", $$v)
	      },
	      expression: "selected.delete"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2284 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-client"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Client"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ModalReveal', {
	    ref: "editReveal"
	  }, [_c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "slot": "trigger",
	      "type": "button"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.code),
	      expression: "item.code"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "code", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Group"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.type),
	      expression: "item.type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.item, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', [_vm._v("PRIVATE")]), _c('option', [_vm._v("BUSINESS")]), _c('option', [_vm._v("MAINTENANCE")])])])])]), _c('div', {
	    staticClass: "row columns text-center"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.edit
	    }
	  }, [_vm._v("Update")])], 1)]), _c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-backoffice-vehicle-hardware"
	  }, [(_vm.$is('hardware-card')) ? _c('div', {
	    staticClass: "card card-section"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "columns shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-lg',
	      "position": 'top'
	    }
	  }, [_c('vehicle-hardware-action-buttons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "update": _vm.update
	    }
	  })], 1)], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('h3', [_vm._v("#VH" + _vm._s(_vm.item.id))]), _c('span', [_vm._v("Manifacturer")]), _c('h3', [_vm._v(_vm._s(_vm._f("manager")(_vm.item.manager)))]), _c('span', [_vm._v("Serial")]), _c('h3', [_vm._v(_vm._s(_vm.item.serial))])])])]) : _vm._e(), (_vm.$is('oneLook')) ? _c('div', {
	    staticClass: "one-look"
	  }, [_c('span', [_vm._v("Hardware Serial")]), _c('span', [_vm._v(_vm._s(_vm.item.serial))])]) : _vm._e(), (_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card3', [_c('div', {
	    staticClass: "field-vehicle-hardware",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("VH-" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Serial " + _vm._s(_vm.item.serial))])]), _c('div', {
	    staticClass: "field-vehicle-serial",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "field-label"
	  }, [_vm._v("Manager")]), _c('div', {
	    staticClass: "field-value"
	  }, [_c('strong', [_vm._v(_vm._s(_vm._f("manager")(_vm.item.manager)))])])])])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns"
	  }, [_c('span', [_vm._v("Hardware Information")])])
	}]}

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-note-list row column"
	  }, [_c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.loadZones
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-client-credit-note"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns p-3"
	  }, [_c('RefundableRecords', {
	    staticClass: "text-center",
	    attrs: {
	      "data-loader": _vm.dataLoader,
	      "selected": _vm.selected
	    },
	    on: {
	      "select": _vm.mapRecords
	    }
	  }), _vm._l((_vm.body.records), function(record, index) {
	    return [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "columns"
	    }, [_c('BackofficeWalletRecord', {
	      attrs: {
	        "item": _vm.findRecord(record.id),
	        "type": "multi-wallet"
	      }
	    })], 1), _c('div', {
	      staticClass: "columns"
	    }, [_c('label', [_vm._v("Type"), (_vm.body.records[index].type === 'EXACT_AMOUNT') ? _c('div', {
	      staticClass: "help-text"
	    }, [_vm._v("Amount should have be billed")]) : _vm._e(), (_vm.body.records[index].type === 'DISCOUNT') ? _c('div', {
	      staticClass: "help-text"
	    }, [_vm._v("Discount paid amount")]) : _vm._e(), _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.body.records[index].type),
	        expression: "body.records[index].type"
	      }],
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(_vm.body.records[index], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, [_c('option', {
	      attrs: {
	        "value": "EXACT_AMOUNT"
	      }
	    }, [_vm._v("Exact amount")]), _c('option', {
	      attrs: {
	        "value": "DISCOUNT"
	      }
	    }, [_vm._v("Discount")])])]), _c('label', [_vm._v("Amount vat included"), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.body.records[index].amount),
	        expression: "body.records[index].amount"
	      }],
	      attrs: {
	        "type": "number",
	        "min": "0"
	      },
	      domProps: {
	        "value": (_vm.body.records[index].amount)
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.body.records[index], "amount", $event.target.value)
	        }, function($event) {
	          return _vm.checkValue($event, record.id)
	        }]
	      }
	    })]), _c('div', {
	      staticClass: "row text-center"
	    }, _vm._l((_vm.getRecordAmount(_vm.body.records[index])), function(value, key) {
	      return _c('div', {
	        staticClass: "column"
	      }, [_c('label', [_vm._v(_vm._s(key.replace("_", " ")))]), _c('h2', [_vm._v(_vm._s(_vm.$priceWithcurrency(value)))])])
	    }), 0), (_vm.findRecord(record.id).invoice.document_total === 0) ? _c('div', {
	      staticClass: "row"
	    }, [_vm._m(0, true)]) : _vm._e()])]), _c('hr')]
	  }), (Object.keys(_vm.body.records).length) ? [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column large-4"
	  }, [_c('label', [_vm._v("Reason"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reason),
	      expression: "body.reason"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "reason", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Emit as PROFORMA"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.emit_as_proforma),
	      expression: "body.emit_as_proforma"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.body.emit_as_proforma) ? _vm._i(_vm.body.emit_as_proforma, null) > -1 : (_vm.body.emit_as_proforma)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.body.emit_as_proforma,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.body, "emit_as_proforma", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.body, "emit_as_proforma", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.body, "emit_as_proforma", $$c)
	        }
	      }, function($event) {
	        _vm.body.emit_as_proforma ? _vm.body.refund_on_gateway = false : _vm.body.emit_as_proforma
	      }]
	    }
	  })]), _c('label', [_vm._v("Refund on gateway"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.refund_on_gateway),
	      expression: "body.refund_on_gateway"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.body.emit_as_proforma
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.body.refund_on_gateway) ? _vm._i(_vm.body.refund_on_gateway, null) > -1 : (_vm.body.refund_on_gateway)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.body.refund_on_gateway,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.body, "refund_on_gateway", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.body, "refund_on_gateway", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.body, "refund_on_gateway", $$c)
	        }
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column text-right mr-3"
	  }, [_c('h2', [_vm._v("Total amount: " + _vm._s(_vm.$priceWithcurrency(_vm.getSummary.toFixed(2))))]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.emit,
	      "confirm": true
	    }
	  }, [_vm._v("Emit "), (_vm.body.emit_as_proforma) ? _c('span', [_vm._v("as Proforma")]) : _c('span', [_vm._v("as Credit note")])])], 1)])] : _vm._e()], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column"
	  }, [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("Can be only refunded as PAID credit")])])
	}]}

/***/ }),
/* 2289 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-vehicle-slot"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 6
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('vehicle-slot-buttons', {
	    attrs: {
	      "vehicle": _vm.item
	    }
	  })], 1)], 1), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'vehicle-image'
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'vehicle-id'
	    },
	    slot: "n2"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'vehicle-brand-and-lot'
	    },
	    slot: "n2"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'vehicle-plate'
	    },
	    slot: "n3"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'vehicle-category'
	    },
	    slot: "n4"
	  }), (_vm.item.segment) ? _c('template', {
	    slot: "n4"
	  }, [_c('div', {
	    staticClass: "field-segment"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Segment")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("SG" + _vm._s(_vm.item.segment.id) + " " + _vm._s(_vm.item.segment.name))])])]) : _vm._e(), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'vehicle-lot'
	    },
	    slot: "n5"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'vehicle-status'
	    },
	    slot: "n6"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'vehicle-additional-status'
	    },
	    slot: "n6"
	  }), _c('div', {
	    staticClass: "pl-2",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'vehicle',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 2)], 1)]) : _vm._e(), (_vm.$is('maintenance')) ? _c('div', {
	    staticClass: "maintenance"
	  }, [_c('vehicle-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'vehicle-status'
	    }
	  }), _c('vehicle-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'vehicle-additional-status'
	    }
	  })], 1) : _vm._e(), (_vm.$is('oneLook')) ? _c('div', {
	    staticClass: "one-look"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'vehicle',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('router-link', {
	    staticClass: "hollow button secondary small",
	    attrs: {
	      "to": {
	        name: 'vehicle',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.item.plate))])], 1) : _vm._e(), (_vm.$is('asset-management-list')) ? _c('div', {
	    staticClass: "asset-management-list"
	  }, [_c('div', {
	    staticClass: "vehicle-id-and-name"
	  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model) + " (V" + _vm._s(_vm.item.id) + ")")]), _c('vehicle-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'vehicle-plate'
	    }
	  })], 1) : _vm._e(), (_vm.$is('category-listing')) ? _c('div', {
	    staticClass: "category-listing"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 4
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('vehicle-slot-buttons', {
	    attrs: {
	      "vehicle": _vm.item
	    }
	  })], 1)], 1), _c('img', {
	    attrs: {
	      "slot": "n1",
	      "src": _vm.item.picture_external,
	      "width": "100"
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'vehicle-id'
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'vehicle-brand'
	    },
	    slot: "n2"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'vehicle-plate'
	    },
	    slot: "n2"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'vehicle-lot'
	    },
	    slot: "n3"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'vehicle-status'
	    },
	    slot: "n4"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'vehicle',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1) : _vm._e(), (_vm.$is('fleet-map')) ? _c('div', {
	    staticClass: "fleet-map"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": false,
	      "showAction": true,
	      "columns": 5
	    }
	  }, [_c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'vehicle-brand'
	    },
	    slot: "n1"
	  }), _c('div', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('span', [_c('img', {
	    attrs: {
	      "src": _vm.item.picture_external,
	      "width": "100"
	    }
	  })])]), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'vehicle-lot'
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'vehicle-plate'
	    },
	    slot: "n2"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'vehicle-fuel-type'
	    },
	    slot: "n3"
	  }), _c('vehicle-status', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "showToolTip": false
	    },
	    slot: "n4"
	  }), _c('vehicle-additional-status', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "showToolTip": false
	    },
	    slot: "n4"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'vehicle',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1) : _vm._e(), (_vm.$is('compact-card')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }), _c('div', {
	    staticClass: "columns shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-lg',
	      "position": 'bottom'
	    }
	  }, [_c('vehicle-slot-buttons', {
	    attrs: {
	      "vehicle": _vm.item
	    }
	  })], 1)], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12 large-6"
	  }, [_c('h2', {
	    staticClass: "vehicle-info"
	  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'vehicle',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('h1', [_vm._v(_vm._s(_vm.item.plate))])]), (_vm.item.parking_lot.id) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'parkingLot',
	        params: {
	          id: _vm.item.parking_lot.id
	        }
	      }
	    }
	  }, [_c('h4', [_vm._v("PL" + _vm._s(_vm.item.parking_lot.id) + " " + _vm._s(_vm.item.parking_lot.name))])]) : _vm._e(), _c('h4', [_vm._v("VS" + _vm._s(_vm.item.slot_id) + " " + _vm._s(_vm.item.vehicle_slot_address))])], 1), _c('div', {
	    staticClass: "column small-12 large-6"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.item.picture_external
	    }
	  }), _c('vehicle-status', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _c('div', {
	    staticClass: "text-center"
	  }, [_vm._t("default")], 2)], 1)])])]) : _vm._e(), (_vm.$is('vehicle-card')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('p', [_vm._v("Vehicle Information")]), _c('p', [_vm._v("CREATED AT " + _vm._s(_vm.item.created_at))]), (_vm.item.archived_at) ? _c('span', [_c('p', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("ARCHIVED AT " + _vm._s(_vm.item.archived_at))]), _c('p', [_vm._v("TIME IN ASSET " + _vm._s(_vm.$dateDifference(_vm.item.created_at, _vm.item.archived_at)))])]) : _vm._e()]), _c('div', {
	    staticClass: "columns shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-lg',
	      "position": 'bottom'
	    }
	  }, [_c('vehicle-slot-buttons', {
	    attrs: {
	      "vehicle": _vm.item
	    }
	  })], 1)], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12"
	  }, [_c('h2', {
	    staticClass: "vehicle-info"
	  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('h2', [_vm._v(_vm._s(_vm.item.color) + " - " + _vm._s(_vm.item.category.name))]), _c('small', [_vm._v("VS" + _vm._s(_vm.item.slot_id) + " - " + _vm._s(_vm.item.slot_name) + " - " + _vm._s(_vm.item.vehicle_slot_address))]), (_vm.item.segment) ? _c('small', [_vm._v("SG" + _vm._s(_vm.item.segment.id) + " " + _vm._s(_vm.item.segment.name))]) : _vm._e(), _c('div', {
	    staticClass: "test",
	    staticStyle: {
	      "position": "relative"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.item.picture_external
	    }
	  }), _c('div', {
	    staticClass: "text-center"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'vehicle',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('h1', [_vm._v(_vm._s(_vm.item.plate))])])], 1), _c('vehicle-status', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _c('vehicle-additional-status', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)])])])]) : _vm._e(), (_vm.$is('parking-lot-assignment')) ? _c('div', {
	    staticClass: "card card-section"
	  }, [_c('span', [_vm._v("Parking lot assignment")]), (_vm.item.parking_lot.id) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'parkingLot',
	        params: {
	          id: _vm.item.parking_lot.id
	        }
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.item.parking_lot.name))])]) : _vm._e()], 1) : _vm._e(), (_vm.$is('replace-listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 7
	    }
	  }, [_c('dropdown', {
	    attrs: {
	      "slot": "actionBullets",
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    },
	    slot: "actionBullets"
	  }, [_vm._t("actionBullets")], 2), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'vehicle-image'
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'vehicle-id'
	    },
	    slot: "n2"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'vehicle-brand-and-lot'
	    },
	    slot: "n2"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'vehicle-plate'
	    },
	    slot: "n3"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'vehicle-fuel-type'
	    },
	    slot: "n4"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'vehicle-category'
	    },
	    slot: "n5"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'vehicle-lot'
	    },
	    slot: "n6"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n7",
	      "item": _vm.item,
	      "fieldName": 'vehicle-status'
	    },
	    slot: "n7"
	  })], 1)], 1)]) : _vm._e(), (_vm.$is('quick-booking')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 4
	    }
	  }, [_c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'vehicle-brand'
	    },
	    slot: "n1"
	  }), _c('div', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('span', [_c('img', {
	    attrs: {
	      "src": _vm.item.picture_external,
	      "width": "100"
	    }
	  })])]), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'vehicle-lot'
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'vehicle-plate'
	    },
	    slot: "n2"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'vehicle-fuel-type'
	    },
	    slot: "n3"
	  }), _c('vehicle-status', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "showToolTip": false
	    },
	    slot: "n4"
	  }), _c('vehicle-additional-status', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "showToolTip": false
	    },
	    slot: "n4"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('bookVehicle', _vm.item)
	      }
	    }
	  }, [_vm._v("Book")])])], 1)], 1)]) : _vm._e(), (_vm.$is('search-result')) ? _c('div', {
	    staticClass: "row vehicle-card-row"
	  }, [_c('div', {
	    staticClass: "columns small-10 text-center vehicle-card"
	  }, [_c('div', {
	    staticClass: "image",
	    staticStyle: {
	      "max-width": "12em",
	      "margin": "0 auto"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.item.picture_external
	    }
	  })]), _c('h2', [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), (_vm.item.distance) ? _c('div', {
	    staticClass: "distance"
	  }, [_c('p', [_vm._v("distance: " + _vm._s(_vm.item.distance) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])]) : _vm._e(), _c('vehicle-fields', {
	    staticClass: "vehicle-card-fields",
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'vehicle-plate'
	    }
	  }), _c('vehicle-status', {
	    staticClass: "vehicle-card-fields",
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "showToolTip": false
	    },
	    slot: "n4"
	  }), _c('vehicle-additional-status', {
	    staticClass: "vehicle-card-fields",
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "showToolTip": false
	    },
	    slot: "n4"
	  }), _vm._t("default", [_c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('bookVehicle', _vm.item)
	      }
	    }
	  }, [_vm._v("Book")])])], 2)]) : _vm._e(), (_vm.$is('federationList')) ? _c('div', {
	    staticClass: "inner-content federation-list"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('vehicle-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'vehicle-id'
	    }
	  }), _c('vehicle-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'vehicle-brand-and-lot'
	    }
	  })], 1), _c('vehicle-fields', {
	    staticClass: "column",
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'vehicle-category'
	    }
	  }), _c('vehicle-fields', {
	    staticClass: "column",
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'vehicle-plate'
	    }
	  }), _c('vehicle-fields', {
	    staticClass: "column",
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'vehicle-lot'
	    }
	  })], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-map card",
	    attrs: {
	      "id": "fullscreenme"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row full-width"
	  }, [_c('div', {
	    staticClass: "column p-0"
	  }, [_c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('google-map', {
	    ref: "map",
	    attrs: {
	      "searchBar": false,
	      "api-key": _vm.mapsAPI,
	      "center": _vm.mapCenter,
	      "zoom": 13,
	      "mapTypeId": 'roadmap',
	      "scrollwheel": false,
	      "zoomControl": false,
	      "mapTypeControl": true,
	      "listenForClick": true
	    }
	  }, [_vm._l((_vm.zones['allowed']), function(allowed) {
	    return _c('div', {
	      staticClass: "allowed"
	    }, _vm._l((allowed.poly), function(poly) {
	      return _c('google-map-polygon', {
	        attrs: {
	          "positions": poly,
	          "color": "green",
	          "fillColor": "green"
	        }
	      })
	    }), 1)
	  }), _vm._l((_vm.zones['forbidden']), function(forbidden) {
	    return _c('div', {
	      staticClass: "forbidden"
	    }, _vm._l((forbidden.poly), function(poly) {
	      return _c('google-map-polygon', {
	        attrs: {
	          "positions": poly,
	          "color": "red",
	          "fillColor": "red"
	        }
	      })
	    }), 1)
	  }), _vm._l((_vm.zones['undesirable']), function(undesirable) {
	    return _c('div', {
	      staticClass: "undesirable"
	    }, _vm._l((undesirable.poly), function(poly) {
	      return _c('google-map-polygon', {
	        attrs: {
	          "positions": poly,
	          "color": "yellow",
	          "fillColor": "yellow"
	        }
	      })
	    }), 1)
	  }), _c('google-map-marker-cluster', {
	    ref: "cluster"
	  }, _vm._l((_vm.reservations), function(reservation, index) {
	    return _c('google-map-marker', {
	      key: reservation.id,
	      ref: 'marker-' + reservation.id,
	      refInFor: true,
	      attrs: {
	        "icon": _vm.vehicleInRange(reservation.vehicle.in_range),
	        "position": {
	          lat: reservation.vehicle.position.latitude,
	          lng: reservation.vehicle.position.longitude
	        },
	        "title": reservation.vehicle.model,
	        "label": reservation.vehicle.model,
	        "labelOrigin": [15, 30]
	      }
	    }, [_c('reservation', {
	      attrs: {
	        "item": reservation,
	        "type": "sentinel"
	      }
	    })], 1)
	  }), 1)], 2) : _vm._e()], 1)], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-3"
	  }, [_c('label', [_vm._v("Sentinellable"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.sentinellable),
	      expression: "search.sentinellable"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "sentinellable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("No filter")]), _c('option', {
	    attrs: {
	      "value": "App\\Models\\Client"
	    }
	  }, [_vm._v("Client")]), _c('option', {
	    attrs: {
	      "value": "App\\Models\\Reservation"
	    }
	  }, [_vm._v("Reservation")])])])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Go Full")]), _c('div', {
	    staticClass: "button",
	    on: {
	      "click": _vm.fullScreen
	    }
	  }, [_vm._v("Full screen")])])]), _c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "search": _vm.search,
	      "data-loader": _vm.loadAlarms
	    }
	  })], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 2291 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-note"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 5
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('CommonCostButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("CC" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Reason")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.reason))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Vat " + _vm._s(_vm.item.tax * 100) + "%")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount.toFixed(2))))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v("Total Amount")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(_vm.item.amount, _vm.item.tax).toFixed(2))))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v("Type")]), (_vm.item.common_cost_type_id) ? _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v("CT" + _vm._s(_vm.item.common_cost_type_id))]) : _vm._e(), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v(_vm._s(_vm.item.common_cost_type_name))])])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-confirm-dialog"
	  }, [_c('div', {
	    staticClass: "reveal small",
	    attrs: {
	      "id": _vm.id
	    }
	  }, [_c('h2', [_vm._v("  " + _vm._s(_vm.title))]), _c('p', {
	    staticClass: "lead"
	  }, [_vm._v("  " + _vm._s(_vm.message))]), _c('div', {
	    staticClass: "content"
	  }, [_vm._t("default")], 2), _c('button', {
	    staticClass: "button success yes",
	    attrs: {
	      "data-close": ""
	    },
	    on: {
	      "click": _vm.successClick
	    }
	  }, [_vm._v("Yes")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "data-close": ""
	    }
	  }, [_vm._v("No")])])])
	},staticRenderFns: []}

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-client-transactions"
	  }, [_c('div', {
	    staticClass: "action-bar"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "action"
	  }, [_c('transaction-list-form', {
	    attrs: {
	      "type": 'entity-filter'
	    },
	    on: {
	      "filterTransactions": _vm.filterTransactions
	    }
	  })], 1)]), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('base-list', {
	    attrs: {
	      "dataLoader": _vm.dataLoader,
	      "component": _vm.component,
	      "search": _vm.search,
	      "componentType": "client-list"
	    }
	  }, [_c('header-columns', {
	    attrs: {
	      "slot": "before",
	      "columns": _vm.headers
	    },
	    slot: "before"
	  })], 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Transactions")])])
	}]}

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: _vm.componentId
	  }, [_c('button', {
	    staticClass: "button small",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Vehicles")]), _c('h2', [_vm._v("Segment SG" + _vm._s(_vm.segment.id) + " " + _vm._s(_vm.segment.name))]), _c('label', [_vm._v("Vehicles")]), _c('SelectizeVehicle', {
	    ref: "select",
	    attrs: {
	      "maxItems": null
	    },
	    on: {
	      "optionSelected": _vm.add
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "disabled": _vm.selected.delete.length || !_vm.selected.add.length,
	      "action": _vm.saveVehicles
	    }
	  }, [_vm._v("Add")]), _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "componentType": "federationList",
	      "dataLoader": _vm.dataLoader,
	      "selectableList": true,
	      "resultsPerPage": 5
	    },
	    model: {
	      value: (_vm.selected.delete),
	      callback: function($$v) {
	        _vm.$set(_vm.selected, "delete", $$v)
	      },
	      expression: "selected.delete"
	    }
	  }), _c('template', {
	    slot: "footer"
	  }, [_c('ActionButton', {
	    attrs: {
	      "disabled": _vm.selected.delete.length === 0,
	      "action": _vm.deleteVehicles
	    }
	  }, [_vm._v("Delete"), (_vm.selected.delete.length) ? _c('span', [_vm._v(" " + _vm._s(_vm.selected.delete.length))]) : _vm._e()])], 1)], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2295 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-offset-11 text-right"
	  }, [_c('common-cost-button-modal', {
	    on: {
	      "itemUpdated": _vm.itemUpdated
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2296 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "componend-mdi-icon"
	  }, [(_vm.icon) ? [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('path', {
	    attrs: {
	      "fill": "currentColor",
	      "d": _vm.icon
	    }
	  })]), (_vm.showName) ? _c('div', [_vm._v(_vm._s(_vm.name))]) : _vm._e()] : [_vm._t("default")]], 2)
	},staticRenderFns: []}

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-smart-edit"
	  }, [_c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2298 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-backoffice-transactions"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 6
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'transaction-id'
	    },
	    slot: "n1"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'transaction-date'
	    },
	    slot: "n1"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'transaction-client'
	    },
	    slot: "n2"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'transaction-payment-method'
	    },
	    slot: "n3"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'invoice-link'
	    },
	    slot: "n4"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'transaction-amount'
	    },
	    slot: "n5"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'transaction-status'
	    },
	    slot: "n6"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n7",
	      "item": _vm.item,
	      "fieldName": 'transaction-date'
	    },
	    slot: "n7"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'transaction',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1)]) : _vm._e(), (_vm.$is('oneLook')) ? _c('div', {
	    staticClass: "one-look"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'transaction',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("TR" + _vm._s(_vm.item.id))])], 1) : _vm._e(), (_vm.$is('client-list')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 5
	    }
	  }, [_c('transaction-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'transaction-id'
	    },
	    slot: "n1"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'transaction-date'
	    },
	    slot: "n1"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'transaction-payment-method'
	    },
	    slot: "n2"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'invoice-link'
	    },
	    slot: "n3"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'transaction-amount'
	    },
	    slot: "n4"
	  }), _c('transaction-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'transaction-status'
	    },
	    slot: "n5"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'transaction',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1)]) : _vm._e(), (_vm.$is('detail')) ? _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column card mr-4 p-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Transaction")]), _c('div', [_vm._v("TR" + _vm._s(_vm.item.id) + "  "), _c('strong', [_vm._v(_vm._s(_vm.item.status))]), _c('br'), _c('small', [_vm._v(_vm._s(_vm.item.response.message))])]), _c('div', [_vm._v("Gateway id  "), _c('a', {
	    on: {
	      "click": _vm.viewOnGateway
	    }
	  }, [_vm._v(_vm._s(_vm.item.transaction_uid))])]), _c('div', {
	    staticClass: "field",
	    style: (_vm.item.amount < 0 ? 'color:#cc4b37' : '')
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount.toFixed(2))))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Client")]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.client_id
	        }
	      }
	    }
	  }, [(_vm.item.client_organization_name) ? _c('span', [_vm._v(_vm._s(_vm.item.client_organization_name))]) : _c('span', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])])], 1)])]), _c('div', {
	    staticClass: "column card mr-4 p-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Invoice")]), (_vm.item.invoice.id) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'invoice',
	        params: {
	          id: _vm.item.invoice.id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.invoice.type) + _vm._s(_vm.item.invoice_internal_id) + " (" + _vm._s(_vm.item.invoice_id) + ")")])]) : _vm._e()], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Payment Method")]), _c('span', [_vm._v("PM" + _vm._s(_vm.item.payment_method_id) + " " + _vm._s(_vm.item.payment_name))]), _c('div', [_vm._v(_vm._s(_vm.item.payment_method_provider))])])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns card mr-4 p-2"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('h2', [_vm._v("Raw response")]), _vm._l((_vm.getResponse), function(value, key) {
	    return _c('pre', [_vm._v(_vm._s(key) + " : " + _vm._s(value))])
	  })], 2)])])]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2299 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-logs"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('accordion', _vm._l((_vm.items), function(l) {
	    return _c('accordion-item', {
	      attrs: {
	        "title": _vm.$dateFormat(l.date.date, "DD-MM-YYYY HH:mm:ss") + ' | ' + l.action
	      }
	    }, [_c('log', {
	      attrs: {
	        "item": l
	      }
	    })], 1)
	  }), 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('h2', [_vm._v("Logs")])])
	}]}

/***/ }),
/* 2300 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-parkinglot-action-buttons"
	  }, [(_vm.entity) ? _c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "dropdown menu",
	    attrs: {
	      "data-dropdown-menu": ""
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#Item-1"
	    }
	  }, [_vm._v("Action")]), _c('ul', {
	    staticClass: "menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Edit")])]), _c('li', [_c('ModalReveal', [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Configuration")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entity.config),
	      expression: "entity.config"
	    }],
	    attrs: {
	      "rows": "10"
	    },
	    domProps: {
	      "value": (_vm.entity.config)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entity, "config", $event.target.value)
	      }
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)], 1)])])]) : (!_vm.entity && _vm.parkingLot) ? _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('div', {
	    staticClass: "small button alert",
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2301 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-registration"
	  }, [_c('form', {
	    on: {
	      "keyUp": _vm.driverLicenseUpdated
	    }
	  }, [_vm._m(0), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Document Type   "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('selectize-document-type', {
	    on: {
	      "optionSelected": _vm.selectDocumentType
	    }
	  })], 1)])]), (_vm.documentType) ? _c('div', {
	    staticClass: "document-fields"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.documentType.has_expiry) ? _c('div', {
	    staticClass: "small-12 large-2 columns"
	  }, [_c('label', [_vm._v("Expiry   "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('date-picker', {
	    model: {
	      value: (_vm.document.expiry_date),
	      callback: function($$v) {
	        _vm.$set(_vm.document, "expiry_date", $$v)
	      },
	      expression: "document.expiry_date"
	    }
	  })], 1)]) : _vm._e(), (_vm.documentType.has_emission) ? _c('div', {
	    staticClass: "small-12 large-2 columns"
	  }, [_c('label', [_vm._v("Issue date   "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('date-picker', {
	    model: {
	      value: (_vm.document.issue_date),
	      callback: function($$v) {
	        _vm.$set(_vm.document, "issue_date", $$v)
	      },
	      expression: "document.issue_date"
	    }
	  })], 1)]) : _vm._e(), (_vm.documentType.has_number) ? _c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Number   "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.document.number),
	      expression: "document.number"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.document.number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.document, "number", $event.target.value)
	      }
	    }
	  })], 1)]) : _vm._e()]), _c('div', {
	    staticClass: "row"
	  }, [(_vm.documentType.has_issuer) ? _c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Issued by   "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.document.issuer),
	      expression: "document.issuer"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.document.issuer)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.document, "issuer", $event.target.value)
	      }
	    }
	  })], 1)]) : _vm._e(), (_vm.documentType.has_country) ? _c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Issue country   "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('selectize-country', {
	    on: {
	      "optionSelected": _vm.selectLicenseCountry
	    }
	  })], 1)]) : _vm._e()]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, _vm._l((_vm.documentType.attachment_views), function(attachment, index) {
	    return _c('div', {
	      staticClass: "upload"
	    }, [_c('label', [_vm._v("Upload " + _vm._s(attachment) + "  "), _c('tooltip', {
	      attrs: {
	        "open": true,
	        "position": 'right',
	        "tip": 'Document Upload Required'
	      }
	    }, [_c('span', {
	      staticClass: "fa fa-star"
	    })])], 1), _c('dropzone', {
	      attrs: {
	        "id": '#myVueDropzone' + index,
	        "url": _vm.dropzoneUrl
	      },
	      on: {
	        "vdropzone-success": function (file, response) {
	          _vm.uploaded(file, response, attachment)
	        }
	      }
	    })], 1)
	  }), 0)])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('h2', [_vm._v("Document")])])
	}]}

/***/ }),
/* 2302 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-toc"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "options": _vm.options,
	      "value-field": "id",
	      "selectedValue": _vm.selectedValue,
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Toc type"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2303 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-list-filter-form filter-form"
	  }, [_c('div', {
	    staticClass: "row",
	    class: {
	      'medium-unstack': _vm.rowUnstack
	    }
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.query),
	      expression: "search.query"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": (_vm.search.query)
	    },
	    on: {
	      "keyup": _vm.enterSubmit,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, "query", $event.target.value)
	      }
	    }
	  }), _c('span', {
	    staticClass: "input-group-label"
	  }, [_c('span', {
	    staticClass: "fa fa-search",
	    on: {
	      "click": _vm.filteredSearch
	    }
	  })])])]), (_vm.balance) ? _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.balance),
	      expression: "search.balance"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text",
	      "placeholder": "Balance filter"
	    },
	    domProps: {
	      "value": (_vm.search.balance)
	    },
	    on: {
	      "keyup": _vm.balanceSubmit,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, "balance", $event.target.value)
	      }
	    }
	  }), _c('span', {
	    staticClass: "input-group-label",
	    on: {
	      "click": _vm.balanceSearch
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-search"
	  })])])]) : _vm._e(), (_vm.actionButton) ? _c('div', {
	    staticClass: "columns"
	  }, [_c('a', {
	    staticClass: "fa fa-angle-double-down fa-2x"
	  })]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2304 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-reservation-rate",
	    class: _vm.item.status
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [(_vm.$is('listing')) ? _c('card3', {
	    staticClass: "add",
	    attrs: {
	      "showAction": true
	    }
	  }, [_c('dropdown', {
	    attrs: {
	      "slot": "actionBullets",
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    },
	    slot: "actionBullets"
	  }), _c('div', {
	    staticClass: "field",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("RR" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "field",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [(_vm.item.time_rate) ? [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Time cost: " + _vm._s(_vm.currency) + _vm._s(_vm.withVat(_vm.item.time_rate.time_cost)) + "/" + _vm._s(_vm.item.time_rate.time_cost_cycle) + "min")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Driving time cost: " + _vm._s(_vm.currency) + _vm._s(_vm.withVat(_vm.item.time_rate.driving_time_cost)) + "/" + _vm._s(_vm.item.time_rate.time_cost_cycle) + "min")])] : _vm._e()], 2), _c('div', {
	    staticClass: "field",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [(_vm.item.distance_rate) ? [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Distance cost")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.withVat(_vm.item.distance_rate.distance_cost)) + "/" + _vm._s(_vm.item.distance_rate.distance_cost_cycle) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])] : _vm._e()], 2), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'configuration-rate',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2305 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('GroupButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("G" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Policies: " + _vm._s(_vm.item.policies.length))]), (!_vm.item.global) ? _c('div', {
	    staticClass: "field"
	  }, [_vm._v("Drivers: " + _vm._s(_vm.item.drivers))]) : _c('div', {
	    staticClass: "field"
	  }, [_vm._v("Global group")])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2306 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-notification pm-notification"
	  }, [_c('div', {
	    staticClass: "notification",
	    class: {
	      success: (_vm.notification.style === 'success'), alert: (_vm.notification.style === 'alert'), warning: (_vm.notification.style === 'warning')
	    }
	  }, [_c('button', {
	    staticClass: "close-button",
	    attrs: {
	      "aria-label": "Close alert",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.removeNotification
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-times",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _c('small', [_vm._v(_vm._s(_vm.notification.code))]), _c('h4', [_c('strong', [_vm._v(_vm._s(_vm.notification.title))])]), (Array.isArray(_vm.notification.subtitle)) ? _vm._l((_vm.notification.subtitle), function(subtitle) {
	    return _c('div', {
	      staticClass: "subtitle"
	    }, [_vm._v(_vm._s(subtitle))])
	  }) : [_c('div', {
	    staticClass: "subtitle"
	  }, [_vm._v(_vm._s(_vm.notification.subtitle))])]], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2307 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-vehicle-slot"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card-n', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 4
	    }
	  }, [_c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item.vehicle,
	      "fieldName": 'vehicle-id'
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item.vehicle,
	      "fieldName": 'vehicle-brand-and-lot'
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item.vehicle,
	      "fieldName": 'vehicle-plate'
	    },
	    slot: "n1"
	  }), _c('div', {
	    staticClass: "cose",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("Code: " + _vm._s(_vm.item.code))]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v("Source: " + _vm._s(_vm.item.source))]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v("Description: " + _vm._s(_vm.item.description))]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v("Alarm at: " + _vm._s(_vm.item.alarm_at))])]), _c('vehicle-status', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item.vehicle,
	      "odometer": "odometer"
	    },
	    slot: "n3"
	  }), _c('div', {
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('a', {
	    staticClass: "fa fa-globe fa-2x",
	    attrs: {
	      "href": 'https://maps.google.com/?q=' + _vm.item.position.latitude + ',' + _vm.item.position.longitude,
	      "target": "_blank"
	    }
	  })])], 1)], 1)]) : _vm._e(), (_vm.$is('map')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card-n', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 4
	    }
	  }, [_c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item.vehicle,
	      "fieldName": 'vehicle-id'
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item.vehicle,
	      "fieldName": 'vehicle-brand-and-lot'
	    },
	    slot: "n1"
	  }), _c('vehicle-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item.vehicle,
	      "fieldName": 'vehicle-plate'
	    },
	    slot: "n2"
	  }), _c('div', {
	    staticClass: "cose",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("Code: " + _vm._s(_vm.item.code) + " " + _vm._s(_vm.item.source))]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v("Description: " + _vm._s(_vm.item.description))])]), _c('div', {
	    staticClass: "cose",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("Alarm at: " + _vm._s(_vm.item.alarm_at))])])], 1)], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2308 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: ("maintenance-" + _vm._uid),
	    attrs: {
	      "id": ("maintenance-" + _vm._uid)
	    },
	    on: {
	      "input": _vm.close
	    }
	  }, [(_vm.request) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    on: {
	      "click": _vm.open
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]) : _c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('h2', [_vm._v("Update intervention request " + _vm._s(_vm.request.id))]), _c('InterventionRequestForm', {
	    attrs: {
	      "sub-request": _vm.request.linked_intervention_request_id !== null,
	      "edit": true
	    },
	    model: {
	      value: (_vm.body),
	      callback: function($$v) {
	        _vm.body = $$v
	      },
	      expression: "body"
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close(false)
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2309 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "disabled": _vm.disabled,
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Operator"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2310 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-reporting reporting card"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('card7', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('reporting-action-buttons', {
	    attrs: {
	      "reporting": _vm.item
	    }
	  })], 1)], 1), _c('reporting-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'reporting-id'
	    },
	    slot: "n1"
	  }), _c('reporting-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'reporting-name'
	    },
	    slot: "n1"
	  }), _c('reporting-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'reporting-driver-info'
	    },
	    slot: "n2"
	  }), _c('reporting-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'reporting-location'
	    },
	    slot: "n3"
	  }), _c('reporting-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'reporting-vehicle'
	    },
	    slot: "n4"
	  }), _c('reporting-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'reporting-reported-at'
	    },
	    slot: "n5"
	  }), _c('reporting-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'reporting-updated-at'
	    },
	    slot: "n6"
	  }), _c('reporting-fields', {
	    attrs: {
	      "slot": "n7",
	      "item": _vm.item,
	      "fieldName": 'reporting-status'
	    },
	    slot: "n7"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reporting',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1) : _vm._e(), (_vm.$is('reservation')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('card-n', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('reporting-action-buttons', {
	    attrs: {
	      "reporting": _vm.item
	    }
	  })], 1)], 1), _c('reporting-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'reporting-id'
	    },
	    slot: "n1"
	  }), _c('reporting-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'reporting-name'
	    },
	    slot: "n1"
	  }), _c('reporting-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'reporting-reported-at'
	    },
	    slot: "n2"
	  }), _c('div', {
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reporting',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2311 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm.componentId,
	    ref: _vm.componentId
	  }, [(_vm.reservation !== null) ? _c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Request preauth")]) : _c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Amount"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.amount),
	      expression: "amount"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.amount = $event.target.value
	      }
	    }
	  })])])]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2312 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-commont-cost-type-action-buttons"
	  }, [_c('ModalReveal', [_c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "slot": "trigger",
	      "type": "button"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.name),
	      expression: "item.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.description),
	      expression: "item.description"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "description", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row columns text-center"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save")])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2313 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-driver-reservation-request"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('ChargingSessionButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("CS" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v("Port " + _vm._s(_vm.item.port))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("UUID")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.uuid))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Start")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.start))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("End")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.end))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Reservation")]), _c('div', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.reservation_id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v("R" + _vm._s(_vm.item.reservation_id))])])], 1)])])]) : _vm._e(), (_vm.$is('reservation')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('ChargingSessionButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("CS" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v("Port " + _vm._s(_vm.item.port))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("UUID")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.uuid))])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Start")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.start))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("End")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.end))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.status))])])])]) : _vm._e()])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2315 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm.key,
	    ref: _vm.componentId,
	    on: {
	      "input": _vm.closeInput
	    }
	  }, [_c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('h2', [_vm._v("Plan Details")]), _c('hr'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Plan Name")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.name),
	      expression: "plan.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plan.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.plan, "name", $event.target.value)
	      }
	    }
	  }), _c('label', [_vm._v("Title")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.title),
	      expression: "plan.title"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plan.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.plan, "title", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Duration (days)")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.duration),
	      expression: "plan.duration"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plan.duration)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.plan, "duration", $event.target.value)
	      }
	    }
	  }), _c('small', [_vm._v("The contractual commitment of the plan (days).")])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Subscription End"), _c('DatePicker', {
	    attrs: {
	      "initialDate": _vm.plan.subscription_end,
	      "pickTime": true,
	      "format": "yyyy-mm-dd",
	      "clearCb": function () {
	        _vm.plan.subscription_end = null
	      }
	    },
	    model: {
	      value: (_vm.plan.subscription_end),
	      callback: function($$v) {
	        _vm.$set(_vm.plan, "subscription_end", $$v)
	      },
	      expression: "plan.subscription_end"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Max Drivers")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.max_drivers),
	      expression: "plan.max_drivers"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plan.max_drivers)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.plan, "max_drivers", $event.target.value)
	      }
	    }
	  }), _c('label', [_vm._v("Status")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.status),
	      expression: "plan.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.plan, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', [_vm._v("AVAILABLE")]), _c('option', [_vm._v("UNAVAILABLE")]), _c('option', [_vm._v("DISABLED")])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Color"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.color),
	      expression: "plan.color"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plan.color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.plan, "color", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Notice"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.notice),
	      expression: "plan.notice"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plan.notice)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.plan, "notice", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row column"
	  }, [_c('label', [_vm._v("Toc")]), _c('SelectizeToc', {
	    attrs: {
	      "selectedValue": _vm.plan.toc_id
	    },
	    on: {
	      "optionSelected": _vm.setTocId,
	      "optionRemoved": function($event) {
	        _vm.plan.toc_id = null
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('h2', [_vm._v("Plan Costs")]), _c('hr'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Subscriptions can be renewed?  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.renewable),
	      expression: "plan.renewable"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.plan.renewable) ? _vm._i(_vm.plan.renewable, null) > -1 : (_vm.plan.renewable)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.plan.renewable,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.plan, "renewable", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.plan, "renewable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.plan, "renewable", $$c)
	        }
	      }
	    }
	  })]), _c('label', [_vm._v("Featured  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.featured),
	      expression: "plan.featured"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.plan.featured) ? _vm._i(_vm.plan.featured, null) > -1 : (_vm.plan.featured)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.plan.featured,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.plan, "featured", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.plan, "featured", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.plan, "featured", $$c)
	        }
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('VatAmountToggler', {
	    attrs: {
	      "label": "Cost",
	      "tax": _vm.configuration.commercial.commercial_vat_rate.value
	    },
	    model: {
	      value: (_vm.plan.cost),
	      callback: function($$v) {
	        _vm.$set(_vm.plan, "cost", $$v)
	      },
	      expression: "plan.cost"
	    }
	  })], 1), (_vm.plan.renewable) ? _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Billing Cycle (days)"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan.billing_cycle),
	      expression: "plan.billing_cycle"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plan.billing_cycle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.plan, "billing_cycle", $event.target.value)
	      }
	    }
	  })]), _c('small', [_vm._v("The frequency (days) with which the plan cost is charged")])]) : _vm._e()]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-6"
	  }, [_c('label', [_vm._v("Active From"), _c('DatePicker', {
	    attrs: {
	      "initialDate": _vm.plan.valid_from,
	      "pickTime": true,
	      "format": "yyyy-mm-dd hh:ii:ss",
	      "clearCb": function () {
	        _vm.plan.valid_from = null
	      }
	    },
	    model: {
	      value: (_vm.plan.valid_from),
	      callback: function($$v) {
	        _vm.$set(_vm.plan, "valid_from", $$v)
	      },
	      expression: "plan.valid_from"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns large-6"
	  }, [_c('label', [_vm._v("Active To"), _c('DatePicker', {
	    attrs: {
	      "initialDate": _vm.plan.valid_to,
	      "pickTime": true,
	      "format": "yyyy-mm-dd hh:ii:ss",
	      "clearCb": function () {
	        _vm.plan.valid_to = null
	      }
	    },
	    model: {
	      value: (_vm.plan.valid_to),
	      callback: function($$v) {
	        _vm.$set(_vm.plan, "valid_to", $$v)
	      },
	      expression: "plan.valid_to"
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row columns"
	  }), _c('div', {
	    staticClass: "row columns"
	  }, [_c('label', [_vm._v("Picture")]), _c('KeplerFileUpload', {
	    attrs: {
	      "selected-prefix": "plans",
	      "selected-visibility": "public",
	      "previewUrl": _vm.plan.picture
	    },
	    on: {
	      "sel": _vm.handleFileSelector
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Description")]), _c('Editor', {
	    attrs: {
	      "value": _vm.plan.description
	    },
	    model: {
	      value: (_vm.plan.description),
	      callback: function($$v) {
	        _vm.$set(_vm.plan, "description", $$v)
	      },
	      expression: "plan.description"
	    }
	  })], 1)]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2316 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm.key,
	    ref: _vm.componentId,
	    on: {
	      "input": _vm.closeInput
	    }
	  }, [_c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.description),
	      expression: "body.description"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "description", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Percentage"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.percentage),
	      expression: "body.percentage"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.body.percentage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "percentage", $event.target.value)
	      }
	    }
	  })])])]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2317 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-reservation-request"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('DriverReservationRequestButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("DRR" + _vm._s(_vm.item.id)), _c('driver', {
	    attrs: {
	      "type": 'onlyname',
	      "item": _vm.item.driver
	    }
	  })], 1), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Start")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.start))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("End")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.end))])])])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Passengers")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.flags.passengers))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Request Completed")]), _c('div', {
	    staticClass: "value"
	  }, [_c('span', {
	    staticClass: "fa",
	    class: {
	      "fa-times": _vm.item.reservation == null, "fa-check": _vm.item.reservation != null
	    }
	  }), (_vm.item.reservation !== null) ? void 0 : _vm._e()], 2)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('label', [_vm._v("Off road")]), _c('div', {
	    staticClass: "value"
	  }, [_c('span', {
	    staticClass: "fa",
	    class: {
	      "fa-times": !_vm.item.flags.offroad, "fa-check": _vm.item.flags.offroad
	    }
	  })])]), _c('div', {
	    staticClass: "column shrink"
	  }, [(_vm.item.flags.hasOwnProperty('luxury')) ? [_c('label', [_vm._v("Luxury")]), _c('div', {
	    staticClass: "value"
	  }, [_c('span', {
	    staticClass: "fa",
	    class: {
	      "fa-times": !_vm.item.flags.luxury, "fa-check": _vm.item.flags.luxury
	    }
	  })])] : _vm._e()], 2)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Pickup")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v("PL" + _vm._s(_vm.item.pick_up.id) + " " + _vm._s(_vm.item.pick_up.name))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Dropoff")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v("PL" + _vm._s(_vm.item.drop_off.id) + " " + _vm._s(_vm.item.drop_off.name))]), (_vm.item.flags.hasOwnProperty('estimated_distance')) ? [_c('label', [_vm._v("Estimated distance")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.flags.estimated_distance))])] : _vm._e()], 2)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.sub_status))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Request Date and Time")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.created_at))]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Request last update")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.updated_at))])])]), (_vm.item.deleted_at != null) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Request deleted at")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.deleted_at))])])]) : _vm._e()]), _c('div', {
	    staticClass: "column shrink"
	  }, [(_vm.item.reservation != null) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.reservation.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })]) : _vm._e()], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-map"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "pt-2"
	  }, [_c('button', {
	    staticClass: "button info",
	    on: {
	      "click": _vm.showFilterPanel
	    }
	  }, [_vm._v("Show Filter Panel")])]), _c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('google-map', {
	    ref: "map",
	    attrs: {
	      "searchBar": true,
	      "api-key": _vm.mapsAPI,
	      "center": _vm.mapCenter,
	      "zoom": 13,
	      "mapTypeId": 'roadmap',
	      "scrollwheel": false,
	      "zoomControl": true,
	      "mapTypeControl": true
	    },
	    on: {
	      "placesChanged": _vm.updateUserPosition
	    }
	  }, [(_vm.showfilter) ? _c('div', {
	    staticClass: "toggles"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('h2', [_vm._v("Filters")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.active_vehicle_slots),
	      expression: "body.active_vehicle_slots"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "active_vehicle_slots", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All")]), _c('option', {
	    domProps: {
	      "value": 1
	    }
	  }, [_vm._v("Enabled")]), _c('option', {
	    domProps: {
	      "value": 0
	    }
	  }, [_vm._v("Disabled")])]), _c('label', [_vm._v("Booking Mode")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reservation_type),
	      expression: "body.reservation_type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "reservation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All")]), _vm._l((_vm.reservation_types), function(reservation_type, key) {
	    return _c('option', {
	      domProps: {
	        "selected": _vm.value === key,
	        "value": key
	      }
	    }, [_vm._v(_vm._s(reservation_type))])
	  })], 2), _c('label', [_vm._v("Vehicle Type"), _c('selectize-vehicle-type', {
	    on: {
	      "optionSelected": _vm.optionSelected,
	      "optionRemoved": _vm.optionRemoved
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.loadVehicles
	    }
	  }, [_vm._v("Apply filters")])], 1), _c('label', [_vm._v("License plate"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plate),
	      expression: "plate"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plate)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.plate = $event.target.value
	      }, _vm.filter]
	    }
	  })])]), _c('div', {
	    staticClass: "content"
	  }, [_c('h2', [_vm._v("Zones")])]), _c('div', {
	    staticClass: "button-group stacked small"
	  }, [_c('button', {
	    staticClass: "button secondary",
	    class: {
	      success: _vm.showAllowed
	    },
	    on: {
	      "click": function($event) {
	        _vm.showAllowed = !_vm.showAllowed
	      }
	    }
	  }, [_vm._v("Allowed")]), _c('button', {
	    staticClass: "button secondary",
	    class: {
	      warning: _vm.showUndesirable
	    },
	    on: {
	      "click": function($event) {
	        _vm.showUndesirable = !_vm.showUndesirable
	      }
	    }
	  }, [_vm._v("Undesirable")]), _c('button', {
	    staticClass: "button secondary",
	    class: {
	      alert: _vm.showForbidden
	    },
	    on: {
	      "click": function($event) {
	        _vm.showForbidden = !_vm.showForbidden
	      }
	    }
	  }, [_vm._v("Forbidden")])])]) : _vm._e(), _vm._l((_vm.zones['allowed']), function(allowed) {
	    return (_vm.showAllowed) ? _c('div', {
	      staticClass: "allowed"
	    }, _vm._l((allowed.poly), function(poly) {
	      return _c('google-map-polygon', {
	        attrs: {
	          "positions": poly,
	          "color": "green",
	          "fillColor": "green"
	        }
	      })
	    }), 1) : _vm._e()
	  }), _vm._l((_vm.zones['forbidden']), function(forbidden) {
	    return (_vm.showForbidden) ? _c('div', {
	      staticClass: "forbidden"
	    }, _vm._l((forbidden.poly), function(poly) {
	      return _c('google-map-polygon', {
	        attrs: {
	          "positions": poly,
	          "color": "red",
	          "fillColor": "red"
	        }
	      })
	    }), 1) : _vm._e()
	  }), _vm._l((_vm.zones['undesirable']), function(undesirable) {
	    return (_vm.showUndesirable) ? _c('div', {
	      staticClass: "undesirable"
	    }, _vm._l((undesirable.poly), function(poly) {
	      return _c('google-map-polygon', {
	        attrs: {
	          "positions": poly,
	          "color": "yellow",
	          "fillColor": "yellow"
	        }
	      })
	    }), 1) : _vm._e()
	  }), _c('google-map-marker-cluster', _vm._l((_vm.filteredVehicles), function(vehicle) {
	    return _c('google-map-marker', {
	      key: vehicle.plate,
	      attrs: {
	        "icon": _vm.vehicleInRange(vehicle),
	        "position": {
	          lat: vehicle.position.latitude,
	          lng: vehicle.position.longitude
	        },
	        "title": vehicle.model,
	        "label": vehicle.model,
	        "labelOrigin": [15, 30]
	      },
	      on: {
	        "click": _vm.updateSelectedVehicle
	      }
	    }, [_c('vehicle', {
	      attrs: {
	        "item": vehicle,
	        "type": 'fleet-map'
	      }
	    })], 1)
	  }), 1)], 2) : _vm._e()], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-packet"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card-n', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 8
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('packet-buttons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("P" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Name")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Amount")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.amount))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v("Minutes")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.item.minutes))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v("Distance")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v(_vm._s(_vm.item.distance))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_vm._v("Duration")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_vm._v(_vm._s(_vm.item.duration))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n7"
	    },
	    slot: "n7"
	  }, [_vm._v("Max Uses")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n7"
	    },
	    slot: "n7"
	  }, [_vm._v(_vm._s(_vm.item.max_uses))]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n8"
	    },
	    slot: "n8"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n8"
	    },
	    slot: "n8"
	  }, [_vm._v(_vm._s(_vm.item.status))])])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2320 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-vehicle-controller"
	  }, [_c('statistics-card5', [_c('div', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('span', [_vm._v("Odometer")]), _c('h3', [_vm._v(_vm._s(_vm.item.odometer) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])]), _c('div', {
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('span', [_vm._v("Fuel Level:")]), _c('h3', [_vm._v(_vm._s(_vm.item.fuel_level) + "%"), (_vm.item.range !== null) ? _c('span', [_vm._v("(" + _vm._s(_vm.item.range) + _vm._s(_vm.configuration.locale.locale_distance_unit.value) + ")")]) : _vm._e()])]), _c('div', {
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('span', [_vm._v("Door Status:")]), _c('h3', [_vm._v(_vm._s(_vm.item.door_status))])]), _c('div', {
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('span', [_vm._v("Engine Status:")]), _c('h3', [_vm._v(_vm._s(_vm.item.engine_status))])]), _c('div', {
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_c('span', [_vm._v("Parking Lot")]), (_vm.item.parking_lot.id) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'parkingLot',
	        params: {
	          id: _vm.item.parking_lot.id
	        }
	      }
	    }
	  }, [_c('h3', [_vm._v(_vm._s(_vm.item.parking_lot.name))])]) : _c('h3', [_vm._v("--")])], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('router-tab-headers', {
	    attrs: {
	      "id": "vehicle-details",
	      "tabs": _vm.tabs
	    }
	  }, [_c('router-view', {
	    staticClass: "content",
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1)])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2321 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: ("maintenance-" + _vm._uid),
	    attrs: {
	      "value": _vm.open
	    }
	  }, [(!_vm.open) ? [(_vm.request) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Complete")]) : _vm._e()] : _vm._e(), _c('h2', [_vm._v("Complete Intervention request IR" + _vm._s(_vm.request.id) + "?")]), (_vm.request.linked_requests.length) ? [_c('label', [_vm._v("Complete linked requests?")]), _c('input-switch', {
	    model: {
	      value: (_vm.body.complete_all),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "complete_all", $$v)
	      },
	      expression: "body.complete_all"
	    }
	  })] : _vm._e(), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$refs[("maintenance-" + _vm._uid)].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2322 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-damage-detail"
	  }, [_c('div', {
	    ref: "damageContainer",
	    staticClass: "damage-container"
	  }, [_c('img', {
	    staticClass: "car-outline",
	    attrs: {
	      "src": _vm.vehicleDamagePicture
	    }
	  }), _vm._l((_vm.pins), function(pin) {
	    return _c('div', {
	      staticClass: "component-pin",
	      class: {
	        'is-expanded': pin.expanded, hover: pin.hover, 'status-PENDING_REVIEW': true
	      },
	      style: ({
	        backgroundColor: pin.status === 'PENDING_REVIEW' ? '#ffc200' : '#2890ff',
	        top: pin.top + 'px',
	        left: pin.left + 'px'
	      }),
	      on: {
	        "mouseover": function($event) {
	          return _vm.selectHovered(pin)
	        },
	        "mouseleave": _vm.resetHover
	      }
	    }, [_c('div', {
	      on: {
	        "click": function($event) {
	          pin.expanded = !pin.expanded
	        }
	      }
	    }, [_c('small', [_vm._v(_vm._s(pin.id))])]), (pin.expanded) ? _c('div', {
	      staticClass: "expanded",
	      on: {
	        "click": function($event) {
	          pin.expanded = !pin.expanded
	        }
	      }
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column"
	    }, [_c('label', [_vm._v("ID")]), _c('router-link', {
	      attrs: {
	        "to": {
	          name: 'reporting',
	          params: {
	            id: pin.id
	          }
	        },
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(pin.id))])], 1), _c('div', {
	      staticClass: "column"
	    }, [_c('label', [_vm._v("UID")]), _c('div', {
	      staticClass: "value"
	    }, [_vm._v(_vm._s(pin.uid))])]), _c('div', {
	      staticClass: "column"
	    }, [_c('label', [_vm._v("Status")]), _c('div', {
	      staticClass: "value"
	    }, [_vm._v(_vm._s(pin.status))])])]), _c('hr'), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column"
	    }, [_c('label', [_vm._v("Description")]), _c('p', [_vm._v(_vm._s(pin.description))])])])]) : _vm._e()])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2323 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-policy-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2324 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    staticClass: "vue-dropzone dropzone",
	    attrs: {
	      "action": _vm.url,
	      "id": _vm.id
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 2325 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component component-backoffice-driver-notes"
	  }, [(_vm.type === 'noteCard') ? _c('span', [_c('ModalReveal', {
	    staticClass: "p-0 m-0"
	  }, [_c('a', {
	    staticClass: "pr-2 fa fa-comment fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [(_vm.notes > 0) ? _c('span', {
	    staticClass: "badge success"
	  }, [_vm._v(_vm._s(_vm.notes))]) : _vm._e()]), _c('label', [_vm._v("Add note"), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.pushNote($event)
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.description),
	      expression: "body.description"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "description", $event.target.value)
	      }
	    }
	  })]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.pushNote
	    }
	  }, [_vm._v("Add")])], 1), _c('h2', [_vm._v("Notes")]), _c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false,
	      "componentType": "table"
	    }
	  })], 1)], 1) : _vm._e(), (_vm.type === 'highlightedNotes') ? _c('div', {
	    staticClass: "div"
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2326 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-packet-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('EditPacketReveal', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2327 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-toc-controller"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('router-view')], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2328 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-parking-lot"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "component-card-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('ParkingLotActionButtons', {
	    attrs: {
	      "parkingLot": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field-parking-lot-id"
	  }, [_vm._v("PL" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-parking-lot-name"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Assigned slots")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.slots))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Actual slots")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.parking_slots_count))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Occupied slots")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.vehicle_slots_count))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Disabled slots")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.vehicle_slots_disabled))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'parkingLot',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2329 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-cards row column"
	  }, [_c('card-list-form', {
	    on: {
	      "filterCards": _vm.setSearch
	    }
	  }), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  }, [_c('header-columns', {
	    attrs: {
	      "slot": "before",
	      "columns": _vm.headers
	    },
	    slot: "before"
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2330 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-map"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('google-map', {
	    ref: "map",
	    attrs: {
	      "searchBar": true,
	      "api-key": _vm.mapsAPI,
	      "center": _vm.mapCenter,
	      "zoom": 13,
	      "mapTypeId": 'roadmap',
	      "scrollwheel": false,
	      "zoomControl": true,
	      "mapTypeControl": true
	    }
	  }, [(_vm.userPosition) ? _c('google-map-marker', {
	    attrs: {
	      "icon": '/static/icon_user_red.png',
	      "position": {
	        lat: _vm.userPosition.latitude,
	        lng: _vm.userPosition.longitude
	      },
	      "title": '',
	      "label": ''
	    },
	    on: {
	      "click": _vm.updateUserPosition
	    }
	  }) : _vm._e(), _vm._l((_vm.vehicles), function(vehicle) {
	    return _c('google-map-marker', {
	      key: vehicle.plate,
	      attrs: {
	        "icon": '/static/map_pin_blue.png',
	        "position": {
	          lat: vehicle.position.latitude,
	          lng: vehicle.position.longitude
	        },
	        "title": vehicle.distance + ' Km',
	        "label": vehicle.model,
	        "labelOrigin": [15, 30]
	      },
	      on: {
	        "click": _vm.updateSelectedVehicle
	      }
	    }, [_c('vehicle', {
	      attrs: {
	        "item": vehicle,
	        "type": 'quick-booking'
	      },
	      on: {
	        "bookVehicle": function($event) {
	          return _vm.$emit('getVehicleSelected', vehicle)
	        }
	      }
	    })], 1)
	  })], 2) : _vm._e()], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2331 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-driver-list row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-4"
	  }, [_c('label', [_vm._v("Status"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    attrs: {
	      "disabled": _vm.search.deleted
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All")]), _c('option', [_vm._v("NEW")]), _c('option', [_vm._v("WAITING")]), _c('option', [_vm._v("ACCEPTED")]), _c('option', {
	    attrs: {
	      "value": "AUTO_ACCEPTED"
	    }
	  }, [_vm._v("AUTO ACCEPTED")]), _c('option', {
	    attrs: {
	      "value": "AUTO_WAITING"
	    }
	  }, [_vm._v("AUTO WAITING")]), _c('option', {
	    attrs: {
	      "value": "AUTO_WAITING_OWFF"
	    }
	  }, [_vm._v("AUTO WAITING OWFF")]), _c('option', {
	    attrs: {
	      "value": "PENDING_CONFIRMATION"
	    }
	  }, [_vm._v("PENDING CONFIRMATION")]), _c('option', {
	    attrs: {
	      "value": "PENDING_ALLOCATION"
	    }
	  }, [_vm._v("PENDING ALLOCATION")]), _c('option', {
	    attrs: {
	      "value": "VOIDED"
	    }
	  }, [_vm._v("VOIDED")]), _c('option', {
	    attrs: {
	      "value": "COMPLETED"
	    }
	  }, [_vm._v("COMPLETED")]), _c('option', [_vm._v("REJECTED")])])])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("SUB STATUS"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.sub_status),
	      expression: "search.sub_status"
	    }],
	    attrs: {
	      "disabled": _vm.search.deleted
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "sub_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All")]), _c('option', {
	    attrs: {
	      "value": "BACKOFFICE_ASSIGNED"
	    }
	  }, [_vm._v("BACKOFFICE ASSIGNED")]), _c('option', {
	    attrs: {
	      "value": "AUTO_ASSIGNED"
	    }
	  }, [_vm._v("AUTO ASSIGNED")])])])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Show deleted"), _c('input-switch', {
	    model: {
	      value: (_vm.search.deleted),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "deleted", $$v)
	      },
	      expression: "search.deleted"
	    }
	  })], 1)])]), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2332 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-subscription-slots"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.availableSlots), function(slot, index) {
	    return _c('div', {
	      staticClass: "columns driver-slot small-2"
	    }, [_c('div', {
	      staticClass: "inner-content"
	    }, [_c('dropdown', [_c('img', {
	      staticClass: "driver-image",
	      attrs: {
	        "slot": "placeholder",
	        "src": slot.profile_picture
	      },
	      slot: "placeholder"
	    }), (slot.available) ? _c('div', {
	      staticClass: "unselect"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "columns small-9"
	    }, [(_vm.selectizeDrivers) ? _c('selectize-driver', {
	      attrs: {
	        "clientDrivers": _vm.selectizeDrivers
	      },
	      on: {
	        "optionSelected": _vm.setDriverId
	      }
	    }) : _vm._e()], 1), _c('div', {
	      staticClass: "columns small-2"
	    }, [_c('input', {
	      staticClass: "button small",
	      attrs: {
	        "type": "submit",
	        "value": "Add"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.addDriver(index)
	        }
	      }
	    })])])]) : _c('div', {
	      staticClass: "select"
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.removeDriver(index)
	        }
	      }
	    }, [_vm._v("Remove from subscription")])])]), _vm._v(_vm._s(slot.name) + " " + _vm._s(slot.surname))], 1)])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2333 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-account-status-filter"
	  }, [_c('AccountStatus', {
	    attrs: {
	      "accountStatus": _vm.status,
	      "statuses": _vm.statuses
	    },
	    on: {
	      "input": _vm.toggle
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2334 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2335 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-reservation-planner row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Driver"), _c('SelectizeDriver', {
	    model: {
	      value: (_vm.driver),
	      callback: function($$v) {
	        _vm.driver = $$v
	      },
	      expression: "driver"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Start Date"), _c('DatePicker', {
	    model: {
	      value: (_vm.startDate),
	      callback: function($$v) {
	        _vm.startDate = $$v
	      },
	      expression: "startDate"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Contract duration"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contractDuration),
	      expression: "contractDuration"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.contractDuration)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contractDuration = $event.target.value
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Parking Lot"), _c('SelectizeParkingLot', {
	    on: {
	      "optionSelected": _vm.setParkingLot,
	      "optionRemoved": _vm.unsetParkingSlot
	    }
	  })], 1)]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Plan to be activated (" + _vm._s(_vm.planId) + ")"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.planId),
	      expression: "planId"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.planId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("- NO PLAN -")]), _vm._l((_vm.plans), function(p) {
	    return _c('option', {
	      domProps: {
	        "value": p.id
	      }
	    }, [_vm._v(_vm._s(p.name))])
	  })], 2)])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Enable custom  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.multipleMode),
	      expression: "multipleMode"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.multipleMode) ? _vm._i(_vm.multipleMode, null) > -1 : (_vm.multipleMode)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.multipleMode,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.multipleMode = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.multipleMode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.multipleMode = $$c
	        }
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [(_vm.plans.length > 0) ? _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Presets shifts"), _vm._l((_vm.shiftsPresets), function(p, i) {
	    return (_vm.shiftsPresets) ? _c('div', {
	      style: ({
	        'background-color': p.color
	      })
	    }, [(_vm.multipleMode) ? _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedPresets[i]),
	        expression: "selectedPresets[i]"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": Array.isArray(_vm.selectedPresets[i]) ? _vm._i(_vm.selectedPresets[i], null) > -1 : (_vm.selectedPresets[i])
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.selectedPresets[i],
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(_vm.selectedPresets, i, $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(_vm.selectedPresets, i, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(_vm.selectedPresets, i, $$c)
	          }
	        }
	      }
	    }) : _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedPreset),
	        expression: "selectedPreset"
	      }],
	      attrs: {
	        "type": "radio"
	      },
	      domProps: {
	        "value": i,
	        "checked": _vm._q(_vm.selectedPreset, i)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selectedPreset = i
	        }
	      }
	    }), _c('span', {
	      staticStyle: {
	        "font-family": "monospace"
	      }
	    }, [_vm._v("  [" + _vm._s(_vm.getPlanName(p.plan_id)) + "] " + _vm._s(p.shift))])]) : _vm._e()
	  })], 2)]) : _vm._e(), (_vm.multipleMode) ? _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Custom shifts"), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.customShifts),
	      expression: "customShifts"
	    }],
	    staticStyle: {
	      "font-family": "monospace"
	    },
	    attrs: {
	      "placeholder": "#C2C2C2 MON|TUE|WED|THU|FRI|SAT|SUN 08:00 09:00",
	      "rows": "5"
	    },
	    domProps: {
	      "value": (_vm.customShifts)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.customShifts = $event.target.value
	      }
	    }
	  })])]) : _vm._e()]), _c('br'), (_vm.multipleMode) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Selected shifts"), _vm._l((_vm.shifts), function(p) {
	    return _c('div', [_c('ul', {
	      staticStyle: {
	        "font-family": "monospace"
	      }
	    }, [_c('li', [_vm._v(_vm._s(p))])])])
	  })], 2)])]) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.search
	    }
	  }, [_vm._v("Search")])], 1)]), _vm._l((_vm.slotsByLots), function(slots, key) {
	    return _c('div', {
	      staticClass: "grouped card",
	      style: (_vm.gridStyle(slots))
	    }, [_c('h1', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(key))]), _vm._l((slots), function(vehicle, id) {
	      return (!vehicle.vehicle.disabled) ? _c('vehicle', {
	        key: id,
	        attrs: {
	          "item": vehicle.vehicle,
	          "type": "search-result"
	        }
	      }, [_c('ActionButton', {
	        attrs: {
	          "action": _vm.bookVehicle,
	          "value": vehicle.vehicle.plate,
	          "disabled": _vm.driver === null
	        }
	      }, [_vm._v("Book")])], 1) : _vm._e()
	    })], 2)
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 2336 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-note-list row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Priority"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.priority),
	      expression: "search.priority"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "priority", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All priorities")]), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Minor")]), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Medium")]), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("Major")])])])]), (_vm.filters && !_vm.filters.hasOwnProperty('vehicle_id')) ? _c('div', {
	    staticClass: "column"
	  }, [_c('selectize-vehicle', {
	    attrs: {
	      "value-field": "id"
	    },
	    model: {
	      value: (_vm.search.vehicle_id),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "vehicle_id", $$v)
	      },
	      expression: "search.vehicle_id"
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Type"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.type),
	      expression: "search.type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All types")]), _c('option', {
	    attrs: {
	      "value": "CLEANING"
	    }
	  }, [_vm._v("Cleaning")]), _c('option', {
	    attrs: {
	      "value": "ROUTINE"
	    }
	  }, [_vm._v("Routine")]), _c('option', {
	    attrs: {
	      "value": "PREPARATION"
	    }
	  }, [_vm._v("Preparation")]), _c('option', {
	    attrs: {
	      "value": "CHECK_OUT"
	    }
	  }, [_vm._v("Check-out")]), _c('option', {
	    attrs: {
	      "value": "REPOSITIONING"
	    }
	  }, [_vm._v("Repositioning")]), _c('option', {
	    attrs: {
	      "value": "ACCIDENT"
	    }
	  }, [_vm._v("Accident")]), _c('option', {
	    attrs: {
	      "value": "EXTERIOR_REPAIR"
	    }
	  }, [_vm._v("Exterior repair")]), _c('option', {
	    attrs: {
	      "value": "RECHARGE"
	    }
	  }, [_vm._v("Recharge")]), _c('option', {
	    attrs: {
	      "value": "LOW_BATTERY"
	    }
	  }, [_vm._v("Low Battery")])])])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Status"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All statuses")]), _c('option', {
	    attrs: {
	      "value": "NEW"
	    }
	  }, [_vm._v("New")]), _c('option', {
	    attrs: {
	      "value": "ASSIGNED"
	    }
	  }, [_vm._v("Assigned")]), _c('option', {
	    attrs: {
	      "value": "IN_PROGRESS"
	    }
	  }, [_vm._v("In progress")]), _c('option', {
	    attrs: {
	      "value": "COMPLETED"
	    }
	  }, [_vm._v("Completed")]), _c('option', {
	    attrs: {
	      "value": "REFUSED"
	    }
	  }, [_vm._v("Refused")])])])])]), _c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "component-type": _vm.listingType,
	      "search": _vm.search
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2337 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-hardware-reveal-create"
	  }, [_c('modal-reveal', {
	    ref: "modalAddVehicleHardware",
	    attrs: {
	      "sizing": "small"
	    }
	  }, [_c('button', {
	    staticClass: "button small",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Add Vehicle Hardware")]), _c('h2', [_vm._v("Add new Vehicle hardware")]), _c('label', [_vm._v("Vehicle V" + _vm._s(_vm.item.id) + " " + _vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Manager"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.manager),
	      expression: "manager"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.manager = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.managers), function(manager, index) {
	    return _c('option', [_vm._v(_vm._s(index))])
	  }), 0)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Serial"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.serial),
	      expression: "body.serial"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.serial)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "serial", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Extra")]), _c('array-edit', {
	    attrs: {
	      "values": _vm.body.extra
	    }
	  }), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.addHardware
	    }
	  }, [_vm._v("Add Hardware")])], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2338 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 2339 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-billed-records"
	  }, [_c('table', [_vm._m(0), _c('tbody', _vm._l((_vm.item.records), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _c('td', [_vm._v(_vm._s(item.driver_id))]), _c('td', [_vm._v(_vm._s(_vm._f("walletableType")(item.walletable_type)) + " - " + _vm._s(item.walletable_id))]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency(parseFloat(item.amount * item.tax).toFixed(2))))]), _c('td', [_vm._v(_vm._s(-item.tax * 100) + "%")]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency(-item.amount)))])])
	  }), 0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Driver Id")]), _c('th', [_vm._v("Type & Id")]), _c('th', [_vm._v("Tax")]), _c('th', [_vm._v("Tax Rate")]), _c('th', [_vm._v("Amount")])])])
	}]}

/***/ }),
/* 2340 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('PolicyReveal', {
	    attrs: {
	      "policyProp": _vm.item
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.remove
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2341 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-client client card"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('client-action-buttons', {
	    attrs: {
	      "client": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('status', {
	    staticClass: "float-left",
	    attrs: {
	      "status": _vm.item.status
	    }
	  }), _vm._v(_vm._s(_vm.item.status)), _c('span', [_vm._v("CL" + _vm._s(_vm.item.id))]), (_vm.item.federation !== null) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Federation: " + _vm._s(_vm.item.federation.name))]) : _vm._e()], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Client")]), _c('div', {
	    staticClass: "name-surname"
	  }, [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))]), _c('div', {
	    staticClass: "organization-name"
	  }, [_vm._v(_vm._s(_vm.item.organization_name))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("City")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.billing_address.city))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Country")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.billing_address.country))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Phone")]), (_vm.item.main_driver) ? _c('div', {
	    staticClass: "field-value"
	  }, [_c('div', {
	    staticClass: "phone"
	  }, [_vm._v(_vm._s(_vm.item.main_driver.phone))]), _c('div', {
	    staticClass: "mobile"
	  }, [_vm._v(_vm._s(_vm.item.main_driver.mobile))])]) : _vm._e()]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created at")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])]) : _vm._e(), (_vm.$is('client-card')) ? _c('div', {
	    staticClass: "client-card card"
	  }, [_c('div', {
	    staticClass: "row inner-content"
	  }, [_c('div', {
	    staticClass: "columns shrink"
	  }, [_vm._v(_vm._s(_vm.item.picture))]), _c('div', {
	    staticClass: "columns"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname) + " (CL" + _vm._s(_vm.item.id) + ")")])]), _vm._v(_vm._s(_vm.item.client_organization_name))], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-right"
	  }, [(_vm.item.main_driver.mobile) ? _c('a', {
	    staticClass: "fa fa-phone fa-lg",
	    attrs: {
	      "href": 'tel:' + _vm.item.main_driver.mobile
	    }
	  }) : _vm._e(), (_vm.item.email) ? _c('a', {
	    staticClass: "fa fa-envelope fa-lg",
	    attrs: {
	      "href": 'mailto:' + _vm.item.email
	    }
	  }) : _vm._e()])])]) : _vm._e(), (_vm.$is('client-approval-card')) ? _c('div', {
	    staticClass: "client-approval-card"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row inner-content align-middle"
	  }, [_c('div', {
	    staticClass: "columns shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'left'
	    }
	  }, [_c('client-action-buttons', {
	    attrs: {
	      "client": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "columns small-3 large-1"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.main_driver.id
	        }
	      }
	    }
	  }, [_c('thumbnail', {
	    attrs: {
	      "image": _vm.item.main_driver.profile_picture
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "columns small-3 large-2"
	  }, [_c('p', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))]), _c('p', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.item.id))]), (_vm.item.federation !== null) ? _c('p', [_vm._v("Federation: " + _vm._s(_vm.item.federation.name))]) : _vm._e()]), _c('div', {
	    staticClass: "columns text-center align-middle"
	  }, [_c('AccountStatus', {
	    attrs: {
	      "accountStatus": _vm.accountStatus
	    }
	  })], 1), _c('div', {
	    staticClass: "columns shrink text-center align-middle"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o fa-2x",
	    class: {
	      activeIcon: true
	    }
	  }), _c('p', {
	    staticClass: "no-wrap"
	  }, [_vm._v(_vm._s(_vm.daysWaiting(_vm.item.updated)))])]), _c('div', {
	    staticClass: "columns shrink text-right align-middle"
	  }, [_c('h5', {
	    staticClass: "mb-0 no-wrap"
	  }, [_vm._v("created: " + _vm._s(_vm.formatDate(_vm.item.created)))]), _c('h5', {
	    staticClass: "mb-0 no-wrap"
	  }, [_vm._v("updated: " + _vm._s(_vm.formatDate(_vm.item.updated)))])]), _c('div', {
	    staticClass: "columns shrink"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])])]) : _vm._e(), (_vm.$is('personal-data')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('h3', [_vm._v("Personal Data")]), _c('hr'), _c('cardN', {
	    attrs: {
	      "columns": 3
	    }
	  }, [_c('div', {
	    staticClass: "field field-first-name",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("First Name")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "field field-last-name",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Last name")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.surname))])]), _c('div', {
	    staticClass: "field field-client-type",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Client Type")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.client_type.type))])])]), _c('cardN', {
	    attrs: {
	      "columns": 3
	    }
	  }, [_c('div', {
	    staticClass: "field field-member-since",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Member Since")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])])]), (_vm.item.federation !== null) ? _c('cardN', {
	    attrs: {
	      "columns": 3
	    }
	  }, [_c('div', {
	    staticClass: "field field-federation",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Federation")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.federation.name))])])]) : _vm._e()], 1) : _vm._e(), (_vm.$is('contacts')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('h3', [_vm._v("Contacts")]), _c('hr'), _c('simple-columns2', [_c('div', {
	    staticClass: "field field-email-address",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Mail Address")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.email))])]), _c('div', {
	    staticClass: "field field-address",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Address")]), _c('div', {
	    staticClass: "address"
	  }, [_vm._v(_vm._s(_vm.item.address.street) + " " + _vm._s(_vm.item.address.city) + " " + _vm._s(_vm.item.address.country))]), _c('div', {
	    staticClass: "postal-code"
	  }, [_vm._v(_vm._s(_vm.item.address.postal_code))])]), _c('div', {
	    staticClass: "field field-phone",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Phone")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.phone))])])])], 1) : _vm._e(), (_vm.$is('billing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('h3', [_vm._v("Billing Details")]), _c('hr'), _c('cardN', {
	    attrs: {
	      "columns": 3
	    }
	  }, [_c('div', {
	    staticClass: "field field-organization-name",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Organization Name")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.organization_name))])]), _c('div', {
	    staticClass: "field field-fiscal-code",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Fiscal Code")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.fiscalCode))])])]), _c('cardN', {
	    attrs: {
	      "columns": 3
	    }
	  }, [_c('div', {
	    staticClass: "field field-vat-number",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Vat number")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.vat_number))])]), _c('div', {
	    staticClass: "field field-billing-address",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Billing Address")]), _c('div', {
	    staticClass: "address"
	  }, [_vm._v(_vm._s(_vm.item.billing_address.street) + " " + _vm._s(_vm.item.billing_address.city) + " " + _vm._s(_vm.item.billing_address.country))]), _c('div', {
	    staticClass: "postal-code"
	  }, [_vm._v(_vm._s(_vm.item.billing_address.postal_code))])])]), _c('cardN', {
	    attrs: {
	      "columns": 1
	    }
	  }, [_c('div', {
	    staticClass: "field field-extra",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, _vm._l((_vm.extra), function(value, label) {
	    return _c('div', {
	      staticClass: "values"
	    }, [_c('div', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s(label))]), _c('div', {
	      staticClass: "value"
	    }, [_vm._v(_vm._s(value))])])
	  }), 0)])], 1) : _vm._e(), (_vm.$is('main-driver')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('h3', [_vm._v("Main driver")]), _c('driver', {
	    attrs: {
	      "type": 'driver-card',
	      "item": _vm.item.main_driver
	    }
	  })], 1) : _vm._e(), (_vm.$is('client-status')) ? _c('div', {
	    staticClass: "client-status"
	  }, [_c('p', [_vm._v("Status"), _c('br'), _vm._v(_vm._s(_vm.item.status))])]) : _vm._e(), (_vm.$is('client-card2')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "driver-card inner-content"
	  }, [_c('div', {
	    staticClass: "row collapse align-middle"
	  }, [_c('div', {
	    staticClass: "columns small-offset-1"
	  }, [_c('div', {
	    staticClass: "client"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname) + " (CL" + _vm._s(_vm.item.id) + ")")])])], 1)])]), _c('div', {
	    staticClass: "row collapse"
	  }, [_c('div', {
	    staticClass: "columns text-right"
	  }, [(_vm.item.main_driver.mobile) ? _c('a', {
	    staticClass: "fa fa-phone fa-lg",
	    attrs: {
	      "href": 'tel:' + _vm.item.main_driver.mobile
	    }
	  }) : _vm._e()]), _c('div', {
	    staticClass: "columns text-right small-1"
	  }, [(_vm.item.email) ? _c('a', {
	    staticClass: "fa fa-envelope fa-lg",
	    attrs: {
	      "href": 'mailto:' + _vm.item.email
	    }
	  }) : _vm._e()])])])]) : _vm._e(), (_vm.$is('federationList')) ? _c('div', {
	    staticClass: "inner-content federation-list"
	  }, [_c('cardN', {
	    attrs: {
	      "columns": 4
	    }
	  }, [_c('div', {
	    staticClass: "field field-first-name",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("First Name")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "field field-last-name",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Last name")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.surname))])]), _c('div', {
	    staticClass: "field field-client-type",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Client Type")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.client_type.type))])]), _c('div', {
	    staticClass: "field field-url-detail text-right",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])], 1) : _vm._e(), ((_vm.item.status === 'SUSPENDED' || _vm.item.status === 'ON HOLD') && _vm.type === 'highlightedNotes') ? _c('div', {
	    staticClass: "card"
	  }, [_c('DriverNotes', {
	    attrs: {
	      "driver_id": _vm.item.main_driver.id,
	      "type": 'highlightedNotes'
	    },
	    on: {
	      "notes": _vm.retriveLastNotes
	    }
	  }), _c('div', {
	    staticClass: "row column pl-2 pr-2 pt-2 pb-2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("last two notes")]), _vm._l((_vm.lastNotes), function(lastNote, key) {
	    return _c('div', {
	      staticClass: "row column small-12"
	    }, [_vm._v(_vm._s(lastNote))])
	  })], 2)], 1) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2342 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.name),
	      expression: "localValue.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.localValue.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.description),
	      expression: "localValue.description"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.localValue.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "description", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', [_c('label', [_vm._v("Number required")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.has_number),
	      expression: "localValue.has_number"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.localValue.has_number) ? _vm._i(_vm.localValue.has_number, null) > -1 : (_vm.localValue.has_number)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.localValue.has_number,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.localValue, "has_number", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.localValue, "has_number", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.localValue, "has_number", $$c)
	        }
	      }
	    }
	  })]), _c('div', [_c('label', [_vm._v("Emission date required")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.has_emission),
	      expression: "localValue.has_emission"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.localValue.has_emission) ? _vm._i(_vm.localValue.has_emission, null) > -1 : (_vm.localValue.has_emission)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.localValue.has_emission,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.localValue, "has_emission", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.localValue, "has_emission", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.localValue, "has_emission", $$c)
	        }
	      }
	    }
	  })]), _c('div', [_c('label', [_vm._v("Expiry date required")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.has_expiry),
	      expression: "localValue.has_expiry"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.localValue.has_expiry) ? _vm._i(_vm.localValue.has_expiry, null) > -1 : (_vm.localValue.has_expiry)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.localValue.has_expiry,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.localValue, "has_expiry", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.localValue, "has_expiry", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.localValue, "has_expiry", $$c)
	        }
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Issuer required")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.has_issuer),
	      expression: "localValue.has_issuer"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.localValue.has_issuer) ? _vm._i(_vm.localValue.has_issuer, null) > -1 : (_vm.localValue.has_issuer)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.localValue.has_issuer,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.localValue, "has_issuer", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.localValue, "has_issuer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.localValue, "has_issuer", $$c)
	        }
	      }
	    }
	  }), _c('div', [_c('label', [_vm._v("Country required")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.has_country),
	      expression: "localValue.has_country"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.localValue.has_country) ? _vm._i(_vm.localValue.has_country, null) > -1 : (_vm.localValue.has_country)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.localValue.has_country,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.localValue, "has_country", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.localValue, "has_country", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.localValue, "has_country", $$c)
	        }
	      }
	    }
	  })])])]), _c('label', [_vm._v("Attachment views"), _vm._l((_vm.localValue.attachment_views), function(attachments, index) {
	    return (typeof _vm.localValue.attachment_views !== 'string') ? _c('div', {
	      staticClass: "input-group"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.localValue.attachment_views[index]),
	        expression: "localValue.attachment_views[index]"
	      }],
	      staticClass: "input-group-field",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.localValue.attachment_views[index])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.localValue.attachment_views, index, $event.target.value)
	        }
	      }
	    }), _c('div', {
	      staticClass: "input-group-button"
	    }, [_c('button', {
	      staticClass: "button warning",
	      on: {
	        "click": function($event) {
	          return _vm.localValue.attachment_views.splice(index, 1)
	        }
	      }
	    }, [_vm._v("-")])])]) : _vm._e()
	  })], 2), _c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        return _vm.localValue.attachment_views.push([])
	      }
	    }
	  }, [_vm._v("Add view")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2343 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-profile"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "client-drivers tabs-inner-content"
	  }, [_c('div', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "is-hidden",
	    attrs: {
	      "id": "edit-main-driver",
	      "data-toggler": "is-hidden"
	    }
	  }, [(_vm.options) ? _c('selectize-driver', {
	    attrs: {
	      "clientDrivers": _vm.options
	    },
	    on: {
	      "optionSelected": _vm.driverSelected
	    }
	  }) : _vm._e(), _c('button', {
	    staticClass: "button success",
	    on: {
	      "click": _vm.updateMainDriver
	    }
	  }, [_vm._v("Update Main driver")])], 1)]), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('div', {
	    staticClass: "client-profile"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('client', {
	    attrs: {
	      "type": 'personal-data',
	      "item": _vm.client
	    }
	  }), _c('client', {
	    attrs: {
	      "type": 'billing',
	      "item": _vm.client
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('client', {
	    attrs: {
	      "type": 'contacts',
	      "item": _vm.client
	    }
	  }), _c('client', {
	    attrs: {
	      "type": 'main-driver',
	      "item": _vm.client
	    }
	  }), _c('div', {
	    staticClass: "columns driver-licenses"
	  }, _vm._l((_vm.driverLicenses), function(license) {
	    return _c('driver-licence', {
	      attrs: {
	        "type": 'license-card-accordion',
	        "item": license
	      }
	    })
	  }), 1)], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Client Profile")])]), _c('div', {
	    staticClass: "action"
	  }, [_c('span', {
	    attrs: {
	      "data-toggle": "edit-main-driver"
	    }
	  }, [_vm._v("Edit main driver")])])])
	}]}

/***/ }),
/* 2344 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component component-subscription subscription"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [(_vm.$is('listing')) ? _c('card7', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "shrink": _vm.shrink
	    }
	  }, [_c('div', {
	    staticClass: "field-subscription-dropdown-buttons",
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('subscription-action-buttons', {
	    attrs: {
	      "subscription": _vm.item
	    }
	  })], 1)], 1), _c('subscription-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'subscription-id-and-client'
	    },
	    slot: "n1"
	  }), _c('subscription-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'plan-name'
	    },
	    slot: "n2"
	  }), _c('subscription-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'subscription-booking-mode'
	    },
	    slot: "n3"
	  }), _c('subscription-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'subscription-max-drivers'
	    },
	    slot: "n4"
	  }), _c('subscription-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'plan-billing-cycle'
	    },
	    slot: "n5"
	  }), _c('div', {
	    staticClass: "field-auto-renew iconized",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_c('i', {
	    staticClass: "pm-icon subs-expiry"
	  }), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Start: " + _vm._s(_vm.$dateFormat(_vm.item.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]), (!_vm.expired) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.daysToExpiry) + " days")]) : (_vm.item.start === null || _vm.item.end === null) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Unactive")]) : _c('div', {
	    staticClass: "field-value expired"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])]), _c('strong', {
	    attrs: {
	      "slot": "n7"
	    },
	    slot: "n7"
	  }, [_vm._v(_vm._s(_vm.item.plan.cost) + _vm._s(_vm.currency) + "/" + _vm._s(_vm.$daysNumberToHuman(_vm.item.plan.billing_cycle)))]), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'subscription',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1) : _vm._e()], 1)]) : _vm._e(), (_vm.$is('driver-data') || _vm.$is('test-data')) ? _c('div', {
	    staticClass: "driver-data"
	  }, [_c('ul', {
	    directives: [{
	      name: "f-accordion",
	      rawName: "v-f-accordion"
	    }],
	    staticClass: "accordion subscription-accordion",
	    attrs: {
	      "data-accordion": "data-accordion",
	      "data-allow-all-closed": "true"
	    }
	  }, [_c('li', {
	    staticClass: "accordion-item",
	    attrs: {
	      "data-accordion-item": "data-accordion-item"
	    }
	  }, [_c('a', {
	    staticClass: "accordion-title",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('backoffice-subscription', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'card-header-include'
	    }
	  })], 1), _c('div', {
	    staticClass: "accordion-content",
	    attrs: {
	      "data-tab-content": "data-tab-content"
	    }
	  }, [_c('backoffice-subscription', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'subscription-action-details'
	    }
	  })], 1)])])]) : _vm._e(), (_vm.$is('card-header-include')) ? _c('div', {
	    staticClass: "card-header-include"
	  }, [_c('card6', {
	    attrs: {
	      "showBullets": true,
	      "showAction": false
	    }
	  }, [_c('subscription-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'plan-name'
	    },
	    slot: "n1"
	  }), _c('div', {
	    staticClass: "field-expire-in",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [(_vm.item.start && _vm.item.end) ? _c('div', {
	    staticClass: "field-value"
	  }, [_c('div', {
	    staticClass: "expire-days"
	  }, [_vm._v("EXPIRE IN: " + _vm._s(_vm.daysToExpiry) + " days")]), _c('div', {
	    staticClass: "expire-date"
	  }, [_vm._v(_vm._s(_vm.item.end))])]) : _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Unactive subscription")])]), _c('subscription-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'subscription-booking-mode'
	    },
	    slot: "n2"
	  }), _c('subscription-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'subscription-max-drivers'
	    },
	    slot: "n3"
	  }), _c('subscription-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'plan-billing-cycle'
	    },
	    slot: "n4"
	  }), _c('div', {
	    staticClass: "field-auto-renew iconized",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_c('i', {
	    staticClass: "pm-icon subs-expiry"
	  }), (!_vm.expired) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.daysToExpiry) + " days")]) : (_vm.item.start === null || _vm.item.end === null) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Unactive")]) : _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.end))])]), _c('strong', {
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_vm._v(_vm._s(_vm.item.plan.cost) + _vm._s(_vm.currency) + "/" + _vm._s(_vm.$daysNumberToHuman(_vm.item.plan.billing_cycle)))])], 1)], 1) : _vm._e(), (_vm.$is('subscription-action-details')) ? _c('div', {
	    staticClass: "subscription-action-details"
	  }, [_c('plan', {
	    attrs: {
	      "item": _vm.item.plan,
	      "type": 'plan-data'
	    }
	  }), _c('h3', [_vm._v("My Drivers")]), _c('hr'), _c('driver-subscription-slots', {
	    attrs: {
	      "subscriptionId": _vm.item.id,
	      "clientId": _vm.item.client.id,
	      "maxDrivers": _vm.item.plan.max_drivers,
	      "subscribedDrivers": _vm.item.drivers
	    }
	  }), _c('div', {
	    staticClass: "subscription-action"
	  }, [_c('button', {
	    staticClass: "pm-button-iconbutton",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Edit"), _c('i', {
	    staticClass: "fa fa-pencil"
	  })]), _c('router-link', {
	    staticClass: "button pm-button-iconbutton",
	    attrs: {
	      "to": {
	        name: 'subscription',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("Details"), _c('i', {
	    staticClass: "fa fa-info"
	  })])], 1)], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2345 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-driver-flag"
	  }, [_c('ModalReveal', [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Add flag")]), _c('array-edit', {
	    attrs: {
	      "options": _vm.extras,
	      "values": _vm.body.flags
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.add,
	      "disabled": Object.keys(_vm.body.flags).length === 0
	    },
	    slot: "footer"
	  }, [_vm._v("Add")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2346 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-smart-edit"
	  }, [_c('SearchVehicleAvailability', {
	    attrs: {
	      "selectable": false,
	      "vehicle": _vm.item.vehicle
	    }
	  }), _c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2347 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-packet-list"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2348 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-configuration-item"
	  }, [_c('b', [_vm._v(_vm._s(_vm.item.description) + " [ " + _vm._s(_vm.itemKey) + " ]")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-11"
	  }, [(_vm.item.possibile === null && (_vm.item.type === 'string' || _vm.item.type === 'numeric')) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.item.default
	    },
	    domProps: {
	      "value": (_vm.value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.value = $event.target.value
	      }
	    }
	  }) : (_vm.item.possibile !== null && (_vm.item.type === 'string' || _vm.item.type === 'numeric')) ? _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("- NOT SET -")]), _vm._l((_vm.item.possibile), function(p, index) {
	    return _c('option', {
	      domProps: {
	        "value": index
	      }
	    }, [_vm._v(_vm._s(p))])
	  })], 2)]) : (_vm.item.possibile === null && (_vm.item.type === 'json')) ? _c('div', [_c('JsonConf', {
	    model: {
	      value: (_vm.value),
	      callback: function($$v) {
	        _vm.value = $$v
	      },
	      expression: "value"
	    }
	  })], 1) : (_vm.item.type.split(':')[0] === 'array') ? _c('div', [(_vm.item.type.split(':')[1] === 'simple') ? _c('div', _vm._l((_vm.item.possibile), function(pos) {
	    return _c('div', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.value),
	        expression: "value"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": pos,
	        "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, pos) > -1 : (_vm.value)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.value,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = pos,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.value = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.value = $$c
	          }
	        }
	      }
	    }), _c('span', [_vm._v(_vm._s(pos))])])
	  }), 0) : (_vm.item.type.split(':')[1] === 'keyed') ? _c('div', [_vm._l((_vm.value), function(prop, iprop) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('DeleteConf', {
	      on: {
	        "click": function($event) {
	          return _vm.deleteKeyed(iprop)
	        }
	      }
	    }), _c('div', {
	      staticClass: "column small-4"
	    }, [_c('input', {
	      attrs: {
	        "type": "text",
	        "disabled": "disabled"
	      },
	      domProps: {
	        "value": iprop
	      }
	    })]), _c('div', {
	      staticClass: "column"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.value[iprop]),
	        expression: "value[iprop]"
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "...insert value here..."
	      },
	      domProps: {
	        "value": (_vm.value[iprop])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.value, iprop, $event.target.value)
	        }
	      }
	    })])], 1)
	  }), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectTmp),
	      expression: "selectTmp"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectTmp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.item.possibile), function(p) {
	    return _c('option', {
	      domProps: {
	        "value": p
	      }
	    }, [_vm._v(_vm._s(p))])
	  }), 0), _c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        return _vm.pushKeyed()
	      }
	    }
	  }, [_vm._v("ADD")])], 2) : _c('div', [(_vm.itemKey === 'fleet_reservation_surveys') ? _c('div', {
	    staticClass: "surveys"
	  }, [_c('ReservationSurveyConfiguration', {
	    attrs: {
	      "value": _vm.value,
	      "item": _vm.item
	    }
	  })], 1) : (_vm.itemKey === 'commercial_reservation_deposit_config') ? _c('div', {
	    staticClass: "deposit"
	  }, [_c('DepositConfiguration', {
	    attrs: {
	      "value": _vm.value,
	      "item": _vm.item
	    }
	  })], 1) : (_vm.itemKey === 'system_client_custom_fields') ? _c('div', {
	    staticClass: "custom-fields"
	  }, [_c('ClientCustomFieldsConfiguration', {
	    model: {
	      value: (_vm.value),
	      callback: function($$v) {
	        _vm.value = $$v
	      },
	      expression: "value"
	    }
	  })], 1) : (_vm.itemKey === 'system_fields_configuration') ? _c('div', {
	    staticClass: "system-fields"
	  }, [_c('SystemFieldsConfiguration', {
	    key: _vm.itemKey,
	    model: {
	      value: (_vm.value),
	      callback: function($$v) {
	        _vm.value = $$v
	      },
	      expression: "value"
	    }
	  })], 1) : (_vm.itemKey === 'fleet_ignore_user_position_for_vehicle') ? _c('div', {
	    staticClass: "fleet-position"
	  }, [_c('FleetPositionConfiguration', {
	    attrs: {
	      "value": _vm.value,
	      "item": _vm.item
	    }
	  })], 1) : (_vm.itemKey === 'italian-e-invoice_split_payments') ? _c('div', {
	    staticClass: "italian-e-invoice"
	  }, [_c('ItalianEInvoiceSplitPaymentConfiguration', {
	    attrs: {
	      "value": _vm.value,
	      "item": _vm.item
	    }
	  })], 1) : (_vm.itemKey === 'commercial_credit_bonus_configuration') ? _c('div', {
	    staticClass: "credit-bonus"
	  }, [_c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        _vm.pushEmptyValue(_vm.item.type.split(':')[1].split(','))
	      }
	    }
	  }, [_vm._v("Add new bonus")]), _vm._l((_vm.value), function(elem, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column shrink"
	    }, [_c('dropdown', {
	      attrs: {
	        "icon": 'fa fa-ellipsis-v fa-2x action',
	        "position": 'top'
	      }
	    }, [_c('div', {
	      staticClass: "dropdown-buttons"
	    }, [_c('CreditBonusConfiguration', {
	      attrs: {
	        "item": elem
	      },
	      on: {
	        "update": _vm.update
	      }
	    }), _c('button', {
	      staticClass: "button",
	      on: {
	        "click": function($event) {
	          return _vm.value.splice(index, 1)
	        }
	      }
	    }, [_vm._v("Delete")]), (elem.amount !== null) ? _c('CreditBonusInformation', {
	      attrs: {
	        "item": elem
	      }
	    }) : _vm._e()], 1)])], 1), _c('div', {
	      staticClass: "column"
	    }, [_c('label', [_vm._v("Name")]), _c('div', [_vm._v(_vm._s(elem.name))])]), _c('div', {
	      staticClass: "column"
	    }, [_c('label', [_vm._v("Amount")]), _c('div', [_vm._v(_vm._s(elem.amount))])]), _c('div', {
	      staticClass: "column"
	    }, [_c('label', [_vm._v("Promo amount")]), _c('div', [_vm._v(_vm._s(elem.promo_amount))])])])
	  })], 2) : _vm._l((_vm.value), function(elem, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('DeleteConf', {
	      on: {
	        "click": function($event) {
	          return _vm.value.splice(index, 1)
	        }
	      }
	    }), _vm._l((elem), function(val, inx) {
	      return _c('div', {
	        staticClass: "column"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index][inx]),
	          expression: "value[index][inx]"
	        }],
	        attrs: {
	          "type": "text",
	          "placeholder": inx
	        },
	        domProps: {
	          "value": (_vm.value[index][inx])
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.value[index], inx, $event.target.value)
	          }
	        }
	      })])
	    })], 2)
	  }), (_vm.itemKey !== 'commercial_credit_bonus_configuration') ? _c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        _vm.pushEmptyValue(_vm.item.type.split(':')[1].split(','))
	      }
	    }
	  }, [_vm._v("ADD")]) : _vm._e()], 2)]) : _c('div', [_c('h1', [_vm._v("TYPE NOT MANAGED!")]), _c('pre', [_vm._v(_vm._s(_vm.item))])])]), _c('div', {
	    staticClass: "column small-1"
	  }, [_c('button', {
	    staticClass: "button small",
	    on: {
	      "click": _vm.update
	    }
	  }, [_vm._v("UPDATE")]), (_vm.item._translatable) ? [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.item._translatable
	    }
	  })] : _vm._e()], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 2349 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.entity) ? _c('div', {
	    staticClass: "component-reservation-action-buttons"
	  }, [(_vm.item) ? _c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "dropdown menu",
	    attrs: {
	      "data-dropdown-menu": ""
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#Item-1"
	    }
	  }, [_vm._v("Action")]), _c('ul', {
	    staticClass: "menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v("Open")])]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("Close")])]), _c('li', [_c('PreauthReveal', {
	    attrs: {
	      "reservation": _vm.entity
	    }
	  })], 1), _c('li', [_c('TerminateReservationReveal', {
	    attrs: {
	      "entity": _vm.entity
	    }
	  })], 1), _c('li', [_c('a', {
	    on: {
	      "click": _vm.extend
	    }
	  }, [_vm._v("Extend")])]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.voidR
	    }
	  }, [_vm._v("Void")])]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v("Cancel")])]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.resend
	    }
	  }, [_vm._v("Force Resend")])]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.cleanup
	    }
	  }, [_vm._v("Cleanup")])]), _c('li', [_c('ChargingSessionReveal', {
	    attrs: {
	      "reservation": _vm.entity
	    }
	  })], 1), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        path: 'report-reservation',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("Report")])], 1), _c('li', [_c('ActionButton', {
	    attrs: {
	      "action": _vm.reconciliate
	    }
	  }, [_c('a', [_vm._v("Reconciliate charged cost")])])], 1), _c('li', [_c('ActionButton', {
	    attrs: {
	      "action": _vm.complete,
	      "saveLabel": "Mark as completed"
	    }
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "slot": "prompt"
	    },
	    slot: "prompt"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Mark R" + _vm._s(_vm.entity.number) + " as completed")]), _c('label', [_vm._v("Strategy"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.strategy),
	      expression: "strategy"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.strategy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "original_end"
	    }
	  }, [_vm._v("End as the booked end")]), _c('option', {
	    attrs: {
	      "value": "first_end_sent"
	    }
	  }, [_vm._v("First end sent")]), _c('option', {
	    attrs: {
	      "value": "user_defined"
	    }
	  }, [_vm._v("Custom")])])]), (_vm.strategy === 'user_defined') ? _c('div', {
	    staticClass: "user-defined"
	  }, [_c('label', [_vm._v("Select Date")]), _c('DatePicker', {
	    attrs: {
	      "pickTime": true,
	      "format": "yyyy-mm-dd hh:ii"
	    },
	    model: {
	      value: (_vm.value),
	      callback: function($$v) {
	        _vm.value = $$v
	      },
	      expression: "value"
	    }
	  })], 1) : _vm._e(), (_vm.entity.booking_mode === 'OWFF') ? [_c('label', [_vm._v("End on selected parking lot")]), _c('SelectizeParkingLot', {
	    model: {
	      value: (_vm.extra.owff_dropoff_parking_lot),
	      callback: function($$v) {
	        _vm.$set(_vm.extra, "owff_dropoff_parking_lot", $$v)
	      },
	      expression: "extra.owff_dropoff_parking_lot"
	    }
	  })] : _vm._e()], 2)]), _c('a', [_vm._v("Mark as completed")])])], 1), _c('li', [_c('a', {
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Edit")])]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.findReplace
	    }
	  }, [_vm._v("Find a replace vehicle")])]), (_vm.entity.maintenance) ? _c('li', [_c('ModalReveal', [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Replace operator")]), _c('h2', [_vm._v("Replace operator")]), _c('selectize-maintenance-driver', {
	    attrs: {
	      "value-field": "id"
	    },
	    model: {
	      value: (_vm.replaceDriverBody.driver_id),
	      callback: function($$v) {
	        _vm.$set(_vm.replaceDriverBody, "driver_id", $$v)
	      },
	      expression: "replaceDriverBody.driver_id"
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)], 1) : _vm._e()])])]) : _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('button', {
	    staticClass: "button success",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v("Open")]), _c('button', {
	    staticClass: "button warning",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("Close")]), _c('button', {
	    staticClass: "button alert",
	    on: {
	      "click": _vm.voidR
	    }
	  }, [_vm._v("Void")]), _c('button', {
	    staticClass: "button warning",
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v("Cancel")]), _c('button', {
	    staticClass: "button warning",
	    on: {
	      "click": _vm.resend
	    }
	  }, [_vm._v("Force resend")]), _c('ReservationUncoveredAmountReveal')], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2350 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: _vm.componentId
	  }, [_c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Action"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.action),
	      expression: "body.action"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Route name or route path on the app"
	    },
	    domProps: {
	      "value": (_vm.body.action)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "action", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Title"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.title),
	      expression: "body.title"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "title", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Slug"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.slug),
	      expression: "body.slug"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.slug)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "slug", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Button label"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.button_labels),
	      expression: "body.button_labels"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.button_labels)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "button_labels", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row column"
	  }, [_c('label', [_vm._v("Content")]), _c('Editor', {
	    model: {
	      value: (_vm.body.content),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "content", $$v)
	      },
	      expression: "body.content"
	    }
	  })], 1), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2351 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-parking-group"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Parking Group Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  })]), _c('label', [_vm._v("Vat"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vat_id),
	      expression: "vat_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.vat_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Select custom vat")]), _vm._l((_vm.vats), function(vat) {
	    return _c('option', {
	      domProps: {
	        "value": vat.id
	      }
	    }, [_vm._v(_vm._s(vat.description) + " (" + _vm._s(vat.name) + " " + _vm._s(vat.percentage) + "%)")])
	  })], 2)])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Booking Mode")]), _c('BookingModeSelect', {
	    model: {
	      value: (_vm.reservation_type),
	      callback: function($$v) {
	        _vm.reservation_type = $$v
	      },
	      expression: "reservation_type"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row columns"
	  }, [_c('button', {
	    staticClass: "button",
	    class: {
	      disabled: !_vm.name || !_vm.reservation_type
	    },
	    on: {
	      "click": _vm.createParkingGroup
	    }
	  }, [_vm._v("Add")])])])
	},staticRenderFns: []}

/***/ }),
/* 2352 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-user-edit"
	  }, [_c('div', {
	    staticClass: "row column card pt-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Username"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.username),
	      expression: "user.username"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.user.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "username", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Email"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "email", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Enabled")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.enabled),
	      expression: "user.enabled"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.user.enabled) ? _vm._i(_vm.user.enabled, null) > -1 : (_vm.user.enabled)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.user.enabled,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.user, "enabled", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.user, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.user, "enabled", $$c)
	        }
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Roles"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.roles),
	      expression: "user.roles"
	    }],
	    attrs: {
	      "multiple": "multiple"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.user, "roles", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.roles), function(role) {
	    return _c('option', {
	      domProps: {
	        "value": role.id
	      }
	    }, [_vm._v(_vm._s(role.name))])
	  }), 0)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Federation")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.federation_id),
	      expression: "user.federation_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.user, "federation_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("--")]), _vm._l((_vm.federations.items), function(federation) {
	    return _c('option', {
	      domProps: {
	        "value": federation.id
	      }
	    }, [_vm._v(_vm._s(federation.name))])
	  })], 2)])]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2353 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-subscriptions"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "driver-subscriptions tabs-inner-content"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "componentType": "driver-data"
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('h2', [_vm._v("Subscriptions")])])
	}]}

/***/ }),
/* 2354 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tabs-panel",
	    class: {
	      'is-active': _vm.active
	    },
	    attrs: {
	      "id": _vm.$toDashedString(_vm.headerName)
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 2355 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-note"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('InstructionButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("IN" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.title))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.subtitle))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("N° of steps")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.steps.length))]), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'instruction',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])], 1)]) : _vm._e(), (_vm.$is('entityList')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('InstructionButtons', {
	    attrs: {
	      "item": _vm.item,
	      "vehicle": true
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("IN" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.instruction.title))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.instruction.subtitle))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("N° of steps")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.instruction.steps.length))]), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'instruction',
	        params: {
	          id: _vm.item.instruction.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2356 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-editor"
	  }, [_c('ckeditor', {
	    attrs: {
	      "editor": _vm.editor,
	      "config": _vm.editorConfig,
	      "disabled": _vm.disabled
	    },
	    on: {
	      "ready": _vm.setText
	    },
	    model: {
	      value: (_vm.editorData),
	      callback: function($$v) {
	        _vm.editorData = $$v
	      },
	      expression: "editorData"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2357 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-note-list row column"
	  }, [_c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.loadZones,
	      "showPerPageSelect": false
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2358 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-drivers"
	  }, [_vm._m(0), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Client Drivers")])])])
	}]}

/***/ }),
/* 2359 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('EditInterventionRequestReveal', {
	    attrs: {
	      "request": _vm.item
	    }
	  }), _c('DetailInterventionRequestReveal', {
	    attrs: {
	      "request": _vm.item
	    }
	  }), _c('CompleteInterventionRequestReveal', {
	    attrs: {
	      "request": _vm.item
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true,
	      "color-class": "warning"
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2360 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Document type"), _c('SelectizeDocumentType', {
	    attrs: {
	      "max-items": 1,
	      "selected-value": _vm.localValue.document_type_id
	    },
	    on: {
	      "optionSelected": _vm.documentTypeSelected
	    }
	  })], 1), _c('label', [_vm._v("Document group"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.document_group),
	      expression: "localValue.document_group"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.localValue.document_group)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "document_group", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Maximum failed transactions"), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.maximum_client_failed_transactions),
	      expression: "localValue.maximum_client_failed_transactions"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Transactions count (count|days 10|30)",
	      "pattern": "[0-9]+\\|[0-9]+"
	    },
	    domProps: {
	      "value": (_vm.localValue.maximum_client_failed_transactions)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "maximum_client_failed_transactions", $event.target.value)
	      }
	    }
	  })])])]), _c('label', [_vm._v("Driver bookings in last days"), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.minimum_bookings_in_last_days),
	      expression: "localValue.minimum_bookings_in_last_days"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Reservation count (eg. count|days 10|30)"
	    },
	    domProps: {
	      "value": (_vm.localValue.minimum_bookings_in_last_days)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "minimum_bookings_in_last_days", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Driver registration"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.minimum_driver_registration_seniority),
	      expression: "localValue.minimum_driver_registration_seniority"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "1",
	      "placeholder": "Years of registration"
	    },
	    domProps: {
	      "value": (_vm.localValue.minimum_driver_registration_seniority)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "minimum_driver_registration_seniority", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Driver age"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.minimum_driver_age),
	      expression: "localValue.minimum_driver_age"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.localValue.minimum_driver_age)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "minimum_driver_age", $event.target.value)
	      }
	    }
	  })])])]), _c('label', [_vm._v("Client minimum invoiced"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.minimum_client_invoiced),
	      expression: "localValue.minimum_client_invoiced"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.localValue.minimum_client_invoiced)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "minimum_client_invoiced", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Minimum document emission years"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.minimum_document_emission_years),
	      expression: "localValue.minimum_document_emission_years"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.localValue.minimum_document_emission_years)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "minimum_document_emission_years", $event.target.value)
	      }
	    }
	  }), _vm._m(0)])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "help-text"
	  }, [_c('small', [_vm._v("Overrides global configuration")])])
	}]}

/***/ }),
/* 2361 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-survey-configuration"
	  }, _vm._l((_vm.value), function(elem, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column shrink delete"
	    }, [_c('DeleteConf', {
	      on: {
	        "click": function($event) {
	          return _vm.value.splice(index, 1)
	        }
	      }
	    })], 1), _vm._l((elem), function(val, inx) {
	      return _c('div', {
	        staticClass: "column"
	      }, [(inx === 'reporting_type_id') ? _c('label', [_vm._v(_vm._s(inx)), _c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index].reporting_type_id),
	          expression: "value[index].reporting_type_id"
	        }],
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.value[index], "reporting_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, [_c('option', {
	        domProps: {
	          "value": null
	        }
	      }, [_vm._v("--")]), _vm._l((_vm.reportingTypes), function(type) {
	        return _c('option', {
	          domProps: {
	            "value": type.id
	          }
	        }, [_vm._v(_vm._s(type.name))])
	      })], 2)]) : (inx === 'rating_threshold') ? _c('label', [_vm._v(_vm._s(inx)), _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index][inx]),
	          expression: "value[index][inx]"
	        }],
	        attrs: {
	          "type": "number",
	          "min": "1",
	          "max": "5"
	        },
	        domProps: {
	          "value": (_vm.value[index][inx])
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.value[index], inx, $event.target.value)
	          }
	        }
	      })]) : (inx === 'mandatory') ? _c('div', {
	        staticClass: "mandatory"
	      }, [_c('label', [_vm._v(_vm._s(inx))]), _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index].mandatory),
	          expression: "value[index].mandatory"
	        }],
	        attrs: {
	          "type": "checkbox"
	        },
	        domProps: {
	          "checked": Array.isArray(_vm.value[index].mandatory) ? _vm._i(_vm.value[index].mandatory, null) > -1 : (_vm.value[index].mandatory)
	        },
	        on: {
	          "change": function($event) {
	            var $$a = _vm.value[index].mandatory,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = null,
	                $$i = _vm._i($$a, $$v);
	              if ($$el.checked) {
	                $$i < 0 && (_vm.$set(_vm.value[index], "mandatory", $$a.concat([$$v])))
	              } else {
	                $$i > -1 && (_vm.$set(_vm.value[index], "mandatory", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	              }
	            } else {
	              _vm.$set(_vm.value[index], "mandatory", $$c)
	            }
	          }
	        }
	      })]) : _c('label', [_vm._v(_vm._s(inx)), _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index][inx]),
	          expression: "value[index][inx]"
	        }],
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": (_vm.value[index][inx])
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.value[index], inx, $event.target.value)
	          }
	        }
	      })])])
	    })], 2)
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2362 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-attributes-action-buttons"
	  }, [_c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])])
	},staticRenderFns: []}

/***/ }),
/* 2363 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('ModalReveal', [_c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "slot": "trigger",
	      "type": "button"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.name),
	      expression: "item.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Priority"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.priority),
	      expression: "item.priority"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.priority)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "priority", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Group"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.group),
	      expression: "item.group"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.item, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', [_vm._v("ALL")]), _c('option', [_vm._v("GENERAL")]), _c('option', [_vm._v("PLAN")])])])])]), _c('div', {
	    staticClass: "row columns text-center"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save Toc Type")])])]), _c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2364 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2365 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm.key,
	    ref: _vm.componentId,
	    on: {
	      "input": _vm.closeInput
	    }
	  }, [(_vm.item && !_vm.item.component) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]) : _c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Token")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.token),
	      expression: "body.token"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.token)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "token", $event.target.value)
	      }
	    }
	  }), _c('label', [_vm._v("Destination")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.destination_type),
	      expression: "body.destination_type"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "destination_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function () { return _vm.body.destination_id = null; }]
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Select an option")]), _vm._l((_vm.destinations), function(destination, key) {
	    return _c('option', {
	      domProps: {
	        "value": key
	      }
	    }, [_vm._v(_vm._s(destination))])
	  })], 2), (_vm.body.destination_type === 'App\\Models\\Plan') ? _c('selectize-plan', {
	    attrs: {
	      "value-field": true
	    },
	    model: {
	      value: (_vm.body.destination_id),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "destination_id", $$v)
	      },
	      expression: "body.destination_id"
	    }
	  }) : _vm._e(), (_vm.body.destination_type === 'App\\Models\\CommonCost') ? _c('selectize-common-cost', {
	    attrs: {
	      "value-field": true
	    },
	    model: {
	      value: (_vm.body.destination_id),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "destination_id", $$v)
	      },
	      expression: "body.destination_id"
	    }
	  }) : _vm._e(), (_vm.body.destination_type === 'App\\Models\\Federation') ? _c('selectize-federation', {
	    attrs: {
	      "value-field": true
	    },
	    model: {
	      value: (_vm.body.destination_id),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "destination_id", $$v)
	      },
	      expression: "body.destination_id"
	    }
	  }) : _vm._e()], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Additional"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.additional_type),
	      expression: "additional_type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.additional_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Select an option")]), _vm._l((_vm.destinations), function(destination, key) {
	    return _c('option', {
	      domProps: {
	        "value": key
	      }
	    }, [_vm._v(_vm._s(destination))])
	  })], 2)]), (_vm.additional_type === 'App\\Models\\Plan') ? _c('selectize-plan', {
	    attrs: {
	      "value-field": true
	    },
	    model: {
	      value: (_vm.additional_id),
	      callback: function($$v) {
	        _vm.additional_id = $$v
	      },
	      expression: "additional_id"
	    }
	  }) : _vm._e(), (_vm.additional_type === 'App\\Models\\CommonCost') ? _c('selectize-common-cost', {
	    attrs: {
	      "value-field": true
	    },
	    model: {
	      value: (_vm.additional_id),
	      callback: function($$v) {
	        _vm.additional_id = $$v
	      },
	      expression: "additional_id"
	    }
	  }) : _vm._e(), (_vm.additional_type === 'App\\Models\\Federation') ? _c('selectize-federation', {
	    attrs: {
	      "value-field": true
	    },
	    model: {
	      value: (_vm.additional_id),
	      callback: function($$v) {
	        _vm.additional_id = $$v
	      },
	      expression: "additional_id"
	    }
	  }) : _vm._e(), _c('button', {
	    staticClass: "small button",
	    attrs: {
	      "disabled": _vm.additional_type === null || _vm.additional_id === null
	    },
	    on: {
	      "click": _vm.addAdditional
	    }
	  }, [_vm._v("Add")]), _vm._l((_vm.body.additional), function(value, i) {
	    return _c('div', {
	      staticClass: "prop-item"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('span', {
	      staticClass: "input-group-label"
	    }, [_vm._v(_vm._s(value.class.split('\\')[value.class.split('\\').length - 1]))]), _c('input', {
	      staticClass: "input-group-field",
	      attrs: {
	        "type": "text",
	        "disabled": "disabled"
	      },
	      domProps: {
	        "value": value.id
	      }
	    }), _c('div', {
	      staticClass: "input-group-button"
	    }, [_c('button', {
	      staticClass: "button warning fa fa-times",
	      on: {
	        "click": function () {
	          _vm.body.additional.splice(i, 1)
	        }
	      }
	    })])])])
	  })], 2)]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2366 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-logs"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('accordion', _vm._l((_vm.items), function(l) {
	    return _c('accordion-item', {
	      attrs: {
	        "title": _vm.$dateFormat(l.date.date, "DD-MM-YYYY HH:mm:ss") + ' | ' + l.action
	      }
	    }, [_c('log', {
	      attrs: {
	        "item": l
	      }
	    })], 1)
	  }), 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('h2', [_vm._v("Logs")])])
	}]}

/***/ }),
/* 2367 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2368 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-client"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "options": _vm.options,
	      "value-field": "code",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Countries"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2369 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-delete-conf"
	  }, [_c('button', {
	    staticClass: "button small warning fa fa-times",
	    on: {
	      "click": _vm.deleteConf
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2370 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component component-backoffice-deposit-configuration"
	  }, [(!_vm.value || _vm.value.length === 0) ? _c('div', {
	    staticClass: "def"
	  }, _vm._l((_vm.item.default), function(elem, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, _vm._l((elem), function(val, inx) {
	      return _c('div', {
	        staticClass: "column"
	      }, [_c('input', {
	        attrs: {
	          "type": "text",
	          "placeholder": inx,
	          "disabled": "disabled"
	        },
	        domProps: {
	          "value": _vm.item.default[index][inx]
	        }
	      })])
	    }), 0)
	  }), 0) : _vm._l((_vm.value), function(elem, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column shrink delete"
	    }, [_c('DeleteConf', {
	      on: {
	        "click": function($event) {
	          return _vm.value.splice(index, 1)
	        }
	      }
	    })], 1), _vm._l((elem), function(val, inx) {
	      return _c('div', {
	        staticClass: "column"
	      }, [(inx === 'strategy') ? _c('div', {
	        staticClass: "strategy"
	      }, [_c('label', [_vm._v(_vm._s(inx)), _c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index].strategy),
	          expression: "value[index].strategy"
	        }],
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.value[index], "strategy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, _vm._l((_vm.strategies), function(strategy) {
	        return _c('option', [_vm._v(_vm._s(strategy))])
	      }), 0)])]) : (inx === 'booking_mode') ? _c('div', {
	        staticClass: "booking-mode"
	      }, [_c('label', [_vm._v(_vm._s(inx)), _c('BookingModeSelect', {
	        attrs: {
	          "isFilter": true
	        },
	        model: {
	          value: (_vm.value[index].booking_mode),
	          callback: function($$v) {
	            _vm.$set(_vm.value[index], "booking_mode", $$v)
	          },
	          expression: "value[index].booking_mode"
	        }
	      })], 1)]) : (inx === 'plan') ? _c('div', {
	        staticClass: "booking-mode"
	      }, [_c('label', [_vm._v(_vm._s(inx)), _c('SelectizePlan', {
	        attrs: {
	          "allowEmptyOption": true,
	          "selectedValue": parseInt(_vm.value[index].plan)
	        },
	        on: {
	          "optionSelected": function($event) {
	            return _vm.setPlan($event, index)
	          },
	          "optionRemoved": function($event) {
	            return _vm.unsetPlan(index)
	          }
	        }
	      })], 1)]) : (inx === 'vehicle_category') ? _c('div', {
	        staticClass: "vehicle-category"
	      }, [_c('label', [_vm._v(_vm._s(inx)), _c('SelectizeCategory', {
	        attrs: {
	          "allowEmptyOption": true,
	          "selectedValue": parseInt(_vm.value[index].vehicle_category)
	        },
	        on: {
	          "optionSelected": function($event) {
	            return _vm.setCategory($event, index)
	          },
	          "optionRemoved": function($event) {
	            return _vm.unsetCategory(index)
	          }
	        }
	      })], 1)]) : _c('div', {
	        staticClass: "other-val"
	      }, [_c('label', [_vm._v(_vm._s(inx)), _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index][inx]),
	          expression: "value[index][inx]"
	        }],
	        attrs: {
	          "type": "text",
	          "placeholder": inx
	        },
	        domProps: {
	          "value": (_vm.value[index][inx])
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.value[index], inx, $event.target.value)
	          }
	        }
	      })])])])
	    })], 2)
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 2371 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('canvas')
	},staticRenderFns: []}

/***/ }),
/* 2372 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.entity) ? _c('div', {
	    staticClass: "component-card-action-buttons"
	  }, [(_vm.actions.length) ? _c('div', {
	    staticClass: "dropdown-buttons"
	  }, _vm._l((_vm.actions), function(action) {
	    return _c('button', {
	      key: action.name,
	      staticClass: "button",
	      class: action.severity,
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": action.callback
	      }
	    }, [_vm._v(_vm._s(action.name))])
	  }), 0) : _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('span', [_vm._v("No actions available")])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2373 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-packet-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm._uid,
	    ref: "editPacketModal"
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('h2', [_vm._v("Edit packet")]), _c('PacketForm', {
	    model: {
	      value: (_vm.body),
	      callback: function($$v) {
	        _vm.body = $$v
	      },
	      expression: "body"
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.edit
	    },
	    slot: "footer"
	  }, [_vm._v("Save")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2374 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-einvoice-status"
	  }, [_c('ActionButton', {
	    attrs: {
	      "slot": "trigger",
	      "action": _vm.getStatus
	    },
	    slot: "trigger"
	  }, [_vm._v("Status SDI")]), _c('ModalReveal', {
	    on: {
	      "input": _vm.closeSdiStatus
	    },
	    model: {
	      value: (_vm.openSdiStatus),
	      callback: function($$v) {
	        _vm.openSdiStatus = $$v
	      },
	      expression: "openSdiStatus"
	    }
	  }, [(_vm.sdiStatus) ? _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Status fattura")]), _c('div', {
	    staticClass: "fname"
	  }, [_vm._v("Nome file: " + _vm._s(_vm.sdiStatus.filename))]), _c('div', {
	    staticClass: "ecode"
	  }, [_vm._v("Errore: " + _vm._s(_vm.sdiStatus.errorCode) + " " + _vm._s(_vm.sdiStatus.errorDescription))]), _c('div', {
	    staticClass: "download"
	  }, [_vm._v("Apri XML ricevuto dallo SDI")]), _c('div', {
	    staticClass: "download"
	  }, [_vm._v("(CTRL+U per vedere il contenuto)")]), _c('a', {
	    staticClass: "fa fa-code fa-2x",
	    on: {
	      "click": _vm.openSentXml
	    }
	  }), _c('hr'), _vm._l((_vm.sdiStatus.invoices), function(status) {
	    return _c('div', {
	      staticClass: "status"
	    }, [_c('div', {
	      staticClass: "line"
	    }, [_vm._v("N° " + _vm._s(status.number) + " - " + _vm._s(status.status) + " " + _vm._s(status.description))]), _c('div', {
	      staticClass: "line"
	    }, [_vm._v(_vm._s(status.statusDescription))])])
	  })], 2)])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2375 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-credit-records"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "component-credit-record"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column expanded"
	  }, [_c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v("PR" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('small', [_c('span', [_vm._v(_vm._s(_vm.item.type))])])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "fiel-content"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])])]), _c('div', {
	    staticClass: "column shrink pl-0"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('PacketRecordButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1)]), _c('div', {
	    staticClass: "row text-center pt-0"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Valid From")]), (_vm.item.valid_from) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.valid_from, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("--")])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Valid To")]), (_vm.item.valid_to) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.valid_to, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("--")])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Minutes")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.item.minutes))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Distance")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.item.distance))])])])])])]) : _vm._e(), (_vm.$is('usages')) ? _c('div', {
	    staticClass: "component-credit-record"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("PR" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('small', [_c('span', [_vm._v(_vm._s(_vm.item.type))]), (_vm.item.type === 'USE') ? _c('span', [_vm._v("  " + _vm._s(_vm.item.walletable_type ? _vm.item.walletable_type : '--') + " " + _vm._s(_vm.item.walletable_id ? _vm.item.walletable_id : '--'))]) : _vm._e()])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Used minutes")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.item.minutes))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Used distance")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.item.distance))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "fiel-content"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.created_at))])])])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2376 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('reservation-id')) ? _c('div', {
	    staticClass: "field-reservation-id"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "reservation-number pm-text-highlight"
	  }, [_vm._v("R" + _vm._s(_vm.item.number))])])], 1)]) : (_vm.$is('vehicle-info')) ? _c('div', {
	    staticClass: "field-vehicle-info text-center"
	  }, [_c('img', {
	    staticClass: "vehicle-picture",
	    attrs: {
	      "src": _vm.item.vehicle.picture_external
	    }
	  }), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.vehicle.brand) + " " + _vm._s(_vm.item.vehicle.model))]), _c('vehicle-fields', {
	    attrs: {
	      "fieldName": 'vehicle-plate',
	      "item": _vm.item.vehicle
	    }
	  })], 1) : (_vm.$is('vehicle-info-no-img')) ? _c('div', {
	    staticClass: "field-vehicle-info text-center"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.vehicle.brand) + " " + _vm._s(_vm.item.vehicle.model))]), _c('vehicle-fields', {
	    attrs: {
	      "fieldName": 'vehicle-plate',
	      "item": _vm.item.vehicle
	    }
	  })], 1) : (_vm.$is('reservation-start')) ? _c('div', {
	    staticClass: "field-reservation-start"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMM YYYY HH:mm')))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, "DD MMM YYYY HH:mm")))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateDifference(_vm.item.start, _vm.item.end)))])]) : (_vm.$is('reservation-start-end')) ? _c('div', {
	    staticClass: "field-reservation-start"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMM HH:mm')))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, "DD MMM HH:mm")))])]) : (_vm.$is('reservation-bmode')) ? _c('div', {
	    staticClass: "field-reservation-bmode"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.booking_mode))])]) : (_vm.$is('reservation-distance')) ? _c('div', {
	    staticClass: "field-reservation-distance"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_c('span', {
	    staticClass: "fa fa-tachometer"
	  }), _c('span', [_vm._v("  " + _vm._s(Math.round(_vm.item.distance)) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])])]) : (_vm.$is('reservation-hours')) ? _c('div', {
	    staticClass: "field-reservation-hours"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateDifference(_vm.item.start, _vm.item.end)))])]) : (_vm.$is('reservation-cost')) ? _c('div', {
	    staticClass: "field-reservation-cost"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_c('span', {
	    staticClass: "fa fa-money"
	  }), _c('span', [_vm._v("  " + _vm._s(_vm.item.cost === null ? '--' : _vm.currency + _vm.item.cost))])])]) : (_vm.$is('reservation-status')) ? _c('div', {
	    staticClass: "field-reservation-status"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Billing: " + _vm._s(_vm.item.billing_status))]), (_vm.item.billing_status === 'UNCHARGEABLE') ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Cancelled: " + _vm._s(_vm.item.canceled))]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2377 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('div', {
	    staticClass: "row card"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Group Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.group.name),
	      expression: "group.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.group.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.group, "name", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Policies"), _c('SelectizePolicy', {
	    attrs: {
	      "selectedValues": _vm.group.policies,
	      "maxItems": null
	    },
	    on: {
	      "optionSelected": _vm.updatePolicies,
	      "optionRemoved": _vm.removePolicies
	    }
	  })], 1)]), _c('div', {
	    staticClass: "column"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.group.global),
	      expression: "group.global"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.group.global) ? _vm._i(_vm.group.global, null) > -1 : (_vm.group.global)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.group.global,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.group, "global", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.group, "global", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.group, "global", $$c)
	        }
	      }
	    }
	  }), _c('label', [_vm._v("Add all Drivers")]), _c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.group.global),
	      expression: "!group.global"
	    }]
	  }, [_vm._v("Drivers"), _c('SelectizeDriver', {
	    ref: "selectizeDrivers",
	    attrs: {
	      "maxItems": null
	    },
	    on: {
	      "optionSelected": _vm.updateDrivers,
	      "optionRemoved": _vm.removeDrivers
	    }
	  })], 1)])]), (_vm.group.id !== null && !_vm.group.global) ? _c('div', {
	    staticClass: "row"
	  }, [(_vm.loaded) ? _c('div', {
	    staticClass: "column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.componentDriver,
	      "dataLoader": _vm.loadDrivers,
	      "componentType": "groupList",
	      "selectableList": true,
	      "resultsPerPage": 5
	    },
	    model: {
	      value: (_vm.selected),
	      callback: function($$v) {
	        _vm.selected = $$v
	      },
	      expression: "selected"
	    }
	  })], 1) : _vm._e()]) : _vm._e(), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save,
	      "disabled": _vm.group.name == null || _vm.group.name === ''
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2378 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": this._uid
	    }
	  }, [_c('div', [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2379 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-federation-add"
	  }, [_c('div', {
	    staticClass: "row column card p-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Federation Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row column"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2380 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$isModuleEnabled(_vm.module)) ? _c('div', {
	    staticClass: "component-is-module-enabled"
	  }, [_vm._t("default")], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2381 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hardware-simulator"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "hw-main-section"
	  }, [_c('h3', {
	    staticClass: "hw-title align-self-middle"
	  }, [_vm._v("Vehicle Status")]), _c('div', {
	    staticClass: "hw-main-row align-center align-middle"
	  }, [_c('div', {
	    staticClass: "hw-plate"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.serial),
	      expression: "serial"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.serial)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.serial = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "hw-car",
	    class: {
	      running: _vm.ignition_status
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/hwsim/model3.png"
	    }
	  }), _c('label', {
	    staticClass: "hw-ignition pulse",
	    class: {
	      disabled: !_vm.serial || _vm.serial.length < 6, active: _vm.ignition_status
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.toggleIgnition()
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ignition_status),
	      expression: "ignition_status"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.ignition_status) ? _vm._i(_vm.ignition_status, null) > -1 : (_vm.ignition_status)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.ignition_status,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.ignition_status = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.ignition_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.ignition_status = $$c
	        }
	      }
	    }
	  })]), _c('label', {
	    staticClass: "hw-doors pulse",
	    class: {
	      disabled: !_vm.serial || _vm.serial.length < 6, active: _vm.door_status
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.toggleDoors()
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.door_status),
	      expression: "door_status"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.door_status) ? _vm._i(_vm.door_status, null) > -1 : (_vm.door_status)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.door_status,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.door_status = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.door_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.door_status = $$c
	        }
	      }
	    }
	  })])]), (_vm.reservation && _vm.reservation.reservation) ? _c('div', {
	    staticClass: "hw-on-board"
	  }, [(_vm.reservation.reservation.status === 'STARTED') ? _c('p', {
	    staticClass: "hw-label active"
	  }, [_vm._v("client on board")]) : _c('p', {
	    staticClass: "hw-label"
	  }, [_vm._v("no client on board")])]) : _vm._e()]), (_vm.reservation && _vm.reservation.reservation) ? _c('div', {
	    staticClass: "hw-main-row align-center align-middle hw-data"
	  }, [_c('div', {
	    staticClass: "hw-column"
	  }, [_c('p', [_vm._v("reservation number")]), _c('p', {
	    staticClass: "hw-res-number"
	  }, [_vm._v(_vm._s(_vm.reservation.reservation.number))])]), _c('div', {
	    staticClass: "hw-column"
	  }, [_c('p', {
	    staticClass: "hw-date"
	  }, [_vm._v(_vm._s(_vm.format(_vm.reservation.reservation.start).date))]), _c('p', {
	    staticClass: "hw-time"
	  }, [_vm._v(_vm._s(_vm.format(_vm.reservation.reservation.start).time))])]), _c('div', {
	    staticClass: "hw-column"
	  }, [_c('p', {
	    staticClass: "hw-date"
	  }, [_vm._v(_vm._s(_vm.format(_vm.reservation.reservation.end).date))]), _c('p', {
	    staticClass: "hw-time"
	  }, [_vm._v(_vm._s(_vm.format(_vm.reservation.reservation.end).time))])]), _c('div', {
	    staticClass: "hw-column"
	  }, [_c('p', {
	    staticClass: "hw-label",
	    class: {
	      active: _vm.reservation.reservation.status === 'STARTED'
	    }
	  }, [_vm._v(_vm._s(_vm.reservation.reservation.status))]), _c('p', {
	    staticClass: "hw-distance"
	  }, [_vm._v(_vm._s(_vm.reservation.reservation.distance) + "km driven")]), _c('p', {
	    staticClass: "hw-trips"
	  }, [_vm._v(_vm._s(_vm.reservation.reservation.trips_count) + " trips")])])]) : _vm._e()]), _c('div', {
	    staticClass: "hw-controls"
	  }, [_c('h4', {
	    staticClass: "hw-title"
	  }, [_vm._v("Trip run simulation")]), _c('p', [_vm._v("you need to open door and switch on engine")]), _c('div', {
	    staticClass: "hw-row-center"
	  }, [_c('div', {
	    staticClass: "hw-column"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.trip_distance),
	      expression: "trip_distance"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "max": "999"
	    },
	    domProps: {
	      "value": (_vm.trip_distance)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.trip_distance = $event.target.value
	      }
	    }
	  }), _c('p', [_vm._v("km")])])]), _c('div', {
	    staticClass: "hw-column hw-center-column"
	  }, [_c('button', {
	    staticClass: "hw-wheel-button",
	    class: {
	      loading: _vm.loading, disabled: !_vm.readyToSend
	    },
	    on: {
	      "click": _vm.sendTrip
	    }
	  }), _vm._m(1)]), _c('div', {
	    staticClass: "hw-column"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fuel_level),
	      expression: "fuel_level"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "max": "100"
	    },
	    domProps: {
	      "value": (_vm.fuel_level)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.fuel_level = $event.target.value
	      }
	    }
	  }), _c('p', [_vm._v("fuel level")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/hwsim/logo.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('p', {
	    staticClass: "align-self-middle"
	  }, [_vm._v("send")])])
	}]}

/***/ }),
/* 2382 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-reporting"
	  }, [_c('div', {
	    staticClass: "row columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "large-2 columns"
	  }, [_c('label', [_vm._v("Status")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.status),
	      expression: "body.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "PENDING_REVIEW"
	    }
	  }, [_vm._v("Pending Review")]), _c('option', {
	    attrs: {
	      "value": "CONFIRMED"
	    }
	  }, [_vm._v("Confirmed")]), _c('option', {
	    attrs: {
	      "value": "RESOLVED"
	    }
	  }, [_vm._v("Resolved")]), _c('option', {
	    attrs: {
	      "value": "VOIDED"
	    }
	  }, [_vm._v("Voided")])])]), _c('fieldset', {
	    staticClass: "large-3 columns"
	  }, [_c('label', [_vm._v("Type")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reporting_type_id),
	      expression: "body.reporting_type_id"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "reporting_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.isDamageReport]
	    }
	  }, _vm._l((_vm.reportingTypes), function(type) {
	    return _c('option', {
	      domProps: {
	        "value": type.id
	      }
	    }, [_vm._v(_vm._s(type.name))])
	  }), 0)]), _c('fieldset', {
	    staticClass: "large-3 columns"
	  }, [_c('label', [_vm._v("Vehicle")]), _c('selectize-vehicle', {
	    attrs: {
	      "disabled": "disabled",
	      "selectedValue": _vm.item.vehicle.id,
	      "max-items": 1
	    },
	    on: {
	      "optionSelected": _vm.vehicleSelected
	    }
	  })], 1), _c('fieldset', {
	    staticClass: "large-3 columns"
	  }, [_c('label', [_vm._v("Driver")]), _c('selectize-driver', {
	    attrs: {
	      "disabled": "disabled",
	      "selectedValue": _vm.item.driver ? _vm.item.driver.id : null,
	      "max-items": 1
	    },
	    on: {
	      "optionSelected": _vm.driverSelected
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row columns"
	  }, [_c('label', [_vm._v("Description"), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.description),
	      expression: "body.description"
	    }],
	    attrs: {
	      "rows": "8"
	    },
	    domProps: {
	      "value": (_vm.body.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "description", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "row columns"
	  }, [_c('label', {
	    attrs: {
	      "aria-describedby": "documentsUpload"
	    }
	  }, [_c('dropzone', {
	    attrs: {
	      "id": "myVueDropzone",
	      "url": _vm.dropzoneUrl
	    },
	    on: {
	      "vdropzone-success": _vm.uploaded
	    }
	  })], 1)]), (_vm.damageReport) ? _c('div', {
	    staticClass: "row columns"
	  }, [(_vm.body.damage_position_raw) ? _c('vehicle-damage', {
	    attrs: {
	      "vehicleType": _vm.item.vehicle.category.vehicle_type.name,
	      "items": _vm.body.damage_position_raw,
	      "editable": true,
	      "vehicleDamagePicture": _vm.item.vehicle.category.damage_picture_external
	    },
	    on: {
	      "damagesUpdated": _vm.updateDamages
	    }
	  }) : _vm._e()], 1) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-center"
	  }, [_c('label', [_c('input', {
	    staticClass: "button expanded",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  })])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2383 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-force-rebook"
	  }, [_c('ModalReveal', {
	    attrs: {
	      "sizing": "small"
	    }
	  }, [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Toggle hidden on map")]), _c('div', {
	    staticClass: "header",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('h2', [_vm._v("Toggle hidden on map")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-8"
	  }, [_c('h2', [_vm._v("V" + _vm._s(_vm.vehicle.id) + " " + _vm._s(_vm.vehicle.brand) + " " + _vm._s(_vm.vehicle.model))]), _c('h2', [_vm._v(_vm._s(_vm.vehicle.plate))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-4"
	  }, [_c('label', [_vm._v("Hidden")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.hidden),
	      expression: "body.hidden"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.body.hidden) ? _vm._i(_vm.body.hidden, null) > -1 : (_vm.body.hidden)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.body.hidden,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.body, "hidden", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.body, "hidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.body, "hidden", $$c)
	        }
	      }
	    }
	  })])])]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.toggleHidden
	    }
	  }, [_vm._v("Save")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2384 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-home"
	  })
	},staticRenderFns: []}

/***/ }),
/* 2385 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-vehicle-reports"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('MaintenanceRequestList', {
	    attrs: {
	      "filters": _vm.search,
	      "listing-type": "detail-listing"
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Maintenance Requests")])]), _c('div', {
	    staticClass: "action"
	  })])
	}]}

/***/ }),
/* 2386 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reporting-list row column"
	  }, [_c('reporting-list-form', {
	    on: {
	      "filterReportings": _vm.setSearch
	    }
	  }), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2387 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-log-timeline"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.tabs), function(tab, k, i) {
	    return _c('div', {
	      key: i,
	      staticClass: "column small-6 large-3 text-center"
	    }, [_c('ToggleableButton', {
	      key: k,
	      attrs: {
	        "selectable": true,
	        "value": _vm.tabs[k]
	      }
	    }, [_c('tooltip', {
	      staticClass: "has-tip",
	      attrs: {
	        "open": true,
	        "position": 'right',
	        "tip": k
	      }
	    }, [_c('span', {
	      staticClass: "fa-2x",
	      class: _vm.getTabIcon(k),
	      on: {
	        "click": function($event) {
	          return _vm.toggle(k)
	        }
	      }
	    }), _c('span', {
	      staticClass: "badge success"
	    }, [_vm._v(_vm._s(_vm.getCount(k)))])])], 1)], 1)
	  }), 0), _c('hr'), _vm._l((_vm.timeline), function(items, key) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "columns"
	    }, [_c('strong', [_vm._v(_vm._s(key))]), _vm._l((items), function(item) {
	      return _c('div', {
	        staticClass: "row log"
	      }, [_c('div', {
	        staticClass: "time columns small-2"
	      }, [_vm._v(_vm._s(_vm.$date(item.created_at).format('HH:mm:ss')))]), _vm._m(0, true), _c('div', {
	        staticClass: "icon"
	      }, [_c('i', {
	        staticClass: "fa",
	        class: _vm.getTabIcon(item.user)
	      })]), _c('div', {
	        staticClass: "column description"
	      }, [_c('div', {
	        staticClass: "user"
	      }, [_vm._v(_vm._s(item.user))]), _c('div', {
	        staticClass: "columns",
	        domProps: {
	          "innerHTML": _vm._s(item.case)
	        }
	      })])])
	    })], 2)])
	  })], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "separator"
	  }, [_c('hr')])
	}]}

/***/ }),
/* 2388 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.vehicle) ? _c('div', {
	    staticClass: "component-vehicle-overview"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "vehicle tabs-inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('vehicle', {
	    attrs: {
	      "item": _vm.vehicle,
	      "type": 'vehicle-card'
	    },
	    on: {
	      "update": _vm.loadVehicle
	    }
	  }), (_vm.vehicle.slot_id === null) ? _c('div', {
	    staticClass: "info"
	  }, [_vm._v("Vehicle is not associated do a parking lot"), _c('create-vehicle-slot', {
	    attrs: {
	      "item": _vm.vehicle
	    },
	    on: {
	      "update": _vm.loadVehicle
	    }
	  })], 1) : _vm._e()], 1), _c('div', {
	    staticClass: "columns"
	  }, [(_vm.vehicle.hardware) ? _c('vehicle-hardware', {
	    attrs: {
	      "item": _vm.vehicle.hardware,
	      "type": 'hardware-card'
	    },
	    on: {
	      "update": _vm.loadVehicle
	    }
	  }) : _c('vehicle-hardware-reveal-create', {
	    staticClass: "text-center",
	    attrs: {
	      "item": _vm.vehicle
	    },
	    on: {
	      "update": _vm.loadVehicle
	    }
	  }), _c('hr'), (_vm.vehicle && _vm.vehicle.slot_id) ? _c('SearchVehicleAvailability', {
	    attrs: {
	      "vehicle": _vm.vehicle,
	      "selectable": false
	    }
	  }) : _vm._e()], 1)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Vehicle Overview")])])])
	}]}

/***/ }),
/* 2389 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-vehicle-costs"
	  }, [_c('CreateNoteModal', {
	    attrs: {
	      "entity": _vm.note.type,
	      "entityId": _vm.$route.params.id
	    },
	    on: {
	      "noteCreated": function($event) {
	        return _vm.$refs.notesBaseList.loadData(1)
	      }
	    }
	  }), _c('div', {
	    staticClass: "container"
	  }, [_c('base-list', {
	    ref: "notesBaseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false,
	      "component-type": "entityList"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2390 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-plan"
	  }, [(_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.options) ? _c('selectize', {
	    attrs: {
	      "value": _vm.value,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Plan",
	      "allowEmptyOption": _vm.allowEmptyOption,
	      "selectedValue": _vm.selectedValue
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2391 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-create-note"
	  }, [_c('NoteForm', {
	    on: {
	      "completed": _vm.createNote
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2392 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-split-payment-configuration"
	  }, _vm._l((_vm.value), function(elem, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('DeleteConf', {
	      on: {
	        "click": function($event) {
	          return _vm.value.splice(index, 1)
	        }
	      }
	    }), _vm._l((elem), function(val, inx) {
	      return _c('div', {
	        staticClass: "column"
	      }, [(inx === 'client_type_id') ? _c('SelectizeClientType', {
	        attrs: {
	          "selectedValue": _vm.value[index][inx]
	        },
	        on: {
	          "optionSelected": function($event) {
	            return _vm.setClientType($event, _vm.value[index])
	          }
	        }
	      }) : _vm._e(), (inx === 'esigibilita_iva') ? _c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index][inx]),
	          expression: "value[index][inx]"
	        }],
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.value[index], inx, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "I"
	        }
	      }, [_vm._v("Immediata (I)")]), _c('option', {
	        attrs: {
	          "value": "S"
	        }
	      }, [_vm._v("Split Payment (S)")])]) : (inx === 'formato_trasmissione') ? _c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index][inx]),
	          expression: "value[index][inx]"
	        }],
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.value[index], inx, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "FPR12"
	        }
	      }, [_vm._v("Formato Privato (FPR12)")]), _c('option', {
	        attrs: {
	          "value": "FPA12"
	        }
	      }, [_vm._v("Formato PA (FPA12)")])]) : (inx === 'modalita_pagamento') ? _c('select', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index][inx]),
	          expression: "value[index][inx]"
	        }],
	        on: {
	          "change": function($event) {
	            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	              return o.selected
	            }).map(function(o) {
	              var val = "_value" in o ? o._value : o.value;
	              return val
	            });
	            _vm.$set(_vm.value[index], inx, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	          }
	        }
	      }, [_c('option', {
	        attrs: {
	          "value": "MP05"
	        }
	      }, [_vm._v("Bonifico (MP05)")]), _c('option', {
	        attrs: {
	          "value": "MP08"
	        }
	      }, [_vm._v("Carta di Credito (MP08)")])]) : _vm._e()], 1)
	    })], 2)
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2393 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle"
	  }, [(_vm.options) ? _c('selectize', {
	    ref: "selectize",
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "disabled": _vm.disabled,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Parking group"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2394 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-hardware-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('button', {
	    staticClass: "button small alert",
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Remove")]), _c('modal-reveal', {
	    ref: "modalUpdateHardware",
	    attrs: {
	      "sizing": "small"
	    }
	  }, [_c('button', {
	    staticClass: "button small warning",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('h2', [_vm._v("Edit Vehicle hardware VH" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Manager"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.manager),
	      expression: "manager"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.manager = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.managers), function(manager, index) {
	    return _c('option', [_vm._v(_vm._s(index))])
	  }), 0)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Serial"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.serial),
	      expression: "item.serial"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.serial)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "serial", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Extra")]), _c('array-edit', {
	    attrs: {
	      "values": _vm.item.extra
	    }
	  }), _c('div', {
	    staticClass: "text-right"
	  }, [_c('div', {
	    staticClass: "fa fa-download fa-2x text-right",
	    attrs: {
	      "title": "Click to copy the configuration"
	    },
	    on: {
	      "click": _vm.exportConfiguration
	    }
	  })]), _c('input', {
	    attrs: {
	      "id": "clipboard",
	      "type": "hidden"
	    },
	    domProps: {
	      "value": JSON.stringify(_vm.item.extra)
	    }
	  }), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.editHardware
	    }
	  }, [_vm._v("Edit Hardware")])], 1)])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2395 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-force-rebook"
	  }, [_c('ModalReveal', {
	    attrs: {
	      "sizing": "small"
	    }
	  }, [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Force Rebook")]), _c('div', {
	    staticClass: "header",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('h2', [_vm._v("Force rebook on " + _vm._s(_vm.vehicle.brand) + " " + _vm._s(_vm.vehicle.model) + " " + _vm._s(_vm.vehicle.plate))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Driver")]), _c('selectize-driver', {
	    on: {
	      "optionSelected": _vm.setDriver
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Memo"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.memo),
	      expression: "body.memo"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.memo)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "memo", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Start"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "format": 'yyyy-mm-dd hh:ii'
	    },
	    model: {
	      value: (_vm.body.start),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "start", $$v)
	      },
	      expression: "body.start"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("End"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "format": 'yyyy-mm-dd hh:ii'
	    },
	    model: {
	      value: (_vm.body.end),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "end", $$v)
	      },
	      expression: "body.end"
	    }
	  })], 1)])]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.forceRebook
	    }
	  }, [_vm._v("Create New Booking")])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2396 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-smart-edit"
	  }, [_c('label', [_vm._v("Document Type"), _c('selectize-document-type', {
	    attrs: {
	      "selected-value": _vm.item.type.id
	    },
	    on: {
	      "optionSelected": _vm.selectDocType
	    }
	  })], 1), _c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2397 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-flag"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "column text-right"
	  }, [_c('span', {
	    staticClass: "fa fa-plus",
	    on: {
	      "click": function($event) {
	        _vm.addFlag = !_vm.addFlag
	      }
	    }
	  })])]), (_vm.addFlag) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.flag),
	      expression: "body.flag"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "flag", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "TERMINATED_IN_FORBIDDEN"
	    }
	  }, [_vm._v("Terminated in forbidden")]), _c('option', {
	    attrs: {
	      "value": "TERMINATED_IN_UNDESIRABLE"
	    }
	  }, [_vm._v("Terminated in undesirable")]), _c('option', {
	    attrs: {
	      "value": "HOLD_BILLING"
	    }
	  }, [_vm._v("Hold billing")]), _c('option', {
	    attrs: {
	      "value": "SKIP_DEPOSIT"
	    }
	  }, [_vm._v("Skip deposit")]), _c('option', {
	    attrs: {
	      "value": "SKIP_BILLING"
	    }
	  }, [_vm._v("Skip billing")]), _c('option', {
	    attrs: {
	      "value": "START_ZONES_CONFIG"
	    }
	  }, [_vm._v("Start zone config")]), _c('option', {
	    attrs: {
	      "value": "END_ZONES_CONFIG"
	    }
	  }, [_vm._v("End zone config")]), _c('option', {
	    attrs: {
	      "value": "EXTRA_COMMON_COST"
	    }
	  }, [_vm._v("Extra common cost")]), _c('option', {
	    attrs: {
	      "value": "SKIP_GPS_CHECK"
	    }
	  }, [_vm._v("Skip GPS check on RT end")]), _c('option', {
	    attrs: {
	      "value": "FORCE_REFUEL_ACTION"
	    }
	  }, [_vm._v("Force refuel")]), _c('option', {
	    attrs: {
	      "value": "FORCE_RECHARGE_ACTION"
	    }
	  }, [_vm._v("Force recharge")])]), _c('label', [_vm._v("Flag value"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.value),
	      expression: "body.value"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "value", $event.target.value)
	      }
	    }
	  })]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.saveFlag
	    }
	  }, [_vm._v("Save")])], 1)]) : _vm._e(), _vm._l((_vm.reservation.flags), function(flag) {
	    return _c('div', {
	      staticClass: "flag"
	    }, [_c('span', [_vm._v(_vm._s(flag.flag) + ":")]), _c('div', {
	      staticClass: "values"
	    }, [_vm._v(_vm._s(flag.value) + " "), _c('ActionButton', {
	      attrs: {
	        "button": false,
	        "action": _vm.editFlag,
	        "value": flag
	      }
	    }, [_c('span', {
	      staticClass: "fa fa-pencil"
	    }, [_vm._v(" ")]), _c('template', {
	      slot: "prompt"
	    }, [_c('h2', [_vm._v("Edit flag " + _vm._s(flag.flag))]), _c('label', [_vm._v("Flag value")]), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (flag.value),
	        expression: "flag.value"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (flag.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(flag, "value", $event.target.value)
	        }
	      }
	    })])], 2), _c('ActionButton', {
	      attrs: {
	        "button": false,
	        "confirm": true,
	        "action": _vm.deleteFlag,
	        "value": flag
	      }
	    }, [_c('span', {
	      staticClass: "fa fa-times"
	    })])], 1)])
	  })], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "column"
	  }, [_c('span', [_vm._v("Flags")])])
	}]}

/***/ }),
/* 2398 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-reporting"
	  }, [_c('div', {
	    staticClass: "row columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('fieldset', {
	    staticClass: "large-2 columns"
	  }, [_c('label', [_vm._v("Status")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.status),
	      expression: "body.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "PENDING_REVIEW"
	    }
	  }, [_vm._v("Pending Review")]), _c('option', {
	    attrs: {
	      "value": "CONFIRMED"
	    }
	  }, [_vm._v("Confirmed")]), _c('option', {
	    attrs: {
	      "value": "RESOLVED"
	    }
	  }, [_vm._v("Resolved")]), _c('option', {
	    attrs: {
	      "value": "VOIDED"
	    }
	  }, [_vm._v("Voided")])])]), _c('fieldset', {
	    staticClass: "large-3 columns"
	  }, [_c('label', [_vm._v("Vehicle")]), _c('selectize-vehicle', {
	    attrs: {
	      "max-items": 1,
	      "selectedValue": _vm.body.vehicle_id
	    },
	    on: {
	      "optionSelected": _vm.vehicleSelected
	    }
	  })], 1), _c('fieldset', {
	    staticClass: "large-3 columns"
	  }, [_c('label', [_vm._v("Type")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reporting_type_id),
	      expression: "body.reporting_type_id"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "reporting_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.isDamageReport]
	    }
	  }, _vm._l((_vm.reportingTypes), function(type) {
	    return _c('option', {
	      domProps: {
	        "value": type.id
	      }
	    }, [_vm._v(_vm._s(type.name))])
	  }), 0)]), _c('fieldset', {
	    staticClass: "large-3 columns"
	  }, [_c('label', [_vm._v("Driver")]), _c('selectize-driver', {
	    attrs: {
	      "max-items": 1
	    },
	    on: {
	      "optionSelected": _vm.driverSelected
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row columns"
	  }, [_c('label', [_vm._v("Description"), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.description),
	      expression: "body.description"
	    }],
	    attrs: {
	      "rows": "8"
	    },
	    domProps: {
	      "value": (_vm.body.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "description", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "row columns"
	  }, [_c('label', {
	    attrs: {
	      "aria-describedby": "documentsUpload"
	    }
	  }, [_c('dropzone', {
	    attrs: {
	      "id": "myVueDropzone",
	      "url": _vm.dropzoneUrl
	    },
	    on: {
	      "vdropzone-success": _vm.uploaded
	    }
	  })], 1)]), (_vm.damageReport) ? _c('div', {
	    staticClass: "row columns"
	  }, [(_vm.body.damage_position_raw) ? _c('vehicle-damage', {
	    attrs: {
	      "items": _vm.body.damage_position_raw,
	      "editable": true,
	      "vehicleDamagePicture": _vm.category.damage_picture_external,
	      "vehicleType": _vm.vehicleType
	    },
	    on: {
	      "damagesUpdated": _vm.updateDamages
	    }
	  }) : _vm._e()], 1) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-center"
	  }, [_c('label', [_c('input', {
	    staticClass: "button expanded",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  })])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2399 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalReveal', {
	    ref: "terminateModal"
	  }, [_c('button', {
	    staticClass: "button",
	    staticStyle: {
	      "color": "#A3A3A3"
	    },
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Terminate")]), _c('h2', [_vm._v("Terminate reservation R" + _vm._s(_vm.entity.number))]), _c('label', [_vm._v("Accept undesirable zone")]), _c('input-switch', {
	    model: {
	      value: (_vm.terminateBody.acceptUndesiderable),
	      callback: function($$v) {
	        _vm.$set(_vm.terminateBody, "acceptUndesiderable", $$v)
	      },
	      expression: "terminateBody.acceptUndesiderable"
	    }
	  }), (!_vm.configuration.constraints.constraints_forbid_to_end_in_forbidden.value) ? [_c('label', [_vm._v("Force forbidden zone")]), _c('input-switch', {
	    attrs: {
	      "disabled": true
	    },
	    model: {
	      value: (_vm.terminateBody.forceForbidden),
	      callback: function($$v) {
	        _vm.$set(_vm.terminateBody, "forceForbidden", $$v)
	      },
	      expression: "terminateBody.forceForbidden"
	    }
	  })] : _vm._e(), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.terminate
	    },
	    slot: "footer"
	  }, [_vm._v("Terminate")])], 2)
	},staticRenderFns: []}

/***/ }),
/* 2400 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.entity) ? _c('div', {
	    staticClass: "component-reporting-action-buttons"
	  }, [(_vm.item) ? _c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "dropdown menu",
	    attrs: {
	      "data-dropdown-menu": ""
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#Item-1"
	    }
	  }, [_vm._v("Action")]), _c('ul', {
	    staticClass: "menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'edit-reporting',
	        params: {
	          id: _vm.entity.id
	        }
	      }
	    }
	  }, [_vm._v("Edit")])], 1), _c('li', [(_vm.entity.status === 'PENDING_REVIEW' || _vm.entity.status === 'CONFIRMED') ? _c('a', {
	    on: {
	      "click": _vm.resolve
	    }
	  }, [_vm._v("Resolve")]) : _vm._e()]), _c('li', [(_vm.entity.status === 'PENDING_REVIEW') ? _c('a', {
	    on: {
	      "click": _vm.confirm
	    }
	  }, [_vm._v("Confirm")]) : _vm._e()]), _c('li', [(_vm.entity.status === 'PENDING_REVIEW') ? _c('a', {
	    on: {
	      "click": _vm.voided
	    }
	  }, [_vm._v("Void")]) : _vm._e()])])])]) : _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [(_vm.entity.status === 'PENDING_REVIEW' || _vm.entity.status === 'CONFIRMED') ? _c('button', {
	    staticClass: "button success",
	    on: {
	      "click": _vm.resolve
	    }
	  }, [_vm._v("Resolve")]) : _vm._e(), (_vm.entity.status === 'PENDING_REVIEW') ? _c('button', {
	    staticClass: "button warning",
	    on: {
	      "click": _vm.confirm
	    }
	  }, [_vm._v("Confirm")]) : _vm._e(), (_vm.entity.status !== 'VOIDED') ? _c('button', {
	    staticClass: "button alert",
	    on: {
	      "click": _vm.voided
	    }
	  }, [_vm._v("Void")]) : _vm._e()])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2401 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', [_c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.clientType.name),
	      expression: "clientType.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.clientType.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.clientType, "name", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Group"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.clientType.type),
	      expression: "clientType.type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.clientType, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', [_vm._v("PRIVATE")]), _c('option', [_vm._v("BUSINESS")]), _c('option', [_vm._v("MAINTENANCE")])])])])]), _c('div', {
	    staticClass: "row columns text-center"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Save Client Type")])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2402 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-list-form filter-form"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Client")]), _c('input-form', {
	    attrs: {
	      "fields": ['query'],
	      "placeholders": ['Client search']
	    },
	    on: {
	      "updatedData": _vm.setSearch
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Status")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "disabled",
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Status")]), _c('option', [_vm._v("ACTIVE")]), _c('option', [_vm._v("SUSPENDED")]), _c('option', [_vm._v("CANCELED")]), _c('option', [_vm._v("ON HOLD")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Client type")]), _c('SelectizeClientType', {
	    on: {
	      "optionSelected": _vm.setClientType,
	      "optionRemoved": function($event) {
	        _vm.search.client_type = null
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('a', {
	    staticClass: "fa fa-filter fa-2x",
	    on: {
	      "click": _vm.setFilters
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2403 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-note"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('InterventionRequestButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("IR" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Priority")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.priority))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Type")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.type))]), (_vm.item.reservation) ? [_c('div', [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Reservation  "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.reservation.id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v("R" + _vm._s(_vm.item.reservation.id))])])], 1), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.reservation.status))])])] : _vm._e()], 2), _c('div', {
	    staticClass: "column"
	  }, [(!_vm.item.driver) ? [_c('h5', [_vm._v("Not assigned")])] : _c('BackofficeDriver', {
	    attrs: {
	      "item": _vm.item.driver,
	      "type": "oneLook"
	    }
	  }), (_vm.item.start) ? [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Started at")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])] : _vm._e(), (_vm.item.end) ? [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Completed at")]), (_vm.item.end) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]) : _vm._e()] : _vm._e()], 2), _c('div', {
	    staticClass: "column text-center"
	  }, [_c('vehicle', {
	    attrs: {
	      "item": _vm.item.vehicle,
	      "type": "oneLook"
	    }
	  }), _c('vehicle', {
	    attrs: {
	      "item": _vm.item.vehicle,
	      "type": "maintenance"
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Start")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Expiry")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.expiry, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), _c('div', {
	    staticClass: "column shrink text-right"
	  }, [(_vm.item.linked_requests.length) ? _c('span', {
	    staticClass: "fa fa-2x",
	    class: {
	      'fa-chevron-up': _vm.showSub, 'fa-chevron-down': !_vm.showSub
	    },
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showSub = !_vm.showSub
	      }
	    }
	  }) : _vm._e()])]), _vm._l((_vm.item.linked_requests), function(request) {
	    return (_vm.showSub) ? [_c('hr'), _c('InterventionRequest', {
	      attrs: {
	        "item": request,
	        "type": "detail-listing"
	      }
	    })] : _vm._e()
	  })], 2)]) : _vm._e(), (_vm.$is('detail-listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('InterventionRequestButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("IR" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Priority")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.priority))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Type")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.type))]), (_vm.item.reservation) ? [_c('div', [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Reservation  "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.reservation.id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v("R" + _vm._s(_vm.item.reservation.id))])])], 1), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.reservation.status))])])] : _vm._e()], 2), _c('div', {
	    staticClass: "column"
	  }, [(!_vm.item.driver) ? [_c('h5', [_vm._v("Not assigned")])] : _c('BackofficeDriver', {
	    attrs: {
	      "item": _vm.item.driver,
	      "type": "oneLook"
	    }
	  }), (_vm.item.start) ? [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Started at")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])] : _vm._e(), (_vm.item.end) ? [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Completed at")]), (_vm.item.end) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]) : _vm._e()] : _vm._e()], 2), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Start")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Expiry")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.expiry, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), _c('div', {
	    staticClass: "column shrink text-right"
	  }, [(_vm.item.linked_requests.length) ? _c('span', {
	    staticClass: "fa fa-2x",
	    class: {
	      'fa-chevron-up': _vm.showSub, 'fa-chevron-down': !_vm.showSub
	    },
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showSub = !_vm.showSub
	      }
	    }
	  }) : _vm._e()])]), _vm._l((_vm.item.linked_requests), function(request) {
	    return (_vm.showSub) ? [_c('hr'), _c('InterventionRequest', {
	      attrs: {
	        "item": request,
	        "type": "detail-listing"
	      }
	    })] : _vm._e()
	  })], 2)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2404 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-note-list row column"
	  }, _vm._l((_vm.reservation_rates), function(rate) {
	    return _c('reservation-rate', {
	      attrs: {
	        "item": rate,
	        "type": "listing"
	      }
	    })
	  }), 1)
	},staticRenderFns: []}

/***/ }),
/* 2405 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-zone-cost"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink pl-0"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('ZoneConfigButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("ZC" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Z" + _vm._s(_vm.item.zone.id) + " " + _vm._s(_vm.item.zone.name))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Cost on Start")]), (_vm.item.common_cost_start) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("CC" + _vm._s(_vm.item.common_cost_start.id) + " " + _vm._s(_vm.item.common_cost_start.reason))]) : _vm._e()]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Cost on End")]), (_vm.item.common_cost_end) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("CC" + _vm._s(_vm.item.common_cost_end.id) + " " + _vm._s(_vm.item.common_cost_end.reason))]) : _vm._e()]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Type")]), _c('div', {
	    staticClass: "fiel-value"
	  }, [_vm._v(_vm._s(_vm.item.type))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Max vehicles")]), _c('div', {
	    staticClass: "fiel-value"
	  }, [_vm._v(_vm._s(_vm.item.max_vehicles))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Min fuel level")]), _c('div', {
	    staticClass: "fiel-value"
	  }, [_vm._v(_vm._s(_vm.item.min_fuel_level))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Max speed")]), _c('div', {
	    staticClass: "fiel-value"
	  }, [_vm._v(_vm._s(_vm.item.max_speed))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'edit-zone-config',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 2406 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-backoffice-attachment"
	  }, _vm._l((_vm.item.attachments), function(attachment) {
	    return _c('div', {
	      staticClass: "driver-license-attachment"
	    }, [_c('dropdown', {
	      staticClass: "float-right",
	      attrs: {
	        "icon": 'fa fa-ellipsis-v fa-2x action',
	        "position": 'bottom'
	      }
	    }, [_c('driver-license-attachment-action-buttons', {
	      attrs: {
	        "licenseId": _vm.item.id,
	        "attachmentId": attachment.id,
	        "attachmentUrl": attachment.url
	      }
	    })], 1), _c('img', {
	      attrs: {
	        "src": attachment.url
	      }
	    })], 1)
	  }), 0) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2407 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "disabled": _vm.disabled,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Attributes"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2408 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-backoffice-wallet-record"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("ID")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("WR" + _vm._s(_vm.item.id))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Type & Id")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm._f("walletableType")(_vm.item.walletable_type))), _c('br'), _c('span', [_vm._v(_vm._s(_vm.item.walletable_id))])])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Tax " + _vm._s(-_vm.item.tax * 100) + "%")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(parseFloat(_vm.item.amount * _vm.item.tax).toFixed(2))))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Amount")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(-_vm.item.amount)))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Invoice")]), _c('div', {
	    staticClass: "field-value h3 mb-0"
	  }, [_vm._v(_vm._s(_vm.commercialDocumentType) + _vm._s(_vm.item.invoice.internal_id) + "(" + _vm._s(_vm.item.invoice.id) + ")")])])])]) : _vm._e(), (_vm.$is('multi-wallet')) ? _c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row pb-0"
	  }, [_c('div', {
	    staticClass: "column expand"
	  }, [_c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.walletableType) + " " + _vm._s(_vm.item.walletable_id))]), _c('div', {
	    staticClass: "fields"
	  }, [_c('small', [_vm._v("WR" + _vm._s(_vm.item.id))])])]), _c('div', {
	    staticClass: "column large-2"
	  }, [_c('div', {
	    staticClass: "field-content"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), (_vm.item.invoice_after !== null) ? _c('div', {
	    staticClass: "invoice-after"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Invoice on")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.invoice_after, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])]) : _vm._e()])])]), _c('div', {
	    staticClass: "row pt-0 pb-0"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Description")]), _vm._l((_vm.item.reason.split('|')), function(reason) {
	    return _c('div', [(reason.startsWith('---')) ? _c('hr', {
	      staticStyle: {
	        "border-style": "dotted",
	        "margin": "0.5em"
	      }
	    }) : (reason.startsWith('- ')) ? _c('strong', [_vm._v(_vm._s(_vm.cleanString(reason, "- ")))]) : (reason.startsWith('>>')) ? _c('span', {
	      staticStyle: {
	        "display": "block",
	        "text-indent": "1em"
	      }
	    }, [_vm._v(_vm._s(_vm.cleanString(reason, ">>")))]) : _c('span', [_vm._v(_vm._s(reason))])])
	  })], 2)]), _c('div', {
	    staticClass: "row text-center bottom"
	  }, [(_vm.walletableType !== 'Invoice') ? [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Vat " + _vm._s(-_vm.item.tax * 100) + "%")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.vat.toFixed(2))))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Amount")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount.toFixed(2))))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Total")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency((_vm.item.amount + _vm.vat).toFixed(2))))])]), (_vm.item.hasOwnProperty('invoice')) ? [(_vm.item.invoice.internal_id) ? _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Invoice")]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'invoice',
	        params: {
	          id: _vm.item.invoice.id
	        }
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.commercialDocumentType) + _vm._s(_vm.item.invoice.internal_id))])])], 1) : (!_vm.item.invoice.internal_id && _vm.item.billable) ? _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Invoice")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Not invoiced yet")])]) : _vm._e()] : _vm._e()] : [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Subtotal")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s((_vm.item.amount.toFixed(2))))])]), (_vm.item.invoice.internal_id) ? _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Invoice")]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'invoice',
	        params: {
	          id: _vm.item.invoice.id
	        }
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.commercialDocumentType) + _vm._s(_vm.item.invoice.internal_id))])])], 1) : (!_vm.item.invoice.internal_id && _vm.item.billable) ? _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Invoice")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Not invoiced yet")])]) : _vm._e()]], 2)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2409 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-merge-zone"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12 large-6"
	  }, [_c('label', [_vm._v("How many geoJson to merge?")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.numOfTextArea),
	      expression: "numOfTextArea"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.numOfTextArea)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.numOfTextArea = $event.target.value
	      }
	    }
	  }), _c('pp', [_vm._v(_vm._s(_vm.numOfTextArea))])], 1)]), _vm._l((_vm.numGeoJsonToMerge), function(n) {
	    return (_vm.numGeoJsonToMerge.length > 0) ? _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column"
	    }, [_c('label', [_vm._v("GeoJson" + _vm._s(n))]), _c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.geoJsonToMerge['geo' + n]),
	        expression: "geoJsonToMerge['geo'+n]"
	      }],
	      attrs: {
	        "rows": "10",
	        "name": 'geo' + n
	      },
	      domProps: {
	        "value": (_vm.geoJsonToMerge['geo' + n])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.geoJsonToMerge, 'geo' + n, $event.target.value)
	        }
	      }
	    })])]) : _vm._e()
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "colomn"
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": _vm.disable
	    },
	    on: {
	      "click": _vm.mergeGeoJson
	    }
	  }, [_vm._v("Merge")])])]), (Object.keys(_vm.geoJsonToMerge).length !== 0 && _vm.spin) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('textarea', {
	    attrs: {
	      "id": "geoJsonToCopy",
	      "rows": "30"
	    },
	    domProps: {
	      "value": _vm.mergedGeoJson
	    }
	  })])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.copyToClipboard
	    }
	  }, [_vm._v("Copy to clipboard")])])])])]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2410 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-subscription-smart-edit"
	  }, [_c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2411 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('div', {
	    staticClass: "flex-container flex-dir-column"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openUrl(_vm.attachmentUrl)
	      }
	    }
	  }, [_vm._v("Download")]), _c('a', {
	    staticClass: "alert-text",
	    on: {
	      "click": _vm.deletec
	    }
	  }, [_vm._v("Delete")])])])
	},staticRenderFns: []}

/***/ }),
/* 2412 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-backoffice-driver-license-attachment-upload"
	  }, [_c('dropzone', {
	    ref: "dropzone",
	    attrs: {
	      "id": "myVueDropzone",
	      "url": _vm.dropzoneUrl
	    },
	    on: {
	      "vdropzone-success": _vm.uploaded,
	      "vdropzone-removed-file": _vm.removeAttachment
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    class: {
	      disabled: _vm.attachments.length === 0
	    },
	    on: {
	      "click": _vm.upload
	    }
	  }, [_vm._v("Save and Submit")])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2413 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: ("maintenance-" + _vm._uid),
	    on: {
	      "input": _vm.close
	    }
	  }, [_c('button', {
	    staticClass: "button success expanded",
	    attrs: {
	      "slot": "trigger"
	    },
	    on: {
	      "click": _vm.open
	    },
	    slot: "trigger"
	  }, [_vm._v("Add sub request")]), _c('h2', [_vm._v("Add sub request to IR" + _vm._s(_vm.body.linked_intervention_request_id))]), _c('InterventionRequestForm', {
	    attrs: {
	      "subRequest": true
	    },
	    model: {
	      value: (_vm.body),
	      callback: function($$v) {
	        _vm.body = $$v
	      },
	      expression: "body"
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close(false)
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2414 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-invoice-controller"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-5"
	  }, [(_vm.client) ? _c('driver', {
	    attrs: {
	      "type": 'driver-card',
	      "item": _vm.client.main_driver
	    }
	  }) : _vm._e()], 1), _c('div', {
	    staticClass: "columns shrink"
	  }, [_c('span', [_vm._v("Emission Date")]), (_vm.item.emission_date) ? _c('h4', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.emission_date, 'DD/MM/YYYY')))]) : _vm._e(), _c('span', [_vm._v("Overdue Date")]), (_vm.item.due_date) ? _c('h4', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.due_date, 'DD/MM/YYYY')))]) : _vm._e()]), _c('div', {
	    staticClass: "columns shrink"
	  }, [_c('span', [_vm._v("Status")]), _c('h4', [_vm._v(_vm._s(_vm.item.status))]), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? [_c('span', [_vm._v("Xml filename")]), (_vm.item.extra.hasOwnProperty('einvoice')) ? _c('h4', [_vm._v(_vm._s(_vm.item.extra.einvoice.uploadedFileName))]) : _c('h4', [_vm._v("--")])] : _vm._e()], 2), _c('div', {
	    staticClass: "column"
	  }, [_c('span', [_vm._v("Document type")]), _c('h4', [_vm._v(_vm._s(_vm.item.type))]), _c('span', [_vm._v("Number")]), (_vm.item.type !== 'PROFORMA') ? _c('h4', [_vm._v(_vm._s(_vm.item.internal_id))]) : _c('h4', [_vm._v("--")])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('client', {
	    attrs: {
	      "item": _vm.client,
	      "type": 'billing'
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('client', {
	    attrs: {
	      "item": _vm.client,
	      "type": 'contacts'
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('table', [_vm._m(0), _c('tbody', _vm._l((_vm.item.records), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _c('td', [_vm._v(_vm._s(item.driver_id))]), _c('td', [_c('div', [_vm._v(_vm._s(_vm._f("walletableType")(item.walletable_type)))]), _c('div', [_vm._v(_vm._s(item.walletable_id))])]), _c('td', {
	      staticStyle: {
	        "font-family": "monospace"
	      }
	    }, _vm._l((item.reason.split('|')), function(reason) {
	      return _c('div', [(reason.startsWith('---')) ? _c('hr', {
	        staticStyle: {
	          "border-style": "dotted",
	          "margin": "0.5em"
	        }
	      }) : (reason.startsWith('- ')) ? _c('strong', [_vm._v(_vm._s(_vm.cleanString(reason, "- ")))]) : (reason.startsWith('>>')) ? _c('span', {
	        staticStyle: {
	          "display": "block",
	          "text-indent": "1em"
	        }
	      }, [_vm._v(_vm._s(_vm.cleanString(reason, ">>")))]) : _c('span', [_vm._v(_vm._s(reason))])])
	    }), 0), _c('td', {
	      staticClass: "text-center"
	    }, [_c('div', [_vm._v(_vm._s(_vm.currency) + _vm._s(parseFloat(item.amount * item.tax).toFixed(2)))]), _c('div', [_c('small', [_vm._v(_vm._s(-item.tax * 100) + "%")])])]), _c('td', {
	      staticClass: "text-center"
	    }, [_c('div', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(-item.amount, -item.tax).toFixed(2))))]), _c('div', [_c('small', [_vm._v(_vm._s(_vm.$priceWithcurrency(-item.amount)) + " VAT EXC")])])])])
	  }), 0)])])]), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _c('div', {
	    staticClass: "columns text-right"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.subtotal)))])])]), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _c('div', {
	    staticClass: "columns text-right"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.tax)))])])]), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _c('div', {
	    staticClass: "columns text-right"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.item.document_total))])])]), (_vm.item.deposits.length) ? _c('div', {
	    staticClass: "row"
	  }, [_vm._m(4), _c('div', {
	    staticClass: "columns text-right"
	  }, [_c('h2', [_vm._v("-" + _vm._s(_vm.$priceWithcurrency(_vm.depositsPaid)))])])]) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(5), _c('div', {
	    staticClass: "columns text-right"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.total)))])])]), (_vm.item.deposits.length) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('h2', [_vm._v("Deposit details:")]), _vm._l((_vm.item.deposits), function(deposit) {
	    return _c('Deposit', {
	      attrs: {
	        "item": deposit,
	        "type": "listing"
	      }
	    })
	  })], 2)]) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Stati fatturazione elettronica")]), (_vm.item.extra.hasOwnProperty('einvoice')) ? _c('div', {
	    staticClass: "container"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.xmlStatus,
	      "componentType": "einvoice"
	    }
	  })], 1) : _vm._e()])]) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Driver Id")]), _c('th', [_vm._v("Type & Id")]), _c('th', [_vm._v("Description (Reason)")]), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Tax")]), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Amount")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns shrink large-offset-9"
	  }, [_c('p', [_vm._v("Subtotal")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns shrink large-offset-9"
	  }, [_c('p', [_vm._v("Tax total")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns shrink large-offset-9"
	  }, [_c('p', [_vm._v("Total")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns shrink large-offset-9"
	  }, [_c('p', [_vm._v("Paid deposits")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns shrink large-offset-9"
	  }, [_c('p', [_vm._v("Net to pay")])])
	}]}

/***/ }),
/* 2415 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal"
	  }, [_c('div', {
	    staticClass: "trigger-wrapper",
	    attrs: {
	      "data-open": _vm.uid
	    }
	  }, [_vm._t("trigger")], 2), _c('div', {
	    staticClass: "reveal",
	    attrs: {
	      "id": _vm.uid,
	      "data-reveal": ""
	    }
	  }, [_vm._t("default"), _vm._m(0), (_vm.confirm) ? _c('div', {
	    staticClass: "confirm-buttons"
	  }, [_c('button', {
	    staticClass: "button success yes",
	    attrs: {
	      "data-close": ""
	    },
	    on: {
	      "click": _vm.confirm
	    }
	  }, [_vm._v("Yes")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "data-close": ""
	    }
	  }, [_vm._v("No")])]) : _vm._e()], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close-button",
	    attrs: {
	      "data-close": "",
	      "aria-label": "Close modal",
	      "type": "button"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 2416 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-invoice-list-filter-form filter-form"
	  }, [_c('div', {
	    staticClass: "row medium-unstack"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.hw_serial),
	      expression: "search.hw_serial"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Search by HW Serial"
	    },
	    domProps: {
	      "value": (_vm.search.hw_serial)
	    },
	    on: {
	      "keyup": _vm.enterSubmit,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, "hw_serial", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "columns"
	  }, [_c('selectize-category', {
	    on: {
	      "optionSelected": _vm.selectVehicleCategory
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('selectize-vehicle', {
	    key: _vm.search.archived,
	    attrs: {
	      "archived": _vm.search.archived
	    },
	    on: {
	      "optionSelected": _vm.selectVehicle,
	      "optionRemoved": _vm.unselectVehicle
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('selectize-vehicle-slot', {
	    attrs: {
	      "placeholder": 'Filter vehicle slot'
	    },
	    on: {
	      "optionSelected": _vm.selectVehicleSlot,
	      "optionRemoved": _vm.unselectVehicleSlot
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.active),
	      expression: "search.active"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("--")]), _c('option', {
	    domProps: {
	      "value": true
	    }
	  }, [_vm._v("Disabled")]), _c('option', {
	    domProps: {
	      "value": false
	    }
	  }, [_vm._v("Enabled")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.archived),
	      expression: "search.archived"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "archived", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected",
	      "disabled": "disabled",
	      "hidden": "hidden"
	    },
	    domProps: {
	      "value": undefined
	    }
	  }, [_vm._v(" Archived Status")]), _c('option', {
	    attrs: {
	      "value": "ARCHIVED"
	    }
	  }, [_vm._v("Archived")]), _c('option', {
	    attrs: {
	      "value": "NOT ARCHIVED"
	    }
	  }, [_vm._v("Not Archived")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('selectize-segment', {
	    attrs: {
	      "valueField": "id"
	    },
	    model: {
	      value: (_vm.search.segment_id),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "segment_id", $$v)
	      },
	      expression: "search.segment_id"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.door_status),
	      expression: "search.door_status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "door_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Locked Status")]), _c('option', {
	    attrs: {
	      "value": "LOCKED"
	    }
	  }, [_vm._v("locked")]), _c('option', {
	    attrs: {
	      "value": "UNLOCKED"
	    }
	  }, [_vm._v("unlocked")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.engine_status),
	      expression: "search.engine_status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "engine_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Engine Status")]), _c('option', {
	    attrs: {
	      "value": "RUNNING"
	    }
	  }, [_vm._v("running")]), _c('option', {
	    attrs: {
	      "value": "NOT RUNNING"
	    }
	  }, [_vm._v("not running")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.ev_plug_status),
	      expression: "search.ev_plug_status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "ev_plug_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Plug Status")]), _c('option', {
	    attrs: {
	      "value": "CHARGING"
	    }
	  }, [_vm._v("charging")]), _c('option', {
	    attrs: {
	      "value": "CONNECTED"
	    }
	  }, [_vm._v("connected")]), _c('option', {
	    attrs: {
	      "value": "DISCONNECTED"
	    }
	  }, [_vm._v("disconnected")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.door_open_status),
	      expression: "search.door_open_status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "door_open_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Door")]), _c('option', {
	    attrs: {
	      "value": "OPEN"
	    }
	  }, [_vm._v("open")]), _c('option', {
	    attrs: {
	      "value": "CLOSED"
	    }
	  }, [_vm._v("closed")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.key_status),
	      expression: "search.key_status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "key_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Key Status")]), _c('option', {
	    attrs: {
	      "value": "PRESENT"
	    }
	  }, [_vm._v("present")]), _c('option', {
	    attrs: {
	      "value": "NOT PRESENT"
	    }
	  }, [_vm._v("not present")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.immobilizer_status),
	      expression: "search.immobilizer_status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "immobilizer_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Immo Status")]), _c('option', {
	    attrs: {
	      "value": "ENABLED"
	    }
	  }, [_vm._v("enabled")]), _c('option', {
	    attrs: {
	      "value": "DISABLED"
	    }
	  }, [_vm._v("disabled")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('a', {
	    staticClass: "fa fa-angle-double-down fa-2x",
	    on: {
	      "click": _vm.filterVehicles
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2417 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-list-filter-form filter-form"
	  }, [(_vm.$is('entity-filter')) ? _c('div', {
	    staticClass: "entity-filters"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    staticClass: "medium-5",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.filterReportings]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": ""
	    }
	  }, [_vm._v("All statuses")]), _c('option', {
	    attrs: {
	      "value": "PENDING_REVIEW"
	    }
	  }, [_vm._v("Pending Review")]), _c('option', {
	    attrs: {
	      "value": "CONFIRMED"
	    }
	  }, [_vm._v("Confirmed")]), _c('option', {
	    attrs: {
	      "value": "RESOLVED"
	    }
	  }, [_vm._v("Resolved")]), _c('option', {
	    attrs: {
	      "value": "VOIDED"
	    }
	  }, [_vm._v("Voided")])])]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Driver")]), _c('SearchEntity', {
	    attrs: {
	      "entity": "drivers"
	    },
	    model: {
	      value: (_vm.search.driver_id),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "driver_id", $$v)
	      },
	      expression: "search.driver_id"
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Vehicle")]), _c('selectize-vehicle', {
	    attrs: {
	      "disabledSlot": 0
	    },
	    on: {
	      "optionSelected": _vm.setVehicleId,
	      "optionRemoved": _vm.unsetVehicleId
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Reporting types")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.reporting_type_id),
	      expression: "search.reporting_type_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "reporting_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All types")]), _vm._l((_vm.reportingTypes), function(reportingType) {
	    return _c('option', {
	      domProps: {
	        "value": reportingType.id
	      }
	    }, [_vm._v(_vm._s(reportingType.name))])
	  })], 2)]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Status")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": ""
	    }
	  }, [_vm._v("All statuses")]), _c('option', {
	    attrs: {
	      "value": "PENDING_REVIEW"
	    }
	  }, [_vm._v("Pending Review")]), _c('option', {
	    attrs: {
	      "value": "CONFIRMED"
	    }
	  }, [_vm._v("Confirmed")]), _c('option', {
	    attrs: {
	      "value": "RESOLVED"
	    }
	  }, [_vm._v("Resolved")]), _c('option', {
	    attrs: {
	      "value": "VOIDED"
	    }
	  }, [_vm._v("Voided")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('a', {
	    staticClass: "fa fa-angle-double-down fa-2x",
	    on: {
	      "click": _vm.filterReportings
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2418 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-registration"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Plate"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.plate),
	      expression: "body.plate"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.plate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "plate", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Model"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.model),
	      expression: "body.model"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.model)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "model", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Odometer"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.odometer),
	      expression: "body.odometer"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.odometer)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "odometer", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Color"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.color),
	      expression: "body.color"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "color", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "small-12-large-6 columns"
	  }, [_c('label', [_vm._v("Category"), _c('selectize-category', {
	    on: {
	      "optionSelected": _vm.selectCategory
	    }
	  })], 1), _c('label', [_vm._v("Fuel type"), _c('fuel-type-select', {
	    on: {
	      "fuelTypeSelected": _vm.selectFuel
	    }
	  })], 1), _c('label', [_vm._v("Brand"), _c('selectize-vehicle-brand', {
	    on: {
	      "optionSelected": _vm.selectBrand
	    }
	  })], 1), _c('label', [_vm._v("Picture"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.picture),
	      expression: "body.picture"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": (_vm.body.picture)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "picture", $event.target.value)
	      }
	    }
	  })]), _c('kepler-file-upload', {
	    attrs: {
	      "selectedPrefix": "vehicles",
	      "selectedVisibility": "public"
	    },
	    on: {
	      "sel": _vm.handleFileSelector
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.formSubmit
	    }
	  }, [_vm._v("Create")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2419 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('CouponReveal', {
	    attrs: {
	      "couponProp": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2420 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-subscription-controller"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns medium-6"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'driver-card',
	      "item": _vm.item.client.main_driver
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row columns"
	  }, [_c('tab-headers', {
	    attrs: {
	      "tabs": _vm.tabHeaders,
	      "id": 'subscription-details',
	      "activeIndex": 0
	    }
	  }, [_c('tab-content', {
	    attrs: {
	      "headerName": 'Subscription',
	      "active": true
	    }
	  }, [_c('subscription', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'card-header-include'
	    }
	  }), _c('subscription', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'subscription-action-details'
	    }
	  })], 1), (_vm.$acl('index-log')) ? _c('tab-content', {
	    attrs: {
	      "headerName": 'Logs'
	    }
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  })], 1) : _vm._e()], 1)], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2421 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-alert-box"
	  }, [_c('div', {
	    class: 'callout ' + _vm.color,
	    attrs: {
	      "data-closable": "data-closable"
	    }
	  }, [_vm._t("default"), (_vm.isClosable()) ? _c('button', {
	    staticClass: "close-button",
	    attrs: {
	      "aria-label": "Dismiss alert",
	      "type": "button",
	      "data-close": "data-close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]) : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2422 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-backoffice-attachment"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.item.url
	    }
	  }), _c('a', {
	    staticClass: "button button-download expanded",
	    on: {
	      "click": function($event) {
	        return _vm.openUrl(_vm.item.url)
	      }
	    }
	  }, [_vm._v("Download")])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2423 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-topup"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column expanded"
	  }, [_c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v("TU" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
	    staticClass: "column shrink pr-0"
	  }, [_c('div', {
	    staticClass: "fiel-content"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at)))])])])]), _c('div', {
	    staticClass: "row text-center pt-0"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Amount")]), _c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount)))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Transaction")]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'transaction',
	        params: {
	          id: _vm.item.transaction.id
	        }
	      }
	    }
	  }, [_c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v("TR" + _vm._s((_vm.item.transaction.id)))])])], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 2424 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: _vm.componentId
	  }, [(_vm.segment == null) ? _c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]) : _c('a', {
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), (_vm.segment == null) ? _c('h2', [_vm._v("Create new segment")]) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [(_vm.segment === null) ? [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })])] : [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.segment._translatable.name,
	      "label": "Name",
	      "value": _vm.segment.name
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })])], _c('label', [_vm._v("Picture"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.picture),
	      expression: "body.picture"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": (_vm.body.picture)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "picture", $event.target.value)
	      }
	    }
	  })]), _c('kepler-file-upload', {
	    attrs: {
	      "selectedPrefix": "segments",
	      "selectedVisibility": "public"
	    },
	    on: {
	      "sel": _vm.handleFileSelector
	    }
	  })], 2), _c('div', {
	    staticClass: "column"
	  }, [(_vm.segment === null) ? [_c('label', [_vm._v("Hint"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.hint),
	      expression: "body.hint"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.hint)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "hint", $event.target.value)
	      }
	    }
	  })])] : [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.segment._translatable.hint,
	      "label": "Hint",
	      "value": _vm.segment.hint
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.hint),
	      expression: "body.hint"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.hint)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "hint", $event.target.value)
	      }
	    }
	  })])]], 2)]), _c('div', {
	    staticClass: "row column"
	  }, [(_vm.segment === null) ? [_c('label', [_vm._v("Description")])] : [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.segment._translatable.description,
	      "label": "Description",
	      "value": _vm.segment.description,
	      "editor": true
	    }
	  })], _c('Editor', {
	    model: {
	      value: (_vm.body.description),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "description", $$v)
	      },
	      expression: "body.description"
	    }
	  })], 2), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2425 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-translate-field"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_vm._t("default", [(!_vm.showInput) ? _c('div', {
	    staticClass: "input-group-field"
	  }, [_c('label', [_vm._v(_vm._s(_vm.label))])]) : _vm._e()]), _c('div', {
	    staticClass: "input-group-label"
	  }, [_c('ModalReveal', [_c('a', {
	    attrs: {
	      "slot": "trigger",
	      "title": "Translate"
	    },
	    on: {
	      "click": _vm.loadLang
	    },
	    slot: "trigger"
	  }, [_c('mdi-icon', {
	    attrs: {
	      "name": "mdi-translate",
	      "show-name": false
	    }
	  })], 1), _c('label', [_vm._v(_vm._s(_vm.label))]), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.value)
	    }
	  }), _c('TranslationEdit', {
	    attrs: {
	      "item": _vm.translations,
	      "editor": _vm.editor,
	      "skipDefaultLang": true,
	      "editable": _vm.editable
	    }
	  })], 1)], 1)], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2426 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-common-cost-type"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": _vm.body.name.toUpperCase()
	    },
	    on: {
	      "input": function($event) {
	        _vm.body.name = $event.target.value.toUpperCase()
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.description),
	      expression: "body.description"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "description", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-right"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.formSubmit
	    }
	  }, [_vm._v("Create")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2427 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm.key,
	    ref: _vm.componentId,
	    on: {
	      "input": _vm.closeInput
	    }
	  }, [(_vm.couponProp) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]) : _c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Activation code"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.code),
	      expression: "body.code"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "code", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Valid from"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "initial-date": _vm.body.start,
	      "format": "yyyy-mm-dd hh:ii:ss"
	    },
	    model: {
	      value: (_vm.body.start),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "start", $$v)
	      },
	      expression: "body.start"
	    }
	  })], 1), _c('label', [_vm._v("Valid to"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "initial-date": _vm.body.end,
	      "format": "yyyy-mm-dd hh:ii:ss"
	    },
	    model: {
	      value: (_vm.body.end),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "end", $$v)
	      },
	      expression: "body.end"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Type"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("Fixed")]), _c('option', [_vm._v("Percentage")])])]), (_vm.type == 'Fixed') ? [_c('label', [_vm._v("Common Cost"), _c('selectize-common-cost', {
	    attrs: {
	      "selectedValue": _vm.body.common_cost_id
	    },
	    on: {
	      "optionSelected": _vm.setCommonCost
	    }
	  })], 1), _c('label', [_vm._v("Service"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.service),
	      expression: "body.service"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "service", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All")]), _c('option', [_vm._v("Reservation")]), _c('option', [_vm._v("Subscription")])])])] : [_c('label', [_vm._v("Discount percentage"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.discount_rate),
	      expression: "body.discount_rate"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.body.discount_rate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "discount_rate", $event.target.value)
	      }
	    }
	  })])], (_vm.type == 'Fixed') ? [_c('label', [_vm._v("Exipiry date"), _c('date-picker', {
	    attrs: {
	      "pickTime": true,
	      "initial-date": _vm.body.expiry_date,
	      "format": "yyyy-mm-dd hh:ii:ss"
	    },
	    model: {
	      value: (_vm.body.expiry_date),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "expiry_date", $$v)
	      },
	      expression: "body.expiry_date"
	    }
	  })], 1), _c('label', [_vm._v("Max days"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.max_days),
	      expression: "body.max_days"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.body.max_days)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "max_days", $event.target.value)
	      }
	    }
	  })])] : _vm._e(), _c('label', [_vm._v("Max uses"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.max_uses),
	      expression: "body.max_uses"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.body.max_uses)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "max_uses", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Max uses per driver"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.max_uses_per_driver),
	      expression: "body.max_uses_per_driver"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.body.max_uses_per_driver)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "max_uses_per_driver", $event.target.value)
	      }
	    }
	  })])], 2)]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2428 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [(!_vm.vehicle) ? _c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")]) : _c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.removeFromVehicle
	    }
	  }, [_vm._v("Delete")])])
	},staticRenderFns: []}

/***/ }),
/* 2429 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: ("maintenance-" + _vm._uid),
	    attrs: {
	      "value": _vm.open
	    }
	  }, [(!_vm.open) ? [(_vm.request) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Detail")]) : _c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })])] : _vm._e(), _c('h2', [_vm._v("Intervention request IR" + _vm._s(_vm.request.id))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('vehicle', {
	    attrs: {
	      "type": "compact-card",
	      "item": _vm.request.vehicle
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Description")]), _c('div', [_vm._v(_vm._s(_vm.request.description))]), _c('label', [_vm._v("Created at")]), _c('div', [_vm._v(" " + _vm._s(_vm.$dateFormat(_vm.request.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('label', [_vm._v("Expiry")]), _c('div', [_vm._v(" " + _vm._s(_vm.$dateFormat(_vm.request.expiry, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])])]), (_vm.request.linked_requests.length) ? _c('MaintenanceRequestList', {
	    attrs: {
	      "request": _vm.request,
	      "filters": _vm.filters,
	      "listing-type": "detail-listing"
	    }
	  }) : _vm._e()], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2430 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [(_vm.$is('listing')) ? [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [(_vm.item.status === 'PROCESSING') ? [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.stopProcessing
	    }
	  }, [_vm._v("Stop")])], 1)] : _vm._e()], 2)], 1), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("C" + _vm._s(_vm.item.id))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Operation:")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.operation))])]), _c('div', {
	    staticClass: "column small-6"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Payload:")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(JSON.stringify(_vm.item.payload)))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Status:")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.status)), (_vm.item.info) ? [_c('div', {
	    staticClass: "field"
	  }, [_c('small', [_vm._v(_vm._s(_vm.item.info.processing) + "/" + _vm._s(_vm.item.info.total) + " (" + _vm._s(Math.round(_vm.item.info.processing / _vm.item.info.total * 100)) + "%)")])])] : _vm._e()], 2)]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Output:")]), (_vm.item.output) ? _c('div', {
	    staticClass: "field"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openUrl(_vm.item.output)
	      }
	    }
	  }, [_vm._v("Download")])]) : _vm._e()]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field-url-detail"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'cargo-operation',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])])] : _vm._e(), (_vm.$is('detail')) ? [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "card p-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Operation:")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.operation))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Status:")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.status))]), (_vm.item.info && _vm.item.status === 'PROCESSING') ? [_c('div', {
	    staticClass: "field"
	  }, [_c('small', [_vm._v(_vm._s(_vm.item.info.processing) + "/" + _vm._s(_vm.item.info.total) + " (" + _vm._s(Math.round(_vm.item.info.processing / _vm.item.info.total * 100)) + "%)")])])] : _vm._e()], 2), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Info")]), _c('pre', {
	    staticStyle: {
	      "font-family": "monospace"
	    }
	  }, [_vm._v(_vm._s(_vm.item.info))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Payload:")]), _c('pre', [_vm._v(_vm._s(_vm.item.payload))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Result:")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(JSON.stringify(_vm.item.result)))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Output:")]), (_vm.item.output) ? _c('div', {
	    staticClass: "field"
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openUrl(_vm.item.output)
	      }
	    }
	  }, [_vm._v("Download")])]) : _vm._e()])])])])])] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2431 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-input-form row"
	  }, _vm._l((_vm.fields), function(field, index) {
	    return _c('div', {
	      staticClass: "column"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.data[field]),
	        expression: "data[field]"
	      }],
	      staticClass: "input-group-field",
	      attrs: {
	        "type": "text",
	        "placeholder": _vm.placeholders && _vm.placeholders[index] ? _vm.placeholders[index] : field
	      },
	      domProps: {
	        "value": (_vm.data[field])
	      },
	      on: {
	        "keyup": function($event) {
	          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	          return _vm.updatedData($event)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.data, field, $event.target.value)
	        }
	      }
	    }), _c('span', {
	      staticClass: "input-group-label",
	      on: {
	        "click": _vm.updatedData
	      }
	    }, [_c('span', {
	      staticClass: "fa fa-search"
	    })])])])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2432 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: "editModal"
	  }, [_c('template', {
	    slot: "trigger"
	  }, [(_vm.item == null) ? _c('a', {
	    staticClass: "fa-stack fa-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]) : _c('button', {
	    staticClass: "button"
	  }, [_vm._v("Edit")])]), _c('h2', [_vm._v("Document requirement")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Select entity " + _vm._s(_vm.body.entity_type)), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.entity_type),
	      expression: "body.entity_type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "entity_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.options), function(value) {
	    return (_vm.options.length) ? _c('option', {
	      domProps: {
	        "value": value
	      }
	    }, [_vm._v(_vm._s(value))]) : _vm._e()
	  }), 0)]), (_vm.body.entity_type === 'VehicleCategory') ? _c('selectize-category', {
	    attrs: {
	      "selected-value": _vm.item.entity.id
	    },
	    on: {
	      "optionSelected": _vm.entitySelected
	    }
	  }) : _vm._e(), (_vm.body.entity_type === 'Plan') ? _c('selectize-plan', {
	    attrs: {
	      "selected-value": _vm.item.entity.id
	    },
	    on: {
	      "optionSelected": _vm.entitySelected
	    }
	  }) : _vm._e(), (_vm.body.entity_type === 'ClientType') ? _c('selectize-client-type', {
	    attrs: {
	      "selected-value": _vm.item.entity.id
	    },
	    on: {
	      "optionSelected": _vm.entitySelected
	    }
	  }) : _vm._e()], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('DocumentRequirementForm', {
	    model: {
	      value: (_vm.body),
	      callback: function($$v) {
	        _vm.body = $$v
	      },
	      expression: "body"
	    }
	  })], 1), _c('div', {
	    staticClass: "row columns text-center"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Update")])], 1)], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2433 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.logs) ? _c('div', {
	    staticClass: "component-reservation-controller"
	  }, [_c('statistics-card4', [(_vm.bookedTimes) ? _c('dl', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('dt', [_vm._v("Start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.final_start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Booked Start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Minimum booked start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.minimum_booked_start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Actual Start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.actual_start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : _c('dl', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('dt', [_vm._v("Booked Start:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), (_vm.bookedTimes) ? _c('dl', {
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('dt', [_vm._v("End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.final_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Booked End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.booked_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Maximum booked end:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.maximum_booked_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Actual End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.actual_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : _c('dl', {
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('dt', [_vm._v("Booked End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), (_vm.bookedTimes) ? _c('dl', {
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('dt', [_vm._v("Initial duration:")]), _c('dd', [_vm._v(_vm._s(_vm.bookedTimes.human_total_booked))]), _c('dt', [_vm._v("Total duration:")]), _c('dd', [_vm._v(_vm._s(_vm.bookedTimes.human_total_booked_final))]), _c('dt', [_vm._v("Billable End:")]), _c('dd', [_vm._v(_vm._s(_vm.$dateFormat(_vm.bookedTimes.billable_end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('dt', [_vm._v("Billing status:")]), _c('dd', [_vm._v(_vm._s(_vm.item.billing_status))]), (_vm.item.billing_status === 'UNCHARGEABLE') ? _c('dt', [_vm._v("Cancelled: " + _vm._s(_vm.item.canceled))]) : _vm._e(), (_vm.item.memo !== null) ? [_c('dt', [_vm._v("Memo")]), _c('dd', [_vm._v(_vm._s(_vm.item.memo))])] : _vm._e()], 2) : _vm._e(), _c('div', {
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('dl', [_c('dt', [_vm._v("Total driven distance:")]), _c('dd', [_vm._v(_vm._s(_vm.item.distance) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])]), _c('hr'), _c('ReservationFlag', {
	    attrs: {
	      "reservation": _vm.item
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-6 small-12"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'driver-card',
	      "item": _vm.item.driver
	    }
	  })], 1), _c('vehicle', {
	    attrs: {
	      "type": 'compact-card',
	      "item": _vm.vehicle
	    }
	  }, [_c('vehicle-additional-status', {
	    attrs: {
	      "item": _vm.vehicle
	    }
	  }), _c('h2', [_vm._v(_vm._s(_vm.item.booking_mode))])], 1), _c('tab-headers', {
	    attrs: {
	      "tabs": _vm.tabs,
	      "id": 'reservation-detail',
	      "activeIndex": 0
	    }
	  }, [_c('tab-content', {
	    attrs: {
	      "headerName": 'Billing & Costs',
	      "active": true
	    }
	  }, [_c('div', {
	    staticClass: "row columns"
	  }, [(_vm.item.reservation_rate) ? [_c('h4', {
	    staticClass: "text-center"
	  }, [_c('span', [_vm._v("RR" + _vm._s(_vm.item.reservation_rate.id) + " " + _vm._s(_vm.item.reservation_rate.name))])]), _c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "field-cost-per-time"
	  }, [_c('div', {
	    staticClass: "field-label"
	  }, [_vm._v("Cost per Time"), (Array.isArray(_vm.item.reservation_rate.config.time_config)) ? _c('div', [_c('h3', {
	    staticClass: "mb-0"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.reservation_rate.time_rate.time_cost)) + " / " + _vm._s(_vm.parseMinutes(_vm.item.reservation_rate.time_rate.time_cost_cycle)))])]), _vm._l((_vm.timeConfig), function(time) {
	    return _c('div', [_c('small', [_vm._v(_vm._s(time))])])
	  })], 2) : _c('div', [_c('h3', {
	    staticClass: "mb-0"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.reservation_rate.time_rate.time_cost)) + " / " + _vm._s(_vm.parseMinutes(_vm.item.reservation_rate.time_rate.time_cost_cycle)))])]), _c('small', [_vm._v(_vm._s(_vm.item.reservation_rate.time_rate.name))])])])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "field-cost-per-distance"
	  }, [_c('div', {
	    staticClass: "field-label"
	  }, [_vm._v("Cost Per distance"), _c('h3', {
	    staticClass: "mb-0"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.distanceConfig[0]))])]), _vm._l((_vm.distanceConfig), function(distance) {
	    return _c('div', [_c('small', [_vm._v(_vm._s(distance))])])
	  })], 2)])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "field-other-costs"
	  }, [_vm._v("Other costs"), _c('div', {
	    staticClass: "field-label"
	  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.getOtherCosts()))])])])])])])] : _vm._e(), _c('accordion', {
	    attrs: {
	      "titles": _vm.accordionData,
	      "multiExpand": "true"
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "Cost breakdown"
	    },
	    slot: "Cost breakdown"
	  }, [_c('table', [_c('thead', _vm._l((['Id', 'Description', 'Amount']), function(head) {
	    return _c('th', [_vm._v(_vm._s(head))])
	  }), 0), _c('tbody', [(_vm.debugInfo.overhead) ? _c('tr', [(_vm.debugInfo.overhead) ? _c('td', [_vm._v(_vm._s(_vm.debugInfo.overhead.id))]) : _vm._e(), (_vm.debugInfo.overhead) ? _c('td', [_vm._v("Reservation overhead")]) : _vm._e(), (_vm.debugInfo.overhead) ? _c('td', [_vm._v(_vm._s(_vm.getOverHeadCost()))]) : _vm._e()]) : _vm._e(), (_vm.debugInfo.overtime) ? _c('tr', [(_vm.debugInfo.overtime) ? _c('td', [_vm._v(_vm._s(_vm.debugInfo.overtime.id))]) : _vm._e(), (_vm.debugInfo.overtime) ? _c('td', [_vm._v("Reservation overtime")]) : _vm._e(), (_vm.debugInfo.overtime) ? _c('td', [_vm._v(_vm._s(_vm.getOverTimeCost()))]) : _vm._e()]) : _vm._e(), (_vm.debugInfo.calculated_cost) ? _c('tr', [(_vm.debugInfo.calculated_cost) ? _c('td', [_vm._v(_vm._s(_vm.debugInfo.calculated_cost.id))]) : _vm._e(), (_vm.debugInfo.calculated_cost) ? _c('td', [_vm._v("Reservation R" + _vm._s(_vm.item.number))]) : _vm._e(), (_vm.debugInfo.calculated_cost) ? _c('td', [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.debugInfo.calculated_cost.total_cost))]) : _vm._e()]) : _vm._e()])])]), _c('div', {
	    attrs: {
	      "slot": "Applied Rates & Overrides"
	    },
	    slot: "Applied Rates & Overrides"
	  }, [(_vm.debugInfo) ? _c('applied-rates', {
	    attrs: {
	      "item": _vm.getAppliedRates()
	    }
	  }) : _vm._e()], 1), _c('div', {
	    attrs: {
	      "slot": "Deposits"
	    },
	    slot: "Deposits"
	  }, [_c('table', [_c('thead', _vm._l((['Id', 'Description', 'Status', 'Amount', 'Date']), function(head) {
	    return _c('th', [_vm._v(_vm._s(head))])
	  }), 0), _vm._l((_vm.deposits), function(deposit) {
	    return _c('tr', {
	      staticClass: "deposits"
	    }, [_c('td', [_vm._v(_vm._s(deposit.id))]), _c('td', [_c('span', [_vm._v(_vm._s(deposit.reason))])]), _c('td', [_vm._v(_vm._s(deposit.status))]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency(deposit.amount)))]), _c('td', [_vm._v(" " + _vm._s(_vm.$dateFormat(deposit.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])])
	  })], 2)]), _c('div', {
	    attrs: {
	      "slot": "Preauths"
	    },
	    slot: "Preauths"
	  }, [_c('PreauthList', {
	    attrs: {
	      "reservation": _vm.item
	    }
	  })], 1)]), _c('hr'), (_vm.item.cost) ? _c('div', [_vm._v("Total"), _c('span', {
	    staticClass: "float-right"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.item.cost))]), _c('div', {
	    staticClass: "help-text"
	  }, [_vm._v("vat included")])])]) : _vm._e()], 2)]), _c('tab-content', {
	    attrs: {
	      "headerName": 'Trips Data'
	    }
	  }, [_c('ul', {
	    directives: [{
	      name: "f-accordion",
	      rawName: "v-f-accordion"
	    }],
	    staticClass: "accordion",
	    attrs: {
	      "data-accordion": "",
	      "data-allow-all-closed": "true"
	    }
	  }, _vm._l((_vm.item.trips), function(trip) {
	    return _c('li', {
	      staticClass: "accordion-item",
	      attrs: {
	        "data-accordion-item": ""
	      }
	    }, [_c('a', {
	      staticClass: "accordion-title",
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v("Trip " + _vm._s(trip.id))]), _c('div', {
	      staticClass: "accordion-content",
	      attrs: {
	        "data-tab-content": ""
	      }
	    }, [_c('table', [_c('thead', _vm._l((['Id', 'Start', 'End', 'Distance', 'Speed']), function(head) {
	      return _c('th', [_vm._v(_vm._s(head))])
	    }), 0), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(trip.id))]), _c('td', [_vm._v(_vm._s(_vm.$dateFormat(trip.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('td', [_vm._v(_vm._s(_vm.$dateFormat(trip.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('td', [_vm._v(_vm._s(trip.distance) + " " + _vm._s(_vm.configuration.locale.locale_distance_unit.value))]), _c('td', [_vm._v(_vm._s(trip.speed) + " " + _vm._s(_vm.configuration.locale.locale_distance_unit.value) + "/h")])])])])])])
	  }), 0)]), _c('tab-content', {
	    attrs: {
	      "headerName": "Notes"
	    }
	  }, [_c('ReservationNotes')], 1), _c('tab-content', {
	    attrs: {
	      "headerName": 'Reports'
	    }
	  }, [_c('div', {
	    staticClass: "component-tabbed-vehicle-costs"
	  }, [(!_vm.item.reportings.length) ? [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("nothing to show")])] : _vm._l((_vm.item.reportings), function(reporting) {
	    return _c('reporting', {
	      attrs: {
	        "item": reporting,
	        "type": "reservation"
	      }
	    })
	  })], 2)]), (_vm.item.booking_mode === 'STR') ? _c('tab-content', {
	    attrs: {
	      "headerName": "STR Detail"
	    }
	  }, [(_vm.item.segment_rate != null) ? _c('div', {
	    staticClass: "row columns"
	  }, [_c('accordion', {
	    attrs: {
	      "titles": _vm.segmentData,
	      "multiExpand": "true"
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "Segment"
	    },
	    slot: "Segment"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "field-segment-id"
	  }, [_c('div', {
	    staticClass: "field-label"
	  }, [_vm._v("id"), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.item.segment_rate.segment.id))])])])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "field-segment-name"
	  }, [_c('div', {
	    staticClass: "field-label"
	  }, [_vm._v("Name"), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.item.segment_rate.segment.name))])])])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "field-segment-description"
	  }, [_c('div', {
	    staticClass: "field-label"
	  }, [_vm._v("Description"), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.item.segment_rate.segment.description))])])])])])])]), _c('div', {
	    attrs: {
	      "slot": "Rental agreement"
	    },
	    slot: "Rental agreement"
	  }, [_c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.segment_rate.extended_description)
	    }
	  })])])], 1) : _c('div', {
	    staticClass: "row columns"
	  }, [_c('h2', {
	    staticClass: "no-result-message text-center"
	  }, [_vm._v("Nothing to show here yet :(")])])]) : _vm._e(), _c('tab-content', {
	    attrs: {
	      "headerName": "Charging sessions"
	    }
	  }, [_c('ChargingSessionsList', {
	    attrs: {
	      "reservation": _vm.item
	    }
	  })], 1)], 1)], 1), _c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('BackofficeReservation', {
	    attrs: {
	      "item": _vm.item,
	      "type": "start-end-position"
	    }
	  })], 1)]), (_vm.$acl('route-reservation')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [(_vm.item) ? _c('ReservationRoute', {
	    attrs: {
	      "item": _vm.item
	    }
	  }) : _vm._e()], 1)]) : _vm._e(), _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('span', [_vm._v("Reservation Status")]), _c('h2', [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('span', [_vm._v("Commercial Status")]), _c('h2', [_vm._v(_vm._s(_vm.item.billing_status))])])]), _c('reservation-log-time-line', {
	    attrs: {
	      "items": _vm.logs
	    }
	  })], 1)])])])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2434 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ModalReveal', {
	    key: _vm.key,
	    ref: "modalOperation",
	    on: {
	      "input": _vm.closeInput
	    }
	  }, [_c('div', {
	    staticClass: "text-right",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('a', {
	    staticClass: "fa-stack fa-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.preset),
	      expression: "preset"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.preset = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.usePreset($event)
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected",
	      "disabled": "disabled",
	      "value": ""
	    }
	  }, [_vm._v("Use preset...")]), _vm._l((_vm.presets), function(i, k) {
	    return _c('option', {
	      key: k,
	      domProps: {
	        "value": k
	      }
	    }, [_vm._v(_vm._s(k) + ": " + _vm._s(i.description))])
	  })], 2)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.jsonOperation),
	      expression: "jsonOperation"
	    }],
	    staticStyle: {
	      "font-family": "monospace"
	    },
	    attrs: {
	      "rows": "10",
	      "placeholder": "Paste your Json Operation"
	    },
	    domProps: {
	      "value": (_vm.jsonOperation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.jsonOperation = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }), _c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    ref: "file",
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "file"
	    }
	  }), _c('div', {
	    staticClass: "input-group-button"
	  }, [_c('div', {
	    staticClass: "button",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.disabled || _vm.spin,
	      "value": "Upload"
	    },
	    on: {
	      "click": _vm.handleFile
	    }
	  }, [(_vm.spin) ? _c('span', {
	    staticClass: "fa fa-spinner fa-spin",
	    class: {
	      spin: _vm.spin
	    }
	  }) : _c('span', [_vm._v("Upload")])])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.doOperation,
	      "disabled": _vm.jsonOperation == ''
	    }
	  }, [_vm._v("Run")])], 1)])]), _c('div', {
	    staticClass: "component-backoffice-cargo-list row column"
	  }, [_c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2435 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('div', {
	    staticClass: "row column card p-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Clients"), _c('SearchEntity', {
	    staticClass: "mb-1",
	    attrs: {
	      "entity": "clients",
	      "clear-input": "clear-input"
	    },
	    on: {
	      "selected": _vm.add
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(result) {
	        return [_c('div', {
	          staticClass: "quick-search-result"
	        }, [_c('div', [_c('small', [_vm._v("CL" + _vm._s(result.result.id))]), _c('div', [_vm._v(_vm._s(result.result.name) + " " + _vm._s(result.result.surname))]), (result.result.organization_name) ? _c('div', [_c('small', [_vm._v(_vm._s(result.result.organization_name))])]) : _vm._e(), _c('div', [_c('small', [_vm._v(_vm._s(result.result.phone))])])])])]
	      }
	    }]),
	    model: {
	      value: (_vm.search),
	      callback: function($$v) {
	        _vm.search = $$v
	      },
	      expression: "search"
	    }
	  })], 1), _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "componentType": "federationList",
	      "selectableList": true,
	      "resultsPerPage": 5
	    },
	    model: {
	      value: (_vm.selected.delete),
	      callback: function($$v) {
	        _vm.$set(_vm.selected, "delete", $$v)
	      },
	      expression: "selected.delete"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [(_vm.selected.delete.length) ? _c('ActionButton', {
	    attrs: {
	      "action": _vm.save,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("Delete")]) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2436 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])])
	},staticRenderFns: []}

/***/ }),
/* 2437 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'federation-vehicles',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("Vehicles")]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'federation-parking-groups',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("Parking groups")]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'federation-clients',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("Clients")]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2438 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Entity")]), _c('span', [_vm._v(_vm._s(_vm.item.sentinellable) + " " + _vm._s(_vm.item.sentinellable_id))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Content")]), _c('span', [_vm._v(_vm._s(_vm.item.content))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Severity")]), _c('span', [_vm._v(_vm._s(_vm.severity))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Date and Time")]), _c('span', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.timestamp, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: _vm.item.sentinellable.toLowerCase(),
	        params: {
	          id: _vm.item.sentinellable_id
	        }
	      },
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 2439 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns"
	  }, [_vm._t("n2")], 2), _c('div', {
	    staticClass: "columns"
	  }, [_vm._t("n3")], 2), _c('div', {
	    staticClass: "columns"
	  }, [_vm._t("n4")], 2), _c('div', {
	    staticClass: "columns"
	  }, [_vm._t("n5")], 2), _c('div', {
	    staticClass: "columns"
	  }, [_vm._t("n6")], 2), _c('div', {
	    staticClass: "columns"
	  }, [_vm._t("n7")], 2)])]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionPage")], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2440 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-vehicle-reports"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-8"
	  }, [_c('date-range-picker', {
	    on: {
	      "input": _vm.dateRangeSelected
	    }
	  })], 1), _c('div', {
	    staticClass: "column shrink"
	  }), _c('a', {
	    staticClass: "fa fa-search fa-2x",
	    on: {
	      "click": _vm.filterReservation
	    }
	  })]), _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "componentType": "vehicle-list"
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Reservations")])])])
	}]}

/***/ }),
/* 2441 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('PolicyButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "refresh": function($event) {
	        return _vm.$emit('refresh')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("P" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._l((_vm.item.configuration), function(conf, key) {
	    return _c('div', {
	      staticClass: "column shrink"
	    }, [(key === 'max_bookable' || key === 'min_bookable') ? _c('div', {
	      staticClass: "bookable"
	    }, [_c('div', [_vm._v(_vm._s(key.replace('_', ' ')))]), _c('div', [_vm._v(_vm._s(conf))])]) : _vm._e(), (key === 'booking_days') ? _c('div', {
	      staticClass: "booking_days"
	    }, [_c('div', [_vm._v("Booking Days")]), _vm._l((conf), function(c) {
	      return _c('span', [_vm._v(_vm._s(c) + " ")])
	    })], 2) : _vm._e()])
	  })], 2)]) : _vm._e(), (_vm.$is('entity-policy')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("P" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Type")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.type))])]), _vm._l((_vm.item.configuration), function(conf, key, i) {
	    return _c('div', {
	      staticClass: "column"
	    }, [_c('div', [_vm._v(_vm._s(key))]), (typeof conf === 'number') ? _c('div', [_vm._v(_vm._s(conf))]) : _vm._e()])
	  })], 2)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2442 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-9"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle show-for-medium"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns n1"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns n2 align-self-middle"
	  }, [_vm._t("n2")], 2), _c('div', {
	    staticClass: "columns n3 align-self-middle"
	  }, [_vm._t("n3")], 2), _c('div', {
	    staticClass: "columns n4 align-self-middle"
	  }, [_vm._t("n4")], 2), _c('div', {
	    staticClass: "columns n5 align-self-middle"
	  }, [_vm._t("n5")], 2), _c('div', {
	    staticClass: "columns n6 align-self-middle"
	  }, [_vm._t("n6")], 2), _c('div', {
	    staticClass: "columns n7 align-self-middle"
	  }, [_vm._t("n7")], 2), _c('div', {
	    staticClass: "columns n8 align-self-middle"
	  }, [_vm._t("n8")], 2), _c('div', {
	    staticClass: "columns n9 align-self-middle"
	  }, [_vm._t("n9")], 2), _c('div', {
	    staticClass: "columns n10 align-self-middle"
	  }, [_vm._t("n10")], 2)])]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle show-for-medium"
	  }, [_vm._t("actionPage")], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2443 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'group',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("Edit")]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2444 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-plan"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('plan-setup', {
	    attrs: {
	      "create": true
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2445 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle"
	  }, [(_vm.options) ? _c('selectize', {
	    ref: "selectize",
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "Intervention request",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "disabled": _vm.disabled,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Intervention requests"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2446 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 2447 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm.key,
	    ref: _vm.componentId,
	    on: {
	      "input": _vm.closeInput
	    }
	  }, [(_vm.policyProp) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]) : _c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.policy.name),
	      expression: "policy.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.policy.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.policy, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Max bookable hours"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.policy.configuration.max_bookable),
	      expression: "policy.configuration.max_bookable"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.policy.configuration.max_bookable)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.policy.configuration, "max_bookable", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Min bookable time in minutes"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.policy.configuration.min_bookable),
	      expression: "policy.configuration.min_bookable"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.policy.configuration.min_bookable)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.policy.configuration, "min_bookable", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Booking Days")]), _c('div', {
	    staticClass: "row"
	  }, _vm._l((['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']), function(day) {
	    return _c('div', {
	      staticClass: "column shrink"
	    }, [_c('label', [_vm._v(_vm._s(day) + " "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.policy.configuration.booking_days),
	        expression: "policy.configuration.booking_days"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": day,
	        "checked": Array.isArray(_vm.policy.configuration.booking_days) ? _vm._i(_vm.policy.configuration.booking_days, day) > -1 : (_vm.policy.configuration.booking_days)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.policy.configuration.booking_days,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = day,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(_vm.policy.configuration, "booking_days", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(_vm.policy.configuration, "booking_days", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(_vm.policy.configuration, "booking_days", $$c)
	          }
	        }
	      }
	    })])])
	  }), 0), _c('label', [_vm._v("Booking hours")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Start"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.policy.configuration.booking_hours.start),
	      expression: "policy.configuration.booking_hours.start"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "HH:mm"
	    },
	    domProps: {
	      "value": (_vm.policy.configuration.booking_hours.start)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.policy.configuration.booking_hours, "start", $event.target.value)
	      }
	    }
	  }), (!_vm.startValid) ? _c('div', {
	    staticClass: "help-text"
	  }, [_vm._v("Invalid format (HH:mm)")]) : _vm._e()])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("End"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.policy.configuration.booking_hours.end),
	      expression: "policy.configuration.booking_hours.end"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "HH:mm"
	    },
	    domProps: {
	      "value": (_vm.policy.configuration.booking_hours.end)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.policy.configuration.booking_hours, "end", $event.target.value)
	      }
	    }
	  }), (!_vm.endValid) ? _c('div', {
	    staticClass: "help-text"
	  }, [_vm._v("Invalid format (HH:mm)")]) : _vm._e()])])])])]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save,
	      "disabled": !_vm.startValid || !_vm.endValid
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2448 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-controller"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'driver-card',
	      "item": _vm.item.main_driver
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('div', {
	    staticClass: "card p-1"
	  }, [_c('router-view')], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2449 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-extra-fields"
	  }, [_c('h2', [_vm._v("Extra")]), _c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.fields), function(value, label) {
	    return _c('div', {
	      staticClass: "columns"
	    }, [_c('label', [_vm._v(_vm._s(label)), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.fields[label]),
	        expression: "fields[label]"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.fields[label])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.fields, label, $event.target.value)
	        }
	      }
	    })])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2450 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabs"
	  }, [_c('ul', {
	    staticClass: "tabs",
	    attrs: {
	      "id": _vm.id,
	      "data-tabs": "",
	      "data-deep-link": _vm.deepLink,
	      "data-update-history": _vm.deepLink,
	      "data-deep-link-smudge": _vm.deepLink
	    }
	  }, _vm._l((_vm.tabs), function(tab, index) {
	    return _c('li', {
	      staticClass: "tabs-title",
	      class: {
	        'is-active': index === _vm.activeIndex
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": '#' + _vm.$toDashedString(tab),
	        "aria-selected": index === _vm.activeIndex
	      }
	    }, [_vm._v(_vm._s(tab))])])
	  }), 0), _c('div', {
	    staticClass: "tabs-content",
	    attrs: {
	      "data-tabs-content": _vm.id
	    }
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2451 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-subscriptions"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "tabs-inner-content client-subscriptions no-space"
	  }, [_c('div', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "is-hidden",
	    attrs: {
	      "id": "create-subscription",
	      "data-toggler": "is-hidden"
	    }
	  }, [_c('client-plan-subscriber', {
	    attrs: {
	      "client_id": _vm.$route.params.id
	    },
	    on: {
	      "subscriptionAdded": _vm.subscriptionAdded
	    }
	  })], 1), _c('base-list', {
	    ref: "tabbedList",
	    attrs: {
	      "dataLoader": _vm.dataLoader,
	      "component": _vm.component
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Client Subscriptions")])]), _c('div', {
	    staticClass: "action"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    attrs: {
	      "data-toggle": "create-subscription"
	    }
	  })])])
	}]}

/***/ }),
/* 2452 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-move-asset"
	  }, [_c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        _vm.moveEnabled = !_vm.moveEnabled
	      }
	    }
	  }, [_vm._v("Move")]), (_vm.moveEnabled) ? _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        _vm.moveEnabled = false
	      }
	    }
	  }, [_vm._v("x")]), _c('h2', [_vm._v("Select the parking slot")]), _c('selectize-grouped-parking-assets', {
	    on: {
	      "parkingSlotSelected": _vm.parkingSlotSelected
	    }
	  }), _c('div', {
	    staticClass: "button-group"
	  }, [(_vm.parking_slot_id) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.move
	    }
	  }, [_vm._v("Move")]) : _vm._e()])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2453 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-login login-box"
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('form', {
	    attrs: {
	      "enctype": "multipart/form-data"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.formSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-fields-wrapper"
	  }, [_c('div', {
	    staticClass: "form-field-wrapper form-field-username"
	  }, [_c('label', [_vm._v("Username\n                            "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.login.username),
	      expression: "login.username"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "username"
	    },
	    domProps: {
	      "value": (_vm.login.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.login, "username", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-field-wrapper form-field-password"
	  }, [_c('label', [_vm._v("Password\n                            "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.login.password),
	      expression: "login.password"
	    }],
	    attrs: {
	      "type": "password",
	      "placeholder": "password"
	    },
	    domProps: {
	      "value": (_vm.login.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.login, "password", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-message-catch text-center"
	  }, [_vm._t("default")], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "login-footer-area"
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-field-wrapper form-field-submit"
	  }, [_c('input', {
	    staticClass: "submit button",
	    attrs: {
	      "type": "submit",
	      "value": "Login"
	    }
	  })])
	}]}

/***/ }),
/* 2454 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-policy-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2455 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('PageButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Title")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.title))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Slug")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.slug))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Action")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.action))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.created_at))])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2456 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-translation-action-buttons"
	  }, [_c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])])
	},staticRenderFns: []}

/***/ }),
/* 2457 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-vehicle-slot"
	  }, [(_vm.$is('asset-management-list')) ? _c('div', {
	    staticClass: "asset-management-list"
	  }, [_c('div', {
	    staticClass: "item-vehicle-slot-id"
	  }, [_vm._v("VS-" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "item-vehicle-slot-name"
	  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
	    staticClass: "item-vehicle-slot-name"
	  }, [_vm._v("Booking mode " + _vm._s(_vm.item.reservation_type))])]) : _c('div', {
	    staticClass: "card inner-content"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.item.name) + "  [disabled: " + _vm._s(_vm.item.disabled) + "]")])]), _c('div', {
	    staticClass: "description"
	  }, [_c('p', [_vm._v(_vm._s(_vm.item.reservation_type) + " - " + _vm._s(_vm.item.vehicle.model) + " - " + _vm._s(_vm.item.vehicle.plate))]), _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.enable
	    }
	  }, [_vm._v("Enable")]), _c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.disable
	    }
	  }, [_vm._v("Disable")])]), _c('accordion', {
	    attrs: {
	      "items": _vm.item
	    }
	  })], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2458 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-reservation"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [(_vm.$is('listing')) ? _c('card5', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true
	    }
	  }, [_c('dropdown', {
	    attrs: {
	      "slot": "actionBullets",
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    },
	    slot: "actionBullets"
	  }, [_c('plan-reservation-rate-action-buttons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "deleted": function($event) {
	        return _vm.$emit('deleted')
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "field",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("PRR" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "field",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("RR" + _vm._s(_vm.item.reservation_rate.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.reservation_rate.name))])]), _c('div', {
	    staticClass: "field",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [(_vm.item.reservation_rate.time_rate) ? [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Time cost: " + _vm._s(_vm.currency) + _vm._s(_vm.withVat(_vm.item.reservation_rate.time_rate.time_cost)) + "/" + _vm._s(_vm.item.reservation_rate.time_rate.time_cost_cycle) + "min")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Driving time cost: " + _vm._s(_vm.currency) + _vm._s(_vm.withVat(_vm.item.reservation_rate.time_rate.driving_time_cost)) + "/" + _vm._s(_vm.item.reservation_rate.time_rate.time_cost_cycle) + "min")])] : _vm._e()], 2), _c('div', {
	    staticClass: "field",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [(_vm.item.reservation_rate.distance_rate) ? [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Distance cost")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.currency) + _vm._s(_vm.withVat(_vm.item.reservation_rate.distance_rate.distance_cost)) + "/" + _vm._s(_vm.item.reservation_rate.distance_rate.distance_cost_cycle) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])] : _vm._e()], 2), _c('div', {
	    staticClass: "field",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Vehicle Category")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("VC" + _vm._s(_vm.item.vehicle_category.id) + " " + _vm._s(_vm.item.vehicle_category.name))])]), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'configuration-rate',
	        params: {
	          id: _vm.item.reservation_rate.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2459 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', [_c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('h2', [_vm._v("Create new document requirement")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Select entity"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entity),
	      expression: "entity"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.entity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.options), function(value) {
	    return (_vm.options.length) ? _c('option', {
	      domProps: {
	        "value": value
	      }
	    }, [_vm._v(_vm._s(value))]) : _vm._e()
	  }), 0)]), (_vm.entity === 'VehicleCategory') ? _c('selectize-category', {
	    on: {
	      "optionSelected": _vm.entitySelected
	    }
	  }) : _vm._e(), (_vm.entity === 'Plan') ? _c('selectize-plan', {
	    on: {
	      "optionSelected": _vm.entitySelected
	    }
	  }) : _vm._e(), (_vm.entity === 'ClientType') ? _c('selectize-client-type', {
	    on: {
	      "optionSelected": _vm.entitySelected
	    }
	  }) : _vm._e()], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Document type"), _c('SelectizeDocumentType', {
	    attrs: {
	      "max-items": 1
	    },
	    on: {
	      "optionSelected": _vm.documentTypeSelected
	    }
	  })], 1), _c('label', [_vm._v("Document group"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.document_group),
	      expression: "body.document_group"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.document_group)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "document_group", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row columns text-center"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Save Document Type")])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2460 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-ranger-picker"
	  }, [_c('v-md-date-range-picker', {
	    attrs: {
	      "show-activator-label": false,
	      "start-date": _vm.startDate,
	      "end-date": _vm.endDate,
	      "showYearSelect": true
	    },
	    on: {
	      "change": _vm.rangeSelected
	    }
	  }, [_c('input', {
	    attrs: {
	      "slot": "input",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": _vm.textLabel
	    },
	    slot: "input"
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2461 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('RegistrationTokenReveal', {
	    attrs: {
	      "item": _vm.item,
	      "type": "edit"
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.remove
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2462 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-statistics-card-4"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_vm._t("n1")], 2)]), _c('div', {
	    staticClass: "columns card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_vm._t("n2")], 2)]), _c('div', {
	    staticClass: "columns card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_vm._t("n3")], 2)]), _c('div', {
	    staticClass: "columns card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_vm._t("n4")], 2)]), _c('div', {
	    staticClass: "columns card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_vm._t("n5")], 2)]), _c('div', {
	    staticClass: "columns card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_vm._t("n6")], 2)]), _c('div', {
	    staticClass: "columns card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_vm._t("n7")], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 2463 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-statistics-card statistics-card-6"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6 medium-2"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n1")], 2)]), _c('div', {
	    staticClass: "columns small-6 medium-2"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n2")], 2)]), _c('div', {
	    staticClass: "columns small-6 medium-2"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n3")], 2)]), _c('div', {
	    staticClass: "columns small-6 medium-2"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n4")], 2)]), _c('div', {
	    staticClass: "columns small-6 medium-2"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n5")], 2)]), _c('div', {
	    staticClass: "columns small-6 medium-2"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n6")], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 2464 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-controller"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'driver-card',
	      "item": _vm.item
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "field-status"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))])])])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'highlightedNotes',
	      "item": _vm.item
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('router-tab-headers', {
	    attrs: {
	      "id": "driver-details",
	      "tabs": _vm.tabs
	    }
	  }, [_c('router-view')], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2465 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-statistics-card statistics-card-5"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6 medium-expand"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n1")], 2)]), _c('div', {
	    staticClass: "columns small-6 medium-expand"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n2")], 2)]), _c('div', {
	    staticClass: "columns small-6 medium-expand"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n3")], 2)]), _c('div', {
	    staticClass: "columns small-6 medium-expand"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n4")], 2)]), _c('div', {
	    staticClass: "columns small-6 medium-expand"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n5")], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 2466 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-statistics-card statistics-card-4"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6 large-3"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n1")], 2)]), _c('div', {
	    staticClass: "columns small-6 large-3"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n2")], 2)]), _c('div', {
	    staticClass: "columns small-6 large-3"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n3")], 2)]), _c('div', {
	    staticClass: "columns small-6 large-3"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_vm._t("n4")], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 2467 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-plan-smart-edit"
	  }, [_c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item,
	      "translatable": _vm.options.translatable
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2468 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-accordion accordion",
	    attrs: {
	      "data-accordion": "",
	      "data-allow-all-closed": true
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 2469 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-coupon-in-use-list"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-2 large-2"
	  }, [_c('selectize-driver', {
	    attrs: {
	      "allowEmptyOption": true
	    },
	    on: {
	      "optionSelected": _vm.selectDriver,
	      "optionRemoved": _vm.unsetDriverId
	    }
	  })], 1), _c('div', {
	    staticClass: "column small-4 large-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchRequest.coupon_code),
	      expression: "searchRequest.coupon_code"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.searchRequest, "coupon_code", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Search for code")]), _vm._l((_vm.options), function(option, index) {
	    return _c('option', {
	      domProps: {
	        "value": option.code
	      }
	    }, [_vm._v(_vm._s(option.code))])
	  })], 2)]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('date-range-picker', {
	    key: _vm.componentKey,
	    staticClass: "rightMargin",
	    attrs: {
	      "label": "Select created range"
	    },
	    on: {
	      "input": _vm.dateRangeSelected
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('a', {
	    staticClass: "fa fa-filter fa-2x",
	    on: {
	      "click": _vm.searchFilter
	    }
	  })])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search,
	      "showPerPageSelect": true
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2470 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "disabled": _vm.disabled,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Toc"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2471 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle"
	  }, [(_vm.options) ? _c('selectize', {
	    ref: "selectize",
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "disabled": _vm.disabled,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Segments"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2472 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "google-map"
	  }, [(_vm.searchBar) ? _c('GoogleMapSearchBox', {
	    attrs: {
	      "embeddedOnMap": true
	    },
	    on: {
	      "placesChanged": _vm.panToPosition
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "placeholder",
	    attrs: {
	      "id": this._uid
	    }
	  }), _vm._t("default"), (_vm.search_marker) ? _c('google-map-marker', {
	    key: _vm.search_marker.title,
	    attrs: {
	      "position": _vm.search_marker.position,
	      "title": _vm.search_marker.title,
	      "label": _vm.search_marker.label
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2473 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-vehicle-costs"
	  }, [_c('div', {
	    staticClass: "action-bar"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "action"
	  }, [_c('CreateNoteModal', {
	    attrs: {
	      "entity": _vm.note.type,
	      "entityId": _vm.$route.params.id
	    },
	    on: {
	      "noteCreated": _vm.addNote
	    }
	  })], 1)]), _c('div', {
	    staticClass: "container"
	  }, [_c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false,
	      "component-type": "entityList"
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Vehicle Notes")])])
	}]}

/***/ }),
/* 2474 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-vehicle-availability"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('search-vehicle-availability', {
	    attrs: {
	      "vehicle": _vm.vehicle
	    },
	    on: {
	      "slotsSelected": _vm.book
	    }
	  }, [_c('label', [_vm._v("Driver"), _c('selectize-driver', {
	    on: {
	      "optionSelected": _vm.selectDriver
	    }
	  })], 1)])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Availability")])])])
	}]}

/***/ }),
/* 2475 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component component-backoffice-client-custom-fields-configuration"
	  }, _vm._l((_vm.value), function(elem, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('DeleteConf', {
	      on: {
	        "click": function($event) {
	          return _vm.value.splice(index, 1)
	        }
	      }
	    }), _vm._l((elem), function(val, inx) {
	      return _c('div', {
	        staticClass: "column"
	      }, [(inx !== 'validation' && inx !== 'default') ? _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.value[index][inx]),
	          expression: "value[index][inx]"
	        }],
	        attrs: {
	          "type": "text",
	          "placeholder": inx
	        },
	        domProps: {
	          "value": (_vm.value[index][inx])
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(_vm.value[index], inx, $event.target.value)
	          }
	        }
	      }) : (inx !== 'default') ? _c('ValidationConfig', {
	        attrs: {
	          "validation-key": "validation"
	        },
	        model: {
	          value: (_vm.value[index]),
	          callback: function($$v) {
	            _vm.$set(_vm.value, index, $$v)
	          },
	          expression: "value[index]"
	        }
	      }) : _vm._e()], 1)
	    })], 2)
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2476 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('reporting-id')) ? _c('div', {
	    staticClass: "field-reporting-id"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("RP" + _vm._s(_vm.item.id))])]) : (_vm.$is('reporting-name')) ? _c('div', {
	    staticClass: "field-reporting-name"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.type.name))])]) : (_vm.$is('reporting-driver-info')) ? _c('div', {
	    staticClass: "field-reporting-driver-info"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'oneLook',
	      "item": _vm.item.driver
	    }
	  }), _c('driver', {
	    attrs: {
	      "type": 'driverName',
	      "item": _vm.item.driver
	    }
	  })], 1) : (_vm.$is('reporting-location')) ? _c('div', {
	    staticClass: "field-reporting-location"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Location")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.location))])]) : (_vm.$is('reporting-vehicle')) ? _c('div', {
	    staticClass: "field-reporting-vehicle"
	  }, [_c('vehicle', {
	    attrs: {
	      "type": 'oneLook',
	      "item": _vm.item.vehicle
	    }
	  })], 1) : (_vm.$is('reporting-reported-at')) ? _c('div', {
	    staticClass: "field-reporting-reported-at"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Reported at")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('reporting-updated-at')) ? _c('div', {
	    staticClass: "field-reporting-updated-at"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Updated at")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.updated, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('reporting-status')) ? _c('div', {
	    staticClass: "field-reporting-status"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value"
	  }, [_c('status', {
	    attrs: {
	      "status": _vm.item.status
	    }
	  })], 1), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2477 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-set-paid"
	  }, [(_vm.invoice.status !== 'PAID') ? _c('reveal', {
	    attrs: {
	      "confirm": true
	    },
	    on: {
	      "confirm": _vm.setPaid
	    }
	  }, [(_vm.buttons) ? _c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Mark as Paid")]) : _c('a', {
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Pay by cash")]), _c('h2', [_vm._v("Do you really want to Mark as Paid the invoice"), _c('strong', [_vm._v("INV" + _vm._s(_vm.invoice.internal_id) + "(" + _vm._s(_vm.invoice.id) + ")")])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2478 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2479 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-coupon-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2480 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-header-columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.columns), function(column, key) {
	    return _c('div', {
	      staticClass: "columns",
	      class: {
	        shrink: column === ''
	      }
	    }, [_vm._v(_vm._s(column))])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2481 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-overview"
	  }, [_c('transaction', {
	    attrs: {
	      "item": _vm.transaction,
	      "type": 'detail'
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2482 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('driver-info')) ? _c('div', {
	    staticClass: "field-driver-info"
	  }, [_c('driver-fields', {
	    attrs: {
	      "fieldName": 'driver-status',
	      "item": _vm.item
	    }
	  }), _c('driver-fields', {
	    attrs: {
	      "fieldName": 'driver-id',
	      "item": _vm.item
	    }
	  }), _c('driver-fields', {
	    attrs: {
	      "fieldName": 'driver-fullname',
	      "item": _vm.item
	    }
	  })], 1) : (_vm.$is('driver-info-no-status')) ? _c('div', {
	    staticClass: "field-driver-info-no-status"
	  }, [_c('driver-fields', {
	    attrs: {
	      "fieldName": 'driver-id',
	      "item": _vm.item
	    }
	  }), _c('driver-fields', {
	    attrs: {
	      "fieldName": 'driver-fullname',
	      "item": _vm.item
	    }
	  })], 1) : (_vm.$is('driver-status')) ? _c('div', {
	    staticClass: "field-driver-status"
	  }, [_c('status', {
	    staticClass: "float-left",
	    attrs: {
	      "status": _vm.item.status
	    }
	  }), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))])], 1) : (_vm.$is('driver-id')) ? _c('div', {
	    staticClass: "field-driver-id"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("DR" + _vm._s(_vm.item.id))])], 1) : (_vm.$is('driver-uid')) ? _c('div', {
	    staticClass: "field-driver-uid"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.uid))])]) : (_vm.$is('client-info')) ? _c('div', {
	    staticClass: "field-client-info"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.client_id
	        }
	      }
	    }
	  }, [_vm._v("CL" + _vm._s(_vm.item.client_id))])], 1), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.client_name))])]) : (_vm.$is('city')) ? _c('div', {
	    staticClass: "field-city"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.address.city))])]) : (_vm.$is('created')) ? _c('div', {
	    staticClass: "field-created"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('updated')) ? _c('div', {
	    staticClass: "field-updated"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.updated, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('phone-and-email')) ? _c('div', {
	    staticClass: "field-phone-and-email"
	  }, [_c('div', {
	    staticClass: "field-phone"
	  }, [_vm._v(_vm._s(_vm.item.phone))]), _c('div', {
	    staticClass: "field-email"
	  }, [_vm._v(_vm._s(_vm.item.email))])]) : (_vm.$is('driver-fullname')) ? _c('div', {
	    staticClass: "driver-fullname",
	    attrs: {
	      "fieldName": 'driver-name'
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v(" " + _vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])], 1) : (_vm.$is('driver-name')) ? _c('div', {
	    staticClass: "driver-name",
	    attrs: {
	      "fieldName": 'driver-name'
	    }
	  }, [_vm._v(_vm._s(_vm.item.name))]) : (_vm.$is('driver-surname')) ? _c('div', {
	    staticClass: "driver-surname",
	    attrs: {
	      "fieldName": 'driver-surname'
	    }
	  }, [_vm._v(_vm._s(_vm.item.surname))]) : (_vm.$is('driver-gender')) ? _c('div', {
	    staticClass: "driver-gender",
	    attrs: {
	      "fieldName": 'driver-gender'
	    }
	  }, [_vm._v(_vm._s(_vm.item.gender))]) : (_vm.$is('driver-country')) ? _c('div', {
	    staticClass: "driver-country",
	    attrs: {
	      "fieldName": 'driver-country'
	    }
	  }, [_vm._v(_vm._s(_vm.item.address.country))]) : (_vm.$is('driver-id')) ? _c('div', {
	    staticClass: "driver-id",
	    attrs: {
	      "type": 'driver-id'
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2483 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-reservation-controller"
	  }, [_c('statistics-card4', [_c('div', {
	    staticClass: "field-reporting-type",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('div', {
	    staticClass: "field-type-name"
	  }, [_vm._v(_vm._s(_vm.item.type.name))]), _c('div', {
	    staticClass: "field-type-description"
	  }, [_vm._v(_vm._s(_vm.item.type.description))])]), _c('div', {
	    staticClass: "field-reporting-status",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
	    staticClass: "field-reporting-location",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Location")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.location))])]), _c('div', {
	    staticClass: "field-reporting-timestamp",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Created " + _vm._s(_vm.$dateFormat(_vm.item.created, "DD-MM-YYYY HH:mm:ss")))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Updated " + _vm._s(_vm.$dateFormat(_vm.item.updated, "DD-MM-YYYY HH:mm:ss")))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-6 small-12"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'driver-card',
	      "item": _vm.item.driver
	    }
	  })], 1), (_vm.item.vehicle) ? _c('vehicle', {
	    attrs: {
	      "type": 'compact-card',
	      "item": _vm.item.vehicle
	    }
	  }) : _vm._e()], 1), _c('div', {
	    staticClass: "columns large-6 small-12"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('p', [_vm._v(_vm._s(_vm.item.description))]), _c('hr'), (_vm.item.damage_position_raw) ? _c('vehicle-damage', {
	    attrs: {
	      "items": _vm.item.damage_position_raw,
	      "vehicleType": _vm.item.vehicle.category.vehicle_type.name,
	      "vehicleDamagePicture": _vm.item.vehicle.category.damage_picture_external
	    }
	  }) : _vm._e(), _c('h2', [_vm._v("Attachments")]), _vm._l((_vm.item.attachments), function(attachment) {
	    return _c('backoffice-attachment', {
	      attrs: {
	        "item": attachment
	      }
	    })
	  })], 2)])])])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2484 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-card"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card-n', {
	    attrs: {
	      "columns": 5,
	      "showBullets": true
	    }
	  }, [_c('Dropdown', {
	    attrs: {
	      "slot": "actionBullets",
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    },
	    slot: "actionBullets"
	  }, [_c('PaymentMethodButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "refresh": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1), _c('payment-method-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'payment-method-id'
	    },
	    slot: "n1"
	  }), _c('payment-method-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'payment-method-name'
	    },
	    slot: "n2"
	  }), _c('payment-method-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'payment-method-provider'
	    },
	    slot: "n3"
	  }), _c('payment-method-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'payment-method-created'
	    },
	    slot: "n4"
	  }), _c('payment-method-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'payment-method-updated'
	    },
	    slot: "n5"
	  })], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2485 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-deposit"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h3', [_vm._v("D" + _vm._s(_vm.item.id))]), _c('small', {
	    style: (_vm.item.status === 'FAIL' ? 'color:red' : '')
	  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Date")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.reason))])])]), _c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Amount")]), _c('h3', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount)))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Walletable")]), (_vm.walletable) ? _c('h3', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.walletable_id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.walletable) + _vm._s(_vm.item.walletable_id))])], 1) : _vm._e()]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Invoice")]), (_vm.item.invoice_id) ? _c('h3', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'invoice',
	        params: {
	          id: _vm.item.invoice_id
	        }
	      }
	    }
	  }, [_vm._v("INV" + _vm._s(_vm.item.invoice_id))])], 1) : _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_vm._v("not invoiced")])])])])]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2486 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-void"
	  }, [_c('ModalReveal', {
	    ref: _vm.componentId
	  }, [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Emit Credit note")]), _c('div', {
	    staticClass: "header",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('h2', [_vm._v("Credit note for the invoice:  "), _c('strong', [_vm._v("INV" + _vm._s(_vm.invoice.internal_id) + "(" + _vm._s(_vm.invoice.id) + ")")])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "medium-12 columns"
	  }, [_c('label', [_vm._v("Invoice credit description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.voidFields.reason),
	      expression: "voidFields.reason"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.voidFields.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.voidFields, "reason", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "medium-12 columns"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.voidFields.refundOnGateway),
	      expression: "voidFields.refundOnGateway"
	    }],
	    attrs: {
	      "type": "radio",
	      "disabled": _vm.invoice.status !== 'PAID'
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.voidFields.refundOnGateway, true)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.voidFields, "refundOnGateway", true)
	      }
	    }
	  }), _vm._v("Refund on gateway  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.voidFields.refundOnGateway),
	      expression: "voidFields.refundOnGateway"
	    }],
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.voidFields.refundOnGateway, false)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.voidFields, "refundOnGateway", false)
	      }
	    }
	  }), _vm._v("Refund on wallet")]), _c('div', {
	    staticClass: "manual"
	  }, [_c('table', [_c('thead', [_c('tr', _vm._l((['ID', 'Walletable', 'Vat', 'Subtotal', 'Total', 'Amount']), function(head) {
	    return _c('th', [_vm._v(_vm._s(head))])
	  }), 0)]), _c('tbody', _vm._l((_vm.invoice.records), function(record) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(record.id))]), _c('td', [_c('div', {
	      staticClass: "walletable"
	    }, [_vm._v(_vm._s(record.walletable_type.replace(/App\\Models\\/, '')) + " " + _vm._s(record.walletable_id))]), _vm._l((record.reason.split('|')), function(reason) {
	      return (record.walletable_type.replace(/App\\Models\\/, '') != 'Reservation') ? _c('div', {
	        staticClass: "reason"
	      }, [_vm._v(_vm._s(reason))]) : _vm._e()
	    })], 2), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency((record.amount * -record.tax).toFixed(2))))]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency((record.amount))))]), _c('td', [_vm._v(_vm._s(_vm.$priceWithcurrency(((record.amount) + (record.amount * -record.tax)).toFixed(2))))]), _c('td', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.voidFields.records[record.id]),
	        expression: "voidFields.records[record.id]"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": Array.isArray(_vm.voidFields.records[record.id]) ? _vm._i(_vm.voidFields.records[record.id], null) > -1 : (_vm.voidFields.records[record.id])
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.voidFields.records[record.id],
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(_vm.voidFields.records, record.id, $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(_vm.voidFields.records, record.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(_vm.voidFields.records, record.id, $$c)
	          }
	        }
	      }
	    }), _c('label', [_vm._v("Correct amount")]), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.voidFields.records[record.id]),
	        expression: "voidFields.records[record.id]"
	      }],
	      attrs: {
	        "type": "number",
	        "min": "0",
	        "disabled": _vm.voidFields.records[record.id] === false
	      },
	      domProps: {
	        "value": (_vm.voidFields.records[record.id])
	      },
	      on: {
	        "keyDown": _vm.isNumber,
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.voidFields.records, record.id, $event.target.value)
	        }, function($event) {
	          return _vm.checkValue(record)
	        }]
	      }
	    }), _c('div', {
	      staticClass: "help-text"
	    }, [_vm._v("Insert above the real amount you want to charge (VAT included). Leave it empty for a full refund."), _c('br'), _vm._v("E.g. if you want to give the customer a 60% discount on a cost of 100 €, enter 40 €")])])])
	  }), 0)])]), _c('h2', {
	    staticClass: "text-right"
	  }, [_vm._v("Invoice total " + _vm._s(_vm.$priceWithcurrency(_vm.invoice.total)))]), _c('h2', {
	    staticClass: "text-right"
	  }, [_vm._v("Amount " + _vm._s(_vm.$priceWithcurrency(_vm.recordsAmount)))])])]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "disabled": _vm.voidFields.reason === '' || _vm.recordsAmount == 0,
	      "color-class": "success",
	      "action": _vm.voidInvoice
	    },
	    slot: "footer"
	  }, [_vm._v("Create")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2487 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: _vm.componentId
	  }, [(_vm.item) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]) : _c('button', {
	    staticClass: "button small",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Add new Segment Rate")]), (_vm.loading) ? _c('loading-spinner') : [(_vm.item !== null) ? _c('h2', [_vm._v("Segment Rate SGR" + _vm._s(_vm.item.id) + "- SG" + _vm._s(_vm.item.segment.id) + " " + _vm._s(_vm.item.segment.name))]) : _c('h2', [_vm._v("Add new Segment Rate")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Reservation Rate"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reservation_rate_id),
	      expression: "body.reservation_rate_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "reservation_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.reservation_rates), function(reservation_rate) {
	    return _c('option', {
	      domProps: {
	        "value": reservation_rate.id
	      }
	    }, [_vm._v("RR" + _vm._s(reservation_rate.id) + " " + _vm._s(reservation_rate.name))])
	  }), 0)])])]), _c('div', {
	    staticClass: "row column"
	  }, [(_vm.item === null) ? [_c('label', [_vm._v("Description")])] : [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.item._translatable.description,
	      "label": "Description",
	      "value": _vm.item.description,
	      "editor": true
	    }
	  })], _c('Editor', {
	    model: {
	      value: (_vm.body.description),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "description", $$v)
	      },
	      expression: "body.description"
	    }
	  })], 2), _c('div', {
	    staticClass: "row column"
	  }, [(_vm.item === null) ? [_c('label', [_vm._v("Extended Description")])] : [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.item._translatable.extended_description,
	      "label": "Extended Description",
	      "editor": true
	    }
	  })], _c('Editor', {
	    model: {
	      value: (_vm.body.extended_description),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "extended_description", $$v)
	      },
	      expression: "body.extended_description"
	    }
	  })], 2), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])]], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2488 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-reservations"
	  }, [_c('div', {
	    staticClass: "action-bar"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "action"
	  }, [_c('reservation-list-form', {
	    attrs: {
	      "type": 'entity-filter'
	    },
	    on: {
	      "filterReservations": _vm.applyFilters
	    }
	  }), (_vm.$acl('vehicles-select-list') && _vm.$acl('index-common-cost')) ? _c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    attrs: {
	      "data-toggle": "create-reservation"
	    }
	  }) : _vm._e()], 1)]), _c('div', {
	    staticClass: "driver-reservations tabs-inner-content no-space fill-bg"
	  }, [(_vm.$acl('vehicles-select-list') && _vm.$acl('index-common-cost')) ? _c('div', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "is-hidden",
	    attrs: {
	      "id": "create-reservation",
	      "data-toggler": "is-hidden"
	    }
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Book for driver DR" + _vm._s(_vm.$route.params.id))]), _c('book-panel', {
	    attrs: {
	      "driverId": _vm.$route.params.id
	    }
	  })], 1) : _vm._e(), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Reservations")])])
	}]}

/***/ }),
/* 2489 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice"
	  }, [_c('off-canvas', {
	    attrs: {
	      "menu_pages": _vm.menu,
	      "title": _vm.title,
	      "action": _vm.action,
	      "user": _vm.user
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2490 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-reservations"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Deposits")])]), _c('base-list', {
	    ref: "loader",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "resultsPerPage": 5
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2491 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "disabled": _vm.disabled,
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Driver"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2492 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-grouped-parking-assets"
	  }, [(_vm.parkingGroups) ? _c('label', [_vm._v("Parking Group"), _c('selectize', {
	    attrs: {
	      "options": _vm.parkingGroups,
	      "optionTemplate": _vm.optionPgTemplate,
	      "renderTemplate": _vm.renderPgTemplate,
	      "maxItems": 1
	    },
	    on: {
	      "itemAdded": _vm.pgSelected,
	      "itemRemoved": _vm.clearLotAndSlot
	    }
	  })], 1) : _vm._e(), (_vm.parkingLots) ? _c('label', [_vm._v("Parking Lot"), _c('selectize', {
	    ref: "selectizeParkingLots",
	    attrs: {
	      "options": _vm.parkingLots,
	      "optionTemplate": _vm.optionPgTemplate,
	      "renderTemplate": _vm.renderPgTemplate,
	      "maxItems": 1
	    },
	    on: {
	      "itemAdded": _vm.plSelected,
	      "itemRemoved": _vm.plUnselected
	    }
	  })], 1) : _vm._e(), (_vm.parkingSlots) ? _c('label', [_vm._v("Parking Slot"), _c('selectize', {
	    ref: "selectizeParkingSlots",
	    attrs: {
	      "options": _vm.parkingSlots,
	      "optionTemplate": _vm.optionPgTemplate,
	      "renderTemplate": _vm.renderPgTemplate,
	      "maxItems": 1
	    },
	    on: {
	      "itemAdded": _vm.psSelected
	    }
	  })], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2493 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-driver"
	  }, [(_vm.$is('expanded')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('p', [_vm._v("status: " + _vm._s(_vm.item.status))]), _c('p', [_vm._v("expiry " + _vm._s(_vm.item.expiry_date))]), _c('p', [_vm._v("issuer.by " + _vm._s(_vm.item.issuer))]), _c('p', [_vm._v("issuer.date " + _vm._s(_vm.item.issue_date))]), _c('p', [_vm._v("issuer_country " + _vm._s(_vm.item.issuer_country))]), _vm._l((_vm.item.attachments), function(i, index) {
	    return _c('button', {
	      staticClass: "button secondary block-button",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openUrl(i.url)
	        }
	      }
	    }, [_vm._v(_vm._s(i.mime))])
	  })], 2) : _vm._e(), (_vm.$is('license-card')) ? _c('div', {
	    staticClass: "license-card"
	  }, [_c('span', [_vm._v("Driver License")]), _c('pre', [_vm._v(_vm._s(_vm.item))])]) : _vm._e(), (_vm.$is('license-card-accordion')) ? _c('div', {
	    staticClass: "license-card-accordion"
	  }, [_c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "accordion",
	    attrs: {
	      "data-accordion": "data-accordion",
	      "data-allow-all-closed": "true"
	    }
	  }, [_c('li', {
	    staticClass: "accordion-item",
	    attrs: {
	      "data-accordion-item": "data-accordion-item"
	    }
	  }, [_c('a', {
	    staticClass: "accordion-title",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.item.type.name))]), (_vm.item.type.has_number) ? _c('h2', [_vm._v(_vm._s(_vm.item.number))]) : _vm._e(), (_vm.item.type.has_issuer) ? _c('p', [_vm._v("ISSUED ON:"), _c('b', [_vm._v(_vm._s(_vm.item.issue_date))])]) : _vm._e(), (_vm.item.type.has_number) ? _c('p', [_vm._v("NUMBER:"), _c('b', [_vm._v(_vm._s(_vm.item.number))])]) : _vm._e()]), _c('div', {
	    staticClass: "columns"
	  }, [_c('p', [_c('strong', [_vm._v("CREATED: " + _vm._s(_vm.item.created_at))])]), (_vm.item.type.has_expiry) ? _c('p', [_c('strong', [_vm._v("EXPIRY DATE: " + _vm._s(_vm.item.expiry_date))])]) : _vm._e(), _c('p', [_c('strong', [_vm._v("STATUS: " + _vm._s(_vm.item.status))])])])])]), _c('div', {
	    staticClass: "accordion-content",
	    attrs: {
	      "data-tab-content": "data-tab-content"
	    }
	  }, [_c('dropdown', {
	    staticClass: "float-right",
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('div', {
	    staticClass: "flex-container flex-dir-column"
	  }, [(_vm.item.status !== 'VALID') ? _c('a', {
	    staticClass: "success-text",
	    on: {
	      "click": _vm.approve
	    }
	  }, [_vm._v("Approve")]) : _vm._e(), _c('div', {
	    staticClass: "warning-text",
	    on: {
	      "click": _vm.refuse
	    }
	  }, [_vm._v("Refuse")]), _c('hr', {
	    staticClass: "dropdown-separator"
	  }), _c('a', {
	    staticClass: "warning-text",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Edit")]), _c('a', {
	    on: {
	      "click": _vm.upload
	    }
	  }, [_vm._v("Upload")]), _c('a', {
	    staticClass: "alert-text",
	    on: {
	      "click": _vm.deleteD
	    }
	  }, [_vm._v("Delete")])])]), (_vm.item.type.has_issuer) ? _c('p', [_vm._v("Issued by:"), _c('b', [_vm._v(" " + _vm._s(_vm.item.issuer))])]) : _vm._e(), (_vm.item.type.has_country) ? _c('p', [_vm._v("Issuer country:"), _c('b', [_vm._v(" " + _vm._s(_vm.item.issuer_country))])]) : _vm._e(), (_vm.item.type.has_emission) ? _c('p', [_vm._v("Issued date:"), _c('b', [_vm._v(" " + _vm._s(_vm.item.issue_date))])]) : _vm._e(), (_vm.item.type.has_number) ? _c('p', [_vm._v("Number:"), _c('b', [_vm._v(" " + _vm._s(_vm.item.number))])]) : _vm._e(), (_vm.item.attachments.length) ? _c('hr') : _c('p', {
	    staticClass: "text-center alert-text no-attachments"
	  }, [_vm._v("no attachments")]), _c('backoffice-driver-license-attachment', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)])])]) : _vm._e(), (_vm.$is('license-approval-list')) ? _c('div', {
	    staticClass: "license-approval-list"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('CardN', {
	    attrs: {
	      "columns": 4,
	      "showAction": true,
	      "showBullets": true
	    }
	  }, [_c('dropdown', {
	    attrs: {
	      "slot": "actionBullets",
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    },
	    slot: "actionBullets"
	  }, [_c('div', {
	    staticClass: "flex-container flex-dir-column"
	  }, [(_vm.item.status !== 'VALID') ? _c('a', {
	    staticClass: "success-text",
	    on: {
	      "click": _vm.approve
	    }
	  }, [_vm._v("Approve")]) : _vm._e(), _c('div', {
	    staticClass: "warning-text",
	    on: {
	      "click": _vm.refuse
	    }
	  }, [_vm._v("Refuse")]), _c('hr', {
	    staticClass: "dropdown-separator"
	  }), _c('a', {
	    staticClass: "warning-text",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Edit")]), _c('a', {
	    on: {
	      "click": _vm.upload
	    }
	  }, [_vm._v("Upload")]), _c('a', {
	    staticClass: "alert-text",
	    on: {
	      "click": _vm.deleteD
	    }
	  }, [_vm._v("Delete")])])]), _c('span', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("D" + _vm._s(_vm.item.id))]), _c('driver-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item.driver,
	      "fieldName": 'driver-info'
	    },
	    slot: "n1"
	  }), _c('div', {
	    staticClass: "document-info",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.item.type.name))])]), (_vm.item.type.has_number) ? _c('span', [_vm._v("Number: " + _vm._s(_vm.item.number))]) : _vm._e(), (_vm.item.type.has_expiry) ? _c('span', [_vm._v("Expiry: " + _vm._s(_vm.item.expiry_date))]) : _vm._e(), (_vm.item.type.has_emission) ? _c('span', [_vm._v("Emission: " + _vm._s(_vm.item.issue_date))]) : _vm._e()]), _c('div', {
	    staticClass: "document-info",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [(_vm.item.type.has_issuer) ? _c('span', [_vm._v("Issuer: " + _vm._s(_vm.item.issuer)), (_vm.item.type.has_country) ? _c('span', [_vm._v(" " + _vm._s(_vm.item.issuer_country))]) : _vm._e()]) : _vm._e(), _c('span', [_vm._v("Created: " + _vm._s(_vm.item.created_at))])]), _c('div', {
	    staticClass: "attachments",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('span', {
	    staticClass: "fa",
	    class: _vm.attachmentButton,
	    on: {
	      "click": function($event) {
	        _vm.showAttachments = !_vm.showAttachments
	      }
	    }
	  })])], 1)], 1)]), (_vm.showAttachments) ? _c('div', {
	    staticClass: "attachments inner-content"
	  }, [(_vm.item.attachments.length) ? _c('hr') : _c('p', {
	    staticClass: "text-center alert-text no-attachments"
	  }, [_vm._v("no attachments")]), _c('backoffice-driver-license-attachment', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _c('div', {
	    staticClass: "row align-justify"
	  }, [_c('h3', [(_vm.item.status !== 'VALID') ? _c('a', {
	    staticClass: "success-text",
	    on: {
	      "click": _vm.approve
	    }
	  }, [_vm._v("Approve")]) : _vm._e()]), _c('h3', [_c('a', {
	    staticClass: "warning-text",
	    on: {
	      "click": _vm.refuse
	    }
	  }, [_vm._v("Refuse")])])])], 1) : _vm._e()]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2494 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-home"
	  }, [_c('div', {
	    staticClass: "hide-for-small-only"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "chart-parameters"
	  }, [_c('div', {
	    staticClass: "row filter-form"
	  }, [_c('div', {
	    staticClass: "columns small-12 medium-3"
	  }, [_c('date-range-picker', {
	    on: {
	      "input": _vm.dateRangeSelected
	    },
	    model: {
	      value: (_vm.myRange),
	      callback: function($$v) {
	        _vm.myRange = $$v
	      },
	      expression: "myRange"
	    }
	  })], 1), _c('div', {
	    staticClass: "columns small-12 medium-3"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.form.bracketing),
	      expression: "form.bracketing"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.form, "bracketing", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "M"
	    }
	  }, [_vm._v("Monthly")]), _c('option', {
	    attrs: {
	      "value": "W"
	    }
	  }, [_vm._v("Weekly")]), _c('option', {
	    attrs: {
	      "value": "D"
	    }
	  }, [_vm._v("Daily")])])]), _c('div', {
	    staticClass: "small-12 medium-3"
	  }, [_c('loading-animation', {
	    attrs: {
	      "loading": _vm.formLoading
	    }
	  })], 1)])])])]), _c('div', {
	    staticClass: "row dashboard-stats"
	  }, [(_vm.$acl('charged-reservations-charts')) ? _c('div', {
	    staticClass: "columns large-6"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_c('h2', [_vm._v("Charged reservations")]), (_vm.res) ? _c('line-chart', {
	    attrs: {
	      "data": _vm.res
	    }
	  }) : _vm._e()], 1)]) : _vm._e(), (_vm.$acl('driven-distance-charts')) ? _c('div', {
	    staticClass: "columns large-6"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_c('h2', [_vm._v("Total mileage")]), (_vm.dis) ? _c('line-chart', {
	    attrs: {
	      "data": _vm.dis
	    }
	  }) : _vm._e()], 1)]) : _vm._e()]), _c('div', {
	    staticClass: "row dashboard-stats"
	  }, [(_vm.$acl('driver-registrations-charts') && _vm.$acl('client-registrations-charts')) ? _c('div', {
	    staticClass: "columns large-6"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_c('h2', [_vm._v("Registrations")]), (_vm.reg) ? _c('bar-chart', {
	    attrs: {
	      "data": _vm.reg
	    }
	  }) : _vm._e()], 1)]) : _vm._e(), (_vm.$acl('vehicle-reservations-charts') && _vm.$acl('vehicle-distance-charts')) ? _c('div', {
	    staticClass: "columns large-6"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_c('h2', [_vm._v("Vehicle allocation")]), (_vm.vei) ? _c('bar-chart', {
	    attrs: {
	      "data": _vm.vei
	    }
	  }) : _vm._e()], 1)]) : _vm._e()]), (_vm.$acl('vehicles-by-zone-charts')) ? _c('div', {
	    staticClass: "row dashboard-stats"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_c('h2', [_vm._v("Vehicles per zone")]), (this.loadingVeiByZ) ? _c('h3', [_vm._v("loading...")]) : _vm._e(), (_vm.veiByZ) ? _c('bar-chart', {
	    attrs: {
	      "data": _vm.veiByZ
	    }
	  }) : _vm._e()], 1)])]) : _vm._e()]), _c('home-controller')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2495 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-credit-bonus-configuration"
	  }, [_c('ModalReveal', {
	    ref: "bonusModal",
	    on: {
	      "modalOpen": _vm.load
	    },
	    scopedSlots: _vm._u([{
	      key: _vm.slot,
	      fn: function(footer) {
	        return [_c('button', {
	          staticClass: "button update",
	          on: {
	            "click": _vm.update
	          }
	        }, [_vm._v("Save")])]
	      }
	    }], null, true)
	  }, [(_vm.item !== null) ? _c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]) : _c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('addBonus')
	      }
	    },
	    slot: "trigger"
	  }, [_vm._v("Add Credit bonus")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Name")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.name),
	      expression: "item.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "name", $event.target.value)
	      }
	    }
	  }), _c('label', [_vm._v("Amount")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.amount),
	      expression: "item.amount"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "amount", $event.target.value)
	      }
	    }
	  }), _c('label', [_vm._v("Promo amount")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.promo_amount),
	      expression: "item.promo_amount"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.promo_amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "promo_amount", $event.target.value)
	      }
	    }
	  }), _c('label', [_vm._v("Max days")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.max_days),
	      expression: "item.max_days"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.max_days)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "max_days", $event.target.value)
	      }
	    }
	  }), _c('label', [_vm._v("Description")]), _c('Editor', {
	    model: {
	      value: (_vm.item.description),
	      callback: function($$v) {
	        _vm.$set(_vm.item, "description", $$v)
	      },
	      expression: "item.description"
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Configuration")]), _c('ArrayEdit', {
	    attrs: {
	      "values": _vm.config,
	      "options": _vm.fields
	    }
	  }), _c('label', [_vm._v("Fallbacks")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.fallback_rules),
	      expression: "item.fallback_rules"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.fallback_rules)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "fallback_rules", $event.target.value)
	      }
	    }
	  })], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2496 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: "addCommonCost"
	  }, [_vm._t("default", [_c('i', {
	    staticClass: "fa fa-plus-circle fa-2x"
	  })], {
	    "slot": "trigger"
	  }), _c('div', {
	    staticClass: "body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Common cost"), _c('SelectizeCommonCost', {
	    on: {
	      "optionSelected": _vm.selected
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Reason"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reason),
	      expression: "body.reason"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "reason", $event.target.value)
	      }
	    }
	  })])])])]), _c('div', {
	    staticClass: "row columns",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2497 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-parking-group inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("PG " + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.name))])])])])
	},staticRenderFns: []}

/***/ }),
/* 2498 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: _vm.componentId
	  }, [_c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Action"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.action),
	      expression: "item.action"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.action)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "action", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Title"), _c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.item._translatable.title,
	      "label": "Title",
	      "value": _vm.item.title
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.title),
	      expression: "item.title"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "title", $event.target.value)
	      }
	    }
	  })])], 1)]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Slug"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.slug),
	      expression: "item.slug"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.slug)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "slug", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Button label"), _c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.item._translatable.button_labels,
	      "label": "Button Labels",
	      "value": _vm.item.button_labels
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.button_labels),
	      expression: "item.button_labels"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.button_labels)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "button_labels", $event.target.value)
	      }
	    }
	  })])], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.item._translatable.content,
	      "label": "Content",
	      "value": _vm.item.content
	    }
	  }), _c('Editor', {
	    model: {
	      value: (_vm.item.content),
	      callback: function($$v) {
	        _vm.$set(_vm.item, "content", $$v)
	      },
	      expression: "item.content"
	    }
	  })], 1)]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.update
	    },
	    slot: "footer"
	  }, [_vm._v("Update")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2499 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-vehicle-reports"
	  }, [_c('div', {
	    staticClass: "action-bar"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "action"
	  }, [_c('reporting-list-form', {
	    attrs: {
	      "type": 'entity-filter'
	    },
	    on: {
	      "filterReportings": _vm.applyFilters
	    }
	  }), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'create-reporting',
	        params: {
	          vehicleId: _vm.$route.params.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    attrs: {
	      "data-toggle": "create-card"
	    }
	  })])], 1)]), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [(_vm.damagePositions) ? _c('vehicle-damage-detail', {
	    ref: "vehicleDamage",
	    attrs: {
	      "items": _vm.damagePositions,
	      "vehicle-damage-picture": _vm.item.category.damage_picture_external
	    }
	  }) : _vm._e(), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Reports")])])
	}]}

/***/ }),
/* 2500 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-accordion-item accordion-item",
	    attrs: {
	      "data-accordion-item": ""
	    }
	  }, [_c('a', {
	    staticClass: "accordion-title",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
	    staticClass: "accordion-content",
	    attrs: {
	      "data-tab-content": ""
	    }
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2501 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-card"
	  }, [_c('table', [_vm._m(0), _c('tbody', [_vm._l((_vm.item.time_rates), function(time) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(time.rate.id))]), _c('td', [_vm._v(_vm._s(time.rate.name))]), _c('td', [_vm._v("Time")]), _c('td', [_c('span', {
	      staticClass: "badge success"
	    }, [_vm._v(_vm._s(time.count))])])])
	  }), _vm._l((_vm.item.distance_rates), function(distance) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(distance.rate.id))]), _c('td', [_vm._v(_vm._s(distance.rate.name))]), _c('td', [_vm._v("Distance")]), _c('td', [_c('span', {
	      staticClass: "badge success"
	    }, [_vm._v(_vm._s(distance.count))])])])
	  })], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Name")]), _c('th', [_vm._v("Type")]), _c('th', [_vm._v("Count")])])
	}]}

/***/ }),
/* 2502 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-translation-add"
	  }, [_c('div', {
	    staticClass: "row column card pt-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("group"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.group),
	      expression: "body.group"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.groups), function(group) {
	    return _c('option', {
	      domProps: {
	        "value": group
	      }
	    }, [_vm._v(_vm._s(group))])
	  }), 0)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("key"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.key),
	      expression: "body.key"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.key)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "key", $event.target.value)
	      }
	    }
	  })])])]), (!_vm.langs.length) ? _c('loading-spinner') : _vm._e(), _vm._m(0), _vm._l((_vm.langs), function(lang) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column small-2 large-1 medium-1"
	    }, [_c('input', {
	      attrs: {
	        "type": "text",
	        "readonly": "readOnly"
	      },
	      domProps: {
	        "value": lang
	      }
	    })]), _c('div', {
	      staticClass: "column"
	    }, [_c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.body.value[lang]),
	        expression: "body.value[lang]"
	      }],
	      attrs: {
	        "name": lang,
	        "rows": "8"
	      },
	      domProps: {
	        "value": (_vm.body.value[lang])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.body.value, lang, $event.target.value)
	        }
	      }
	    })])])
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.firstSaving ? 'Save Translation' : 'Add Another Translation'))])], 1)])], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("lang")])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("value")])])])
	}]}

/***/ }),
/* 2503 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-plan-reservation-rates"
	  }, [(Object.keys(_vm.planRates).length) ? [_c('ul', {
	    staticClass: "tabs",
	    attrs: {
	      "id": "tabs",
	      "data-deep-link": false,
	      "data-update-history": false,
	      "data-deep-link-smudge": false,
	      "data-deep-link-smudge-delay": 500,
	      "data-tabs": ""
	    }
	  }, _vm._l((_vm.bookingModes), function(tab, key, index) {
	    return _c('li', {
	      staticClass: "tabs-title",
	      class: {
	        'is-active': index === 0
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": '#' + tab,
	        "aria-selected": index === 0
	      }
	    }, [_vm._v(_vm._s(tab) + " (" + _vm._s(_vm.getTotal(tab)) + ")")])])
	  }), 0), _c('div', {
	    staticClass: "tabs-content",
	    attrs: {
	      "data-tabs-content": "tabs"
	    }
	  }, _vm._l((_vm.bookingModes), function(tab, key, index) {
	    return _c('div', {
	      staticClass: "tabs-panel is-active",
	      attrs: {
	        "id": tab
	      }
	    }, [_c('CreatePlanReservationRates', {
	      attrs: {
	        "booking-mode": tab,
	        "plan-id": _vm.$route.params.id
	      },
	      on: {
	        "added": _vm.loadModes
	      }
	    }), _vm._l((_vm.planRates.items[tab]), function(planRates, key) {
	      return (_vm.hasPlanForBm(tab)) ? [_c('plan-reservation-rate', {
	        attrs: {
	          "item": planRates,
	          "type": "listing"
	        }
	      })] : _vm._e()
	    })], 2)
	  }), 0)] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2504 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-damage"
	  }, [_c('div', {
	    staticClass: "damage-container"
	  }, [_c('img', {
	    staticClass: "car-outline",
	    attrs: {
	      "src": _vm.vehicleDamagePicture
	    },
	    on: {
	      "click": _vm.addPin
	    }
	  }), _vm._l((_vm.pins), function(pin, index) {
	    return _c('div', {
	      staticClass: "component-pin",
	      style: ({
	        top: pin.top + 'px',
	        left: pin.left + 'px'
	      }),
	      on: {
	        "click": function($event) {
	          return _vm.removePin(pin)
	        }
	      }
	    }, [(pin.id) ? _c('span', {
	      staticStyle: {
	        "margin-top": "15px"
	      }
	    }, [_vm._v(_vm._s(pin.id))]) : _vm._e()])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2505 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-packet-vehicle-category-buttons"
	  }, [_c('packet-vehicle-category-modal', {
	    attrs: {
	      "packetCategory": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('button', {
	    staticClass: "button"
	  }, [_vm._v("Edit")])])]), _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true
	    }
	  }, [_vm._v("Delete")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2506 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-plan"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.attribute.name),
	      expression: "attribute.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.attribute.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.attribute, "name", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Description")]), (_vm.$route.params.hasOwnProperty('id')) ? [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.attribute._translatable.description,
	      "label": "Description",
	      "value": _vm.attribute.description
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.attribute.description),
	      expression: "attribute.description"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.attribute.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.attribute, "description", $event.target.value)
	      }
	    }
	  })])] : [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.attribute.description),
	      expression: "attribute.description"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.attribute.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.attribute, "description", $event.target.value)
	      }
	    }
	  })]], 2)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('label', [_vm._v("Type"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.attribute.type),
	      expression: "attribute.type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.attribute, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', [_vm._v("number")]), _c('option', [_vm._v("string")])])]), _c('label', [_vm._v("Recommended  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.attribute.recommended),
	      expression: "attribute.recommended"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.attribute.recommended) ? _vm._i(_vm.attribute.recommended, null) > -1 : (_vm.attribute.recommended)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.attribute.recommended,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.attribute, "recommended", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.attribute, "recommended", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.attribute, "recommended", $$c)
	        }
	      }
	    }
	  })]), _c('label', [_vm._v("Private  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.attribute.private),
	      expression: "attribute.private"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.attribute.private) ? _vm._i(_vm.attribute.private, null) > -1 : (_vm.attribute.private)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.attribute.private,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.attribute, "private", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.attribute, "private", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.attribute, "private", $$c)
	        }
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('label', [_vm._v("Vehicle type")]), _c('SelectizeVehicleType', {
	    attrs: {
	      "selectedValue": _vm.attribute.vehicle_type_id
	    },
	    on: {
	      "optionSelected": _vm.setVehicleType
	    }
	  }), _c('label', [_vm._v("Icon")]), _c('SelectizeIcon', {
	    attrs: {
	      "value-field": "iconName"
	    },
	    model: {
	      value: (_vm.attribute.icon),
	      callback: function($$v) {
	        _vm.$set(_vm.attribute, "icon", $$v)
	      },
	      expression: "attribute.icon"
	    }
	  })], 1), _c('div', {
	    staticClass: "row columns"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.createAttribute
	    }
	  }, [_vm._v("Save")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2507 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-kepler-file-upload"
	  }, [(_vm.previewUrl) ? _c('div', {
	    staticClass: "preview"
	  }, [(_vm.canPreview) ? _c('div', {
	    staticClass: "preview-image",
	    style: (_vm.previewStyle)
	  }) : _c('div', {
	    staticClass: "download-file"
	  }, [_c('a', {
	    on: {
	      "click": _vm.openUrl
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file-pdf-o fa-3x"
	  }), _c('br'), _c('small', [_vm._v(_vm._s(_vm.previewUrl))])])]), (!_vm.previewOnly) ? _c('button', {
	    staticClass: "button alert small",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('sel', null)
	      }
	    }
	  }, [_vm._v("Remove")]) : _vm._e()]) : _vm._e(), (!_vm.previewOnly) ? _c('div', {
	    staticClass: "uploader"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    ref: "file",
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "file"
	    }
	  }), _c('div', {
	    staticClass: "input-group-button"
	  }, [_c('input', {
	    staticClass: "button",
	    attrs: {
	      "type": "submit",
	      "value": "Upload"
	    },
	    on: {
	      "click": _vm.startUpload
	    }
	  })])]), _c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        _vm.advanced = !_vm.advanced
	      }
	    }
	  }, [_vm._v("ADVANCED")])]) : _vm._e(), (_vm.advanced) ? _c('div', {
	    staticClass: "advanced-upload"
	  }, [_c('label', [_vm._v("VISIBILITY"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.visibility),
	      expression: "visibility"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.visibility = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.visibilityOptions), function(o) {
	    return _c('option', [_vm._v(_vm._s(o))])
	  }), 0)]), _c('label', [_vm._v("PREFIX"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.prefix),
	      expression: "prefix"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.prefix = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.listPublic]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "null",
	      "selected": "selected"
	    }
	  }, [_vm._v("no_prefix")]), _vm._l((_vm.prefixOptions), function(o) {
	    return _c('option', [_vm._v(_vm._s(o))])
	  })], 2)]), _c('label', [_vm._v("FILENAME"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filename),
	      expression: "filename"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "filename"
	    },
	    domProps: {
	      "value": (_vm.filename)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.filename = $event.target.value
	      }
	    }
	  })]), (_vm.listing.length) ? _c('div', {
	    staticClass: "uploaded-gallery"
	  }, _vm._l((_vm.listing), function(l) {
	    return _c('div', {
	      staticClass: "card ml-1"
	    }, [(_vm.preview(l)) ? _c('div', {
	      style: (_vm.cardStyle(l)),
	      on: {
	        "click": function($event) {
	          return _vm.imageSelected(l)
	        }
	      }
	    }) : _c('div', {
	      style: (_vm.cardStyle(l)),
	      on: {
	        "click": function($event) {
	          return _vm.imageSelected(l)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "fa fa-3x",
	      class: _vm.getMime(l)
	    })]), _c('div', {
	      staticClass: "p-1"
	    }, [_c('small', {
	      staticClass: "internal-path"
	    }, [_vm._v(_vm._s(l.internal_path))])]), _c('div', {
	      staticClass: "buttons p-1"
	    }, [_c('ActionButton', {
	      attrs: {
	        "button": false,
	        "action": _vm.deleteFile,
	        "confirm": true,
	        "value": l.internal_path
	      }
	    }, [_c('div', {
	      staticClass: "fa fa-times",
	      staticStyle: {
	        "cursor": "pointer",
	        "color": "red"
	      }
	    })])], 1)])
	  }), 0) : [_c('h2', [_vm._v("No images/files found on with selected prefix")])]], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2508 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.remove
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2509 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-packet-form"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-4"
	  }, [(_vm.localValue.hasOwnProperty('_translatable')) ? [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.localValue._translatable.name,
	      "label": "Name",
	      "value": _vm.localValue.name
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.name),
	      expression: "localValue.name"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.localValue.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "name", $event.target.value)
	      }
	    }
	  })])] : [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.name),
	      expression: "localValue.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.localValue.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "name", $event.target.value)
	      }
	    }
	  })])], _c('label', [_vm._v("Amount"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.amount),
	      expression: "localValue.amount"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.localValue.amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "amount", $event.target.value)
	      }
	    }
	  })])], 2), _c('div', {
	    staticClass: "columns large-8"
	  }, [(!_vm.localValue.hasOwnProperty('_translatable')) ? [_c('label', [_vm._v("Description")])] : [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.localValue._translatable.description,
	      "label": "Description",
	      "value": _vm.localValue.description,
	      "editor": true
	    }
	  })], _c('Editor', {
	    model: {
	      value: (_vm.localValue.description),
	      callback: function($$v) {
	        _vm.$set(_vm.localValue, "description", $$v)
	      },
	      expression: "localValue.description"
	    }
	  })], 2)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-3"
	  }, [_c('label', [_vm._v("Minutes")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.minutes),
	      expression: "localValue.minutes"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.localValue.minutes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "minutes", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "columns large-3"
	  }, [_c('label', [_vm._v("Distance")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.distance),
	      expression: "localValue.distance"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.localValue.distance)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "distance", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "columns large-3"
	  }, [_c('label', [_vm._v("Duration")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.duration),
	      expression: "localValue.duration"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.localValue.duration)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "duration", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "columns large-3"
	  }, [_c('label', [_vm._v("Max Uses")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.max_uses),
	      expression: "localValue.max_uses"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.localValue.max_uses)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "max_uses", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "columns large-3"
	  }, [_c('label', [_vm._v("Status")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.status),
	      expression: "localValue.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.localValue, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Select status")]), _c('option', {
	    attrs: {
	      "value": "AVAILABLE"
	    }
	  }, [_vm._v("AVAILABLE")]), _c('option', {
	    attrs: {
	      "value": "UNAVAILABLE"
	    }
	  }, [_vm._v("UNAVAILABLE")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2510 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-coupon-list row column"
	  }, [_c('div', {
	    staticClass: "text-right"
	  }, [_c('segment-reveal', {
	    attrs: {
	      "segment": null
	    },
	    on: {
	      "itemUpdated": _vm.loadSegments
	    }
	  })], 1), (_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.segments.length && !_vm.loading) ? [_c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.segments), function(segment, index) {
	    return _c('div', {
	      staticClass: "column small-12 large-4 category",
	      class: {
	        active: _vm.activeIndex === index
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setSearch(index)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "inner-content card text-center"
	    }, [_c('div', {
	      staticClass: "row p-1"
	    }, [(_vm.activeIndex === index) ? _c('div', {
	      staticClass: "column shrink"
	    }, [_c('dropdown', {
	      attrs: {
	        "icon": 'fa fa-ellipsis-v fa-2x action',
	        "position": 'bottom'
	      }
	    }, [_c('div', {
	      staticClass: "dropdown-buttons"
	    }, [(_vm.activeIndex === index) ? _c('segment-reveal', {
	      attrs: {
	        "segment": segment
	      }
	    }) : _vm._e(), _c('segment-attributes-reveal', {
	      attrs: {
	        "segment": segment
	      }
	    }), _c('segment-slots-reveal', {
	      attrs: {
	        "segment": segment
	      }
	    })], 1)])], 1) : _vm._e(), _c('div', {
	      staticClass: "column small-8",
	      staticStyle: {
	        "text-align": "left"
	      }
	    }, [_c('p', [_vm._v("SG" + _vm._s(segment.id) + " " + _vm._s(segment.name) + "  ")])]), _c('div', {
	      staticClass: "column shrink"
	    })]), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column"
	    }, [(segment.attributes.length) ? _c('hr') : _vm._e(), _vm._l((segment.attributes), function(attribute) {
	      return _c('span', [_vm._v(_vm._s(attribute.name) + ": " + _vm._s(attribute.value) + " ")])
	    })], 2)])])])
	  }), 0)]), (_vm.segments[_vm.activeIndex]) ? [_c('hr'), _c('h2', [_vm._v("Segment rates")]), (_vm.segments[_vm.activeIndex]) ? _c('SegmentRateReveal', {
	    key: _vm.segments[_vm.activeIndex].id,
	    attrs: {
	      "segment": _vm.segments[_vm.activeIndex]
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$refs.list.loadData(1)
	      }
	    }
	  }) : _vm._e(), (_vm.segments.length) ? _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false,
	      "search": _vm.search
	    }
	  }) : _vm._e()] : _vm._e()] : (_vm.segments.length == 0 && !_vm.loading) ? [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("No segments")])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2511 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('EditPlanReservationRates', {
	    attrs: {
	      "rate-id": _vm.item.id
	    }
	  }), _c('button', {
	    staticClass: "button alert",
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2512 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle-slot"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Vehicle slot"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2513 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component component-backoffice-document-requirement"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": "fa fa-ellipsis-v fa-2x action",
	      "position": "top"
	    }
	  }, [_c('DocumentRequirementButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('small', [_vm._v("DCR" + _vm._s(_vm.item.id))])]), _c('div', {
	    staticClass: "label",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("Document type")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("DT" + _vm._s(_vm.item.document_type.id) + " " + _vm._s(_vm.item.document_type.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Entity")])]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.entity_class.replace(/App\\Models\\/, '')) + " " + _vm._s(_vm.item.entity.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(" " + _vm._s(_vm.item.entity.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(" Group")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(" " + _vm._s(_vm.item.document_group))])])], 1)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2514 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('PageReveal', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("Delete")]), _c('a', {
	    staticClass: "button",
	    attrs: {
	      "href": _vm.appUrl,
	      "target": "_blank"
	    }
	  }, [_vm._v("Preview")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2515 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-json-conf"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.json),
	      expression: "json"
	    }],
	    staticStyle: {
	      "font-family": "Monospace"
	    },
	    attrs: {
	      "rows": "20"
	    },
	    domProps: {
	      "value": (_vm.json)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.json = $event.target.value
	      }, _vm.updateValue]
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2516 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.roi) ? _c('div', {
	    staticClass: "component-tabbed-vehicle-costs"
	  }, [_c('div', {
	    staticClass: "action-bar"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "action"
	  }, [_c('modal-reveal', {
	    ref: "modalAddCost",
	    attrs: {
	      "sizing": "small"
	    }
	  }, [_c('div', {
	    staticClass: "text-right",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle fa-2x"
	  })]), _c('h2', [_vm._v("Add cost")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6"
	  }, [_c('label', [_vm._v("Cost Type"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cost.asset_cost_record_type_id),
	      expression: "cost.asset_cost_record_type_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.cost, "asset_cost_record_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.costTypes), function(costType) {
	    return _c('option', {
	      domProps: {
	        "value": costType.id
	      }
	    }, [_vm._v(_vm._s(costType.name))])
	  }), 0)]), _c('label', [_vm._v("Amount"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cost.amount),
	      expression: "cost.amount"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.cost.amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.cost, "amount", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Date"), _c('date-picker', {
	    model: {
	      value: (_vm.cost.date),
	      callback: function($$v) {
	        _vm.$set(_vm.cost, "date", $$v)
	      },
	      expression: "cost.date"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns small-6"
	  }, [_c('label', [_vm._v("Description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cost.description),
	      expression: "cost.description"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.cost.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.cost, "description", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Vat %"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vatRate),
	      expression: "vatRate"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.vatRate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.vatRate = $event.target.value
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.cost.asset_cost_record_type_id || !_vm.cost.amount || !_vm.cost.description
	    },
	    on: {
	      "click": _vm.addCost
	    }
	  }, [_vm._v("Save")])])])])], 1)]), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-center"
	  }, [_c('Label', [_vm._v("Select range")]), _c('date-range-picker', {
	    on: {
	      "input": _vm.dateRangeSelected
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6 text-center"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('span', [_vm._v("Reservations")]), _c('h3', [_vm._v(_vm._s(_vm.currency) + _vm._s(Math.ceil(_vm.roi.reservation_amount)))])])])]), _c('div', {
	    staticClass: "columns small-6 text-center"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('span', [_vm._v("Costs")]), _c('h3', [_vm._v(_vm._s(_vm.currency) + _vm._s(Math.ceil(_vm.roi.costs_amount)))])])])])])])]), _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search,
	      "showPerPageSelect": false
	    }
	  }, [_c('header-columns', {
	    attrs: {
	      "slot": "before",
	      "columns": _vm.headers
	    },
	    slot: "before"
	  })], 1)], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Vehicle Costs")])])
	}]}

/***/ }),
/* 2517 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pm-page"
	  }, [_c('div', {
	    staticClass: "page-frame page-frame-top"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-center"
	  }, [_c('img', {
	    staticClass: "topbar-main-logo",
	    attrs: {
	      "src": _vm.logo
	    }
	  })])])]), (_vm.title) ? _c('div', {
	    staticClass: "top-bar show-for-large"
	  }, [_c('div', {
	    staticClass: "top-bar-left text-center"
	  }, [_c('span', [_vm._v(_vm._s(_vm.time))])]), _c('div', {
	    staticClass: "top-bar-right"
	  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _c('span', [_vm._v(" ")]), _c('i', {
	    staticClass: "fa fa-retweet",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.reload
	    }
	  })])]) : _vm._e(), _c('div', {
	    staticClass: "off-canvas"
	  }, [_c('div', {
	    staticClass: "off-canvas-wrapper",
	    attrs: {
	      "data-off-canvas-wrapper": ""
	    }
	  }, [(_vm.userAuthenticated) ? _c('div', {
	    directives: [{
	      name: "f-off-canvas",
	      rawName: "v-f-off-canvas"
	    }],
	    staticClass: "off-canvas-absolute position-left reveal-for-large",
	    attrs: {
	      "id": "offCanvasLeft",
	      "data-off-canvas": ""
	    }
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "vertical menu"
	  }, [_vm._l((_vm.menu_pages), function(item) {
	    return _c('router-link', {
	      class: item.name,
	      attrs: {
	        "to": {
	          name: item.name
	        },
	        "tag": "li"
	      }
	    }, [_c('a', [_vm._v(_vm._s(item.display_name))]), (item.childrens) ? _c('ul', _vm._l((item.childrens), function(child) {
	      return _c('li', [_c('router-link', {
	        attrs: {
	          "to": {
	            name: child.name
	          }
	        }
	      }, [_vm._v(_vm._s(child.display_name))])], 1)
	    }), 0) : _vm._e()])
	  }), _c('li', {
	    staticClass: "no-icon router-link-active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Profile")]), _c('ul', [_c('li', [_c('div', [_c('small', [_c('span', [_vm._v(_vm._s(_vm.userStore.username) + " (ID: " + _vm._s(_vm.userStore.id) + ")")])])]), _c('div', [_c('small', [_c('span', [_vm._v(_vm._s(_vm.userStore.email))])])])])])]), _c('li', {
	    staticClass: "no-icon router-link-active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Extra")]), _c('ul', _vm._l((_vm.extra_pages), function(page) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": page.url,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(page.name))])])
	  }), 0)])], 2)]) : _vm._e(), _c('div', {
	    staticClass: "title-bar hide-for-large"
	  }, [_c('div', {
	    staticClass: "title-bar-left row align-middle align-center"
	  }, [_c('button', {
	    staticClass: "menu-icon",
	    attrs: {
	      "type": "button",
	      "data-toggle": "offCanvasLeft"
	    }
	  }), _c('span', {
	    staticClass: "title-bar-title"
	  }, [_vm._v(_vm._s(_vm.title))]), _c('i', {
	    staticClass: "fa fa-2x fa-retweet",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": _vm.reload
	    }
	  })])]), (_vm.userAuthenticated) ? _c('div', {
	    directives: [{
	      name: "f-off-canvas",
	      rawName: "v-f-off-canvas"
	    }],
	    staticClass: "offCanvasBig off-canvas-absolute position-right",
	    attrs: {
	      "id": "offCanvasRight",
	      "data-off-canvas": ""
	    }
	  }, [_c('button', {
	    staticClass: "close-button",
	    attrs: {
	      "aria-label": "Close menu",
	      "type": "button",
	      "data-close": ""
	    },
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), (_vm.component) ? _c(_vm.component.component, _vm._b({
	    tag: "component"
	  }, 'component', _vm.component.props, false)) : _vm._e()], 1) : _vm._e(), _c('div', {
	    staticClass: "off-canvas-content",
	    attrs: {
	      "data-off-canvas-content": ""
	    }
	  }, [(_vm.component && _vm.component.position === 'top') ? _c('div', {
	    attrs: {
	      "id": "customCanvas"
	    }
	  }, [_c('button', {
	    staticClass: "close-button",
	    attrs: {
	      "aria-label": "Close menu",
	      "type": "button",
	      "data-close": ""
	    },
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c(_vm.component.component, _vm._b({
	    tag: "component"
	  }, 'component', _vm.component.props, false))], 1)])])]) : _vm._e(), (_vm.userAuthenticated) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-12 large-10"
	  }, [(!_vm.hideForAcl) ? _c('breadcrumbs') : _vm._e()], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "side-actions"
	  }, [_c('QuickSearch')], 1), _vm._l((this.$route.meta.action), function(act) {
	    return _c(act.component, {
	      tag: "div",
	      staticClass: "side-actions",
	      attrs: {
	        "type": "act",
	        "item": act
	      }
	    })
	  }), (_vm.action && !_vm.hideForAcl) ? _c(_vm.action.component, {
	    tag: "div",
	    staticClass: "side-actions",
	    attrs: {
	      "type": "action",
	      "item": _vm.action
	    }
	  }) : _vm._e()], 2)]) : _vm._e(), _c('div', {
	    staticClass: "is-hidden",
	    attrs: {
	      "id": "preloader"
	    }
	  }), _c('router-view', {
	    key: _vm.$route.fullPath
	  })], 1), _c('div', {
	    staticClass: "rw"
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "show-for-small-only",
	    staticStyle: {
	      "min-height": "50px"
	    }
	  }, [_c('button', {
	    staticClass: "close-button",
	    attrs: {
	      "aria-label": "Close menu",
	      "type": "button",
	      "data-close": ""
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	}]}

/***/ }),
/* 2518 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-smart-edit"
	  }, [_c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2519 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list reporting-types-list row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.types), function(type, index) {
	    return _c('div', {
	      key: ("RT{type.id}-" + index),
	      staticClass: "column small-12 large-6 category"
	    }, [_c('div', {
	      staticClass: "inner-content card text-center"
	    }, [_c('div', {
	      staticClass: "row text-center"
	    }, [_c('div', {
	      staticClass: "column text-left"
	    }, [_c('h2', [_vm._v(_vm._s(type.name))])]), _c('div', {
	      staticClass: "column text-right"
	    }, [_c('ModalReveal', {
	      ref: 'reveal-' + type.uid,
	      refInFor: true
	    }, [_c('i', {
	      staticClass: "fa fa-pencil",
	      attrs: {
	        "slot": "trigger"
	      },
	      slot: "trigger"
	    }), _c('EditReportingType', {
	      attrs: {
	        "reportingType": type
	      },
	      on: {
	        "reportingTypeEdited": function($event) {
	          return _vm.reportEdited(type)
	        }
	      }
	    })], 1), _c('pre', [_vm._v("RT" + _vm._s(type.id))])], 1)]), _c('div', {
	      staticClass: "row text-center"
	    }, [_c('div', {
	      staticClass: "column text-left"
	    }, [_c('p', [_vm._v(_vm._s(type.description))])])])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2520 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-add-driver-license"
	  }, [_c('label', [_vm._v("Document Type"), _c('selectize-document-type', {
	    on: {
	      "optionSelected": _vm.selectDocType
	    }
	  })], 1), (_vm.documentType) ? _c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.document
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }) : _vm._e(), (_vm.documentType) ? _c('div', {
	    staticClass: "attachments"
	  }, _vm._l((_vm.documentType.attachment_views), function(attachment, index) {
	    return _c('div', {
	      staticClass: "upload"
	    }, [_c('label', [_vm._v("Upload " + _vm._s(attachment))]), _c('dropzone', {
	      attrs: {
	        "id": '#myVueDropzone' + index,
	        "url": _vm.dropzoneUrl
	      },
	      on: {
	        "vdropzone-success": function (file, response) {
	          _vm.uploaded(file, response, attachment)
	        }
	      }
	    })], 1)
	  }), 0) : _vm._e(), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.create
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2521 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-packet-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm._uid,
	    ref: "packetModal"
	  }, [_vm._t("default", [_c('a', {
	    staticClass: "fa-stack fa-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })])], {
	    "slot": "trigger"
	  }), _c('h2', [_vm._v("Create Packet")]), _c('PacketForm', {
	    model: {
	      value: (_vm.body),
	      callback: function($$v) {
	        _vm.body = $$v
	      },
	      expression: "body"
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")])], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2522 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-simple-columns2 row"
	  }, [_c('div', {
	    staticClass: "columns n1 small-6"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns n2 small-6"
	  }, [_vm._t("n2")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2523 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-router-view-page"
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 2524 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-invoice-list-filter-form filter-form"
	  }, [_c('div', {
	    staticClass: "row medium-unstack"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "columns"
	  }, [_c('selectize-driver', {
	    on: {
	      "optionSelected": _vm.setDriverId
	    },
	    model: {
	      value: (_vm.search.driver_id),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "driver_id", $$v)
	      },
	      expression: "search.driver_id"
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.chip_id),
	      expression: "search.chip_id"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Chip id"
	    },
	    domProps: {
	      "value": (_vm.search.chip_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, "chip_id", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "columns"
	  }, [_c('a', {
	    staticClass: "fa fa-angle-double-down fa-2x",
	    on: {
	      "click": _vm.filterCards
	    }
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "fa fa-search fa-2x"
	  })])
	}]}

/***/ }),
/* 2525 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('EditParkingGroup', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _c('DeleteParkingGroup', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2526 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": this._uid
	    }
	  }, [_c('div', [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2527 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Vehicle Brand"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2528 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-array-edit"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('selectize-vehicle-attribute', {
	    staticClass: "input-group-field",
	    on: {
	      "optionSelected": _vm.setValue
	    },
	    model: {
	      value: (_vm.newName),
	      callback: function($$v) {
	        _vm.newName = $$v
	      },
	      expression: "newName"
	    }
	  }), _c('div', {
	    staticClass: "input-group-button"
	  }, [_c('button', {
	    staticClass: "button fa fa-plus",
	    attrs: {
	      "disabled": !_vm.newName
	    },
	    on: {
	      "click": _vm.addField
	    }
	  })])], 1), _vm._l((_vm.values), function(value, label) {
	    return (typeof value !== 'undefined') ? _c('div', {
	      staticClass: "prop-item"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('span', {
	      staticClass: "input-group-label"
	    }, [_vm._v(_vm._s(label))]), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.values[label].value),
	        expression: "values[label].value"
	      }],
	      staticClass: "input-group-field",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.values[label].value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.values[label], "value", $event.target.value)
	        }
	      }
	    }), _c('div', {
	      staticClass: "input-group-button"
	    }, [_c('button', {
	      staticClass: "button warning fa fa-times",
	      on: {
	        "click": function($event) {
	          return _vm.removeField(label)
	        }
	      }
	    })])])]) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 2529 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "create-plan_rate-reservation-rates"
	  }, [_c('ModalReveal', {
	    ref: "revealPlanCreate"
	  }, [_c('div', {
	    staticClass: "button button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Add for " + _vm._s(_vm.bookingMode))]), _c('h2', [_vm._v("Plan reservation rate for " + _vm._s(_vm.bookingMode))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan_rate.name),
	      expression: "plan_rate.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plan_rate.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.plan_rate, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Vehicle Category"), _c('selectize-category', {
	    on: {
	      "optionSelected": _vm.selectCategory
	    }
	  })], 1)]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Reservation rate"), _c('selectize-reservation-rate', {
	    on: {
	      "optionSelected": _vm.selectRate
	    }
	  })], 1), _c('label', [_vm._v("Disabled"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan_rate.disabled),
	      expression: "plan_rate.disabled"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.plan_rate.disabled) ? _vm._i(_vm.plan_rate.disabled, null) > -1 : (_vm.plan_rate.disabled)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.plan_rate.disabled,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.plan_rate, "disabled", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.plan_rate, "disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.plan_rate, "disabled", $$c)
	        }
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-right"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.savePlanRate
	    }
	  }, [_vm._v("Save")])], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2530 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-reservations"
	  }, [_c('div', {
	    staticClass: "action-bar"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "action"
	  }, [_c('reservation-list-form', {
	    attrs: {
	      "type": 'entity-filter'
	    },
	    on: {
	      "filterReservations": _vm.filterReservations
	    }
	  }), _c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    attrs: {
	      "data-toggle": "create-reservation"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "tabs-inner-content no-horizontal-space client-reservations fill-bg"
	  }, [_c('div', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "is-hidden",
	    attrs: {
	      "id": "create-reservation",
	      "data-toggler": "is-hidden"
	    }
	  }, [(_vm.drivers.length > 0) ? _c('book-panel', {
	    attrs: {
	      "entityDrivers": _vm.drivers
	    },
	    on: {
	      "reservationCreated": function($event) {
	        return _vm.$refs.loader.loadData(1)
	      }
	    }
	  }) : _vm._e()], 1), _c('base-list', {
	    ref: "loader",
	    attrs: {
	      "component": _vm.component,
	      "search": _vm.search,
	      "dataLoader": _vm.dataLoader
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Client Reservations")])])
	}]}

/***/ }),
/* 2531 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-reservation-hold-billing row column"
	  }, [_c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2532 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', [_c('a', {
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Document Requirements")]), _c('h2', [_vm._v("Requirement " + _vm._s(_vm.entity_type) + " " + _vm._s(_vm.entity_id))]), _c('DocumentRequirementForm', {
	    model: {
	      value: (_vm.body),
	      callback: function($$v) {
	        _vm.body = $$v
	      },
	      expression: "body"
	    }
	  }), _c('div', {
	    staticClass: "row columns text-center"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Add requirement")])], 1), _c('hr'), _c('h2', [_vm._v("Document Requirements")]), (_vm.loading) ? _c('loading-spinner') : _vm._e(), (!_vm.loading && _vm.requirements.length === 0) ? [_c('h2', [_vm._v("Vehicle category has no requirements")])] : _vm._e(), _vm._l((_vm.requirements), function(item) {
	    return (_vm.requirements.length) ? _c('document-requirement', {
	      attrs: {
	        "item": item,
	        "type": "listing"
	      },
	      on: {
	        "itemUpdated": _vm.loadRequirements
	      }
	    }) : _vm._e()
	  })], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2533 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', [_c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tocType.name),
	      expression: "tocType.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.tocType.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.tocType, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Priority"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tocType.priority),
	      expression: "tocType.priority"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.tocType.priority)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.tocType, "priority", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Group"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tocType.group),
	      expression: "tocType.group"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.tocType, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', [_vm._v("ALL")]), _c('option', [_vm._v("GENERAL")]), _c('option', [_vm._v("PLAN")])])])])]), _c('div', {
	    staticClass: "row columns text-center"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Save Toc Type")])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2534 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-credit-records"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Packets")])]), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "resultsPerPage": 5,
	      "componentType": "listing"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2535 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])])])
	},staticRenderFns: []}

/***/ }),
/* 2536 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-route"
	  }, [_c('GoogleMapContainer', [_c('GoogleMap', {
	    ref: "logs",
	    attrs: {
	      "api-key": _vm.mapsAPI,
	      "center": _vm.mapCenter,
	      "mapTypeControl": true
	    }
	  }, [(_vm.zones.allowed) ? _c('div', _vm._l((_vm.zones.allowed.poly), function(allowed) {
	    return _c('google-map-polygon', {
	      attrs: {
	        "positions": allowed,
	        "color": "green",
	        "fillColor": "green"
	      }
	    })
	  }), 1) : _vm._e(), (_vm.zones.forbidden) ? _c('div', _vm._l((_vm.zones.forbidden.poly), function(forbidden) {
	    return (_vm.zones.forbidden !== null) ? _c('google-map-polygon', {
	      attrs: {
	        "positions": forbidden
	      }
	    }) : _vm._e()
	  }), 1) : _vm._e(), (_vm.zones.undesiderable) ? _c('div', _vm._l((_vm.zones.undesiderable.poly), function(undesiderable) {
	    return (_vm.zones.undesiderable) ? _c('google-map-polygon', {
	      attrs: {
	        "positions": undesiderable,
	        "color": "yellow",
	        "fillColor": "yellow"
	      }
	    }) : _vm._e()
	  }), 1) : _vm._e(), _vm._l((_vm.currentPointStep), function(index) {
	    return (_vm.showMarkers) ? _c('GoogleMapMarker', {
	      attrs: {
	        "label": ("" + index),
	        "title": ("" + index),
	        "position": _vm.routes[index - 1],
	        "clickable": true
	      }
	    }, [_c('p', [_vm._v(_vm._s(_vm.$date(_vm.routes[index - 1].timestamp).format('DD MMM YYYY HH:mm:ss')))])]) : _vm._e()
	  }), _c('GoogleMapPolyline', {
	    attrs: {
	      "positions": _vm.showRoute
	    }
	  })], 2)], 1), _c('Slider', {
	    attrs: {
	      "max": _vm.routes.length
	    },
	    on: {
	      "input": _vm.center
	    },
	    model: {
	      value: (_vm.currentPointStep),
	      callback: function($$v) {
	        _vm.currentPointStep = $$v
	      },
	      expression: "currentPointStep"
	    }
	  }), (_vm.routes.length) ? _c('div', {
	    staticClass: "player"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$date(_vm.routes[0].timestamp).format('DD MMM YYYY HH:mm:ss')))]), _c('span', [_vm._v(_vm._s(_vm.$date(_vm.routes[_vm.currentPoint].timestamp).format('DD MMM YYYY HH:mm:ss')))]), _c('span', [_vm._v(_vm._s(_vm.$date(_vm.routes[_vm.routes.length - 1].timestamp).format('DD MMM YYYY HH:mm:ss')))])]) : _vm._e(), _c('div', {
	    staticClass: "player"
	  }, [_c('div', {
	    staticClass: "buttons fa fa-2x",
	    class: _vm.autoPlayClass,
	    on: {
	      "click": _vm.togglePlay
	    }
	  }), _c('div', {
	    staticClass: "buttons fa fa-2x fa-map-marker",
	    style: ([_vm.showMarkers ? {
	      color: 'green'
	    } : '']),
	    on: {
	      "click": function($event) {
	        _vm.showMarkers = !_vm.showMarkers
	      }
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2537 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm.componentId,
	    ref: _vm.componentId
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Cash in")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Amount vat included"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.amount),
	      expression: "body.amount"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.body.amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "amount", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Reason"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reason),
	      expression: "body.reason"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "reason", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Vat")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.tax),
	      expression: "body.tax"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "tax", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Select vat")]), _vm._l((_vm.vats), function(vat) {
	    return _c('option', {
	      domProps: {
	        "value": vat.percentage / 100
	      }
	    }, [_vm._v(_vm._s(vat.description) + " (" + _vm._s(vat.name) + " " + _vm._s(vat.percentage) + "%)")])
	  })], 2)])]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save,
	      "confirm": "confirm"
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2538 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Document Type"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2539 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-vehicle-instructions"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Vehicle Instructions")]), _c('div', {
	    staticClass: "fa fa-plus",
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": function($event) {
	        _vm.add = !_vm.add
	      }
	    },
	    slot: "action"
	  })]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.add),
	      expression: "add"
	    }],
	    staticClass: "instruction-list"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('selectize-instructions', {
	    on: {
	      "optionSelected": _vm.selectInstruction
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [(!_vm.addInProgress) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.addInstruction
	    }
	  }, [_vm._v("Add")]) : _vm._e()])]), (_vm.addInProgress) ? _c('loading-spinner') : _vm._e()], 1), _c('div', {
	    staticClass: "container"
	  }, [_c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false,
	      "component-type": "entityList"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2540 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-intervention-request-form"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [
	    [_c('label', [_vm._v("Status"), _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.localValue.status),
	        expression: "localValue.status"
	      }],
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(_vm.localValue, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, _vm._l((['NEW', 'ASSIGNED', 'IN_PROGRESS', 'COMPLETED', 'REFUSED']), function(status) {
	      return _c('option', [_vm._v(_vm._s(status))])
	    }), 0)])], (!_vm.localValue.has_linked_requests) ? _c('selectize-maintenance-driver', {
	      attrs: {
	        "value-field": "id",
	        "selectedValue": _vm.localValue.maintenance_driver_id
	      },
	      model: {
	        value: (_vm.localValue.maintenance_driver_id),
	        callback: function($$v) {
	          _vm.$set(_vm.localValue, "maintenance_driver_id", $$v)
	        },
	        expression: "localValue.maintenance_driver_id"
	      }
	    }) : _vm._e(), [_c('label', [_vm._v("Start")]), _c('date-picker', {
	      attrs: {
	        "format": "yyyy-mm-dd hh:ii:ss",
	        "pick-time": "pick-time",
	        "initial-date": _vm.localValue.start_at
	      },
	      model: {
	        value: (_vm.localValue.start_at),
	        callback: function($$v) {
	          _vm.$set(_vm.localValue, "start_at", $$v)
	        },
	        expression: "localValue.start_at"
	      }
	    }), _c('label', [_vm._v("Expiry")]), _c('date-picker', {
	      attrs: {
	        "format": "yyyy-mm-dd hh:ii:ss",
	        "pick-time": "pick-time",
	        "initial-date": _vm.localValue.expiry
	      },
	      model: {
	        value: (_vm.localValue.expiry),
	        callback: function($$v) {
	          _vm.$set(_vm.localValue, "expiry", $$v)
	        },
	        expression: "localValue.expiry"
	      }
	    })]
	  ], 2), _c('div', {
	    staticClass: "column"
	  }, [(!_vm.edit) ? [_c('label', [_vm._v("Disable for booking"), _c('input-switch', {
	    model: {
	      value: (_vm.localValue.create_reservation),
	      callback: function($$v) {
	        _vm.$set(_vm.localValue, "create_reservation", $$v)
	      },
	      expression: "localValue.create_reservation"
	    }
	  })], 1)] : _vm._e(), (_vm.localValue.hasOwnProperty('vehicle_id') && !_vm.subRequest) ? _c('selectize-vehicle', {
	    attrs: {
	      "value-field": "id",
	      "selectedValue": _vm.localValue.vehicle_id,
	      "disabled": _vm.localValue.linked_intervention_request_id !== null
	    },
	    model: {
	      value: (_vm.localValue.vehicle_id),
	      callback: function($$v) {
	        _vm.$set(_vm.localValue, "vehicle_id", $$v)
	      },
	      expression: "localValue.vehicle_id"
	    }
	  }) : _vm._e(), _c('label', [_vm._v("Priority"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.priority),
	      expression: "localValue.priority"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.localValue, "priority", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Minor")]), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Medium")]), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("Major")])]), _c('label', [_vm._v("Type"), (_vm.edit) ? [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.type),
	      expression: "localValue.type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.localValue, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "CLEANING"
	    }
	  }, [_vm._v("Cleaning")]), _c('option', {
	    attrs: {
	      "value": "ROUTINE"
	    }
	  }, [_vm._v("Routine")]), _c('option', {
	    attrs: {
	      "value": "PREPARATION"
	    }
	  }, [_vm._v("Preparation")]), _c('option', {
	    attrs: {
	      "value": "CHECK_OUT"
	    }
	  }, [_vm._v("Check-out")]), _c('option', {
	    attrs: {
	      "value": "REPOSITIONING"
	    }
	  }, [_vm._v("Repositioning")]), _c('option', {
	    attrs: {
	      "value": "ACCIDENT"
	    }
	  }, [_vm._v("Accident")]), _c('option', {
	    attrs: {
	      "value": "EXTERIOR_REPAIR"
	    }
	  }, [_vm._v("Exterior repair")]), _c('option', {
	    attrs: {
	      "value": "RECHARGE"
	    }
	  }, [_vm._v("Recharge")]), _c('option', {
	    attrs: {
	      "value": "LOW_BATTERY"
	    }
	  }, [_vm._v("Low Battery")])])] : _vm._l((['CLEANING', 'ROUTINE', 'PREPARATION', 'CHECK_OUT', 'REPOSITIONING', 'ACCIDENT', 'EXTERIOR_REPAIR', 'RECHARGE', 'LOW_BATTERY']), function(type) {
	    return [_c('label', [_vm._v(_vm._s(type) + "  "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.localValue.type),
	        expression: "localValue.type"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": type,
	        "checked": Array.isArray(_vm.localValue.type) ? _vm._i(_vm.localValue.type, type) > -1 : (_vm.localValue.type)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.localValue.type,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = type,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(_vm.localValue, "type", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(_vm.localValue, "type", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(_vm.localValue, "type", $$c)
	          }
	        }
	      }
	    })])]
	  })], 2)])], 2)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Description")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localValue.description),
	      expression: "localValue.description"
	    }],
	    attrs: {
	      "rows": "10"
	    },
	    domProps: {
	      "value": (_vm.localValue.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.localValue, "description", $event.target.value)
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2541 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-client"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Driver Licenses"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2542 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-start-end-timepicker"
	  }, [_c('select', _vm._l((_vm.hours), function(hour) {
	    return _c('option', [_vm._v(_vm._s(hour))])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2543 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2544 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-note"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": false,
	      "showAction": false,
	      "columns": 6
	    }
	  }, [_c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("TOC" + _vm._s(_vm.item.toc.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v(_vm._s(_vm.item.toc.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.signed_on))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Document date")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.document_date))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v("Type")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.item.toc.toc_type.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.item.toc.toc_type.group))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v("Version")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v(_vm._s(_vm.item.document_version))]), (_vm.hasAttachment) ? _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_vm._v("Document")]) : _vm._e(), (_vm.hasAttachment) ? _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-2x fa-file-pdf-o",
	    on: {
	      "click": function($event) {
	        return _vm.fileUrl()
	      }
	    }
	  })])]) : _vm._e()])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2545 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-card"
	  }, [_vm._m(0), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Driver Tocs")])])])
	}]}

/***/ }),
/* 2546 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.entity) ? _c('div', {
	    staticClass: "component-invoice-action-buttons"
	  }, [(_vm.item) ? _c('div', {
	    staticClass: "dropdown-actions"
	  }, [(_vm.item) ? _c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "dropdown menu",
	    attrs: {
	      "data-dropdown-menu": ""
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#Item-1"
	    }
	  }, [_vm._v("Action")]), _c('ul', {
	    staticClass: "menu"
	  }, [((_vm.entity.type === 'INVOICE' || _vm.entity.type === 'PROFORMA') && _vm.entity.status !== 'PAID') ? _c('li', [_c('invoice-reveal-pay', {
	    attrs: {
	      "invoice": _vm.entity
	    },
	    on: {
	      "payInvoice": _vm.payInvoice
	    }
	  })], 1) : _vm._e(), (_vm.entity.type === 'INVOICE' && _vm.entity.status !== 'PAID') ? _c('li', [_c('invoice-reveal-mark-as-paid', {
	    attrs: {
	      "invoice": _vm.entity
	    },
	    on: {
	      "setPaid": _vm.setPaid
	    }
	  })], 1) : _vm._e(), (_vm.entity.type === 'INVOICE' && _vm.entity.status !== 'CANCELED') ? _c('li', [_c('invoice-reveal-void', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  })], 1) : _vm._e(), (_vm.$isModuleEnabled('italian-e-invoice')) ? _c('li', [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.downloadXML
	    }
	  }, [_vm._v("Scarica fattura XML")])]) : _vm._e(), (_vm.$isModuleEnabled('zucchetti')) ? _c('li', [_c('DownloadAsEvilVersion', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  })], 1) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? _c('li', [_c('UpdateEinvoiceFileName', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  })], 1) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? _c('li', [_c('SendToExternal', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  })], 1) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice')) ? _c('li', [_c('EinvoiceGetStatus', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  })], 1) : _vm._e(), _c('li', [_c('invoice-transactions', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  })], 1), (_vm.entity.type === 'PROFORMA') ? _c('li', [_c('ConvertProformaToCreditNote', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  })], 1) : _vm._e(), _c('li', [_c('ActionButton', {
	    attrs: {
	      "confirm": true,
	      "action": _vm.markAsAwaitingPayment
	    }
	  }, [_vm._v("Mark as awaiting payment")])], 1)])])]) : _vm._e(), _c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        return _vm.openUrl(_vm.entity.url)
	      }
	    }
	  }, [_vm._m(0)]), _c('is-module-enabled', {
	    attrs: {
	      "module": "italian-e-invoice"
	    }
	  }, [_c('button', {
	    staticClass: "button small",
	    on: {
	      "click": _vm.downloadXML
	    }
	  }, [_c('span', [_c('i', {
	    staticClass: "fa fa-code"
	  }), _vm._v("  Download XML")])]), (_vm.xmlUrl) ? _c('a', {
	    attrs: {
	      "href": _vm.xmlUrl
	    }
	  }) : _vm._e()])], 1) : _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [((_vm.invoice.type === 'INVOICE' || _vm.entity.type === 'PROFORMA') && _vm.invoice.status !== 'PAID' && _vm.invoice.status !== 'CANCELED') ? _c('invoice-reveal-pay', {
	    attrs: {
	      "invoice": _vm.entity
	    },
	    on: {
	      "payInvoice": _vm.payInvoice
	    }
	  }) : _vm._e(), (_vm.invoice.type === 'INVOICE' && _vm.invoice.status !== 'PAID' && _vm.invoice.status !== 'CANCELED') ? _c('invoice-reveal-mark-as-paid', {
	    attrs: {
	      "invoice": _vm.entity
	    },
	    on: {
	      "setPaid": _vm.setPaid
	    }
	  }) : _vm._e(), (_vm.invoice.type === 'INVOICE' && _vm.invoice.status !== 'CANCELED') ? _c('invoice-reveal-void', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  }) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice') && (_vm.invoice.type === 'INVOICE' || _vm.entity.type === 'CREDIT NOTE')) ? _c('EinvoiceGetStatus', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  }) : _vm._e(), (_vm.$isModuleEnabled('aruba-italian-e-invoice') && (_vm.invoice.type === 'INVOICE' || _vm.entity.type === 'CREDIT NOTE')) ? _c('SendToExternal', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  }) : _vm._e(), _c('ActionButton', {
	    attrs: {
	      "confirm": true,
	      "action": _vm.markAsAwaitingPayment
	    }
	  }, [_vm._v("Mark as awaiting payment")]), _c('invoice-transactions', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  }), _c('is-module-enabled', {
	    attrs: {
	      "module": "zucchetti"
	    }
	  }, [_c('DownloadAsEvilVersion', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  })], 1), _c('invoice-records', {
	    attrs: {
	      "invoice": _vm.entity
	    }
	  })], 1)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('i', {
	    staticClass: "fa fa-file-pdf-o"
	  }), _vm._v("  Download")])
	}]}

/***/ }),
/* 2547 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-create-vehicle-slot"
	  }, [_c('modal-reveal', {
	    ref: "createVehicleSlotModal",
	    attrs: {
	      "sizing": "small"
	    }
	  }, [_c('button', {
	    staticClass: "button small",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Archive Slot")]), _c('h2', [_vm._v("Archive")]), _c('p', [_vm._v("Select where to move all past reservations of vehicle slots associated to this parking slot")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('selectize-grouped-parking-assets', {
	    on: {
	      "parkingSlotSelected": _vm.setParkingSlot
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": _vm.parkingSlot === null
	    },
	    on: {
	      "click": _vm.archive
	    }
	  }, [_vm._v("Archive")])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2548 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-alarms row column"
	  }, [_c('alarm-list-form', {
	    on: {
	      "filterAlarms": _vm.setSearch
	    }
	  }), _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2549 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-translation row column"
	  }, [_c('GroupedTranslation', {
	    attrs: {
	      "translations": _vm.overriddenTranslations
	    }
	  }, [_c('h3', [_vm._v("Overriden translations")])]), _c('GroupedTranslation', {
	    attrs: {
	      "translations": _vm.overridableTranslations
	    }
	  }, [_c('h3', [_vm._v("Overridable translations")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2550 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-google-map-search-box"
	  }, [_c('input', {
	    staticClass: "input controls",
	    attrs: {
	      "id": this._uid + '-search-input',
	      "type": "text",
	      "placeholder": "Search..."
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2551 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-slider"
	  }, [_c('input', {
	    attrs: {
	      "type": "range",
	      "min": _vm.min,
	      "max": _vm.max,
	      "step": _vm.step
	    },
	    domProps: {
	      "value": _vm.value
	    },
	    on: {
	      "change": _vm.updateStep
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2552 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loading-spinner",
	    style: ({
	      'height': _vm.height
	    })
	  }, [_c('div', {
	    staticClass: "rect1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "rect2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "rect3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "rect4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "rect5"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2553 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-parking-lot-controller"
	  }, [(_vm.parkingGroup) ? _c('div', {
	    staticClass: "component-statistics-card statistics-card-4"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6 large-4"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_c('span', [_vm._v("Parking Lot")]), _c('h3', [_vm._v("PL-" + _vm._s(_vm.item.id) + " " + _vm._s(_vm.item.name))])])]), _c('div', {
	    staticClass: "columns small-6 large-4"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_c('span', [_vm._v("Parking Group")]), _c('h3', [_vm._v("PG-" + _vm._s(_vm.parkingGroup.id) + " " + _vm._s(_vm.parkingGroup.name))])])]), _c('div', {
	    staticClass: "columns small-6 large-4"
	  }, [_c('div', {
	    staticClass: "inner-content card"
	  }, [_c('span', [_vm._v("Total Slots")]), _c('h3', [_vm._v(_vm._s(_vm.item.parking_slots.length))])])])])]) : _c('loading-spinner'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('router-tab-headers', {
	    attrs: {
	      "id": "vehicle-details",
	      "tabs": _vm.tabs
	    }
	  }, [_c('router-view')], 1)], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2554 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-smart-edit"
	  }, [_c('selectize-driver', {
	    on: {
	      "optionSelected": _vm.driverSelected
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2555 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('invoice-number')) ? _c('div', {
	    staticClass: "field-invoice-number"
	  }, [_c('p', [_vm._v("INV" + _vm._s(_vm.item.internal_id) + "(" + _vm._s(_vm.item.number) + ")")])]) : (_vm.$is('invoice-emission-date')) ? _c('div', {
	    staticClass: "field-emission-date"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Emission date:")]), (_vm.item.emission_date) ? _c('p', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.emission_date, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e()]) : (_vm.$is('invoice-due-date')) ? _c('div', {
	    staticClass: "field-due-date"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Due date:")]), (_vm.item.due_date) ? _c('p', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.due_date, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e()]) : (_vm.$is('invoice-client-info')) ? _c('div', {
	    staticClass: "field-client-info"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Client name:")]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.billing_info.client_id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.item.billing_info.organization_name))])], 1) : (_vm.$is('invoice-tax')) ? _c('div', {
	    staticClass: "field-tax"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_c('span', [_vm._v("NET: " + _vm._s(_vm.currency) + " " + _vm._s(_vm.item.subtotal))]), _c('br'), _c('span', [_vm._v("TAX: " + _vm._s(_vm.currency) + " " + _vm._s(_vm.item.tax))])])]) : (_vm.$is('invoice-total')) ? _c('div', {
	    staticClass: "field-total"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("TOTAL:"), _c('br'), _c('span', [_vm._v(_vm._s(_vm.currency) + " " + _vm._s(_vm.item.document_total))])])]) : (_vm.$is('invoice-paid-on')) ? _c('div', {
	    staticClass: "field-paid-on"
	  }, [(_vm.item.payed_on) ? _c('p', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.payed_on, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e()]) : (_vm.$is('invoice-status')) ? _c('div', {
	    staticClass: "field-status"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("Status:")]), _c('p', [_vm._v(_vm._s(_vm.item.status))])]) : (_vm.$is('invoice-transaction')) ? _c('div', {
	    staticClass: "field-transaction"
	  }, _vm._l((_vm.item.transactions), function(transaction) {
	    return (transaction.status === 'SUCCESS') ? _c('transaction', {
	      attrs: {
	        "item": transaction,
	        "type": 'oneLook'
	      }
	    }) : _vm._e()
	  }), 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2556 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-controller"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'driver-card',
	      "item": _vm.item.main_driver
	    }
	  })], 1), _c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column m-1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [(_vm.checkLoader) ? _c('loading-spinner') : _vm._e(), (_vm.checkedData && _vm.showCheck) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "row columnizer",
	    domProps: {
	      "innerHTML": _vm._s(_vm.showObject(null, _vm.checkedData))
	    }
	  })]) : _vm._e(), (!_vm.showCheck) ? _c('div', {
	    staticClass: "button small m-1 float-left",
	    on: {
	      "click": function($event) {
	        return _vm.loadCheckedData('quick')
	      }
	    }
	  }, [_vm._v("Quick Check")]) : _vm._e(), (!_vm.showCheck) ? _c('div', {
	    staticClass: "button small m-1 float-right",
	    on: {
	      "click": function($event) {
	        return _vm.loadCheckedData('complete')
	      }
	    }
	  }, [_vm._v("Complete Check")]) : _c('div', {
	    staticClass: "button small m-1 float-right",
	    on: {
	      "click": _vm.showHideCheckButton
	    }
	  }, [_vm._v("Hide Data")])], 1)])])])]), _c('div', {
	    staticClass: "container"
	  }, [(_vm.$acl('balance-billing')) ? _c('div', {
	    staticClass: "balance"
	  }, [(_vm.balanceLoader) ? _c('loading-spinner') : _c('Cards', {
	    attrs: {
	      "data": _vm.clientMetrics
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6"
	  }, [_c('client', {
	    attrs: {
	      "type": 'highlightedNotes',
	      "item": _vm.item
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('router-tab-headers', {
	    attrs: {
	      "id": "client-details",
	      "tabs": _vm.tabs,
	      "id": 'client-detail',
	      "activeIndex": 0,
	      "deepLink": true
	    }
	  }, [_c('router-view')], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2557 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loading-animation"
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "spinner"
	  }, [_c('div', {
	    staticClass: "double-bounce1"
	  }), _c('div', {
	    staticClass: "double-bounce2"
	  })]) : _c('div', {
	    staticClass: "slot"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2558 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-registration"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": _vm.body.name.toUpperCase()
	    },
	    on: {
	      "input": function($event) {
	        _vm.body.name = $event.target.value.toUpperCase()
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.description),
	      expression: "body.description"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "description", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-right"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.formSubmit
	    }
	  }, [_vm._v("Create")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2559 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-action-bar"
	  }, [_c('div', {
	    staticClass: "action-bar",
	    class: {
	      inverted: _vm.inverted
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._t("title")], 2), _c('div', {
	    staticClass: "action"
	  }, [_vm._t("action")], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 2560 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('EditDocumentRequirementButtonModal', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2561 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-client-approval row column"
	  }, [_c('AccontStatusFilter', {
	    attrs: {
	      "statuses": ['document_status', 'payment_method', 'subscription']
	    },
	    model: {
	      value: (_vm.search),
	      callback: function($$v) {
	        _vm.search = $$v
	      },
	      expression: "search"
	    }
	  }), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search,
	      "componentType": "client-approval-card"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2562 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "card p-2"
	  }, [_c('label', [_vm._v("Recipient info")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recipient_info),
	      expression: "recipient_info"
	    }],
	    attrs: {
	      "rows": "5"
	    },
	    domProps: {
	      "value": (_vm.recipient_info)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.recipient_info = $event.target.value
	      }
	    }
	  })]), _vm._l((_vm.headers), function(header) {
	    return [_c('div', {
	      staticClass: "card p-2"
	    }, [_c('label', [_vm._v(_vm._s(header))]), _c('button', {
	      staticClass: "button",
	      on: {
	        "click": function($event) {
	          return _vm.addField(header)
	        }
	      }
	    }, [_vm._v("Add new info")]), _vm._l((_vm.body[header]), function(info, index) {
	      return [_c('div', {
	        staticClass: "row"
	      }, [_c('div', {
	        staticClass: "column"
	      }, [_c('label', [_vm._v("Title"), _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (info.title),
	          expression: "info.title"
	        }],
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": (info.title)
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(info, "title", $event.target.value)
	          }
	        }
	      })])]), _c('div', {
	        staticClass: "column"
	      }, [_c('label', [_vm._v("Value")]), _c('div', {
	        staticClass: "input-group"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (info.value),
	          expression: "info.value"
	        }],
	        staticClass: "input-group-field",
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": (info.value)
	        },
	        on: {
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            _vm.$set(info, "value", $event.target.value)
	          }
	        }
	      }), _c('div', {
	        staticClass: "input-group-button"
	      }, [_c('button', {
	        staticClass: "button fa fa-times",
	        on: {
	          "click": function () {
	            _vm.body[header].splice(index, 1)
	          }
	        }
	      })])])])])]
	    })], 2)]
	  })], 2), _c('div', {
	    staticClass: "column card p-2"
	  }, [_c('label', [_vm._v("Description")]), _c('Editor', {
	    model: {
	      value: (_vm.body.text),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "text", $$v)
	      },
	      expression: "body.text"
	    }
	  }), _c('label', [_vm._v("prev_next_reservations"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.prev_next_reservations),
	      expression: "body.prev_next_reservations"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "0"
	    },
	    domProps: {
	      "value": (_vm.body.prev_next_reservations)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "prev_next_reservations", $event.target.value)
	      }
	    }
	  })]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.save,
	      "disabled": _vm.recipient_info === '' || _vm.body.text === ''
	    }
	  }, [_vm._v("Generate pdf")])], 1)]), _c('div', {
	    staticClass: "row column"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2563 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-smart-edit"
	  }, [_c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2564 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "toggleable-button"
	  }, [_c('button', {
	    class: _vm.buttonClass,
	    attrs: {
	      "disabled": _vm.disabled,
	      "value": _vm.value
	    },
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2565 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-attribute-list row column"
	  }, [_c('base-list', {
	    ref: "baseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.loadZones,
	      "showPerPageSelect": false
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2566 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-credit-record-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('PacketRecordUsageReveal', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2567 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal"
	  }, [_c('div', {
	    staticClass: "trigger",
	    on: {
	      "click": _vm.openModal
	    }
	  }, [_vm._t("trigger")], 2), _c('div', {
	    ref: _vm.id,
	    staticClass: "modal-component",
	    attrs: {
	      "id": _vm.id
	    }
	  }, [(_vm.showModal || _vm.value) ? _c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-container"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "text-right close"
	  }, [_c('i', {
	    staticClass: "fa fa-times",
	    on: {
	      "click": function($event) {
	        return _vm.close(_vm.id)
	      }
	    }
	  })]), _vm._t("header")], 2), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("default")], 2), _c('div', {
	    staticClass: "modal-footer"
	  }, [_vm._t("footer")], 2)])])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2568 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-transaction-list-filter-form filter-form"
	  }, [(_vm.$is('entity-filter')) ? _c('div', {
	    staticClass: "entity-filters"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    staticClass: "medium-5",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.filterTransactions]
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All statuses")]), _c('option', {
	    attrs: {
	      "value": "SUCCESS"
	    }
	  }, [_vm._v("Success")]), _c('option', {
	    attrs: {
	      "value": "FAILED"
	    }
	  }, [_vm._v("Failed")]), _c('option', {
	    attrs: {
	      "value": "NEW"
	    }
	  }, [_vm._v("New")]), _c('option', {
	    attrs: {
	      "value": "HARD FAILED"
	    }
	  }, [_vm._v("Hard failed")]), _c('option', {
	    attrs: {
	      "value": "SOFT FAILED"
	    }
	  }, [_vm._v("Soft Failed")])])]) : _c('div', {
	    staticClass: "row medium-unstack"
	  }, [_c('div', {
	    staticClass: "columns large-3"
	  }, [_c('selectize-client', {
	    on: {
	      "optionSelected": _vm.selectClient
	    }
	  })], 1), _c('div', {
	    staticClass: "columns large-3"
	  }, [_c('date-range-picker', {
	    on: {
	      "input": _vm.dateRangeSelected
	    }
	  })], 1), _c('div', {
	    staticClass: "columns large-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": "selected"
	    }
	  }, [_vm._v("All statuses")]), _c('option', {
	    attrs: {
	      "value": "SUCCESS"
	    }
	  }, [_vm._v("Success")]), _c('option', {
	    attrs: {
	      "value": "FAILED"
	    }
	  }, [_vm._v("Failed")]), _c('option', {
	    attrs: {
	      "value": "NEW"
	    }
	  }, [_vm._v("New")]), _c('option', {
	    attrs: {
	      "value": "HARD FAILED"
	    }
	  }, [_vm._v("Hard failed")]), _c('option', {
	    attrs: {
	      "value": "SOFT FAILED"
	    }
	  }, [_vm._v("Soft Failed")])])]), _c('div', {
	    staticClass: "columns large-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.type),
	      expression: "search.type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": "selected"
	    }
	  }, [_vm._v("All types")]), _c('option', {
	    attrs: {
	      "value": "INBOUND"
	    }
	  }, [_vm._v("Inbound")]), _c('option', {
	    attrs: {
	      "value": "OUTBOUND"
	    }
	  }, [_vm._v("Outbound")])])]), _c('div', {
	    staticClass: "columns large-1"
	  }, [_c('a', {
	    staticClass: "fa fa-angle-double-down fa-2x",
	    on: {
	      "click": _vm.filterTransactions
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2569 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-packet-vehicle-category-modal"
	  }, [_c('ModalReveal', {
	    key: _vm.key,
	    ref: "packetCategoryModal",
	    on: {
	      "input": _vm.closeInput
	    }
	  }, [_vm._t("default", [_c('a', {
	    staticClass: "fa-stack fa-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })])], {
	    "slot": "trigger"
	  }), _c('div', {
	    staticClass: "body"
	  }, [_c('h2', [_vm._v("Assign packet to category")]), (_vm.packetCategory) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-4"
	  }, [_c('label', [_vm._v("Packet Vehicle Category id:")]), _c('input', {
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": _vm.packetCategory.id
	    }
	  })]), _c('div', {
	    staticClass: "columns large-4"
	  }, [_c('label', [_vm._v("Packet id:")]), _c('input', {
	    attrs: {
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": _vm.selectedPacket
	    }
	  })])]) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [(!_vm.packetCategory) ? _c('div', {
	    staticClass: "columns large-4"
	  }, [_c('SelectizePacket', {
	    on: {
	      "optionSelected": _vm.selectPacket
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "columns large-4"
	  }, [_c('SelectizeCategory', {
	    attrs: {
	      "selectedValue": _vm.selectedCategory
	    },
	    on: {
	      "optionSelected": _vm.selectCategory
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row columns",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2570 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-fuel-type"
	  }, [_c('selectize', {
	    attrs: {
	      "options": _vm.fuelTypes,
	      "maxItems": 1
	    },
	    on: {
	      "itemAdded": _vm.selected
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2571 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-coupon"
	  }, [_vm._m(0), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Driver coupons")])])
	}]}

/***/ }),
/* 2572 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle-slot"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Vehicle slot"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2573 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "disabled": _vm.disabled,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Instructions"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2574 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-vehicle-cost"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 4
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('vehicle-cost-buttons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("VC" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v(_vm._s(_vm.item.type.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.description))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Amount: " + _vm._s(_vm.currency) + _vm._s(_vm.item.amount))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Tax: " + _vm._s(_vm.currency) + _vm._s(_vm.item.tax))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.item.date))])])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2575 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-common cost type"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('common-cost-type-button', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("CCT" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Description")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.description))])])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2576 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-client-transactions"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Payment Methods")]), _c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    attrs: {
	      "slot": "action",
	      "data-toggle": "create-payment"
	    },
	    slot: "action"
	  })]), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('div', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "is-hidden",
	    attrs: {
	      "id": "create-payment",
	      "data-toggler": "is-hidden"
	    }
	  }, [_c('p', [_vm._v("Select offline payment provider")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.payment_provider),
	      expression: "payment_provider"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.payment_provider = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("offline")]), _c('option', [_vm._v("test-pass")]), _c('option', [_vm._v("test-fail")])]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.handleCreatePayment
	    }
	  }, [_vm._v("Create")])], 1), _c('base-list', {
	    ref: "loader",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2577 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-week-planner"
	  }, [_c('div', {
	    staticClass: "days-selector"
	  }, [_c('p', {
	    staticClass: "mx-1"
	  }, [_vm._v("shifts number")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.shiftCount),
	      expression: "shiftCount"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.shiftCount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.shiftCounts), function(value, key) {
	    return _c('option', {
	      domProps: {
	        "value": value
	      }
	    }, [_vm._v(_vm._s(key))])
	  }), 0), _c('p', {
	    staticClass: "mx-1"
	  }, [_vm._v("days to show")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.daysToShow),
	      expression: "daysToShow"
	    }],
	    attrs: {
	      "type": "number",
	      "max": "21"
	    },
	    domProps: {
	      "value": (_vm.daysToShow)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.daysToShow = $event.target.value
	      }
	    }
	  }), _c('p', {
	    staticClass: "mx-1"
	  }, [_vm._v("hour offset")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hourOffset),
	      expression: "hourOffset"
	    }],
	    attrs: {
	      "type": "number",
	      "max": "12"
	    },
	    domProps: {
	      "value": (_vm.hourOffset)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hourOffset = $event.target.value
	      }
	    }
	  })]), _c('EasyWeeksWrapper', {
	    attrs: {
	      "daysToShow": Number(_vm.daysToShow),
	      "autoShift": _vm.shiftCount,
	      "hourOffset": _vm.hourOffset
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2578 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-translation"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('TranslationButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("TR" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.id))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("group")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.group))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("key")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.key))])]), _c('div', {
	    staticClass: "column cutMessage"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("value")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(" " + _vm._s(_vm.item.value))])]), _c('div', {
	    staticClass: "column shrink align-self-middle"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'translation',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 2579 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component component-backoffice-driver-notification"
	  }, [_c('ModalReveal', {
	    staticClass: "p-0 m-0"
	  }, [_c('a', {
	    staticClass: "pr-2 fa fa-send-o",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }), _c('label', [_vm._v("Send Notification"), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.pushNotification($event)
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.subject),
	      expression: "body.subject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "subject"
	    },
	    domProps: {
	      "value": (_vm.body.subject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "subject", $event.target.value)
	      }
	    }
	  }), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.content),
	      expression: "body.content"
	    }],
	    attrs: {
	      "rows": "6",
	      "placeholder": "content"
	    },
	    domProps: {
	      "value": (_vm.body.content)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "content", $event.target.value)
	      }
	    }
	  }), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.url),
	      expression: "body.url"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "https url"
	    },
	    domProps: {
	      "value": (_vm.body.url)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "url", $event.target.value)
	      }
	    }
	  })]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.pushNotification
	    }
	  }, [_vm._v("Send")])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2580 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "components-backoffice-parkinglots-overview"
	  }, [_vm._m(0), (_vm.item) ? _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_vm._l((_vm.item.layout), function(svg, id) {
	    return (_vm.item.layout) ? _c('div', {
	      staticClass: "row"
	    }, [_c('strong', {
	      staticClass: "text-center"
	    }, [_vm._v("ID: " + _vm._s(id))]), _c('svg', {
	      attrs: {
	        "viewBox": svg.viewBox,
	        "preserveAspectRatio": "xMidYMid meet",
	        "xmlns": "http://www.w3.org/2000/svg"
	      }
	    }, [_c('g', _vm._l((svg.paths), function(d, id) {
	      return _c('path', {
	        class: _vm.getClass(id),
	        attrs: {
	          "d": d.d,
	          "transform": d.t
	        },
	        on: {
	          "mouseover": function($event) {
	            return _vm.tooltip(id)
	          },
	          "click": function($event) {
	            return _vm.clicked(id)
	          }
	        }
	      })
	    }), 0)]), _c('p', {
	      staticClass: "center"
	    }, [_vm._v(_vm._s(_vm.tooltipText))])]) : _vm._e()
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-5"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.item.picture_external
	    }
	  })]), _c('div', {
	    staticClass: "column small-7"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('h3', [_vm._v("Description")]), _c('div', {
	    staticClass: "description",
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.description)
	    }
	  }), _c('h3', [_vm._v("Allowed Zone")]), (_vm.item.allowed_zone) ? _c('p', [_vm._v(_vm._s(_vm.item.allowed_zone.name))]) : _c('p', [_vm._v("--")]), _c('h3', [_vm._v("Undesiderable Zone")]), (_vm.item.undesiderable_zone) ? _c('p', [_vm._v(_vm._s(_vm.item.undesiderable_zone.name))]) : _c('p', [_vm._v("--")]), _c('h3', [_vm._v("Forbidden Zone")]), (_vm.item.forbidden_zone) ? _c('p', [_vm._v(_vm._s(_vm.item.forbidden_zone.name))]) : _c('p', [_vm._v("--")])])])])], 2) : _c('loading-spinner')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('h2', [_vm._v("Parking Lot Overview")])])
	}]}

/***/ }),
/* 2581 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "call-button"
	  }, [_c('ModalReveal', {
	    staticClass: "p-0 m-0"
	  }, [_vm._t("default", [_c('div', {
	    staticClass: "pr-2 fa fa-phone fa-lg",
	    staticStyle: {
	      "color": "blue",
	      "cursor": "pointer"
	    }
	  })], {
	    "slot": "trigger"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Number to call:"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.payload.external),
	      expression: "payload.external"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.payload.external)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.payload, "external", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Intern to use:"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.payload.internal),
	      expression: "payload.internal"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.payload.internal)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.payload, "internal", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('button', {
	    staticClass: "button action-button",
	    class: {
	      disabled: _vm.loading
	    },
	    on: {
	      "click": _vm.requestCall
	    }
	  }, [_vm._v("Request call")])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [(_vm.loading) ? _c('span', {
	    staticClass: "fa fa-spinner fa-spin"
	  }) : _vm._e()])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('p', [_vm._v(_vm._s(_vm.result))])])])], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2582 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-zucchetti"
	  }, [_c('ModalReveal', {
	    on: {
	      "modalOpen": _vm.checkClient
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('button', {
	    staticClass: "button"
	  }, [_vm._v("Visualizza tracciato")])]), _c('div', [_c('label', [_vm._v("Enable debug")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query.debug),
	      expression: "query.debug"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.query.debug) ? _vm._i(_vm.query.debug, null) > -1 : (_vm.query.debug)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.query.debug,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.query, "debug", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.query, "debug", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.query, "debug", $$c)
	        }
	      }
	    }
	  })]), _c('div', [_c('label', [_vm._v("Pn serial"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.query.pn_serial),
	      expression: "query.pn_serial"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.query.pn_serial)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.query, "pn_serial", $event.target.value)
	      }
	    }
	  })])]), (_vm.data) ? _c('textarea', {
	    domProps: {
	      "value": _vm.data
	    }
	  }) : _vm._e(), _c('ActionButton', {
	    attrs: {
	      "action": _vm.download
	    }
	  }, [_vm._v("Load")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2583 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-driver-pending-delete row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "componentType": "pendingDelete"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2584 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "disabled": _vm.disabled,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Vehicle Type"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2585 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-search-vehicle-availability"
	  }, [_c('h2', [_vm._v("Availability")]), (_vm.availability.length) ? _c('backoffice-vehicle-availability', {
	    attrs: {
	      "availability": _vm.availability,
	      "selectable": _vm.selectable
	    },
	    on: {
	      "update:availability": function($event) {
	        _vm.availability = $event
	      },
	      "slotsSelected": _vm.slotSelected,
	      "loadExtra": _vm.showExtraDay
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2586 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('div', {
	    staticClass: "row column card p-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Vehicles"), _c('SelectizeVehicle', {
	    ref: "select",
	    attrs: {
	      "maxItems": null
	    },
	    on: {
	      "optionSelected": _vm.add,
	      "optionRemoved": _vm.remove
	    }
	  })], 1), _c('base-list', {
	    ref: "list",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "componentType": "federationList",
	      "selectableList": true,
	      "resultsPerPage": 5
	    },
	    model: {
	      value: (_vm.selected.delete),
	      callback: function($$v) {
	        _vm.$set(_vm.selected, "delete", $$v)
	      },
	      expression: "selected.delete"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2587 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Cards"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2588 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-edit-reporting-type"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.description),
	      expression: "body.description"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "description", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "switch small"
	  }, [_c('label', [_vm._v("Position required")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.position_required),
	      expression: "body.position_required"
	    }],
	    staticClass: "switch-input",
	    attrs: {
	      "id": "position-required",
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.body.position_required) ? _vm._i(_vm.body.position_required, null) > -1 : (_vm.body.position_required)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.body.position_required,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.body, "position_required", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.body, "position_required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.body, "position_required", $$c)
	        }
	      }
	    }
	  }), _vm._m(0)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "switch small"
	  }, [_c('label', [_vm._v("Attachment required")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.attachment_required),
	      expression: "body.attachment_required"
	    }],
	    staticClass: "switch-input",
	    attrs: {
	      "id": "attachment_required",
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.body.attachment_required) ? _vm._i(_vm.body.attachment_required, null) > -1 : (_vm.body.attachment_required)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.body.attachment_required,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.body, "attachment_required", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.body, "attachment_required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.body, "attachment_required", $$c)
	        }
	      }
	    }
	  }), _vm._m(1)])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns actions"
	  }, [_c('button', {
	    staticClass: "button small",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Save")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "switch-paddle",
	    attrs: {
	      "for": "position-required"
	    }
	  }, [_c('span', {
	    staticClass: "show-for-sr"
	  }, [_vm._v("Position required")]), _c('span', {
	    staticClass: "switch-active",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("Yes")]), _c('span', {
	    staticClass: "switch-inactive",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "switch-paddle",
	    attrs: {
	      "for": "attachment_required"
	    }
	  }, [_c('span', {
	    staticClass: "show-for-sr"
	  }, [_vm._v("Attachment required")]), _c('span', {
	    staticClass: "switch-active",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("Yes")]), _c('span', {
	    staticClass: "switch-inactive",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("No")])])
	}]}

/***/ }),
/* 2589 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('TimeRange', {
	    attrs: {
	      "reservation": _vm.reservation,
	      "availability": _vm.availability
	    },
	    on: {
	      "selection": _vm.handleExtend
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 2590 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('FederationButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("F" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'federation-vehicles',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2591 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: ("maintenance-" + _vm._uid),
	    on: {
	      "input": _vm.close
	    }
	  }, [(_vm.request) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]) : _c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('InterventionRequestForm', {
	    on: {
	      "input": _vm.check
	    },
	    model: {
	      value: (_vm.body),
	      callback: function($$v) {
	        _vm.body = $$v
	      },
	      expression: "body"
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.save
	    },
	    slot: "footer"
	  }, [_vm._v("Save")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close(false)
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2592 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-list-filter-form filter-form"
	  }, [(_vm.$is('entity-filter')) ? _c('div', {
	    staticClass: "entity-filters"
	  }, [_c('label', [_vm._v("Status")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    staticClass: "medium-5",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.filterReservations]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": ""
	    }
	  }, [_vm._v("All statuses")]), _c('option', {
	    attrs: {
	      "value": "STARTED"
	    }
	  }, [_vm._v("Started")]), _c('option', {
	    attrs: {
	      "value": "CONFIRMED"
	    }
	  }, [_vm._v("Confirmed")]), _c('option', {
	    attrs: {
	      "value": "PLANNED"
	    }
	  }, [_vm._v("Planned")]), _c('option', {
	    attrs: {
	      "value": "SENT"
	    }
	  }, [_vm._v("Sent")]), _c('option', {
	    attrs: {
	      "value": "COMPLETED"
	    }
	  }, [_vm._v("Completed")]), _c('option', {
	    attrs: {
	      "value": "ERROR"
	    }
	  }, [_vm._v("Error")]), _c('option', {
	    attrs: {
	      "value": "CANCELLED"
	    }
	  }, [_vm._v("Cancelled")])])]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-1"
	  }, [(_vm.$isNot('export-form')) ? _c('a', {
	    staticClass: "fa fa-search fa-2x",
	    attrs: {
	      "data-toggle": "search-input select-status click-filter"
	    }
	  }) : _vm._e()]), _c('div', {
	    staticClass: "columns toggle-input",
	    attrs: {
	      "id": "search-input",
	      "data-toggler": ".toggle-input"
	    }
	  }, [_c('search-input-form', {
	    staticClass: "small-12",
	    on: {
	      "filteredSearch": _vm.searchFromInput
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "select-status",
	      "data-toggler": ".toggle-select"
	    }
	  }, [_c('div', {
	    staticClass: "columns large-2"
	  }, [_c('selectize-vehicle', {
	    attrs: {
	      "disabledSlot": 0
	    },
	    on: {
	      "optionSelected": _vm.vehicleSelected
	    }
	  })], 1), _c('div', {
	    staticClass: "columns large-3"
	  }, [_c('date-range-picker', {
	    on: {
	      "input": _vm.dateRangeSelected
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("ending in range")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns minwidth"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.ending_date),
	      expression: "search.ending_date"
	    }],
	    staticClass: "switch",
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.search.ending_date) ? _vm._i(_vm.search.ending_date, null) > -1 : (_vm.search.ending_date)
	    },
	    on: {
	      "click": _vm.toggleCheckbox,
	      "change": function($event) {
	        var $$a = _vm.search.ending_date,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.search, "ending_date", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.search, "ending_date", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.search, "ending_date", $$c)
	        }
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "columns large-2"
	  }, [_c('BookingModeSelect', {
	    attrs: {
	      "isFilter": true
	    },
	    model: {
	      value: (_vm.search.booking_mode),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "booking_mode", $$v)
	      },
	      expression: "search.booking_mode"
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "",
	      "selected": "selected"
	    }
	  }, [_vm._v("All Reservation Status")]), _c('option', {
	    attrs: {
	      "value": "STARTED"
	    }
	  }, [_vm._v("Started")]), _c('option', {
	    attrs: {
	      "value": "CONFIRMED"
	    }
	  }, [_vm._v("Confirmed")]), _c('option', {
	    attrs: {
	      "value": "PLANNED"
	    }
	  }, [_vm._v("Planned")]), _c('option', {
	    attrs: {
	      "value": "SENT"
	    }
	  }, [_vm._v("Sent")]), _c('option', {
	    attrs: {
	      "value": "COMPLETED"
	    }
	  }, [_vm._v("Completed")]), _c('option', {
	    attrs: {
	      "value": "ERROR"
	    }
	  }, [_vm._v("Error")]), _c('option', {
	    attrs: {
	      "value": "CANCELLED"
	    }
	  }, [_vm._v("Cancelled")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.billing_status),
	      expression: "search.billing_status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "billing_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All Billing Status")]), _c('option', {
	    attrs: {
	      "value": "UNCHARGEABLE"
	    }
	  }, [_vm._v("Uncharchable")]), _c('option', {
	    attrs: {
	      "value": "MAINTENANCE"
	    }
	  }, [_vm._v("Maintenance")]), _c('option', {
	    attrs: {
	      "value": "ON_HOLD"
	    }
	  }, [_vm._v("On Hold")]), _c('option', {
	    attrs: {
	      "value": "READY"
	    }
	  }, [_vm._v("Ready")]), _c('option', {
	    attrs: {
	      "value": "CHARGED"
	    }
	  }, [_vm._v("Charged")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.flag),
	      expression: "search.flag"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "flag", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All Reservation Flags")]), _c('option', {
	    attrs: {
	      "value": "TERMINATED_IN_FORBIDDEN"
	    }
	  }, [_vm._v("Terminated in forbidden")]), _c('option', {
	    attrs: {
	      "value": "TERMINATED_IN_UNDESIRABLE"
	    }
	  }, [_vm._v("Terminated in undesirable")]), _c('option', {
	    attrs: {
	      "value": "HOLD_BILLING"
	    }
	  }, [_vm._v("Hold billing")]), _c('option', {
	    attrs: {
	      "value": "SKIP_DEPOSIT"
	    }
	  }, [_vm._v("Skip deposit")]), _c('option', {
	    attrs: {
	      "value": "SKIP_BILLING"
	    }
	  }, [_vm._v("Skip billing")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.order_by),
	      expression: "search.order_by"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "order_by", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "",
	      "disabled": ""
	    }
	  }, [_vm._v("Order by")]), _c('option', {
	    attrs: {
	      "value": "id"
	    }
	  }, [_vm._v("Id")]), _c('option', {
	    attrs: {
	      "value": "start"
	    }
	  }, [_vm._v("Start")]), _c('option', {
	    attrs: {
	      "value": "end"
	    }
	  }, [_vm._v("End")])])])])]), (_vm.$isNot('export-form')) ? _c('div', {
	    staticClass: "columns small-1 text-right",
	    attrs: {
	      "id": "click-filter",
	      "data-toggler": ".toggle-input"
	    }
	  }, [_c('a', {
	    staticClass: "fa fa-2x",
	    class: {
	      'fa-sort-numeric-asc': _vm.sortAsc, 'fa-sort-numeric-desc': !_vm.sortAsc
	    },
	    on: {
	      "click": _vm.toggleDirection
	    }
	  }), _c('a', {
	    staticClass: "fa fa-filter fa-2x",
	    on: {
	      "click": _vm.filterReservations
	    }
	  })]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2593 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$acl('edit-clients')) ? _c('div', {
	    staticClass: "component-client-smart-edit"
	  }, [_c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1) : _c('h3', [_vm._v("Your account doesn't have permission to edit clients.")])
	},staticRenderFns: []}

/***/ }),
/* 2594 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-void"
	  }, [_c('ModalReveal', [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Usage details")]), _c('div', {
	    staticClass: "header",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('h2', [_vm._v(" PR" + _vm._s(_vm.item.id) + " ")]), _c('Cards', {
	    attrs: {
	      "data": _vm.packetData
	    }
	  })], 1), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "data-loader": _vm.dataLoader,
	      "componentType": "usages"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2595 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-reservations"
	  }, [_c('div', {
	    staticClass: "action-bar"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "action"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    on: {
	      "click": _vm.createDriverLicense
	    }
	  })])]), _c('div', {
	    staticClass: "column row"
	  }, _vm._l((_vm.licenses), function(license) {
	    return _c('div', {
	      staticClass: "columns small-12 medium-8 medium-offset-2 driver-licenses"
	    }, [_c('driver-licence', {
	      attrs: {
	        "type": 'license-card-accordion',
	        "item": license
	      }
	    })], 1)
	  }), 0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Driver Licenses")])])
	}]}

/***/ }),
/* 2596 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-list row column"
	  }, [_c('cards', {
	    attrs: {
	      "data": _vm.parsedReports
	    }
	  }), _c('vehicle-list-form', {
	    on: {
	      "filterVehicles": _vm.setSearch
	    }
	  }), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2597 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: _vm.componentId
	  }, [_c('button', {
	    staticClass: "button small",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Segment attributes")]), _c('label', [_vm._v("Attributes")]), _c('Attributes', {
	    attrs: {
	      "save-action": _vm.updateAttribute,
	      "delete-action": _vm.deleteAttribute
	    },
	    model: {
	      value: (_vm.body.attributes),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "attributes", $$v)
	      },
	      expression: "body.attributes"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2598 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-charging-sessions-list"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('base-list', {
	    ref: "chargingSessionsBaseList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false,
	      "component-type": _vm.reservation !== null ? 'reservation' : 'listing'
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2599 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-entity-page"
	  }, [(_vm.item) ? _c(_vm.itemComponent, {
	    tag: "component",
	    attrs: {
	      "item": _vm.item,
	      "type": 'expanded',
	      "id": _vm.item.id
	    },
	    on: {
	      "refresh": _vm.refresh
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2600 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-translation-edit"
	  }, [_c('div', {
	    staticClass: "row column card pt-2"
	  }, [_c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v(_vm._s(_vm.body.group) + "." + _vm._s(_vm.body.key))]), (_vm.allowedLanguages.length) ? [_vm._m(0), _vm._l((_vm.allowedLanguages), function(key) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column small-2 large-1 medium-1"
	    }, [_c('input', {
	      attrs: {
	        "type": "text",
	        "readonly": "readOnly"
	      },
	      domProps: {
	        "value": key
	      }
	    })]), _c('div', {
	      staticClass: "column"
	    }, [(_vm.editor) ? _c('Editor', {
	      attrs: {
	        "disabled": !_vm.item.editable && !_vm.editableKeys.includes(key)
	      },
	      model: {
	        value: (typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value[key]),
	        callback: function($$v) {
	          _vm.$set(typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value, key, $$v)
	        },
	        expression: "typeof body.value[key] === 'object'? JSON.stringify(body.value[key]) : body.value[key]"
	      }
	    }) : _c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value[key]),
	        expression: "typeof body.value[key] === 'object'? JSON.stringify(body.value[key]) : body.value[key]"
	      }],
	      attrs: {
	        "name": key,
	        "rows": "8",
	        "disabled": !_vm.item.editable && !_vm.editableKeys.includes(key)
	      },
	      domProps: {
	        "value": (typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value[key])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(typeof _vm.body.value[key] === 'object' ? JSON.stringify(_vm.body.value[key]) : _vm.body.value, key, $event.target.value)
	        }
	      }
	    })], 1)])
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.update
	    }
	  }, [_vm._v("Update")])], 1), _c('div', {
	    staticClass: "column text-right"
	  }, [(_vm.deleteButton) ? _c('TranslationButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  }) : _vm._e()], 1)])] : [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("Missing allowedLanguages configuration")])]], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("lang")])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("value")])])])
	}]}

/***/ }),
/* 2601 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-wallet"
	  }, [_vm._v(_vm._s(_vm.item.balance))])
	},staticRenderFns: []}

/***/ }),
/* 2602 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-vehicle-attributes"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Vehicle Attributes")]), _c('div', {
	    staticClass: "fa fa-plus",
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": function($event) {
	        _vm.add = !_vm.add
	      }
	    },
	    slot: "action"
	  })]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.add),
	      expression: "add"
	    }],
	    staticClass: "attributes-list"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('selectize-vehicle-attribute', {
	    staticClass: "input-group-field",
	    on: {
	      "optionSelected": _vm.updateAttributes
	    }
	  }), _c('div', {
	    staticClass: "input-group-button"
	  }, [_c('button', {
	    staticClass: "button fa fa-plus",
	    on: {
	      "click": _vm.addAttribute
	    }
	  })])], 1)])]), (_vm.addInProgress) ? _c('loading-spinner') : _vm._e()], 1), _c('div', {
	    staticClass: "container"
	  }, _vm._l((_vm.attributes), function(attribute, index) {
	    return _c('div', {
	      staticClass: "prop-item"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('span', {
	      staticClass: "input-group-label"
	    }, [(attribute.attribute.icon) ? _c('MdiIcon', {
	      attrs: {
	        "name": attribute.attribute.icon,
	        "show-name": false
	      }
	    }) : _vm._e(), _c('span', [_vm._v(_vm._s(attribute.attribute.name))])], 1), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (attribute.value),
	        expression: "attribute.value"
	      }],
	      staticClass: "input-group-field",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (attribute.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(attribute, "value", $event.target.value)
	        }
	      }
	    }), _c('div', {
	      staticClass: "input-group-button"
	    }, [_c('button', {
	      staticClass: "button default fa fa-save",
	      on: {
	        "click": function($event) {
	          return _vm.saveAttribute(attribute)
	        }
	      }
	    }), _c('button', {
	      staticClass: "button warning fa fa-times",
	      on: {
	        "click": function($event) {
	          return _vm.removeAttribute(index)
	        }
	      }
	    })])])])
	  }), 0)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2603 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "button alert",
	    on: {
	      "click": _vm.dismiss
	    }
	  }, [_vm._v("Dismiss")])
	},staticRenderFns: []}

/***/ }),
/* 2604 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-translation-add"
	  }, [(Object.keys(_vm.translations).length > 0) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column large-4"
	  }, [_vm._t("default"), (_vm.translations !== []) ? _c('ul', {
	    directives: [{
	      name: "f-accordion",
	      rawName: "v-f-accordion"
	    }],
	    staticClass: "accordion",
	    attrs: {
	      "data-accordion": "",
	      "data-allow-all-closed": "true"
	    }
	  }, _vm._l((_vm.translations), function(values, group) {
	    return _c('li', {
	      staticClass: "accordion-item",
	      attrs: {
	        "data-accordion-item": ""
	      }
	    }, [_c('a', {
	      staticClass: "accordion-title",
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v(_vm._s(group.toUpperCase()))]), _c('div', {
	      staticClass: "accordion-content",
	      attrs: {
	        "data-tab-content": ""
	      }
	    }, _vm._l((values), function(value) {
	      return _c('div', [_c('a', {
	        staticClass: "small",
	        on: {
	          "click": function($event) {
	            return _vm.openEditor(value.key, group)
	          }
	        }
	      }, [_vm._v(_vm._s(value.key))])])
	    }), 0)])
	  }), 0) : _vm._e()], 2), (Object.keys(_vm.selected).length) ? _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "card p-2"
	  }, [_c('span', {
	    staticClass: "fa fa-times text-right",
	    on: {
	      "click": function($event) {
	        _vm.selected = {}
	      }
	    }
	  }), _c('TranslationEdit', {
	    attrs: {
	      "item": _vm.selected,
	      "delete-button": _vm.selected.id !== undefined
	    }
	  })], 1)]) : _vm._e()]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2605 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-note"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('TocTypeButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("TT" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Group")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.group))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Priority")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.priority))])])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2606 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-driver-approval row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-4 small-12"
	  }, [_c('SearchEntity', {
	    attrs: {
	      "entity": "drivers"
	    },
	    model: {
	      value: (_vm.search.driver_id),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "driver_id", $$v)
	      },
	      expression: "search.driver_id"
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('AccontStatusFilter', {
	    attrs: {
	      "statuses": ['document_status', 'subscription']
	    },
	    model: {
	      value: (_vm.search),
	      callback: function($$v) {
	        _vm.search = $$v
	      },
	      expression: "search"
	    }
	  })], 1)]), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search,
	      "componentType": "approvalListing"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2607 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vat-amount-toggler"
	  }, [_c('label', [_vm._v(_vm._s(_vm.label)), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.amount),
	      expression: "amount"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.amount)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.amount = $event.target.value
	      }, _vm.setAmount]
	    }
	  }), _c('div', {
	    staticClass: "help-text"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.recordAmount)) + " included vat")])]), _c('label', [_vm._v("Included vat  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vat),
	      expression: "vat"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.vat) ? _vm._i(_vm.vat, null) > -1 : (_vm.vat)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.vat,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.vat = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.vat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.vat = $$c
	        }
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2608 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2609 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.options) ? _c('selectize', {
	    ref: "selectize",
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Reservation Rates"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2610 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy-button"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('SegmentRevealRate', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true
	    }
	  }, [_vm._v("Delete")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2611 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$acl('index-plan')) ? _c('div', {
	    staticClass: "component-backoffice-plan-list"
	  }, _vm._l((_vm.items), function(plans, status) {
	    return _c('div', {
	      staticClass: "plan-list"
	    }, [_c('div', {
	      staticClass: "row column"
	    }, [_c('h2', [_vm._v(_vm._s(status))])]), _c('div', {
	      staticClass: "row"
	    }, _vm._l((plans), function(item) {
	      return _c('div', {
	        staticClass: "columns plan large-4"
	      }, [_c('div', {
	        staticClass: "card",
	        style: ({
	          backgroundImage: _vm.getUrl(item.picture),
	          width: '100%',
	          height: '200px',
	          backgroundRepeat: 'no-repeat',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center'
	        })
	      }, [_c('div', {
	        staticClass: "inner-content",
	        class: {
	          'img-overlay': item.picture !== null
	        }
	      }, [_c('router-link', {
	        attrs: {
	          "to": {
	            name: 'plan',
	            params: {
	              id: item.id
	            }
	          }
	        }
	      }, [_c('h2', [_vm._v("#P" + _vm._s(item.id) + " - " + _vm._s(item.name))])]), _c('h4', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(item.cost).toFixed(2))) + " / " + _vm._s(item.billing_cycle) + " days")]), (item.featured) ? _c('h4', [_vm._v("Featured")]) : _vm._e(), (item.default) ? _c('h4', [_vm._v("Default")]) : _vm._e()], 1)])])
	    }), 0)])
	  }), 0) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2612 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-policy-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2613 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-note"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 8
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('DocumentTypeButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("DT" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Description")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.description))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Attachment views")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.attachment_views.join(' - ')))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v("Number required")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.item.has_number ? 'Yes' : 'No'))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v("Emission required")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v(_vm._s(_vm.item.has_emission ? 'Yes' : 'No'))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_vm._v("Expiry required")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n6"
	    },
	    slot: "n6"
	  }, [_vm._v(_vm._s(_vm.item.has_expiry ? 'Yes' : 'No'))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n7"
	    },
	    slot: "n7"
	  }, [_vm._v("Issuer required")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n7"
	    },
	    slot: "n7"
	  }, [_vm._v(_vm._s(_vm.item.has_issuer ? 'Yes' : 'No'))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n8"
	    },
	    slot: "n8"
	  }, [_vm._v("Country required")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n8"
	    },
	    slot: "n8"
	  }, [_vm._v(_vm._s(_vm.item.has_country ? 'Yes' : 'No'))])])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2614 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-zone-list component-backoffice-category-list"
	  }, [_c('div', {
	    staticClass: "row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.zones), function(zone, index) {
	    return _c('div', {
	      staticClass: "column small-12 large-6 category"
	    }, [_c('div', {
	      staticClass: "inner-content card"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column shrink"
	    }, [_c('dropdown', {
	      attrs: {
	        "icon": 'fa fa-ellipsis-v fa-2x action',
	        "position": 'top'
	      }
	    }, [_c('div', {
	      staticClass: "dropdown-buttons"
	    }, [_c('a', {
	      staticClass: "button",
	      on: {
	        "click": _vm.deleteZone
	      }
	    }, [_vm._v("Delete")]), _c('ModalReveal', {
	      ref: "revealGeoJson",
	      refInFor: true
	    }, [_c('button', {
	      staticClass: "button",
	      attrs: {
	        "slot": "trigger"
	      },
	      on: {
	        "click": _vm.showGeoJson
	      },
	      slot: "trigger"
	    }, [_vm._v("Copy GeoJson to clipboard")]), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column"
	    }, [(_vm.spin) ? _c('loading-spinner') : _c('textarea', {
	      attrs: {
	        "id": "geoJsonToCopy",
	        "rows": "30"
	      },
	      domProps: {
	        "value": _vm.geoJson
	      }
	    })], 1)]), _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column"
	    }, [_c('button', {
	      staticClass: "button",
	      attrs: {
	        "disabled": _vm.geoJson === ''
	      },
	      on: {
	        "click": _vm.copyToClipboard
	      }
	    }, [_vm._v("Copy to clipboard")])])])])], 1)])], 1), _c('div', {
	      staticClass: "column"
	    }, [_c('div', [_vm._v("Z" + _vm._s(zone.id))]), _c('div', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'edit-zone',
	          params: {
	            id: zone.id
	          }
	        }
	      }
	    }, [_c('h3', [_vm._v(_vm._s(zone.name) + "  ")])])], 1)])])])])
	  }), 0)])])
	},staticRenderFns: []}

/***/ }),
/* 2615 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-reservation",
	    class: _vm.item.status
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [(_vm.$is('listing')) ? _c('CardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 6
	    }
	  }, [_c('div', {
	    staticClass: "field-reservation-dropdown-buttons",
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('reservation-action-buttons', {
	    attrs: {
	      "reservation": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-reservation-info",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('reservation-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'reservation-id',
	      "type": 'reservation-id'
	    }
	  }), _c('driver', {
	    attrs: {
	      "type": 'onlyname',
	      "item": _vm.item.driver
	    }
	  })], 1), _c('reservation-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'reservation-bmode'
	    },
	    slot: "n1"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n2",
	      "fieldName": 'vehicle-info',
	      "item": _vm.item
	    },
	    slot: "n2"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'reservation-start'
	    },
	    slot: "n3"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'reservation-distance'
	    },
	    slot: "n4"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'reservation-cost'
	    },
	    slot: "n4"
	  }), _c('BackofficeReservation', {
	    attrs: {
	      "slot": "n5",
	      "type": "start-end-position",
	      "item": _vm.item
	    },
	    slot: "n5"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'reservation-status'
	    },
	    slot: "n6"
	  }), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1) : _vm._e()], 1), (_vm.item.status == 'STARTED') ? _c('div', {
	    staticClass: "warning progress pm-progress thin"
	  }, [_c('div', {
	    staticClass: "progress-meter",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]) : _vm._e()]) : _vm._e(), (_vm.$is('start-end-position')) ? _c('div', {
	    staticClass: "start-end-position"
	  }, [(_vm.item.booking_mode === 'OWFF') ? _c('div', {
	    staticClass: "owff"
	  }, [_c('div', {
	    staticClass: "extra-info"
	  }, [_vm._m(0), _c('span', [_vm._v("  " + _vm._s(_vm.item.extra.owff.pickup.name))])]), (_vm.item.extra.owff.dropoff !== null) ? _c('div', {
	    staticClass: "extra-info"
	  }, [_vm._m(1), _c('span', [_vm._v("  " + _vm._s(_vm.item.extra.owff.dropoff.name))])]) : _vm._e()]) : _c('div', {
	    staticClass: "parking-lot"
	  }, [_vm._v("PL" + _vm._s(_vm.item.vehicle.parking_lot.id) + " " + _vm._s(_vm.item.vehicle.parking_lot.name))]), _c('div', {
	    staticClass: "vehicle-slot"
	  }, [_vm._v("VS" + _vm._s(_vm.item.vehicle.slot_id) + " " + _vm._s(_vm.item.vehicle.vehicle_slot_address))])]) : _vm._e(), (_vm.$is('drv-res-list')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card9', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true
	    }
	  }, [_c('div', {
	    staticClass: "field-reservation-dropdown-buttons",
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('reservation-action-buttons', {
	    attrs: {
	      "reservation": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-reservation-info",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('reservation-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'reservation-id',
	      "type": 'reservation-id'
	    }
	  }), _c('img', {
	    staticClass: "vehicle-picture",
	    attrs: {
	      "src": _vm.item.vehicle.picture_external
	    }
	  })], 1), _c('reservation-fields', {
	    attrs: {
	      "slot": "n2",
	      "fieldName": 'vehicle-info',
	      "item": _vm.item
	    },
	    slot: "n2"
	  }), _c('div', {
	    staticClass: "parking-lot",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("PL" + _vm._s(_vm.item.vehicle.parking_lot.id) + " " + _vm._s(_vm.item.vehicle.parking_lot.name))]), _c('reservation-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'reservation-start'
	    },
	    slot: "n3"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'reservation-end'
	    },
	    slot: "n4"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'reservation-bmode'
	    },
	    slot: "n5"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'reservation-distance'
	    },
	    slot: "n6"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n7",
	      "item": _vm.item,
	      "fieldName": 'reservation-hours'
	    },
	    slot: "n7"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n8",
	      "item": _vm.item,
	      "fieldName": 'reservation-cost'
	    },
	    slot: "n8"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n9",
	      "item": _vm.item,
	      "fieldName": 'reservation-status'
	    },
	    slot: "n9"
	  }), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1), (_vm.item.status == 'STARTED') ? _c('div', {
	    staticClass: "warning progress pm-progress thin"
	  }, [_c('div', {
	    staticClass: "progress-meter",
	    staticStyle: {
	      "width": "70%"
	    }
	  })]) : _vm._e()]) : _vm._e(), (_vm.$is('client-list')) ? _c('div', {
	    staticClass: "client-list"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card9', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true
	    }
	  }, [_c('div', {
	    staticClass: "field-reservation-dropdown-buttons",
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('reservation-action-buttons', {
	    attrs: {
	      "reservation": _vm.item
	    }
	  })], 1)], 1), _c('reservation-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'reservation-id'
	    },
	    slot: "n1"
	  }), _c('div', {
	    staticClass: "driver",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v(_vm._s(_vm.item.driver.name) + " " + _vm._s(_vm.item.driver.surname))]), _c('reservation-fields', {
	    attrs: {
	      "slot": "n2",
	      "fieldName": 'vehicle-info',
	      "item": _vm.item
	    },
	    slot: "n2"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'reservation-start'
	    },
	    slot: "n3"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'reservation-end'
	    },
	    slot: "n4"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n5",
	      "item": _vm.item,
	      "fieldName": 'reservation-bmode'
	    },
	    slot: "n5"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'reservation-distance'
	    },
	    slot: "n6"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n7",
	      "item": _vm.item,
	      "fieldName": 'reservation-hours'
	    },
	    slot: "n7"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n8",
	      "item": _vm.item,
	      "fieldName": 'reservation-cost'
	    },
	    slot: "n8"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n9",
	      "item": _vm.item,
	      "fieldName": 'reservation-status'
	    },
	    slot: "n9"
	  }), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1)])]) : _vm._e(), (_vm.$is('vehicle-list')) ? _c('div', {
	    staticClass: "vehicle-list"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('CardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 6
	    }
	  }, [_c('div', {
	    staticClass: "field-reservation-dropdown-buttons",
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('reservation-action-buttons', {
	    attrs: {
	      "reservation": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-reservation-info",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('reservation-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'reservation-id',
	      "type": 'reservation-id'
	    }
	  }), _c('driver', {
	    attrs: {
	      "type": 'onlyname',
	      "item": _vm.item.driver
	    }
	  })], 1), _c('reservation-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'reservation-bmode'
	    },
	    slot: "n1"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n2",
	      "item": _vm.item,
	      "fieldName": 'reservation-start'
	    },
	    slot: "n2"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'reservation-distance'
	    },
	    slot: "n3"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'reservation-cost'
	    },
	    slot: "n4"
	  }), _c('BackofficeReservation', {
	    attrs: {
	      "slot": "n5",
	      "type": "start-end-position",
	      "item": _vm.item
	    },
	    slot: "n5"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n6",
	      "item": _vm.item,
	      "fieldName": 'reservation-status'
	    },
	    slot: "n6"
	  }), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)], 1)], 1)])]) : _vm._e(), (_vm.$is('shortList')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('card5', [_c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'reservation',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("R" + _vm._s(_vm.item.number))])], 1), _c('div', {
	    staticClass: "field-vehicle",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.vehicle.model))]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'vehicle',
	        params: {
	          id: _vm.item.vehicle.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.item.vehicle.plate))])], 1), _c('div', {
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.driver.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.item.driver.name) + " " + _vm._s(_vm.item.driver.surname))])], 1), _c('div', {
	    staticClass: "field-reservation-start",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMMM')))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, 'HH:mm')))])]), _c('div', {
	    staticClass: "field-reservation-end",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, 'DD MMMM')))]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, 'HH:mm')))])])])], 1)]) : _vm._e(), (_vm.$is('sentinel')) ? _c('div', {
	    staticClass: "sentinel"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('CardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 4
	    }
	  }, [_c('div', {
	    staticClass: "field-reservation-dropdown-buttons",
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('reservation-action-buttons', {
	    attrs: {
	      "reservation": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-reservation-info",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('reservation-fields', {
	    attrs: {
	      "item": _vm.item,
	      "fieldName": 'reservation-id',
	      "type": 'reservation-id'
	    }
	  }), _c('driver', {
	    attrs: {
	      "type": 'onlyname',
	      "item": _vm.item.driver
	    }
	  })], 1), _c('reservation-fields', {
	    attrs: {
	      "slot": "n1",
	      "item": _vm.item,
	      "fieldName": 'reservation-bmode'
	    },
	    slot: "n1"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n2",
	      "fieldName": 'vehicle-info-no-img',
	      "item": _vm.item
	    },
	    slot: "n2"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n3",
	      "item": _vm.item,
	      "fieldName": 'reservation-start-end'
	    },
	    slot: "n3"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'reservation-distance'
	    },
	    slot: "n4"
	  }), _c('reservation-fields', {
	    attrs: {
	      "slot": "n4",
	      "item": _vm.item,
	      "fieldName": 'reservation-cost'
	    },
	    slot: "n4"
	  }), _c('a', {
	    staticClass: "fa fa-globe fa-2x",
	    attrs: {
	      "slot": "n4"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('locate')
	      }
	    },
	    slot: "n4"
	  })], 1)], 1)])]) : _vm._e()]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "fa-stack",
	    staticStyle: {
	      "color": "green"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o fa-stack-2x"
	  }), _c('strong', {
	    staticClass: "fa-stack-1x"
	  }, [_vm._v("D")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "fa-stack",
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o fa-stack-2x"
	  }), _c('strong', {
	    staticClass: "fa-stack-1x"
	  }, [_vm._v("A")])])
	}]}

/***/ }),
/* 2616 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": this._uid
	    }
	  }, [_c('div', [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2617 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-federation-controller"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns small-6 large-12"
	  }, [_c('div', {
	    staticClass: "row column"
	  }, [_c('router-tab-headers', {
	    attrs: {
	      "tabs": _vm.tabs,
	      "id": 'federation-vehicles',
	      "activeIndex": 0,
	      "deepLink": true
	    }
	  }, [_c('router-view')], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 2618 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-create-zone"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12 large-6"
	  }, [_c('label', [_vm._v("Select zone"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.zone_id),
	      expression: "body.zone_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "zone_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Select zone")]), _vm._l((_vm.zones), function(zone, id) {
	    return _c('option', {
	      domProps: {
	        "value": zone.id
	      }
	    }, [_vm._v(_vm._s(zone.name))])
	  })], 2)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Type"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.type),
	      expression: "body.type"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.type)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "type", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Color"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.color),
	      expression: "body.color"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.color)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "color", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("On reservation start")]), _c('SelectizeCommonCost', {
	    attrs: {
	      "selectedValue": _vm.body.start_common_cost_id
	    },
	    on: {
	      "optionSelected": function($event) {
	        return _vm.setCommonCost('start_common_cost_id', $event)
	      },
	      "optionRemoved": function($event) {
	        return _vm.unsetCommonCost('start_common_cost_id')
	      }
	    }
	  }), _c('label', [_vm._v("Show on public map")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.show),
	      expression: "body.show"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.body.show) ? _vm._i(_vm.body.show, null) > -1 : (_vm.body.show)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.body.show,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.body, "show", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.body, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.body, "show", $$c)
	        }
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("On reservation end")]), _c('SelectizeCommonCost', {
	    attrs: {
	      "selectedValue": _vm.body.end_common_cost_id
	    },
	    on: {
	      "optionSelected": function($event) {
	        return _vm.setCommonCost('end_common_cost_id', $event)
	      },
	      "optionRemoved": function($event) {
	        return _vm.unsetCommonCost('end_common_cost_id')
	      }
	    }
	  }), _c('label', [_vm._v("Max vehicles"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.max_vehicles),
	      expression: "body.max_vehicles"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "0"
	    },
	    domProps: {
	      "value": (_vm.body.max_vehicles)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "max_vehicles", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Min fuel level"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.min_fuel_level),
	      expression: "body.min_fuel_level"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "0"
	    },
	    domProps: {
	      "value": (_vm.body.min_fuel_level)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "min_fuel_level", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Max speed"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.max_speed),
	      expression: "body.max_speed"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "0"
	    },
	    domProps: {
	      "value": (_vm.body.max_speed)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "max_speed", $event.target.value)
	      }
	    }
	  })])], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('GoogleMapContainer', [_c('GoogleMap', {
	    ref: "map",
	    staticStyle: {
	      "height": "500px"
	    },
	    attrs: {
	      "api-key": _vm.apiKey,
	      "center": _vm.mapCenter,
	      "libraries": ['places', 'visualization', 'drawing'],
	      "zoomControl": true,
	      "mapTypeControl": true
	    }
	  }, _vm._l((_vm.selectedPoly), function(p) {
	    return (_vm.body.zone_id !== null) ? _c('google-map-polygon', {
	      attrs: {
	        "positions": p,
	        "color": _vm.body.color,
	        "fillColor": _vm.body.color
	      }
	    }) : _vm._e()
	  }), 1)], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2619 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-add-parking-lot"
	  }, [_c('div', {
	    staticClass: "row columns callout"
	  }, [_c('h6', [_vm._v("Add new Parking Lot")]), _c('h3', [_vm._v("Selected Parking Group: " + _vm._s(_vm.item.name))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  })]), _c('label', [_vm._v("Available slots"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.availableSlots),
	      expression: "availableSlots"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.availableSlots)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.availableSlots = $event.target.value
	      }
	    }
	  })]), _c('label', [_vm._v("Allowed Zone"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.allowed_zone_id),
	      expression: "allowed_zone_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.allowed_zone_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Not Selected")]), _vm._l((_vm.zones), function(zone) {
	    return _c('option', {
	      domProps: {
	        "value": zone.id
	      }
	    }, [_vm._v(_vm._s(zone.name))])
	  })], 2)]), _c('label', [_vm._v("Undesirable Zone"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.undesiderable_zone_id),
	      expression: "undesiderable_zone_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.undesiderable_zone_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Not Selected")]), _vm._l((_vm.zones), function(zone) {
	    return _c('option', {
	      domProps: {
	        "value": zone.id
	      }
	    }, [_vm._v(_vm._s(zone.name))])
	  })], 2)]), _c('label', [_vm._v("Forbidden zone"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.forbidden_zone_id),
	      expression: "forbidden_zone_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.forbidden_zone_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Not Selected")]), _vm._l((_vm.zones), function(zone) {
	    return _c('option', {
	      domProps: {
	        "value": zone.id
	      }
	    }, [_vm._v(_vm._s(zone.name))])
	  })], 2)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Description")]), _c('Editor', {
	    attrs: {
	      "value": _vm.description
	    },
	    model: {
	      value: (_vm.description),
	      callback: function($$v) {
	        _vm.description = $$v
	      },
	      expression: "description"
	    }
	  }), _c('label', [_vm._v("Picture"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.picture),
	      expression: "picture"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.picture)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.picture = $event.target.value
	      }
	    }
	  })]), _c('kepler-file-upload', {
	    attrs: {
	      "selected-prefix": "parking-lot",
	      "selected-visibility": "public"
	    },
	    on: {
	      "sel": _vm.handleFileSelector
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Latitude"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.latitude),
	      expression: "latitude"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.latitude)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.latitude = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Longitude"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.longitude),
	      expression: "longitude"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.longitude)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.longitude = $event.target.value
	      }
	    }
	  })])])]), _c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        _vm.openMap = !_vm.openMap
	      }
	    }
	  }, [_vm._v("Toggle Map")]), (_vm.openMap) ? _c('div', {
	    staticClass: "row columns"
	  }, [_c('label', [_vm._v("Click on the map for select the parking lot position")]), _c('div', {
	    staticClass: "map-wrapper"
	  }, [_c('GoogleMapContainer', [_c('GoogleMap', {
	    attrs: {
	      "apiKey": _vm.mapKey,
	      "center": _vm.mapCenter,
	      "searchBar": true,
	      "mapTypeId": 'roadmap',
	      "mapTypeControl": true,
	      "listenForClick": true
	    },
	    on: {
	      "mapClicked": _vm.updateMarker,
	      "placesChanged": _vm.hideMarker
	    }
	  }, [(_vm.markerPosition) ? _c('GoogleMapMarker', {
	    attrs: {
	      "position": _vm.mapCenter,
	      "title": "",
	      "label": ""
	    }
	  }) : _vm._e(), (_vm.undesiderable_zone_id) ? _c('div', {
	    staticClass: "polygons"
	  }, _vm._l((_vm.zones[_vm.undesiderable_zone_id].poly), function(p) {
	    return _c('GoogleMapPolygon', {
	      attrs: {
	        "positions": p,
	        "color": "yellow",
	        "fillColor": "yellow"
	      }
	    })
	  }), 1) : _vm._e(), (_vm.forbidden_zone_id) ? _c('div', {
	    staticClass: "polygons"
	  }, _vm._l((_vm.zones[_vm.forbidden_zone_id].poly), function(p) {
	    return _c('GoogleMapPolygon', {
	      attrs: {
	        "positions": p,
	        "color": "red",
	        "fillColor": "red"
	      }
	    })
	  }), 1) : _vm._e(), (_vm.allowed_zone_id) ? _c('div', {
	    staticClass: "polygons"
	  }, _vm._l((_vm.zones[_vm.allowed_zone_id].poly), function(p) {
	    return _c('GoogleMapPolygon', {
	      attrs: {
	        "positions": p,
	        "color": "green",
	        "fillColor": "green"
	      }
	    })
	  }), 1) : _vm._e()], 1)], 1)], 1), _c('p', [_vm._v(_vm._s(_vm.latitude) + " " + _vm._s(_vm.longitude))])]) : _vm._e(), _c('div', {
	    staticClass: "row column"
	  }, [_c('button', {
	    staticClass: "button",
	    class: {
	      disabled: !_vm.description || !_vm.name || !_vm.latitude || !_vm.longitude
	    },
	    on: {
	      "click": _vm.addParkingLot
	    }
	  }, [_vm._v("Add")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2620 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-packet"
	  }, [(_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.options) ? _c('selectize', {
	    attrs: {
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Packet",
	      "allowEmptyOption": _vm.allowEmptyOption,
	      "selectedValue": _vm.selectedValue,
	      "disabled": _vm.disabled
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2621 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.value) ? _c('div', {
	    staticClass: "component-wallet-record-list"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Wallet records")]), (_vm.expanded) ? _c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": function($event) {
	        _vm.walletAddCostToggle = !_vm.walletAddCostToggle
	      }
	    },
	    slot: "action"
	  }) : _vm._e(), _c('i', {
	    staticClass: "fa fa-2x",
	    class: {
	      'fa-eye-slash': _vm.expanded, 'fa-eye': !_vm.expanded
	    },
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": function($event) {
	        _vm.expanded = !_vm.expanded
	      }
	    },
	    slot: "action"
	  }), _c('ActionButton', {
	    attrs: {
	      "slot": "action",
	      "button": false,
	      "action": _vm.refreshList
	    },
	    slot: "action"
	  }, [_c('span', {
	    staticClass: "fa fa-refresh fa-2x",
	    staticStyle: {
	      "color": "white"
	    }
	  })])], 1), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.expanded),
	      expression: "expanded"
	    }],
	    staticClass: "wallet"
	  }, [(_vm.value.amounts['RECORDS_VATIN'] != _vm.value.amounts['BALANCE_VATIN']) ? [_c('h3', [_vm._v("Current Balance: " + _vm._s(_vm.$priceWithcurrency(_vm.value.amounts['RECORDS_VATIN'])))]), (_vm.value.amounts['UNINVOICED_RECORDS_VATIN'] !== '0.00') ? _c('span', {
	    staticClass: "small"
	  }, [_vm._v("(Inc. " + _vm._s(_vm.$priceWithcurrency(_vm.value.amounts['UNINVOICED_RECORDS_VATIN'])) + " of uninvoiced items)")]) : _vm._e()] : _vm._e(), (_vm.value.amounts['UNINVOICED_DEPOSITS_VATIN'] !== '0.00') ? _c('span', {
	    staticClass: "small"
	  }, [_vm._v("(Inc. " + _vm._s(_vm.$priceWithcurrency(_vm.value.amounts['UNINVOICED_DEPOSITS_VATIN'])) + " of uncredited deposits)")]) : _vm._e(), (_vm.walletAddCostToggle) ? _c('wallet-add-cost', {
	    attrs: {
	      "wallet": _vm.value
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('base-list', {
	    ref: "wrList",
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "resultsPerPage": 5,
	      "search": _vm.search,
	      "component-type": "multi-wallet"
	    }
	  })], 1)], 2)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2622 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-note"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 4
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'top'
	    }
	  }, [_c('TocButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("TOC" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v("Required from")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.required_from))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Disabled")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.disabled))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v("Version")]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.item.version))]), _c('div', {
	    staticClass: "field-url-detail",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'toc',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])], 1)]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2623 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.types), function(type, index) {
	    return _c('div', {
	      key: ("VT" + (type.id) + "-" + index),
	      staticClass: "column small-12 large-6 category",
	      class: {
	        active: _vm.activeIndex === index
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setSearch(index)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "inner-content card text-center"
	    }, [_c('div', {
	      staticClass: "row text-center"
	    }, [_c('div', {
	      staticClass: "column text-left"
	    }, [_c('h2', [_vm._v(_vm._s(type.name))])]), _c('div', {
	      staticClass: "column text-right"
	    }, [_c('pre', [_vm._v("VT" + _vm._s(type.id))])])]), _c('div', {
	      staticClass: "row text-center"
	    }, [_c('div', {
	      staticClass: "column text-right"
	    }, [(_vm.activeIndex === index) ? _c('i', {
	      staticClass: "fa fa-trash fa-2x",
	      on: {
	        "click": _vm.deleteType
	      }
	    }) : _vm._e()])]), _c('div', {
	      staticClass: "row text-center"
	    }, [_c('div', {
	      staticClass: "column text-left"
	    }, [_c('p', [_vm._v(_vm._s(type.description))])])])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2624 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', [_c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('EditReportingType')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2625 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "google-map-container"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 2626 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-password-smart-edit"
	  }, [_c('smart-edit', {
	    attrs: {
	      "options": _vm.options,
	      "value": _vm.item
	    },
	    on: {
	      "input": _vm.updateFields
	    }
	  }), _vm._m(0), _c('button', {
	    staticClass: "button expanded",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save and Submit")])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "callout alert"
	  }, [_c('h3', [_c('strong', [_vm._v("Warning")])]), _c('h5', [_vm._v("This may have legal implications")]), _c('p', [_vm._v("Inform the user to update his password as soon as possible")])])
	}]}

/***/ }),
/* 2627 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-edit-parking-group"
	  }, [_c('modal-reveal', {
	    ref: "modalEditPG",
	    attrs: {
	      "sizing": "small"
	    }
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('h2', [_vm._v("Edit Parking Group - " + _vm._s(_vm.item.name))]), _c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.name),
	      expression: "item.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "name", $event.target.value)
	      }
	    }
	  })]), _c('BookingModeSelect', {
	    model: {
	      value: (_vm.item.reservation_type),
	      callback: function($$v) {
	        _vm.$set(_vm.item, "reservation_type", $$v)
	      },
	      expression: "item.reservation_type"
	    }
	  }), _c('label', [_vm._v("Vat"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vat_id),
	      expression: "vat_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.vat_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Select custom vat")]), _vm._l((_vm.vats), function(vat) {
	    return _c('option', {
	      domProps: {
	        "value": vat.id
	      }
	    }, [_vm._v(_vm._s(vat.description) + " (" + _vm._s(vat.name) + " " + _vm._s(vat.percentage) + "%)")])
	  })], 2)]), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Save")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2628 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-vehicle-slot-disable"
	  }, [_c('ModalReveal', {
	    ref: _vm.componentId
	  }, [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Disable")]), _c('div', {
	    staticClass: "header",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('h2', [_vm._v("Disable vehicle slot")])]), _c('div', {
	    staticClass: "row"
	  }), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "large-6 text-left"
	  }, [(!_vm.noreason) ? _c('label', [_vm._v("Reason"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reason),
	      expression: "body.reason"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "reason", $event.target.value)
	      }
	    }
	  })]) : _vm._e(), _c('label', [_vm._v("Disable without reason"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.noreason),
	      expression: "noreason"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.noreason) ? _vm._i(_vm.noreason, null) > -1 : (_vm.noreason)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.noreason,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.noreason = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.noreason = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.noreason = $$c
	        }
	      }, _vm.toggleReason]
	    }
	  })])])]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "color-class": "success",
	      "action": _vm.disable,
	      "confirm": true
	    },
	    slot: "footer"
	  }, [_vm._v("Disable")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2629 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-invoice-list-filter-form filter-form"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-3"
	  }, [_c('SearchEntity', {
	    attrs: {
	      "entity": "clients"
	    },
	    model: {
	      value: (_vm.search.client_id),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "client_id", $$v)
	      },
	      expression: "search.client_id"
	    }
	  })], 1), _c('div', {
	    staticClass: "columns large-2"
	  }, [_c('selectize-plan', {
	    on: {
	      "optionSelected": _vm.selectPlan
	    }
	  })], 1), _c('div', {
	    staticClass: "columns large-2"
	  }, [_c('date-picker', {
	    attrs: {
	      "placeholder": 'Expire from'
	    },
	    model: {
	      value: (_vm.search.expire_from),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "expire_from", $$v)
	      },
	      expression: "search.expire_from"
	    }
	  })], 1), _c('div', {
	    staticClass: "columns large-2"
	  }, [_c('date-picker', {
	    attrs: {
	      "placeholder": 'Expire to'
	    },
	    model: {
	      value: (_vm.search.expire_to),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "expire_to", $$v)
	      },
	      expression: "search.expire_to"
	    }
	  })], 1), _c('div', {
	    staticClass: "columns large-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.active),
	      expression: "search.active"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("All")]), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Not Expired")]), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Expired")])])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('a', {
	    staticClass: "fa fa-angle-double-down fa-2x",
	    on: {
	      "click": _vm.filterSubscriptions
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2630 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-invoice invoice"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "invoice-list"
	  }, [_c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row collapse"
	  }, [_c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('invoice-action-buttons', {
	    attrs: {
	      "invoice": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns align-self-middle"
	  }, [_c('invoice-fields', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'invoice-number'
	    }
	  }), _c('div', {
	    staticClass: "type"
	  }, [_vm._v(_vm._s(_vm.item.type))])], 1), _c('div', {
	    staticClass: "columns align-self-middle"
	  }, [_c('invoice-fields', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'invoice-emission-date'
	    }
	  })], 1), _c('div', {
	    staticClass: "columns align-self-middle"
	  }, [_c('invoice-fields', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'invoice-due-date'
	    }
	  })], 1), _c('div', {
	    staticClass: "columns align-self-middle"
	  }, [_c('invoice-fields', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'invoice-client-info'
	    }
	  })], 1), _c('div', {
	    staticClass: "columns align-self-middle"
	  }, [_c('invoice-fields', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'invoice-tax'
	    }
	  })], 1), _c('div', {
	    staticClass: "columns align-self-middle"
	  }, [_c('invoice-fields', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'invoice-total'
	    }
	  })], 1), _c('div', {
	    staticClass: "columns align-self-middle"
	  }, [_c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("NET TO PAY:")]), _c('span', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.total)))])]), _c('div', {
	    staticClass: "columns align-self-middle"
	  }, [_c('invoice-fields', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'invoice-status'
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_c('div', {
	    staticClass: "row align-center align-middle",
	    attrs: {
	      "slot": "actionPage"
	    },
	    slot: "actionPage"
	  }, [_c('is-module-enabled', {
	    attrs: {
	      "module": "italian-e-invoice"
	    }
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.downloadXML,
	      "button": false
	    }
	  }, [_c('div', {
	    staticClass: "fa fa-code fa-2x",
	    style: (_vm.xmlStatus)
	  })])], 1), _c('a', {
	    staticClass: "fa fa-file-pdf-o fa-2x",
	    on: {
	      "click": function($event) {
	        return _vm.openUrl(_vm.item.url)
	      }
	    }
	  }), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'invoice',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-2x action"
	  })])], 1)])])])]) : _vm._e(), (_vm.$is('client-invoices')) ? _c('div', {
	    staticClass: "invoice-list"
	  }, [_c('div', {
	    staticClass: "client-invoices"
	  }, [_c('div', {
	    staticClass: "component-card"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column expand"
	  }, [_c('h3', {
	    staticClass: "mb-0"
	  }, [_vm._v(_vm._s(_vm.label) + _vm._s(_vm.item.internal_id) + "(" + _vm._s(_vm.item.number) + ")")]), (_vm.label === 'INV') ? _c('small', [_c('strong', [_vm._v(_vm._s(_vm.item.status))]), (_vm.item.status == 'PAID') ? _c('span', [_vm._v(": " + _vm._s(_vm.$dateFormat(_vm.item.payed_on, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))]) : _vm._e()]) : _vm._e()]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "field-content"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Emission")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(" " + _vm._s(_vm.$dateFormat(_vm.item.emission_date, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])]), (_vm.label !== 'CRN') ? _c('div', {
	    staticClass: "field-content"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Due date")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.due_date, _vm.$toMomentFormat(_vm.configuration.locale.locale_date_format.value))))])]) : _vm._e()]), _c('div', {
	    staticClass: "column shrink",
	    staticStyle: {
	      "padding-left": "0",
	      "padding-right": "0"
	    }
	  }, [(_vm.label === 'INV' || _vm.label === 'PRO') ? _c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('invoice-action-buttons', {
	    attrs: {
	      "invoice": _vm.item
	    }
	  })], 1) : _vm._e()], 1)]), _c('div', {
	    staticClass: "row text-center pt-0 bottom"
	  }, [_c('div', {
	    staticClass: "column shrink p-1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Tax")]), _c('h3', [_vm._v(" " + _vm._s(_vm.$priceWithcurrency(_vm.item.tax)))])]), _c('div', {
	    staticClass: "column shrink p-1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Subtotal")]), _c('h3', [_vm._v(" " + _vm._s(_vm.$priceWithcurrency(_vm.item.subtotal)))])]), _c('div', {
	    staticClass: "column shrink p-1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Total")]), _c('h3', [_vm._v(" " + _vm._s(_vm.$priceWithcurrency(_vm.item.document_total)))])]), _c('div', {
	    staticClass: "column shrink p-1"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Net to Pay")]), _c('h3', [_vm._v(" " + _vm._s(_vm.$priceWithcurrency(_vm.item.total)))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('label', [_vm._v(" ")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink pl-0 pr-0"
	  }, [_c('is-module-enabled', {
	    attrs: {
	      "module": "italian-e-invoice"
	    }
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.downloadXML,
	      "button": false
	    }
	  }, [_c('div', {
	    staticClass: "fa fa-code fa-2x",
	    style: (_vm.xmlStatus)
	  })])], 1)], 1), _c('div', {
	    staticClass: "column shrink pl-0 pr-0"
	  }, [_c('a', {
	    staticClass: "fa fa-2x fa-file-pdf-o",
	    on: {
	      "click": function($event) {
	        return _vm.openUrl(_vm.item.url)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "column shrink pl-0 pr-0"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'invoice',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-2x fa-angle-right action"
	  })])], 1)])])])])])]) : _vm._e(), (_vm.$is('einvoice')) ? _c('div', {
	    staticClass: "client-invoices"
	  }, [_c('CardN', {
	    attrs: {
	      "columns": 3
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v("File name:")]), _c('div', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v(_vm._s(_vm.item.uploadFileName))]), _c('div', {
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_vm._v(_vm._s(_vm.item.errorCode) + " - " + _vm._s(_vm.item.errorDescription))]), _c('div', {
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v("Date")]), _c('div', {
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.created_at))])])], 1) : _vm._e(), (_vm.$is('record-details')) ? _c('div', {
	    staticClass: "invoice-list"
	  }) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2631 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-client-wallets"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Billing")]), _c('AddCommonCostToWallet', {
	    attrs: {
	      "slot": "action",
	      "wallet": _vm.selectedWallet.id
	    },
	    slot: "action"
	  })], 1), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "wallets card"
	  }, _vm._l((_vm.wallets), function(wallet, id) {
	    return _c('div', {
	      staticClass: "wallet",
	      class: {
	        selected: _vm.selectedIndex === id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setActive(id)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "wallet-info"
	    }, [_c('div', [_vm._v("W" + _vm._s(wallet.id) + " " + _vm._s(wallet.name))]), _c('div', [(wallet.payment_method !== null) ? [_c('span', [_vm._v("PM" + _vm._s(wallet.payment_method.id)), _c('small', [_vm._v(_vm._s(wallet.payment_method.name))])])] : [_c('small', [_vm._v("NO PAYMENT METHOD ASSOCIATED WITH THIS WALLET")])]], 2), _c('h3', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.wallets[id].amounts['BALANCE_VATIN'])))])]), (_vm.selectedIndex === id) ? _c('div', {
	      staticClass: "wallet-actions"
	    }, [(_vm.$acl('run-command-console')) ? _c('ActionButton', {
	      attrs: {
	        "action": _vm.billWallet,
	        "button": false
	      }
	    }, [_c('div', {
	      staticClass: "fa fa-money",
	      staticStyle: {
	        "color": "white"
	      }
	    })]) : _vm._e(), _c('div', {
	      staticClass: "fa fa-pencil",
	      on: {
	        "click": _vm.editWallet
	      }
	    })], 1) : _vm._e()])
	  }), 0)])]), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('BackofficeMultiWallet', {
	    ref: "wrList",
	    model: {
	      value: (_vm.selectedWallet),
	      callback: function($$v) {
	        _vm.selectedWallet = $$v
	      },
	      expression: "selectedWallet"
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [(_vm.selectedWallet) ? _c('TabbedClientInvoices', {
	    ref: "inList",
	    attrs: {
	      "wallet": _vm.selectedWallet
	    }
	  }) : _vm._e()], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('TabbedPacketRecords')], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('TabbedClientDeposits', {
	    ref: "dpList"
	  })], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('TabbedCreditRecords', {
	    ref: "crList",
	    attrs: {
	      "type": "Promo"
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('TabbedPaidCreditRecords', {
	    ref: "crList",
	    attrs: {
	      "type": "Paid"
	    }
	  })], 1)])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2632 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-void"
	  }, [_c('ModalReveal', [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Registration token")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Registration tokens"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.registrationToken),
	      expression: "body.registrationToken"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "registrationToken", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.registrationTokens), function(token) {
	    return _c('option', {
	      domProps: {
	        "value": token.id
	      }
	    }, [_vm._v("RT" + _vm._s(token.id) + " " + _vm._s(token.token))])
	  }), 0)])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Type")]), (_vm.selected !== null) ? _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.selected.destination_type) + " " + _vm._s(_vm.selected.destination_id))]) : _vm._e(), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Additional")]), (_vm.selected !== null) ? _vm._l((_vm.selected.additional), function(additional) {
	    return (_vm.selected !== null) ? _c('div', {
	      staticClass: "field-value"
	    }, [_vm._v(_vm._s(additional.class) + " " + _vm._s(additional.id))]) : _vm._e()
	  }) : _vm._e()], 2)]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.add
	    },
	    slot: "footer"
	  }, [_vm._v("Add")]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2633 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-common-cost-type-list row column"
	  }, [_c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2634 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": this._uid
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 2635 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-registration"
	  }, [_c('form', {
	    attrs: {
	      "enctype": "multipart/form-data"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.formSubmit($event)
	      }
	    }
	  }, [_vm._m(0), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("Client Type  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.client_type_id),
	      expression: "body.client_type_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "client_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Choose a client type")]), _vm._l((_vm.clientTypes), function(v) {
	    return _c('option', {
	      domProps: {
	        "value": v.id
	      }
	    }, [_vm._v(_vm._s(v.code))])
	  })], 2)], 1)]), _c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("Name  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("Surname  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.surname),
	      expression: "body.surname"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.surname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "surname", $event.target.value)
	      }
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("Email  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.email),
	      expression: "body.email"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "email", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("Phone  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.phone),
	      expression: "body.phone"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "international prefix call (ex: +39-3951231231)",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "phone", $event.target.value)
	      }
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("Mobile  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.mobile),
	      expression: "body.mobile"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "international prefix call (ex: +39-3951231231)",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.mobile)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "mobile", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("Birthdate  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('date-picker', {
	    attrs: {
	      "placeholder": "insert date"
	    },
	    model: {
	      value: (_vm.body.birthdate),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "birthdate", $$v)
	      },
	      expression: "body.birthdate"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("Fiscal code  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.fiscal_code),
	      expression: "body.fiscal_code"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.fiscal_code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "fiscal_code", $event.target.value)
	      }
	    }
	  })], 1)])]), (_vm.isBusinessAccount) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Vat number  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.vat_number),
	      expression: "body.vat_number"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.vat_number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "vat_number", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-6 columns"
	  }, [_c('label', [_vm._v("Organization name  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.organization_name),
	      expression: "body.organization_name"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.organization_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "organization_name", $event.target.value)
	      }
	    }
	  })], 1)])]) : _vm._e(), _vm._m(1), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Street name  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.address.street),
	      expression: "body.address.street"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.address.street)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.address, "street", $event.target.value)
	      }
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("City  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.address.city),
	      expression: "body.address.city"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.address.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.address, "city", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Region  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.address.region),
	      expression: "body.address.region"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.address.region)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.address, "region", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Country  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('selectize-country', {
	    on: {
	      "optionSelected": _vm.setAddressCountry
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-2 columns"
	  }, [_c('label', [_vm._v("Postal code  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.address.postal_code),
	      expression: "body.address.postal_code"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.address.postal_code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.address, "postal_code", $event.target.value)
	      }
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('div', {
	    staticClass: "switch large"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.address),
	      expression: "address"
	    }],
	    staticClass: "switch-input",
	    attrs: {
	      "id": "yes-no",
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.address) ? _vm._i(_vm.address, null) > -1 : (_vm.address)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.address,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.address = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.address = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.address = $$c
	        }
	      }
	    }
	  }), _vm._m(3)])])]), (!_vm.address) ? _c('div', [_vm._m(4), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Street name  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.billing_address.street),
	      expression: "body.billing_address.street"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.billing_address.street)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.billing_address, "street", $event.target.value)
	      }
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("City  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.billing_address.city),
	      expression: "body.billing_address.city"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.billing_address.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.billing_address, "city", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Region  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.billing_address.region),
	      expression: "body.billing_address.region"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.billing_address.region)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.billing_address, "region", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Country  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('selectize-country', {
	    on: {
	      "optionSelected": _vm.setBillingAddressCountry
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-2 columns"
	  }, [_c('label', [_vm._v("Postal code  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.billing_address.postal_code),
	      expression: "body.billing_address.postal_code"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.billing_address.postal_code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.billing_address, "postal_code", $event.target.value)
	      }
	    }
	  })], 1)])])]) : _vm._e(), _c('hr'), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(5), _c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('div', {
	    staticClass: "switch large"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.document),
	      expression: "document"
	    }],
	    staticClass: "switch-input",
	    attrs: {
	      "id": "add-document",
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.document) ? _vm._i(_vm.document, null) > -1 : (_vm.document)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.document,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.document = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.document = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.document = $$c
	        }
	      }
	    }
	  }), _vm._m(6)])])]), (_vm.document) ? _c('backoffice-driver-license-create', {
	    on: {
	      "driverLicenseUpdated": _vm.setDriverLicenseFields
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('ClientExtraFields', {
	    attrs: {
	      "fields": _vm.body.extra
	    }
	  })], 1)]), _vm._m(7)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('h2', [_vm._v("Personal information")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row column"
	  }, [_c('hr'), _c('h2', [_vm._v("Residential Address")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "small-12 large-4 large-offset-3 columns"
	  }, [_c('label', [_vm._v("Is billing address the same as the residential address?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "switch-paddle",
	    attrs: {
	      "for": "yes-no"
	    }
	  }, [_c('span', {
	    staticClass: "switch-active",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("Yes")]), _c('span', {
	    staticClass: "switch-inactive",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("No")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('h2', [_vm._v("Billing address")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "small-12 large-4 large-offset-3 columns"
	  }, [_c('label', [_vm._v("Add document?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "switch-paddle",
	    attrs: {
	      "for": "add-document"
	    }
	  }, [_c('span', {
	    staticClass: "switch-active",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("Yes")]), _c('span', {
	    staticClass: "switch-inactive",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("No")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-center"
	  }, [_c('label', [_c('input', {
	    staticClass: "button",
	    attrs: {
	      "type": "submit"
	    }
	  })])])])
	}]}

/***/ }),
/* 2636 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2637 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-array-edit"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newName),
	      expression: "newName"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newName = $event.target.value
	      }
	    }
	  }), _c('div', {
	    staticClass: "input-group-button"
	  }, [_c('button', {
	    staticClass: "button fa fa-plus",
	    attrs: {
	      "disabled": !_vm.newName
	    },
	    on: {
	      "click": _vm.addField
	    }
	  })])]), (_vm.options !== null) ? _c('div', {
	    staticClass: "input-group"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newName),
	      expression: "newName"
	    }],
	    staticClass: "input-group-field",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.newName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_vm._l((_vm.options), function(groups) {
	    return _vm._l((groups), function(group, groupName) {
	      return _c('optgroup', {
	        key: groupName,
	        attrs: {
	          "label": groupName
	        }
	      }, [_vm._l((group), function(options) {
	        return _vm._l((options), function(item, key) {
	          return _c('option', {
	            domProps: {
	              "value": key
	            }
	          }, [_vm._v(_vm._s(item))])
	        })
	      })], 2)
	    })
	  })], 2), _c('div', {
	    staticClass: "input-group-button"
	  }, [_c('button', {
	    staticClass: "button fa fa-plus",
	    attrs: {
	      "disabled": !_vm.newName
	    },
	    on: {
	      "click": _vm.addField
	    }
	  })])]) : _vm._e(), _vm._l((_vm.values), function(value, label) {
	    return (typeof value !== 'undefined') ? _c('div', {
	      staticClass: "prop-item"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('span', {
	      staticClass: "input-group-label"
	    }, [_vm._v(_vm._s(label))]), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.values[label]),
	        expression: "values[label]"
	      }],
	      staticClass: "input-group-field",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.values[label])
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.values, label, $event.target.value)
	        }
	      }
	    }), _c('div', {
	      staticClass: "input-group-button"
	    }, [_c('button', {
	      staticClass: "button warning fa fa-times",
	      on: {
	        "click": function($event) {
	          return _vm.removeField(label)
	        }
	      }
	    })])])]) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 2638 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-create-note"
	  }, [_c('modal-reveal', {
	    ref: "modalAddNote",
	    attrs: {
	      "sizing": "tiny"
	    }
	  }, [_c('div', {
	    staticClass: "text-right",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle fa-2x"
	  })]), _c('NoteForm', {
	    on: {
	      "completed": _vm.createNote
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2639 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "add-vehicle-asset"
	  }, [_c('button', {
	    staticClass: "button small",
	    on: {
	      "click": function($event) {
	        _vm.addEnabled = !_vm.addEnabled
	      }
	    }
	  }, [_vm._v("Add Vehicle")]), (_vm.addEnabled) ? _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        _vm.addEnabled = false
	      }
	    }
	  }, [_vm._v("x")]), _c('label', [_vm._v("Booking Mode"), _c('BookingModeSelect', {
	    model: {
	      value: (_vm.bookingMode),
	      callback: function($$v) {
	        _vm.bookingMode = $$v
	      },
	      expression: "bookingMode"
	    }
	  })], 1), _c('label', [_vm._v("Select Vehicle"), _c('selectize-available-vehicle-slot', {
	    on: {
	      "optionSelected": _vm.selected
	    }
	  })], 1), _c('button', {
	    staticClass: "button",
	    class: {
	      disabled: !_vm.itemSelected || !_vm.bookingMode
	    },
	    on: {
	      "click": _vm.add
	    }
	  }, [_vm._v("Add")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2640 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-void"
	  }, [_c('reveal', {
	    attrs: {
	      "confirm": true
	    },
	    on: {
	      "confirm": _vm.refundTransaction
	    }
	  }, [(_vm.buttons) ? _c('a', {
	    staticClass: "button alert",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Refund")]) : _c('a', {
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Refund")]), _c('h2', [_vm._v("Do you really want to refund the transaction"), _c('strong', [_vm._v("TR" + _vm._s(_vm.transaction.id))])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "medium-6 columns"
	  }, [_c('label', [_vm._v("Amount"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.refundFields.amount),
	      expression: "refundFields.amount"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.refundFields.amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.refundFields, "amount", $event.target.value)
	      }
	    }
	  })])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2641 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'coupons'
	      }
	    }
	  }, [_vm._v("C" + _vm._s(_vm.item.id))])], 1), _c('div', {
	    staticClass: "field"
	  }, [_vm._v("Code:" + _vm._s(_vm.item.coupon.code))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'driver',
	        params: {
	          id: _vm.item.driver.id
	        }
	      }
	    }
	  }, [_vm._v("D" + _vm._s(_vm.item.driver.id))])], 1), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.driver.client_name))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.created))])]), (_vm.item.coupon.common_cost !== null) ? _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.coupon.common_cost.reason))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(_vm.item.coupon.common_cost.amount, _vm.item.coupon.common_cost.tax).toFixed(2))))])]) : _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Discount"), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.coupon.discount_rate) + "%")])])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v("Valid from")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.coupon.start))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v("Valid to")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.coupon.end))])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2642 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component reveal"
	  }, [_c('div', {
	    directives: [{
	      name: "f-nd",
	      rawName: "v-f-nd"
	    }],
	    staticClass: "reveal",
	    attrs: {
	      "id": _vm.id,
	      "data-reveal": "data-reveal",
	      "data-options": _vm.options
	    }
	  }, [_vm._m(0), _vm._t("default")], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close-button",
	    attrs: {
	      "data-close": "",
	      "aria-label": "Close modal",
	      "type": "button"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 2643 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-void"
	  }, [_c('ModalReveal', [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Billed Records")]), _c('div', {
	    staticClass: "header",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('h2', [_vm._v("Records  "), _c('strong', [_vm._v("INV" + _vm._s(_vm.invoice.internal_id) + "(" + _vm._s(_vm.invoice.id) + ")")])])]), _c('BilledRecords', {
	    attrs: {
	      "item": _vm.invoice
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2644 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabs"
	  }, [_c('ul', {
	    staticClass: "tabs",
	    attrs: {
	      "id": 'tabs-' + _vm._uid,
	      "data-tabs": ""
	    }
	  }, _vm._l((_vm.tabs), function(tab, index) {
	    return _c('li', {
	      staticClass: "tabs-title"
	    }, [_c('router-link', {
	      attrs: {
	        "to": {
	          name: tab.name,
	          params: {
	            id: _vm.$route.params.id
	          }
	        },
	        "aria-selected": tab.pathName === _vm.$route.meta.name
	      }
	    }, [_vm._v(_vm._s(tab.headerName))])], 1)
	  }), 0), _c('div', {
	    staticClass: "tabs-content",
	    attrs: {
	      "data-tabs-content": _vm.$route.meta.name
	    }
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2645 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reject-driver-request-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('CashInPreauthReveal', {
	    attrs: {
	      "preauth": _vm.item
	    }
	  }), _c('ActionButton', {
	    attrs: {
	      "action": _vm.refresh,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("Refresh")]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.cancelPreauth,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("Cancel")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2646 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.entity) ? _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [(_vm.item && _vm.canDo) ? _c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "dropdown menu",
	    attrs: {
	      "data-dropdown-menu": ""
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#Item-1"
	    }
	  }, [_vm._v("Action")]), _c('ul', {
	    staticClass: "menu"
	  }, [(_vm.canApprove) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.approve
	    }
	  }, [_vm._v("Approve")])]) : _vm._e(), (_vm.canReactivate) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.reactivate
	    }
	  }, [_vm._v("Reactivate")])]) : _vm._e(), (_vm.canSuspend) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.suspend
	    }
	  }, [_vm._v("Suspend")])]) : _vm._e(), (_vm.canDelete) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.deleteDriver
	    }
	  }, [_vm._v("Delete")])]) : _vm._e(), (_vm.canEdit) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Edit")])]) : _vm._e(), (_vm.canResetPassword) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.setNewPassword
	    }
	  }, [_vm._v("Set new Password")])]) : _vm._e(), (_vm.canSendResetPassword) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.sendPasswordResetEmail
	    }
	  }, [_vm._v("Request password reset")])]) : _vm._e(), _c('li', [_c('AddDriverFlagReveal', {
	    attrs: {
	      "item": _vm.entity
	    }
	  })], 1)])])]) : (_vm.canDo) ? _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [(_vm.canApprove) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.approve
	    }
	  }, [_vm._v("Approve")]) : _vm._e(), (_vm.canReactivate) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.reactivate
	    }
	  }, [_vm._v("Reactivate")]) : _vm._e(), (_vm.canSuspend) ? _c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.suspend
	    }
	  }, [_vm._v("Suspend")]) : _vm._e(), (_vm.canDelete) ? _c('button', {
	    staticClass: "button alert",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.deleteDriver
	    }
	  }, [_vm._v("Delete")]) : _vm._e()]) : (_vm.pendingDelete) ? _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.deleteClientAccount,
	      "confirm": true
	    }
	  }, [_vm._v("Delete client account")])], 1) : _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('p', [_vm._v("No actions available")])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2647 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-topup"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Top Ups")])]), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "resultsPerPage": 5,
	      "componentType": "client-invoices"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2648 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "asset-management-action-buttons"
	  }, [_c('div', {
	    staticClass: "button-group small"
	  }, [_c('swap-asset', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "processSwap": _vm.processSwap
	    }
	  }), _c('move-asset', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "assetMoved": _vm.assetMoved
	    }
	  }), _c('router-link', {
	    staticClass: "button button-small warning",
	    attrs: {
	      "to": {
	        name: 'operations',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_vm._v("Drain")]), _c('div', {
	    staticClass: "button alert small alert-text",
	    on: {
	      "click": _vm.dismiss
	    }
	  }, [_vm._v("Dismiss")])], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2649 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "disabled": _vm.disabled,
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Parking lot"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2650 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-1"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.recipient_id))]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: _vm.item.recipient_type.toLowerCase(),
	        params: {
	          id: _vm.item.recipient_id
	        }
	      }
	    }
	  }, [_c('div', {
	    staticClass: "field"
	  }, [(_vm.item.recipient_type === 'Client') ? _c('a', {
	    staticClass: "fa fa-user-circle-o"
	  }) : _vm._e(), (_vm.item.recipient_type === 'Driver') ? _c('a', {
	    staticClass: "fa fa-drivers-license-o"
	  }) : _vm._e()])])], 1), _c('div', {
	    staticClass: "columns large-4"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.type))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v("sent at: " + _vm._s(_vm.item.date))])]), _c('div', {
	    staticClass: "columns large-7"
	  }, [_c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.getStrippedMessage())), _c('ModalReveal', [_c('a', {
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("show all")]), _vm._l((_vm.item.message), function(im, k) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "columns flex0"
	    }, [_vm._v(_vm._s(k) + ":")]), _c('div', {
	      staticClass: "columns"
	    }, [_vm._v(_vm._s(im))])])
	  })], 2)], 1)])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2651 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-credit-records"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.type) + " Credit")]), (_vm.expanded) ? _c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addCredit = !_vm.addCredit
	      }
	    },
	    slot: "action"
	  }) : _vm._e(), _c('i', {
	    staticClass: "fa fa-2x",
	    class: {
	      'fa-eye-slash': _vm.expanded, 'fa-eye': !_vm.expanded
	    },
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": function($event) {
	        _vm.expanded = !_vm.expanded
	      }
	    },
	    slot: "action"
	  })]), (_vm.addCredit) ? _c('div', {
	    staticClass: "add-credit"
	  }, [_c('label', [_vm._v("Amount"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.amount),
	      expression: "body.amount"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.body.amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "amount", $event.target.value)
	      }
	    }
	  })]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.addNewCredit
	    }
	  }, [_vm._v("Add Credit")])], 1) : _vm._e(), (_vm.expanded) ? _c('base-list', {
	    ref: "listCr",
	    attrs: {
	      "component": _vm.component,
	      "search": _vm.search,
	      "dataLoader": _vm.dataLoader,
	      "resultsPerPage": 5
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2652 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('CommonCostButtonModal', {
	    attrs: {
	      "cost": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('button', {
	    staticClass: "button"
	  }, [_vm._v("Edit")])])]), _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true
	    }
	  }, [_vm._v("Delete")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2653 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-driver-reservation-request"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }) : _vm._e(), (_vm.$is('reservation')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('PreauthButtons', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("PR" + _vm._s(_vm.item.id))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Amount")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount)))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Process on")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.process_on))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Expiry")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.expiry))])])])]) : _vm._e()])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2654 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component component-backoffice-card"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('cardN', {
	    attrs: {
	      "showBullets": true,
	      "showAction": true,
	      "columns": 5
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "actionBullets"
	    },
	    slot: "actionBullets"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('card-action-buttons', {
	    attrs: {
	      "card": _vm.item
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_vm._v(_vm._s(_vm.item.name)), _c('p', [_vm._v(_vm._s(_vm.item.id) + " " + _vm._s(_vm.item.uid))])]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('driver', {
	    attrs: {
	      "type": 'oneLook',
	      "item": _vm.item.driver
	    }
	  })], 1), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_vm._v(_vm._s(_vm.item.chip_id))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_vm._v(_vm._s(_vm.item.enabled))]), _c('div', {
	    staticClass: "field-value",
	    attrs: {
	      "slot": "n5"
	    },
	    slot: "n5"
	  }, [_vm._v(_vm._s(_vm.item.id) + " " + _vm._s(_vm.item.uid))])])], 1)])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2655 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-role-edit"
	  }, [_c('div', {
	    staticClass: "row column card pt-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Role Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.role.name),
	      expression: "role.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.role.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.role, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Role Description"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.role.description),
	      expression: "role.description"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.role.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.role, "description", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Permissions"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.role.menu),
	      expression: "role.menu"
	    }],
	    attrs: {
	      "multiple": "multiple"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.role, "menu", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "menu_overview"
	    }
	  }, [_vm._v("Overview")]), _c('option', {
	    attrs: {
	      "value": "menu_todo"
	    }
	  }, [_vm._v("Todo's")]), _c('option', {
	    attrs: {
	      "value": "menu_customers"
	    }
	  }, [_vm._v("Customers")]), _c('option', {
	    attrs: {
	      "value": "menu_booking"
	    }
	  }, [_vm._v("Booking")]), _c('option', {
	    attrs: {
	      "value": "menu_billing"
	    }
	  }, [_vm._v("Billing")]), _c('option', {
	    attrs: {
	      "value": "menu_assets"
	    }
	  }, [_vm._v("Assets")]), _c('option', {
	    attrs: {
	      "value": "menu_support"
	    }
	  }, [_vm._v("Support")])])])])]), _c('div', {
	    staticClass: "row column"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2656 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-base-list"
	  }, [_c('p', {
	    staticClass: "text-center"
	  }, [_vm._v("Total results: " + _vm._s(_vm.data.items_count || _vm.data.items_count === 0 ? _vm.data.items_count : '...loading...'))]), (_vm.data.items_count > 0) ? _vm._t("before") : _vm._e(), _c('div', {
	    staticClass: "list-items"
	  }, [(_vm.data.items_count === 0) ? _c('h2', {
	    staticClass: "no-result-message text-center"
	  }, [_vm._v("Nothing to show here yet :(")]) : _vm._e(), (!_vm.data.items) ? _c('loading-spinner') : _vm._e(), (_vm.selectableList) ? _c('div', {
	    staticClass: "select-all"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectAll),
	      expression: "selectAll"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
	    },
	    on: {
	      "click": _vm.selectAllCheckboxes,
	      "change": function($event) {
	        var $$a = _vm.selectAll,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.selectAll = $$c
	        }
	      }
	    }
	  }), _c('label', [_vm._v("Select all")])]) : _vm._e(), _vm._l((_vm.data.items), function(item, i) {
	    return _c('div', {
	      key: item.id,
	      staticClass: "list-item",
	      class: {
	        'list-odd': i % 2, 'flex-list': _vm.selectableList
	      }
	    }, [(_vm.selectableList) ? _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selected),
	        expression: "selected"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": item.id,
	        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, item.id) > -1 : (_vm.selected)
	      },
	      on: {
	        "input": function($event) {
	          return _vm.checkboxChanged(i, $event.target)
	        },
	        "change": function($event) {
	          var $$a = _vm.selected,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = item.id,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.selected = $$c
	          }
	        }
	      }
	    }) : _vm._e(), _c(_vm.component, {
	      tag: "component",
	      attrs: {
	        "item": item,
	        "type": _vm.componentType,
	        "id": item.id
	      },
	      on: {
	        "itemUpdated": function($event) {
	          return _vm.loadData(1)
	        }
	      }
	    })], 1)
	  })], 2), _vm._t("after"), (_vm.showPerPageSelect) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.resultsPerPageSelect),
	      expression: "resultsPerPageSelect"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.resultsPerPageSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.setResultsPerPage]
	    }
	  }, [_c('option', [_vm._v("5")]), _c('option', [_vm._v("10")]), _c('option', [_vm._v("25")]), _c('option', [_vm._v("45")]), _c('option', [_vm._v("60")])])]), _c('div', {
	    staticClass: "column"
	  }, [_c('pagination', {
	    attrs: {
	      "results": _vm.data.items_count,
	      "perPage": _vm.data.per_page_count,
	      "currentPage": _vm.currentPage
	    },
	    on: {
	      "pageUpdated": _vm.loadData
	    }
	  })], 1)]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2657 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cards row gutter-small"
	  }, [(_vm.data.length === 0) ? _c('loading-spinner', {
	    staticClass: "column"
	  }) : _vm._e(), _vm._l((_vm.data), function(d) {
	    return _c('div', {
	      staticClass: "columns",
	      class: _vm.classes
	    }, [_c('div', {
	      staticClass: "card"
	    }, [_c('div', {
	      staticClass: "card-section"
	    }, [(d.callback) ? _c('a', {
	      class: d.callback.class,
	      on: {
	        "click": function($event) {
	          return d.callback.func()
	        }
	      }
	    }) : _vm._e(), _c('b', {
	      domProps: {
	        "innerHTML": _vm._s(d.title)
	      }
	    }), _c('h1', {
	      style: ({
	        color: d.color
	      }),
	      domProps: {
	        "innerHTML": _vm._s(d.value)
	      }
	    }), _c('div', {
	      staticClass: "content",
	      domProps: {
	        "innerHTML": _vm._s(d.extra)
	      }
	    })])])])
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 2658 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-tabbed-preauth-list"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false,
	      "component-type": _vm.reservation !== null ? 'reservation' : 'listing'
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2659 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.remove
	    }
	  }, [_vm._v("Delete")])])])
	},staticRenderFns: []}

/***/ }),
/* 2660 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-transaction-controller"
	  }, [_c('transaction', {
	    attrs: {
	      "item": _vm.item,
	      "type": 'detail'
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2661 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ("component-card-" + _vm.columns)
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row align-middle"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.columns), function(n) {
	    return _c('div', {
	      staticClass: "columns align-self-middle",
	      class: {
	        'shrink': _vm.shouldShrink('n' + n)
	      }
	    }, [_vm._t('n' + n)], 2)
	  }), 0)]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionPage")], 2) : _vm._e()]), _c('div', {
	    staticClass: "row"
	  }, [_vm._t("bottom")], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 2662 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "create-plan_rate-reservation-rates"
	  }, [_c('ModalReveal', {
	    ref: "revealPlanEdit"
	  }, [_c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [(_vm.plan_rate) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('h2', [_vm._v("Plan reservation rate")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan_rate.name),
	      expression: "plan_rate.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.plan_rate.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.plan_rate, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Vehicle Category"), _c('selectize-category', {
	    attrs: {
	      "selectedValue": _vm.plan_rate.vehicle_category_id
	    },
	    on: {
	      "optionSelected": _vm.selectCategory
	    }
	  })], 1), _c('label', [_vm._v("Reservation rate"), _c('selectize-reservation-rate', {
	    attrs: {
	      "selectedValue": _vm.plan_rate.reservation_rate_id
	    },
	    on: {
	      "optionSelected": _vm.selectRate
	    }
	  })], 1), _c('label', [_vm._v("Disabled"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.plan_rate.disabled),
	      expression: "plan_rate.disabled"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.plan_rate.disabled) ? _vm._i(_vm.plan_rate.disabled, null) > -1 : (_vm.plan_rate.disabled)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.plan_rate.disabled,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.plan_rate, "disabled", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.plan_rate, "disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.plan_rate, "disabled", $$c)
	        }
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-right"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.savePlanRate
	    }
	  }, [_vm._v("Save")])], 1)])])]) : _vm._e()])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2663 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-action-button"
	  }, [_c('ModalReveal', {
	    ref: "prompt"
	  }, [_vm._t("prompt"), _c('div', {
	    staticClass: "row columns",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": _vm.disabled || _vm.spin
	    },
	    on: {
	      "click": _vm.callAction
	    }
	  }, [(_vm.spin) ? _c('span', {
	    staticClass: "fa fa-spinner fa-spin",
	    class: {
	      spin: _vm.spin
	    }
	  }) : _c('span', [_vm._v("Save")])])])], 2), _c('button', {
	    staticClass: "action-button",
	    class: {
	      colorClass: _vm.colorClass, button: _vm.button
	    },
	    attrs: {
	      "disabled": _vm.disabled || _vm.spin
	    },
	    on: {
	      "click": _vm.call
	    }
	  }, [(_vm.spin) ? _c('span', {
	    staticClass: "fa fa-spinner fa-spin",
	    class: {
	      spin: _vm.spin
	    }
	  }) : _vm._t("default")], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2664 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    key: _vm.key,
	    ref: "commonCostModal",
	    on: {
	      "input": _vm.closeInput
	    }
	  }, [_vm._t("default", [_c('a', {
	    staticClass: "fa-stack fa-lg"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })])], {
	    "slot": "trigger"
	  }), _c('div', {
	    staticClass: "body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Reason"), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reason),
	      expression: "body.reason"
	    }],
	    domProps: {
	      "value": (_vm.body.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "reason", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Type"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.common_cost_type_id),
	      expression: "body.common_cost_type_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "common_cost_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.commonCostTypes), function(costType) {
	    return _c('option', {
	      domProps: {
	        "value": costType.id
	      }
	    }, [_vm._v(_vm._s(costType.name))])
	  }), 0)])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Tax"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.tax),
	      expression: "body.tax"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "tax", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.vats), function(vat) {
	    return _c('option', {
	      domProps: {
	        "value": vat.percentage / 100
	      }
	    }, [_vm._v(_vm._s(vat.description) + " (" + _vm._s(vat.name) + " " + _vm._s(vat.percentage) + "%)")])
	  }), 0)]), _c('label', [_vm._v("Add as a debit amount?")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isDebit),
	      expression: "isDebit"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "value": _vm.isChecked,
	      "checked": Array.isArray(_vm.isDebit) ? _vm._i(_vm.isDebit, _vm.isChecked) > -1 : (_vm.isDebit)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isDebit,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = _vm.isChecked,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isDebit = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isDebit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isDebit = $$c
	        }
	      }
	    }
	  })]), _c('div', {
	    staticClass: "column"
	  }, [_c('VatAmountToggler', {
	    attrs: {
	      "label": "Amount",
	      "tax": _vm.body.tax
	    },
	    model: {
	      value: (_vm.body.amount),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "amount", $$v)
	      },
	      expression: "body.amount"
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row columns",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2665 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-instruction-step"
	  }, [_c('div', {
	    staticClass: "steps"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-4 small-12"
	  }, [_c('label', [_vm._v("Step Type"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.step.type),
	      expression: "step.type"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.step, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.$emit('resetValue')
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "html"
	    }
	  }, [_vm._v("html")]), _c('option', {
	    attrs: {
	      "value": "youtube"
	    }
	  }, [_vm._v("youtube")]), _c('option', {
	    attrs: {
	      "value": "image"
	    }
	  }, [_vm._v("Image")]), _c('option', {
	    attrs: {
	      "value": "linked_image"
	    }
	  }, [_vm._v("Linked image")])])])]), _c('div', {
	    staticClass: "columns large-8 small-12"
	  }, [(_vm.step.type === 'html') ? _c('div', {
	    staticClass: "editor"
	  }, [_c('label', [_vm._v("Description")]), _c('Editor', {
	    attrs: {
	      "value": _vm.step.value
	    },
	    model: {
	      value: (_vm.step.value),
	      callback: function($$v) {
	        _vm.$set(_vm.step, "value", $$v)
	      },
	      expression: "step.value"
	    }
	  })], 1) : (_vm.step.type === 'youtube') ? _c('label', [_vm._v("Youtube embed url"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.step.value),
	      expression: "step.value"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.step.value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.step, "value", $event.target.value)
	      }
	    }
	  })]) : (_vm.step.type === 'image') ? _c('div', {
	    staticClass: "uploader"
	  }, [_c('KeplerFileUpload', {
	    attrs: {
	      "selected-prefix": "vehicle-instructions",
	      "previewUrl": _vm.step.value,
	      "selected-visibility": "public"
	    },
	    on: {
	      "sel": function($event) {
	        return _vm.handleFileSelector($event, _vm.step.type)
	      }
	    }
	  })], 1) : (_vm.step.type === 'linked_image') ? _c('div', {
	    staticClass: "uploader"
	  }, [_c('label', [_vm._v("URL")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.step.image_link),
	      expression: "step.image_link"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.step.image_link)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.step, "image_link", $event.target.value)
	      }
	    }
	  }), _c('KeplerFileUpload', {
	    attrs: {
	      "selected-prefix": "vehicle-instructions",
	      "previewUrl": _vm.step.image_url,
	      "selected-visibility": "public"
	    },
	    on: {
	      "sel": function($event) {
	        return _vm.handleFileSelector($event, _vm.step.type)
	      }
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "text-right",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('button', {
	    staticClass: "button small warning",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('remove')
	      }
	    }
	  }, [_vm._v("Remove")])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2666 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-plan-subscriber"
	  }, [_vm._v(" Add a subscription (Client " + _vm._s(_vm.client_id) + "):"), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column large-4 align-right"
	  }, [_c('label', [_vm._v("Also show unavailables  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.unavailable),
	      expression: "unavailable"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "checked": "false"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.unavailable) ? _vm._i(_vm.unavailable, null) > -1 : (_vm.unavailable)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.unavailable,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.unavailable = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.unavailable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.unavailable = $$c
	        }
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selected_plan),
	      expression: "selected_plan"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selected_plan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.getPlans()), function(plan, index) {
	    return _c('option', {
	      domProps: {
	        "value": plan.id
	      }
	    }, [_vm._v(_vm._s(plan.name))])
	  }), 0)]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Free subscription"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.free_subscription),
	      expression: "free_subscription"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "checked": "true"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.free_subscription) ? _vm._i(_vm.free_subscription, null) > -1 : (_vm.free_subscription)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.free_subscription,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.free_subscription = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.free_subscription = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.free_subscription = $$c
	        }
	      }
	    }
	  })]), _c('label', [_vm._v("Subscribe main driver"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subscribe_main_driver),
	      expression: "subscribe_main_driver"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "checked": "true"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.subscribe_main_driver) ? _vm._i(_vm.subscribe_main_driver, null) > -1 : (_vm.subscribe_main_driver)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.subscribe_main_driver,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.subscribe_main_driver = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.subscribe_main_driver = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.subscribe_main_driver = $$c
	        }
	      }
	    }
	  })])])]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.subscribe
	    }
	  }, [_vm._v("Subscribe")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2667 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reservation-requests"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('ModalReveal', {
	    ref: _vm.modal
	  }, [_c('a', {
	    attrs: {
	      "slot": "trigger"
	    },
	    on: {
	      "click": _vm.search
	    },
	    slot: "trigger"
	  }, [_vm._v("Create Booking")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('Driver', {
	    attrs: {
	      "item": _vm.item.driver,
	      "type": "driver-card"
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Dates")]), _c('div', [_vm._v("From: " + _vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMM YYYY HH:mm')) + " - " + _vm._s(_vm.item.pick_up.name))]), _c('div', [_vm._v("To: " + _vm._s(_vm.$dateFormat(_vm.item.end, 'DD MMM YYYY HH:mm')) + "  - " + _vm._s(_vm.item.drop_off.name))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Passengers")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.flags.passengers))]), (_vm.item.flags.hasOwnProperty('luxury')) ? [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Luxury")]), _c('div', {
	    staticClass: "value"
	  }, [_c('span', {
	    staticClass: "fa",
	    class: {
	      "fa-times": !_vm.item.flags.luxury, "fa-check": _vm.item.flags.luxury
	    }
	  })])] : _vm._e()], 2), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Offroad")]), _c('span', {
	    staticClass: "fa",
	    class: {
	      "offroad": _vm.item.flags.offroad, "fa-times": !_vm.item.flags.offroad, "fa-check": _vm.item.flags.offroad
	    }
	  }), (_vm.item.flags.hasOwnProperty('estimated_distance')) ? [_c('label', [_vm._v("Estimated distance")]), _c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.item.flags.estimated_distance))])] : _vm._e()], 2)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Notes")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.notes))])])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("Select the vehicle")]), (_vm.slots.length === 0 && !_vm.loading) ? [_c('h2', {
	    staticClass: "text-center"
	  }, [_vm._v("No available vehicles")])] : _vm._e(), _vm._l((_vm.slots), function(vehicle, id) {
	    return (!vehicle.disabled) ? _c('vehicle', {
	      key: id,
	      attrs: {
	        "item": vehicle,
	        "type": "search-result"
	      },
	      on: {
	        "bookVehicle": _vm.bookNow
	      }
	    }) : _vm._e()
	  })], 2)])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2668 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-9"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle show-for-medium"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns n1 large-2 small-12"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns n2 align-self-middle small-12 medium-6 large-2"
	  }, [_vm._t("n2")], 2), _c('div', {
	    staticClass: "columns n3 align-self-middle small-6 large-1"
	  }, [_vm._t("n3")], 2), _c('div', {
	    staticClass: "columns n4 align-self-middle small-6 large-1"
	  }, [_vm._t("n4")], 2), _c('div', {
	    staticClass: "columns n5 align-self-middle small-6 large-1"
	  }, [_vm._t("n5")], 2), _c('div', {
	    staticClass: "columns n6 align-self-middle large-1"
	  }, [_vm._t("n6")], 2), _c('div', {
	    staticClass: "columns n7 align-self-middle large-1"
	  }, [_vm._t("n7")], 2), _c('div', {
	    staticClass: "columns n8 align-self-middle small-12 large-1"
	  }, [_vm._t("n8")], 2), _c('div', {
	    staticClass: "columns n9 align-self-middle large-2"
	  }, [_vm._t("n9")], 2)])]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle show-for-medium"
	  }, [_vm._t("actionPage")], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2669 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-8"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns n1 align-self-middle"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns n2 align-self-middle"
	  }, [_vm._t("n2")], 2), _c('div', {
	    staticClass: "columns n3 align-self-middle"
	  }, [_vm._t("n3")], 2), _c('div', {
	    staticClass: "columns n4 align-self-middle"
	  }, [_vm._t("n4")], 2), _c('div', {
	    staticClass: "columns n5 align-self-middle"
	  }, [_vm._t("n5")], 2), _c('div', {
	    staticClass: "columns n6 align-self-middle"
	  }, [_vm._t("n6")], 2), _c('div', {
	    staticClass: "columns n7 align-self-middle"
	  }, [_vm._t("n7")], 2), _c('div', {
	    staticClass: "columns n8 align-self-middle"
	  }, [_vm._t("n8")], 2)])]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionPage")], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2670 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-plan"
	  }, [(_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.options) ? _c('selectize', {
	    attrs: {
	      "value": _vm.value,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Cost",
	      "allowEmptyOption": _vm.allowEmptyOption,
	      "selectedValue": _vm.selectedValue
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2671 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-7"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((7), function(n) {
	    return _c('div', {
	      staticClass: "columns align-self-middle",
	      class: {
	        'shrink': _vm.shouldShrink('n' + n)
	      }
	    }, [_vm._t('n' + n)], 2)
	  }), 0)]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionPage")], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2672 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-6"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns n1 align-self-middle"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns n2 align-self-middle"
	  }, [_vm._t("n2")], 2), _c('div', {
	    staticClass: "columns n3 align-self-middle"
	  }, [_vm._t("n3")], 2), _c('div', {
	    staticClass: "columns n4 align-self-middle"
	  }, [_vm._t("n4")], 2), _c('div', {
	    staticClass: "columns n5 align-self-middle"
	  }, [_vm._t("n5")], 2), _c('div', {
	    staticClass: "columns n6 align-self-middle"
	  }, [_vm._t("n6")], 2)])]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionPage")], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2673 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-5"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns n1 align-self-middle"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns n2 align-self-middle"
	  }, [_vm._t("n2")], 2), _c('div', {
	    staticClass: "columns n3 align-self-middle"
	  }, [_vm._t("n3")], 2), _c('div', {
	    staticClass: "columns n4 align-self-middle"
	  }, [_vm._t("n4")], 2), _c('div', {
	    staticClass: "columns n5 align-self-middle"
	  }, [_vm._t("n5")], 2)])]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionPage")], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2674 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-4"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns n1"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns n2"
	  }, [_vm._t("n2")], 2), _c('div', {
	    staticClass: "columns n3"
	  }, [_vm._t("n3")], 2), _c('div', {
	    staticClass: "columns n4"
	  }, [_vm._t("n4")], 2)])]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionPage")], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2675 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-card-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.showBullets) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns n1 align-self-middle"
	  }, [_vm._t("n1")], 2), _c('div', {
	    staticClass: "columns n2 align-self-middle"
	  }, [_vm._t("n2")], 2), _c('div', {
	    staticClass: "columns n3 align-self-middle"
	  }, [_vm._t("n3")], 2)])]), (_vm.showAction) ? _c('div', {
	    staticClass: "columns shrink align-self-middle"
	  }, [_vm._t("actionPage")], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 2676 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-vehicle-status"
	  }, [(_vm.showToolTip) ? _c('div', {
	    staticClass: "row align-middle align-center"
	  }, [(_vm.odometer) ? _c('tooltip', {
	    staticClass: "has-tip",
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": ("Odometer: " + (_vm.item.odometer) + (_vm.configuration.locale.locale_distance_unit.value))
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-dashboard fa-lg"
	  }), _c('span', {
	    staticClass: "label fuelStatus"
	  }, [_vm._v(_vm._s(_vm.item.odometer) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])]) : _vm._e(), _c('tooltip', {
	    staticClass: "has-tip",
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Fuel type: ' + _vm.item.fuel_type
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-bolt fa-lg",
	    class: _vm.fuelLevel()
	  }), _c('span', {
	    staticClass: "label fuelStatus"
	  }, [_vm._v(_vm._s(_vm.fuelStatus()))])]), _c('tooltip', {
	    staticClass: "has-tip",
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Door: ' + _vm.item.door_status
	    }
	  }, [_c('span', {
	    class: _vm.doorStatus(_vm.item.door_status)
	  })]), _c('tooltip', {
	    staticClass: "has-tip",
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Engine: ' + _vm.item.engine_status
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-car fa-lg",
	    class: _vm.status(_vm.item.engine_status)
	  })]), _c('tooltip', {
	    staticClass: "has-tip",
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": _vm.item.vehicle_slot_hidden ? 'Hidden on map' : 'Visible on map'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-lg",
	    class: _vm.visibility(_vm.item.vehicle_slot_hidden)
	  })]), _c('span', {
	    staticClass: "has-tip"
	  }, [_c('span', {
	    staticClass: "fa fa-product-hunt fa-lg",
	    class: _vm.inRange(),
	    on: {
	      "click": _vm.openDetail
	    }
	  })])], 1) : _vm._e(), (_vm.showDetail) ? _c('div', {
	    staticClass: "position-detail"
	  }, [_c('div', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        _vm.showDetail = false
	      }
	    }
	  }, [_vm._v("x")]), _c('GoogleMapContainer', [_c('GoogleMap', {
	    attrs: {
	      "api-key": _vm.mapsAPI,
	      "center": {
	        lat: _vm.item.position.latitude,
	        lng: _vm.item.position.longitude
	      },
	      "zoom": 17,
	      "zoomControl": true
	    }
	  }, [_c('google-map-marker', {
	    key: _vm.item.plate,
	    attrs: {
	      "position": {
	        lat: _vm.item.position.latitude,
	        lng: _vm.item.position.longitude
	      },
	      "title": ((_vm.item.brand) + " " + (_vm.item.model)),
	      "label": ((_vm.item.brand) + " " + (_vm.item.model))
	    }
	  })], 1)], 1)], 1) : _vm._e(), (_vm.showToolTip === false) ? _c('div', {
	    staticClass: "row align-middle align-center"
	  }, [_c('span', {
	    staticClass: "fa fa-dashboard fa-lg"
	  }), _c('span', {
	    staticClass: "label fuelStatus"
	  }, [_vm._v(_vm._s(_vm.item.odometer) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))]), _c('span', {
	    staticClass: "fa fa-bolt fa-lg",
	    class: _vm.fuelLevel()
	  }), _c('span', {
	    staticClass: "label fuelStatus"
	  }, [_vm._v(_vm._s(_vm.fuelStatus()))]), _c('span', {
	    class: _vm.doorStatus(_vm.item.door_status)
	  }), _c('span', {
	    staticClass: "fa fa-car fa-lg",
	    class: _vm.status(_vm.item.engine_status)
	  })]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2677 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-ranger-picker"
	  }, [_c('VueCtkRangeDatePicker', {
	    attrs: {
	      "format": _vm.format,
	      "label": _vm.label,
	      "range": true,
	      "noLabel": true,
	      "noHeader": false,
	      "color": "#5EB9CF",
	      "formatted": "ll"
	    },
	    model: {
	      value: (_vm.internalValue),
	      callback: function($$v) {
	        _vm.internalValue = $$v
	      },
	      expression: "internalValue"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2678 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.mounted) ? _c('div', {
	    staticClass: "component-dropdown"
	  }, [_c('div', {
	    staticClass: "dropdown-placeholder",
	    attrs: {
	      "data-toggle": 'dropdown-' + _vm._uid
	    }
	  }, [_vm._t("placeholder", [_c('i', {
	    class: _vm.icon
	  })])], 2), _c('div', {
	    directives: [{
	      name: "f-dropdown",
	      rawName: "v-f-dropdown"
	    }],
	    staticClass: "dropdown-pane",
	    class: _vm.position,
	    attrs: {
	      "data-close-on-click": "true",
	      "id": 'dropdown-' + _vm._uid,
	      "data-auto-focus": "true",
	      "data-dropdown": ""
	    }
	  }, [_vm._t("default")], 2)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2679 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-attributes"
	  }, [_c('div', {
	    staticClass: "attributes-list"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('selectize-vehicle-attribute', {
	    staticClass: "input-group-field",
	    on: {
	      "optionSelected": _vm.updateAttributes
	    }
	  }), _c('div', {
	    staticClass: "input-group-button"
	  }, [_c('button', {
	    staticClass: "button fa fa-plus",
	    on: {
	      "click": _vm.addAttribute
	    }
	  })])], 1)])])]), _c('div', {
	    staticClass: "container"
	  }, _vm._l((_vm.value), function(attribute, index) {
	    return _c('div', {
	      staticClass: "prop-item"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('span', {
	      staticClass: "input-group-label"
	    }, [_vm._v(_vm._s(attribute.name))]), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (attribute.value),
	        expression: "attribute.value"
	      }],
	      staticClass: "input-group-field",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (attribute.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(attribute, "value", $event.target.value)
	        }
	      }
	    }), _c('div', {
	      staticClass: "input-group-button"
	    }, [_c('button', {
	      staticClass: "button default save",
	      attrs: {
	        "disabled": _vm.value[index].value == null || _vm.value[index].value == '' || _vm.disabled || _vm.spin
	      },
	      on: {
	        "click": function($event) {
	          return _vm.saveAttribute(attribute)
	        }
	      }
	    }, [(_vm.spin) ? _c('span', {
	      staticClass: "fa fa-spinner fa-spin",
	      class: {
	        spin: _vm.spin
	      }
	    }) : _c('span', {
	      staticClass: "fa fa-save"
	    })]), _c('button', {
	      staticClass: "button warning fa",
	      attrs: {
	        "disabled": _vm.disabled || _vm.spin
	      },
	      on: {
	        "click": function($event) {
	          return _vm.removeAttribute(index)
	        }
	      }
	    }, [(_vm.spin) ? _c('span', {
	      staticClass: "fa fa-spinner fa-spin",
	      class: {
	        spin: _vm.spin
	      }
	    }) : _c('span', {
	      staticClass: "fa fa-times"
	    })])])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2680 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.entity) ? _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [(_vm.item && _vm.canDo) ? _c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "dropdown menu",
	    attrs: {
	      "data-dropdown-menu": ""
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#Item-1"
	    }
	  }, [_vm._v("Action")]), _c('ul', {
	    staticClass: "menu"
	  }, [(_vm.canActivate) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.activate
	    }
	  }, [_vm._v("Activate")])]) : _vm._e(), (_vm.canSuspend) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.suspend
	    }
	  }, [_vm._v("Suspend")])]) : _vm._e(), (_vm.canDelete) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.deleteClient
	    }
	  }, [_vm._v("Delete")])]) : _vm._e(), (_vm.canEdit) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Edit")])]) : _vm._e(), (_vm.canDump) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.dump
	    }
	  }, [_vm._v("Dump Data")])]) : _vm._e(), _c('li', [_c('registration-token-reveal', {
	    attrs: {
	      "item": _vm.entity
	    }
	  })], 1)])])]) : (_vm.canDo) ? _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [(_vm.canActivate) ? _c('button', {
	    staticClass: "button success",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.activate
	    }
	  }, [_vm._v("Activate")]) : _vm._e(), (_vm.canSuspend) ? _c('button', {
	    staticClass: "button warning",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.suspend
	    }
	  }, [_vm._v("Suspend")]) : _vm._e(), (_vm.canDelete) ? _c('button', {
	    staticClass: "button alert",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.deletec
	    }
	  }, [_vm._v("Delete")]) : _vm._e()]) : _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('p', [_vm._v("No actions available")])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2681 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('payment-method-id')) ? _c('div', {
	    staticClass: "field-payment-method-id"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("ID")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.id) + " " + _vm._s(_vm.item.uid))])]) : (_vm.$is('payment-method-name')) ? _c('div', {
	    staticClass: "field-payment-method-id"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Payment method Name")]), _c('div', {
	    staticClass: "field-value"
	  }, [_c('a', {
	    on: {
	      "click": _vm.viewPMOnGateway
	    }
	  }, [_vm._v(_vm._s(_vm.item.name))])])]) : (_vm.$is('payment-method-provider')) ? _c('div', {
	    staticClass: "field-payment-method-id"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Provider")]), _c('div', {
	    staticClass: "field-value"
	  }, [_c('a', {
	    on: {
	      "click": _vm.viewClientOnGateway
	    }
	  }, [_vm._v(_vm._s(_vm.item.provider))])])]) : (_vm.$is('payment-method-created')) ? _c('div', {
	    staticClass: "field-payment-method-id"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, "DD/MM/YYYY hh:mm")))])]) : (_vm.$is('payment-method-updated')) ? _c('div', {
	    staticClass: "field-payment-method-id"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Updated")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.updated, "DD/MM/YYYY hh:mm")))])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2682 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.remove,
	      "confirm": true,
	      "color-class": "warning"
	    }
	  }, [_vm._v("Delete")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2683 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-notification-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": true
	    }
	  }, [_c('header-columns', {
	    attrs: {
	      "slot": "before",
	      "columns": _vm.headers
	    },
	    slot: "before"
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2684 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "application"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "notification-panel"
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, _vm._l((_vm.notificationsStore.notifications), function(n, i) {
	    return _c('notification', {
	      key: n.title,
	      attrs: {
	        "notification": n
	      }
	    })
	  }), 1)], 1), (_vm.title && _vm.title != '') ? _c('div', {
	    staticClass: "upperBar"
	  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('router-view'), _c('div', {
	    attrs: {
	      "id": "global-modal-container"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2685 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-icon"
	  }, [(_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "iconName",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Icon"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2686 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.toc !== null) ? _c('div', {
	    staticClass: "component-create-plan"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Name")]), (_vm.$route.params.hasOwnProperty('id')) ? [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.toc._translatable.name,
	      "label": "Name",
	      "value": _vm.toc.name,
	      "editable": false
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toc.name),
	      expression: "toc.name"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.toc.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.toc, "name", $event.target.value)
	      }
	    }
	  })])] : [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toc.name),
	      expression: "toc.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.toc.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.toc, "name", $event.target.value)
	      }
	    }
	  })]], 2), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Toc Type"), _c('selectize-toc-type', {
	    attrs: {
	      "selectedValue": _vm.toc.toc_type.id
	    },
	    on: {
	      "optionSelected": _vm.setTocType
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Version"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toc.version),
	      expression: "toc.version"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.toc.version)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.toc, "version", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Required from"), _c('DatePicker', {
	    attrs: {
	      "initialDate": _vm.toc.required_from
	    },
	    model: {
	      value: (_vm.toc.required_from),
	      callback: function($$v) {
	        _vm.$set(_vm.toc, "required_from", $$v)
	      },
	      expression: "toc.required_from"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Optional")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toc.optional),
	      expression: "toc.optional"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.toc.optional) ? _vm._i(_vm.toc.optional, null) > -1 : (_vm.toc.optional)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.toc.optional,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.toc, "optional", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.toc, "optional", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.toc, "optional", $$c)
	        }
	      }
	    }
	  })]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Disabled")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toc.disabled),
	      expression: "toc.disabled"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.toc.disabled) ? _vm._i(_vm.toc.disabled, null) > -1 : (_vm.toc.disabled)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.toc.disabled,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.toc, "disabled", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.toc, "disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.toc, "disabled", $$c)
	        }
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Acceptance statement")]), (_vm.$route.params.hasOwnProperty('id')) ? [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.toc._translatable.acceptance_statement,
	      "label": "Acceptance statement",
	      "value": _vm.toc.acceptance_statement,
	      "editable": false
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toc.acceptance_statement),
	      expression: "toc.acceptance_statement"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.toc.acceptance_statement)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.toc, "acceptance_statement", $event.target.value)
	      }
	    }
	  })])] : [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toc.acceptance_statement),
	      expression: "toc.acceptance_statement"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.toc.acceptance_statement)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.toc, "acceptance_statement", $event.target.value)
	      }
	    }
	  })], _c('label', [_vm._v("External url"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toc.link),
	      expression: "toc.link"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.toc.link)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.toc, "link", $event.target.value)
	      }
	    }
	  })])], 2), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Priority"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.toc.priority),
	      expression: "toc.priority"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.toc.priority)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.toc, "priority", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Attachment")]), _c('KeplerFileUpload', {
	    attrs: {
	      "selected-prefix": "tocs",
	      "selected-visibility": "public",
	      "preview-url": _vm.toc.attachment
	    },
	    on: {
	      "sel": _vm.handleFileSelector
	    }
	  }), _c('TocAttachmentTranslationReveal', {
	    staticClass: "mt-3",
	    model: {
	      value: (_vm.toc.attachment_translations),
	      callback: function($$v) {
	        _vm.$set(_vm.toc, "attachment_translations", $$v)
	      },
	      expression: "toc.attachment_translations"
	    }
	  })], 1)]), _vm._m(0), _c('div', {
	    staticClass: "row columns"
	  }, [(!_vm.$route.params.hasOwnProperty('id')) ? [_c('label', [_vm._v("Content")])] : [_c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.toc._translatable.content,
	      "label": "Content",
	      "value": _vm.toc.content,
	      "editor": true,
	      "editable": false
	    }
	  })], _c('Editor', {
	    model: {
	      value: (_vm.toc.content),
	      callback: function($$v) {
	        _vm.$set(_vm.toc, "content", $$v)
	      },
	      expression: "toc.content"
	    }
	  }), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.createToc
	    }
	  }, [_vm._v("Save")])], 2)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  })])
	}]}

/***/ }),
/* 2687 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.status) ? _c('span', {
	    staticClass: "component-status statuslight",
	    class: 'status-' + _vm.status
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2688 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('UserButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('status', {
	    attrs: {
	      "status": _vm.item.enabled ? 'ACTIVE' : 'PENDING_REVIEW'
	    }
	  }), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("U" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.username))])], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Federation")]), (_vm.item.federation !== null) ? _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.federation.name))]) : _vm._e()]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Email")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.email))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Role")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.roles.map(function (u) { return u.name; }).join(', ')))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.created_at))])]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'user',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2689 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-role"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("RL" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Description")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.description))])]), _c('div', {
	    staticClass: "column shrink align-self-middle"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'role',
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right fa-3x action"
	  })])], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 2690 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-quick-search",
	    on: {
	      "focusout": _vm.handleFocusout
	    }
	  }, [_c('a', {
	    staticClass: "fa-stack fa-lg",
	    on: {
	      "click": function($event) {
	        _vm.searchOpen = !_vm.searchOpen
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-search fa-stack-1x fa-inverse"
	  })]), (_vm.searchOpen) ? [_c('div', {
	    staticClass: "search-container"
	  }, [_c('div', {
	    staticClass: "search mt-2 card"
	  }, [_c('SearchEntity', {
	    staticClass: "mb-1",
	    attrs: {
	      "entity": "clients"
	    },
	    on: {
	      "selected": function($event) {
	        return _vm.gotoEntity($event, 'clients')
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(result) {
	        return [_c('div', {
	          staticClass: "quick-search-result"
	        }, [_c('div', [_c('small', [_vm._v("CL" + _vm._s(result.result.id))]), _c('div', [_vm._v(_vm._s(result.result.name) + " " + _vm._s(result.result.surname))]), (result.result.organization_name) ? _c('div', [_c('small', [_vm._v(_vm._s(result.result.organization_name))])]) : _vm._e(), _c('div', [_c('small', [_vm._v(_vm._s(result.result.phone))])])])])]
	      }
	    }], null, false, 2676815204)
	  }), _c('SearchEntity', {
	    staticClass: "mb-1",
	    attrs: {
	      "entity": "drivers"
	    },
	    on: {
	      "selected": function($event) {
	        return _vm.gotoEntity($event, 'drivers')
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(result) {
	        return [_c('div', {
	          staticClass: "quick-search-result"
	        }, [_c('div', [_c('small', [_vm._v("DR" + _vm._s(result.result.id))]), _c('div', [_vm._v(_vm._s(result.result.name) + " " + _vm._s(result.result.surname))]), _c('small', [_vm._v(_vm._s(result.result.mobile))])])])]
	      }
	    }], null, false, 2353354591)
	  }), _c('SearchEntity', {
	    staticClass: "mb-1",
	    attrs: {
	      "entity": "reservations"
	    },
	    on: {
	      "selected": function($event) {
	        return _vm.gotoEntity($event, 'reservations')
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(result) {
	        return [_c('div', {
	          staticClass: "quick-search-result"
	        }, [_c('span', [_vm._v("R" + _vm._s(result.result.id))]), _c('span', [_vm._v(_vm._s(result.result.status))]), _c('small', [_vm._v(_vm._s(_vm.$dateFormat(result.result.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))) + " - " + _vm._s(_vm.$dateFormat(result.result.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('small', [_vm._v(_vm._s(result.result.vehicle.brand) + " " + _vm._s(result.result.vehicle.model) + " " + _vm._s(result.result.vehicle.plate))]), _c('small', [_vm._v("D" + _vm._s(result.result.driver.id) + " " + _vm._s(result.result.driver.name) + " " + _vm._s(result.result.driver.surname))])])]
	      }
	    }], null, false, 3601414489)
	  }), _c('SearchEntity', {
	    staticClass: "mb-1",
	    attrs: {
	      "entity": "vehicles"
	    },
	    on: {
	      "selected": function($event) {
	        return _vm.gotoEntity($event, 'vehicles')
	      }
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(result) {
	        return [_c('div', {
	          staticClass: "quick-search-result"
	        }, [_c('span', [_vm._v("V" + _vm._s(result.result.id))]), _c('small', [_vm._v(_vm._s(result.result.brand) + " " + _vm._s(result.result.model) + " " + _vm._s(result.result.plate))]), _c('small', [_vm._v("PL" + _vm._s(result.result.parking_lot.id) + " " + _vm._s(result.result.parking_lot.name))])])]
	      }
	    }], null, false, 108632437)
	  })], 1)])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 2691 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-accordion"
	  }, [_c('ul', {
	    directives: [{
	      name: "f-accordion",
	      rawName: "v-f-accordion"
	    }],
	    staticClass: "accordion",
	    attrs: {
	      "data-accordion": "data-accordion",
	      "data-allow-all-closed": _vm.allClosed,
	      "data-multi-expand": _vm.multiExpand
	    }
	  }, _vm._l((_vm.titles), function(title) {
	    return _c('li', {
	      staticClass: "accordion-item",
	      attrs: {
	        "data-accordion-item": "data-accordion-item"
	      }
	    }, [_c('a', {
	      staticClass: "accordion-title",
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v(_vm._s(title))]), _c('div', {
	      staticClass: "accordion-content",
	      attrs: {
	        "data-tab-content": "data-tab-content"
	      }
	    }, [_vm._t(title)], 2)])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2692 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-wallet-uninvoiced"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Client")]), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'client',
	        params: {
	          id: _vm.item.client.id
	        }
	      }
	    }
	  }, [_vm._v("CL" + _vm._s(_vm.item.client.id) + " " + _vm._s(_vm.item.client.name) + " " + _vm._s(_vm.item.client.surname))])], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Uninvoiced Records")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.records.length))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Amount")]), _c('div', {
	    staticClass: "field-value",
	    class: {
	      'warning-text': _vm.item.billable_amount < 0
	    }
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.billable_amount)))])])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "text-right"
	  }, [_c('button', {
	    staticClass: "button fa fa-2x",
	    class: {
	      'fa-arrow-up': _vm.detail, 'fa-arrow-down': !_vm.detail
	    },
	    on: {
	      "click": function($event) {
	        _vm.detail = !_vm.detail
	      }
	    }
	  })])])]), (_vm.detail) ? [_c('table', [_vm._m(0), _c('tbody', _vm._l((_vm.item.records), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _c('td', [_vm._v(_vm._s(item.driver_id))]), _c('td', [_c('div', [_vm._v(_vm._s(_vm._f("walletableType")(item.walletable_type)))]), _c('div', [_vm._v(_vm._s(item.walletable_id))])]), _c('td', {
	      staticStyle: {
	        "font-family": "monospace"
	      }
	    }, _vm._l((item.reason.split('|')), function(reason) {
	      return _c('div', [(reason.startsWith('---')) ? _c('hr', {
	        staticStyle: {
	          "border-style": "dotted",
	          "margin": "0.5em"
	        }
	      }) : (reason.startsWith('- ')) ? _c('strong', [_vm._v(_vm._s(_vm.cleanString(reason, "- ")))]) : (reason.startsWith('>>')) ? _c('span', {
	        staticStyle: {
	          "display": "block",
	          "text-indent": "1em"
	        }
	      }, [_vm._v(_vm._s(_vm.cleanString(reason, ">>")))]) : _c('span', [_vm._v(_vm._s(reason))])])
	    }), 0), _c('td', {
	      staticClass: "text-center"
	    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(item.amount, item.tax).toFixed(2))))])]), _c('div', [_c('small', [_vm._v(_vm._s(-item.tax * 100) + "%")])])]), _c('td', {
	      staticClass: "text-center"
	    }, [_c('div', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(-item.amount, -item.tax).toFixed(2))))]), _c('div', [_c('small', [_vm._v(_vm._s(_vm.$priceWithcurrency(-item.amount)) + " VAT EXC")])])])])
	  }), 0)]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.billWallet,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("Bill wallet")])] : _vm._e()], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _c('th', [_vm._v("Driver Id")]), _c('th', [_vm._v("Type & Id")]), _c('th', [_vm._v("Description (Reason)")]), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Tax")]), _c('th', {
	    staticClass: "text-center"
	  }, [_vm._v("Amount")])])])
	}]}

/***/ }),
/* 2693 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-policy-list row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "showPerPageSelect": false
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2694 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-search-vehicle-availability"
	  }, [_c('h2', [_vm._v("Extend reservation")]), (_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.availability.length) ? _c('backoffice-vehicle-availability', {
	    attrs: {
	      "availability": _vm.availability,
	      "selectable": _vm.selectable,
	      "extend": true
	    },
	    on: {
	      "update:availability": function($event) {
	        _vm.availability = $event
	      },
	      "slotsSelected": _vm.slotSelected,
	      "loadExtra": _vm.showExtraDay
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2695 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.entity) ? _c('div', {
	    staticClass: "component-transaction-action-buttons"
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2696 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-driver-list row column"
	  }, [_c('DriverListForm', {
	    on: {
	      "setSearch": _vm.setSearch
	    }
	  }), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  }, [_c('header-columns', {
	    attrs: {
	      "slot": "before",
	      "columns": _vm.headers
	    },
	    slot: "before"
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2697 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-plan-setup"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [(_vm.plan) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Plan Name")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.name))]), _c('label', [_vm._v("Status")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.status))]), _c('label', [_vm._v("Color")]), _c('span', [_vm._v(_vm._s(_vm.item.color))]), _c('label', [_vm._v("Notice")]), _c('span', [_vm._v(_vm._s(_vm.item.notice))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Duration (days)")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.duration))]), _c('legend', [_vm._v("The contractual commitment of the plan (days).")]), _c('label', [_vm._v("Subscription End")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.subscription_end))]), _c('label', [_vm._v("Max Drivers")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.max_drivers))]), _c('label', [_vm._v("Renewable")]), _c('span', {
	    staticClass: "fa fa-check",
	    class: {
	      'success-text': _vm.item.renewable
	    }
	  }), _c('label', [_vm._v("Featured")]), _c('span', {
	    staticClass: "fa fa-check",
	    class: {
	      'success-text': _vm.item.featured
	    }
	  })])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12"
	  }, [_c('label', [_vm._v("Description")]), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.plan.description)
	    }
	  })])])]), _c('div', {
	    staticClass: "columns small-12 large-6"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Cost"), _c('div', {
	    staticClass: "help-text"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(_vm.plan.cost))) + " included vat")])])]), (_vm.item.renewable) ? _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Billing Cycle (days)")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.billing_cycle))])]) : _vm._e()]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns large-6"
	  }, [_c('label', [_vm._v("Active From")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.valid_from))])]), _c('div', {
	    staticClass: "columns large-6"
	  }, [_c('label', [_vm._v("Active To")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.valid_to))])])]), (_vm.item.toc) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Toc")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("T" + _vm._s(_vm.item.toc.id) + " " + _vm._s(_vm.item.toc.name))])])]) : _vm._e(), (_vm.item.picture) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column",
	    style: (_vm.planPictureStyle)
	  })]) : _vm._e()])]) : _vm._e()]), (_vm.$route.params.id && _vm.plan !== null) ? _c('div', {
	    staticClass: "plan-reservation-rates"
	  }, [_c('TabHeaders', {
	    attrs: {
	      "tabs": ['Reservation Rates', ("Logs (" + (_vm.plan.logs.length) + ")")],
	      "id": "plan-things",
	      "activeIndex": 0
	    }
	  }, [_c('TabContent', {
	    staticClass: "p-0",
	    attrs: {
	      "headerName": "Reservation Rates",
	      "active": true
	    }
	  }, [_c('PlanReservationRates')], 1), _c('TabContent', {
	    attrs: {
	      "headerName": ("Logs (" + (_vm.plan.logs.length) + ")")
	    }
	  }, [_c('accordion', _vm._l((_vm.plan.logs), function(l) {
	    return _c('accordion-item', {
	      attrs: {
	        "title": _vm.$dateFormat(l.date.date, "DD-MM-YYYY HH:mm:ss") + ' | ' + l.action
	      }
	    }, [_c('log', {
	      attrs: {
	        "item": l
	      }
	    })], 1)
	  }), 1)], 1)], 1)], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('h2', [_vm._v("Plan settings")])])
	}]}

/***/ }),
/* 2698 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-login-page"
	  }, [_c('div', {
	    staticClass: "row login-page-container align-middle collapse"
	  }, [_c('div', {
	    staticClass: "columns hide-for-small-only small-12 medium-6 region-left align-self-middle"
	  }, [_c('div', {
	    staticClass: "col-wrapper"
	  }, [_c('div', {
	    staticClass: "branding full"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.positiveLogo
	    }
	  })])])]), _c('div', {
	    staticClass: "columns small-12 small-order-1 medium-6 region-right"
	  }, [_c('div', {
	    staticClass: "col-wrapper"
	  }, [_c('img', {
	    staticClass: "show-for-small-only",
	    attrs: {
	      "src": _vm.positiveLogo
	    }
	  }), _c('h1', {
	    staticClass: "welcome-title"
	  }, [_vm._v("Login to your account")]), _c('login', {
	    on: {
	      "login": _vm.loginHandler
	    }
	  }, [(_vm.error_message) ? _c('div', {
	    staticClass: "login-error-message"
	  }, [_vm._v(_vm._s(_vm.error_message))]) : _vm._e()]), _c('p', {
	    on: {
	      "click": function($event) {
	        return _vm.tokenLogin()
	      }
	    }
	  }, [_vm._v("use token")])], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 2699 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle"
	  }, [(_vm.options) ? _c('selectize', {
	    ref: "selectize",
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "disabled": _vm.disabled,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Vehicle"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    },
	    model: {
	      value: (_vm.selectedValue),
	      callback: function($$v) {
	        _vm.selectedValue = $$v
	      },
	      expression: "selectedValue"
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2700 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.item) ? _c('div', {
	    staticClass: "component-credit-record-action-buttons"
	  }, [_c('div', {
	    staticClass: "dropdown-buttons"
	  }, [(((_vm.item.type === 'PAID' || _vm.item.type === 'PROMO') && _vm.item.status !== 'EXPIRED')) ? _c('ActionButton', {
	    attrs: {
	      "action": _vm.expireCredit,
	      "confirm": true
	    }
	  }, [_vm._v("Expire")]) : _vm._e(), _c('CreditRecordUsageReveal', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2701 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component component-backoffice-deposit-configuration"
	  }, _vm._l((_vm.validations), function(validation, label) {
	    return _c('div', {
	      staticClass: "field"
	    }, [_c('div', {
	      staticClass: "column"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (validation.active),
	        expression: "validation.active"
	      }],
	      attrs: {
	        "id": (_vm._uid + "-" + label),
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": Array.isArray(validation.active) ? _vm._i(validation.active, null) > -1 : (validation.active)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = validation.active,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.$set(validation, "active", $$a.concat([$$v])))
	            } else {
	              $$i > -1 && (_vm.$set(validation, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	            }
	          } else {
	            _vm.$set(validation, "active", $$c)
	          }
	        }
	      }
	    }), _c('label', {
	      attrs: {
	        "for": (_vm._uid + "-" + label)
	      }
	    }, [_vm._v(_vm._s(label))])]), _c('div', {
	      staticClass: "column"
	    }, [(label === 'default' && validation.active) ? _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (validation.value),
	        expression: "validation.value"
	      }],
	      attrs: {
	        "type": "text",
	        "id": (_vm._uid + "-" + label),
	        "placeholder": "default"
	      },
	      domProps: {
	        "value": (validation.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(validation, "value", $event.target.value)
	        }
	      }
	    }) : _vm._e(), (label === 'custom' && validation.active) ? _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (validation.value),
	        expression: "validation.value"
	      }],
	      attrs: {
	        "type": "text",
	        "id": (_vm._uid + "-" + label),
	        "placeholder": "custom validation"
	      },
	      domProps: {
	        "value": (validation.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(validation, "value", $event.target.value)
	        }
	      }
	    }) : _vm._e()])])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2702 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-create-vehicle-slot"
	  }, [_c('modal-reveal', {
	    ref: "createVehicleSlotModal",
	    attrs: {
	      "sizing": "small"
	    }
	  }, [_c('button', {
	    staticClass: "button small",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Add to Parking Lot")]), _c('h2', [_vm._v("Add V" + _vm._s(_vm.item.id) + " to a parking")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Vehicle Slot name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })]), _c('BookingModeSelect', {
	    model: {
	      value: (_vm.body.booking_mode),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "booking_mode", $$v)
	      },
	      expression: "body.booking_mode"
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('selectize-grouped-parking-assets', {
	    on: {
	      "parkingSlotSelected": _vm.setParkingSlot
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.body.parking_slot_id || !_vm.body.booking_mode
	    },
	    on: {
	      "click": _vm.createVehicleSlot
	    }
	  }, [_vm._v("Create")])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2703 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-vehicle-category"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Description"), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.description),
	      expression: "body.description"
	    }],
	    attrs: {
	      "rows": "5"
	    },
	    domProps: {
	      "value": (_vm.body.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "description", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Vehicle Types"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.vehicle_type_id),
	      expression: "body.vehicle_type_id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "vehicle_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.vehicleTypes), function(vehicleType) {
	    return _c('option', {
	      domProps: {
	        "value": vehicleType.id
	      }
	    }, [_vm._v(_vm._s(vehicleType.name))])
	  }), 0)]), _c('label', [_vm._v("Category image")]), _c('KeplerFileUpload', {
	    attrs: {
	      "selected-prefix": "vehicle-categories",
	      "selected-visibility": "public",
	      "previewUrl": _vm.body.picture
	    },
	    on: {
	      "sel": _vm.handleFileSelector
	    }
	  }), _c('label', [_vm._v("Category damage picture")]), _c('KeplerFileUpload', {
	    attrs: {
	      "selected-prefix": "damage-picture",
	      "selected-visibility": "public",
	      "previewUrl": _vm.body.damage_picture
	    },
	    on: {
	      "sel": _vm.handleFileDamageSelector
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.addVehicleCategory
	    }
	  }, [_vm._v("Create")])])])
	},staticRenderFns: []}

/***/ }),
/* 2704 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.categories), function(category, index) {
	    return _c('div', {
	      staticClass: "column small-12 large-4 category",
	      class: {
	        active: _vm.activeIndex === index
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setSearch(index)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "inner-content card text-center"
	    }, [_c('div', {
	      staticClass: "row p-1"
	    }, [(_vm.activeIndex === index) ? _c('div', {
	      staticClass: "column shrink"
	    }, [_c('dropdown', {
	      key: ((_vm.$options.name) + "_" + index),
	      attrs: {
	        "icon": "fa fa-ellipsis-v fa-2x action",
	        "position": "bottom"
	      }
	    }, [_c('div', {
	      staticClass: "dropdown-buttons"
	    }, [_c('edit-vehicle-category', {
	      attrs: {
	        "item": category
	      }
	    }), _c('ActionButton', {
	      attrs: {
	        "action": _vm.deleteCategory,
	        "confirm": true
	      }
	    }, [_vm._v("Delete")]), _c('requirement-modal', {
	      attrs: {
	        "entity_id": category.id,
	        "entity_type": "VehicleCategory"
	      }
	    })], 1)])], 1) : _vm._e(), _c('div', {
	      staticClass: "column text-left"
	    }, [_c('small', [_vm._v("C" + _vm._s(category.id))]), _c('h2', [_vm._v(_vm._s(category.name))])])])])])
	  }), 0), _c('div', {
	    staticClass: "row column"
	  }, [_c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2705 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-invoice-list-filter-form filter-form"
	  }, [(_vm.$is('entity-filter')) ? _c('div', {
	    staticClass: "entity-filters"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.filterInvoices]
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All statuses")]), _c('option', {
	    attrs: {
	      "value": "ON HOLD"
	    }
	  }, [_vm._v("On hold")]), _c('option', {
	    attrs: {
	      "value": "HOLDOVER PAYMENT"
	    }
	  }, [_vm._v("Holdover Payment")]), _c('option', {
	    attrs: {
	      "value": "PAID"
	    }
	  }, [_vm._v("Paid")]), _c('option', {
	    attrs: {
	      "value": "CANCELED"
	    }
	  }, [_vm._v("Canceled")]), _c('option', {
	    attrs: {
	      "value": "OVERDUE"
	    }
	  }, [_vm._v("Overdue")]), _c('option', {
	    attrs: {
	      "value": "SENT"
	    }
	  }, [_vm._v("Sent (Not paid)")]), _c('option', {
	    attrs: {
	      "value": "AWAITING PAYMENT"
	    }
	  }, [_vm._v("Awaiting Payment")]), _c('option', {
	    attrs: {
	      "value": "NO PAYMENT METHOD"
	    }
	  }, [_vm._v("No payment Method")])])]) : (_vm.$is('type-filter')) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.type),
	      expression: "search.type"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, _vm.filterInvoices]
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All types")]), _c('option', {
	    attrs: {
	      "value": "INVOICE"
	    }
	  }, [_vm._v("Invoice")]), _c('option', {
	    attrs: {
	      "value": "CREDIT NOTE"
	    }
	  }, [_vm._v("Credit Note")]), _c('option', {
	    attrs: {
	      "value": "PROFORMA"
	    }
	  }, [_vm._v("Proforma")])]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('date-range-picker', {
	    on: {
	      "input": _vm.dateRangeSelected
	    }
	  })], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('search-entity', {
	    attrs: {
	      "entity": "clients"
	    },
	    model: {
	      value: (_vm.search.client_id),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "client_id", $$v)
	      },
	      expression: "search.client_id"
	    }
	  }), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.final_sectional),
	      expression: "search.final_sectional"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Final sectional / internal id"
	    },
	    domProps: {
	      "value": (_vm.search.final_sectional)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.search, "final_sectional", $event.target.value)
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.sectional),
	      expression: "search.sectional"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "sectional", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All sectionals")]), _vm._l((_vm.sectionals), function(sectional) {
	    return _c('option', {
	      domProps: {
	        "value": sectional
	      }
	    }, [_vm._v(_vm._s(sectional))])
	  })], 2), _c('is-module-enabled', {
	    attrs: {
	      "module": "aruba-italian-e-invoice"
	    }
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.sdi),
	      expression: "search.sdi"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "sdi", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Filtro Sdi")]), _c('option', [_vm._v("sdi-wait")]), _c('option', [_vm._v("sdi-rejected")]), _c('option', [_vm._v("sdi-not-sent")])])])], 1), _c('div', {
	    staticClass: "columns"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.status),
	      expression: "search.status"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All statuses")]), _c('option', {
	    attrs: {
	      "value": "ON HOLD"
	    }
	  }, [_vm._v("On hold")]), _c('option', {
	    attrs: {
	      "value": "HOLDOVER PAYMENT"
	    }
	  }, [_vm._v("Holdover Payment")]), _c('option', {
	    attrs: {
	      "value": "PAID"
	    }
	  }, [_vm._v("Paid")]), _c('option', {
	    attrs: {
	      "value": "CANCELED"
	    }
	  }, [_vm._v("Canceled")]), _c('option', {
	    attrs: {
	      "value": "OVERDUE"
	    }
	  }, [_vm._v("Overdue")]), _c('option', {
	    attrs: {
	      "value": "SENT"
	    }
	  }, [_vm._v("Sent (Not paid)")]), _c('option', {
	    attrs: {
	      "value": "AWAITING PAYMENT"
	    }
	  }, [_vm._v("Awaiting Payment")]), _c('option', {
	    attrs: {
	      "value": "NO PAYMENT METHOD"
	    }
	  }, [_vm._v("No payment Method")])]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search.type),
	      expression: "search.type"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.search, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "selected"
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All types")]), _c('option', {
	    attrs: {
	      "value": "INVOICE"
	    }
	  }, [_vm._v("Invoice")]), _c('option', {
	    attrs: {
	      "value": "CREDIT NOTE"
	    }
	  }, [_vm._v("Credit Note")]), _c('option', {
	    attrs: {
	      "value": "PROFORMA"
	    }
	  }, [_vm._v("Proforma")]), _c('span', [_vm._v("Exclude proforma")])])]), _c('div', {
	    staticClass: "columns large-1 text-center"
	  }, [_c('InputSwitch', {
	    attrs: {
	      "idEl": "proforma"
	    },
	    on: {
	      "input": _vm.filterProforma
	    },
	    model: {
	      value: (_vm.search.proforma),
	      callback: function($$v) {
	        _vm.$set(_vm.search, "proforma", $$v)
	      },
	      expression: "search.proforma"
	    }
	  }, [_c('span', [_vm._v("Exclude proforma")])])], 1), _c('div', {
	    staticClass: "columns small-1 text-right"
	  }, [_c('a', {
	    staticClass: "fa fa-filter fa-2x",
	    on: {
	      "click": _vm.filterInvoices
	    }
	  }), _c('is-module-enabled', {
	    attrs: {
	      "module": "italian-e-invoice"
	    }
	  }, [(_vm.search.from !== null && _vm.search.to !== null) ? _c('div', {
	    staticClass: "download-zip"
	  }, [_c('a', {
	    staticClass: "fa fa-file-archive-o fa-2x",
	    on: {
	      "click": _vm.downloadZip
	    }
	  })]) : _vm._e()])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2706 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-logs"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "tabs-inner-content"
	  }, [_c('accordion', _vm._l((_vm.items), function(l) {
	    return _c('accordion-item', {
	      attrs: {
	        "title": _vm.$dateFormat(l.date.date, "DD-MM-YYYY HH:mm:ss") + ' | ' + l.action
	      }
	    }, [_c('log', {
	      attrs: {
	        "item": l
	      }
	    })], 1)
	  }), 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('h2', [_vm._v("Logs")])])
	}]}

/***/ }),
/* 2707 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-inline-editable-field",
	    attrs: {
	      "title": "Double click for edit"
	    }
	  }, [(_vm.editable) ? _c('div', {
	    staticClass: "fa fa-save",
	    on: {
	      "click": _vm.saveAndClose
	    }
	  }, [_vm._v(" ")]) : _vm._e(), (_vm.editable) ? _c('div', {
	    staticClass: "fa fa-times",
	    on: {
	      "click": _vm.closeAndRevert
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "field",
	    class: {
	      editable: _vm.editable
	    },
	    attrs: {
	      "contenteditable": _vm.editable
	    },
	    on: {
	      "dblclick": _vm.toggleEdit,
	      "input": _vm.update,
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.update($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.item_field))])])
	},staticRenderFns: []}

/***/ }),
/* 2708 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-instruction"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Title"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.instruction.title),
	      expression: "instruction.title"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.instruction.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.instruction, "title", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Subtitle"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.instruction.subtitle),
	      expression: "instruction.subtitle"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.instruction.subtitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.instruction, "subtitle", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('ActionBar', [_c('div', {
	    staticClass: "title",
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v("Steps")]), _c('div', {
	    staticClass: "action",
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": _vm.addStep
	    },
	    slot: "action"
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  })])]), _vm._l((_vm.instruction.steps), function(step, index) {
	    return _c('InstructionStep', {
	      key: Math.random(),
	      attrs: {
	        "step": step
	      },
	      on: {
	        "remove": function($event) {
	          return _vm.removeStep(index)
	        },
	        "resetValue": function($event) {
	          return _vm.resetStep(index)
	        }
	      }
	    })
	  })], 2)]), _c('div', {
	    staticClass: "row columns",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "text-right"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.saveInstruction
	    }
	  }, [_vm._v("Save")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2709 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', [_c('button', {
	    staticClass: "button success",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Uncovered amount")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('h2', [_vm._v("hello")])])]), _c('button', {
	    staticClass: "button alert float-right",
	    attrs: {
	      "slot": "footer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$refs[_vm.componentId].close()
	      }
	    },
	    slot: "footer"
	  }, [_vm._v("Cancel")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2710 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-force-rebook"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.show = !_vm.show
	      }
	    }
	  }, [_vm._v("Attachment translations")]), (_vm.show) ? _c('div', {
	    staticClass: "row column"
	  }, [_vm._l((_vm.allowedLanguages), function(lang) {
	    return [_c('label', [_vm._v(_vm._s(lang))]), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.translation[lang]),
	        expression: "translation[lang]"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": (_vm.translation[lang])
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(_vm.translation, lang, $event.target.value)
	        }, function($event) {
	          return _vm.$emit('input', _vm.translation)
	        }]
	      }
	    })]
	  })], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2711 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-transaction-list row column"
	  }, [_c('transaction-list-form', {
	    on: {
	      "filterTransactions": _vm.setSearch
	    }
	  }), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2712 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-driver"
	  }, [(_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "name",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "renderTemplate": _vm.renderTemplate,
	      "allowEmptyOption": _vm.allowEmptyOption,
	      "placeholder": "Categories"
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2713 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-wallet-add-cost"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Amount"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.amount),
	      expression: "body.amount"
	    }],
	    attrs: {
	      "type": "number",
	      "min": "0"
	    },
	    domProps: {
	      "value": (_vm.body.amount)
	    },
	    on: {
	      "keypress": function($event) {
	        return _vm.isNumber(_vm.event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "amount", $event.target.value)
	      }
	    }
	  }), _c('label', [_vm._v("Included vat  "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.vat),
	      expression: "vat"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.vat) ? _vm._i(_vm.vat, null) > -1 : (_vm.vat)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.vat,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.vat = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.vat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.vat = $$c
	        }
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "help-text"
	  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.recordAmount)) + " included vat")])]), _c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Tax"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.tax),
	      expression: "body.tax"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "tax", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("Select vat")]), _vm._l((_vm.vats), function(vat) {
	    return _c('option', {
	      domProps: {
	        "value": vat.percentage / 100
	      }
	    }, [_vm._v(_vm._s(vat.description) + " (" + _vm._s(vat.name) + " " + _vm._s(vat.percentage) + "%)")])
	  })], 2)]), _c('label', [_vm._v("Reason"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reason),
	      expression: "body.reason"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "reason", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row column"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.submit
	    }
	  }, [_vm._v("Add to wallet")])], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 2714 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-registration"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.formSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Client")]), _c('SearchEntity', {
	    staticClass: "mb-1",
	    attrs: {
	      "entity": "clients"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(result) {
	        return [_c('div', {
	          staticClass: "quick-search-result"
	        }, [_c('div', [_c('small', [_vm._v("CL" + _vm._s(result.result.id))]), _c('div', [_vm._v(_vm._s(result.result.name) + " " + _vm._s(result.result.surname))]), (result.result.organization_name) ? _c('div', [_c('small', [_vm._v(_vm._s(result.result.organization_name))])]) : _vm._e(), _c('div', [_c('small', [_vm._v(_vm._s(result.result.phone))])])])])]
	      }
	    }]),
	    model: {
	      value: (_vm.body.client_id),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "client_id", $$v)
	      },
	      expression: "body.client_id"
	    }
	  })], 1), _c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Name  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required',
	      "required": "required"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.name),
	      expression: "body.name"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "name", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-2 columns"
	  }, [_c('label', [_vm._v("Surname  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required',
	      "required": "required"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.surname),
	      expression: "body.surname"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.surname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "surname", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-2 columns"
	  }, [_c('label', [_vm._v("Title"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.title),
	      expression: "body.title"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "Mr"
	    }
	  }, [_vm._v("Mr")]), _c('option', {
	    attrs: {
	      "value": "Mrs"
	    }
	  }, [_vm._v("Mrs")]), _c('option', {
	    attrs: {
	      "value": "Ms"
	    }
	  }, [_vm._v("Ms")]), _c('option', {
	    attrs: {
	      "value": "Miss"
	    }
	  }, [_vm._v("Miss")])])])]), _c('div', {
	    staticClass: "small-12 large-2 columns"
	  }, [_c('label', [_vm._v("Gender"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.gender),
	      expression: "body.gender"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "-"
	    }
	  }, [_vm._v("-")]), _c('option', {
	    attrs: {
	      "value": "M"
	    }
	  }, [_vm._v("M")]), _c('option', {
	    attrs: {
	      "value": "F"
	    }
	  }, [_vm._v("F")])])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("Mobile  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.mobile_phone),
	      expression: "body.mobile_phone"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "international prefix call (ex: +39-3951231231)",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.mobile_phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "mobile_phone", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Email  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.email),
	      expression: "body.email"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "email", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Birthdate  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('date-picker', {
	    attrs: {
	      "required": "required"
	    },
	    model: {
	      value: (_vm.body.birthdate),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "birthdate", $$v)
	      },
	      expression: "body.birthdate"
	    }
	  })], 1)])]), _vm._m(0), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('label', [_vm._v("Street name  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.address.street),
	      expression: "body.address.street"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.body.address.street)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.address, "street", $event.target.value)
	      }
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('label', [_vm._v("City  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required',
	      "required": "required"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.address.city),
	      expression: "body.address.city"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.address.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.address, "city", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Region  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required',
	      "required": "required"
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.address.region),
	      expression: "body.address.region"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.address.region)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.address, "region", $event.target.value)
	      }
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-3 columns"
	  }, [_c('label', [_vm._v("Country  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('selectize-country', {
	    on: {
	      "optionSelected": _vm.selectCountry
	    }
	  })], 1)]), _c('div', {
	    staticClass: "small-12 large-2 columns"
	  }, [_c('label', [_vm._v("Postal code  "), _c('tooltip', {
	    attrs: {
	      "open": true,
	      "position": 'right',
	      "tip": 'Field Required'
	    }
	  }, [_c('span', {
	    staticClass: "fa fa-star"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.address.postal_code),
	      expression: "body.address.postal_code"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": ""
	    },
	    domProps: {
	      "value": (_vm.body.address.postal_code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body.address, "postal_code", $event.target.value)
	      }
	    }
	  })], 1)])]), _c('hr'), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _c('div', {
	    staticClass: "small-12 large-4 columns"
	  }, [_c('div', {
	    staticClass: "switch large"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.document),
	      expression: "document"
	    }],
	    staticClass: "switch-input",
	    attrs: {
	      "id": "add-document",
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.document) ? _vm._i(_vm.document, null) > -1 : (_vm.document)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.document,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.document = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.document = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.document = $$c
	        }
	      }
	    }
	  }), _vm._m(2)])])]), (_vm.document) ? _c('backoffice-driver-license-create', {
	    on: {
	      "driverLicenseUpdated": _vm.setDriverLicenseFields
	    }
	  }) : _vm._e(), _vm._m(3)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('h2', [_vm._v("Residential address")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "small-12 large-4 large-offset-3 columns"
	  }, [_c('label', [_vm._v("Add document?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "switch-paddle",
	    attrs: {
	      "for": "add-document"
	    }
	  }, [_c('span', {
	    staticClass: "switch-active",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("Yes")]), _c('span', {
	    staticClass: "switch-inactive",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("No")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns text-center"
	  }, [_c('label', [_c('input', {
	    staticClass: "button",
	    attrs: {
	      "type": "submit"
	    }
	  })])])])
	}]}

/***/ }),
/* 2715 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-void"
	  }, [_c('ModalReveal', [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Related Transactions")]), _c('div', {
	    staticClass: "header",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('h2', [_vm._v("Transactions  "), _c('strong', [_vm._v("INV" + _vm._s(_vm.invoice.internal_id) + "(" + _vm._s(_vm.invoice.id) + ")")])])]), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "data-loader": _vm.dataLoader
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2716 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-vehicle-category"
	  }, [_c('modal-reveal', {
	    ref: "modalEditVehicleCategory",
	    attrs: {
	      "sizing": "small"
	    }
	  }, [_c('a', {
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Edit")]), _c('h2', [_vm._v("Edit Vehicle Category " + _vm._s(_vm.item.id) + " - " + _vm._s(_vm.item.name))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Name"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.name),
	      expression: "item.name"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.item.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "name", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Description"), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.description),
	      expression: "item.description"
	    }],
	    attrs: {
	      "rows": "5"
	    },
	    domProps: {
	      "value": (_vm.item.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.item, "description", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Category damage picture")]), _c('KeplerFileUpload', {
	    attrs: {
	      "selected-prefix": "damage-picture",
	      "selected-visibility": "public",
	      "previewUrl": _vm.item.damage_picture
	    },
	    on: {
	      "sel": _vm.handleFileDamageSelector
	    }
	  })], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Vehicle Types"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.vehicle_type.id),
	      expression: "item.vehicle_type.id"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.item.vehicle_type, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.vehicleTypes), function(vehicleType) {
	    return _c('option', {
	      domProps: {
	        "value": vehicleType.id
	      }
	    }, [_vm._v(_vm._s(vehicleType.name))])
	  }), 0)]), _c('label', [_vm._v("Category image")]), _c('KeplerFileUpload', {
	    attrs: {
	      "selected-prefix": "vehicle-categories",
	      "selected-visibility": "public",
	      "previewUrl": _vm.item.picture
	    },
	    on: {
	      "sel": _vm.handleFileSelector
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.editVehicleCategory
	    }
	  }, [_vm._v("Edit")])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2717 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [_c('ModalReveal', {
	    ref: "documentTypeReveal"
	  }, [_c('a', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]), _c('h2', [_vm._v("Create new document type")]), _c('DocumentTypeForm', {
	    model: {
	      value: (_vm.documentType),
	      callback: function($$v) {
	        _vm.documentType = $$v
	      },
	      expression: "documentType"
	    }
	  }), _c('template', {
	    slot: "footer"
	  }, [_c('ActionButton', {
	    attrs: {
	      "action": _vm.save
	    }
	  }, [_vm._v("Save")])], 1)], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2718 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-create-entity-button"
	  }, [(_vm.item.path !== 'merge') ? _c('router-link', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "to": _vm.item.path
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
	  })]) : _vm._e(), (_vm.item.path === 'merge') ? _c('router-link', {
	    staticClass: "fa-stack fa-lg",
	    attrs: {
	      "to": _vm.item.path
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-stack-2x"
	  }), _c('i', {
	    staticClass: "fa fa-gear fa-stack-1x fa-inverse"
	  })]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2719 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-send-to-external-service"
	  }, [_c('reveal', {
	    attrs: {
	      "confirm": true
	    },
	    on: {
	      "confirm": _vm.sendToSDI
	    }
	  }, [_c('h2', [_vm._v("Sei sicuro?")]), (_vm.invoice.extra.hasOwnProperty('einvoice')) ? _c('div', {
	    staticClass: "status"
	  }, [_c('h2', [_vm._v("Ultimi status")]), _vm._l((_vm.invoice.extra.einvoice.results), function(result) {
	    return _c('div', {
	      staticClass: "results"
	    }, [_c('div', [_vm._v("File name: " + _vm._s(result.uploadFileName))]), _c('div', [_vm._v("Result: " + _vm._s(result.errorCode) + " - " + _vm._s(result.errorDescription))]), _c('div', [_vm._v("Date: " + _vm._s(result.created_at))])])
	  })], 2) : _vm._e(), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Invia a SDI")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2720 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-subscription-list row column"
	  }, [(_vm.reports) ? _c('statistics-card4', [_c('div', {
	    attrs: {
	      "slot": "n1"
	    },
	    slot: "n1"
	  }, [_c('p', [_vm._v("Total Subscriptions")]), _c('h2', [_vm._v(_vm._s(_vm.reports.total_subscriptions))])]), _c('div', {
	    attrs: {
	      "slot": "n2"
	    },
	    slot: "n2"
	  }, [_c('p', [_vm._v("Expired Subscriptions")]), _c('h2', [_vm._v(_vm._s(_vm.reports.expiring_subscriptions))])]), _c('div', {
	    attrs: {
	      "slot": "n3"
	    },
	    slot: "n3"
	  }, [_c('p', [_vm._v("Renewed subscriptions")]), _c('h2', [_vm._v(_vm._s(_vm.reports.renewed_subscriptions))])]), _c('div', {
	    attrs: {
	      "slot": "n4"
	    },
	    slot: "n4"
	  }, [_c('p', [_vm._v("Renewed subscriptions Amount")]), _c('h2', [_vm._v(_vm._s(Math.ceil(_vm.reports.renewed_subscriptions_amount)) + _vm._s(_vm.currency))])])]) : _vm._e(), _c('subscription-list-form', {
	    on: {
	      "filterSubscriptions": _vm.setSearch
	    }
	  }), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  }, [_c('header-columns', {
	    attrs: {
	      "slot": "before",
	      "columns": _vm.headers
	    },
	    slot: "before"
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2721 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-booking-mode"
	  }, [(_vm.$is('select')) ? _c('select', {
	    attrs: {
	      "disabled": _vm.disabled
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$emit('input', $event.target.value)
	      }
	    }
	  }, [(_vm.isFilter) ? _c('option', {
	    attrs: {
	      "selected": ""
	    },
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All booking types")]) : _vm._e(), _vm._l((_vm.bookingModes), function(bookingMode, key) {
	    return _c('option', {
	      domProps: {
	        "selected": _vm.value === key,
	        "value": key
	      }
	    }, [_vm._v(_vm._s(bookingMode))])
	  })], 2) : (_vm.$is('checkbox')) ? _c('fieldset', [_c('h3', [_vm._v("Booking Modes")]), _vm._l((_vm.bookingModes), function(bookingMode, key) {
	    return [_c('label', [_vm._v(_vm._s(bookingMode)), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selected),
	        expression: "selected"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": key,
	        "checked": _vm.value === key,
	        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, key) > -1 : (_vm.selected)
	      },
	      on: {
	        "change": [function($event) {
	          var $$a = _vm.selected,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = key,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.selected = $$c
	          }
	        }, function($event) {
	          return _vm.$emit('input', _vm.selected)
	        }]
	      }
	    })])]
	  })], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2722 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('SegmentButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("SGR" + _vm._s(_vm.item.id))]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v("SG" + _vm._s(_vm.item.segment.id) + " " + _vm._s(_vm.item.segment.name))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Rate")]), _c('div', {
	    staticClass: "field"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'configuration-rate',
	        params: {
	          id: _vm.item.reservation_rate.id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v("RR" + _vm._s(_vm.item.reservation_rate.id) + " " + _vm._s(_vm.item.reservation_rate.name))])])], 1)])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2723 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-account-status"
	  }, _vm._l((_vm.statuses), function(status) {
	    return _c('div', {
	      staticClass: "status"
	    }, [_c('div', {
	      staticClass: "stats"
	    }, [_c('i', {
	      staticClass: "fa fa-2x",
	      class: _vm.getStatusClass(status),
	      on: {
	        "click": function($event) {
	          return _vm.$emit('input', status)
	        }
	      }
	    }), _c('p', {
	      staticClass: "no-wrap"
	    }, [_vm._v(_vm._s(status.replace(/_status|_method/gi, '')))])])])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 2724 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-proforma-to-credit-note"
	  }, [_c('ModalReveal', {
	    on: {
	      "input": _vm.closeReveal
	    },
	    model: {
	      value: (_vm.openReveal),
	      callback: function($$v) {
	        _vm.openReveal = $$v
	      },
	      expression: "openReveal"
	    }
	  }, [_c('button', {
	    staticClass: "button",
	    attrs: {
	      "slot": "trigger"
	    },
	    on: {
	      "click": _vm.open
	    },
	    slot: "trigger"
	  }, [_vm._v("Make credit note")]), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Refund on gateway"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.refund_on_gateway),
	      expression: "refund_on_gateway"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.refund_on_gateway) ? _vm._i(_vm.refund_on_gateway, null) > -1 : (_vm.refund_on_gateway)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.refund_on_gateway,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.refund_on_gateway = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.refund_on_gateway = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.refund_on_gateway = $$c
	        }
	      }
	    }
	  })])])])]), _c('ActionButton', {
	    attrs: {
	      "slot": "footer",
	      "action": _vm.convertToCreditNote,
	      "confirm": true
	    },
	    slot: "footer"
	  }, [_vm._v("Make Credit note")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2725 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-credit-records"
	  }, [_c('ActionBar', [_c('h2', {
	    attrs: {
	      "slot": "title"
	    },
	    slot: "title"
	  }, [_vm._v(_vm._s(_vm.type) + " Credit")]), (_vm.expanded) ? _c('i', {
	    staticClass: "fa fa-plus-circle fa-2x",
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addCredit = !_vm.addCredit
	      }
	    },
	    slot: "action"
	  }) : _vm._e(), _c('i', {
	    staticClass: "fa fa-2x",
	    class: {
	      'fa-eye-slash': _vm.expanded, 'fa-eye': !_vm.expanded
	    },
	    attrs: {
	      "slot": "action"
	    },
	    on: {
	      "click": function($event) {
	        _vm.expanded = !_vm.expanded
	      }
	    },
	    slot: "action"
	  })]), (_vm.addCredit) ? _c('div', {
	    staticClass: "add-credit"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Amount Vat Included"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.amount),
	      expression: "body.amount"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.body.amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "amount", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Reason"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.reason),
	      expression: "body.reason"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.body.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "reason", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Tax"), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.tax),
	      expression: "body.tax"
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.body.tax)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.body, "tax", $event.target.value)
	      }
	    }
	  })]), _c('label', [_vm._v("Service"), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body.service),
	      expression: "body.service"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.body, "service", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("All")]), _c('option', [_vm._v("Reservation")]), _c('option', [_vm._v("Subscription")])])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Valid from"), _c('DatePicker', {
	    model: {
	      value: (_vm.body.valid_from),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "valid_from", $$v)
	      },
	      expression: "body.valid_from"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "column"
	  }, [_c('label', [_vm._v("Valid to"), _c('DatePicker', {
	    model: {
	      value: (_vm.body.valid_to),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "valid_to", $$v)
	      },
	      expression: "body.valid_to"
	    }
	  })], 1)])]), _c('ActionButton', {
	    attrs: {
	      "action": _vm.addNewCredit
	    }
	  }, [_vm._v("Add Credit")])], 1) : _vm._e(), (_vm.expanded) ? _c('base-list', {
	    ref: "listCr",
	    attrs: {
	      "component": _vm.component,
	      "search": _vm.search,
	      "dataLoader": _vm.dataLoader,
	      "resultsPerPage": 5,
	      "componentType": "listing"
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2726 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-search-entity",
	    attrs: {
	      "tabindex": "0"
	    },
	    on: {
	      "keydown": _vm.showChar,
	      "keyup": _vm.showChar
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchQuery),
	      expression: "searchQuery"
	    }],
	    staticClass: "m-0",
	    class: {
	      'noborder': _vm.showResults && !_vm.loading
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": ("Search " + _vm.entity)
	    },
	    domProps: {
	      "value": (_vm.searchQuery)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchQuery = $event.target.value
	      }, _vm.debouncedSearch],
	      "focusout": _vm.handleFocusout,
	      "focusin": _vm.handleFocusIn
	    }
	  }), (_vm.loading) ? _c('div', {
	    staticClass: "loading"
	  }, [_c('loading-spinner', {
	    attrs: {
	      "height": "30px"
	    }
	  })], 1) : _vm._e(), (!_vm.loading) ? _c('div', {
	    staticClass: "results",
	    class: {
	      'open': _vm.showResults, 'scroll': _vm.results.length > 6
	    },
	    attrs: {
	      "tabindex": "1"
	    }
	  }, [_vm._l((_vm.results), function(result) {
	    return (_vm.results.length && _vm.showResults) ? _c('div', {
	      key: result.id,
	      staticClass: "result",
	      class: {
	        'selected': result.id === _vm.selected
	      },
	      on: {
	        "click": function($event) {
	          return _vm.select($event, result)
	        }
	      }
	    }, [_vm._t("default", [_c('div', [_c('small', [_vm._v(_vm._s(_vm.prefix) + _vm._s(result.id))]), _c('div', [_vm._v(_vm._s(result.name) + " " + _vm._s(result.surname))])])], {
	      "result": result
	    })], 2) : _vm._e()
	  }), (!_vm.results.length && _vm.showResults) ? _c('div', {
	    staticClass: "no-results"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_vm._v("No results")])]) : _vm._e()], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2727 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-reveal-void"
	  }, [_c('ModalReveal', [_c('button', {
	    staticClass: "button danger",
	    attrs: {
	      "slot": "trigger"
	    },
	    slot: "trigger"
	  }, [_vm._v("Usage details")]), _c('div', {
	    staticClass: "header",
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('h2', [_vm._v(" CR" + _vm._s(_vm.item.id) + " ")]), _c('h4', [_vm._v(_vm._s(_vm.item.reason))]), _c('Cards', {
	    attrs: {
	      "data": _vm.creditData
	    }
	  })], 1), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "data-loader": _vm.dataLoader,
	      "componentType": "usages"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2728 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "time-range"
	  }, [_c('h2', [_vm._v("Extend time")]), _c('p', [_vm._v("Set up the marker to change time")]), _c('div', {
	    staticClass: "rect-list"
	  }, [_vm._m(0), _vm._l((_vm.availability), function(item, index) {
	    return _c('div', {
	      staticClass: "rect",
	      class: {
	        available: item.available, reservation: _vm.isInReservation(index)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onClick(index)
	        }
	      }
	    }, [(index % 3 == 0) ? _c('div', {
	      staticClass: "text"
	    }, [_vm._v(_vm._s(_vm.formatDate(item.end)))]) : _vm._e()])
	  })], 2), (_vm.debug.selectedEnd) ? _c('h3', [_vm._v("Extend this reservation to " + _vm._s(_vm.debug.selectedEnd))]) : _vm._e(), _c('div', {
	    staticClass: "button",
	    on: {
	      "click": _vm.handleConfirm
	    }
	  }, [_vm._v("Confirm Extension")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "slider"
	  }, [_c('i', {
	    staticClass: "fa fa-circle fa-2x",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ }),
/* 2729 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-driver-group"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label pb-0"
	  }, [_vm._v("Group")]), _c('div', {
	    staticClass: "field m-0"
	  }, [_vm._v("G" + _vm._s(_vm.item.id) + " " + _vm._s(_vm.item.name))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Policies")]), _c('div', {
	    staticClass: "field m-0"
	  }, [_vm._v(_vm._s(_vm.item.policies.length))])]), _c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Supervisor")]), _c('br'), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.supervisor),
	      expression: "item.supervisor"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.item.supervisor) ? _vm._i(_vm.item.supervisor, null) > -1 : (_vm.item.supervisor)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.item.supervisor,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.item, "supervisor", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.item, "supervisor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.item, "supervisor", $$c)
	        }
	      }, function($event) {
	        return _vm.$emit('toggleSupervisor', _vm.item)
	      }]
	    }
	  })]), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('DriverGroupButtons', {
	    attrs: {
	      "item": _vm.item,
	      "driver": _vm.driver
	    }
	  })], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2730 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [_c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "dropdown menu",
	    attrs: {
	      "data-dropdown-menu": ""
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#Item-1"
	    }
	  }, [_vm._v("Action")]), _c('ul', {
	    staticClass: "menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Edit")])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 2731 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-selectize-vehicle"
	  }, [(_vm.loading) ? _c('loading-spinner') : _vm._e(), (_vm.options) ? _c('selectize', {
	    attrs: {
	      "selectedValue": _vm.selectedValue,
	      "options": _vm.options,
	      "value-field": "id",
	      "maxItems": _vm.maxItems,
	      "label-field": "plate",
	      "items": _vm.items,
	      "searchField": _vm.searchableFields,
	      "optionTemplate": _vm.optionTemplate,
	      "disabled": _vm.disabled,
	      "renderTemplate": _vm.renderTemplate,
	      "placeholder": "Client Type",
	      "loading": _vm.loading
	    },
	    on: {
	      "itemAdded": _vm.optionSelected,
	      "itemRemoved": _vm.optionRemoved
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2732 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-action-buttons"
	  }, [(_vm.$is('action')) ? _c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "dropdown menu",
	    attrs: {
	      "data-dropdown-menu": ""
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Action")]), _c('ul', {
	    staticClass: "menu"
	  }, _vm._l((_vm.actions), function(action) {
	    return _c('li', [_c('a', {
	      on: {
	        "click": action.callback
	      }
	    }, [_vm._v(_vm._s(action.name))])])
	  }), 0)])]) : _c('div', {
	    staticClass: "dropdown-buttons"
	  }, _vm._l((_vm.actions), function(action) {
	    return _c('button', {
	      staticClass: "button",
	      class: action.severity,
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": action.callback
	      }
	    }, [_vm._v(_vm._s(action.name))])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2733 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$is('wallet-record-id')) ? _c('div', {
	    staticClass: "field-wallet-record-id"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("ID")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v("WR" + _vm._s(_vm.item.id))])]) : (_vm.$is('wallet-record-walletable')) ? _c('div', {
	    staticClass: "field-walletable"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Walletable")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.walletableType) + "(" + _vm._s(_vm.item.walletable_id) + ")")])]) : (_vm.$is('wallet-record-tax')) ? _c('div', {
	    staticClass: "field-wallet-record-tax"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Tax")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.currency) + _vm._s(parseFloat((_vm.item.amount * -1) * _vm.item.tax).toFixed(2)))])]) : (_vm.$is('wallet-record-tax-rate')) ? _c('div', {
	    staticClass: "field-wallet-record-tax-rate"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Tax Rate")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.item.tax * 100) + "%")])]) : (_vm.$is('wallet-record-amount')) ? _c('div', {
	    staticClass: "field-wallet-record-amount"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Amount")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(" " + _vm._s(_vm.currency) + _vm._s(_vm.item.amount))])]) : (_vm.$is('wallet-record-created')) ? _c('div', {
	    staticClass: "field-wallet-record-created"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field-value"
	  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('wallet-record-invoice')) ? _c('div', {
	    staticClass: "field-wallet-invoice"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Invoice")]), (_vm.item.invoice.internal_id) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'invoice',
	        params: {
	          id: _vm.item.invoice.id
	        }
	      }
	    }
	  }, [_c('span', [_vm._v(" INV" + _vm._s(_vm.item.invoice.internal_id))])]) : _c('span', [_vm._v("Uninvoiced")])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2734 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-backoffice-edit-zone"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "inner-content"
	  }, [(!_vm.zone.name) ? _c('LoadingSpinner') : [_c('h2', [_vm._v("Editing zone " + _vm._s(_vm.$route.params.id))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column small-12 large-6"
	  }, [_c('label', [_vm._v("Name")]), _c('TranslateField', {
	    attrs: {
	      "group": "entities",
	      "field": _vm.zone._translatable.name,
	      "label": "Name",
	      "value": _vm.zone.name
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.zone.name),
	      expression: "zone.name"
	    }],
	    staticClass: "input-group-field",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.zone.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.zone, "name", $event.target.value)
	      }
	    }
	  })])], 1)]), _c('div', {
	    staticClass: "row column"
	  }, [_c('label', [_vm._v("Add from geojson"), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.zone.poly),
	      expression: "zone.poly"
	    }],
	    attrs: {
	      "rows": "10"
	    },
	    domProps: {
	      "value": (_vm.zone.poly)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.zone, "poly", $event.target.value)
	      }
	    }
	  })]), _c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('google-map', {
	    ref: "map",
	    attrs: {
	      "zoomControl": true,
	      "mapTypeControl": true,
	      "search-bar": true,
	      "api-key": _vm.apiKey,
	      "center": _vm.mapCenter,
	      "libraries": ['places', 'visualization', 'drawing']
	    }
	  }, [(_vm.zone.poly) ? _c('google-map-drawing-manager', {
	    attrs: {
	      "initial": _vm.zone.poly
	    },
	    on: {
	      "updated": _vm.shapeUpdated
	    }
	  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _c('div', {
	    staticClass: "row column mt-3"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.updateZone
	    }
	  }, [_vm._v("Update")])])]], 2)])])])])
	},staticRenderFns: []}

/***/ }),
/* 2735 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.entity && _vm.actions.length) ? _c('action-buttons', {
	    attrs: {
	      "actions": _vm.actions,
	      "type": _vm.type
	    }
	  }) : (_vm.entity) ? _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [_c('span', [_vm._v("No actions available")])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2736 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-date-picker"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(0), _c('input', {
	    staticClass: "date-picker input-group-field",
	    attrs: {
	      "disabled": _vm.disabled,
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": _vm.initialDate
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$emit('uplaksdjflkasj')
	      }
	    }
	  }), (_vm.ClearCb && !_vm.disabled) ? _c('div', {
	    staticClass: "input-group-button"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.ClearCb
	    }
	  }, [_vm._v("X")])]) : _vm._e(), _vm._t("default")], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-label"
	  }, [_c('span', {
	    staticClass: "fa fa-calendar"
	  })])
	}]}

/***/ }),
/* 2737 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-home-controller"
	  }, [(_vm.$acl('search-search')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_vm._m(0), _c('entities-search')], 1)]) : _vm._e(), (_vm.$acl('_booking')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_vm._m(1), _c('book-panel')], 1)]) : _vm._e(), (_vm.$acl('index-reporting')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_vm._m(2), _c('base-list', {
	    attrs: {
	      "component": _vm.reportingsComponent,
	      "dataLoader": _vm.reportingsDataLoader
	    }
	  })], 1)]) : _vm._e(), (_vm.$acl('index-reservations')) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "columns"
	  }, [_vm._m(3), _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.reservationDataLoader
	    }
	  })], 1)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Quick search")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Quick booking")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Support Requests")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action-bar"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("Reservations")])])])
	}]}

/***/ }),
/* 2738 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-asset-management"
	  }, [_c('div', {
	    staticClass: "component-backoffice-category-list row column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.parkingGroups), function(parkingGroup, index) {
	    return _c('div', {
	      staticClass: "column small-12 large-4 category",
	      class: {
	        active: _vm.activeIndex === index
	      }
	    }, [_c('div', {
	      staticClass: "inner-content card"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column shrink"
	    }, [(_vm.activeIndex === index) ? _c('dropdown', {
	      attrs: {
	        "icon": 'fa fa-ellipsis-v fa-2x action',
	        "position": 'top'
	      }
	    }, [_c('ParkingGroupButtons', {
	      attrs: {
	        "item": parkingGroup
	      }
	    })], 1) : _vm._e()], 1), _c('div', {
	      staticClass: "column",
	      on: {
	        "click": function($event) {
	          return _vm.setSearch(index, parkingGroup)
	        }
	      }
	    }, [_c('h3', [_c('small', [_vm._v("PG" + _vm._s(parkingGroup.id) + " ")]), _c('span', [_vm._v(_vm._s(parkingGroup.name))])]), _c('small', [_vm._v("BM: " + _vm._s(parkingGroup.reservation_type))])])])])])
	  }), 0), _vm._l((_vm.parkingGroups), function(parkingGroup, index) {
	    return (_vm.activeIndex === index) ? _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "column text left"
	    }, [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'add-parking-lot',
	          params: {
	            id: parkingGroup.id
	          }
	        }
	      }
	    }, [_c('button', {
	      staticClass: "button small"
	    }, [_vm._v("Add new Parking Lot")])])], 1)]) : _vm._e()
	  }), _c('div', {
	    staticClass: "row column"
	  }, [(_vm.parking_group !== null) ? _c('base-list', {
	    attrs: {
	      "component": _vm.component,
	      "dataLoader": _vm.dataLoader,
	      "search": _vm.search
	    }
	  }) : _vm._e()], 1)], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2739 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.entity) ? _c('div', {
	    staticClass: "component-client-action-buttons"
	  }, [(_vm.item) ? _c('ul', {
	    directives: [{
	      name: "f",
	      rawName: "v-f"
	    }],
	    staticClass: "dropdown menu",
	    attrs: {
	      "data-dropdown-menu": ""
	    }
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#Item-1"
	    }
	  }, [_vm._v("Action")]), _c('ul', {
	    staticClass: "menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Edit")])]), _c('li', [(_vm.entity.slot_disabled === 1 && _vm.entity.archived_at === '') ? _c('a', {
	    on: {
	      "click": _vm.enable
	    }
	  }, [_vm._v("Enable Vehicle Slot")]) : _vm._e()]), _c('li', [(_vm.entity.slot_disabled === 0) ? _c('VehicleSlotDisableReveal', {
	    attrs: {
	      "item": _vm.entity
	    }
	  }, [_vm._v("         li")]) : _vm._e()], 1), _c('li', [(!_vm.entity.archived_at) ? _c('a', {
	    on: {
	      "click": _vm.archive
	    }
	  }, [_vm._v("Archive")]) : _vm._e()]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.requestData
	    }
	  }, [_vm._v("Request data")])]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.openDoors
	    }
	  }, [_vm._v("Open Doors")])]), _c('li', [_c('ActionButton', {
	    attrs: {
	      "action": _vm.activateImmo,
	      "confirm": "confirm"
	    }
	  }, [_vm._v("Activate Immo")])], 1), _c('li', [_c('a', {
	    on: {
	      "click": _vm.closeDoors
	    }
	  }, [_vm._v("Close Doors")])])])])]) : _c('div', {
	    staticClass: "dropdown-buttons"
	  }, [(_vm.entity.slot_disabled === 1) ? _c('a', {
	    staticClass: "success-text",
	    on: {
	      "click": _vm.enable
	    }
	  }, [_vm._v("Enable")]) : _vm._e(), (_vm.entity.slot_disabled === 0) ? _c('VehicleSlotDisableReveal', {
	    attrs: {
	      "item": _vm.entity
	    }
	  }) : _vm._e(), (_vm.entity.slot_id) ? _c('swap-asset', {
	    attrs: {
	      "item": _vm.vehicleSlot
	    },
	    on: {
	      "processSwap": _vm.processSwap
	    }
	  }) : _vm._e(), (_vm.entity.slot_id) ? _c('move-asset', {
	    attrs: {
	      "item": _vm.vehicleSlot
	    }
	  }) : _vm._e(), _c('ToggleHiddenOnMap', {
	    attrs: {
	      "vehicle": _vm.entity
	    }
	  }), (_vm.entity.slot_id) ? _c('a', {
	    staticClass: "warning-text",
	    on: {
	      "click": _vm.dismiss
	    }
	  }, [_vm._v("Dismiss")]) : _vm._e(), (_vm.entity.slot_id) ? _c('router-link', {
	    staticClass: "alert-text",
	    attrs: {
	      "to": {
	        name: 'operations',
	        params: {
	          id: _vm.entity.id
	        }
	      }
	    }
	  }, [_vm._v("Drain")]) : _vm._e(), _c('ForceRebook', {
	    attrs: {
	      "vehicle": _vm.entity
	    }
	  })], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 2740 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-policy"
	  }, [(_vm.$is('listing')) ? _c('div', {
	    staticClass: "inner-content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "column shrink"
	  }, [_c('dropdown', {
	    attrs: {
	      "icon": 'fa fa-ellipsis-v fa-2x action',
	      "position": 'bottom'
	    }
	  }, [_c('RegistrationTokenButtons', {
	    attrs: {
	      "item": _vm.item
	    },
	    on: {
	      "itemUpdated": function($event) {
	        return _vm.$emit('itemUpdated')
	      }
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "column shrink"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("RT" + _vm._s(_vm.item.id))])]), _c('div', {
	    staticClass: "column text-center"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Token")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.token))])]), _c('div', {
	    staticClass: "column text-center"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Type")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.destination_type))])]), _c('div', {
	    staticClass: "column text-center"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Destination")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.destination_name))])]), _c('div', {
	    staticClass: "column text-center"
	  }, [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Created")]), _c('div', {
	    staticClass: "field"
	  }, [_vm._v(_vm._s(_vm.item.created_at))])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 2741 */,
/* 2742 */,
/* 2743 */,
/* 2744 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.c30a6e752093e6fc9492.js